// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%2300c9a7%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%2371869d%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23ed4c78%27 viewBox=%270 0 12 12%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23ed4c78%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23fff%27 d=%27M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%274%27 height=%274%27 viewBox=%270 0 4 4%27%3e%3cpath stroke=%27%23fff%27 d=%27M0 2h4%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27%23677788%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2730%27 height=%2730%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.7%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 fill=%27%23fff%27 width=%278%27 height=%278%27 viewBox=%270 0 8 8%27%3e%3cpath d=%27M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%23677788%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%23677788%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M15.78,11.28a.75.75,0,0,1,.22.53v.38a.77.77,0,0,1-.22.53l-5.14,5.13a.5.5,0,0,1-.71,0l-.71-.71a.49.49,0,0,1,0-.7L13.67,12,9.22,7.56a.5.5,0,0,1,0-.71l.71-.7a.5.5,0,0,1,.71,0Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27rgba%28255, 255, 255, 0.7%29%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%23377dff%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%23fff%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%231e2022%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%2300c9a7%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%2309a5be%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%23f5ca99%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%23ed4c78%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%23f7faff%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%2321325b%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("data:image/svg+xml,%3Csvg width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27%232d1582%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("data:image/svg+xml,%3Csvg width=%2716%27 height=%2716%27 viewBox=%270 0 110 110%27 fill=%27%23e7eaf3%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M55,110L55,110C24.6,110,0,85.4,0,55v0C0,24.6,24.6,0,55,0h0c30.4,0,55,24.6,55,55v0C110,85.4,85.4,110,55,110zM81.6,31c-1.5-1.4-3.9-1.4-5.4,0.1L43.7,64.3l-8-9.6c-1.8-2.2-4.9-2.6-6.9-0.9c-1.8,1.5-2.1,4.1-0.9,6.2l10.2,17.3c2,3.3,6.7,3.6,9,0.5L82,36.2C83.3,34.7,83.1,32.4,81.6,31z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("data:image/svg+xml,%3Csvg width=%2716%27 height=%2716%27 viewBox=%270 0 110 110%27 fill=%27%23377dff%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M55,110L55,110C24.6,110,0,85.4,0,55v0C0,24.6,24.6,0,55,0h0c30.4,0,55,24.6,55,55v0C110,85.4,85.4,110,55,110zM81.6,31c-1.5-1.4-3.9-1.4-5.4,0.1L43.7,64.3l-8-9.6c-1.8-2.2-4.9-2.6-6.9-0.9c-1.8,1.5-2.1,4.1-0.9,6.2l10.2,17.3c2,3.3,6.7,3.6,9,0.5L82,36.2C83.3,34.7,83.1,32.4,81.6,31z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("data:image/svg+xml,%3Csvg width=%2716%27 height=%2716%27 viewBox=%270 0 110 110%27 fill=%27%23377dff%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cpath d=%27M98.1,16.2c-2.5-2.3-6.4-2.2-8.7,0.2L36.7,70.1l-13-15.5c-2.9-3.5-7.9-4.1-11.1-1.4c-2.9,2.4-3.5,6.6-1.4,10.1l16.5,28c3.2,5.4,10.8,5.8,14.5,0.8l56.5-67.3C100.7,22.1,100.4,18.5,98.1,16.2z%27/%3E%3C/svg%3E%0A", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../svg/components/circle-preloader.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!
 * Bootstrap v4.5.3 (https://getbootstrap.com/)
 * Copyright 2011-2020 The Bootstrap Authors
 * Copyright 2011-2020 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
 */
:root {
  --blue: #377dff;
  --indigo: #2d1582;
  --purple: #6f42c1;
  --pink: #e83e8c;
  --red: #ed4c78;
  --orange: #fd7e14;
  --yellow: #f5ca99;
  --green: #28a745;
  --teal: #00c9a7;
  --cyan: #09a5be;
  --white: #fff;
  --gray: #8c98a4;
  --gray-dark: #71869d;
  --primary: #377dff;
  --secondary: #71869d;
  --success: #00c9a7;
  --info: #09a5be;
  --warning: #f5ca99;
  --danger: #ed4c78;
  --light: #f7faff;
  --dark: #21325b;
  --indigo: #2d1582;
  --breakpoint-xs: 0;
  --breakpoint-sm: 576px;
  --breakpoint-md: 768px;
  --breakpoint-lg: 992px;
  --breakpoint-xl: 1200px;
  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html {
  font-family: sans-serif;
  line-height: 1.15;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

article, aside, figcaption, figure, footer, header, hgroup, main, nav, section {
  display: block;
}

body {
  margin: 0;
  font-family: "Open Sans", sans-serif;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #677788;
  text-align: left;
  background-color: #fff;
}

[tabindex="-1"]:focus:not(:focus-visible) {
  outline: 0 !important;
}

hr {
  box-sizing: content-box;
  height: 0;
  overflow: visible;
}

h1, h2, h3, h4, h5, h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
}

p {
  margin-top: 0;
  margin-bottom: 1rem;
}

abbr[title],
abbr[data-original-title] {
  text-decoration: underline;
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  border-bottom: 0;
  text-decoration-skip-ink: none;
}

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit;
}

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem;
}

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0;
}

dt {
  font-weight: 600;
}

dd {
  margin-bottom: .5rem;
  margin-left: 0;
}

blockquote {
  margin: 0 0 1rem;
}

b,
strong {
  font-weight: bolder;
}

small {
  font-size: 80%;
}

sub,
sup {
  position: relative;
  font-size: 75%;
  line-height: 0;
  vertical-align: baseline;
}

sub {
  bottom: -.25em;
}

sup {
  top: -.5em;
}

a {
  color: #377dff;
  text-decoration: none;
  background-color: transparent;
}

a:hover {
  color: #0052ea;
  text-decoration: none;
}

a:not([href]):not([class]) {
  color: inherit;
  text-decoration: none;
}

a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none;
}

pre,
code,
kbd,
samp {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  font-size: 1em;
}

pre {
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  -ms-overflow-style: scrollbar;
}

figure {
  margin: 0 0 1rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

svg {
  overflow: hidden;
  vertical-align: middle;
}

table {
  border-collapse: collapse;
}

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #8c98a4;
  text-align: left;
  caption-side: bottom;
}

th {
  text-align: inherit;
  text-align: -webkit-match-parent;
}

label {
  display: inline-block;
  margin-bottom: 0.5rem;
}

button {
  border-radius: 0;
}

button:focus {
  outline: 1px dotted;
  outline: 5px auto -webkit-focus-ring-color;
}

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
}

button,
input {
  overflow: visible;
}

button,
select {
  text-transform: none;
}

[role="button"] {
  cursor: pointer;
}

select {
  word-wrap: normal;
}

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button;
}

button:not(:disabled),
[type="button"]:not(:disabled),
[type="reset"]:not(:disabled),
[type="submit"]:not(:disabled) {
  cursor: pointer;
}

button::-moz-focus-inner,
[type="button"]::-moz-focus-inner,
[type="reset"]::-moz-focus-inner,
[type="submit"]::-moz-focus-inner {
  padding: 0;
  border-style: none;
}

input[type="radio"],
input[type="checkbox"] {
  box-sizing: border-box;
  padding: 0;
}

textarea {
  overflow: auto;
  resize: vertical;
}

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0;
}

legend {
  display: block;
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: .5rem;
  font-size: 1.5rem;
  line-height: inherit;
  color: inherit;
  white-space: normal;
}

@media (max-width: 1200px) {
  legend {
    font-size: calc(1.275rem + 0.3vw) ;
  }
}

progress {
  vertical-align: baseline;
}

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  height: auto;
}

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: none;
}

[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}

::-webkit-file-upload-button {
  font: inherit;
  -webkit-appearance: button;
}

output {
  display: inline-block;
}

summary {
  display: list-item;
  cursor: pointer;
}

template {
  display: none;
}

[hidden] {
  display: none !important;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.4;
  color: #1e2022;
}

h1, .h1 {
  font-size: 2.5rem;
}

@media (max-width: 1200px) {
  h1, .h1 {
    font-size: calc(1.375rem + 1.5vw) ;
  }
}

h2, .h2 {
  font-size: 1.875rem;
}

@media (max-width: 1200px) {
  h2, .h2 {
    font-size: calc(1.3125rem + 0.75vw) ;
  }
}

h3, .h3 {
  font-size: 1.3125rem;
}

@media (max-width: 1200px) {
  h3, .h3 {
    font-size: calc(1.25625rem + 0.075vw) ;
  }
}

h4, .h4 {
  font-size: 1.125rem;
}

h5, .h5 {
  font-size: 1rem;
}

h6, .h6 {
  font-size: 0.875rem;
}

.lead {
  font-size: 1.25rem;
  font-weight: 400;
}

.display-1 {
  font-size: 6rem;
  font-weight: 600;
  line-height: 1.2;
}

@media (max-width: 1200px) {
  .display-1 {
    font-size: calc(1.725rem + 5.7vw) ;
  }
}

.display-2 {
  font-size: 5.5rem;
  font-weight: 600;
  line-height: 1.2;
}

@media (max-width: 1200px) {
  .display-2 {
    font-size: calc(1.675rem + 5.1vw) ;
  }
}

.display-3 {
  font-size: 4.5rem;
  font-weight: 600;
  line-height: 1.2;
}

@media (max-width: 1200px) {
  .display-3 {
    font-size: calc(1.575rem + 3.9vw) ;
  }
}

.display-4 {
  font-size: 3.5rem;
  font-weight: 600;
  line-height: 1.2;
}

@media (max-width: 1200px) {
  .display-4 {
    font-size: calc(1.475rem + 2.7vw) ;
  }
}

hr {
  margin-top: 1rem;
  margin-bottom: 1rem;
  border: 0;
  border-top: 0.0625rem solid #e7eaf3;
}

small,
.small {
  font-size: 80%;
  font-weight: 400;
}

mark,
.mark {
  padding: 0.2em;
  background-color: rgba(55, 125, 255, 0.1);
}

.list-unstyled {
  padding-left: 0;
  list-style: none;
}

.list-inline {
  padding-left: 0;
  list-style: none;
}

.list-inline-item {
  display: inline-block;
}

.list-inline-item:not(:last-child) {
  margin-right: 0.5rem;
}

.initialism {
  font-size: 90%;
  text-transform: uppercase;
}

.blockquote {
  margin-bottom: 1rem;
  font-size: 1rem;
}

.blockquote-footer {
  display: block;
  font-size: 80%;
  color: #8c98a4;
}

.blockquote-footer::before {
  content: "\\2014\\00A0";
}

.img-fluid {
  max-width: 100%;
  height: auto;
}

.img-thumbnail {
  padding: 0.25rem;
  background-color: #fff;
  border: 0.0625rem solid #e7eaf3;
  border-radius: 0.3125rem;
  max-width: 100%;
  height: auto;
}

.figure {
  display: inline-block;
}

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1;
}

.figure-caption {
  font-size: 90%;
  color: #8c98a4;
}

code {
  font-size: 87.5%;
  color: #e83e8c;
  word-wrap: break-word;
}

a > code {
  color: inherit;
}

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 87.5%;
  color: #1e2022;
  background-color: #e7eaf3;
  border-radius: 0.25rem;
}

kbd kbd {
  padding: 0;
  font-size: 100%;
  font-weight: 600;
}

pre {
  display: block;
  font-size: 87.5%;
  color: #1e2022;
}

pre code {
  font-size: inherit;
  color: inherit;
  word-break: normal;
}

.pre-scrollable {
  max-height: 340px;
  overflow-y: scroll;
}

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl {
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px;
  }
}

@media (min-width: 768px) {
  .container, .container-sm, .container-md {
    max-width: 720px;
  }
}

@media (min-width: 992px) {
  .container, .container-sm, .container-md, .container-lg {
    max-width: 960px;
  }
}

@media (min-width: 1200px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1140px;
  }
}

.row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -15px;
  margin-left: -15px;
}

.no-gutters {
  margin-right: 0;
  margin-left: 0;
}

.no-gutters > .col,
.no-gutters > [class*="col-"] {
  padding-right: 0;
  padding-left: 0;
}

.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,
.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,
.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,
.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,
.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,
.col-xl-auto {
  position: relative;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}

.col {
  flex-basis: 0;
  flex-grow: 1;
  max-width: 100%;
}

.row-cols-1 > * {
  flex: 0 0 100%;
  max-width: 100%;
}

.row-cols-2 > * {
  flex: 0 0 50%;
  max-width: 50%;
}

.row-cols-3 > * {
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}

.row-cols-4 > * {
  flex: 0 0 25%;
  max-width: 25%;
}

.row-cols-5 > * {
  flex: 0 0 20%;
  max-width: 20%;
}

.row-cols-6 > * {
  flex: 0 0 16.66667%;
  max-width: 16.66667%;
}

.col-auto {
  flex: 0 0 auto;
  width: auto;
  max-width: 100%;
}

.col-1 {
  flex: 0 0 8.33333%;
  max-width: 8.33333%;
}

.col-2 {
  flex: 0 0 16.66667%;
  max-width: 16.66667%;
}

.col-3 {
  flex: 0 0 25%;
  max-width: 25%;
}

.col-4 {
  flex: 0 0 33.33333%;
  max-width: 33.33333%;
}

.col-5 {
  flex: 0 0 41.66667%;
  max-width: 41.66667%;
}

.col-6 {
  flex: 0 0 50%;
  max-width: 50%;
}

.col-7 {
  flex: 0 0 58.33333%;
  max-width: 58.33333%;
}

.col-8 {
  flex: 0 0 66.66667%;
  max-width: 66.66667%;
}

.col-9 {
  flex: 0 0 75%;
  max-width: 75%;
}

.col-10 {
  flex: 0 0 83.33333%;
  max-width: 83.33333%;
}

.col-11 {
  flex: 0 0 91.66667%;
  max-width: 91.66667%;
}

.col-12 {
  flex: 0 0 100%;
  max-width: 100%;
}

.order-first {
  order: -1;
}

.order-last {
  order: 13;
}

.order-0 {
  order: 0;
}

.order-1 {
  order: 1;
}

.order-2 {
  order: 2;
}

.order-3 {
  order: 3;
}

.order-4 {
  order: 4;
}

.order-5 {
  order: 5;
}

.order-6 {
  order: 6;
}

.order-7 {
  order: 7;
}

.order-8 {
  order: 8;
}

.order-9 {
  order: 9;
}

.order-10 {
  order: 10;
}

.order-11 {
  order: 11;
}

.order-12 {
  order: 12;
}

.offset-1 {
  margin-left: 8.33333%;
}

.offset-2 {
  margin-left: 16.66667%;
}

.offset-3 {
  margin-left: 25%;
}

.offset-4 {
  margin-left: 33.33333%;
}

.offset-5 {
  margin-left: 41.66667%;
}

.offset-6 {
  margin-left: 50%;
}

.offset-7 {
  margin-left: 58.33333%;
}

.offset-8 {
  margin-left: 66.66667%;
}

.offset-9 {
  margin-left: 75%;
}

.offset-10 {
  margin-left: 83.33333%;
}

.offset-11 {
  margin-left: 91.66667%;
}

@media (min-width: 576px) {
  .col-sm {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-sm-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-sm-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-sm-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
  .row-cols-sm-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-sm-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-sm-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-sm-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }
  .col-sm-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
  .col-sm-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-sm-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
  .col-sm-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }
  .col-sm-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-sm-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }
  .col-sm-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }
  .col-sm-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-sm-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }
  .col-sm-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }
  .col-sm-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-sm-first {
    order: -1;
  }
  .order-sm-last {
    order: 13;
  }
  .order-sm-0 {
    order: 0;
  }
  .order-sm-1 {
    order: 1;
  }
  .order-sm-2 {
    order: 2;
  }
  .order-sm-3 {
    order: 3;
  }
  .order-sm-4 {
    order: 4;
  }
  .order-sm-5 {
    order: 5;
  }
  .order-sm-6 {
    order: 6;
  }
  .order-sm-7 {
    order: 7;
  }
  .order-sm-8 {
    order: 8;
  }
  .order-sm-9 {
    order: 9;
  }
  .order-sm-10 {
    order: 10;
  }
  .order-sm-11 {
    order: 11;
  }
  .order-sm-12 {
    order: 12;
  }
  .offset-sm-0 {
    margin-left: 0;
  }
  .offset-sm-1 {
    margin-left: 8.33333%;
  }
  .offset-sm-2 {
    margin-left: 16.66667%;
  }
  .offset-sm-3 {
    margin-left: 25%;
  }
  .offset-sm-4 {
    margin-left: 33.33333%;
  }
  .offset-sm-5 {
    margin-left: 41.66667%;
  }
  .offset-sm-6 {
    margin-left: 50%;
  }
  .offset-sm-7 {
    margin-left: 58.33333%;
  }
  .offset-sm-8 {
    margin-left: 66.66667%;
  }
  .offset-sm-9 {
    margin-left: 75%;
  }
  .offset-sm-10 {
    margin-left: 83.33333%;
  }
  .offset-sm-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 768px) {
  .col-md {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-md-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-md-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-md-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
  .row-cols-md-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-md-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-md-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-md-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }
  .col-md-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
  .col-md-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-md-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
  .col-md-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }
  .col-md-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-md-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }
  .col-md-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }
  .col-md-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-md-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }
  .col-md-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }
  .col-md-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-md-first {
    order: -1;
  }
  .order-md-last {
    order: 13;
  }
  .order-md-0 {
    order: 0;
  }
  .order-md-1 {
    order: 1;
  }
  .order-md-2 {
    order: 2;
  }
  .order-md-3 {
    order: 3;
  }
  .order-md-4 {
    order: 4;
  }
  .order-md-5 {
    order: 5;
  }
  .order-md-6 {
    order: 6;
  }
  .order-md-7 {
    order: 7;
  }
  .order-md-8 {
    order: 8;
  }
  .order-md-9 {
    order: 9;
  }
  .order-md-10 {
    order: 10;
  }
  .order-md-11 {
    order: 11;
  }
  .order-md-12 {
    order: 12;
  }
  .offset-md-0 {
    margin-left: 0;
  }
  .offset-md-1 {
    margin-left: 8.33333%;
  }
  .offset-md-2 {
    margin-left: 16.66667%;
  }
  .offset-md-3 {
    margin-left: 25%;
  }
  .offset-md-4 {
    margin-left: 33.33333%;
  }
  .offset-md-5 {
    margin-left: 41.66667%;
  }
  .offset-md-6 {
    margin-left: 50%;
  }
  .offset-md-7 {
    margin-left: 58.33333%;
  }
  .offset-md-8 {
    margin-left: 66.66667%;
  }
  .offset-md-9 {
    margin-left: 75%;
  }
  .offset-md-10 {
    margin-left: 83.33333%;
  }
  .offset-md-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 992px) {
  .col-lg {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-lg-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-lg-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-lg-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
  .row-cols-lg-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-lg-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-lg-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-lg-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }
  .col-lg-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
  .col-lg-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-lg-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
  .col-lg-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }
  .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-lg-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }
  .col-lg-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }
  .col-lg-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-lg-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }
  .col-lg-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }
  .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-lg-first {
    order: -1;
  }
  .order-lg-last {
    order: 13;
  }
  .order-lg-0 {
    order: 0;
  }
  .order-lg-1 {
    order: 1;
  }
  .order-lg-2 {
    order: 2;
  }
  .order-lg-3 {
    order: 3;
  }
  .order-lg-4 {
    order: 4;
  }
  .order-lg-5 {
    order: 5;
  }
  .order-lg-6 {
    order: 6;
  }
  .order-lg-7 {
    order: 7;
  }
  .order-lg-8 {
    order: 8;
  }
  .order-lg-9 {
    order: 9;
  }
  .order-lg-10 {
    order: 10;
  }
  .order-lg-11 {
    order: 11;
  }
  .order-lg-12 {
    order: 12;
  }
  .offset-lg-0 {
    margin-left: 0;
  }
  .offset-lg-1 {
    margin-left: 8.33333%;
  }
  .offset-lg-2 {
    margin-left: 16.66667%;
  }
  .offset-lg-3 {
    margin-left: 25%;
  }
  .offset-lg-4 {
    margin-left: 33.33333%;
  }
  .offset-lg-5 {
    margin-left: 41.66667%;
  }
  .offset-lg-6 {
    margin-left: 50%;
  }
  .offset-lg-7 {
    margin-left: 58.33333%;
  }
  .offset-lg-8 {
    margin-left: 66.66667%;
  }
  .offset-lg-9 {
    margin-left: 75%;
  }
  .offset-lg-10 {
    margin-left: 83.33333%;
  }
  .offset-lg-11 {
    margin-left: 91.66667%;
  }
}

@media (min-width: 1200px) {
  .col-xl {
    flex-basis: 0;
    flex-grow: 1;
    max-width: 100%;
  }
  .row-cols-xl-1 > * {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .row-cols-xl-2 > * {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .row-cols-xl-3 > * {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
  .row-cols-xl-4 > * {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .row-cols-xl-5 > * {
    flex: 0 0 20%;
    max-width: 20%;
  }
  .row-cols-xl-6 > * {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto;
    max-width: 100%;
  }
  .col-xl-1 {
    flex: 0 0 8.33333%;
    max-width: 8.33333%;
  }
  .col-xl-2 {
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
  }
  .col-xl-3 {
    flex: 0 0 25%;
    max-width: 25%;
  }
  .col-xl-4 {
    flex: 0 0 33.33333%;
    max-width: 33.33333%;
  }
  .col-xl-5 {
    flex: 0 0 41.66667%;
    max-width: 41.66667%;
  }
  .col-xl-6 {
    flex: 0 0 50%;
    max-width: 50%;
  }
  .col-xl-7 {
    flex: 0 0 58.33333%;
    max-width: 58.33333%;
  }
  .col-xl-8 {
    flex: 0 0 66.66667%;
    max-width: 66.66667%;
  }
  .col-xl-9 {
    flex: 0 0 75%;
    max-width: 75%;
  }
  .col-xl-10 {
    flex: 0 0 83.33333%;
    max-width: 83.33333%;
  }
  .col-xl-11 {
    flex: 0 0 91.66667%;
    max-width: 91.66667%;
  }
  .col-xl-12 {
    flex: 0 0 100%;
    max-width: 100%;
  }
  .order-xl-first {
    order: -1;
  }
  .order-xl-last {
    order: 13;
  }
  .order-xl-0 {
    order: 0;
  }
  .order-xl-1 {
    order: 1;
  }
  .order-xl-2 {
    order: 2;
  }
  .order-xl-3 {
    order: 3;
  }
  .order-xl-4 {
    order: 4;
  }
  .order-xl-5 {
    order: 5;
  }
  .order-xl-6 {
    order: 6;
  }
  .order-xl-7 {
    order: 7;
  }
  .order-xl-8 {
    order: 8;
  }
  .order-xl-9 {
    order: 9;
  }
  .order-xl-10 {
    order: 10;
  }
  .order-xl-11 {
    order: 11;
  }
  .order-xl-12 {
    order: 12;
  }
  .offset-xl-0 {
    margin-left: 0;
  }
  .offset-xl-1 {
    margin-left: 8.33333%;
  }
  .offset-xl-2 {
    margin-left: 16.66667%;
  }
  .offset-xl-3 {
    margin-left: 25%;
  }
  .offset-xl-4 {
    margin-left: 33.33333%;
  }
  .offset-xl-5 {
    margin-left: 41.66667%;
  }
  .offset-xl-6 {
    margin-left: 50%;
  }
  .offset-xl-7 {
    margin-left: 58.33333%;
  }
  .offset-xl-8 {
    margin-left: 66.66667%;
  }
  .offset-xl-9 {
    margin-left: 75%;
  }
  .offset-xl-10 {
    margin-left: 83.33333%;
  }
  .offset-xl-11 {
    margin-left: 91.66667%;
  }
}

.table {
  width: 100%;
  margin-bottom: 1rem;
  color: #677788;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: top;
  border-top: 0.0625rem solid #e7eaf3;
}

.table thead th {
  vertical-align: bottom;
  border-bottom: 0.125rem solid #e7eaf3;
}

.table tbody + tbody {
  border-top: 0.125rem solid #e7eaf3;
}

.table-sm th,
.table-sm td {
  padding: 0.3rem;
}

.table-bordered {
  border: 0.0625rem solid #e7eaf3;
}

.table-bordered th,
.table-bordered td {
  border: 0.0625rem solid #e7eaf3;
}

.table-bordered thead th,
.table-bordered thead td {
  border-bottom-width: 0.125rem;
}

.table-borderless th,
.table-borderless td,
.table-borderless thead th,
.table-borderless tbody + tbody {
  border: 0;
}

.table-striped tbody tr:nth-of-type(odd) {
  background-color: #f8fafd;
}

.table-hover tbody tr:hover {
  color: #677788;
  background-color: rgba(231, 234, 243, 0.4);
}

.table-primary,
.table-primary > th,
.table-primary > td {
  background-color: #c7dbff;
}

.table-primary th,
.table-primary td,
.table-primary thead th,
.table-primary tbody + tbody {
  border-color: #97bbff;
}

.table-hover .table-primary:hover {
  background-color: #aecbff;
}

.table-hover .table-primary:hover > td,
.table-hover .table-primary:hover > th {
  background-color: #aecbff;
}

.table-secondary,
.table-secondary > th,
.table-secondary > td {
  background-color: #d7dde4;
}

.table-secondary th,
.table-secondary td,
.table-secondary thead th,
.table-secondary tbody + tbody {
  border-color: #b5c0cc;
}

.table-hover .table-secondary:hover {
  background-color: #c8d0da;
}

.table-hover .table-secondary:hover > td,
.table-hover .table-secondary:hover > th {
  background-color: #c8d0da;
}

.table-success,
.table-success > th,
.table-success > td {
  background-color: #b8f0e6;
}

.table-success th,
.table-success td,
.table-success thead th,
.table-success tbody + tbody {
  border-color: #7ae3d1;
}

.table-hover .table-success:hover {
  background-color: #a3ecdf;
}

.table-hover .table-success:hover > td,
.table-hover .table-success:hover > th {
  background-color: #a3ecdf;
}

.table-info,
.table-info > th,
.table-info > td {
  background-color: #bae6ed;
}

.table-info th,
.table-info td,
.table-info thead th,
.table-info tbody + tbody {
  border-color: #7fd0dd;
}

.table-hover .table-info:hover {
  background-color: #a6dfe8;
}

.table-hover .table-info:hover > td,
.table-hover .table-info:hover > th {
  background-color: #a6dfe8;
}

.table-warning,
.table-warning > th,
.table-warning > td {
  background-color: #fcf0e2;
}

.table-warning th,
.table-warning td,
.table-warning thead th,
.table-warning tbody + tbody {
  border-color: #fae3ca;
}

.table-hover .table-warning:hover {
  background-color: #fae4cb;
}

.table-hover .table-warning:hover > td,
.table-hover .table-warning:hover > th {
  background-color: #fae4cb;
}

.table-danger,
.table-danger > th,
.table-danger > td {
  background-color: #facdd9;
}

.table-danger th,
.table-danger td,
.table-danger thead th,
.table-danger tbody + tbody {
  border-color: #f6a2b9;
}

.table-hover .table-danger:hover {
  background-color: #f8b6c7;
}

.table-hover .table-danger:hover > td,
.table-hover .table-danger:hover > th {
  background-color: #f8b6c7;
}

.table-light,
.table-light > th,
.table-light > td {
  background-color: #fdfeff;
}

.table-light th,
.table-light td,
.table-light thead th,
.table-light tbody + tbody {
  border-color: #fbfcff;
}

.table-hover .table-light:hover {
  background-color: #e4f1ff;
}

.table-hover .table-light:hover > td,
.table-hover .table-light:hover > th {
  background-color: #e4f1ff;
}

.table-dark,
.table-dark > th,
.table-dark > td {
  background-color: #c1c6d1;
}

.table-dark th,
.table-dark td,
.table-dark thead th,
.table-dark tbody + tbody {
  border-color: #8c94aa;
}

.table-hover .table-dark:hover {
  background-color: #b2b9c6;
}

.table-hover .table-dark:hover > td,
.table-hover .table-dark:hover > th {
  background-color: #b2b9c6;
}

.table-indigo,
.table-indigo > th,
.table-indigo > td {
  background-color: #c4bddc;
}

.table-indigo th,
.table-indigo td,
.table-indigo thead th,
.table-indigo tbody + tbody {
  border-color: #9285be;
}

.table-hover .table-indigo:hover {
  background-color: #b5acd3;
}

.table-hover .table-indigo:hover > td,
.table-hover .table-indigo:hover > th {
  background-color: #b5acd3;
}

.table-active,
.table-active > th,
.table-active > td {
  background-color: rgba(231, 234, 243, 0.4);
}

.table-hover .table-active:hover {
  background-color: rgba(214, 219, 235, 0.4);
}

.table-hover .table-active:hover > td,
.table-hover .table-active:hover > th {
  background-color: rgba(214, 219, 235, 0.4);
}

.table .thead-dark th {
  color: #fff;
  background-color: #21325b;
  border-color: #2b4177;
}

.table .thead-light th {
  color: #677788;
  background-color: #f8fafd;
  border-color: #e7eaf3;
}

.table-dark {
  color: #fff;
  background-color: #21325b;
}

.table-dark th,
.table-dark td,
.table-dark thead th {
  border-color: #2b4177;
}

.table-dark.table-bordered {
  border: 0;
}

.table-dark.table-striped tbody tr:nth-of-type(odd) {
  background-color: rgba(255, 255, 255, 0.05);
}

.table-dark.table-hover tbody tr:hover {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.075);
}

@media (max-width: 575.98px) {
  .table-responsive-sm {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-sm > .table-bordered {
    border: 0;
  }
}

@media (max-width: 767.98px) {
  .table-responsive-md {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-md > .table-bordered {
    border: 0;
  }
}

@media (max-width: 991.98px) {
  .table-responsive-lg {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-lg > .table-bordered {
    border: 0;
  }
}

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    display: block;
    width: 100%;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .table-responsive-xl > .table-bordered {
    border: 0;
  }
}

.table-responsive {
  display: block;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
}

.table-responsive > .table-bordered {
  border: 0;
}

.form-control {
  display: block;
  width: 100%;
  height: calc(1.6em + 1.625rem);
  padding: 0.75rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #1e2022;
  background-color: #fff;
  background-clip: padding-box;
  border: 0.0625rem solid #e7eaf3;
  border-radius: 0.3125rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .form-control {
    transition: none;
  }
}

.form-control::-ms-expand {
  background-color: transparent;
  border: 0;
}

.form-control:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #1e2022;
}

.form-control:focus {
  color: #1e2022;
  background-color: #fff;
  border-color: rgba(55, 125, 255, 0.4);
  outline: 0;
  box-shadow: 0 0 10px rgba(55, 125, 255, 0.1);
}

.form-control::placeholder {
  color: #97a4af;
  opacity: 1;
}

.form-control:disabled, .form-control[readonly] {
  background-color: #f8fafd;
  opacity: 1;
}

input[type="date"].form-control,
input[type="time"].form-control,
input[type="datetime-local"].form-control,
input[type="month"].form-control {
  appearance: none;
}

select.form-control:focus::-ms-value {
  color: #1e2022;
  background-color: #fff;
}

.form-control-file,
.form-control-range {
  display: block;
  width: 100%;
}

.col-form-label {
  padding-top: 0.8125rem;
  padding-bottom: 0.8125rem;
  margin-bottom: 0;
  font-size: inherit;
  line-height: 1.6;
}

.col-form-label-lg {
  padding-top: 1.1875rem;
  padding-bottom: 1.1875rem;
  font-size: 1.25rem;
  line-height: 1.5;
}

.col-form-label-sm {
  padding-top: 0.6875rem;
  padding-bottom: 0.6875rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.75rem 0;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.6;
  color: #677788;
  background-color: transparent;
  border: solid transparent;
  border-width: 0.0625rem 0;
}

.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
  padding-right: 0;
  padding-left: 0;
}

.form-control-sm {
  height: calc(1.5em + 1.375rem);
  padding: 0.625rem 1.125rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.form-control-lg {
  height: calc(1.5em + 2.375rem);
  padding: 1.125rem 1.125rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.75rem;
}

select.form-control[size], select.form-control[multiple] {
  height: auto;
}

textarea.form-control {
  height: auto;
}

.form-group {
  margin-bottom: 1.5rem;
}

.form-text {
  display: block;
  margin-top: 0.25rem;
}

.form-row {
  display: flex;
  flex-wrap: wrap;
  margin-right: -5px;
  margin-left: -5px;
}

.form-row > .col,
.form-row > [class*="col-"] {
  padding-right: 5px;
  padding-left: 5px;
}

.form-check {
  position: relative;
  display: block;
  padding-left: 1.25rem;
}

.form-check-input {
  position: absolute;
  margin-top: 0.3rem;
  margin-left: -1.25rem;
}

.form-check-input[disabled] ~ .form-check-label,
.form-check-input:disabled ~ .form-check-label {
  color: #8c98a4;
}

.form-check-label {
  margin-bottom: 0;
}

.form-check-inline {
  display: inline-flex;
  align-items: center;
  padding-left: 0;
  margin-right: 0.75rem;
}

.form-check-inline .form-check-input {
  position: static;
  margin-top: 0;
  margin-right: 0.3125rem;
  margin-left: 0;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #00c9a7;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.875rem;
  line-height: 1.6;
  color: #fff;
  background-color: #00c9a7;
  border-radius: 0.3125rem;
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #00c9a7;
  padding-right: calc(1.6em + 1.5rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.4em + 0.375rem) center;
  background-size: calc(0.8em + 0.75rem) calc(0.8em + 0.75rem);
}

.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #00c9a7;
  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.6em + 1.5rem);
  background-position: top calc(0.4em + 0.375rem) right calc(0.4em + 0.375rem);
}

.was-validated .custom-select:valid, .custom-select.is-valid {
  border-color: #00c9a7;
  padding-right: calc(0.75em + 3.125rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.5rem center/1rem 1rem, url(${___CSS_LOADER_URL_REPLACEMENT_0___}) #fff no-repeat center right 2rem/calc(0.8em + 0.75rem) calc(0.8em + 0.75rem);
}

.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {
  border-color: #00c9a7;
  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.25);
}

.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #00c9a7;
}

.was-validated .form-check-input:valid ~ .valid-feedback,
.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,
.form-check-input.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {
  color: #00c9a7;
}

.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {
  border-color: #00c9a7;
}

.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {
  border-color: #00fcd1;
  background-color: #00fcd1;
}

.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.25);
}

.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #00c9a7;
}

.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {
  border-color: #00c9a7;
}

.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {
  border-color: #00c9a7;
  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.25);
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 80%;
  color: #ed4c78;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: .1rem;
  font-size: 0.875rem;
  line-height: 1.6;
  color: #fff;
  background-color: #ed4c78;
  border-radius: 0.3125rem;
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #ed4c78;
  padding-right: calc(1.6em + 1.5rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-repeat: no-repeat;
  background-position: right calc(0.4em + 0.375rem) center;
  background-size: calc(0.8em + 0.75rem) calc(0.8em + 0.75rem);
}

.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #ed4c78;
  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.6em + 1.5rem);
  background-position: top calc(0.4em + 0.375rem) right calc(0.4em + 0.375rem);
}

.was-validated .custom-select:invalid, .custom-select.is-invalid {
  border-color: #ed4c78;
  padding-right: calc(0.75em + 3.125rem);
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.5rem center/1rem 1rem, url(${___CSS_LOADER_URL_REPLACEMENT_2___}) #fff no-repeat center right 2rem/calc(0.8em + 0.75rem) calc(0.8em + 0.75rem);
}

.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {
  border-color: #ed4c78;
  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.25);
}

.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #ed4c78;
}

.was-validated .form-check-input:invalid ~ .invalid-feedback,
.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,
.form-check-input.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {
  color: #ed4c78;
}

.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {
  border-color: #ed4c78;
}

.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {
  border-color: #f27a9b;
  background-color: #f27a9b;
}

.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {
  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.25);
}

.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {
  border-color: #ed4c78;
}

.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {
  border-color: #ed4c78;
}

.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {
  border-color: #ed4c78;
  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.25);
}

.form-inline {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
}

.form-inline .form-check {
  width: 100%;
}

@media (min-width: 576px) {
  .form-inline label {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 0;
  }
  .form-inline .form-group {
    display: flex;
    flex: 0 0 auto;
    flex-flow: row wrap;
    align-items: center;
    margin-bottom: 0;
  }
  .form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
  }
  .form-inline .form-control-plaintext {
    display: inline-block;
  }
  .form-inline .input-group,
  .form-inline .custom-select {
    width: auto;
  }
  .form-inline .form-check {
    display: flex;
    align-items: center;
    justify-content: center;
    width: auto;
    padding-left: 0;
  }
  .form-inline .form-check-input {
    position: relative;
    flex-shrink: 0;
    margin-top: 0;
    margin-right: 0.25rem;
    margin-left: 0;
  }
  .form-inline .custom-control {
    align-items: center;
    justify-content: center;
  }
  .form-inline .custom-control-label {
    margin-bottom: 0;
  }
}

.btn {
  display: inline-block;
  font-weight: 600;
  color: #677788;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
          user-select: none;
  background-color: transparent;
  border: 0.0625rem solid transparent;
  padding: 0.75rem 1rem;
  font-size: 1rem;
  line-height: 1.6;
  border-radius: 0.3125rem;
  transition: all 0.2s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .btn {
    transition: none;
  }
}

.btn:hover {
  color: #677788;
  text-decoration: none;
}

.btn:focus, .btn.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 125, 255, 0.25);
}

.btn.disabled, .btn:disabled {
  opacity: 0.65;
}

.btn:not(:disabled):not(.disabled) {
  cursor: pointer;
}

a.btn.disabled,
fieldset:disabled a.btn {
  pointer-events: none;
}

.btn-primary {
  color: #fff;
  background-color: #377dff;
  border-color: #377dff;
}

.btn-primary:hover {
  color: #fff;
  background-color: #1164ff;
  border-color: #045cff;
}

.btn-primary:focus, .btn-primary.focus {
  color: #fff;
  background-color: #1164ff;
  border-color: #045cff;
  box-shadow: 0 0 0 0.2rem rgba(85, 145, 255, 0.5);
}

.btn-primary.disabled, .btn-primary:disabled {
  color: #fff;
  background-color: #377dff;
  border-color: #377dff;
}

.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  color: #fff;
  background-color: #045cff;
  border-color: #0056f6;
}

.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(85, 145, 255, 0.5);
}

.btn-secondary {
  color: #fff;
  background-color: #71869d;
  border-color: #71869d;
}

.btn-secondary:hover {
  color: #fff;
  background-color: #5f7389;
  border-color: #596d82;
}

.btn-secondary:focus, .btn-secondary.focus {
  color: #fff;
  background-color: #5f7389;
  border-color: #596d82;
  box-shadow: 0 0 0 0.2rem rgba(134, 152, 172, 0.5);
}

.btn-secondary.disabled, .btn-secondary:disabled {
  color: #fff;
  background-color: #71869d;
  border-color: #71869d;
}

.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active,
.show > .btn-secondary.dropdown-toggle {
  color: #fff;
  background-color: #596d82;
  border-color: #54667a;
}

.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(134, 152, 172, 0.5);
}

.btn-success {
  color: #fff;
  background-color: #00c9a7;
  border-color: #00c9a7;
}

.btn-success:hover {
  color: #fff;
  background-color: #00a387;
  border-color: #00967d;
}

.btn-success:focus, .btn-success.focus {
  color: #fff;
  background-color: #00a387;
  border-color: #00967d;
  box-shadow: 0 0 0 0.2rem rgba(38, 209, 180, 0.5);
}

.btn-success.disabled, .btn-success:disabled {
  color: #fff;
  background-color: #00c9a7;
  border-color: #00c9a7;
}

.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,
.show > .btn-success.dropdown-toggle {
  color: #fff;
  background-color: #00967d;
  border-color: #008972;
}

.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,
.show > .btn-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(38, 209, 180, 0.5);
}

.btn-info {
  color: #fff;
  background-color: #09a5be;
  border-color: #09a5be;
}

.btn-info:hover {
  color: #fff;
  background-color: #078599;
  border-color: #077b8d;
}

.btn-info:focus, .btn-info.focus {
  color: #fff;
  background-color: #078599;
  border-color: #077b8d;
  box-shadow: 0 0 0 0.2rem rgba(46, 179, 200, 0.5);
}

.btn-info.disabled, .btn-info:disabled {
  color: #fff;
  background-color: #09a5be;
  border-color: #09a5be;
}

.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,
.show > .btn-info.dropdown-toggle {
  color: #fff;
  background-color: #077b8d;
  border-color: #067081;
}

.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(46, 179, 200, 0.5);
}

.btn-warning {
  color: #1e2022;
  background-color: #f5ca99;
  border-color: #f5ca99;
}

.btn-warning:hover {
  color: #1e2022;
  background-color: #f2b876;
  border-color: #f0b26b;
}

.btn-warning:focus, .btn-warning.focus {
  color: #1e2022;
  background-color: #f2b876;
  border-color: #f0b26b;
  box-shadow: 0 0 0 0.2rem rgba(213, 177, 135, 0.5);
}

.btn-warning.disabled, .btn-warning:disabled {
  color: #1e2022;
  background-color: #f5ca99;
  border-color: #f5ca99;
}

.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,
.show > .btn-warning.dropdown-toggle {
  color: #1e2022;
  background-color: #f0b26b;
  border-color: #efac5f;
}

.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,
.show > .btn-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(213, 177, 135, 0.5);
}

.btn-danger {
  color: #fff;
  background-color: #ed4c78;
  border-color: #ed4c78;
}

.btn-danger:hover {
  color: #fff;
  background-color: #ea295e;
  border-color: #e81e55;
}

.btn-danger:focus, .btn-danger.focus {
  color: #fff;
  background-color: #ea295e;
  border-color: #e81e55;
  box-shadow: 0 0 0 0.2rem rgba(240, 103, 140, 0.5);
}

.btn-danger.disabled, .btn-danger:disabled {
  color: #fff;
  background-color: #ed4c78;
  border-color: #ed4c78;
}

.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,
.show > .btn-danger.dropdown-toggle {
  color: #fff;
  background-color: #e81e55;
  border-color: #e2174e;
}

.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,
.show > .btn-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(240, 103, 140, 0.5);
}

.btn-light {
  color: #1e2022;
  background-color: #f7faff;
  border-color: #f7faff;
}

.btn-light:hover {
  color: #1e2022;
  background-color: #d1e2ff;
  border-color: #c4daff;
}

.btn-light:focus, .btn-light.focus {
  color: #1e2022;
  background-color: #d1e2ff;
  border-color: #c4daff;
  box-shadow: 0 0 0 0.2rem rgba(214, 217, 222, 0.5);
}

.btn-light.disabled, .btn-light:disabled {
  color: #1e2022;
  background-color: #f7faff;
  border-color: #f7faff;
}

.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active,
.show > .btn-light.dropdown-toggle {
  color: #1e2022;
  background-color: #c4daff;
  border-color: #b7d2ff;
}

.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus,
.show > .btn-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(214, 217, 222, 0.5);
}

.btn-dark {
  color: #fff;
  background-color: #21325b;
  border-color: #21325b;
}

.btn-dark:hover {
  color: #fff;
  background-color: #17233f;
  border-color: #131d36;
}

.btn-dark:focus, .btn-dark.focus {
  color: #fff;
  background-color: #17233f;
  border-color: #131d36;
  box-shadow: 0 0 0 0.2rem rgba(66, 81, 116, 0.5);
}

.btn-dark.disabled, .btn-dark:disabled {
  color: #fff;
  background-color: #21325b;
  border-color: #21325b;
}

.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active,
.show > .btn-dark.dropdown-toggle {
  color: #fff;
  background-color: #131d36;
  border-color: #10182c;
}

.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus,
.show > .btn-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(66, 81, 116, 0.5);
}

.btn-indigo {
  color: #fff;
  background-color: #2d1582;
  border-color: #2d1582;
}

.btn-indigo:hover {
  color: #fff;
  background-color: #221061;
  border-color: #1e0e56;
}

.btn-indigo:focus, .btn-indigo.focus {
  color: #fff;
  background-color: #221061;
  border-color: #1e0e56;
  box-shadow: 0 0 0 0.2rem rgba(77, 56, 149, 0.5);
}

.btn-indigo.disabled, .btn-indigo:disabled {
  color: #fff;
  background-color: #2d1582;
  border-color: #2d1582;
}

.btn-indigo:not(:disabled):not(.disabled):active, .btn-indigo:not(:disabled):not(.disabled).active,
.show > .btn-indigo.dropdown-toggle {
  color: #fff;
  background-color: #1e0e56;
  border-color: #1a0c4b;
}

.btn-indigo:not(:disabled):not(.disabled):active:focus, .btn-indigo:not(:disabled):not(.disabled).active:focus,
.show > .btn-indigo.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(77, 56, 149, 0.5);
}

.btn-outline-primary {
  color: #377dff;
  border-color: #377dff;
}

.btn-outline-primary:hover {
  color: #fff;
  background-color: #377dff;
  border-color: #377dff;
}

.btn-outline-primary:focus, .btn-outline-primary.focus {
  box-shadow: 0 0 0 0.2rem rgba(55, 125, 255, 0.5);
}

.btn-outline-primary.disabled, .btn-outline-primary:disabled {
  color: #377dff;
  background-color: transparent;
}

.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,
.show > .btn-outline-primary.dropdown-toggle {
  color: #fff;
  background-color: #377dff;
  border-color: #377dff;
}

.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-primary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(55, 125, 255, 0.5);
}

.btn-outline-secondary {
  color: #71869d;
  border-color: #71869d;
}

.btn-outline-secondary:hover {
  color: #fff;
  background-color: #71869d;
  border-color: #71869d;
}

.btn-outline-secondary:focus, .btn-outline-secondary.focus {
  box-shadow: 0 0 0 0.2rem rgba(113, 134, 157, 0.5);
}

.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {
  color: #71869d;
  background-color: transparent;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active,
.show > .btn-outline-secondary.dropdown-toggle {
  color: #fff;
  background-color: #71869d;
  border-color: #71869d;
}

.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-secondary.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(113, 134, 157, 0.5);
}

.btn-outline-success {
  color: #00c9a7;
  border-color: #00c9a7;
}

.btn-outline-success:hover {
  color: #fff;
  background-color: #00c9a7;
  border-color: #00c9a7;
}

.btn-outline-success:focus, .btn-outline-success.focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.5);
}

.btn-outline-success.disabled, .btn-outline-success:disabled {
  color: #00c9a7;
  background-color: transparent;
}

.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,
.show > .btn-outline-success.dropdown-toggle {
  color: #fff;
  background-color: #00c9a7;
  border-color: #00c9a7;
}

.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-success.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.5);
}

.btn-outline-info {
  color: #09a5be;
  border-color: #09a5be;
}

.btn-outline-info:hover {
  color: #fff;
  background-color: #09a5be;
  border-color: #09a5be;
}

.btn-outline-info:focus, .btn-outline-info.focus {
  box-shadow: 0 0 0 0.2rem rgba(9, 165, 190, 0.5);
}

.btn-outline-info.disabled, .btn-outline-info:disabled {
  color: #09a5be;
  background-color: transparent;
}

.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active,
.show > .btn-outline-info.dropdown-toggle {
  color: #fff;
  background-color: #09a5be;
  border-color: #09a5be;
}

.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-info.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(9, 165, 190, 0.5);
}

.btn-outline-warning {
  color: #f5ca99;
  border-color: #f5ca99;
}

.btn-outline-warning:hover {
  color: #1e2022;
  background-color: #f5ca99;
  border-color: #f5ca99;
}

.btn-outline-warning:focus, .btn-outline-warning.focus {
  box-shadow: 0 0 0 0.2rem rgba(245, 202, 153, 0.5);
}

.btn-outline-warning.disabled, .btn-outline-warning:disabled {
  color: #f5ca99;
  background-color: transparent;
}

.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active,
.show > .btn-outline-warning.dropdown-toggle {
  color: #1e2022;
  background-color: #f5ca99;
  border-color: #f5ca99;
}

.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-warning.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(245, 202, 153, 0.5);
}

.btn-outline-danger {
  color: #ed4c78;
  border-color: #ed4c78;
}

.btn-outline-danger:hover {
  color: #fff;
  background-color: #ed4c78;
  border-color: #ed4c78;
}

.btn-outline-danger:focus, .btn-outline-danger.focus {
  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.5);
}

.btn-outline-danger.disabled, .btn-outline-danger:disabled {
  color: #ed4c78;
  background-color: transparent;
}

.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active,
.show > .btn-outline-danger.dropdown-toggle {
  color: #fff;
  background-color: #ed4c78;
  border-color: #ed4c78;
}

.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-danger.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.5);
}

.btn-outline-light {
  color: #f7faff;
  border-color: #f7faff;
}

.btn-outline-light:hover {
  color: #1e2022;
  background-color: #f7faff;
  border-color: #f7faff;
}

.btn-outline-light:focus, .btn-outline-light.focus {
  box-shadow: 0 0 0 0.2rem rgba(247, 250, 255, 0.5);
}

.btn-outline-light.disabled, .btn-outline-light:disabled {
  color: #f7faff;
  background-color: transparent;
}

.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active,
.show > .btn-outline-light.dropdown-toggle {
  color: #1e2022;
  background-color: #f7faff;
  border-color: #f7faff;
}

.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-light.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(247, 250, 255, 0.5);
}

.btn-outline-dark {
  color: #21325b;
  border-color: #21325b;
}

.btn-outline-dark:hover {
  color: #fff;
  background-color: #21325b;
  border-color: #21325b;
}

.btn-outline-dark:focus, .btn-outline-dark.focus {
  box-shadow: 0 0 0 0.2rem rgba(33, 50, 91, 0.5);
}

.btn-outline-dark.disabled, .btn-outline-dark:disabled {
  color: #21325b;
  background-color: transparent;
}

.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active,
.show > .btn-outline-dark.dropdown-toggle {
  color: #fff;
  background-color: #21325b;
  border-color: #21325b;
}

.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-dark.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(33, 50, 91, 0.5);
}

.btn-outline-indigo {
  color: #2d1582;
  border-color: #2d1582;
}

.btn-outline-indigo:hover {
  color: #fff;
  background-color: #2d1582;
  border-color: #2d1582;
}

.btn-outline-indigo:focus, .btn-outline-indigo.focus {
  box-shadow: 0 0 0 0.2rem rgba(45, 21, 130, 0.5);
}

.btn-outline-indigo.disabled, .btn-outline-indigo:disabled {
  color: #2d1582;
  background-color: transparent;
}

.btn-outline-indigo:not(:disabled):not(.disabled):active, .btn-outline-indigo:not(:disabled):not(.disabled).active,
.show > .btn-outline-indigo.dropdown-toggle {
  color: #fff;
  background-color: #2d1582;
  border-color: #2d1582;
}

.btn-outline-indigo:not(:disabled):not(.disabled):active:focus, .btn-outline-indigo:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-indigo.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(45, 21, 130, 0.5);
}

.btn-link {
  font-weight: 400;
  color: #377dff;
  text-decoration: none;
}

.btn-link:hover {
  color: #0052ea;
  text-decoration: none;
}

.btn-link:focus, .btn-link.focus {
  text-decoration: none;
}

.btn-link:disabled, .btn-link.disabled {
  color: #8c98a4;
  pointer-events: none;
}

.btn-lg, .btn-group-lg > .btn {
  padding: 1.125rem 1.125rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.75rem;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 0.625rem 1.125rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.btn-block {
  display: block;
  width: 100%;
}

.btn-block + .btn-block {
  margin-top: 0.5rem;
}

input[type="submit"].btn-block,
input[type="reset"].btn-block,
input[type="button"].btn-block {
  width: 100%;
}

.fade {
  transition: opacity 0.15s linear;
}

@media (prefers-reduced-motion: reduce) {
  .fade {
    transition: none;
  }
}

.fade:not(.show) {
  opacity: 0;
}

.collapse:not(.show) {
  display: none;
}

.collapsing {
  position: relative;
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease;
}

@media (prefers-reduced-motion: reduce) {
  .collapsing {
    transition: none;
  }
}

.dropup,
.dropright,
.dropdown,
.dropleft {
  position: relative;
}

.dropdown-toggle {
  white-space: nowrap;
}

.dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  min-width: 8.4375rem;
  padding: 1rem 0;
  margin: 0.5rem 0 0;
  font-size: 1rem;
  color: #677788;
  text-align: left;
  list-style: none;
  background-color: #fff;
  background-clip: padding-box;
  border: 0 solid rgba(0, 0, 0, 0.15);
  border-radius: 0.75rem;
}

.dropdown-menu-left {
  right: auto;
  left: 0;
}

.dropdown-menu-right {
  right: 0;
  left: auto;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-sm-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-md-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-lg-right {
    right: 0;
    left: auto;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-left {
    right: auto;
    left: 0;
  }
  .dropdown-menu-xl-right {
    right: 0;
    left: auto;
  }
}

.dropup .dropdown-menu {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.dropright .dropdown-menu {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: 0.5rem;
}

.dropright .dropdown-toggle::after {
  vertical-align: 0;
}

.dropleft .dropdown-menu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: 0.5rem;
}

.dropleft .dropdown-toggle::before {
  vertical-align: 0;
}

.dropdown-menu[x-placement^="top"], .dropdown-menu[x-placement^="right"], .dropdown-menu[x-placement^="bottom"], .dropdown-menu[x-placement^="left"] {
  right: auto;
  bottom: auto;
}

.dropdown-divider {
  height: 0;
  margin: 0.5rem 0;
  overflow: hidden;
  border-top: 1px solid #e7eaf3;
}

.dropdown-item {
  display: block;
  width: 100%;
  padding: 0.375rem 1.5rem;
  clear: both;
  font-weight: 400;
  color: #1e2022;
  text-align: inherit;
  white-space: nowrap;
  background-color: transparent;
  border: 0;
}

.dropdown-item:hover, .dropdown-item:focus {
  color: #121314;
  text-decoration: none;
  background-color: rgba(189, 197, 209, 0.3);
}

.dropdown-item.active, .dropdown-item:active {
  color: #1e2022;
  text-decoration: none;
  background-color: rgba(189, 197, 209, 0.3);
}

.dropdown-item.disabled, .dropdown-item:disabled {
  color: #8c98a4;
  pointer-events: none;
  background-color: transparent;
}

.dropdown-menu.show {
  display: block;
}

.dropdown-header {
  display: block;
  padding: 1rem 1.5rem;
  margin-bottom: 0;
  font-size: 0.875rem;
  color: #8c98a4;
  white-space: nowrap;
}

.dropdown-item-text {
  display: block;
  padding: 0.375rem 1.5rem;
  color: #1e2022;
}

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle;
}

.btn-group > .btn,
.btn-group-vertical > .btn {
  position: relative;
  flex: 1 1 auto;
}

.btn-group > .btn:hover,
.btn-group-vertical > .btn:hover {
  z-index: 1;
}

.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,
.btn-group-vertical > .btn:focus,
.btn-group-vertical > .btn:active,
.btn-group-vertical > .btn.active {
  z-index: 1;
}

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
}

.btn-toolbar .input-group {
  width: auto;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) {
  margin-left: -0.0625rem;
}

.btn-group > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group > .btn-group:not(:last-child) > .btn {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.btn-group > .btn:not(:first-child),
.btn-group > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.dropdown-toggle-split {
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.dropdown-toggle-split::after,
.dropup .dropdown-toggle-split::after,
.dropright .dropdown-toggle-split::after {
  margin-left: 0;
}

.dropleft .dropdown-toggle-split::before {
  margin-right: 0;
}

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.84375rem;
  padding-left: 0.84375rem;
}

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.84375rem;
  padding-left: 0.84375rem;
}

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
}

.btn-group-vertical > .btn,
.btn-group-vertical > .btn-group {
  width: 100%;
}

.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) {
  margin-top: -0.0625rem;
}

.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-vertical > .btn-group:not(:last-child) > .btn {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.btn-group-vertical > .btn:not(:first-child),
.btn-group-vertical > .btn-group:not(:first-child) > .btn {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.btn-group-toggle > .btn,
.btn-group-toggle > .btn-group > .btn {
  margin-bottom: 0;
}

.btn-group-toggle > .btn input[type="radio"],
.btn-group-toggle > .btn input[type="checkbox"],
.btn-group-toggle > .btn-group > .btn input[type="radio"],
.btn-group-toggle > .btn-group > .btn input[type="checkbox"] {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%;
}

.input-group > .form-control,
.input-group > .form-control-plaintext,
.input-group > .custom-select,
.input-group > .custom-file {
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
  margin-bottom: 0;
}

.input-group > .form-control + .form-control,
.input-group > .form-control + .custom-select,
.input-group > .form-control + .custom-file,
.input-group > .form-control-plaintext + .form-control,
.input-group > .form-control-plaintext + .custom-select,
.input-group > .form-control-plaintext + .custom-file,
.input-group > .custom-select + .form-control,
.input-group > .custom-select + .custom-select,
.input-group > .custom-select + .custom-file,
.input-group > .custom-file + .form-control,
.input-group > .custom-file + .custom-select,
.input-group > .custom-file + .custom-file {
  margin-left: -0.0625rem;
}

.input-group > .form-control:focus,
.input-group > .custom-select:focus,
.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {
  z-index: 3;
}

.input-group > .custom-file .custom-file-input:focus {
  z-index: 4;
}

.input-group > .form-control:not(:last-child),
.input-group > .custom-select:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .form-control:not(:first-child),
.input-group > .custom-select:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group > .custom-file {
  display: flex;
  align-items: center;
}

.input-group > .custom-file:not(:last-child) .custom-file-label,
.input-group > .custom-file:not(:last-child) .custom-file-label::after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .custom-file:not(:first-child) .custom-file-label {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group-prepend,
.input-group-append {
  display: flex;
}

.input-group-prepend .btn,
.input-group-append .btn {
  position: relative;
  z-index: 2;
}

.input-group-prepend .btn:focus,
.input-group-append .btn:focus {
  z-index: 3;
}

.input-group-prepend .btn + .btn,
.input-group-prepend .btn + .input-group-text,
.input-group-prepend .input-group-text + .input-group-text,
.input-group-prepend .input-group-text + .btn,
.input-group-append .btn + .btn,
.input-group-append .btn + .input-group-text,
.input-group-append .input-group-text + .input-group-text,
.input-group-append .input-group-text + .btn {
  margin-left: -0.0625rem;
}

.input-group-prepend {
  margin-right: -0.0625rem;
}

.input-group-append {
  margin-left: -0.0625rem;
}

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.75rem 1rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #97a4af;
  text-align: center;
  white-space: nowrap;
  background-color: transparent;
  border: 0.0625rem solid #e7eaf3;
  border-radius: 0.3125rem;
}

.input-group-text input[type="radio"],
.input-group-text input[type="checkbox"] {
  margin-top: 0;
}

.input-group-lg > .form-control:not(textarea),
.input-group-lg > .custom-select {
  height: calc(1.5em + 2.375rem);
}

.input-group-lg > .form-control,
.input-group-lg > .custom-select,
.input-group-lg > .input-group-prepend > .input-group-text,
.input-group-lg > .input-group-append > .input-group-text,
.input-group-lg > .input-group-prepend > .btn,
.input-group-lg > .input-group-append > .btn {
  padding: 1.125rem 1.125rem;
  font-size: 1.25rem;
  line-height: 1.5;
  border-radius: 0.75rem;
}

.input-group-sm > .form-control:not(textarea),
.input-group-sm > .custom-select {
  height: calc(1.5em + 1.375rem);
}

.input-group-sm > .form-control,
.input-group-sm > .custom-select,
.input-group-sm > .input-group-prepend > .input-group-text,
.input-group-sm > .input-group-append > .input-group-text,
.input-group-sm > .input-group-prepend > .btn,
.input-group-sm > .input-group-append > .btn {
  padding: 0.625rem 1.125rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.25rem;
}

.input-group-lg > .custom-select,
.input-group-sm > .custom-select {
  padding-right: 2rem;
}

.input-group > .input-group-prepend > .btn,
.input-group > .input-group-prepend > .input-group-text,
.input-group > .input-group-append:not(:last-child) > .btn,
.input-group > .input-group-append:not(:last-child) > .input-group-text,
.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),
.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append > .btn,
.input-group > .input-group-append > .input-group-text,
.input-group > .input-group-prepend:not(:first-child) > .btn,
.input-group > .input-group-prepend:not(:first-child) > .input-group-text,
.input-group > .input-group-prepend:first-child > .btn:not(:first-child),
.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.custom-control {
  position: relative;
  z-index: 1;
  display: block;
  min-height: 1.6rem;
  padding-left: 1.5rem;
  color-adjust: exact;
}

.custom-control-inline {
  display: inline-flex;
  margin-right: 1rem;
}

.custom-control-input {
  position: absolute;
  left: 0;
  z-index: -1;
  width: 1rem;
  height: 1.3rem;
  opacity: 0;
}

.custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #377dff;
  background-color: #377dff;
}

.custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: 0 0 10px rgba(55, 125, 255, 0.1);
}

.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {
  border-color: rgba(55, 125, 255, 0.4);
}

.custom-control-input:not(:disabled):active ~ .custom-control-label::before {
  color: #fff;
  background-color: #eaf1ff;
  border-color: #eaf1ff;
}

.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {
  color: #8c98a4;
}

.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {
  background-color: #f8fafd;
}

.custom-control-label {
  position: relative;
  margin-bottom: 0;
  vertical-align: top;
}

.custom-control-label::before {
  position: absolute;
  top: 0.3rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  pointer-events: none;
  content: "";
  background-color: #fff;
  border: #d6dbeb solid 0.0625rem;
}

.custom-control-label::after {
  position: absolute;
  top: 0.3rem;
  left: -1.5rem;
  display: block;
  width: 1rem;
  height: 1rem;
  content: "";
  background: no-repeat 50% / 50% 50%;
}

.custom-checkbox .custom-control-label::before {
  border-radius: 0.25rem;
}

.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {
  border-color: #377dff;
  background-color: #377dff;
}

.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(55, 125, 255, 0.5);
}

.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {
  background-color: rgba(55, 125, 255, 0.5);
}

.custom-radio .custom-control-label::before {
  border-radius: 50%;
}

.custom-radio .custom-control-input:checked ~ .custom-control-label::after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
}

.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(55, 125, 255, 0.5);
}

.custom-switch {
  padding-left: 2.25rem;
}

.custom-switch .custom-control-label::before {
  left: -2.25rem;
  width: 1.75rem;
  pointer-events: all;
  border-radius: 0.5rem;
}

.custom-switch .custom-control-label::after {
  top: 0.425rem;
  left: -2.125rem;
  width: 0.75rem;
  height: 0.75rem;
  background-color: #d6dbeb;
  border-radius: 0.5rem;
  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .custom-switch .custom-control-label::after {
    transition: none;
  }
}

.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  background-color: #fff;
  transform: translateX(0.75rem);
}

.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {
  background-color: rgba(55, 125, 255, 0.5);
}

.custom-select {
  display: inline-block;
  width: 100%;
  height: calc(1.6em + 1.625rem);
  padding: 0.75rem 2rem 0.75rem 1rem;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #1e2022;
  vertical-align: middle;
  background: #fff url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right 0.5rem center/1rem 1rem;
  border: 0.0625rem solid #e7eaf3;
  border-radius: 0.3125rem;
  appearance: none;
}

.custom-select:focus {
  border-color: rgba(55, 125, 255, 0.4);
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 125, 255, 0.25);
}

.custom-select:focus::-ms-value {
  color: #1e2022;
  background-color: #fff;
}

.custom-select[multiple], .custom-select[size]:not([size="1"]) {
  height: auto;
  padding-right: 1rem;
  background-image: none;
}

.custom-select:disabled {
  color: #8c98a4;
  background-color: #f8fafd;
}

.custom-select::-ms-expand {
  display: none;
}

.custom-select:-moz-focusring {
  color: transparent;
  text-shadow: 0 0 0 #1e2022;
}

.custom-select-sm {
  height: calc(1.5em + 1.375rem);
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 1.125rem;
  font-size: 0.875rem;
}

.custom-select-lg {
  height: calc(1.5em + 2.375rem);
  padding-top: 1.125rem;
  padding-bottom: 1.125rem;
  padding-left: 1.125rem;
  font-size: 1.25rem;
}

.custom-file {
  position: relative;
  display: inline-block;
  width: 100%;
  height: calc(1.6em + 1.625rem);
  margin-bottom: 0;
}

.custom-file-input {
  position: relative;
  z-index: 2;
  width: 100%;
  height: calc(1.6em + 1.625rem);
  margin: 0;
  opacity: 0;
}

.custom-file-input:focus ~ .custom-file-label {
  border-color: rgba(55, 125, 255, 0.4);
  box-shadow: 0 0 10px rgba(55, 125, 255, 0.1);
}

.custom-file-input[disabled] ~ .custom-file-label,
.custom-file-input:disabled ~ .custom-file-label {
  background-color: #f8fafd;
}

.custom-file-input:lang(en) ~ .custom-file-label::after {
  content: "Browse";
}

.custom-file-input ~ .custom-file-label[data-browse]::after {
  content: attr(data-browse);
}

.custom-file-label {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1;
  height: calc(1.6em + 1.625rem);
  padding: 0.75rem 1rem;
  font-weight: 400;
  line-height: 1.6;
  color: #8c98a4;
  background-color: #fff;
  border: 0.0625rem solid #e7eaf3;
  border-radius: 0.3125rem;
}

.custom-file-label::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  display: block;
  height: calc(1.6em + 1.5rem);
  padding: 0.75rem 1rem;
  line-height: 1.6;
  color: #8c98a4;
  content: "Browse";
  background-color: transparent;
  border-left: inherit;
  border-radius: 0 0.3125rem 0.3125rem 0;
}

.custom-range {
  width: 100%;
  height: 1.4rem;
  padding: 0;
  background-color: transparent;
  appearance: none;
}

.custom-range:focus {
  outline: none;
}

.custom-range:focus::-webkit-slider-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 10px rgba(55, 125, 255, 0.1);
}

.custom-range:focus::-moz-range-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 10px rgba(55, 125, 255, 0.1);
}

.custom-range:focus::-ms-thumb {
  box-shadow: 0 0 0 1px #fff, 0 0 10px rgba(55, 125, 255, 0.1);
}

.custom-range::-moz-focus-outer {
  border: 0;
}

.custom-range::-webkit-slider-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: -0.25rem;
  background-color: #377dff;
  border: 0;
  border-radius: 1rem;
  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-webkit-slider-thumb {
    -webkit-transition: none;
    transition: none;
  }
}

.custom-range::-webkit-slider-thumb:active {
  background-color: #eaf1ff;
}

.custom-range::-webkit-slider-runnable-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e7eaf3;
  border-color: transparent;
  border-radius: 1rem;
}

.custom-range::-moz-range-thumb {
  width: 1rem;
  height: 1rem;
  background-color: #377dff;
  border: 0;
  border-radius: 1rem;
  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-moz-range-thumb {
    -moz-transition: none;
    transition: none;
  }
}

.custom-range::-moz-range-thumb:active {
  background-color: #eaf1ff;
}

.custom-range::-moz-range-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: #e7eaf3;
  border-color: transparent;
  border-radius: 1rem;
}

.custom-range::-ms-thumb {
  width: 1rem;
  height: 1rem;
  margin-top: 0;
  margin-right: 0.2rem;
  margin-left: 0.2rem;
  background-color: #377dff;
  border: 0;
  border-radius: 1rem;
  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none;
}

@media (prefers-reduced-motion: reduce) {
  .custom-range::-ms-thumb {
    -ms-transition: none;
    transition: none;
  }
}

.custom-range::-ms-thumb:active {
  background-color: #eaf1ff;
}

.custom-range::-ms-track {
  width: 100%;
  height: 0.5rem;
  color: transparent;
  cursor: pointer;
  background-color: transparent;
  border-color: transparent;
  border-width: 0.5rem;
}

.custom-range::-ms-fill-lower {
  background-color: #e7eaf3;
  border-radius: 1rem;
}

.custom-range::-ms-fill-upper {
  margin-right: 15px;
  background-color: #e7eaf3;
  border-radius: 1rem;
}

.custom-range:disabled::-webkit-slider-thumb {
  background-color: #97a4af;
}

.custom-range:disabled::-webkit-slider-runnable-track {
  cursor: default;
}

.custom-range:disabled::-moz-range-thumb {
  background-color: #97a4af;
}

.custom-range:disabled::-moz-range-track {
  cursor: default;
}

.custom-range:disabled::-ms-thumb {
  background-color: #97a4af;
}

.custom-control-label::before,
.custom-file-label,
.custom-select {
  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .custom-control-label::before,
  .custom-file-label,
  .custom-select {
    transition: none;
  }
}

.nav {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.nav-link {
  display: block;
  padding: 0.5rem 1rem;
}

.nav-link:hover, .nav-link:focus {
  text-decoration: none;
}

.nav-link.disabled {
  color: #8c98a4;
  pointer-events: none;
  cursor: default;
}

.nav-tabs {
  border-bottom: 0.0625rem solid #e7eaf3;
}

.nav-tabs .nav-item {
  margin-bottom: -0.0625rem;
}

.nav-tabs .nav-link {
  border: 0.0625rem solid transparent;
  border-top-left-radius: 0.3125rem;
  border-top-right-radius: 0.3125rem;
}

.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
  border-color: transparent;
}

.nav-tabs .nav-link.disabled {
  color: #8c98a4;
  background-color: transparent;
  border-color: transparent;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.show .nav-link {
  color: #377dff;
  background-color: #fff;
  border-color: transparent transparent #377dff;
}

.nav-tabs .dropdown-menu {
  margin-top: -0.0625rem;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.nav-pills .nav-link {
  border-radius: 0.3125rem;
}

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  color: #fff;
  background-color: #377dff;
}

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center;
}

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center;
}

.tab-content > .tab-pane {
  display: none;
}

.tab-content > .active {
  display: block;
}

.navbar {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0 0;
}

.navbar .container,
.navbar .container-fluid, .navbar .container-sm, .navbar .container-md, .navbar .container-lg, .navbar .container-xl {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}

.navbar-brand {
  display: inline-block;
  padding-top: 0.3rem;
  padding-bottom: 0.3rem;
  margin-right: 0;
  font-size: 1.25rem;
  line-height: inherit;
  white-space: nowrap;
}

.navbar-brand:hover, .navbar-brand:focus {
  text-decoration: none;
}

.navbar-nav {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.navbar-nav .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.navbar-nav .dropdown-menu {
  position: static;
  float: none;
}

.navbar-text {
  display: inline-block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center;
}

.navbar-toggler {
  padding: 0.75rem 0.75rem;
  font-size: 1.25rem;
  line-height: 1;
  background-color: transparent;
  border: 0.0625rem solid transparent;
  border-radius: 0.3125rem;
}

.navbar-toggler:hover, .navbar-toggler:focus {
  text-decoration: none;
}

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  content: "";
  background: no-repeat center center;
  background-size: 100% 100%;
}

@media (max-width: 575.98px) {
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-sm .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-sm > .container,
  .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-sm .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-sm .navbar-toggler {
    display: none;
  }
}

@media (max-width: 767.98px) {
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-md .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-md > .container,
  .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-md .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-md .navbar-toggler {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-lg .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-lg .navbar-toggler {
    display: none;
  }
}

@media (max-width: 1199.98px) {
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-flow: row nowrap;
    justify-content: flex-start;
  }
  .navbar-expand-xl .navbar-nav {
    flex-direction: row;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    position: absolute;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-right: 0.5rem;
    padding-left: 0.5rem;
  }
  .navbar-expand-xl > .container,
  .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {
    flex-wrap: nowrap;
  }
  .navbar-expand-xl .navbar-collapse {
    display: flex !important;
    flex-basis: auto;
  }
  .navbar-expand-xl .navbar-toggler {
    display: none;
  }
}

.navbar-expand {
  flex-flow: row nowrap;
  justify-content: flex-start;
}

.navbar-expand > .container,
.navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {
  padding-right: 0;
  padding-left: 0;
}

.navbar-expand .navbar-nav {
  flex-direction: row;
}

.navbar-expand .navbar-nav .dropdown-menu {
  position: absolute;
}

.navbar-expand .navbar-nav .nav-link {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.navbar-expand > .container,
.navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {
  flex-wrap: nowrap;
}

.navbar-expand .navbar-collapse {
  display: flex !important;
  flex-basis: auto;
}

.navbar-expand .navbar-toggler {
  display: none;
}

.navbar-light .navbar-brand {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-nav .nav-link {
  color: #677788;
}

.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {
  color: #0052ea;
}

.navbar-light .navbar-nav .nav-link.disabled {
  color: rgba(0, 0, 0, 0.3);
}

.navbar-light .navbar-nav .show > .nav-link,
.navbar-light .navbar-nav .active > .nav-link,
.navbar-light .navbar-nav .nav-link.show,
.navbar-light .navbar-nav .nav-link.active {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-toggler {
  color: #677788;
  border-color: rgba(0, 0, 0, 0.1);
}

.navbar-light .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
}

.navbar-light .navbar-text {
  color: #677788;
}

.navbar-light .navbar-text a {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {
  color: rgba(0, 0, 0, 0.9);
}

.navbar-dark .navbar-brand {
  color: #fff;
}

.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {
  color: #fff;
}

.navbar-dark .navbar-nav .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {
  color: #fff;
}

.navbar-dark .navbar-nav .nav-link.disabled {
  color: rgba(255, 255, 255, 0.25);
}

.navbar-dark .navbar-nav .show > .nav-link,
.navbar-dark .navbar-nav .active > .nav-link,
.navbar-dark .navbar-nav .nav-link.show,
.navbar-dark .navbar-nav .nav-link.active {
  color: #fff;
}

.navbar-dark .navbar-toggler {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.1);
}

.navbar-dark .navbar-toggler-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.navbar-dark .navbar-text {
  color: rgba(255, 255, 255, 0.7);
}

.navbar-dark .navbar-text a {
  color: #fff;
}

.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {
  color: #fff;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: border-box;
  border: 0.0625rem solid rgba(231, 234, 243, 0.7);
  border-radius: 0.75rem;
}

.card > hr {
  margin-right: 0;
  margin-left: 0;
}

.card > .list-group {
  border-top: inherit;
  border-bottom: inherit;
}

.card > .list-group:first-child {
  border-top-width: 0;
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}

.card > .list-group:last-child {
  border-bottom-width: 0;
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}

.card > .card-header + .list-group,
.card > .list-group + .card-footer {
  border-top: 0;
}

.card-body {
  flex: 1 1 auto;
  min-height: 1px;
  padding: 1.5rem;
}

.card-title {
  margin-bottom: 1.5rem;
}

.card-subtitle {
  margin-top: -0.75rem;
  margin-bottom: 0;
}

.card-text:last-child {
  margin-bottom: 0;
}

.card-link:hover {
  text-decoration: none;
}

.card-link + .card-link {
  margin-left: 1.5rem;
}

.card-header {
  padding: 1.5rem 1.5rem;
  margin-bottom: 0;
  background-color: #fff;
  border-bottom: 0.0625rem solid rgba(231, 234, 243, 0.7);
}

.card-header:first-child {
  border-radius: 0.75rem 0.75rem 0 0;
}

.card-footer {
  padding: 1.5rem 1.5rem;
  background-color: #fff;
  border-top: 0.0625rem solid rgba(231, 234, 243, 0.7);
}

.card-footer:last-child {
  border-radius: 0 0 0.75rem 0.75rem;
}

.card-header-tabs {
  margin-right: -0.75rem;
  margin-bottom: -1.5rem;
  margin-left: -0.75rem;
  border-bottom: 0;
}

.card-header-pills {
  margin-right: -0.75rem;
  margin-left: -0.75rem;
}

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 1.25rem;
  border-radius: 0.75rem;
}

.card-img,
.card-img-top,
.card-img-bottom {
  flex-shrink: 0;
  width: 100%;
}

.card-img,
.card-img-top {
  border-top-left-radius: 0.75rem;
  border-top-right-radius: 0.75rem;
}

.card-img,
.card-img-bottom {
  border-bottom-right-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}

.card-deck .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-deck {
    display: flex;
    flex-flow: row wrap;
    margin-right: -15px;
    margin-left: -15px;
  }
  .card-deck .card {
    flex: 1 0;
    margin-right: 15px;
    margin-bottom: 0;
    margin-left: 15px;
  }
}

.card-group > .card {
  margin-bottom: 15px;
}

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap;
  }
  .card-group > .card {
    flex: 1 0;
    margin-bottom: 0;
  }
  .card-group > .card + .card {
    margin-left: 0;
    border-left: 0;
  }
  .card-group > .card:not(:last-child) {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-top,
  .card-group > .card:not(:last-child) .card-header {
    border-top-right-radius: 0;
  }
  .card-group > .card:not(:last-child) .card-img-bottom,
  .card-group > .card:not(:last-child) .card-footer {
    border-bottom-right-radius: 0;
  }
  .card-group > .card:not(:first-child) {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-top,
  .card-group > .card:not(:first-child) .card-header {
    border-top-left-radius: 0;
  }
  .card-group > .card:not(:first-child) .card-img-bottom,
  .card-group > .card:not(:first-child) .card-footer {
    border-bottom-left-radius: 0;
  }
}

.card-columns .card {
  margin-bottom: 1.5rem;
}

@media (min-width: 576px) {
  .card-columns {
    column-count: 3;
    column-gap: 1.25rem;
    orphans: 1;
    widows: 1;
  }
  .card-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.accordion {
  overflow-anchor: none;
}

.accordion > .card {
  overflow: hidden;
}

.accordion > .card:not(:last-of-type) {
  border-bottom: 0;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.accordion > .card:not(:first-of-type) {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.accordion > .card > .card-header {
  border-radius: 0;
  margin-bottom: -0.0625rem;
}

.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  padding: 0.75rem 1rem;
  margin-bottom: 1rem;
  list-style: none;
  background-color: transparent;
  border-radius: 0.3125rem;
}

.breadcrumb-item {
  display: flex;
}

.breadcrumb-item + .breadcrumb-item {
  padding-left: 0.5rem;
}

.breadcrumb-item + .breadcrumb-item::before {
  display: inline-block;
  padding-right: 0.5rem;
  color: #8c98a4;
  content: "/";
}

.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: underline;
}

.breadcrumb-item + .breadcrumb-item:hover::before {
  text-decoration: none;
}

.breadcrumb-item.active {
  color: #1e2022;
}

.pagination {
  display: flex;
  padding-left: 0;
  list-style: none;
  border-radius: 0.3125rem;
}

.page-link {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: 0;
  line-height: 1.25;
  color: #677788;
  background-color: #fff;
  border: 0 solid #e7eaf3;
}

.page-link:hover {
  z-index: 2;
  color: #377dff;
  text-decoration: none;
  background-color: rgba(55, 125, 255, 0.1);
  border-color: rgba(55, 125, 255, 0.1);
}

.page-link:focus {
  z-index: 3;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 125, 255, 0.25);
}

.page-item:first-child .page-link {
  margin-left: 0;
  border-top-left-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
}

.page-item:last-child .page-link {
  border-top-right-radius: 0.3125rem;
  border-bottom-right-radius: 0.3125rem;
}

.page-item.active .page-link {
  z-index: 3;
  color: #fff;
  background-color: #377dff;
  border-color: #377dff;
}

.page-item.disabled .page-link {
  color: #8c98a4;
  pointer-events: none;
  cursor: auto;
  background-color: #fff;
  border-color: #e7eaf3;
}

.pagination-lg .page-link {
  padding: 0.75rem 1.5rem;
  font-size: 1.25rem;
  line-height: 1.5;
}

.pagination-lg .page-item:first-child .page-link {
  border-top-left-radius: 0.75rem;
  border-bottom-left-radius: 0.75rem;
}

.pagination-lg .page-item:last-child .page-link {
  border-top-right-radius: 0.75rem;
  border-bottom-right-radius: 0.75rem;
}

.pagination-sm .page-link {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
}

.pagination-sm .page-item:first-child .page-link {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.pagination-sm .page-item:last-child .page-link {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.badge {
  display: inline-block;
  padding: 0.275rem 0.5em;
  font-size: 75%;
  font-weight: 600;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.3125rem;
  transition: all 0.2s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .badge {
    transition: none;
  }
}

a.badge:hover, a.badge:focus {
  text-decoration: none;
}

.badge:empty {
  display: none;
}

.btn .badge {
  position: relative;
  top: -1px;
}

.badge-pill {
  padding-right: 0.6em;
  padding-left: 0.6em;
  border-radius: 10rem;
}

.badge-primary {
  color: #fff;
  background-color: #377dff;
}

a.badge-primary:hover, a.badge-primary:focus {
  color: #fff;
  background-color: #045cff;
}

a.badge-primary:focus, a.badge-primary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(55, 125, 255, 0.5);
}

.badge-secondary {
  color: #fff;
  background-color: #71869d;
}

a.badge-secondary:hover, a.badge-secondary:focus {
  color: #fff;
  background-color: #596d82;
}

a.badge-secondary:focus, a.badge-secondary.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(113, 134, 157, 0.5);
}

.badge-success {
  color: #fff;
  background-color: #00c9a7;
}

a.badge-success:hover, a.badge-success:focus {
  color: #fff;
  background-color: #00967d;
}

a.badge-success:focus, a.badge-success.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.5);
}

.badge-info {
  color: #fff;
  background-color: #09a5be;
}

a.badge-info:hover, a.badge-info:focus {
  color: #fff;
  background-color: #077b8d;
}

a.badge-info:focus, a.badge-info.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(9, 165, 190, 0.5);
}

.badge-warning {
  color: #1e2022;
  background-color: #f5ca99;
}

a.badge-warning:hover, a.badge-warning:focus {
  color: #1e2022;
  background-color: #f0b26b;
}

a.badge-warning:focus, a.badge-warning.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(245, 202, 153, 0.5);
}

.badge-danger {
  color: #fff;
  background-color: #ed4c78;
}

a.badge-danger:hover, a.badge-danger:focus {
  color: #fff;
  background-color: #e81e55;
}

a.badge-danger:focus, a.badge-danger.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.5);
}

.badge-light {
  color: #1e2022;
  background-color: #f7faff;
}

a.badge-light:hover, a.badge-light:focus {
  color: #1e2022;
  background-color: #c4daff;
}

a.badge-light:focus, a.badge-light.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(247, 250, 255, 0.5);
}

.badge-dark {
  color: #fff;
  background-color: #21325b;
}

a.badge-dark:hover, a.badge-dark:focus {
  color: #fff;
  background-color: #131d36;
}

a.badge-dark:focus, a.badge-dark.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(33, 50, 91, 0.5);
}

.badge-indigo {
  color: #fff;
  background-color: #2d1582;
}

a.badge-indigo:hover, a.badge-indigo:focus {
  color: #fff;
  background-color: #1e0e56;
}

a.badge-indigo:focus, a.badge-indigo.focus {
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(45, 21, 130, 0.5);
}

.jumbotron {
  padding: 2rem 1rem;
  margin-bottom: 2rem;
  background-color: #f8fafd;
  border-radius: 0.75rem;
}

@media (min-width: 576px) {
  .jumbotron {
    padding: 4rem 2rem;
  }
}

.jumbotron-fluid {
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.alert {
  position: relative;
  padding: 0.75rem 1.25rem;
  margin-bottom: 1rem;
  border: 0.0625rem solid transparent;
  border-radius: 0.3125rem;
}

.alert-heading {
  color: inherit;
}

.alert-link {
  font-weight: 600;
}

.alert-dismissible {
  padding-right: 3.75rem;
}

.alert-dismissible .close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 2;
  padding: 0.75rem 1.25rem;
  color: inherit;
}

.alert-primary {
  color: #1d4185;
  background-color: #d7e5ff;
  border-color: #c7dbff;
}

.alert-primary hr {
  border-top-color: #aecbff;
}

.alert-primary .alert-link {
  color: #142d5b;
}

.alert-secondary {
  color: #3b4652;
  background-color: #e3e7eb;
  border-color: #d7dde4;
}

.alert-secondary hr {
  border-top-color: #c8d0da;
}

.alert-secondary .alert-link {
  color: #262d34;
}

.alert-success {
  color: #006957;
  background-color: #ccf4ed;
  border-color: #b8f0e6;
}

.alert-success hr {
  border-top-color: #a3ecdf;
}

.alert-success .alert-link {
  color: #00362d;
}

.alert-info {
  color: #055663;
  background-color: #ceedf2;
  border-color: #bae6ed;
}

.alert-info hr {
  border-top-color: #a6dfe8;
}

.alert-info .alert-link {
  color: #032c32;
}

.alert-warning {
  color: #7f6950;
  background-color: #fdf4eb;
  border-color: #fcf0e2;
}

.alert-warning hr {
  border-top-color: #fae4cb;
}

.alert-warning .alert-link {
  color: #604f3c;
}

.alert-danger {
  color: #7b283e;
  background-color: #fbdbe4;
  border-color: #facdd9;
}

.alert-danger hr {
  border-top-color: #f8b6c7;
}

.alert-danger .alert-link {
  color: #551b2b;
}

.alert-light {
  color: #808285;
  background-color: #fdfeff;
  border-color: #fdfeff;
}

.alert-light hr {
  border-top-color: #e4f1ff;
}

.alert-light .alert-link {
  color: #67696b;
}

.alert-dark {
  color: #111a2f;
  background-color: #d3d6de;
  border-color: #c1c6d1;
}

.alert-dark hr {
  border-top-color: #b2b9c6;
}

.alert-dark .alert-link {
  color: #03050a;
}

.alert-indigo {
  color: #170b44;
  background-color: #d5d0e6;
  border-color: #c4bddc;
}

.alert-indigo hr {
  border-top-color: #b5acd3;
}

.alert-indigo .alert-link {
  color: #080418;
}

@keyframes progress-bar-stripes {
  from {
    background-position: 0.75rem 0;
  }
  to {
    background-position: 0 0;
  }
}

.progress {
  display: flex;
  height: 0.75rem;
  overflow: hidden;
  line-height: 0;
  font-size: 0.75rem;
  background-color: #e7eaf3;
  border-radius: 0.3125rem;
}

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: #fff;
  text-align: center;
  white-space: nowrap;
  background-color: #377dff;
  transition: width 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar {
    transition: none;
  }
}

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: 0.75rem 0.75rem;
}

.progress-bar-animated {
  animation: progress-bar-stripes 1s linear infinite;
}

@media (prefers-reduced-motion: reduce) {
  .progress-bar-animated {
    animation: none;
  }
}

.media {
  display: flex;
  align-items: flex-start;
}

.media-body {
  flex: 1 1;
}

.list-group {
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: 0.3125rem;
}

.list-group-item-action {
  width: 100%;
  color: #677788;
  text-align: inherit;
}

.list-group-item-action:hover, .list-group-item-action:focus {
  z-index: 1;
  color: #677788;
  text-decoration: none;
  background-color: #f7faff;
}

.list-group-item-action:active {
  color: #677788;
  background-color: #f8fafd;
}

.list-group-item {
  position: relative;
  display: block;
  padding: 0.75rem 1.25rem;
  background-color: #fff;
  border: 0.0625rem solid #e7eaf3;
}

.list-group-item:first-child {
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
}

.list-group-item:last-child {
  border-bottom-right-radius: inherit;
  border-bottom-left-radius: inherit;
}

.list-group-item.disabled, .list-group-item:disabled {
  color: #8c98a4;
  pointer-events: none;
  background-color: #fff;
}

.list-group-item.active {
  z-index: 2;
  color: #fff;
  background-color: #377dff;
  border-color: #377dff;
}

.list-group-item + .list-group-item {
  border-top-width: 0;
}

.list-group-item + .list-group-item.active {
  margin-top: -0.0625rem;
  border-top-width: 0.0625rem;
}

.list-group-horizontal {
  flex-direction: row;
}

.list-group-horizontal > .list-group-item:first-child {
  border-bottom-left-radius: 0.3125rem;
  border-top-right-radius: 0;
}

.list-group-horizontal > .list-group-item:last-child {
  border-top-right-radius: 0.3125rem;
  border-bottom-left-radius: 0;
}

.list-group-horizontal > .list-group-item.active {
  margin-top: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item {
  border-top-width: 0.0625rem;
  border-left-width: 0;
}

.list-group-horizontal > .list-group-item + .list-group-item.active {
  margin-left: -0.0625rem;
  border-left-width: 0.0625rem;
}

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row;
  }
  .list-group-horizontal-sm > .list-group-item:first-child {
    border-bottom-left-radius: 0.3125rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item:last-child {
    border-top-right-radius: 0.3125rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-sm > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item {
    border-top-width: 0.0625rem;
    border-left-width: 0;
  }
  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
    margin-left: -0.0625rem;
    border-left-width: 0.0625rem;
  }
}

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row;
  }
  .list-group-horizontal-md > .list-group-item:first-child {
    border-bottom-left-radius: 0.3125rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item:last-child {
    border-top-right-radius: 0.3125rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-md > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item {
    border-top-width: 0.0625rem;
    border-left-width: 0;
  }
  .list-group-horizontal-md > .list-group-item + .list-group-item.active {
    margin-left: -0.0625rem;
    border-left-width: 0.0625rem;
  }
}

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row;
  }
  .list-group-horizontal-lg > .list-group-item:first-child {
    border-bottom-left-radius: 0.3125rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item:last-child {
    border-top-right-radius: 0.3125rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-lg > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item {
    border-top-width: 0.0625rem;
    border-left-width: 0;
  }
  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
    margin-left: -0.0625rem;
    border-left-width: 0.0625rem;
  }
}

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row;
  }
  .list-group-horizontal-xl > .list-group-item:first-child {
    border-bottom-left-radius: 0.3125rem;
    border-top-right-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item:last-child {
    border-top-right-radius: 0.3125rem;
    border-bottom-left-radius: 0;
  }
  .list-group-horizontal-xl > .list-group-item.active {
    margin-top: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item {
    border-top-width: 0.0625rem;
    border-left-width: 0;
  }
  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
    margin-left: -0.0625rem;
    border-left-width: 0.0625rem;
  }
}

.list-group-flush {
  border-radius: 0;
}

.list-group-flush > .list-group-item {
  border-width: 0 0 0.0625rem;
}

.list-group-flush > .list-group-item:last-child {
  border-bottom-width: 0;
}

.list-group-item-primary {
  color: #1d4185;
  background-color: #c7dbff;
}

.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
  color: #1d4185;
  background-color: #aecbff;
}

.list-group-item-primary.list-group-item-action.active {
  color: #fff;
  background-color: #1d4185;
  border-color: #1d4185;
}

.list-group-item-secondary {
  color: #3b4652;
  background-color: #d7dde4;
}

.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
  color: #3b4652;
  background-color: #c8d0da;
}

.list-group-item-secondary.list-group-item-action.active {
  color: #fff;
  background-color: #3b4652;
  border-color: #3b4652;
}

.list-group-item-success {
  color: #006957;
  background-color: #b8f0e6;
}

.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
  color: #006957;
  background-color: #a3ecdf;
}

.list-group-item-success.list-group-item-action.active {
  color: #fff;
  background-color: #006957;
  border-color: #006957;
}

.list-group-item-info {
  color: #055663;
  background-color: #bae6ed;
}

.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
  color: #055663;
  background-color: #a6dfe8;
}

.list-group-item-info.list-group-item-action.active {
  color: #fff;
  background-color: #055663;
  border-color: #055663;
}

.list-group-item-warning {
  color: #7f6950;
  background-color: #fcf0e2;
}

.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
  color: #7f6950;
  background-color: #fae4cb;
}

.list-group-item-warning.list-group-item-action.active {
  color: #fff;
  background-color: #7f6950;
  border-color: #7f6950;
}

.list-group-item-danger {
  color: #7b283e;
  background-color: #facdd9;
}

.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
  color: #7b283e;
  background-color: #f8b6c7;
}

.list-group-item-danger.list-group-item-action.active {
  color: #fff;
  background-color: #7b283e;
  border-color: #7b283e;
}

.list-group-item-light {
  color: #808285;
  background-color: #fdfeff;
}

.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
  color: #808285;
  background-color: #e4f1ff;
}

.list-group-item-light.list-group-item-action.active {
  color: #fff;
  background-color: #808285;
  border-color: #808285;
}

.list-group-item-dark {
  color: #111a2f;
  background-color: #c1c6d1;
}

.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
  color: #111a2f;
  background-color: #b2b9c6;
}

.list-group-item-dark.list-group-item-action.active {
  color: #fff;
  background-color: #111a2f;
  border-color: #111a2f;
}

.list-group-item-indigo {
  color: #170b44;
  background-color: #c4bddc;
}

.list-group-item-indigo.list-group-item-action:hover, .list-group-item-indigo.list-group-item-action:focus {
  color: #170b44;
  background-color: #b5acd3;
}

.list-group-item-indigo.list-group-item-action.active {
  color: #fff;
  background-color: #170b44;
  border-color: #170b44;
}

.close {
  float: right;
  font-size: 1.25rem;
  font-weight: 600;
  line-height: 1;
  color: #1e2022;
  text-shadow: 0 1px 0 #fff;
  opacity: .5;
}

.close:hover {
  color: #1e2022;
  text-decoration: none;
}

.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {
  opacity: .75;
}

button.close {
  padding: 0;
  background-color: transparent;
  border: 0;
}

a.close.disabled {
  pointer-events: none;
}

.toast {
  flex-basis: 350px;
  max-width: 350px;
  font-size: 0.875rem;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);
  opacity: 0;
  border-radius: 0.25rem;
}

.toast:not(:last-child) {
  margin-bottom: 0.75rem;
}

.toast.showing {
  opacity: 1;
}

.toast.show {
  display: block;
  opacity: 1;
}

.toast.hide {
  display: none;
}

.toast-header {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.75rem;
  color: #8c98a4;
  background-color: rgba(255, 255, 255, 0.85);
  background-clip: padding-box;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
  border-top-left-radius: calc(0.25rem - 1px);
  border-top-right-radius: calc(0.25rem - 1px);
}

.toast-body {
  padding: 0.75rem;
}

.modal-open {
  overflow: hidden;
}

.modal-open .modal {
  overflow-x: hidden;
  overflow-y: auto;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1005;
  display: none;
  width: 100%;
  height: 100%;
  overflow: hidden;
  outline: 0;
}

.modal-dialog {
  position: relative;
  width: auto;
  margin: 0.5rem;
  pointer-events: none;
}

.modal.fade .modal-dialog {
  transition: transform 0.3s ease-out;
  transform: translate(0, -50px);
}

@media (prefers-reduced-motion: reduce) {
  .modal.fade .modal-dialog {
    transition: none;
  }
}

.modal.show .modal-dialog {
  transform: none;
}

.modal.modal-static .modal-dialog {
  transform: scale(1.02);
}

.modal-dialog-scrollable {
  display: flex;
  max-height: calc(100% - 1rem);
}

.modal-dialog-scrollable .modal-content {
  max-height: calc(100vh - 1rem);
  overflow: hidden;
}

.modal-dialog-scrollable .modal-header,
.modal-dialog-scrollable .modal-footer {
  flex-shrink: 0;
}

.modal-dialog-scrollable .modal-body {
  overflow-y: auto;
}

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - 1rem);
}

.modal-dialog-centered::before {
  display: block;
  height: calc(100vh - 1rem);
  height: min-content;
  content: "";
}

.modal-dialog-centered.modal-dialog-scrollable {
  flex-direction: column;
  justify-content: center;
  height: 100%;
}

.modal-dialog-centered.modal-dialog-scrollable .modal-content {
  max-height: none;
}

.modal-dialog-centered.modal-dialog-scrollable::before {
  content: none;
}

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 0.0625rem solid transparent;
  border-radius: 0.75rem;
  outline: 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1004;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 50, 91, 0.125);
}

.modal-backdrop.fade {
  opacity: 0;
}

.modal-backdrop.show {
  opacity: 1;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  border-bottom: 0.0625rem solid #e7eaf3;
  border-top-left-radius: 0.6875rem;
  border-top-right-radius: 0.6875rem;
}

.modal-header .close {
  padding: 1rem 1.5rem;
  margin: -1rem -1.5rem -1rem auto;
}

.modal-title {
  margin-bottom: 0;
  line-height: 1.6;
}

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: 1.5rem;
}

.modal-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: 1.25rem;
  border-top: 0.0625rem solid #e7eaf3;
  border-bottom-right-radius: 0.6875rem;
  border-bottom-left-radius: 0.6875rem;
}

.modal-footer > * {
  margin: 0.25rem;
}

.modal-scrollbar-measure {
  position: absolute;
  top: -9999px;
  width: 50px;
  height: 50px;
  overflow: scroll;
}

@media (min-width: 576px) {
  .modal-dialog {
    max-width: 550px;
    margin: 1.75rem auto;
  }
  .modal-dialog-scrollable {
    max-height: calc(100% - 3.5rem);
  }
  .modal-dialog-scrollable .modal-content {
    max-height: calc(100vh - 3.5rem);
  }
  .modal-dialog-centered {
    min-height: calc(100% - 3.5rem);
  }
  .modal-dialog-centered::before {
    height: calc(100vh - 3.5rem);
    height: min-content;
  }
  .modal-sm {
    max-width: 400px;
  }
}

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    max-width: 800px;
  }
}

@media (min-width: 1200px) {
  .modal-xl {
    max-width: 1140px;
  }
}

.tooltip {
  position: absolute;
  z-index: 9999;
  display: block;
  margin: 0;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.6;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  opacity: 0;
}

.tooltip.show {
  opacity: 1;
}

.tooltip .arrow {
  position: absolute;
  display: block;
  width: 0.8rem;
  height: 0.4rem;
}

.tooltip .arrow::before {
  position: absolute;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-tooltip-top, .bs-tooltip-auto[x-placement^="top"] {
  padding: 0.4rem 0;
}

.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^="top"] .arrow {
  bottom: 0;
}

.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^="top"] .arrow::before {
  top: 0;
  border-width: 0.4rem 0.4rem 0;
  border-top-color: #21325b;
}

.bs-tooltip-right, .bs-tooltip-auto[x-placement^="right"] {
  padding: 0 0.4rem;
}

.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^="right"] .arrow {
  left: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^="right"] .arrow::before {
  right: 0;
  border-width: 0.4rem 0.4rem 0.4rem 0;
  border-right-color: #21325b;
}

.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^="bottom"] {
  padding: 0.4rem 0;
}

.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^="bottom"] .arrow {
  top: 0;
}

.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^="bottom"] .arrow::before {
  bottom: 0;
  border-width: 0 0.4rem 0.4rem;
  border-bottom-color: #21325b;
}

.bs-tooltip-left, .bs-tooltip-auto[x-placement^="left"] {
  padding: 0 0.4rem;
}

.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^="left"] .arrow {
  right: 0;
  width: 0.4rem;
  height: 0.8rem;
}

.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^="left"] .arrow::before {
  left: 0;
  border-width: 0.4rem 0 0.4rem 0.4rem;
  border-left-color: #21325b;
}

.tooltip-inner {
  max-width: 200px;
  padding: 0.25rem 0.5rem;
  color: #fff;
  text-align: center;
  background-color: #21325b;
  border-radius: 0.3125rem;
}

.popover {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1060;
  display: block;
  max-width: 276px;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
  font-weight: 400;
  line-height: 1.6;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  word-spacing: normal;
  white-space: normal;
  line-break: auto;
  font-size: 0.875rem;
  word-wrap: break-word;
  background-color: #fff;
  background-clip: padding-box;
  border: 0.0625rem solid transparent;
  border-radius: 0.75rem;
}

.popover .arrow {
  position: absolute;
  display: block;
  width: 1rem;
  height: 0.5rem;
  margin: 0 0.75rem;
}

.popover .arrow::before, .popover .arrow::after {
  position: absolute;
  display: block;
  content: "";
  border-color: transparent;
  border-style: solid;
}

.bs-popover-top, .bs-popover-auto[x-placement^="top"] {
  margin-bottom: 0.5rem;
}

.bs-popover-top > .arrow, .bs-popover-auto[x-placement^="top"] > .arrow {
  bottom: -0.5625rem;
}

.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^="top"] > .arrow::before {
  bottom: 0;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: rgba(0, 0, 0, 0.05);
}

.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^="top"] > .arrow::after {
  bottom: 0.0625rem;
  border-width: 0.5rem 0.5rem 0;
  border-top-color: #fff;
}

.bs-popover-right, .bs-popover-auto[x-placement^="right"] {
  margin-left: 0.5rem;
}

.bs-popover-right > .arrow, .bs-popover-auto[x-placement^="right"] > .arrow {
  left: -0.5625rem;
  width: 0.5rem;
  height: 1rem;
  margin: 0.75rem 0;
}

.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^="right"] > .arrow::before {
  left: 0;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: rgba(0, 0, 0, 0.05);
}

.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^="right"] > .arrow::after {
  left: 0.0625rem;
  border-width: 0.5rem 0.5rem 0.5rem 0;
  border-right-color: #fff;
}

.bs-popover-bottom, .bs-popover-auto[x-placement^="bottom"] {
  margin-top: 0.5rem;
}

.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^="bottom"] > .arrow {
  top: -0.5625rem;
}

.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^="bottom"] > .arrow::before {
  top: 0;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: rgba(0, 0, 0, 0.05);
}

.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^="bottom"] > .arrow::after {
  top: 0.0625rem;
  border-width: 0 0.5rem 0.5rem 0.5rem;
  border-bottom-color: #fff;
}

.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 1rem;
  margin-left: -0.5rem;
  content: "";
  border-bottom: 0.0625rem solid #f8fafd;
}

.bs-popover-left, .bs-popover-auto[x-placement^="left"] {
  margin-right: 0.5rem;
}

.bs-popover-left > .arrow, .bs-popover-auto[x-placement^="left"] > .arrow {
  right: -0.5625rem;
  width: 0.5rem;
  height: 1rem;
  margin: 0.75rem 0;
}

.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^="left"] > .arrow::before {
  right: 0;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: rgba(0, 0, 0, 0.05);
}

.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^="left"] > .arrow::after {
  right: 0.0625rem;
  border-width: 0.5rem 0 0.5rem 0.5rem;
  border-left-color: #fff;
}

.popover-header {
  padding: 0.75rem 1rem;
  margin-bottom: 0;
  font-size: 1rem;
  color: #1e2022;
  background-color: #f8fafd;
  border-bottom: 0.0625rem solid #e4ecf7;
  border-top-left-radius: 0.6875rem;
  border-top-right-radius: 0.6875rem;
}

.popover-header:empty {
  display: none;
}

.popover-body {
  padding: 1.125rem 1rem;
  color: #677788;
}

.carousel {
  position: relative;
}

.carousel.pointer-event {
  touch-action: pan-y;
}

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.carousel-inner::after {
  display: block;
  clear: both;
  content: "";
}

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-item {
    transition: none;
  }
}

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block;
}

.carousel-item-next:not(.carousel-item-left),
.active.carousel-item-right {
  transform: translateX(100%);
}

.carousel-item-prev:not(.carousel-item-right),
.active.carousel-item-left {
  transform: translateX(-100%);
}

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none;
}

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-left,
.carousel-fade .carousel-item-prev.carousel-item-right {
  z-index: 1;
  opacity: 1;
}

.carousel-fade .active.carousel-item-left,
.carousel-fade .active.carousel-item-right {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-fade .active.carousel-item-left,
  .carousel-fade .active.carousel-item-right {
    transition: none;
  }
}

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  color: #fff;
  text-align: center;
  opacity: 0.5;
  transition: opacity 0.15s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-control-prev,
  .carousel-control-next {
    transition: none;
  }
}

.carousel-control-prev:hover, .carousel-control-prev:focus,
.carousel-control-next:hover,
.carousel-control-next:focus {
  color: #fff;
  text-decoration: none;
  outline: 0;
  opacity: 0.9;
}

.carousel-control-prev {
  left: 0;
}

.carousel-control-next {
  right: 0;
}

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  background: no-repeat 50% / 100% 100%;
}

.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
}

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
}

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 15;
  display: flex;
  justify-content: center;
  padding-left: 0;
  margin-right: 15%;
  margin-left: 15%;
  list-style: none;
}

.carousel-indicators li {
  box-sizing: content-box;
  flex: 0 1 auto;
  width: 30px;
  height: 3px;
  margin-right: 3px;
  margin-left: 3px;
  text-indent: -999px;
  cursor: pointer;
  background-color: #fff;
  background-clip: padding-box;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;
  opacity: .5;
  transition: opacity 0.6s ease;
}

@media (prefers-reduced-motion: reduce) {
  .carousel-indicators li {
    transition: none;
  }
}

.carousel-indicators .active {
  opacity: 1;
}

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 20px;
  left: 15%;
  z-index: 10;
  padding-top: 20px;
  padding-bottom: 20px;
  color: #fff;
  text-align: center;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.spinner-border {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border .75s linear infinite;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
  border-width: 0.2em;
}

@keyframes spinner-grow {
  0% {
    transform: scale(0);
  }
  50% {
    opacity: 1;
    transform: none;
  }
}

.spinner-grow {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  vertical-align: text-bottom;
  background-color: currentColor;
  border-radius: 50%;
  opacity: 0;
  animation: spinner-grow .75s linear infinite;
}

.spinner-grow-sm {
  width: 1rem;
  height: 1rem;
}

.align-baseline {
  vertical-align: baseline !important;
}

.align-top {
  vertical-align: top !important;
}

.align-middle {
  vertical-align: middle !important;
}

.align-bottom {
  vertical-align: bottom !important;
}

.align-text-bottom {
  vertical-align: text-bottom !important;
}

.align-text-top {
  vertical-align: text-top !important;
}

.bg-primary {
  background-color: #377dff !important;
}

a.bg-primary:hover, a.bg-primary:focus,
button.bg-primary:hover,
button.bg-primary:focus {
  background-color: #045cff !important;
}

.bg-secondary {
  background-color: #71869d !important;
}

a.bg-secondary:hover, a.bg-secondary:focus,
button.bg-secondary:hover,
button.bg-secondary:focus {
  background-color: #596d82 !important;
}

.bg-success {
  background-color: #00c9a7 !important;
}

a.bg-success:hover, a.bg-success:focus,
button.bg-success:hover,
button.bg-success:focus {
  background-color: #00967d !important;
}

.bg-info {
  background-color: #09a5be !important;
}

a.bg-info:hover, a.bg-info:focus,
button.bg-info:hover,
button.bg-info:focus {
  background-color: #077b8d !important;
}

.bg-warning {
  background-color: #f5ca99 !important;
}

a.bg-warning:hover, a.bg-warning:focus,
button.bg-warning:hover,
button.bg-warning:focus {
  background-color: #f0b26b !important;
}

.bg-danger {
  background-color: #ed4c78 !important;
}

a.bg-danger:hover, a.bg-danger:focus,
button.bg-danger:hover,
button.bg-danger:focus {
  background-color: #e81e55 !important;
}

.bg-light {
  background-color: #f7faff !important;
}

a.bg-light:hover, a.bg-light:focus,
button.bg-light:hover,
button.bg-light:focus {
  background-color: #c4daff !important;
}

.bg-dark {
  background-color: #21325b !important;
}

a.bg-dark:hover, a.bg-dark:focus,
button.bg-dark:hover,
button.bg-dark:focus {
  background-color: #131d36 !important;
}

.bg-indigo {
  background-color: #2d1582 !important;
}

a.bg-indigo:hover, a.bg-indigo:focus,
button.bg-indigo:hover,
button.bg-indigo:focus {
  background-color: #1e0e56 !important;
}

.bg-white {
  background-color: #fff !important;
}

.bg-transparent {
  background-color: transparent !important;
}

.border {
  border: 0.0625rem solid #e7eaf3 !important;
}

.border-top {
  border-top: 0.0625rem solid #e7eaf3 !important;
}

.border-right {
  border-right: 0.0625rem solid #e7eaf3 !important;
}

.border-bottom {
  border-bottom: 0.0625rem solid #e7eaf3 !important;
}

.border-left {
  border-left: 0.0625rem solid #e7eaf3 !important;
}

.border-0 {
  border: 0 !important;
}

.border-top-0 {
  border-top: 0 !important;
}

.border-right-0 {
  border-right: 0 !important;
}

.border-bottom-0 {
  border-bottom: 0 !important;
}

.border-left-0 {
  border-left: 0 !important;
}

.border-primary {
  border-color: #377dff !important;
}

.border-secondary {
  border-color: #71869d !important;
}

.border-success {
  border-color: #00c9a7 !important;
}

.border-info {
  border-color: #09a5be !important;
}

.border-warning {
  border-color: #f5ca99 !important;
}

.border-danger {
  border-color: #ed4c78 !important;
}

.border-light {
  border-color: #f7faff !important;
}

.border-dark {
  border-color: #21325b !important;
}

.border-indigo {
  border-color: #2d1582 !important;
}

.border-white {
  border-color: #fff !important;
}

.rounded-sm {
  border-radius: 0.25rem !important;
}

.rounded {
  border-radius: 0.3125rem !important;
}

.rounded-top {
  border-top-left-radius: 0.3125rem !important;
  border-top-right-radius: 0.3125rem !important;
}

.rounded-right {
  border-top-right-radius: 0.3125rem !important;
  border-bottom-right-radius: 0.3125rem !important;
}

.rounded-bottom {
  border-bottom-right-radius: 0.3125rem !important;
  border-bottom-left-radius: 0.3125rem !important;
}

.rounded-left {
  border-top-left-radius: 0.3125rem !important;
  border-bottom-left-radius: 0.3125rem !important;
}

.rounded-lg {
  border-radius: 0.75rem !important;
}

.rounded-circle {
  border-radius: 50% !important;
}

.rounded-pill {
  border-radius: 50rem !important;
}

.rounded-0 {
  border-radius: 0 !important;
}

.clearfix::after {
  display: block;
  clear: both;
  content: "";
}

.d-none {
  display: none !important;
}

.d-inline {
  display: inline !important;
}

.d-inline-block {
  display: inline-block !important;
}

.d-block {
  display: block !important;
}

.d-table {
  display: table !important;
}

.d-table-row {
  display: table-row !important;
}

.d-table-cell {
  display: table-cell !important;
}

.d-flex {
  display: flex !important;
}

.d-inline-flex {
  display: inline-flex !important;
}

@media (min-width: 576px) {
  .d-sm-none {
    display: none !important;
  }
  .d-sm-inline {
    display: inline !important;
  }
  .d-sm-inline-block {
    display: inline-block !important;
  }
  .d-sm-block {
    display: block !important;
  }
  .d-sm-table {
    display: table !important;
  }
  .d-sm-table-row {
    display: table-row !important;
  }
  .d-sm-table-cell {
    display: table-cell !important;
  }
  .d-sm-flex {
    display: flex !important;
  }
  .d-sm-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 768px) {
  .d-md-none {
    display: none !important;
  }
  .d-md-inline {
    display: inline !important;
  }
  .d-md-inline-block {
    display: inline-block !important;
  }
  .d-md-block {
    display: block !important;
  }
  .d-md-table {
    display: table !important;
  }
  .d-md-table-row {
    display: table-row !important;
  }
  .d-md-table-cell {
    display: table-cell !important;
  }
  .d-md-flex {
    display: flex !important;
  }
  .d-md-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 992px) {
  .d-lg-none {
    display: none !important;
  }
  .d-lg-inline {
    display: inline !important;
  }
  .d-lg-inline-block {
    display: inline-block !important;
  }
  .d-lg-block {
    display: block !important;
  }
  .d-lg-table {
    display: table !important;
  }
  .d-lg-table-row {
    display: table-row !important;
  }
  .d-lg-table-cell {
    display: table-cell !important;
  }
  .d-lg-flex {
    display: flex !important;
  }
  .d-lg-inline-flex {
    display: inline-flex !important;
  }
}

@media (min-width: 1200px) {
  .d-xl-none {
    display: none !important;
  }
  .d-xl-inline {
    display: inline !important;
  }
  .d-xl-inline-block {
    display: inline-block !important;
  }
  .d-xl-block {
    display: block !important;
  }
  .d-xl-table {
    display: table !important;
  }
  .d-xl-table-row {
    display: table-row !important;
  }
  .d-xl-table-cell {
    display: table-cell !important;
  }
  .d-xl-flex {
    display: flex !important;
  }
  .d-xl-inline-flex {
    display: inline-flex !important;
  }
}

@media print {
  .d-print-none {
    display: none !important;
  }
  .d-print-inline {
    display: inline !important;
  }
  .d-print-inline-block {
    display: inline-block !important;
  }
  .d-print-block {
    display: block !important;
  }
  .d-print-table {
    display: table !important;
  }
  .d-print-table-row {
    display: table-row !important;
  }
  .d-print-table-cell {
    display: table-cell !important;
  }
  .d-print-flex {
    display: flex !important;
  }
  .d-print-inline-flex {
    display: inline-flex !important;
  }
}

.embed-responsive {
  position: relative;
  display: block;
  width: 100%;
  padding: 0;
  overflow: hidden;
}

.embed-responsive::before {
  display: block;
  content: "";
}

.embed-responsive .embed-responsive-item,
.embed-responsive iframe,
.embed-responsive embed,
.embed-responsive object,
.embed-responsive video {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}

.embed-responsive-21by9::before {
  padding-top: 42.85714%;
}

.embed-responsive-16by9::before {
  padding-top: 56.25%;
}

.embed-responsive-4by3::before {
  padding-top: 75%;
}

.embed-responsive-1by1::before {
  padding-top: 100%;
}

.flex-row {
  flex-direction: row !important;
}

.flex-column {
  flex-direction: column !important;
}

.flex-row-reverse {
  flex-direction: row-reverse !important;
}

.flex-column-reverse {
  flex-direction: column-reverse !important;
}

.flex-wrap {
  flex-wrap: wrap !important;
}

.flex-nowrap {
  flex-wrap: nowrap !important;
}

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important;
}

.flex-fill {
  flex: 1 1 auto !important;
}

.flex-grow-0 {
  flex-grow: 0 !important;
}

.flex-grow-1 {
  flex-grow: 1 !important;
}

.flex-shrink-0 {
  flex-shrink: 0 !important;
}

.flex-shrink-1 {
  flex-shrink: 1 !important;
}

.justify-content-start {
  justify-content: flex-start !important;
}

.justify-content-end {
  justify-content: flex-end !important;
}

.justify-content-center {
  justify-content: center !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.justify-content-around {
  justify-content: space-around !important;
}

.align-items-start {
  align-items: flex-start !important;
}

.align-items-end {
  align-items: flex-end !important;
}

.align-items-center {
  align-items: center !important;
}

.align-items-baseline {
  align-items: baseline !important;
}

.align-items-stretch {
  align-items: stretch !important;
}

.align-content-start {
  align-content: flex-start !important;
}

.align-content-end {
  align-content: flex-end !important;
}

.align-content-center {
  align-content: center !important;
}

.align-content-between {
  align-content: space-between !important;
}

.align-content-around {
  align-content: space-around !important;
}

.align-content-stretch {
  align-content: stretch !important;
}

.align-self-auto {
  align-self: auto !important;
}

.align-self-start {
  align-self: flex-start !important;
}

.align-self-end {
  align-self: flex-end !important;
}

.align-self-center {
  align-self: center !important;
}

.align-self-baseline {
  align-self: baseline !important;
}

.align-self-stretch {
  align-self: stretch !important;
}

@media (min-width: 576px) {
  .flex-sm-row {
    flex-direction: row !important;
  }
  .flex-sm-column {
    flex-direction: column !important;
  }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-sm-wrap {
    flex-wrap: wrap !important;
  }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-sm-fill {
    flex: 1 1 auto !important;
  }
  .flex-sm-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-sm-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-sm-start {
    justify-content: flex-start !important;
  }
  .justify-content-sm-end {
    justify-content: flex-end !important;
  }
  .justify-content-sm-center {
    justify-content: center !important;
  }
  .justify-content-sm-between {
    justify-content: space-between !important;
  }
  .justify-content-sm-around {
    justify-content: space-around !important;
  }
  .align-items-sm-start {
    align-items: flex-start !important;
  }
  .align-items-sm-end {
    align-items: flex-end !important;
  }
  .align-items-sm-center {
    align-items: center !important;
  }
  .align-items-sm-baseline {
    align-items: baseline !important;
  }
  .align-items-sm-stretch {
    align-items: stretch !important;
  }
  .align-content-sm-start {
    align-content: flex-start !important;
  }
  .align-content-sm-end {
    align-content: flex-end !important;
  }
  .align-content-sm-center {
    align-content: center !important;
  }
  .align-content-sm-between {
    align-content: space-between !important;
  }
  .align-content-sm-around {
    align-content: space-around !important;
  }
  .align-content-sm-stretch {
    align-content: stretch !important;
  }
  .align-self-sm-auto {
    align-self: auto !important;
  }
  .align-self-sm-start {
    align-self: flex-start !important;
  }
  .align-self-sm-end {
    align-self: flex-end !important;
  }
  .align-self-sm-center {
    align-self: center !important;
  }
  .align-self-sm-baseline {
    align-self: baseline !important;
  }
  .align-self-sm-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 768px) {
  .flex-md-row {
    flex-direction: row !important;
  }
  .flex-md-column {
    flex-direction: column !important;
  }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-md-wrap {
    flex-wrap: wrap !important;
  }
  .flex-md-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-md-fill {
    flex: 1 1 auto !important;
  }
  .flex-md-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-md-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-md-start {
    justify-content: flex-start !important;
  }
  .justify-content-md-end {
    justify-content: flex-end !important;
  }
  .justify-content-md-center {
    justify-content: center !important;
  }
  .justify-content-md-between {
    justify-content: space-between !important;
  }
  .justify-content-md-around {
    justify-content: space-around !important;
  }
  .align-items-md-start {
    align-items: flex-start !important;
  }
  .align-items-md-end {
    align-items: flex-end !important;
  }
  .align-items-md-center {
    align-items: center !important;
  }
  .align-items-md-baseline {
    align-items: baseline !important;
  }
  .align-items-md-stretch {
    align-items: stretch !important;
  }
  .align-content-md-start {
    align-content: flex-start !important;
  }
  .align-content-md-end {
    align-content: flex-end !important;
  }
  .align-content-md-center {
    align-content: center !important;
  }
  .align-content-md-between {
    align-content: space-between !important;
  }
  .align-content-md-around {
    align-content: space-around !important;
  }
  .align-content-md-stretch {
    align-content: stretch !important;
  }
  .align-self-md-auto {
    align-self: auto !important;
  }
  .align-self-md-start {
    align-self: flex-start !important;
  }
  .align-self-md-end {
    align-self: flex-end !important;
  }
  .align-self-md-center {
    align-self: center !important;
  }
  .align-self-md-baseline {
    align-self: baseline !important;
  }
  .align-self-md-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 992px) {
  .flex-lg-row {
    flex-direction: row !important;
  }
  .flex-lg-column {
    flex-direction: column !important;
  }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-lg-wrap {
    flex-wrap: wrap !important;
  }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-lg-fill {
    flex: 1 1 auto !important;
  }
  .flex-lg-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-lg-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-lg-start {
    justify-content: flex-start !important;
  }
  .justify-content-lg-end {
    justify-content: flex-end !important;
  }
  .justify-content-lg-center {
    justify-content: center !important;
  }
  .justify-content-lg-between {
    justify-content: space-between !important;
  }
  .justify-content-lg-around {
    justify-content: space-around !important;
  }
  .align-items-lg-start {
    align-items: flex-start !important;
  }
  .align-items-lg-end {
    align-items: flex-end !important;
  }
  .align-items-lg-center {
    align-items: center !important;
  }
  .align-items-lg-baseline {
    align-items: baseline !important;
  }
  .align-items-lg-stretch {
    align-items: stretch !important;
  }
  .align-content-lg-start {
    align-content: flex-start !important;
  }
  .align-content-lg-end {
    align-content: flex-end !important;
  }
  .align-content-lg-center {
    align-content: center !important;
  }
  .align-content-lg-between {
    align-content: space-between !important;
  }
  .align-content-lg-around {
    align-content: space-around !important;
  }
  .align-content-lg-stretch {
    align-content: stretch !important;
  }
  .align-self-lg-auto {
    align-self: auto !important;
  }
  .align-self-lg-start {
    align-self: flex-start !important;
  }
  .align-self-lg-end {
    align-self: flex-end !important;
  }
  .align-self-lg-center {
    align-self: center !important;
  }
  .align-self-lg-baseline {
    align-self: baseline !important;
  }
  .align-self-lg-stretch {
    align-self: stretch !important;
  }
}

@media (min-width: 1200px) {
  .flex-xl-row {
    flex-direction: row !important;
  }
  .flex-xl-column {
    flex-direction: column !important;
  }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important;
  }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important;
  }
  .flex-xl-wrap {
    flex-wrap: wrap !important;
  }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important;
  }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important;
  }
  .flex-xl-fill {
    flex: 1 1 auto !important;
  }
  .flex-xl-grow-0 {
    flex-grow: 0 !important;
  }
  .flex-xl-grow-1 {
    flex-grow: 1 !important;
  }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important;
  }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important;
  }
  .justify-content-xl-start {
    justify-content: flex-start !important;
  }
  .justify-content-xl-end {
    justify-content: flex-end !important;
  }
  .justify-content-xl-center {
    justify-content: center !important;
  }
  .justify-content-xl-between {
    justify-content: space-between !important;
  }
  .justify-content-xl-around {
    justify-content: space-around !important;
  }
  .align-items-xl-start {
    align-items: flex-start !important;
  }
  .align-items-xl-end {
    align-items: flex-end !important;
  }
  .align-items-xl-center {
    align-items: center !important;
  }
  .align-items-xl-baseline {
    align-items: baseline !important;
  }
  .align-items-xl-stretch {
    align-items: stretch !important;
  }
  .align-content-xl-start {
    align-content: flex-start !important;
  }
  .align-content-xl-end {
    align-content: flex-end !important;
  }
  .align-content-xl-center {
    align-content: center !important;
  }
  .align-content-xl-between {
    align-content: space-between !important;
  }
  .align-content-xl-around {
    align-content: space-around !important;
  }
  .align-content-xl-stretch {
    align-content: stretch !important;
  }
  .align-self-xl-auto {
    align-self: auto !important;
  }
  .align-self-xl-start {
    align-self: flex-start !important;
  }
  .align-self-xl-end {
    align-self: flex-end !important;
  }
  .align-self-xl-center {
    align-self: center !important;
  }
  .align-self-xl-baseline {
    align-self: baseline !important;
  }
  .align-self-xl-stretch {
    align-self: stretch !important;
  }
}

.float-left {
  float: left !important;
}

.float-right {
  float: right !important;
}

.float-none {
  float: none !important;
}

@media (min-width: 576px) {
  .float-sm-left {
    float: left !important;
  }
  .float-sm-right {
    float: right !important;
  }
  .float-sm-none {
    float: none !important;
  }
}

@media (min-width: 768px) {
  .float-md-left {
    float: left !important;
  }
  .float-md-right {
    float: right !important;
  }
  .float-md-none {
    float: none !important;
  }
}

@media (min-width: 992px) {
  .float-lg-left {
    float: left !important;
  }
  .float-lg-right {
    float: right !important;
  }
  .float-lg-none {
    float: none !important;
  }
}

@media (min-width: 1200px) {
  .float-xl-left {
    float: left !important;
  }
  .float-xl-right {
    float: right !important;
  }
  .float-xl-none {
    float: none !important;
  }
}

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important;
}

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important;
}

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important;
}

.overflow-auto {
  overflow: auto !important;
}

.overflow-hidden {
  overflow: hidden !important;
}

.position-static {
  position: static !important;
}

.position-relative {
  position: relative !important;
}

.position-absolute {
  position: absolute !important;
}

.position-fixed {
  position: fixed !important;
}

.position-sticky {
  position: sticky !important;
}

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030;
}

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030;
}

@supports (position: sticky) {
  .sticky-top {
    position: sticky;
    top: 0;
    z-index: 1020;
  }
}

.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.sr-only-focusable:active, .sr-only-focusable:focus {
  position: static;
  width: auto;
  height: auto;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.shadow-sm {
  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1) !important;
}

.shadow {
  box-shadow: 0px 0.375rem 1.5rem 0px rgba(140, 152, 164, 0.125) !important;
}

.shadow-lg {
  box-shadow: 0px 10px 40px 10px rgba(140, 152, 164, 0.175) !important;
}

.shadow-none {
  box-shadow: none !important;
}

.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.w-15 {
  width: 15% !important;
}

.w-20 {
  width: 20% !important;
}

.w-30 {
  width: 30% !important;
}

.w-35 {
  width: 35% !important;
}

.w-40 {
  width: 40% !important;
}

.w-60 {
  width: 60% !important;
}

.w-65 {
  width: 65% !important;
}

.w-80 {
  width: 80% !important;
}

.w-85 {
  width: 85% !important;
}

.w-90 {
  width: 90% !important;
}

.h-25 {
  height: 25% !important;
}

.h-50 {
  height: 50% !important;
}

.h-75 {
  height: 75% !important;
}

.h-100 {
  height: 100% !important;
}

.h-auto {
  height: auto !important;
}

.h-15 {
  height: 15% !important;
}

.h-20 {
  height: 20% !important;
}

.h-30 {
  height: 30% !important;
}

.h-35 {
  height: 35% !important;
}

.h-40 {
  height: 40% !important;
}

.h-60 {
  height: 60% !important;
}

.h-65 {
  height: 65% !important;
}

.h-80 {
  height: 80% !important;
}

.h-85 {
  height: 85% !important;
}

.h-90 {
  height: 90% !important;
}

.mw-100 {
  max-width: 100% !important;
}

.mh-100 {
  max-height: 100% !important;
}

.min-vw-100 {
  min-width: 100vw !important;
}

.min-vh-100 {
  min-height: 100vh !important;
}

.vw-100 {
  width: 100vw !important;
}

.vh-100 {
  height: 100vh !important;
}

.m-0 {
  margin: 0 !important;
}

.mt-0,
.my-0 {
  margin-top: 0 !important;
}

.mr-0,
.mx-0 {
  margin-right: 0 !important;
}

.mb-0,
.my-0 {
  margin-bottom: 0 !important;
}

.ml-0,
.mx-0 {
  margin-left: 0 !important;
}

.m-1 {
  margin: 0.25rem !important;
}

.mt-1,
.my-1 {
  margin-top: 0.25rem !important;
}

.mr-1,
.mx-1 {
  margin-right: 0.25rem !important;
}

.mb-1,
.my-1 {
  margin-bottom: 0.25rem !important;
}

.ml-1,
.mx-1 {
  margin-left: 0.25rem !important;
}

.m-2 {
  margin: 0.5rem !important;
}

.mt-2,
.my-2 {
  margin-top: 0.5rem !important;
}

.mr-2,
.mx-2 {
  margin-right: 0.5rem !important;
}

.mb-2,
.my-2 {
  margin-bottom: 0.5rem !important;
}

.ml-2,
.mx-2 {
  margin-left: 0.5rem !important;
}

.m-3 {
  margin: 1rem !important;
}

.mt-3,
.my-3 {
  margin-top: 1rem !important;
}

.mr-3,
.mx-3 {
  margin-right: 1rem !important;
}

.mb-3,
.my-3 {
  margin-bottom: 1rem !important;
}

.ml-3,
.mx-3 {
  margin-left: 1rem !important;
}

.m-4 {
  margin: 1.5rem !important;
}

.mt-4,
.my-4 {
  margin-top: 1.5rem !important;
}

.mr-4,
.mx-4 {
  margin-right: 1.5rem !important;
}

.mb-4,
.my-4 {
  margin-bottom: 1.5rem !important;
}

.ml-4,
.mx-4 {
  margin-left: 1.5rem !important;
}

.m-5 {
  margin: 2rem !important;
}

.mt-5,
.my-5 {
  margin-top: 2rem !important;
}

.mr-5,
.mx-5 {
  margin-right: 2rem !important;
}

.mb-5,
.my-5 {
  margin-bottom: 2rem !important;
}

.ml-5,
.mx-5 {
  margin-left: 2rem !important;
}

.m-6 {
  margin: 2.5rem !important;
}

.mt-6,
.my-6 {
  margin-top: 2.5rem !important;
}

.mr-6,
.mx-6 {
  margin-right: 2.5rem !important;
}

.mb-6,
.my-6 {
  margin-bottom: 2.5rem !important;
}

.ml-6,
.mx-6 {
  margin-left: 2.5rem !important;
}

.m-7 {
  margin: 3rem !important;
}

.mt-7,
.my-7 {
  margin-top: 3rem !important;
}

.mr-7,
.mx-7 {
  margin-right: 3rem !important;
}

.mb-7,
.my-7 {
  margin-bottom: 3rem !important;
}

.ml-7,
.mx-7 {
  margin-left: 3rem !important;
}

.m-8 {
  margin: 3.5rem !important;
}

.mt-8,
.my-8 {
  margin-top: 3.5rem !important;
}

.mr-8,
.mx-8 {
  margin-right: 3.5rem !important;
}

.mb-8,
.my-8 {
  margin-bottom: 3.5rem !important;
}

.ml-8,
.mx-8 {
  margin-left: 3.5rem !important;
}

.m-9 {
  margin: 4rem !important;
}

.mt-9,
.my-9 {
  margin-top: 4rem !important;
}

.mr-9,
.mx-9 {
  margin-right: 4rem !important;
}

.mb-9,
.my-9 {
  margin-bottom: 4rem !important;
}

.ml-9,
.mx-9 {
  margin-left: 4rem !important;
}

.m-10 {
  margin: 4.5rem !important;
}

.mt-10,
.my-10 {
  margin-top: 4.5rem !important;
}

.mr-10,
.mx-10 {
  margin-right: 4.5rem !important;
}

.mb-10,
.my-10 {
  margin-bottom: 4.5rem !important;
}

.ml-10,
.mx-10 {
  margin-left: 4.5rem !important;
}

.m-11 {
  margin: 5rem !important;
}

.mt-11,
.my-11 {
  margin-top: 5rem !important;
}

.mr-11,
.mx-11 {
  margin-right: 5rem !important;
}

.mb-11,
.my-11 {
  margin-bottom: 5rem !important;
}

.ml-11,
.mx-11 {
  margin-left: 5rem !important;
}

.p-0 {
  padding: 0 !important;
}

.pt-0,
.py-0 {
  padding-top: 0 !important;
}

.pr-0,
.px-0 {
  padding-right: 0 !important;
}

.pb-0,
.py-0 {
  padding-bottom: 0 !important;
}

.pl-0,
.px-0 {
  padding-left: 0 !important;
}

.p-1 {
  padding: 0.25rem !important;
}

.pt-1,
.py-1 {
  padding-top: 0.25rem !important;
}

.pr-1,
.px-1 {
  padding-right: 0.25rem !important;
}

.pb-1,
.py-1 {
  padding-bottom: 0.25rem !important;
}

.pl-1,
.px-1 {
  padding-left: 0.25rem !important;
}

.p-2 {
  padding: 0.5rem !important;
}

.pt-2,
.py-2 {
  padding-top: 0.5rem !important;
}

.pr-2,
.px-2 {
  padding-right: 0.5rem !important;
}

.pb-2,
.py-2 {
  padding-bottom: 0.5rem !important;
}

.pl-2,
.px-2 {
  padding-left: 0.5rem !important;
}

.p-3 {
  padding: 1rem !important;
}

.pt-3,
.py-3 {
  padding-top: 1rem !important;
}

.pr-3,
.px-3 {
  padding-right: 1rem !important;
}

.pb-3,
.py-3 {
  padding-bottom: 1rem !important;
}

.pl-3,
.px-3 {
  padding-left: 1rem !important;
}

.p-4 {
  padding: 1.5rem !important;
}

.pt-4,
.py-4 {
  padding-top: 1.5rem !important;
}

.pr-4,
.px-4 {
  padding-right: 1.5rem !important;
}

.pb-4,
.py-4 {
  padding-bottom: 1.5rem !important;
}

.pl-4,
.px-4 {
  padding-left: 1.5rem !important;
}

.p-5 {
  padding: 2rem !important;
}

.pt-5,
.py-5 {
  padding-top: 2rem !important;
}

.pr-5,
.px-5 {
  padding-right: 2rem !important;
}

.pb-5,
.py-5 {
  padding-bottom: 2rem !important;
}

.pl-5,
.px-5 {
  padding-left: 2rem !important;
}

.p-6 {
  padding: 2.5rem !important;
}

.pt-6,
.py-6 {
  padding-top: 2.5rem !important;
}

.pr-6,
.px-6 {
  padding-right: 2.5rem !important;
}

.pb-6,
.py-6 {
  padding-bottom: 2.5rem !important;
}

.pl-6,
.px-6 {
  padding-left: 2.5rem !important;
}

.p-7 {
  padding: 3rem !important;
}

.pt-7,
.py-7 {
  padding-top: 3rem !important;
}

.pr-7,
.px-7 {
  padding-right: 3rem !important;
}

.pb-7,
.py-7 {
  padding-bottom: 3rem !important;
}

.pl-7,
.px-7 {
  padding-left: 3rem !important;
}

.p-8 {
  padding: 3.5rem !important;
}

.pt-8,
.py-8 {
  padding-top: 3.5rem !important;
}

.pr-8,
.px-8 {
  padding-right: 3.5rem !important;
}

.pb-8,
.py-8 {
  padding-bottom: 3.5rem !important;
}

.pl-8,
.px-8 {
  padding-left: 3.5rem !important;
}

.p-9 {
  padding: 4rem !important;
}

.pt-9,
.py-9 {
  padding-top: 4rem !important;
}

.pr-9,
.px-9 {
  padding-right: 4rem !important;
}

.pb-9,
.py-9 {
  padding-bottom: 4rem !important;
}

.pl-9,
.px-9 {
  padding-left: 4rem !important;
}

.p-10 {
  padding: 4.5rem !important;
}

.pt-10,
.py-10 {
  padding-top: 4.5rem !important;
}

.pr-10,
.px-10 {
  padding-right: 4.5rem !important;
}

.pb-10,
.py-10 {
  padding-bottom: 4.5rem !important;
}

.pl-10,
.px-10 {
  padding-left: 4.5rem !important;
}

.p-11 {
  padding: 5rem !important;
}

.pt-11,
.py-11 {
  padding-top: 5rem !important;
}

.pr-11,
.px-11 {
  padding-right: 5rem !important;
}

.pb-11,
.py-11 {
  padding-bottom: 5rem !important;
}

.pl-11,
.px-11 {
  padding-left: 5rem !important;
}

.m-n1 {
  margin: -0.25rem !important;
}

.mt-n1,
.my-n1 {
  margin-top: -0.25rem !important;
}

.mr-n1,
.mx-n1 {
  margin-right: -0.25rem !important;
}

.mb-n1,
.my-n1 {
  margin-bottom: -0.25rem !important;
}

.ml-n1,
.mx-n1 {
  margin-left: -0.25rem !important;
}

.m-n2 {
  margin: -0.5rem !important;
}

.mt-n2,
.my-n2 {
  margin-top: -0.5rem !important;
}

.mr-n2,
.mx-n2 {
  margin-right: -0.5rem !important;
}

.mb-n2,
.my-n2 {
  margin-bottom: -0.5rem !important;
}

.ml-n2,
.mx-n2 {
  margin-left: -0.5rem !important;
}

.m-n3 {
  margin: -1rem !important;
}

.mt-n3,
.my-n3 {
  margin-top: -1rem !important;
}

.mr-n3,
.mx-n3 {
  margin-right: -1rem !important;
}

.mb-n3,
.my-n3 {
  margin-bottom: -1rem !important;
}

.ml-n3,
.mx-n3 {
  margin-left: -1rem !important;
}

.m-n4 {
  margin: -1.5rem !important;
}

.mt-n4,
.my-n4 {
  margin-top: -1.5rem !important;
}

.mr-n4,
.mx-n4 {
  margin-right: -1.5rem !important;
}

.mb-n4,
.my-n4 {
  margin-bottom: -1.5rem !important;
}

.ml-n4,
.mx-n4 {
  margin-left: -1.5rem !important;
}

.m-n5 {
  margin: -2rem !important;
}

.mt-n5,
.my-n5 {
  margin-top: -2rem !important;
}

.mr-n5,
.mx-n5 {
  margin-right: -2rem !important;
}

.mb-n5,
.my-n5 {
  margin-bottom: -2rem !important;
}

.ml-n5,
.mx-n5 {
  margin-left: -2rem !important;
}

.m-n6 {
  margin: -2.5rem !important;
}

.mt-n6,
.my-n6 {
  margin-top: -2.5rem !important;
}

.mr-n6,
.mx-n6 {
  margin-right: -2.5rem !important;
}

.mb-n6,
.my-n6 {
  margin-bottom: -2.5rem !important;
}

.ml-n6,
.mx-n6 {
  margin-left: -2.5rem !important;
}

.m-n7 {
  margin: -3rem !important;
}

.mt-n7,
.my-n7 {
  margin-top: -3rem !important;
}

.mr-n7,
.mx-n7 {
  margin-right: -3rem !important;
}

.mb-n7,
.my-n7 {
  margin-bottom: -3rem !important;
}

.ml-n7,
.mx-n7 {
  margin-left: -3rem !important;
}

.m-n8 {
  margin: -3.5rem !important;
}

.mt-n8,
.my-n8 {
  margin-top: -3.5rem !important;
}

.mr-n8,
.mx-n8 {
  margin-right: -3.5rem !important;
}

.mb-n8,
.my-n8 {
  margin-bottom: -3.5rem !important;
}

.ml-n8,
.mx-n8 {
  margin-left: -3.5rem !important;
}

.m-n9 {
  margin: -4rem !important;
}

.mt-n9,
.my-n9 {
  margin-top: -4rem !important;
}

.mr-n9,
.mx-n9 {
  margin-right: -4rem !important;
}

.mb-n9,
.my-n9 {
  margin-bottom: -4rem !important;
}

.ml-n9,
.mx-n9 {
  margin-left: -4rem !important;
}

.m-n10 {
  margin: -4.5rem !important;
}

.mt-n10,
.my-n10 {
  margin-top: -4.5rem !important;
}

.mr-n10,
.mx-n10 {
  margin-right: -4.5rem !important;
}

.mb-n10,
.my-n10 {
  margin-bottom: -4.5rem !important;
}

.ml-n10,
.mx-n10 {
  margin-left: -4.5rem !important;
}

.m-n11 {
  margin: -5rem !important;
}

.mt-n11,
.my-n11 {
  margin-top: -5rem !important;
}

.mr-n11,
.mx-n11 {
  margin-right: -5rem !important;
}

.mb-n11,
.my-n11 {
  margin-bottom: -5rem !important;
}

.ml-n11,
.mx-n11 {
  margin-left: -5rem !important;
}

.m-auto {
  margin: auto !important;
}

.mt-auto,
.my-auto {
  margin-top: auto !important;
}

.mr-auto,
.mx-auto {
  margin-right: auto !important;
}

.mb-auto,
.my-auto {
  margin-bottom: auto !important;
}

.ml-auto,
.mx-auto {
  margin-left: auto !important;
}

@media (min-width: 576px) {
  .m-sm-0 {
    margin: 0 !important;
  }
  .mt-sm-0,
  .my-sm-0 {
    margin-top: 0 !important;
  }
  .mr-sm-0,
  .mx-sm-0 {
    margin-right: 0 !important;
  }
  .mb-sm-0,
  .my-sm-0 {
    margin-bottom: 0 !important;
  }
  .ml-sm-0,
  .mx-sm-0 {
    margin-left: 0 !important;
  }
  .m-sm-1 {
    margin: 0.25rem !important;
  }
  .mt-sm-1,
  .my-sm-1 {
    margin-top: 0.25rem !important;
  }
  .mr-sm-1,
  .mx-sm-1 {
    margin-right: 0.25rem !important;
  }
  .mb-sm-1,
  .my-sm-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-sm-1,
  .mx-sm-1 {
    margin-left: 0.25rem !important;
  }
  .m-sm-2 {
    margin: 0.5rem !important;
  }
  .mt-sm-2,
  .my-sm-2 {
    margin-top: 0.5rem !important;
  }
  .mr-sm-2,
  .mx-sm-2 {
    margin-right: 0.5rem !important;
  }
  .mb-sm-2,
  .my-sm-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-sm-2,
  .mx-sm-2 {
    margin-left: 0.5rem !important;
  }
  .m-sm-3 {
    margin: 1rem !important;
  }
  .mt-sm-3,
  .my-sm-3 {
    margin-top: 1rem !important;
  }
  .mr-sm-3,
  .mx-sm-3 {
    margin-right: 1rem !important;
  }
  .mb-sm-3,
  .my-sm-3 {
    margin-bottom: 1rem !important;
  }
  .ml-sm-3,
  .mx-sm-3 {
    margin-left: 1rem !important;
  }
  .m-sm-4 {
    margin: 1.5rem !important;
  }
  .mt-sm-4,
  .my-sm-4 {
    margin-top: 1.5rem !important;
  }
  .mr-sm-4,
  .mx-sm-4 {
    margin-right: 1.5rem !important;
  }
  .mb-sm-4,
  .my-sm-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-sm-4,
  .mx-sm-4 {
    margin-left: 1.5rem !important;
  }
  .m-sm-5 {
    margin: 2rem !important;
  }
  .mt-sm-5,
  .my-sm-5 {
    margin-top: 2rem !important;
  }
  .mr-sm-5,
  .mx-sm-5 {
    margin-right: 2rem !important;
  }
  .mb-sm-5,
  .my-sm-5 {
    margin-bottom: 2rem !important;
  }
  .ml-sm-5,
  .mx-sm-5 {
    margin-left: 2rem !important;
  }
  .m-sm-6 {
    margin: 2.5rem !important;
  }
  .mt-sm-6,
  .my-sm-6 {
    margin-top: 2.5rem !important;
  }
  .mr-sm-6,
  .mx-sm-6 {
    margin-right: 2.5rem !important;
  }
  .mb-sm-6,
  .my-sm-6 {
    margin-bottom: 2.5rem !important;
  }
  .ml-sm-6,
  .mx-sm-6 {
    margin-left: 2.5rem !important;
  }
  .m-sm-7 {
    margin: 3rem !important;
  }
  .mt-sm-7,
  .my-sm-7 {
    margin-top: 3rem !important;
  }
  .mr-sm-7,
  .mx-sm-7 {
    margin-right: 3rem !important;
  }
  .mb-sm-7,
  .my-sm-7 {
    margin-bottom: 3rem !important;
  }
  .ml-sm-7,
  .mx-sm-7 {
    margin-left: 3rem !important;
  }
  .m-sm-8 {
    margin: 3.5rem !important;
  }
  .mt-sm-8,
  .my-sm-8 {
    margin-top: 3.5rem !important;
  }
  .mr-sm-8,
  .mx-sm-8 {
    margin-right: 3.5rem !important;
  }
  .mb-sm-8,
  .my-sm-8 {
    margin-bottom: 3.5rem !important;
  }
  .ml-sm-8,
  .mx-sm-8 {
    margin-left: 3.5rem !important;
  }
  .m-sm-9 {
    margin: 4rem !important;
  }
  .mt-sm-9,
  .my-sm-9 {
    margin-top: 4rem !important;
  }
  .mr-sm-9,
  .mx-sm-9 {
    margin-right: 4rem !important;
  }
  .mb-sm-9,
  .my-sm-9 {
    margin-bottom: 4rem !important;
  }
  .ml-sm-9,
  .mx-sm-9 {
    margin-left: 4rem !important;
  }
  .m-sm-10 {
    margin: 4.5rem !important;
  }
  .mt-sm-10,
  .my-sm-10 {
    margin-top: 4.5rem !important;
  }
  .mr-sm-10,
  .mx-sm-10 {
    margin-right: 4.5rem !important;
  }
  .mb-sm-10,
  .my-sm-10 {
    margin-bottom: 4.5rem !important;
  }
  .ml-sm-10,
  .mx-sm-10 {
    margin-left: 4.5rem !important;
  }
  .m-sm-11 {
    margin: 5rem !important;
  }
  .mt-sm-11,
  .my-sm-11 {
    margin-top: 5rem !important;
  }
  .mr-sm-11,
  .mx-sm-11 {
    margin-right: 5rem !important;
  }
  .mb-sm-11,
  .my-sm-11 {
    margin-bottom: 5rem !important;
  }
  .ml-sm-11,
  .mx-sm-11 {
    margin-left: 5rem !important;
  }
  .p-sm-0 {
    padding: 0 !important;
  }
  .pt-sm-0,
  .py-sm-0 {
    padding-top: 0 !important;
  }
  .pr-sm-0,
  .px-sm-0 {
    padding-right: 0 !important;
  }
  .pb-sm-0,
  .py-sm-0 {
    padding-bottom: 0 !important;
  }
  .pl-sm-0,
  .px-sm-0 {
    padding-left: 0 !important;
  }
  .p-sm-1 {
    padding: 0.25rem !important;
  }
  .pt-sm-1,
  .py-sm-1 {
    padding-top: 0.25rem !important;
  }
  .pr-sm-1,
  .px-sm-1 {
    padding-right: 0.25rem !important;
  }
  .pb-sm-1,
  .py-sm-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-sm-1,
  .px-sm-1 {
    padding-left: 0.25rem !important;
  }
  .p-sm-2 {
    padding: 0.5rem !important;
  }
  .pt-sm-2,
  .py-sm-2 {
    padding-top: 0.5rem !important;
  }
  .pr-sm-2,
  .px-sm-2 {
    padding-right: 0.5rem !important;
  }
  .pb-sm-2,
  .py-sm-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-sm-2,
  .px-sm-2 {
    padding-left: 0.5rem !important;
  }
  .p-sm-3 {
    padding: 1rem !important;
  }
  .pt-sm-3,
  .py-sm-3 {
    padding-top: 1rem !important;
  }
  .pr-sm-3,
  .px-sm-3 {
    padding-right: 1rem !important;
  }
  .pb-sm-3,
  .py-sm-3 {
    padding-bottom: 1rem !important;
  }
  .pl-sm-3,
  .px-sm-3 {
    padding-left: 1rem !important;
  }
  .p-sm-4 {
    padding: 1.5rem !important;
  }
  .pt-sm-4,
  .py-sm-4 {
    padding-top: 1.5rem !important;
  }
  .pr-sm-4,
  .px-sm-4 {
    padding-right: 1.5rem !important;
  }
  .pb-sm-4,
  .py-sm-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-sm-4,
  .px-sm-4 {
    padding-left: 1.5rem !important;
  }
  .p-sm-5 {
    padding: 2rem !important;
  }
  .pt-sm-5,
  .py-sm-5 {
    padding-top: 2rem !important;
  }
  .pr-sm-5,
  .px-sm-5 {
    padding-right: 2rem !important;
  }
  .pb-sm-5,
  .py-sm-5 {
    padding-bottom: 2rem !important;
  }
  .pl-sm-5,
  .px-sm-5 {
    padding-left: 2rem !important;
  }
  .p-sm-6 {
    padding: 2.5rem !important;
  }
  .pt-sm-6,
  .py-sm-6 {
    padding-top: 2.5rem !important;
  }
  .pr-sm-6,
  .px-sm-6 {
    padding-right: 2.5rem !important;
  }
  .pb-sm-6,
  .py-sm-6 {
    padding-bottom: 2.5rem !important;
  }
  .pl-sm-6,
  .px-sm-6 {
    padding-left: 2.5rem !important;
  }
  .p-sm-7 {
    padding: 3rem !important;
  }
  .pt-sm-7,
  .py-sm-7 {
    padding-top: 3rem !important;
  }
  .pr-sm-7,
  .px-sm-7 {
    padding-right: 3rem !important;
  }
  .pb-sm-7,
  .py-sm-7 {
    padding-bottom: 3rem !important;
  }
  .pl-sm-7,
  .px-sm-7 {
    padding-left: 3rem !important;
  }
  .p-sm-8 {
    padding: 3.5rem !important;
  }
  .pt-sm-8,
  .py-sm-8 {
    padding-top: 3.5rem !important;
  }
  .pr-sm-8,
  .px-sm-8 {
    padding-right: 3.5rem !important;
  }
  .pb-sm-8,
  .py-sm-8 {
    padding-bottom: 3.5rem !important;
  }
  .pl-sm-8,
  .px-sm-8 {
    padding-left: 3.5rem !important;
  }
  .p-sm-9 {
    padding: 4rem !important;
  }
  .pt-sm-9,
  .py-sm-9 {
    padding-top: 4rem !important;
  }
  .pr-sm-9,
  .px-sm-9 {
    padding-right: 4rem !important;
  }
  .pb-sm-9,
  .py-sm-9 {
    padding-bottom: 4rem !important;
  }
  .pl-sm-9,
  .px-sm-9 {
    padding-left: 4rem !important;
  }
  .p-sm-10 {
    padding: 4.5rem !important;
  }
  .pt-sm-10,
  .py-sm-10 {
    padding-top: 4.5rem !important;
  }
  .pr-sm-10,
  .px-sm-10 {
    padding-right: 4.5rem !important;
  }
  .pb-sm-10,
  .py-sm-10 {
    padding-bottom: 4.5rem !important;
  }
  .pl-sm-10,
  .px-sm-10 {
    padding-left: 4.5rem !important;
  }
  .p-sm-11 {
    padding: 5rem !important;
  }
  .pt-sm-11,
  .py-sm-11 {
    padding-top: 5rem !important;
  }
  .pr-sm-11,
  .px-sm-11 {
    padding-right: 5rem !important;
  }
  .pb-sm-11,
  .py-sm-11 {
    padding-bottom: 5rem !important;
  }
  .pl-sm-11,
  .px-sm-11 {
    padding-left: 5rem !important;
  }
  .m-sm-n1 {
    margin: -0.25rem !important;
  }
  .mt-sm-n1,
  .my-sm-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-sm-n1,
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-sm-n1,
  .my-sm-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-sm-n1,
  .mx-sm-n1 {
    margin-left: -0.25rem !important;
  }
  .m-sm-n2 {
    margin: -0.5rem !important;
  }
  .mt-sm-n2,
  .my-sm-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-sm-n2,
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-sm-n2,
  .my-sm-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-sm-n2,
  .mx-sm-n2 {
    margin-left: -0.5rem !important;
  }
  .m-sm-n3 {
    margin: -1rem !important;
  }
  .mt-sm-n3,
  .my-sm-n3 {
    margin-top: -1rem !important;
  }
  .mr-sm-n3,
  .mx-sm-n3 {
    margin-right: -1rem !important;
  }
  .mb-sm-n3,
  .my-sm-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-sm-n3,
  .mx-sm-n3 {
    margin-left: -1rem !important;
  }
  .m-sm-n4 {
    margin: -1.5rem !important;
  }
  .mt-sm-n4,
  .my-sm-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-sm-n4,
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-sm-n4,
  .my-sm-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-sm-n4,
  .mx-sm-n4 {
    margin-left: -1.5rem !important;
  }
  .m-sm-n5 {
    margin: -2rem !important;
  }
  .mt-sm-n5,
  .my-sm-n5 {
    margin-top: -2rem !important;
  }
  .mr-sm-n5,
  .mx-sm-n5 {
    margin-right: -2rem !important;
  }
  .mb-sm-n5,
  .my-sm-n5 {
    margin-bottom: -2rem !important;
  }
  .ml-sm-n5,
  .mx-sm-n5 {
    margin-left: -2rem !important;
  }
  .m-sm-n6 {
    margin: -2.5rem !important;
  }
  .mt-sm-n6,
  .my-sm-n6 {
    margin-top: -2.5rem !important;
  }
  .mr-sm-n6,
  .mx-sm-n6 {
    margin-right: -2.5rem !important;
  }
  .mb-sm-n6,
  .my-sm-n6 {
    margin-bottom: -2.5rem !important;
  }
  .ml-sm-n6,
  .mx-sm-n6 {
    margin-left: -2.5rem !important;
  }
  .m-sm-n7 {
    margin: -3rem !important;
  }
  .mt-sm-n7,
  .my-sm-n7 {
    margin-top: -3rem !important;
  }
  .mr-sm-n7,
  .mx-sm-n7 {
    margin-right: -3rem !important;
  }
  .mb-sm-n7,
  .my-sm-n7 {
    margin-bottom: -3rem !important;
  }
  .ml-sm-n7,
  .mx-sm-n7 {
    margin-left: -3rem !important;
  }
  .m-sm-n8 {
    margin: -3.5rem !important;
  }
  .mt-sm-n8,
  .my-sm-n8 {
    margin-top: -3.5rem !important;
  }
  .mr-sm-n8,
  .mx-sm-n8 {
    margin-right: -3.5rem !important;
  }
  .mb-sm-n8,
  .my-sm-n8 {
    margin-bottom: -3.5rem !important;
  }
  .ml-sm-n8,
  .mx-sm-n8 {
    margin-left: -3.5rem !important;
  }
  .m-sm-n9 {
    margin: -4rem !important;
  }
  .mt-sm-n9,
  .my-sm-n9 {
    margin-top: -4rem !important;
  }
  .mr-sm-n9,
  .mx-sm-n9 {
    margin-right: -4rem !important;
  }
  .mb-sm-n9,
  .my-sm-n9 {
    margin-bottom: -4rem !important;
  }
  .ml-sm-n9,
  .mx-sm-n9 {
    margin-left: -4rem !important;
  }
  .m-sm-n10 {
    margin: -4.5rem !important;
  }
  .mt-sm-n10,
  .my-sm-n10 {
    margin-top: -4.5rem !important;
  }
  .mr-sm-n10,
  .mx-sm-n10 {
    margin-right: -4.5rem !important;
  }
  .mb-sm-n10,
  .my-sm-n10 {
    margin-bottom: -4.5rem !important;
  }
  .ml-sm-n10,
  .mx-sm-n10 {
    margin-left: -4.5rem !important;
  }
  .m-sm-n11 {
    margin: -5rem !important;
  }
  .mt-sm-n11,
  .my-sm-n11 {
    margin-top: -5rem !important;
  }
  .mr-sm-n11,
  .mx-sm-n11 {
    margin-right: -5rem !important;
  }
  .mb-sm-n11,
  .my-sm-n11 {
    margin-bottom: -5rem !important;
  }
  .ml-sm-n11,
  .mx-sm-n11 {
    margin-left: -5rem !important;
  }
  .m-sm-auto {
    margin: auto !important;
  }
  .mt-sm-auto,
  .my-sm-auto {
    margin-top: auto !important;
  }
  .mr-sm-auto,
  .mx-sm-auto {
    margin-right: auto !important;
  }
  .mb-sm-auto,
  .my-sm-auto {
    margin-bottom: auto !important;
  }
  .ml-sm-auto,
  .mx-sm-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 768px) {
  .m-md-0 {
    margin: 0 !important;
  }
  .mt-md-0,
  .my-md-0 {
    margin-top: 0 !important;
  }
  .mr-md-0,
  .mx-md-0 {
    margin-right: 0 !important;
  }
  .mb-md-0,
  .my-md-0 {
    margin-bottom: 0 !important;
  }
  .ml-md-0,
  .mx-md-0 {
    margin-left: 0 !important;
  }
  .m-md-1 {
    margin: 0.25rem !important;
  }
  .mt-md-1,
  .my-md-1 {
    margin-top: 0.25rem !important;
  }
  .mr-md-1,
  .mx-md-1 {
    margin-right: 0.25rem !important;
  }
  .mb-md-1,
  .my-md-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-md-1,
  .mx-md-1 {
    margin-left: 0.25rem !important;
  }
  .m-md-2 {
    margin: 0.5rem !important;
  }
  .mt-md-2,
  .my-md-2 {
    margin-top: 0.5rem !important;
  }
  .mr-md-2,
  .mx-md-2 {
    margin-right: 0.5rem !important;
  }
  .mb-md-2,
  .my-md-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-md-2,
  .mx-md-2 {
    margin-left: 0.5rem !important;
  }
  .m-md-3 {
    margin: 1rem !important;
  }
  .mt-md-3,
  .my-md-3 {
    margin-top: 1rem !important;
  }
  .mr-md-3,
  .mx-md-3 {
    margin-right: 1rem !important;
  }
  .mb-md-3,
  .my-md-3 {
    margin-bottom: 1rem !important;
  }
  .ml-md-3,
  .mx-md-3 {
    margin-left: 1rem !important;
  }
  .m-md-4 {
    margin: 1.5rem !important;
  }
  .mt-md-4,
  .my-md-4 {
    margin-top: 1.5rem !important;
  }
  .mr-md-4,
  .mx-md-4 {
    margin-right: 1.5rem !important;
  }
  .mb-md-4,
  .my-md-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-md-4,
  .mx-md-4 {
    margin-left: 1.5rem !important;
  }
  .m-md-5 {
    margin: 2rem !important;
  }
  .mt-md-5,
  .my-md-5 {
    margin-top: 2rem !important;
  }
  .mr-md-5,
  .mx-md-5 {
    margin-right: 2rem !important;
  }
  .mb-md-5,
  .my-md-5 {
    margin-bottom: 2rem !important;
  }
  .ml-md-5,
  .mx-md-5 {
    margin-left: 2rem !important;
  }
  .m-md-6 {
    margin: 2.5rem !important;
  }
  .mt-md-6,
  .my-md-6 {
    margin-top: 2.5rem !important;
  }
  .mr-md-6,
  .mx-md-6 {
    margin-right: 2.5rem !important;
  }
  .mb-md-6,
  .my-md-6 {
    margin-bottom: 2.5rem !important;
  }
  .ml-md-6,
  .mx-md-6 {
    margin-left: 2.5rem !important;
  }
  .m-md-7 {
    margin: 3rem !important;
  }
  .mt-md-7,
  .my-md-7 {
    margin-top: 3rem !important;
  }
  .mr-md-7,
  .mx-md-7 {
    margin-right: 3rem !important;
  }
  .mb-md-7,
  .my-md-7 {
    margin-bottom: 3rem !important;
  }
  .ml-md-7,
  .mx-md-7 {
    margin-left: 3rem !important;
  }
  .m-md-8 {
    margin: 3.5rem !important;
  }
  .mt-md-8,
  .my-md-8 {
    margin-top: 3.5rem !important;
  }
  .mr-md-8,
  .mx-md-8 {
    margin-right: 3.5rem !important;
  }
  .mb-md-8,
  .my-md-8 {
    margin-bottom: 3.5rem !important;
  }
  .ml-md-8,
  .mx-md-8 {
    margin-left: 3.5rem !important;
  }
  .m-md-9 {
    margin: 4rem !important;
  }
  .mt-md-9,
  .my-md-9 {
    margin-top: 4rem !important;
  }
  .mr-md-9,
  .mx-md-9 {
    margin-right: 4rem !important;
  }
  .mb-md-9,
  .my-md-9 {
    margin-bottom: 4rem !important;
  }
  .ml-md-9,
  .mx-md-9 {
    margin-left: 4rem !important;
  }
  .m-md-10 {
    margin: 4.5rem !important;
  }
  .mt-md-10,
  .my-md-10 {
    margin-top: 4.5rem !important;
  }
  .mr-md-10,
  .mx-md-10 {
    margin-right: 4.5rem !important;
  }
  .mb-md-10,
  .my-md-10 {
    margin-bottom: 4.5rem !important;
  }
  .ml-md-10,
  .mx-md-10 {
    margin-left: 4.5rem !important;
  }
  .m-md-11 {
    margin: 5rem !important;
  }
  .mt-md-11,
  .my-md-11 {
    margin-top: 5rem !important;
  }
  .mr-md-11,
  .mx-md-11 {
    margin-right: 5rem !important;
  }
  .mb-md-11,
  .my-md-11 {
    margin-bottom: 5rem !important;
  }
  .ml-md-11,
  .mx-md-11 {
    margin-left: 5rem !important;
  }
  .p-md-0 {
    padding: 0 !important;
  }
  .pt-md-0,
  .py-md-0 {
    padding-top: 0 !important;
  }
  .pr-md-0,
  .px-md-0 {
    padding-right: 0 !important;
  }
  .pb-md-0,
  .py-md-0 {
    padding-bottom: 0 !important;
  }
  .pl-md-0,
  .px-md-0 {
    padding-left: 0 !important;
  }
  .p-md-1 {
    padding: 0.25rem !important;
  }
  .pt-md-1,
  .py-md-1 {
    padding-top: 0.25rem !important;
  }
  .pr-md-1,
  .px-md-1 {
    padding-right: 0.25rem !important;
  }
  .pb-md-1,
  .py-md-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-md-1,
  .px-md-1 {
    padding-left: 0.25rem !important;
  }
  .p-md-2 {
    padding: 0.5rem !important;
  }
  .pt-md-2,
  .py-md-2 {
    padding-top: 0.5rem !important;
  }
  .pr-md-2,
  .px-md-2 {
    padding-right: 0.5rem !important;
  }
  .pb-md-2,
  .py-md-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-md-2,
  .px-md-2 {
    padding-left: 0.5rem !important;
  }
  .p-md-3 {
    padding: 1rem !important;
  }
  .pt-md-3,
  .py-md-3 {
    padding-top: 1rem !important;
  }
  .pr-md-3,
  .px-md-3 {
    padding-right: 1rem !important;
  }
  .pb-md-3,
  .py-md-3 {
    padding-bottom: 1rem !important;
  }
  .pl-md-3,
  .px-md-3 {
    padding-left: 1rem !important;
  }
  .p-md-4 {
    padding: 1.5rem !important;
  }
  .pt-md-4,
  .py-md-4 {
    padding-top: 1.5rem !important;
  }
  .pr-md-4,
  .px-md-4 {
    padding-right: 1.5rem !important;
  }
  .pb-md-4,
  .py-md-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-md-4,
  .px-md-4 {
    padding-left: 1.5rem !important;
  }
  .p-md-5 {
    padding: 2rem !important;
  }
  .pt-md-5,
  .py-md-5 {
    padding-top: 2rem !important;
  }
  .pr-md-5,
  .px-md-5 {
    padding-right: 2rem !important;
  }
  .pb-md-5,
  .py-md-5 {
    padding-bottom: 2rem !important;
  }
  .pl-md-5,
  .px-md-5 {
    padding-left: 2rem !important;
  }
  .p-md-6 {
    padding: 2.5rem !important;
  }
  .pt-md-6,
  .py-md-6 {
    padding-top: 2.5rem !important;
  }
  .pr-md-6,
  .px-md-6 {
    padding-right: 2.5rem !important;
  }
  .pb-md-6,
  .py-md-6 {
    padding-bottom: 2.5rem !important;
  }
  .pl-md-6,
  .px-md-6 {
    padding-left: 2.5rem !important;
  }
  .p-md-7 {
    padding: 3rem !important;
  }
  .pt-md-7,
  .py-md-7 {
    padding-top: 3rem !important;
  }
  .pr-md-7,
  .px-md-7 {
    padding-right: 3rem !important;
  }
  .pb-md-7,
  .py-md-7 {
    padding-bottom: 3rem !important;
  }
  .pl-md-7,
  .px-md-7 {
    padding-left: 3rem !important;
  }
  .p-md-8 {
    padding: 3.5rem !important;
  }
  .pt-md-8,
  .py-md-8 {
    padding-top: 3.5rem !important;
  }
  .pr-md-8,
  .px-md-8 {
    padding-right: 3.5rem !important;
  }
  .pb-md-8,
  .py-md-8 {
    padding-bottom: 3.5rem !important;
  }
  .pl-md-8,
  .px-md-8 {
    padding-left: 3.5rem !important;
  }
  .p-md-9 {
    padding: 4rem !important;
  }
  .pt-md-9,
  .py-md-9 {
    padding-top: 4rem !important;
  }
  .pr-md-9,
  .px-md-9 {
    padding-right: 4rem !important;
  }
  .pb-md-9,
  .py-md-9 {
    padding-bottom: 4rem !important;
  }
  .pl-md-9,
  .px-md-9 {
    padding-left: 4rem !important;
  }
  .p-md-10 {
    padding: 4.5rem !important;
  }
  .pt-md-10,
  .py-md-10 {
    padding-top: 4.5rem !important;
  }
  .pr-md-10,
  .px-md-10 {
    padding-right: 4.5rem !important;
  }
  .pb-md-10,
  .py-md-10 {
    padding-bottom: 4.5rem !important;
  }
  .pl-md-10,
  .px-md-10 {
    padding-left: 4.5rem !important;
  }
  .p-md-11 {
    padding: 5rem !important;
  }
  .pt-md-11,
  .py-md-11 {
    padding-top: 5rem !important;
  }
  .pr-md-11,
  .px-md-11 {
    padding-right: 5rem !important;
  }
  .pb-md-11,
  .py-md-11 {
    padding-bottom: 5rem !important;
  }
  .pl-md-11,
  .px-md-11 {
    padding-left: 5rem !important;
  }
  .m-md-n1 {
    margin: -0.25rem !important;
  }
  .mt-md-n1,
  .my-md-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-md-n1,
  .mx-md-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-md-n1,
  .my-md-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-md-n1,
  .mx-md-n1 {
    margin-left: -0.25rem !important;
  }
  .m-md-n2 {
    margin: -0.5rem !important;
  }
  .mt-md-n2,
  .my-md-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-md-n2,
  .mx-md-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-md-n2,
  .my-md-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-md-n2,
  .mx-md-n2 {
    margin-left: -0.5rem !important;
  }
  .m-md-n3 {
    margin: -1rem !important;
  }
  .mt-md-n3,
  .my-md-n3 {
    margin-top: -1rem !important;
  }
  .mr-md-n3,
  .mx-md-n3 {
    margin-right: -1rem !important;
  }
  .mb-md-n3,
  .my-md-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-md-n3,
  .mx-md-n3 {
    margin-left: -1rem !important;
  }
  .m-md-n4 {
    margin: -1.5rem !important;
  }
  .mt-md-n4,
  .my-md-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-md-n4,
  .mx-md-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-md-n4,
  .my-md-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-md-n4,
  .mx-md-n4 {
    margin-left: -1.5rem !important;
  }
  .m-md-n5 {
    margin: -2rem !important;
  }
  .mt-md-n5,
  .my-md-n5 {
    margin-top: -2rem !important;
  }
  .mr-md-n5,
  .mx-md-n5 {
    margin-right: -2rem !important;
  }
  .mb-md-n5,
  .my-md-n5 {
    margin-bottom: -2rem !important;
  }
  .ml-md-n5,
  .mx-md-n5 {
    margin-left: -2rem !important;
  }
  .m-md-n6 {
    margin: -2.5rem !important;
  }
  .mt-md-n6,
  .my-md-n6 {
    margin-top: -2.5rem !important;
  }
  .mr-md-n6,
  .mx-md-n6 {
    margin-right: -2.5rem !important;
  }
  .mb-md-n6,
  .my-md-n6 {
    margin-bottom: -2.5rem !important;
  }
  .ml-md-n6,
  .mx-md-n6 {
    margin-left: -2.5rem !important;
  }
  .m-md-n7 {
    margin: -3rem !important;
  }
  .mt-md-n7,
  .my-md-n7 {
    margin-top: -3rem !important;
  }
  .mr-md-n7,
  .mx-md-n7 {
    margin-right: -3rem !important;
  }
  .mb-md-n7,
  .my-md-n7 {
    margin-bottom: -3rem !important;
  }
  .ml-md-n7,
  .mx-md-n7 {
    margin-left: -3rem !important;
  }
  .m-md-n8 {
    margin: -3.5rem !important;
  }
  .mt-md-n8,
  .my-md-n8 {
    margin-top: -3.5rem !important;
  }
  .mr-md-n8,
  .mx-md-n8 {
    margin-right: -3.5rem !important;
  }
  .mb-md-n8,
  .my-md-n8 {
    margin-bottom: -3.5rem !important;
  }
  .ml-md-n8,
  .mx-md-n8 {
    margin-left: -3.5rem !important;
  }
  .m-md-n9 {
    margin: -4rem !important;
  }
  .mt-md-n9,
  .my-md-n9 {
    margin-top: -4rem !important;
  }
  .mr-md-n9,
  .mx-md-n9 {
    margin-right: -4rem !important;
  }
  .mb-md-n9,
  .my-md-n9 {
    margin-bottom: -4rem !important;
  }
  .ml-md-n9,
  .mx-md-n9 {
    margin-left: -4rem !important;
  }
  .m-md-n10 {
    margin: -4.5rem !important;
  }
  .mt-md-n10,
  .my-md-n10 {
    margin-top: -4.5rem !important;
  }
  .mr-md-n10,
  .mx-md-n10 {
    margin-right: -4.5rem !important;
  }
  .mb-md-n10,
  .my-md-n10 {
    margin-bottom: -4.5rem !important;
  }
  .ml-md-n10,
  .mx-md-n10 {
    margin-left: -4.5rem !important;
  }
  .m-md-n11 {
    margin: -5rem !important;
  }
  .mt-md-n11,
  .my-md-n11 {
    margin-top: -5rem !important;
  }
  .mr-md-n11,
  .mx-md-n11 {
    margin-right: -5rem !important;
  }
  .mb-md-n11,
  .my-md-n11 {
    margin-bottom: -5rem !important;
  }
  .ml-md-n11,
  .mx-md-n11 {
    margin-left: -5rem !important;
  }
  .m-md-auto {
    margin: auto !important;
  }
  .mt-md-auto,
  .my-md-auto {
    margin-top: auto !important;
  }
  .mr-md-auto,
  .mx-md-auto {
    margin-right: auto !important;
  }
  .mb-md-auto,
  .my-md-auto {
    margin-bottom: auto !important;
  }
  .ml-md-auto,
  .mx-md-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 992px) {
  .m-lg-0 {
    margin: 0 !important;
  }
  .mt-lg-0,
  .my-lg-0 {
    margin-top: 0 !important;
  }
  .mr-lg-0,
  .mx-lg-0 {
    margin-right: 0 !important;
  }
  .mb-lg-0,
  .my-lg-0 {
    margin-bottom: 0 !important;
  }
  .ml-lg-0,
  .mx-lg-0 {
    margin-left: 0 !important;
  }
  .m-lg-1 {
    margin: 0.25rem !important;
  }
  .mt-lg-1,
  .my-lg-1 {
    margin-top: 0.25rem !important;
  }
  .mr-lg-1,
  .mx-lg-1 {
    margin-right: 0.25rem !important;
  }
  .mb-lg-1,
  .my-lg-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-lg-1,
  .mx-lg-1 {
    margin-left: 0.25rem !important;
  }
  .m-lg-2 {
    margin: 0.5rem !important;
  }
  .mt-lg-2,
  .my-lg-2 {
    margin-top: 0.5rem !important;
  }
  .mr-lg-2,
  .mx-lg-2 {
    margin-right: 0.5rem !important;
  }
  .mb-lg-2,
  .my-lg-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-lg-2,
  .mx-lg-2 {
    margin-left: 0.5rem !important;
  }
  .m-lg-3 {
    margin: 1rem !important;
  }
  .mt-lg-3,
  .my-lg-3 {
    margin-top: 1rem !important;
  }
  .mr-lg-3,
  .mx-lg-3 {
    margin-right: 1rem !important;
  }
  .mb-lg-3,
  .my-lg-3 {
    margin-bottom: 1rem !important;
  }
  .ml-lg-3,
  .mx-lg-3 {
    margin-left: 1rem !important;
  }
  .m-lg-4 {
    margin: 1.5rem !important;
  }
  .mt-lg-4,
  .my-lg-4 {
    margin-top: 1.5rem !important;
  }
  .mr-lg-4,
  .mx-lg-4 {
    margin-right: 1.5rem !important;
  }
  .mb-lg-4,
  .my-lg-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-lg-4,
  .mx-lg-4 {
    margin-left: 1.5rem !important;
  }
  .m-lg-5 {
    margin: 2rem !important;
  }
  .mt-lg-5,
  .my-lg-5 {
    margin-top: 2rem !important;
  }
  .mr-lg-5,
  .mx-lg-5 {
    margin-right: 2rem !important;
  }
  .mb-lg-5,
  .my-lg-5 {
    margin-bottom: 2rem !important;
  }
  .ml-lg-5,
  .mx-lg-5 {
    margin-left: 2rem !important;
  }
  .m-lg-6 {
    margin: 2.5rem !important;
  }
  .mt-lg-6,
  .my-lg-6 {
    margin-top: 2.5rem !important;
  }
  .mr-lg-6,
  .mx-lg-6 {
    margin-right: 2.5rem !important;
  }
  .mb-lg-6,
  .my-lg-6 {
    margin-bottom: 2.5rem !important;
  }
  .ml-lg-6,
  .mx-lg-6 {
    margin-left: 2.5rem !important;
  }
  .m-lg-7 {
    margin: 3rem !important;
  }
  .mt-lg-7,
  .my-lg-7 {
    margin-top: 3rem !important;
  }
  .mr-lg-7,
  .mx-lg-7 {
    margin-right: 3rem !important;
  }
  .mb-lg-7,
  .my-lg-7 {
    margin-bottom: 3rem !important;
  }
  .ml-lg-7,
  .mx-lg-7 {
    margin-left: 3rem !important;
  }
  .m-lg-8 {
    margin: 3.5rem !important;
  }
  .mt-lg-8,
  .my-lg-8 {
    margin-top: 3.5rem !important;
  }
  .mr-lg-8,
  .mx-lg-8 {
    margin-right: 3.5rem !important;
  }
  .mb-lg-8,
  .my-lg-8 {
    margin-bottom: 3.5rem !important;
  }
  .ml-lg-8,
  .mx-lg-8 {
    margin-left: 3.5rem !important;
  }
  .m-lg-9 {
    margin: 4rem !important;
  }
  .mt-lg-9,
  .my-lg-9 {
    margin-top: 4rem !important;
  }
  .mr-lg-9,
  .mx-lg-9 {
    margin-right: 4rem !important;
  }
  .mb-lg-9,
  .my-lg-9 {
    margin-bottom: 4rem !important;
  }
  .ml-lg-9,
  .mx-lg-9 {
    margin-left: 4rem !important;
  }
  .m-lg-10 {
    margin: 4.5rem !important;
  }
  .mt-lg-10,
  .my-lg-10 {
    margin-top: 4.5rem !important;
  }
  .mr-lg-10,
  .mx-lg-10 {
    margin-right: 4.5rem !important;
  }
  .mb-lg-10,
  .my-lg-10 {
    margin-bottom: 4.5rem !important;
  }
  .ml-lg-10,
  .mx-lg-10 {
    margin-left: 4.5rem !important;
  }
  .m-lg-11 {
    margin: 5rem !important;
  }
  .mt-lg-11,
  .my-lg-11 {
    margin-top: 5rem !important;
  }
  .mr-lg-11,
  .mx-lg-11 {
    margin-right: 5rem !important;
  }
  .mb-lg-11,
  .my-lg-11 {
    margin-bottom: 5rem !important;
  }
  .ml-lg-11,
  .mx-lg-11 {
    margin-left: 5rem !important;
  }
  .p-lg-0 {
    padding: 0 !important;
  }
  .pt-lg-0,
  .py-lg-0 {
    padding-top: 0 !important;
  }
  .pr-lg-0,
  .px-lg-0 {
    padding-right: 0 !important;
  }
  .pb-lg-0,
  .py-lg-0 {
    padding-bottom: 0 !important;
  }
  .pl-lg-0,
  .px-lg-0 {
    padding-left: 0 !important;
  }
  .p-lg-1 {
    padding: 0.25rem !important;
  }
  .pt-lg-1,
  .py-lg-1 {
    padding-top: 0.25rem !important;
  }
  .pr-lg-1,
  .px-lg-1 {
    padding-right: 0.25rem !important;
  }
  .pb-lg-1,
  .py-lg-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-lg-1,
  .px-lg-1 {
    padding-left: 0.25rem !important;
  }
  .p-lg-2 {
    padding: 0.5rem !important;
  }
  .pt-lg-2,
  .py-lg-2 {
    padding-top: 0.5rem !important;
  }
  .pr-lg-2,
  .px-lg-2 {
    padding-right: 0.5rem !important;
  }
  .pb-lg-2,
  .py-lg-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-lg-2,
  .px-lg-2 {
    padding-left: 0.5rem !important;
  }
  .p-lg-3 {
    padding: 1rem !important;
  }
  .pt-lg-3,
  .py-lg-3 {
    padding-top: 1rem !important;
  }
  .pr-lg-3,
  .px-lg-3 {
    padding-right: 1rem !important;
  }
  .pb-lg-3,
  .py-lg-3 {
    padding-bottom: 1rem !important;
  }
  .pl-lg-3,
  .px-lg-3 {
    padding-left: 1rem !important;
  }
  .p-lg-4 {
    padding: 1.5rem !important;
  }
  .pt-lg-4,
  .py-lg-4 {
    padding-top: 1.5rem !important;
  }
  .pr-lg-4,
  .px-lg-4 {
    padding-right: 1.5rem !important;
  }
  .pb-lg-4,
  .py-lg-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-lg-4,
  .px-lg-4 {
    padding-left: 1.5rem !important;
  }
  .p-lg-5 {
    padding: 2rem !important;
  }
  .pt-lg-5,
  .py-lg-5 {
    padding-top: 2rem !important;
  }
  .pr-lg-5,
  .px-lg-5 {
    padding-right: 2rem !important;
  }
  .pb-lg-5,
  .py-lg-5 {
    padding-bottom: 2rem !important;
  }
  .pl-lg-5,
  .px-lg-5 {
    padding-left: 2rem !important;
  }
  .p-lg-6 {
    padding: 2.5rem !important;
  }
  .pt-lg-6,
  .py-lg-6 {
    padding-top: 2.5rem !important;
  }
  .pr-lg-6,
  .px-lg-6 {
    padding-right: 2.5rem !important;
  }
  .pb-lg-6,
  .py-lg-6 {
    padding-bottom: 2.5rem !important;
  }
  .pl-lg-6,
  .px-lg-6 {
    padding-left: 2.5rem !important;
  }
  .p-lg-7 {
    padding: 3rem !important;
  }
  .pt-lg-7,
  .py-lg-7 {
    padding-top: 3rem !important;
  }
  .pr-lg-7,
  .px-lg-7 {
    padding-right: 3rem !important;
  }
  .pb-lg-7,
  .py-lg-7 {
    padding-bottom: 3rem !important;
  }
  .pl-lg-7,
  .px-lg-7 {
    padding-left: 3rem !important;
  }
  .p-lg-8 {
    padding: 3.5rem !important;
  }
  .pt-lg-8,
  .py-lg-8 {
    padding-top: 3.5rem !important;
  }
  .pr-lg-8,
  .px-lg-8 {
    padding-right: 3.5rem !important;
  }
  .pb-lg-8,
  .py-lg-8 {
    padding-bottom: 3.5rem !important;
  }
  .pl-lg-8,
  .px-lg-8 {
    padding-left: 3.5rem !important;
  }
  .p-lg-9 {
    padding: 4rem !important;
  }
  .pt-lg-9,
  .py-lg-9 {
    padding-top: 4rem !important;
  }
  .pr-lg-9,
  .px-lg-9 {
    padding-right: 4rem !important;
  }
  .pb-lg-9,
  .py-lg-9 {
    padding-bottom: 4rem !important;
  }
  .pl-lg-9,
  .px-lg-9 {
    padding-left: 4rem !important;
  }
  .p-lg-10 {
    padding: 4.5rem !important;
  }
  .pt-lg-10,
  .py-lg-10 {
    padding-top: 4.5rem !important;
  }
  .pr-lg-10,
  .px-lg-10 {
    padding-right: 4.5rem !important;
  }
  .pb-lg-10,
  .py-lg-10 {
    padding-bottom: 4.5rem !important;
  }
  .pl-lg-10,
  .px-lg-10 {
    padding-left: 4.5rem !important;
  }
  .p-lg-11 {
    padding: 5rem !important;
  }
  .pt-lg-11,
  .py-lg-11 {
    padding-top: 5rem !important;
  }
  .pr-lg-11,
  .px-lg-11 {
    padding-right: 5rem !important;
  }
  .pb-lg-11,
  .py-lg-11 {
    padding-bottom: 5rem !important;
  }
  .pl-lg-11,
  .px-lg-11 {
    padding-left: 5rem !important;
  }
  .m-lg-n1 {
    margin: -0.25rem !important;
  }
  .mt-lg-n1,
  .my-lg-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-lg-n1,
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-lg-n1,
  .my-lg-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-lg-n1,
  .mx-lg-n1 {
    margin-left: -0.25rem !important;
  }
  .m-lg-n2 {
    margin: -0.5rem !important;
  }
  .mt-lg-n2,
  .my-lg-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-lg-n2,
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-lg-n2,
  .my-lg-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-lg-n2,
  .mx-lg-n2 {
    margin-left: -0.5rem !important;
  }
  .m-lg-n3 {
    margin: -1rem !important;
  }
  .mt-lg-n3,
  .my-lg-n3 {
    margin-top: -1rem !important;
  }
  .mr-lg-n3,
  .mx-lg-n3 {
    margin-right: -1rem !important;
  }
  .mb-lg-n3,
  .my-lg-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-lg-n3,
  .mx-lg-n3 {
    margin-left: -1rem !important;
  }
  .m-lg-n4 {
    margin: -1.5rem !important;
  }
  .mt-lg-n4,
  .my-lg-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-lg-n4,
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-lg-n4,
  .my-lg-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-lg-n4,
  .mx-lg-n4 {
    margin-left: -1.5rem !important;
  }
  .m-lg-n5 {
    margin: -2rem !important;
  }
  .mt-lg-n5,
  .my-lg-n5 {
    margin-top: -2rem !important;
  }
  .mr-lg-n5,
  .mx-lg-n5 {
    margin-right: -2rem !important;
  }
  .mb-lg-n5,
  .my-lg-n5 {
    margin-bottom: -2rem !important;
  }
  .ml-lg-n5,
  .mx-lg-n5 {
    margin-left: -2rem !important;
  }
  .m-lg-n6 {
    margin: -2.5rem !important;
  }
  .mt-lg-n6,
  .my-lg-n6 {
    margin-top: -2.5rem !important;
  }
  .mr-lg-n6,
  .mx-lg-n6 {
    margin-right: -2.5rem !important;
  }
  .mb-lg-n6,
  .my-lg-n6 {
    margin-bottom: -2.5rem !important;
  }
  .ml-lg-n6,
  .mx-lg-n6 {
    margin-left: -2.5rem !important;
  }
  .m-lg-n7 {
    margin: -3rem !important;
  }
  .mt-lg-n7,
  .my-lg-n7 {
    margin-top: -3rem !important;
  }
  .mr-lg-n7,
  .mx-lg-n7 {
    margin-right: -3rem !important;
  }
  .mb-lg-n7,
  .my-lg-n7 {
    margin-bottom: -3rem !important;
  }
  .ml-lg-n7,
  .mx-lg-n7 {
    margin-left: -3rem !important;
  }
  .m-lg-n8 {
    margin: -3.5rem !important;
  }
  .mt-lg-n8,
  .my-lg-n8 {
    margin-top: -3.5rem !important;
  }
  .mr-lg-n8,
  .mx-lg-n8 {
    margin-right: -3.5rem !important;
  }
  .mb-lg-n8,
  .my-lg-n8 {
    margin-bottom: -3.5rem !important;
  }
  .ml-lg-n8,
  .mx-lg-n8 {
    margin-left: -3.5rem !important;
  }
  .m-lg-n9 {
    margin: -4rem !important;
  }
  .mt-lg-n9,
  .my-lg-n9 {
    margin-top: -4rem !important;
  }
  .mr-lg-n9,
  .mx-lg-n9 {
    margin-right: -4rem !important;
  }
  .mb-lg-n9,
  .my-lg-n9 {
    margin-bottom: -4rem !important;
  }
  .ml-lg-n9,
  .mx-lg-n9 {
    margin-left: -4rem !important;
  }
  .m-lg-n10 {
    margin: -4.5rem !important;
  }
  .mt-lg-n10,
  .my-lg-n10 {
    margin-top: -4.5rem !important;
  }
  .mr-lg-n10,
  .mx-lg-n10 {
    margin-right: -4.5rem !important;
  }
  .mb-lg-n10,
  .my-lg-n10 {
    margin-bottom: -4.5rem !important;
  }
  .ml-lg-n10,
  .mx-lg-n10 {
    margin-left: -4.5rem !important;
  }
  .m-lg-n11 {
    margin: -5rem !important;
  }
  .mt-lg-n11,
  .my-lg-n11 {
    margin-top: -5rem !important;
  }
  .mr-lg-n11,
  .mx-lg-n11 {
    margin-right: -5rem !important;
  }
  .mb-lg-n11,
  .my-lg-n11 {
    margin-bottom: -5rem !important;
  }
  .ml-lg-n11,
  .mx-lg-n11 {
    margin-left: -5rem !important;
  }
  .m-lg-auto {
    margin: auto !important;
  }
  .mt-lg-auto,
  .my-lg-auto {
    margin-top: auto !important;
  }
  .mr-lg-auto,
  .mx-lg-auto {
    margin-right: auto !important;
  }
  .mb-lg-auto,
  .my-lg-auto {
    margin-bottom: auto !important;
  }
  .ml-lg-auto,
  .mx-lg-auto {
    margin-left: auto !important;
  }
}

@media (min-width: 1200px) {
  .m-xl-0 {
    margin: 0 !important;
  }
  .mt-xl-0,
  .my-xl-0 {
    margin-top: 0 !important;
  }
  .mr-xl-0,
  .mx-xl-0 {
    margin-right: 0 !important;
  }
  .mb-xl-0,
  .my-xl-0 {
    margin-bottom: 0 !important;
  }
  .ml-xl-0,
  .mx-xl-0 {
    margin-left: 0 !important;
  }
  .m-xl-1 {
    margin: 0.25rem !important;
  }
  .mt-xl-1,
  .my-xl-1 {
    margin-top: 0.25rem !important;
  }
  .mr-xl-1,
  .mx-xl-1 {
    margin-right: 0.25rem !important;
  }
  .mb-xl-1,
  .my-xl-1 {
    margin-bottom: 0.25rem !important;
  }
  .ml-xl-1,
  .mx-xl-1 {
    margin-left: 0.25rem !important;
  }
  .m-xl-2 {
    margin: 0.5rem !important;
  }
  .mt-xl-2,
  .my-xl-2 {
    margin-top: 0.5rem !important;
  }
  .mr-xl-2,
  .mx-xl-2 {
    margin-right: 0.5rem !important;
  }
  .mb-xl-2,
  .my-xl-2 {
    margin-bottom: 0.5rem !important;
  }
  .ml-xl-2,
  .mx-xl-2 {
    margin-left: 0.5rem !important;
  }
  .m-xl-3 {
    margin: 1rem !important;
  }
  .mt-xl-3,
  .my-xl-3 {
    margin-top: 1rem !important;
  }
  .mr-xl-3,
  .mx-xl-3 {
    margin-right: 1rem !important;
  }
  .mb-xl-3,
  .my-xl-3 {
    margin-bottom: 1rem !important;
  }
  .ml-xl-3,
  .mx-xl-3 {
    margin-left: 1rem !important;
  }
  .m-xl-4 {
    margin: 1.5rem !important;
  }
  .mt-xl-4,
  .my-xl-4 {
    margin-top: 1.5rem !important;
  }
  .mr-xl-4,
  .mx-xl-4 {
    margin-right: 1.5rem !important;
  }
  .mb-xl-4,
  .my-xl-4 {
    margin-bottom: 1.5rem !important;
  }
  .ml-xl-4,
  .mx-xl-4 {
    margin-left: 1.5rem !important;
  }
  .m-xl-5 {
    margin: 2rem !important;
  }
  .mt-xl-5,
  .my-xl-5 {
    margin-top: 2rem !important;
  }
  .mr-xl-5,
  .mx-xl-5 {
    margin-right: 2rem !important;
  }
  .mb-xl-5,
  .my-xl-5 {
    margin-bottom: 2rem !important;
  }
  .ml-xl-5,
  .mx-xl-5 {
    margin-left: 2rem !important;
  }
  .m-xl-6 {
    margin: 2.5rem !important;
  }
  .mt-xl-6,
  .my-xl-6 {
    margin-top: 2.5rem !important;
  }
  .mr-xl-6,
  .mx-xl-6 {
    margin-right: 2.5rem !important;
  }
  .mb-xl-6,
  .my-xl-6 {
    margin-bottom: 2.5rem !important;
  }
  .ml-xl-6,
  .mx-xl-6 {
    margin-left: 2.5rem !important;
  }
  .m-xl-7 {
    margin: 3rem !important;
  }
  .mt-xl-7,
  .my-xl-7 {
    margin-top: 3rem !important;
  }
  .mr-xl-7,
  .mx-xl-7 {
    margin-right: 3rem !important;
  }
  .mb-xl-7,
  .my-xl-7 {
    margin-bottom: 3rem !important;
  }
  .ml-xl-7,
  .mx-xl-7 {
    margin-left: 3rem !important;
  }
  .m-xl-8 {
    margin: 3.5rem !important;
  }
  .mt-xl-8,
  .my-xl-8 {
    margin-top: 3.5rem !important;
  }
  .mr-xl-8,
  .mx-xl-8 {
    margin-right: 3.5rem !important;
  }
  .mb-xl-8,
  .my-xl-8 {
    margin-bottom: 3.5rem !important;
  }
  .ml-xl-8,
  .mx-xl-8 {
    margin-left: 3.5rem !important;
  }
  .m-xl-9 {
    margin: 4rem !important;
  }
  .mt-xl-9,
  .my-xl-9 {
    margin-top: 4rem !important;
  }
  .mr-xl-9,
  .mx-xl-9 {
    margin-right: 4rem !important;
  }
  .mb-xl-9,
  .my-xl-9 {
    margin-bottom: 4rem !important;
  }
  .ml-xl-9,
  .mx-xl-9 {
    margin-left: 4rem !important;
  }
  .m-xl-10 {
    margin: 4.5rem !important;
  }
  .mt-xl-10,
  .my-xl-10 {
    margin-top: 4.5rem !important;
  }
  .mr-xl-10,
  .mx-xl-10 {
    margin-right: 4.5rem !important;
  }
  .mb-xl-10,
  .my-xl-10 {
    margin-bottom: 4.5rem !important;
  }
  .ml-xl-10,
  .mx-xl-10 {
    margin-left: 4.5rem !important;
  }
  .m-xl-11 {
    margin: 5rem !important;
  }
  .mt-xl-11,
  .my-xl-11 {
    margin-top: 5rem !important;
  }
  .mr-xl-11,
  .mx-xl-11 {
    margin-right: 5rem !important;
  }
  .mb-xl-11,
  .my-xl-11 {
    margin-bottom: 5rem !important;
  }
  .ml-xl-11,
  .mx-xl-11 {
    margin-left: 5rem !important;
  }
  .p-xl-0 {
    padding: 0 !important;
  }
  .pt-xl-0,
  .py-xl-0 {
    padding-top: 0 !important;
  }
  .pr-xl-0,
  .px-xl-0 {
    padding-right: 0 !important;
  }
  .pb-xl-0,
  .py-xl-0 {
    padding-bottom: 0 !important;
  }
  .pl-xl-0,
  .px-xl-0 {
    padding-left: 0 !important;
  }
  .p-xl-1 {
    padding: 0.25rem !important;
  }
  .pt-xl-1,
  .py-xl-1 {
    padding-top: 0.25rem !important;
  }
  .pr-xl-1,
  .px-xl-1 {
    padding-right: 0.25rem !important;
  }
  .pb-xl-1,
  .py-xl-1 {
    padding-bottom: 0.25rem !important;
  }
  .pl-xl-1,
  .px-xl-1 {
    padding-left: 0.25rem !important;
  }
  .p-xl-2 {
    padding: 0.5rem !important;
  }
  .pt-xl-2,
  .py-xl-2 {
    padding-top: 0.5rem !important;
  }
  .pr-xl-2,
  .px-xl-2 {
    padding-right: 0.5rem !important;
  }
  .pb-xl-2,
  .py-xl-2 {
    padding-bottom: 0.5rem !important;
  }
  .pl-xl-2,
  .px-xl-2 {
    padding-left: 0.5rem !important;
  }
  .p-xl-3 {
    padding: 1rem !important;
  }
  .pt-xl-3,
  .py-xl-3 {
    padding-top: 1rem !important;
  }
  .pr-xl-3,
  .px-xl-3 {
    padding-right: 1rem !important;
  }
  .pb-xl-3,
  .py-xl-3 {
    padding-bottom: 1rem !important;
  }
  .pl-xl-3,
  .px-xl-3 {
    padding-left: 1rem !important;
  }
  .p-xl-4 {
    padding: 1.5rem !important;
  }
  .pt-xl-4,
  .py-xl-4 {
    padding-top: 1.5rem !important;
  }
  .pr-xl-4,
  .px-xl-4 {
    padding-right: 1.5rem !important;
  }
  .pb-xl-4,
  .py-xl-4 {
    padding-bottom: 1.5rem !important;
  }
  .pl-xl-4,
  .px-xl-4 {
    padding-left: 1.5rem !important;
  }
  .p-xl-5 {
    padding: 2rem !important;
  }
  .pt-xl-5,
  .py-xl-5 {
    padding-top: 2rem !important;
  }
  .pr-xl-5,
  .px-xl-5 {
    padding-right: 2rem !important;
  }
  .pb-xl-5,
  .py-xl-5 {
    padding-bottom: 2rem !important;
  }
  .pl-xl-5,
  .px-xl-5 {
    padding-left: 2rem !important;
  }
  .p-xl-6 {
    padding: 2.5rem !important;
  }
  .pt-xl-6,
  .py-xl-6 {
    padding-top: 2.5rem !important;
  }
  .pr-xl-6,
  .px-xl-6 {
    padding-right: 2.5rem !important;
  }
  .pb-xl-6,
  .py-xl-6 {
    padding-bottom: 2.5rem !important;
  }
  .pl-xl-6,
  .px-xl-6 {
    padding-left: 2.5rem !important;
  }
  .p-xl-7 {
    padding: 3rem !important;
  }
  .pt-xl-7,
  .py-xl-7 {
    padding-top: 3rem !important;
  }
  .pr-xl-7,
  .px-xl-7 {
    padding-right: 3rem !important;
  }
  .pb-xl-7,
  .py-xl-7 {
    padding-bottom: 3rem !important;
  }
  .pl-xl-7,
  .px-xl-7 {
    padding-left: 3rem !important;
  }
  .p-xl-8 {
    padding: 3.5rem !important;
  }
  .pt-xl-8,
  .py-xl-8 {
    padding-top: 3.5rem !important;
  }
  .pr-xl-8,
  .px-xl-8 {
    padding-right: 3.5rem !important;
  }
  .pb-xl-8,
  .py-xl-8 {
    padding-bottom: 3.5rem !important;
  }
  .pl-xl-8,
  .px-xl-8 {
    padding-left: 3.5rem !important;
  }
  .p-xl-9 {
    padding: 4rem !important;
  }
  .pt-xl-9,
  .py-xl-9 {
    padding-top: 4rem !important;
  }
  .pr-xl-9,
  .px-xl-9 {
    padding-right: 4rem !important;
  }
  .pb-xl-9,
  .py-xl-9 {
    padding-bottom: 4rem !important;
  }
  .pl-xl-9,
  .px-xl-9 {
    padding-left: 4rem !important;
  }
  .p-xl-10 {
    padding: 4.5rem !important;
  }
  .pt-xl-10,
  .py-xl-10 {
    padding-top: 4.5rem !important;
  }
  .pr-xl-10,
  .px-xl-10 {
    padding-right: 4.5rem !important;
  }
  .pb-xl-10,
  .py-xl-10 {
    padding-bottom: 4.5rem !important;
  }
  .pl-xl-10,
  .px-xl-10 {
    padding-left: 4.5rem !important;
  }
  .p-xl-11 {
    padding: 5rem !important;
  }
  .pt-xl-11,
  .py-xl-11 {
    padding-top: 5rem !important;
  }
  .pr-xl-11,
  .px-xl-11 {
    padding-right: 5rem !important;
  }
  .pb-xl-11,
  .py-xl-11 {
    padding-bottom: 5rem !important;
  }
  .pl-xl-11,
  .px-xl-11 {
    padding-left: 5rem !important;
  }
  .m-xl-n1 {
    margin: -0.25rem !important;
  }
  .mt-xl-n1,
  .my-xl-n1 {
    margin-top: -0.25rem !important;
  }
  .mr-xl-n1,
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
  }
  .mb-xl-n1,
  .my-xl-n1 {
    margin-bottom: -0.25rem !important;
  }
  .ml-xl-n1,
  .mx-xl-n1 {
    margin-left: -0.25rem !important;
  }
  .m-xl-n2 {
    margin: -0.5rem !important;
  }
  .mt-xl-n2,
  .my-xl-n2 {
    margin-top: -0.5rem !important;
  }
  .mr-xl-n2,
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
  }
  .mb-xl-n2,
  .my-xl-n2 {
    margin-bottom: -0.5rem !important;
  }
  .ml-xl-n2,
  .mx-xl-n2 {
    margin-left: -0.5rem !important;
  }
  .m-xl-n3 {
    margin: -1rem !important;
  }
  .mt-xl-n3,
  .my-xl-n3 {
    margin-top: -1rem !important;
  }
  .mr-xl-n3,
  .mx-xl-n3 {
    margin-right: -1rem !important;
  }
  .mb-xl-n3,
  .my-xl-n3 {
    margin-bottom: -1rem !important;
  }
  .ml-xl-n3,
  .mx-xl-n3 {
    margin-left: -1rem !important;
  }
  .m-xl-n4 {
    margin: -1.5rem !important;
  }
  .mt-xl-n4,
  .my-xl-n4 {
    margin-top: -1.5rem !important;
  }
  .mr-xl-n4,
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
  }
  .mb-xl-n4,
  .my-xl-n4 {
    margin-bottom: -1.5rem !important;
  }
  .ml-xl-n4,
  .mx-xl-n4 {
    margin-left: -1.5rem !important;
  }
  .m-xl-n5 {
    margin: -2rem !important;
  }
  .mt-xl-n5,
  .my-xl-n5 {
    margin-top: -2rem !important;
  }
  .mr-xl-n5,
  .mx-xl-n5 {
    margin-right: -2rem !important;
  }
  .mb-xl-n5,
  .my-xl-n5 {
    margin-bottom: -2rem !important;
  }
  .ml-xl-n5,
  .mx-xl-n5 {
    margin-left: -2rem !important;
  }
  .m-xl-n6 {
    margin: -2.5rem !important;
  }
  .mt-xl-n6,
  .my-xl-n6 {
    margin-top: -2.5rem !important;
  }
  .mr-xl-n6,
  .mx-xl-n6 {
    margin-right: -2.5rem !important;
  }
  .mb-xl-n6,
  .my-xl-n6 {
    margin-bottom: -2.5rem !important;
  }
  .ml-xl-n6,
  .mx-xl-n6 {
    margin-left: -2.5rem !important;
  }
  .m-xl-n7 {
    margin: -3rem !important;
  }
  .mt-xl-n7,
  .my-xl-n7 {
    margin-top: -3rem !important;
  }
  .mr-xl-n7,
  .mx-xl-n7 {
    margin-right: -3rem !important;
  }
  .mb-xl-n7,
  .my-xl-n7 {
    margin-bottom: -3rem !important;
  }
  .ml-xl-n7,
  .mx-xl-n7 {
    margin-left: -3rem !important;
  }
  .m-xl-n8 {
    margin: -3.5rem !important;
  }
  .mt-xl-n8,
  .my-xl-n8 {
    margin-top: -3.5rem !important;
  }
  .mr-xl-n8,
  .mx-xl-n8 {
    margin-right: -3.5rem !important;
  }
  .mb-xl-n8,
  .my-xl-n8 {
    margin-bottom: -3.5rem !important;
  }
  .ml-xl-n8,
  .mx-xl-n8 {
    margin-left: -3.5rem !important;
  }
  .m-xl-n9 {
    margin: -4rem !important;
  }
  .mt-xl-n9,
  .my-xl-n9 {
    margin-top: -4rem !important;
  }
  .mr-xl-n9,
  .mx-xl-n9 {
    margin-right: -4rem !important;
  }
  .mb-xl-n9,
  .my-xl-n9 {
    margin-bottom: -4rem !important;
  }
  .ml-xl-n9,
  .mx-xl-n9 {
    margin-left: -4rem !important;
  }
  .m-xl-n10 {
    margin: -4.5rem !important;
  }
  .mt-xl-n10,
  .my-xl-n10 {
    margin-top: -4.5rem !important;
  }
  .mr-xl-n10,
  .mx-xl-n10 {
    margin-right: -4.5rem !important;
  }
  .mb-xl-n10,
  .my-xl-n10 {
    margin-bottom: -4.5rem !important;
  }
  .ml-xl-n10,
  .mx-xl-n10 {
    margin-left: -4.5rem !important;
  }
  .m-xl-n11 {
    margin: -5rem !important;
  }
  .mt-xl-n11,
  .my-xl-n11 {
    margin-top: -5rem !important;
  }
  .mr-xl-n11,
  .mx-xl-n11 {
    margin-right: -5rem !important;
  }
  .mb-xl-n11,
  .my-xl-n11 {
    margin-bottom: -5rem !important;
  }
  .ml-xl-n11,
  .mx-xl-n11 {
    margin-left: -5rem !important;
  }
  .m-xl-auto {
    margin: auto !important;
  }
  .mt-xl-auto,
  .my-xl-auto {
    margin-top: auto !important;
  }
  .mr-xl-auto,
  .mx-xl-auto {
    margin-right: auto !important;
  }
  .mb-xl-auto,
  .my-xl-auto {
    margin-bottom: auto !important;
  }
  .ml-xl-auto,
  .mx-xl-auto {
    margin-left: auto !important;
  }
}

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  pointer-events: auto;
  content: "";
  background-color: rgba(0, 0, 0, 0);
}

.text-monospace {
  font-family: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}

.text-justify {
  text-align: justify !important;
}

.text-wrap {
  white-space: normal !important;
}

.text-nowrap {
  white-space: nowrap !important;
}

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.text-left {
  text-align: left !important;
}

.text-right {
  text-align: right !important;
}

.text-center {
  text-align: center !important;
}

@media (min-width: 576px) {
  .text-sm-left {
    text-align: left !important;
  }
  .text-sm-right {
    text-align: right !important;
  }
  .text-sm-center {
    text-align: center !important;
  }
}

@media (min-width: 768px) {
  .text-md-left {
    text-align: left !important;
  }
  .text-md-right {
    text-align: right !important;
  }
  .text-md-center {
    text-align: center !important;
  }
}

@media (min-width: 992px) {
  .text-lg-left {
    text-align: left !important;
  }
  .text-lg-right {
    text-align: right !important;
  }
  .text-lg-center {
    text-align: center !important;
  }
}

@media (min-width: 1200px) {
  .text-xl-left {
    text-align: left !important;
  }
  .text-xl-right {
    text-align: right !important;
  }
  .text-xl-center {
    text-align: center !important;
  }
}

.text-lowercase {
  text-transform: lowercase !important;
}

.text-uppercase {
  text-transform: uppercase !important;
}

.text-capitalize {
  text-transform: capitalize !important;
}

.font-weight-light {
  font-weight: 300 !important;
}

.font-weight-lighter {
  font-weight: lighter !important;
}

.font-weight-normal {
  font-weight: 400 !important;
}

.font-weight-bold {
  font-weight: 600 !important;
}

.font-weight-bolder {
  font-weight: bolder !important;
}

.font-italic {
  font-style: italic !important;
}

.text-white {
  color: #fff !important;
}

.text-primary {
  color: #377dff !important;
}

a.text-primary:hover, a.text-primary:focus {
  color: #0052ea !important;
}

.text-secondary {
  color: #71869d !important;
}

a.text-secondary:hover, a.text-secondary:focus {
  color: #4f6072 !important;
}

.text-success {
  color: #00c9a7 !important;
}

a.text-success:hover, a.text-success:focus {
  color: #007d67 !important;
}

.text-info {
  color: #09a5be !important;
}

a.text-info:hover, a.text-info:focus {
  color: #066675 !important;
}

.text-warning {
  color: #f5ca99 !important;
}

a.text-warning:hover, a.text-warning:focus {
  color: #eea653 !important;
}

.text-danger {
  color: #ed4c78 !important;
}

a.text-danger:hover, a.text-danger:focus {
  color: #d7164a !important;
}

.text-light {
  color: #f7faff !important;
}

a.text-light:hover, a.text-light:focus {
  color: #abcaff !important;
}

.text-dark {
  color: #21325b !important;
}

a.text-dark:hover, a.text-dark:focus {
  color: #0d1323 !important;
}

.text-indigo {
  color: #2d1582 !important;
}

a.text-indigo:hover, a.text-indigo:focus {
  color: #160a40 !important;
}

.text-body {
  color: #677788 !important;
}

.text-muted {
  color: #8c98a4 !important;
}

.text-black-50 {
  color: rgba(0, 0, 0, 0.5) !important;
}

.text-white-50 {
  color: rgba(255, 255, 255, 0.5) !important;
}

.text-hide {
  font: 0/0 a;
  color: transparent;
  text-shadow: none;
  background-color: transparent;
  border: 0;
}

.text-decoration-none {
  text-decoration: none !important;
}

.text-break {
  word-break: break-word !important;
  word-wrap: break-word !important;
}

.text-reset {
  color: inherit !important;
}

.visible {
  visibility: visible !important;
}

.invisible {
  visibility: hidden !important;
}

@media print {
  *,
  *::before,
  *::after {
    text-shadow: none !important;
    box-shadow: none !important;
  }
  a:not(.btn) {
    text-decoration: underline;
  }
  abbr[title]::after {
    content: " (" attr(title) ")";
  }
  pre {
    white-space: pre-wrap !important;
  }
  pre,
  blockquote {
    border: 0.0625rem solid #97a4af;
    page-break-inside: avoid;
  }
  thead {
    display: table-header-group;
  }
  tr,
  img {
    page-break-inside: avoid;
  }
  p,
  h2,
  h3 {
    orphans: 3;
    widows: 3;
  }
  h2,
  h3 {
    page-break-after: avoid;
  }
  @page {
    size: a3;
  }
  body {
    min-width: 992px !important;
  }
  .container {
    min-width: 992px !important;
  }
  .navbar {
    display: none;
  }
  .badge {
    border: 0.0625rem solid #000;
  }
  .table {
    border-collapse: collapse !important;
  }
  .table td,
  .table th {
    background-color: #fff !important;
  }
  .table-bordered th,
  .table-bordered td {
    border: 1px solid #e7eaf3 !important;
  }
  .table-dark {
    color: inherit;
  }
  .table-dark th,
  .table-dark td,
  .table-dark thead th,
  .table-dark tbody + tbody {
    border-color: #e7eaf3;
  }
  .table .thead-dark th {
    color: inherit;
    border-color: #e7eaf3;
  }
}

/*----------------------------------------------------------------------
  * Front - Responsive Website Template version v3.3.0
  * Copyright 2018 Htmlstream
  * Licensed under Bootstrap Themes (https://themes.getbootstrap.com/licenses/)
------------------------------------------------------------------------*/
.w-25 {
  width: 25% !important;
}

.w-50 {
  width: 50% !important;
}

.w-75 {
  width: 75% !important;
}

.w-100 {
  width: 100% !important;
}

.w-auto {
  width: auto !important;
}

.w-15 {
  width: 15% !important;
}

.w-20 {
  width: 20% !important;
}

.w-30 {
  width: 30% !important;
}

.w-35 {
  width: 35% !important;
}

.w-40 {
  width: 40% !important;
}

.w-60 {
  width: 60% !important;
}

.w-65 {
  width: 65% !important;
}

.w-80 {
  width: 80% !important;
}

.w-85 {
  width: 85% !important;
}

.w-90 {
  width: 90% !important;
}

@media (min-width: 576px) {
  .w-sm-25 {
    width: 25% !important;
  }
  .w-sm-50 {
    width: 50% !important;
  }
  .w-sm-75 {
    width: 75% !important;
  }
  .w-sm-100 {
    width: 100% !important;
  }
  .w-sm-auto {
    width: auto !important;
  }
  .w-sm-15 {
    width: 15% !important;
  }
  .w-sm-20 {
    width: 20% !important;
  }
  .w-sm-30 {
    width: 30% !important;
  }
  .w-sm-35 {
    width: 35% !important;
  }
  .w-sm-40 {
    width: 40% !important;
  }
  .w-sm-60 {
    width: 60% !important;
  }
  .w-sm-65 {
    width: 65% !important;
  }
  .w-sm-80 {
    width: 80% !important;
  }
  .w-sm-85 {
    width: 85% !important;
  }
  .w-sm-90 {
    width: 90% !important;
  }
}

@media (min-width: 768px) {
  .w-md-25 {
    width: 25% !important;
  }
  .w-md-50 {
    width: 50% !important;
  }
  .w-md-75 {
    width: 75% !important;
  }
  .w-md-100 {
    width: 100% !important;
  }
  .w-md-auto {
    width: auto !important;
  }
  .w-md-15 {
    width: 15% !important;
  }
  .w-md-20 {
    width: 20% !important;
  }
  .w-md-30 {
    width: 30% !important;
  }
  .w-md-35 {
    width: 35% !important;
  }
  .w-md-40 {
    width: 40% !important;
  }
  .w-md-60 {
    width: 60% !important;
  }
  .w-md-65 {
    width: 65% !important;
  }
  .w-md-80 {
    width: 80% !important;
  }
  .w-md-85 {
    width: 85% !important;
  }
  .w-md-90 {
    width: 90% !important;
  }
}

@media (min-width: 992px) {
  .w-lg-25 {
    width: 25% !important;
  }
  .w-lg-50 {
    width: 50% !important;
  }
  .w-lg-75 {
    width: 75% !important;
  }
  .w-lg-100 {
    width: 100% !important;
  }
  .w-lg-auto {
    width: auto !important;
  }
  .w-lg-15 {
    width: 15% !important;
  }
  .w-lg-20 {
    width: 20% !important;
  }
  .w-lg-30 {
    width: 30% !important;
  }
  .w-lg-35 {
    width: 35% !important;
  }
  .w-lg-40 {
    width: 40% !important;
  }
  .w-lg-60 {
    width: 60% !important;
  }
  .w-lg-65 {
    width: 65% !important;
  }
  .w-lg-80 {
    width: 80% !important;
  }
  .w-lg-85 {
    width: 85% !important;
  }
  .w-lg-90 {
    width: 90% !important;
  }
}

@media (min-width: 1200px) {
  .w-xl-25 {
    width: 25% !important;
  }
  .w-xl-50 {
    width: 50% !important;
  }
  .w-xl-75 {
    width: 75% !important;
  }
  .w-xl-100 {
    width: 100% !important;
  }
  .w-xl-auto {
    width: auto !important;
  }
  .w-xl-15 {
    width: 15% !important;
  }
  .w-xl-20 {
    width: 20% !important;
  }
  .w-xl-30 {
    width: 30% !important;
  }
  .w-xl-35 {
    width: 35% !important;
  }
  .w-xl-40 {
    width: 40% !important;
  }
  .w-xl-60 {
    width: 60% !important;
  }
  .w-xl-65 {
    width: 65% !important;
  }
  .w-xl-80 {
    width: 80% !important;
  }
  .w-xl-85 {
    width: 85% !important;
  }
  .w-xl-90 {
    width: 90% !important;
  }
}

.space-0,
.space-top-0 {
  padding-top: 0 !important;
}

.space-0,
.space-bottom-0 {
  padding-bottom: 0 !important;
}

.space-1,
.space-top-1 {
  padding-top: 2rem !important;
}

.space-1,
.space-bottom-1 {
  padding-bottom: 2rem !important;
}

.space-2,
.space-top-2 {
  padding-top: 4rem !important;
}

.space-2,
.space-bottom-2 {
  padding-bottom: 4rem !important;
}

.space-3,
.space-top-3 {
  padding-top: 8rem !important;
}

.space-3,
.space-bottom-3 {
  padding-bottom: 8rem !important;
}

.space-4,
.space-top-4 {
  padding-top: 12.5rem !important;
}

.space-4,
.space-bottom-4 {
  padding-bottom: 12.5rem !important;
}

.space-5,
.space-top-5 {
  padding-top: 15rem !important;
}

.space-5,
.space-bottom-5 {
  padding-bottom: 15rem !important;
}

@media (min-width: 576px) {
  .space-sm-0,
  .space-top-sm-0 {
    padding-top: 0 !important;
  }
  .space-sm-0,
  .space-bottom-sm-0 {
    padding-bottom: 0 !important;
  }
  .space-sm-1,
  .space-top-sm-1 {
    padding-top: 2rem !important;
  }
  .space-sm-1,
  .space-bottom-sm-1 {
    padding-bottom: 2rem !important;
  }
  .space-sm-2,
  .space-top-sm-2 {
    padding-top: 4rem !important;
  }
  .space-sm-2,
  .space-bottom-sm-2 {
    padding-bottom: 4rem !important;
  }
  .space-sm-3,
  .space-top-sm-3 {
    padding-top: 8rem !important;
  }
  .space-sm-3,
  .space-bottom-sm-3 {
    padding-bottom: 8rem !important;
  }
  .space-sm-4,
  .space-top-sm-4 {
    padding-top: 12.5rem !important;
  }
  .space-sm-4,
  .space-bottom-sm-4 {
    padding-bottom: 12.5rem !important;
  }
  .space-sm-5,
  .space-top-sm-5 {
    padding-top: 15rem !important;
  }
  .space-sm-5,
  .space-bottom-sm-5 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 768px) {
  .space-md-0,
  .space-top-md-0 {
    padding-top: 0 !important;
  }
  .space-md-0,
  .space-bottom-md-0 {
    padding-bottom: 0 !important;
  }
  .space-md-1,
  .space-top-md-1 {
    padding-top: 2rem !important;
  }
  .space-md-1,
  .space-bottom-md-1 {
    padding-bottom: 2rem !important;
  }
  .space-md-2,
  .space-top-md-2 {
    padding-top: 4rem !important;
  }
  .space-md-2,
  .space-bottom-md-2 {
    padding-bottom: 4rem !important;
  }
  .space-md-3,
  .space-top-md-3 {
    padding-top: 8rem !important;
  }
  .space-md-3,
  .space-bottom-md-3 {
    padding-bottom: 8rem !important;
  }
  .space-md-4,
  .space-top-md-4 {
    padding-top: 12.5rem !important;
  }
  .space-md-4,
  .space-bottom-md-4 {
    padding-bottom: 12.5rem !important;
  }
  .space-md-5,
  .space-top-md-5 {
    padding-top: 15rem !important;
  }
  .space-md-5,
  .space-bottom-md-5 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 992px) {
  .space-lg-0,
  .space-top-lg-0 {
    padding-top: 0 !important;
  }
  .space-lg-0,
  .space-bottom-lg-0 {
    padding-bottom: 0 !important;
  }
  .space-lg-1,
  .space-top-lg-1 {
    padding-top: 2rem !important;
  }
  .space-lg-1,
  .space-bottom-lg-1 {
    padding-bottom: 2rem !important;
  }
  .space-lg-2,
  .space-top-lg-2 {
    padding-top: 4rem !important;
  }
  .space-lg-2,
  .space-bottom-lg-2 {
    padding-bottom: 4rem !important;
  }
  .space-lg-3,
  .space-top-lg-3 {
    padding-top: 8rem !important;
  }
  .space-lg-3,
  .space-bottom-lg-3 {
    padding-bottom: 8rem !important;
  }
  .space-lg-4,
  .space-top-lg-4 {
    padding-top: 12.5rem !important;
  }
  .space-lg-4,
  .space-bottom-lg-4 {
    padding-bottom: 12.5rem !important;
  }
  .space-lg-5,
  .space-top-lg-5 {
    padding-top: 15rem !important;
  }
  .space-lg-5,
  .space-bottom-lg-5 {
    padding-bottom: 15rem !important;
  }
}

@media (min-width: 1200px) {
  .space-xl-0,
  .space-top-xl-0 {
    padding-top: 0 !important;
  }
  .space-xl-0,
  .space-bottom-xl-0 {
    padding-bottom: 0 !important;
  }
  .space-xl-1,
  .space-top-xl-1 {
    padding-top: 2rem !important;
  }
  .space-xl-1,
  .space-bottom-xl-1 {
    padding-bottom: 2rem !important;
  }
  .space-xl-2,
  .space-top-xl-2 {
    padding-top: 4rem !important;
  }
  .space-xl-2,
  .space-bottom-xl-2 {
    padding-bottom: 4rem !important;
  }
  .space-xl-3,
  .space-top-xl-3 {
    padding-top: 8rem !important;
  }
  .space-xl-3,
  .space-bottom-xl-3 {
    padding-bottom: 8rem !important;
  }
  .space-xl-4,
  .space-top-xl-4 {
    padding-top: 12.5rem !important;
  }
  .space-xl-4,
  .space-bottom-xl-4 {
    padding-bottom: 12.5rem !important;
  }
  .space-xl-5,
  .space-top-xl-5 {
    padding-top: 15rem !important;
  }
  .space-xl-5,
  .space-bottom-xl-5 {
    padding-bottom: 15rem !important;
  }
}

/*------------------------------------
  Default Styles
------------------------------------*/
main {
  position: relative;
}

h1, h2, h3, h4, h5, h6,
.h1, .h2, .h3, .h4, .h5, .h6 {
  color: #1e2022;
}

figure {
  margin-bottom: 0;
}

svg {
  margin-bottom: -8px;
  vertical-align: baseline;
}

sup {
  right: -.5rem;
}

/*------------------------------------
  Highlight Color
------------------------------------*/

::selection {
  color: #fff;
  background-color: #377dff;
}

.bg-primary ::selection {
  color: #377dff;
  background-color: #fff;
}

/*------------------------------------
  Accessibility
------------------------------------*/
:focus,
a:focus,
button:focus {
  outline: 0;
}

.form-control:focus {
  box-shadow: 0 0 0 0 transparent;
}

.btn:focus, .btn.focus, .btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus, .btn:not([disabled]):not(.disabled):active, .btn:not([disabled]):not(.disabled).active {
  box-shadow: 0 0 0 0 transparent;
}

.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus,
.show > .btn.dropdown-toggle:focus {
  box-shadow: 0 0 0 0 transparent;
}

.custom-select:focus,
.page-link:focus {
  box-shadow: 0 0 0 0 transparent;
}

.custom-control-input:checked ~ .custom-control-label::before,
.custom-control-input:focus ~ .custom-control-label::before,
.custom-control-input:active ~ .custom-control-label::before {
  box-shadow: 0 0 0 0 transparent;
}

.custom-file-input:focus ~ .custom-file-label {
  box-shadow: 0 0 0 0 transparent;
}

.bootstrap-select .dropdown-toggle:focus {
  outline: 0 !important;
}

/*------------------------------------
  Print styles
------------------------------------*/
@media print {
  header, footer, .btn {
    display: none;
  }
}

/*------------------------------------
  Skippy
------------------------------------*/
.skippy {
  display: none;
}

/*------------------------------------
  List Article
------------------------------------*/
.list-article > li:not(:last-child) {
  padding-bottom: 1rem;
}

.list-article .list-article > li:first-child {
  padding-top: 1rem;
}

.list-article .list-article > li:last-child {
  padding-bottom: 0;
}

.list-sm-article > li:not(:last-child) {
  padding-bottom: 0.5rem;
}

.list-sm-article .list-sm-article > li:first-child {
  padding-top: 0.5rem;
}

.list-sm-article .list-sm-article > li:last-child {
  padding-bottom: 0;
}

.list-lg-article > li:not(:last-child) {
  padding-bottom: 2rem;
}

.list-lg-article .list-lg-article > li:first-child {
  padding-top: 2rem;
}

.list-lg-article .list-lg-article > li:last-child {
  padding-bottom: 0;
}

/*------------------------------------
  List Group
------------------------------------*/
.list-group-item:first-child {
  border-top-left-radius: 0.3125rem;
  border-top-right-radius: 0.3125rem;
}

.list-group-item:last-child {
  border-bottom-right-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
}

.list-group-icon {
  width: 1.25rem;
  text-align: center;
  margin-right: 0.25rem;
}

.list-group-no-gutters .list-group-item {
  padding-right: 0;
  padding-left: 0;
}

.list-group-item-light {
  background-color: #f7faff;
}

/* Sizes */
.list-group-lg .list-group-icon {
  font-size: 1.25rem;
  width: 2.5rem;
  margin-right: 0.5rem;
}

/*------------------------------------
  List Separator
------------------------------------*/
.list-separator {
  margin-bottom: 0;
}

.list-separator .list-inline-item {
  position: relative;
  margin-left: 0;
  margin-right: -0.25rem;
}

.list-separator .list-inline-item:not(:last-child) {
  padding-right: 2rem;
}

.list-separator .list-inline-item:not(:last-child)::after {
  position: absolute;
  top: calc(50% - 0.15625rem);
  right: 0.84375rem;
  width: 0.3125rem;
  height: 0.3125rem;
  background-color: #bdc5d1;
  border-radius: 0.3125rem;
  content: "";
}

.list-separator .list-separator-link {
  color: #677788;
}

.list-separator .list-separator-link:hover {
  color: #0052ea;
}

/*------------------------------------
  Links
------------------------------------*/
.link {
  font-size: 0.875rem;
  display: inline-flex;
}

.link-icon {
  position: relative;
  line-height: 1;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  text-align: center;
  width: 1.375rem;
  height: 1.375rem;
  font-size: 1rem;
  color: #377dff;
  background-color: rgba(55, 125, 255, 0.1);
  border-radius: 50%;
  transition: 0.3s;
}

.link:hover .link-icon {
  transform: rotate(90deg);
}

/* Collapse */
.link-collapse[aria-expanded="false"] .link-collapse-default {
  display: inline-block;
}

.link-collapse[aria-expanded="false"] .link-collapse-active {
  display: none;
}

.link-collapse[aria-expanded="true"] .link-collapse-default {
  display: none;
}

.link-collapse[aria-expanded="true"] .link-collapse-active {
  display: inline-block;
}

/* Link Underline */
.link-underline {
  color: #8c98a4;
  border-bottom: 0.0625rem dashed #97a4af;
}

.link-underline:hover {
  border-color: #0052ea;
}

.link-underline-toggle-default {
  display: inline-block;
}

.link-underline-toggle-toggled {
  display: none;
}

.link-underline.toggled .link-underline-toggle-default {
  display: none;
}

.link-underline.toggled .link-underline-toggle-toggled {
  display: inline-block;
}

/* Link Underline Light */
.link-underline-light {
  color: rgba(255, 255, 255, 0.7);
  border-bottom: 0.0625rem dashed rgba(255, 255, 255, 0.7);
}

.link-underline-light:hover {
  color: #fff;
  border-color: rgba(255, 255, 255, 0.7);
}

/*------------------------------------
  Header Default
------------------------------------*/
.header {
  position: relative;
  right: 0;
  left: 0;
  width: 100%;
  z-index: 1001;
}

.header-section {
  position: relative;
  z-index: 1;
  background-color: #fff;
}

.header-section-divider {
  border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.2);
}

.header-box-shadow .header-section {
  box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);
}

.header-box-shadow-on-scroll.scrolled .header-section {
  box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);
}

/* Navbar Brand */
.navbar-brand,
.navbar-brand > img {
  width: 7.5rem;
}

/* Navbar Toggler */
.navbar-toggler {
  background-color: #f8fafd;
}

.navbar-toggler .navbar-toggler-default {
  display: flex;
}

.navbar-toggler .navbar-toggler-toggled {
  display: none;
}

.navbar-toggler[aria-expanded="true"] .navbar-toggler-default {
  display: none;
}

.navbar-toggler[aria-expanded="true"] .navbar-toggler-toggled {
  display: flex;
}

/* Nav Item */
.header .navbar-nav-item:first-child .nav-link {
  padding-left: 0;
}

.navbar-nav-item:hover .nav-link, .navbar-nav-item:focus .nav-link {
  color: #377dff;
}

/* Nav Link */
.header .navbar-nav-item.active .nav-link,
.header .nav-link.active {
  color: #377dff;
}

.header .nav-link {
  color: #677788;
}

.header .nav-link-toggle {
  display: flex;
  align-items: center;
}

.header .nav-link-toggle::after {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat right center/1rem 1rem;
  content: "";
  margin-left: 0.5rem;
  transition: 0.3s ease;
}

/* Dropdown */
.header .navbar-nav .dropdown-menu {
  margin-top: -0.125rem;
}

.header .navbar-nav .dropdown-menu.hs-mega-menu {
  padding-top: 0;
  padding-bottom: 0;
}

.header .navbar-nav .dropdown-item {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.header .dropdown-item-toggle {
  display: flex;
  align-items: center;
}

.header .dropdown-item-toggle::after {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) no-repeat right center/1rem 1rem;
  content: "";
  margin-left: auto;
  transition: 0.3s ease;
}

.header .hs-mega-menu .dropdown-item {
  padding-right: 0;
  padding-left: 0;
}

[class*="navbar-expand"] .dropdown-item {
  background-color: transparent;
}

[class*="navbar-expand"] .dropdown-item.active:not(:focus):not(:active), [class*="navbar-expand"] .dropdown-item:hover {
  color: #377dff;
  background-color: transparent;
}

/* Promo */
.navbar-promo {
  background-color: #f8fafd;
}

.navbar-promo-inner {
  color: inherit;
  padding: 2rem 2rem;
}

.navbar-promo-item {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
}

.navbar-promo-item ~ .navbar-promo-item {
  border-top: 0.0625rem solid #e7eaf3;
}

.navbar-promo-link {
  display: block;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  margin-top: 0.75rem;
  margin-bottom: 0.75rem;
}

.navbar-promo-link.disabled {
  opacity: .7;
  pointer-events: none;
}

.navbar-promo-link:hover .navbar-promo-title {
  color: #377dff;
}

.navbar-promo-card {
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-clip: border-box;
}

.navbar-promo-card-deck {
  display: block;
}

.navbar-promo-card-deck:not(:last-child) .navbar-promo-item {
  border-bottom: 0.0625rem solid #e7eaf3;
}

.navbar-promo-card-deck .navbar-promo-item {
  border-top: none;
}

.navbar-promo-card-body {
  flex: 1 1 auto;
}

.navbar-promo-icon {
  width: 100%;
  max-width: 2.75rem;
  margin-right: 1rem;
}

.navbar-promo-title {
  display: block;
  color: #1e2022;
  font-size: 1rem;
  font-weight: 600;
}

.navbar-promo-text {
  display: block;
  font-size: 0.875rem;
  color: #677788;
}

.navbar-promo-footer {
  background-color: #f8fafd;
  border-bottom-right-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.navbar-promo-footer-item {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}

.navbar-promo-footer-text {
  display: block;
  font-size: 0.8125rem;
}

.navbar-promo-footer-ver-divider {
  position: relative;
}

.navbar-promo-footer-ver-divider::before {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-right: 0.0625rem solid #e7eaf3;
  content: "";
}

/* Banner */
.navbar-banner {
  position: relative;
  height: 100%;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
  border-bottom-left-radius: 0.3125rem;
}

.navbar-banner::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(30, 32, 34, 0.5);
  border-bottom-left-radius: 0.3125rem;
  content: "";
}

.navbar-banner-content {
  z-index: 1;
  width: 100%;
  text-align: center;
  padding: 2rem 2rem;
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

/* Product Banner */
.navbar-product-banner {
  background-color: #f8fafd;
  border-bottom-right-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
  padding-right: 1.5rem;
}

.navbar-product-banner-content {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

/*------------------------------------
  Header Helpers
------------------------------------*/
.header-invisible {
  display: none;
}

.header-moved-up {
  transform: translate3d(0, -100%, 0);
}

.header-moved-up.header-hide-topbar {
  transform: translate3d(0, -36px, 0);
}

.header-faded {
  opacity: 0;
  visibility: hidden;
}

.header-section-hidden {
  position: relative;
}

.header[data-hs-header-options*="fixMoment"] {
  transition: 0.3s ease;
}

.header.header-untransitioned {
  transition: none;
}

.header.js-header-fix-moment {
  position: fixed;
  top: 0;
  bottom: auto;
}

.header.js-header-fix-moment .header-hide-content {
  display: none;
}

.header-fix-top {
  position: fixed;
}

.header.header-fix-top[data-hs-header-options*="effectCompensation"] {
  transition: none;
}

/*------------------------------------
  Nav Alignments
------------------------------------*/
@media (min-width: 992px) {
  .header .navbar-body,
  .header .navbar-nav {
    margin-left: auto;
  }
  .left-aligned-navbar .navbar-body,
  .left-aligned-navbar .navbar-nav {
    width: 100%;
    margin-left: 0;
    margin-right: auto;
  }
  .left-aligned-navbar .navbar-brand {
    margin-left: 0;
    margin-right: 3rem;
  }
  .left-aligned-navbar .navbar-nav-last-item {
    margin-left: auto;
  }
  .center-aligned-navbar .navbar-body,
  .center-aligned-navbar .navbar-nav {
    margin-left: auto;
    margin-right: auto;
  }
}

@media (min-width: 768px) {
  .center-aligned-navbar.header-abs-top-sm .navbar-body,
  .center-aligned-navbar.header-abs-top-sm .navbar-nav {
    margin-left: auto;
    margin-right: auto;
  }
}

/*------------------------------------
  Header Default
------------------------------------*/
.navbar-nav-scroll {
  max-width: 100%;
  height: 4.625rem;
  overflow: hidden;
}

.navbar-nav-scroll .navbar-nav {
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

/*------------------------------------
  Nav Wrap
------------------------------------*/
.navbar-nav-wrap {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.navbar-expand .navbar-nav-wrap {
  justify-content: space-between;
}

.navbar-expand .navbar-nav-wrap-content {
  order: 3;
}

.navbar-expand .navbar-nav-wrap-toggler {
  order: 3;
  text-align: right;
}

.navbar-expand .navbar-nav-wrap-collapse {
  order: 2;
}

@media (min-width: 576px) {
  .navbar-expand-sm .navbar-nav-wrap {
    justify-content: space-between;
  }
  .navbar-expand-sm .navbar-nav-wrap-content {
    order: 3;
  }
  .navbar-expand-sm .navbar-nav-wrap-toggler {
    order: 3;
    text-align: right;
  }
  .navbar-expand-sm .navbar-nav-wrap-collapse {
    order: 2;
  }
}

@media (min-width: 768px) {
  .navbar-expand-md .navbar-nav-wrap {
    justify-content: space-between;
  }
  .navbar-expand-md .navbar-nav-wrap-content {
    order: 3;
  }
  .navbar-expand-md .navbar-nav-wrap-toggler {
    order: 3;
    text-align: right;
  }
  .navbar-expand-md .navbar-nav-wrap-collapse {
    order: 2;
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg .navbar-nav-wrap {
    justify-content: space-between;
  }
  .navbar-expand-lg .navbar-nav-wrap-content {
    order: 3;
  }
  .navbar-expand-lg .navbar-nav-wrap-toggler {
    order: 3;
    text-align: right;
  }
  .navbar-expand-lg .navbar-nav-wrap-collapse {
    order: 2;
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl .navbar-nav-wrap {
    justify-content: space-between;
  }
  .navbar-expand-xl .navbar-nav-wrap-content {
    order: 3;
  }
  .navbar-expand-xl .navbar-nav-wrap-toggler {
    order: 3;
    text-align: right;
  }
  .navbar-expand-xl .navbar-nav-wrap-collapse {
    order: 2;
  }
}

@media (max-width: 575.98px) {
  .navbar-expand-sm .navbar-nav-wrap {
    justify-content: flex-end;
  }
  .navbar-expand-sm .navbar-nav-wrap-brand {
    margin-right: auto;
  }
  .navbar-expand-sm .navbar-nav-wrap-content {
    text-align: center;
    margin-right: 0.5rem;
  }
}

@media (max-width: 767.98px) {
  .navbar-expand-md .navbar-nav-wrap {
    justify-content: flex-end;
  }
  .navbar-expand-md .navbar-nav-wrap-brand {
    margin-right: auto;
  }
  .navbar-expand-md .navbar-nav-wrap-content {
    text-align: center;
    margin-right: 0.5rem;
  }
}

@media (max-width: 991.98px) {
  .navbar-expand-lg .navbar-nav-wrap {
    justify-content: flex-end;
  }
  .navbar-expand-lg .navbar-nav-wrap-brand {
    margin-right: auto;
  }
  .navbar-expand-lg .navbar-nav-wrap-content {
    text-align: center;
    margin-right: 0.5rem;
  }
}

@media (max-width: 1199.98px) {
  .navbar-expand-xl .navbar-nav-wrap {
    justify-content: flex-end;
  }
  .navbar-expand-xl .navbar-nav-wrap-brand {
    margin-right: auto;
  }
  .navbar-expand-xl .navbar-nav-wrap-content {
    text-align: center;
    margin-right: 0.5rem;
  }
}

.navbar-expand .navbar-nav-wrap {
  justify-content: flex-end;
}

.navbar-expand .navbar-nav-wrap-brand {
  margin-right: auto;
}

.navbar-expand .navbar-nav-wrap-content {
  text-align: center;
  margin-right: 0.5rem;
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .navbar-expand-md .navbar-nav-wrap-brand {
    flex: 0 0 100%;
    max-width: 100%;
  }
}

/*------------------------------------
  Fullscreen
------------------------------------*/
.fullscreen {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  visibility: hidden;
}

.fullscreen-container, .fullscreen-overlay {
  transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out;
}

.fullscreen-container {
  position: relative;
  z-index: 1000;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  visibility: hidden;
}

.fullscreen-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 999;
  opacity: 0;
  visibility: hidden;
  background-image: linear-gradient(to right, rgba(33, 50, 91, 0.9) 0%, rgba(33, 50, 91, 0.9) 100%);
  background-repeat: repeat-x;
  transition-delay: 0.5s;
}

.fullscreen-body {
  max-height: 75vh;
  overflow: hidden;
  overflow-y: auto;
}

.fullscreen-body::-webkit-scrollbar {
  width: 0.5rem;
}

.fullscreen-body::-webkit-scrollbar-thumb {
  background-color: rgba(189, 197, 209, 0.6);
  visibility: hidden;
}

.fullscreen-body:hover::-webkit-scrollbar-thumb {
  visibility: visible;
}

.fullscreen.fullscreen-showed {
  visibility: visible;
}

.fullscreen.fullscreen-showed .fullscreen-container,
.fullscreen.fullscreen-showed .fullscreen-overlay {
  opacity: 1;
  visibility: visible;
}

.fullscreen.fullscreen-showed .fullscreen-overlay {
  transition-delay: 0s;
}

.fullscreen.fullscreen-showed .fullscreen-container {
  transition-delay: 0.5s;
}

.header .fullscreen-toggler.navbar-toggler {
  display: inline-flex;
  z-index: 1001;
}

.header .fullscreen-toggler.navbar-toggler .navbar-toggler-default {
  display: flex;
}

.header .fullscreen-toggler.navbar-toggler .navbar-toggler-toggled {
  display: none;
}

.header .fullscreen-toggler.navbar-toggler[aria-pressed="true"] .navbar-toggler-default {
  display: none;
}

.header .fullscreen-toggler.navbar-toggler[aria-pressed="true"] .navbar-toggler-toggled {
  display: flex;
}

/*------------------------------------
  Header Fullscreen Style
------------------------------------*/
.fullscreen-nav {
  padding-left: 0;
  list-style: none;
  margin-bottom: 0;
}

.fullscreen-nav-list {
  list-style: none;
  padding-left: 0;
  margin-bottom: 0;
}

.fullscreen-nav-link {
  display: inline-block;
  font-size: 1.375rem;
  color: #fff;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

@media (min-width: 992px) {
  .fullscreen-nav-link {
    font-size: 1.75rem;
  }
}

.fullscreen-nav-link:hover {
  color: rgba(255, 255, 255, 0.7);
}

.fullscreen-submenu {
  position: relative;
  transition: 0.3s ease-in-out;
}

.fullscreen-submenu .fullscreen-submenu .fullscreen-submenu-list {
  margin-left: 1rem;
}

.fullscreen-submenu .fullscreen-nav-list {
  border-left: 0.125rem solid rgba(255, 255, 255, 0.6);
  padding-left: 0;
}

.fullscreen-submenu-nav-link {
  display: inline-block;
  color: #fff;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  padding-right: 1rem;
  padding-left: 1rem;
}

.fullscreen-submenu-nav-link.disabled {
  color: rgba(255, 255, 255, 0.7);
  pointer-events: none;
}

.fullscreen-submenu-nav-link:hover {
  color: rgba(255, 255, 255, 0.7);
}

.fullscreen-submenu-list {
  list-style: none;
  border-left: 0.125rem solid rgba(255, 255, 255, 0.6);
  padding-left: 0;
  margin-bottom: 0;
}

.fullscreen .fullscreen-submenu-list-link {
  display: inline-block;
  color: rgba(255, 255, 255, 0.7);
}

.fullscreen .fullscreen-submenu-list-link:hover {
  color: #fff;
}

/*------------------------------------
  Transparent Header
------------------------------------*/
.header-bg-transparent:not(.js-header-fix-moment) .search-push-top[style*="display: block"] + .header-section {
  background-color: #fff;
}

.header-bg-transparent:not(.js-header-fix-moment) .header-section {
  background-color: transparent;
}

.header-bg-transparent .navbar-brand-collapsed,
.header-bg-transparent .navbar-brand-on-scroll {
  display: none;
}

.header-bg-transparent.js-header-fix-moment .navbar-brand-default {
  display: none;
}

.header-bg-transparent.js-header-fix-moment .navbar-brand-on-scroll {
  display: inline-block;
}

@media (min-width: 576px) and (min-width: 576px) {
  .header-bg-transparent-sm:not(.js-header-fix-moment) .search-push-top[style*="display: block"] + .header-section {
    background-color: #fff;
  }
  .header-bg-transparent-sm:not(.js-header-fix-moment) .header-section {
    background-color: transparent;
  }
}

@media (min-width: 576px) {
  .header-bg-transparent-sm .navbar-brand-collapsed,
  .header-bg-transparent-sm .navbar-brand-on-scroll {
    display: none;
  }
  .header-bg-transparent-sm.js-header-fix-moment .navbar-brand-default {
    display: none;
  }
  .header-bg-transparent-sm.js-header-fix-moment .navbar-brand-on-scroll {
    display: inline-block;
  }
}

@media (min-width: 768px) and (min-width: 768px) {
  .header-bg-transparent-md:not(.js-header-fix-moment) .search-push-top[style*="display: block"] + .header-section {
    background-color: #fff;
  }
  .header-bg-transparent-md:not(.js-header-fix-moment) .header-section {
    background-color: transparent;
  }
}

@media (min-width: 768px) {
  .header-bg-transparent-md .navbar-brand-collapsed,
  .header-bg-transparent-md .navbar-brand-on-scroll {
    display: none;
  }
  .header-bg-transparent-md.js-header-fix-moment .navbar-brand-default {
    display: none;
  }
  .header-bg-transparent-md.js-header-fix-moment .navbar-brand-on-scroll {
    display: inline-block;
  }
}

@media (min-width: 992px) and (min-width: 992px) {
  .header-bg-transparent-lg:not(.js-header-fix-moment) .search-push-top[style*="display: block"] + .header-section {
    background-color: #fff;
  }
  .header-bg-transparent-lg:not(.js-header-fix-moment) .header-section {
    background-color: transparent;
  }
}

@media (min-width: 992px) {
  .header-bg-transparent-lg .navbar-brand-collapsed,
  .header-bg-transparent-lg .navbar-brand-on-scroll {
    display: none;
  }
  .header-bg-transparent-lg.js-header-fix-moment .navbar-brand-default {
    display: none;
  }
  .header-bg-transparent-lg.js-header-fix-moment .navbar-brand-on-scroll {
    display: inline-block;
  }
}

@media (min-width: 1200px) and (min-width: 1200px) {
  .header-bg-transparent-xl:not(.js-header-fix-moment) .search-push-top[style*="display: block"] + .header-section {
    background-color: #fff;
  }
  .header-bg-transparent-xl:not(.js-header-fix-moment) .header-section {
    background-color: transparent;
  }
}

@media (min-width: 1200px) {
  .header-bg-transparent-xl .navbar-brand-collapsed,
  .header-bg-transparent-xl .navbar-brand-on-scroll {
    display: none;
  }
  .header-bg-transparent-xl.js-header-fix-moment .navbar-brand-default {
    display: none;
  }
  .header-bg-transparent-xl.js-header-fix-moment .navbar-brand-on-scroll {
    display: inline-block;
  }
}

@media (max-width: 575.98px) {
  .header-bg-transparent-sm .navbar-brand-default,
  .header-bg-transparent-sm .navbar-brand-on-scroll {
    display: none;
  }
}

@media (max-width: 767.98px) {
  .header-bg-transparent-md .navbar-brand-default,
  .header-bg-transparent-md .navbar-brand-on-scroll {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .header-bg-transparent-lg .navbar-brand-default,
  .header-bg-transparent-lg .navbar-brand-on-scroll {
    display: none;
  }
}

@media (max-width: 1199.98px) {
  .header-bg-transparent-xl .navbar-brand-default,
  .header-bg-transparent-xl .navbar-brand-on-scroll {
    display: none;
  }
}

.header-bg-transparent .navbar-brand-default,
.header-bg-transparent .navbar-brand-on-scroll {
  display: none;
}

.header-bg-transparent .navbar-brand-default {
  display: flex;
}

@media (max-width: 991.98px) {
  .header-bg-transparent .navbar-nav,
  .header-bg-transparent-sm .navbar-nav,
  .header-bg-transparent-md .navbar-nav,
  .header-bg-transparent-lg .navbar-nav {
    background-color: #fff;
    padding: 0.875rem 1.5rem;
  }
}

/*------------------------------------
  Header On Scroll
------------------------------------*/
.header-white-bg-on-scroll.scrolled .header-section {
  background-color: #fff;
}

/*------------------------------------
  Header White Nav Links
------------------------------------*/
.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .navbar-nav-item:hover .nav-link {
  color: #fff;
}

.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .nav-link.active, .header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .nav-link:hover {
  color: #fff;
}

.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link,
.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary {
  color: rgba(255, 255, 255, 0.7);
}

.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link:hover,
.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary:hover {
  color: #fff;
}

.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .nav-link-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat right center/1rem 1rem;
}

@media (min-width: 576px) {
  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .navbar-nav-item:hover .nav-link {
    color: #fff;
  }
  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .nav-link {
    color: rgba(255, 255, 255, 0.7);
  }
  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .nav-link.active, .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .nav-link:hover {
    color: #fff;
  }
  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link,
  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary {
    color: rgba(255, 255, 255, 0.7);
  }
  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link:hover,
  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary:hover {
    color: #fff;
  }
  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .nav-link-toggle::after {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat right center/1rem 1rem;
  }
}

@media (min-width: 768px) {
  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .navbar-nav-item:hover .nav-link {
    color: #fff;
  }
  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .nav-link {
    color: rgba(255, 255, 255, 0.7);
  }
  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .nav-link.active, .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .nav-link:hover {
    color: #fff;
  }
  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link,
  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary {
    color: rgba(255, 255, 255, 0.7);
  }
  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link:hover,
  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary:hover {
    color: #fff;
  }
  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .nav-link-toggle::after {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat right center/1rem 1rem;
  }
}

@media (min-width: 992px) {
  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .navbar-nav-item:hover .nav-link {
    color: #fff;
  }
  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .nav-link {
    color: rgba(255, 255, 255, 0.7);
  }
  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .nav-link.active, .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .nav-link:hover {
    color: #fff;
  }
  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link,
  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary {
    color: rgba(255, 255, 255, 0.7);
  }
  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link:hover,
  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary:hover {
    color: #fff;
  }
  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .nav-link-toggle::after {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat right center/1rem 1rem;
  }
}

@media (min-width: 1200px) {
  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .navbar-nav-item:hover .nav-link {
    color: #fff;
  }
  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .nav-link {
    color: rgba(255, 255, 255, 0.7);
  }
  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .nav-link.active, .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .nav-link:hover {
    color: #fff;
  }
  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link,
  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary {
    color: rgba(255, 255, 255, 0.7);
  }
  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link:hover,
  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary:hover {
    color: #fff;
  }
  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .nav-link-toggle::after {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) no-repeat right center/1rem 1rem;
  }
}

/*------------------------------------
  Navbar Expand
------------------------------------*/
.navbar-expand {
  flex-wrap: wrap;
}

.navbar-expand .navbar-navbar-toggler {
  display: none;
}

.navbar-expand .navbar-nav {
  align-items: center;
}

.navbar-expand .navbar-nav .navbar-nav-last-item {
  text-align: right;
  padding-left: 1rem;
  padding-right: 0;
}

.navbar-expand .navbar-nav .nav-link {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
  padding-right: 0.75rem;
  padding-left: 0.75rem;
}

.navbar-expand .navbar-nav .dropdown-menu {
  border-top: 0.1875rem solid #377dff;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
}

.navbar-expand .navbar-nav .dropdown-menu .hs-has-sub-menu .dropdown-menu {
  margin-top: -1.1875rem;
}

.navbar-expand .mega-menu-position-right-fix.dropdown-menu, .navbar-expand .mega-menu-position-right-fix.hs-mega-menu.hs-position-right {
  right: 20%;
  left: auto;
}

.navbar-expand .mega-menu-body {
  padding: 2.5rem 2.5rem;
  margin-left: 0;
  margin-right: 0;
}

.navbar-expand .navbar-promo {
  border-bottom-right-radius: 0.3125rem;
}

.navbar-expand .navbar-promo-card {
  display: flex;
  flex: 1 0;
  flex-direction: column;
}

.navbar-expand .navbar-promo-card-deck {
  display: flex;
  flex-flow: row wrap;
}

.navbar-expand .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link {
  position: relative;
}

.navbar-expand .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link::after {
  position: absolute;
  top: 0;
  right: 0;
  margin-right: -1.5rem;
  border-right: 0.0625rem solid #e7eaf3;
  height: 100%;
  content: "";
}

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: wrap;
  }
  .navbar-expand-sm .navbar-navbar-toggler {
    display: none;
  }
  .navbar-expand-sm .navbar-nav {
    align-items: center;
  }
  .navbar-expand-sm .navbar-nav .navbar-nav-last-item {
    text-align: right;
    padding-left: 1rem;
    padding-right: 0;
  }
  .navbar-expand-sm .navbar-nav .nav-link {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    padding-right: 0.75rem;
    padding-left: 0.75rem;
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu {
    border-top: 0.1875rem solid #377dff;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0.3125rem;
    border-bottom-left-radius: 0.3125rem;
    box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
  }
  .navbar-expand-sm .navbar-nav .dropdown-menu .hs-has-sub-menu .dropdown-menu {
    margin-top: -1.1875rem;
  }
  .navbar-expand-sm .mega-menu-position-right-fix.dropdown-menu, .navbar-expand-sm .mega-menu-position-right-fix.hs-mega-menu.hs-position-right {
    right: 20%;
    left: auto;
  }
  .navbar-expand-sm .mega-menu-body {
    padding: 2.5rem 2.5rem;
    margin-left: 0;
    margin-right: 0;
  }
  .navbar-expand-sm .navbar-promo {
    border-bottom-right-radius: 0.3125rem;
  }
  .navbar-expand-sm .navbar-promo-card {
    display: flex;
    flex: 1 0;
    flex-direction: column;
  }
  .navbar-expand-sm .navbar-promo-card-deck {
    display: flex;
    flex-flow: row wrap;
  }
  .navbar-expand-sm .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link {
    position: relative;
  }
  .navbar-expand-sm .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link::after {
    position: absolute;
    top: 0;
    right: 0;
    margin-right: -1.5rem;
    border-right: 0.0625rem solid #e7eaf3;
    height: 100%;
    content: "";
  }
}

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: wrap;
  }
  .navbar-expand-md .navbar-navbar-toggler {
    display: none;
  }
  .navbar-expand-md .navbar-nav {
    align-items: center;
  }
  .navbar-expand-md .navbar-nav .navbar-nav-last-item {
    text-align: right;
    padding-left: 1rem;
    padding-right: 0;
  }
  .navbar-expand-md .navbar-nav .nav-link {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    padding-right: 0.75rem;
    padding-left: 0.75rem;
  }
  .navbar-expand-md .navbar-nav .dropdown-menu {
    border-top: 0.1875rem solid #377dff;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0.3125rem;
    border-bottom-left-radius: 0.3125rem;
    box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
  }
  .navbar-expand-md .navbar-nav .dropdown-menu .hs-has-sub-menu .dropdown-menu {
    margin-top: -1.1875rem;
  }
  .navbar-expand-md .mega-menu-position-right-fix.dropdown-menu, .navbar-expand-md .mega-menu-position-right-fix.hs-mega-menu.hs-position-right {
    right: 20%;
    left: auto;
  }
  .navbar-expand-md .mega-menu-body {
    padding: 2.5rem 2.5rem;
    margin-left: 0;
    margin-right: 0;
  }
  .navbar-expand-md .navbar-promo {
    border-bottom-right-radius: 0.3125rem;
  }
  .navbar-expand-md .navbar-promo-card {
    display: flex;
    flex: 1 0;
    flex-direction: column;
  }
  .navbar-expand-md .navbar-promo-card-deck {
    display: flex;
    flex-flow: row wrap;
  }
  .navbar-expand-md .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link {
    position: relative;
  }
  .navbar-expand-md .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link::after {
    position: absolute;
    top: 0;
    right: 0;
    margin-right: -1.5rem;
    border-right: 0.0625rem solid #e7eaf3;
    height: 100%;
    content: "";
  }
}

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: wrap;
  }
  .navbar-expand-lg .navbar-navbar-toggler {
    display: none;
  }
  .navbar-expand-lg .navbar-nav {
    align-items: center;
  }
  .navbar-expand-lg .navbar-nav .navbar-nav-last-item {
    text-align: right;
    padding-left: 1rem;
    padding-right: 0;
  }
  .navbar-expand-lg .navbar-nav .nav-link {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    padding-right: 0.75rem;
    padding-left: 0.75rem;
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu {
    border-top: 0.1875rem solid #377dff;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0.3125rem;
    border-bottom-left-radius: 0.3125rem;
    box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
  }
  .navbar-expand-lg .navbar-nav .dropdown-menu .hs-has-sub-menu .dropdown-menu {
    margin-top: -1.1875rem;
  }
  .navbar-expand-lg .mega-menu-position-right-fix.dropdown-menu, .navbar-expand-lg .mega-menu-position-right-fix.hs-mega-menu.hs-position-right {
    right: 20%;
    left: auto;
  }
  .navbar-expand-lg .mega-menu-body {
    padding: 2.5rem 2.5rem;
    margin-left: 0;
    margin-right: 0;
  }
  .navbar-expand-lg .navbar-promo {
    border-bottom-right-radius: 0.3125rem;
  }
  .navbar-expand-lg .navbar-promo-card {
    display: flex;
    flex: 1 0;
    flex-direction: column;
  }
  .navbar-expand-lg .navbar-promo-card-deck {
    display: flex;
    flex-flow: row wrap;
  }
  .navbar-expand-lg .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link {
    position: relative;
  }
  .navbar-expand-lg .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link::after {
    position: absolute;
    top: 0;
    right: 0;
    margin-right: -1.5rem;
    border-right: 0.0625rem solid #e7eaf3;
    height: 100%;
    content: "";
  }
}

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: wrap;
  }
  .navbar-expand-xl .navbar-navbar-toggler {
    display: none;
  }
  .navbar-expand-xl .navbar-nav {
    align-items: center;
  }
  .navbar-expand-xl .navbar-nav .navbar-nav-last-item {
    text-align: right;
    padding-left: 1rem;
    padding-right: 0;
  }
  .navbar-expand-xl .navbar-nav .nav-link {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
    padding-right: 0.75rem;
    padding-left: 0.75rem;
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu {
    border-top: 0.1875rem solid #377dff;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0.3125rem;
    border-bottom-left-radius: 0.3125rem;
    box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
  }
  .navbar-expand-xl .navbar-nav .dropdown-menu .hs-has-sub-menu .dropdown-menu {
    margin-top: -1.1875rem;
  }
  .navbar-expand-xl .mega-menu-position-right-fix.dropdown-menu, .navbar-expand-xl .mega-menu-position-right-fix.hs-mega-menu.hs-position-right {
    right: 20%;
    left: auto;
  }
  .navbar-expand-xl .mega-menu-body {
    padding: 2.5rem 2.5rem;
    margin-left: 0;
    margin-right: 0;
  }
  .navbar-expand-xl .navbar-promo {
    border-bottom-right-radius: 0.3125rem;
  }
  .navbar-expand-xl .navbar-promo-card {
    display: flex;
    flex: 1 0;
    flex-direction: column;
  }
  .navbar-expand-xl .navbar-promo-card-deck {
    display: flex;
    flex-flow: row wrap;
  }
  .navbar-expand-xl .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link {
    position: relative;
  }
  .navbar-expand-xl .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link::after {
    position: absolute;
    top: 0;
    right: 0;
    margin-right: -1.5rem;
    border-right: 0.0625rem solid #e7eaf3;
    height: 100%;
    content: "";
  }
}

@media (max-width: 575.98px) {
  .navbar-expand-sm.navbar {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .navbar-expand-sm .navbar-brand,
  .navbar-expand-sm .navbar-brand > img {
    width: 7rem;
  }
  .navbar-expand-sm .navbar-nav {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .navbar-expand-sm .navbar-nav-last-item {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .navbar-expand-sm .nav-link {
    display: flex;
    align-items: center;
  }
  .navbar-expand-sm .nav-link-toggle::after {
    margin-left: auto;
  }
  .navbar-expand-sm .hs-mega-menu {
    max-width: 100% !important;
  }
  .navbar-expand-sm .hs-mega-menu-opened .nav-link-toggle::after,
  .navbar-expand-sm .hs-sub-menu-opened .nav-link-toggle::after {
    transform: rotate(-180deg);
  }
  .navbar-expand-sm .dropdown-item-toggle::after {
    transform: rotate(90deg);
  }
  .navbar-expand-sm .hs-sub-menu-opened > .dropdown-item-toggle::after {
    transform: rotate(-90deg);
  }
  .navbar-expand-sm .mega-menu-body {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .navbar-expand-sm .dropdown-menu {
    box-shadow: none;
  }
  .navbar-expand-sm .dropdown-menu:not(.navbar-promo):not(.dropdown-menu-no-border-on-mobile) {
    border-left: 0.1875rem solid #e7eaf3;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .navbar-expand-sm .dropdown-menu .mega-menu-body {
    padding-left: 1.5rem;
  }
  .navbar-expand-sm .hs-has-sub-menu .hs-sub-menu .hs-sub-menu {
    margin-left: 1.5rem;
  }
  .navbar-expand-sm .hs-has-sub-menu .hs-sub-menu .hs-has-sub-menu .dropdown-item-toggle {
    padding-right: 0.6125rem;
  }
  .navbar-expand-sm .navbar-promo-card-deck:last-child .navbar-promo-item:not(:last-child) {
    border-bottom: 0.0625rem solid #e7eaf3;
  }
}

@media (max-width: 767.98px) {
  .navbar-expand-md.navbar {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .navbar-expand-md .navbar-brand,
  .navbar-expand-md .navbar-brand > img {
    width: 7rem;
  }
  .navbar-expand-md .navbar-nav {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .navbar-expand-md .navbar-nav-last-item {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .navbar-expand-md .nav-link {
    display: flex;
    align-items: center;
  }
  .navbar-expand-md .nav-link-toggle::after {
    margin-left: auto;
  }
  .navbar-expand-md .hs-mega-menu {
    max-width: 100% !important;
  }
  .navbar-expand-md .hs-mega-menu-opened .nav-link-toggle::after,
  .navbar-expand-md .hs-sub-menu-opened .nav-link-toggle::after {
    transform: rotate(-180deg);
  }
  .navbar-expand-md .dropdown-item-toggle::after {
    transform: rotate(90deg);
  }
  .navbar-expand-md .hs-sub-menu-opened > .dropdown-item-toggle::after {
    transform: rotate(-90deg);
  }
  .navbar-expand-md .mega-menu-body {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .navbar-expand-md .dropdown-menu {
    box-shadow: none;
  }
  .navbar-expand-md .dropdown-menu:not(.navbar-promo):not(.dropdown-menu-no-border-on-mobile) {
    border-left: 0.1875rem solid #e7eaf3;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .navbar-expand-md .dropdown-menu .mega-menu-body {
    padding-left: 1.5rem;
  }
  .navbar-expand-md .hs-has-sub-menu .hs-sub-menu .hs-sub-menu {
    margin-left: 1.5rem;
  }
  .navbar-expand-md .hs-has-sub-menu .hs-sub-menu .hs-has-sub-menu .dropdown-item-toggle {
    padding-right: 0.6125rem;
  }
  .navbar-expand-md .navbar-promo-card-deck:last-child .navbar-promo-item:not(:last-child) {
    border-bottom: 0.0625rem solid #e7eaf3;
  }
}

@media (max-width: 991.98px) {
  .navbar-expand-lg.navbar {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .navbar-expand-lg .navbar-brand,
  .navbar-expand-lg .navbar-brand > img {
    width: 7rem;
  }
  .navbar-expand-lg .navbar-nav {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .navbar-expand-lg .navbar-nav-last-item {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .navbar-expand-lg .nav-link {
    display: flex;
    align-items: center;
  }
  .navbar-expand-lg .nav-link-toggle::after {
    margin-left: auto;
  }
  .navbar-expand-lg .hs-mega-menu {
    max-width: 100% !important;
  }
  .navbar-expand-lg .hs-mega-menu-opened .nav-link-toggle::after,
  .navbar-expand-lg .hs-sub-menu-opened .nav-link-toggle::after {
    transform: rotate(-180deg);
  }
  .navbar-expand-lg .dropdown-item-toggle::after {
    transform: rotate(90deg);
  }
  .navbar-expand-lg .hs-sub-menu-opened > .dropdown-item-toggle::after {
    transform: rotate(-90deg);
  }
  .navbar-expand-lg .mega-menu-body {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .navbar-expand-lg .dropdown-menu {
    box-shadow: none;
  }
  .navbar-expand-lg .dropdown-menu:not(.navbar-promo):not(.dropdown-menu-no-border-on-mobile) {
    border-left: 0.1875rem solid #e7eaf3;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .navbar-expand-lg .dropdown-menu .mega-menu-body {
    padding-left: 1.5rem;
  }
  .navbar-expand-lg .hs-has-sub-menu .hs-sub-menu .hs-sub-menu {
    margin-left: 1.5rem;
  }
  .navbar-expand-lg .hs-has-sub-menu .hs-sub-menu .hs-has-sub-menu .dropdown-item-toggle {
    padding-right: 0.6125rem;
  }
  .navbar-expand-lg .navbar-promo-card-deck:last-child .navbar-promo-item:not(:last-child) {
    border-bottom: 0.0625rem solid #e7eaf3;
  }
}

@media (max-width: 1199.98px) {
  .navbar-expand-xl.navbar {
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
  }
  .navbar-expand-xl .navbar-brand,
  .navbar-expand-xl .navbar-brand > img {
    width: 7rem;
  }
  .navbar-expand-xl .navbar-nav {
    margin-top: 1rem;
    margin-bottom: 1rem;
  }
  .navbar-expand-xl .navbar-nav-last-item {
    padding-top: 0.75rem;
    padding-bottom: 0.75rem;
  }
  .navbar-expand-xl .nav-link {
    display: flex;
    align-items: center;
  }
  .navbar-expand-xl .nav-link-toggle::after {
    margin-left: auto;
  }
  .navbar-expand-xl .hs-mega-menu {
    max-width: 100% !important;
  }
  .navbar-expand-xl .hs-mega-menu-opened .nav-link-toggle::after,
  .navbar-expand-xl .hs-sub-menu-opened .nav-link-toggle::after {
    transform: rotate(-180deg);
  }
  .navbar-expand-xl .dropdown-item-toggle::after {
    transform: rotate(90deg);
  }
  .navbar-expand-xl .hs-sub-menu-opened > .dropdown-item-toggle::after {
    transform: rotate(-90deg);
  }
  .navbar-expand-xl .mega-menu-body {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
  .navbar-expand-xl .dropdown-menu {
    box-shadow: none;
  }
  .navbar-expand-xl .dropdown-menu:not(.navbar-promo):not(.dropdown-menu-no-border-on-mobile) {
    border-left: 0.1875rem solid #e7eaf3;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }
  .navbar-expand-xl .dropdown-menu .mega-menu-body {
    padding-left: 1.5rem;
  }
  .navbar-expand-xl .hs-has-sub-menu .hs-sub-menu .hs-sub-menu {
    margin-left: 1.5rem;
  }
  .navbar-expand-xl .hs-has-sub-menu .hs-sub-menu .hs-has-sub-menu .dropdown-item-toggle {
    padding-right: 0.6125rem;
  }
  .navbar-expand-xl .navbar-promo-card-deck:last-child .navbar-promo-item:not(:last-child) {
    border-bottom: 0.0625rem solid #e7eaf3;
  }
}

.navbar-expand.navbar {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.navbar-expand .navbar-brand,
.navbar-expand .navbar-brand > img {
  width: 7rem;
}

.navbar-expand .navbar-nav {
  margin-top: 1rem;
  margin-bottom: 1rem;
}

.navbar-expand .navbar-nav-last-item {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.navbar-expand .nav-link {
  display: flex;
  align-items: center;
}

.navbar-expand .nav-link-toggle::after {
  margin-left: auto;
}

.navbar-expand .hs-mega-menu {
  max-width: 100% !important;
}

.navbar-expand .hs-mega-menu-opened .nav-link-toggle::after,
.navbar-expand .hs-sub-menu-opened .nav-link-toggle::after {
  transform: rotate(-180deg);
}

.navbar-expand .dropdown-item-toggle::after {
  transform: rotate(90deg);
}

.navbar-expand .hs-sub-menu-opened > .dropdown-item-toggle::after {
  transform: rotate(-90deg);
}

.navbar-expand .mega-menu-body {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}

.navbar-expand .dropdown-menu {
  box-shadow: none;
}

.navbar-expand .dropdown-menu:not(.navbar-promo):not(.dropdown-menu-no-border-on-mobile) {
  border-left: 0.1875rem solid #e7eaf3;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.navbar-expand .dropdown-menu .mega-menu-body {
  padding-left: 1.5rem;
}

.navbar-expand .hs-has-sub-menu .hs-sub-menu .hs-sub-menu {
  margin-left: 1.5rem;
}

.navbar-expand .hs-has-sub-menu .hs-sub-menu .hs-has-sub-menu .dropdown-item-toggle {
  padding-right: 0.6125rem;
}

.navbar-expand .navbar-promo-card-deck:last-child .navbar-promo-item:not(:last-child) {
  border-bottom: 0.0625rem solid #e7eaf3;
}

@media (max-width: 767.98px) {
  .navbar-expand-sm .header-nav-last-item {
    display: none;
  }
}

@media (max-width: 991.98px) {
  .navbar-expand-xs .navbar-banner,
  .navbar-expand-xs .navbar-product-banner,
  .navbar-expand-sm .navbar-banner,
  .navbar-expand-sm .navbar-product-banner,
  .navbar-expand-md .navbar-banner,
  .navbar-expand-md .navbar-product-banner,
  .navbar-expand-lg .navbar-banner,
  .navbar-expand-lg .navbar-product-banner {
    display: none;
  }
  .navbar-expand .navbar-brand {
    padding-top: 0.5rem;
  }
}

@media (max-width: 1199.98px) {
  .navbar-expand-xl .navbar-banner,
  .navbar-expand-xl .navbar-product-banner {
    display: none;
  }
}

@media (min-width: 1200px) {
  .header .mega-menu-position-right-fix-xl.hs-mega-menu.hs-position-right {
    right: 20%;
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .navbar-expand-md .navbar-brand {
    padding-top: 0.5rem;
  }
  .header .mega-menu-position-right-fix-md.hs-mega-menu.hs-position-right {
    right: 20%;
  }
}

@media (min-width: 992px) {
  [class*="navbar-expand"]:not(.navbar-expand-xl) {
    flex-wrap: nowrap;
  }
  .navbar-expand-lg-collapse-block .navbar-collapse {
    display: block !important;
  }
}

/*------------------------------------
  Header Floating
------------------------------------*/
.header-floating {
  position: absolute;
  right: 0;
  left: 0;
  margin-top: 2.5rem;
}

.header-floating.js-header-fix-moment {
  position: fixed;
  background-color: #fff;
  box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);
  margin-top: 0;
}

.header-floating.js-header-fix-moment .header-floating-inner {
  box-shadow: none;
}

.header-floating-inner {
  border-radius: 0.3125rem;
  padding-left: 1rem;
  padding-right: 1rem;
}

@media (min-width: 576px) {
  .header-floating-sm {
    position: absolute;
    right: 0;
    left: 0;
    margin-top: 2.5rem;
  }
  .header-floating-sm.js-header-fix-moment {
    position: fixed;
    background-color: #fff;
    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);
    margin-top: 0;
  }
  .header-floating-sm.js-header-fix-moment .header-floating-inner {
    box-shadow: none;
  }
  .header-floating-inner {
    border-radius: 0.3125rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (min-width: 768px) {
  .header-floating-md {
    position: absolute;
    right: 0;
    left: 0;
    margin-top: 2.5rem;
  }
  .header-floating-md.js-header-fix-moment {
    position: fixed;
    background-color: #fff;
    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);
    margin-top: 0;
  }
  .header-floating-md.js-header-fix-moment .header-floating-inner {
    box-shadow: none;
  }
  .header-floating-inner {
    border-radius: 0.3125rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (min-width: 992px) {
  .header-floating-lg {
    position: absolute;
    right: 0;
    left: 0;
    margin-top: 2.5rem;
  }
  .header-floating-lg.js-header-fix-moment {
    position: fixed;
    background-color: #fff;
    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);
    margin-top: 0;
  }
  .header-floating-lg.js-header-fix-moment .header-floating-inner {
    box-shadow: none;
  }
  .header-floating-inner {
    border-radius: 0.3125rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (min-width: 1200px) {
  .header-floating-xl {
    position: absolute;
    right: 0;
    left: 0;
    margin-top: 2.5rem;
  }
  .header-floating-xl.js-header-fix-moment {
    position: fixed;
    background-color: #fff;
    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);
    margin-top: 0;
  }
  .header-floating-xl.js-header-fix-moment .header-floating-inner {
    box-shadow: none;
  }
  .header-floating-inner {
    border-radius: 0.3125rem;
    padding-left: 1rem;
    padding-right: 1rem;
  }
}

@media (max-width: 575.98px) {
  .header-floating-sm {
    background-color: #fff;
    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);
  }
  .header-floating-sm.header-box-shadow .header-section,
  .header-floating-sm.header-box-shadow-on-scroll.scrolled .header-section {
    box-shadow: none;
  }
}

@media (max-width: 767.98px) {
  .header-floating-md {
    background-color: #fff;
    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);
  }
  .header-floating-md.header-box-shadow .header-section,
  .header-floating-md.header-box-shadow-on-scroll.scrolled .header-section {
    box-shadow: none;
  }
}

@media (max-width: 991.98px) {
  .header-floating-lg {
    background-color: #fff;
    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);
  }
  .header-floating-lg.header-box-shadow .header-section,
  .header-floating-lg.header-box-shadow-on-scroll.scrolled .header-section {
    box-shadow: none;
  }
}

@media (max-width: 1199.98px) {
  .header-floating-xl {
    background-color: #fff;
    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);
  }
  .header-floating-xl.header-box-shadow .header-section,
  .header-floating-xl.header-box-shadow-on-scroll.scrolled .header-section {
    box-shadow: none;
  }
}

.header-floating {
  background-color: #fff;
  box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);
}

.header-floating.header-box-shadow .header-section,
.header-floating.header-box-shadow-on-scroll.scrolled .header-section {
  box-shadow: none;
}

@media (max-width: 991.98px) {
  .header-floating-inner {
    padding-right: 0;
    padding-left: 0;
  }
}

@media (max-width: 767.98px) {
  .header-floating-md .header-floating-inner {
    max-height: 75vh;
    overflow: hidden;
    overflow-y: auto;
  }
  .header-floating-md .header-floating-inner::-webkit-scrollbar {
    width: 0.5rem;
  }
  .header-floating-md .header-floating-inner::-webkit-scrollbar-thumb {
    background-color: rgba(189, 197, 209, 0.6);
    visibility: hidden;
  }
  .header-floating-md .header-floating-inner:hover::-webkit-scrollbar-thumb {
    visibility: visible;
  }
}

@media (max-width: 991.98px) {
  .header-floating .header-floating-inner,
  .header-floating-sm .header-floating-inner,
  .header-floating-lg .header-floating-inner {
    max-height: 75vh;
    overflow: hidden;
    overflow-y: auto;
  }
  .header-floating .header-floating-inner::-webkit-scrollbar,
  .header-floating-sm .header-floating-inner::-webkit-scrollbar,
  .header-floating-lg .header-floating-inner::-webkit-scrollbar {
    width: 0.5rem;
  }
  .header-floating .header-floating-inner::-webkit-scrollbar-thumb,
  .header-floating-sm .header-floating-inner::-webkit-scrollbar-thumb,
  .header-floating-lg .header-floating-inner::-webkit-scrollbar-thumb {
    background-color: rgba(189, 197, 209, 0.6);
    visibility: hidden;
  }
  .header-floating .header-floating-inner:hover::-webkit-scrollbar-thumb,
  .header-floating-sm .header-floating-inner:hover::-webkit-scrollbar-thumb,
  .header-floating-lg .header-floating-inner:hover::-webkit-scrollbar-thumb {
    visibility: visible;
  }
}

@media (max-width: 1199.98px) {
  .header-floating-xl .header-floating-inner {
    max-height: 75vh;
    overflow: hidden;
    overflow-y: auto;
  }
  .header-floating-xl .header-floating-inner::-webkit-scrollbar {
    width: 0.5rem;
  }
  .header-floating-xl .header-floating-inner::-webkit-scrollbar-thumb {
    background-color: rgba(189, 197, 209, 0.6);
    visibility: hidden;
  }
  .header-floating-xl .header-floating-inner:hover::-webkit-scrollbar-thumb {
    visibility: visible;
  }
}

/*------------------------------------
  Absolute Positions
------------------------------------*/
.header-abs-top {
  position: absolute;
  top: 0;
  bottom: auto;
}

@media (min-width: 576px) {
  .header-abs-top-sm {
    position: absolute;
    top: 0;
    bottom: auto;
  }
}

@media (min-width: 768px) {
  .header-abs-top-md {
    position: absolute;
    top: 0;
    bottom: auto;
  }
}

@media (min-width: 992px) {
  .header-abs-top-lg {
    position: absolute;
    top: 0;
    bottom: auto;
  }
}

@media (min-width: 1200px) {
  .header-abs-top-xl {
    position: absolute;
    top: 0;
    bottom: auto;
  }
}

@media (max-width: 767.98px) {
  .header-abs-top-md .header-abs-top-inner {
    max-height: 75vh;
    overflow: hidden;
    overflow-y: auto;
  }
  .header-abs-top-md .header-abs-top-inner::-webkit-scrollbar {
    width: 0.5rem;
  }
  .header-abs-top-md .header-abs-top-inner::-webkit-scrollbar-thumb {
    background-color: rgba(189, 197, 209, 0.6);
    visibility: hidden;
  }
  .header-abs-top-md .header-abs-top-inner:hover::-webkit-scrollbar-thumb {
    visibility: visible;
  }
}

@media (max-width: 991.98px) {
  .header-abs-top .header-abs-top-inner,
  .header-abs-top-sm .header-abs-top-inner,
  .header-abs-top-lg .header-abs-top-inner {
    max-height: 75vh;
    overflow: hidden;
    overflow-y: auto;
  }
  .header-abs-top .header-abs-top-inner::-webkit-scrollbar,
  .header-abs-top-sm .header-abs-top-inner::-webkit-scrollbar,
  .header-abs-top-lg .header-abs-top-inner::-webkit-scrollbar {
    width: 0.5rem;
  }
  .header-abs-top .header-abs-top-inner::-webkit-scrollbar-thumb,
  .header-abs-top-sm .header-abs-top-inner::-webkit-scrollbar-thumb,
  .header-abs-top-lg .header-abs-top-inner::-webkit-scrollbar-thumb {
    background-color: rgba(189, 197, 209, 0.6);
    visibility: hidden;
  }
  .header-abs-top .header-abs-top-inner:hover::-webkit-scrollbar-thumb,
  .header-abs-top-sm .header-abs-top-inner:hover::-webkit-scrollbar-thumb,
  .header-abs-top-lg .header-abs-top-inner:hover::-webkit-scrollbar-thumb {
    visibility: visible;
  }
}

@media (max-width: 1199.98px) {
  .header-abs-top-xl .header-abs-top-inner {
    max-height: 75vh;
    overflow: hidden;
    overflow-y: auto;
  }
  .header-abs-top-xl .header-abs-top-inner::-webkit-scrollbar {
    width: 0.5rem;
  }
  .header-abs-top-xl .header-abs-top-inner::-webkit-scrollbar-thumb {
    background-color: rgba(189, 197, 209, 0.6);
    visibility: hidden;
  }
  .header-abs-top-xl .header-abs-top-inner:hover::-webkit-scrollbar-thumb {
    visibility: visible;
  }
}

/*------------------------------------
  Sticky Positions
------------------------------------*/
.header-sticky-top {
  position: fixed;
  bottom: auto;
  top: 0;
}

@media (min-width: 576px) {
  .header-sticky-top-sm {
    position: fixed;
    bottom: auto;
    top: 0;
  }
}

@media (min-width: 768px) {
  .header-sticky-top-md {
    position: fixed;
    bottom: auto;
    top: 0;
  }
}

@media (min-width: 992px) {
  .header-sticky-top-lg {
    position: fixed;
    bottom: auto;
    top: 0;
  }
}

@media (min-width: 1200px) {
  .header-sticky-top-xl {
    position: fixed;
    bottom: auto;
    top: 0;
  }
}

@media (max-width: 767.98px) {
  .header-sticky-top-md .header-sticky-top-inner {
    max-height: 75vh;
    overflow: hidden;
    overflow-y: auto;
  }
  .header-sticky-top-md .header-sticky-top-inner::-webkit-scrollbar {
    width: 0.5rem;
  }
  .header-sticky-top-md .header-sticky-top-inner::-webkit-scrollbar-thumb {
    background-color: rgba(189, 197, 209, 0.6);
    visibility: hidden;
  }
  .header-sticky-top-md .header-sticky-top-inner:hover::-webkit-scrollbar-thumb {
    visibility: visible;
  }
}

@media (max-width: 991.98px) {
  .header-sticky-top .header-sticky-top-inner,
  .header-sticky-top-sm .header-sticky-top-inner,
  .header-sticky-top-lg .header-sticky-top-inner {
    max-height: 75vh;
    overflow: hidden;
    overflow-y: auto;
  }
  .header-sticky-top .header-sticky-top-inner::-webkit-scrollbar,
  .header-sticky-top-sm .header-sticky-top-inner::-webkit-scrollbar,
  .header-sticky-top-lg .header-sticky-top-inner::-webkit-scrollbar {
    width: 0.5rem;
  }
  .header-sticky-top .header-sticky-top-inner::-webkit-scrollbar-thumb,
  .header-sticky-top-sm .header-sticky-top-inner::-webkit-scrollbar-thumb,
  .header-sticky-top-lg .header-sticky-top-inner::-webkit-scrollbar-thumb {
    background-color: rgba(189, 197, 209, 0.6);
    visibility: hidden;
  }
  .header-sticky-top .header-sticky-top-inner:hover::-webkit-scrollbar-thumb,
  .header-sticky-top-sm .header-sticky-top-inner:hover::-webkit-scrollbar-thumb,
  .header-sticky-top-lg .header-sticky-top-inner:hover::-webkit-scrollbar-thumb {
    visibility: visible;
  }
}

@media (max-width: 1199.98px) {
  .header-sticky-top-xl .header-sticky-top-inner {
    max-height: 75vh;
    overflow: hidden;
    overflow-y: auto;
  }
  .header-sticky-top-xl .header-sticky-top-inner::-webkit-scrollbar {
    width: 0.5rem;
  }
  .header-sticky-top-xl .header-sticky-top-inner::-webkit-scrollbar-thumb {
    background-color: rgba(189, 197, 209, 0.6);
    visibility: hidden;
  }
  .header-sticky-top-xl .header-sticky-top-inner:hover::-webkit-scrollbar-thumb {
    visibility: visible;
  }
}

/*------------------------------------
  Animation
------------------------------------*/
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.fadeIn {
  animation-name: fadeIn;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 15px, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}

.fadeInUp {
  animation-name: fadeInUp;
}

@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}

.fadeOut {
  animation-name: fadeOut;
}

@keyframes fadeOutUp {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}

.fadeOutUp {
  animation-name: fadeOutUp;
}

@keyframes fadeOutDown {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}

.fadeOutDown {
  animation-name: fadeOutDown;
}

@keyframes slideInUp {
  from {
    transform: translate3d(0, 10px, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

.slideInUp {
  animation-name: slideInUp;
}

@keyframes slideInDown {
  from {
    transform: translate3d(0, -10px, 0);
    visibility: visible;
  }
  to {
    transform: translate3d(0, 0, 0);
  }
}

.slideInDown {
  animation-name: slideInDown;
}

@keyframes fadeInLeft {
  from {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fadeInLeft {
  animation-name: fadeInLeft;
}

@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

.fadeInRight {
  animation-name: fadeInRight;
}

@keyframes fadeOutLeft {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(-100%, 0, 0);
  }
}

.fadeOutLeft {
  animation-name: fadeOutLeft;
}

@keyframes fadeOutRight {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
}

.fadeOutRight {
  animation-name: fadeOutRight;
}

/*------------------------------------
  Alert Styles
------------------------------------*/
.alert-primary {
  color: #fff;
  background-color: #377dff;
  border-color: #377dff;
}

.alert-primary hr {
  border-top-color: #1e6cff;
}

.alert-primary .alert-link {
  color: #fff;
}

.alert-secondary {
  color: #fff;
  background-color: #71869d;
  border-color: #71869d;
}

.alert-secondary hr {
  border-top-color: #647991;
}

.alert-secondary .alert-link {
  color: #fff;
}

.alert-success {
  color: #fff;
  background-color: #00c9a7;
  border-color: #00c9a7;
}

.alert-success hr {
  border-top-color: #00b092;
}

.alert-success .alert-link {
  color: #fff;
}

.alert-info {
  color: #fff;
  background-color: #09a5be;
  border-color: #09a5be;
}

.alert-info hr {
  border-top-color: #0890a6;
}

.alert-info .alert-link {
  color: #fff;
}

.alert-warning {
  color: #1e2022;
  background-color: #f5ca99;
  border-color: #f5ca99;
}

.alert-warning hr {
  border-top-color: #f3be82;
}

.alert-warning .alert-link {
  color: #1e2022;
}

.alert-danger {
  color: #fff;
  background-color: #ed4c78;
  border-color: #ed4c78;
}

.alert-danger hr {
  border-top-color: #eb3567;
}

.alert-danger .alert-link {
  color: #fff;
}

.alert-light {
  color: #1e2022;
  background-color: #f7faff;
  border-color: #f7faff;
}

.alert-light hr {
  border-top-color: #deeaff;
}

.alert-light .alert-link {
  color: #1e2022;
}

.alert-dark {
  color: #fff;
  background-color: #21325b;
  border-color: #21325b;
}

.alert-dark hr {
  border-top-color: #1a2848;
}

.alert-dark .alert-link {
  color: #fff;
}

.alert-indigo {
  color: #fff;
  background-color: #2d1582;
  border-color: #2d1582;
}

.alert-indigo hr {
  border-top-color: #25116c;
}

.alert-indigo .alert-link {
  color: #fff;
}

/* primary soft */
.alert-soft-primary {
  color: #377dff;
  background-color: rgba(55, 125, 255, 0.1);
}

.alert-soft-primary .alert-link {
  color: #377dff;
}

.alert-soft-primary .alert-link:hover {
  color: #1366ff;
}

/* secondary soft */
.alert-soft-secondary {
  color: #71869d;
  background-color: rgba(113, 134, 157, 0.1);
}

.alert-soft-secondary .alert-link {
  color: #71869d;
}

.alert-soft-secondary .alert-link:hover {
  color: #60748b;
}

/* success soft */
.alert-soft-success {
  color: #00c9a7;
  background-color: rgba(0, 201, 167, 0.1);
}

.alert-soft-success .alert-link {
  color: #00c9a7;
}

.alert-soft-success .alert-link:hover {
  color: #00a589;
}

/* info soft */
.alert-soft-info {
  color: #09a5be;
  background-color: rgba(9, 165, 190, 0.1);
}

.alert-soft-info .alert-link {
  color: #09a5be;
}

.alert-soft-info .alert-link:hover {
  color: #07879c;
}

/* warning soft */
.alert-soft-warning {
  color: #f5ca99;
  background-color: rgba(245, 202, 153, 0.1);
}

.alert-soft-warning .alert-link {
  color: #f5ca99;
}

.alert-soft-warning .alert-link:hover {
  color: #f2b978;
}

/* danger soft */
.alert-soft-danger {
  color: #ed4c78;
  background-color: rgba(237, 76, 120, 0.1);
}

.alert-soft-danger .alert-link {
  color: #ed4c78;
}

.alert-soft-danger .alert-link:hover {
  color: #ea2c60;
}

/* light soft */
.alert-soft-light {
  color: #f7faff;
  background-color: rgba(247, 250, 255, 0.1);
}

.alert-soft-light .alert-link {
  color: #f7faff;
}

.alert-soft-light .alert-link:hover {
  color: #d3e4ff;
}

/* dark soft */
.alert-soft-dark {
  color: #21325b;
  background-color: rgba(33, 50, 91, 0.1);
}

.alert-soft-dark .alert-link {
  color: #21325b;
}

.alert-soft-dark .alert-link:hover {
  color: #172441;
}

/* indigo soft */
.alert-soft-indigo {
  color: #2d1582;
  background-color: rgba(45, 21, 130, 0.1);
}

.alert-soft-indigo .alert-link {
  color: #2d1582;
}

.alert-soft-indigo .alert-link:hover {
  color: #221063;
}

/*------------------------------------
  Avatar
------------------------------------*/
.avatar {
  position: relative;
  display: inline-block;
  width: 3.125rem;
  height: 3.125rem;
  border-radius: 0.3125rem;
}

.avatar-img {
  max-width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.3125rem;
}

.avatar-initials {
  font-size: 1rem;
  font-weight: 600;
  text-transform: uppercase;
}

.avatar-circle {
  border-radius: 50%;
}

.avatar-circle .avatar-img {
  border-radius: 50%;
}

.avatar-centered {
  display: flex;
  margin-right: auto;
  margin-left: auto;
}

.avatar-border-lg {
  border: 0.1875rem solid #fff;
}

/*------------------------------------
  Avatar Group
------------------------------------*/
.avatar-group {
  display: flex;
}

.avatar-group .avatar-circle .avatar-initials {
  border-radius: 50%;
}

.avatar-group .avatar-xs .avatar-img,
.avatar-group .avatar-xs .avatar-initials,
.avatar-group .avatar-sm .avatar-img,
.avatar-group .avatar-sm .avatar-initials,
.avatar-group .avatar .avatar-img,
.avatar-group .avatar .avatar-initials {
  border: 2px solid #fff;
}

.avatar-group .avatar-lg .avatar-img,
.avatar-group .avatar-lg .avatar-initials {
  border: 5px solid #fff;
}

.avatar-group .avatar-xl .avatar-img,
.avatar-group .avatar-xl .avatar-initials {
  border: 7px solid #fff;
}

.avatar-group .avatar + .avatar {
  margin-left: -1rem;
}

.avatar-group .avatar-xs + .avatar-xs {
  margin-left: -0.6125rem;
}

.avatar-group .avatar-sm + .avatar-sm {
  margin-left: -0.875rem;
}

.avatar-group .avatar-lg + .avatar-lg {
  margin-left: -1.5rem;
}

.avatar-group .avatar-xl + .avatar-xl {
  margin-left: -2rem;
}

/*------------------------------------
  Avatar Initials
------------------------------------*/
.avatar-initials {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

/*------------------------------------
  Avatar Sizes
------------------------------------*/
.avatar.avatar-circle .avatar-status {
  bottom: -0.21875rem;
  right: -0.21875rem;
}

.avatar.avatar-circle .avatar-sm-status {
  bottom: 0;
  right: 0;
}

.avatar.avatar-circle .avatar-lg-status {
  bottom: -0.325rem;
  right: -0.325rem;
}

.avatar-xss {
  width: 1rem;
  height: 1rem;
}

.avatar-xss .avatar-initials {
  font-size: 0.75rem;
}

.avatar-xs {
  width: 1.75rem;
  height: 1.75rem;
}

.avatar-xs .avatar-initials {
  font-size: 0.75rem;
}

.avatar-xs.avatar-circle .avatar-status {
  bottom: -0.21875rem;
  right: -0.21875rem;
}

.avatar-xs.avatar-circle .avatar-sm-status {
  bottom: -0.11719rem;
  right: -0.11719rem;
}

.avatar-xs.avatar-circle .avatar-lg-status {
  bottom: -0.325rem;
  right: -0.325rem;
}

.avatar-xs {
  width: 1.75rem;
  height: 1.75rem;
}

.avatar-xs .avatar-initials {
  font-size: 0.75rem;
}

.avatar-xs.avatar-circle .avatar-status {
  bottom: -0.21875rem;
  right: -0.21875rem;
}

.avatar-xs.avatar-circle .avatar-sm-status {
  bottom: -0.11719rem;
  right: -0.11719rem;
}

.avatar-xs.avatar-circle .avatar-lg-status {
  bottom: -0.325rem;
  right: -0.325rem;
}

.avatar-sm {
  width: 2.6875rem;
  height: 2.6875rem;
}

.avatar-sm .avatar-initials {
  font-size: 0.8125rem;
}

.avatar-sm.avatar-circle .avatar-status {
  bottom: -0.21875rem;
  right: -0.21875rem;
}

.avatar-sm.avatar-circle .avatar-sm-status {
  bottom: -0.09375rem;
  right: -0.09375rem;
}

.avatar-sm.avatar-circle .avatar-lg-status {
  bottom: -0.40625rem;
  right: -0.40625rem;
}

.avatar-lg {
  width: 4.25rem;
  height: 4.25rem;
}

.avatar-lg .avatar-initials {
  font-size: 1.25rem;
}

.avatar-lg.avatar-circle .avatar-status {
  bottom: -0.13125rem;
  right: -0.13125rem;
}

.avatar-lg.avatar-circle .avatar-sm-status {
  bottom: 0.09375rem;
  right: 0.09375rem;
}

.avatar-lg.avatar-circle .avatar-lg-status {
  bottom: -0.20312rem;
  right: -0.20312rem;
}

.avatar-xl {
  width: 5.625rem;
  height: 5.625rem;
}

.avatar-xl .avatar-initials {
  font-size: 2rem;
}

.avatar-xl.avatar-circle .avatar-status {
  bottom: 0.16406rem;
  right: 0.16406rem;
}

.avatar-xl.avatar-circle .avatar-sm-status {
  bottom: 0.23438rem;
  right: 0.23438rem;
}

.avatar-xl.avatar-circle .avatar-lg-status {
  bottom: 0.13542rem;
  right: 0.13542rem;
}

.avatar-xxl {
  width: 7rem;
  height: 7rem;
}

.avatar-xxl .avatar-initials {
  font-size: 3rem;
}

.avatar-xxl.avatar-circle .avatar-status {
  bottom: 0.4375rem;
  right: 0.4375rem;
}

.avatar-xxl.avatar-circle .avatar-sm-status {
  bottom: 0.58333rem;
  right: 0.58333rem;
}

.avatar-xxl.avatar-circle .avatar-lg-status {
  bottom: 0.29545rem;
  right: 0.29545rem;
}

/*------------------------------------
  Avatar Status
------------------------------------*/
.avatar-status {
  position: absolute;
  bottom: -0.525rem;
  right: -0.525rem;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  white-space: nowrap;
  text-align: center;
  vertical-align: baseline;
  border: 0.125rem solid #fff;
  width: 1.3125rem;
  height: 1.3125rem;
  line-height: 1;
  font-size: 0.625rem;
  border-radius: 50%;
}

.avatar-sm-status {
  bottom: -0.2625rem;
  right: -0.2625rem;
  width: 0.9375rem;
  height: 0.9375rem;
  font-size: 0.5rem;
}

.avatar-lg-status {
  width: 1.625rem;
  height: 1.625rem;
  font-size: 0.75rem;
}

/*------------------------------------
  Avatar Styles
------------------------------------*/
/* primary soft */
.avatar-primary {
  color: #fff;
  background-color: #377dff;
}

/* secondary soft */
.avatar-secondary {
  color: #fff;
  background-color: #71869d;
}

/* success soft */
.avatar-success {
  color: #fff;
  background-color: #00c9a7;
}

/* info soft */
.avatar-info {
  color: #fff;
  background-color: #09a5be;
}

/* warning soft */
.avatar-warning {
  color: #1e2022;
  background-color: #f5ca99;
}

/* danger soft */
.avatar-danger {
  color: #fff;
  background-color: #ed4c78;
}

/* light soft */
.avatar-light {
  color: #1e2022;
  background-color: #f7faff;
}

/* dark soft */
.avatar-dark {
  color: #fff;
  background-color: #21325b;
}

/* indigo soft */
.avatar-indigo {
  color: #fff;
  background-color: #2d1582;
}

/* primary soft */
.avatar-soft-primary {
  color: #377dff;
  background-color: rgba(55, 125, 255, 0.1);
}

/* secondary soft */
.avatar-soft-secondary {
  color: #71869d;
  background-color: rgba(113, 134, 157, 0.1);
}

/* success soft */
.avatar-soft-success {
  color: #00c9a7;
  background-color: rgba(0, 201, 167, 0.1);
}

/* info soft */
.avatar-soft-info {
  color: #09a5be;
  background-color: rgba(9, 165, 190, 0.1);
}

/* warning soft */
.avatar-soft-warning {
  color: #f5ca99;
  background-color: rgba(245, 202, 153, 0.1);
}

/* danger soft */
.avatar-soft-danger {
  color: #ed4c78;
  background-color: rgba(237, 76, 120, 0.1);
}

/* light soft */
.avatar-soft-light {
  color: #f7faff;
  background-color: rgba(247, 250, 255, 0.1);
}

/* dark soft */
.avatar-soft-dark {
  color: #21325b;
  background-color: rgba(33, 50, 91, 0.1);
}

/* indigo soft */
.avatar-soft-indigo {
  color: #2d1582;
  background-color: rgba(45, 21, 130, 0.1);
}

/*------------------------------------
  Blockquote
------------------------------------*/
.blockquote {
  font-size: 1rem;
  border-left: 0.1875rem solid #e7eaf3;
  padding-left: 0.75rem;
  margin-bottom: 0;
}

.blockquote-footer {
  margin-top: 1rem;
}

/*------------------------------------
  Badge Soft
------------------------------------*/
/* primary soft */
.badge-soft-primary {
  color: #377dff;
  background-color: rgba(55, 125, 255, 0.1);
}

a.badge-soft-primary:hover, a.badge-soft-primary:focus {
  color: #fff;
  background-color: #377dff;
}

/* secondary soft */
.badge-soft-secondary {
  color: #71869d;
  background-color: rgba(113, 134, 157, 0.1);
}

a.badge-soft-secondary:hover, a.badge-soft-secondary:focus {
  color: #fff;
  background-color: #71869d;
}

/* success soft */
.badge-soft-success {
  color: #00c9a7;
  background-color: rgba(0, 201, 167, 0.1);
}

a.badge-soft-success:hover, a.badge-soft-success:focus {
  color: #fff;
  background-color: #00c9a7;
}

/* info soft */
.badge-soft-info {
  color: #09a5be;
  background-color: rgba(9, 165, 190, 0.1);
}

a.badge-soft-info:hover, a.badge-soft-info:focus {
  color: #fff;
  background-color: #09a5be;
}

/* warning soft */
.badge-soft-warning {
  color: #f5ca99;
  background-color: rgba(245, 202, 153, 0.1);
}

a.badge-soft-warning:hover, a.badge-soft-warning:focus {
  color: #1e2022;
  background-color: #f5ca99;
}

/* danger soft */
.badge-soft-danger {
  color: #ed4c78;
  background-color: rgba(237, 76, 120, 0.1);
}

a.badge-soft-danger:hover, a.badge-soft-danger:focus {
  color: #fff;
  background-color: #ed4c78;
}

/* light soft */
.badge-soft-light {
  color: #f7faff;
  background-color: rgba(247, 250, 255, 0.1);
}

a.badge-soft-light:hover, a.badge-soft-light:focus {
  color: #1e2022;
  background-color: #f7faff;
}

/* dark soft */
.badge-soft-dark {
  color: #21325b;
  background-color: rgba(33, 50, 91, 0.1);
}

a.badge-soft-dark:hover, a.badge-soft-dark:focus {
  color: #fff;
  background-color: #21325b;
}

/* indigo soft */
.badge-soft-indigo {
  color: #2d1582;
  background-color: rgba(45, 21, 130, 0.1);
}

a.badge-soft-indigo:hover, a.badge-soft-indigo:focus {
  color: #fff;
  background-color: #2d1582;
}

.badge-soft-warning {
  color: #ec9a3c !important;
}

/*------------------------------------
  Custom Buttons
------------------------------------*/
.btn.dropdown-toggle {
  display: inline-flex;
  align-items: center;
}

.btn-white {
  font-weight: 400;
  background-color: #fff;
  border-color: #e7eaf3;
}

.btn-white.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right center/1rem 1rem;
}

.btn-white:hover, .btn-white:focus, .btn-white.focus, .btn-white:active, .btn-white.active {
  color: #0052ea;
  box-shadow: 0px 3px 6px -2px rgba(140, 152, 164, 0.25);
}

.btn-white:hover.dropdown-toggle::after, .btn-white:focus.dropdown-toggle::after, .btn-white.focus.dropdown-toggle::after, .btn-white:active.dropdown-toggle::after, .btn-white.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat right center/1rem 1rem;
}

.btn-white.disabled, .btn-white:disabled {
  color: #677788;
  background-color: rgba(231, 234, 243, 0.5);
}

.btn-primary.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-secondary.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-success.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-info.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-warning.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat right center/1rem 1rem;
}

.btn-danger.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-light.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat right center/1rem 1rem;
}

.btn-dark.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-indigo.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-outline-primary.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat right center/1rem 1rem;
}

.btn-outline-primary:hover.dropdown-toggle::after, .btn-outline-primary:active.dropdown-toggle::after, .btn-outline-primary.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-outline-secondary.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right center/1rem 1rem;
}

.btn-outline-secondary:hover.dropdown-toggle::after, .btn-outline-secondary:active.dropdown-toggle::after, .btn-outline-secondary.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-outline-success.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat right center/1rem 1rem;
}

.btn-outline-success:hover.dropdown-toggle::after, .btn-outline-success:active.dropdown-toggle::after, .btn-outline-success.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-outline-info.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat right center/1rem 1rem;
}

.btn-outline-info:hover.dropdown-toggle::after, .btn-outline-info:active.dropdown-toggle::after, .btn-outline-info.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-outline-warning.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat right center/1rem 1rem;
}

.btn-outline-warning:hover.dropdown-toggle::after, .btn-outline-warning:active.dropdown-toggle::after, .btn-outline-warning.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat right center/1rem 1rem;
}

.btn-outline-danger.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat right center/1rem 1rem;
}

.btn-outline-danger:hover.dropdown-toggle::after, .btn-outline-danger:active.dropdown-toggle::after, .btn-outline-danger.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-outline-light.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat right center/1rem 1rem;
}

.btn-outline-light:hover.dropdown-toggle::after, .btn-outline-light:active.dropdown-toggle::after, .btn-outline-light.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat right center/1rem 1rem;
}

.btn-outline-dark.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat right center/1rem 1rem;
}

.btn-outline-dark:hover.dropdown-toggle::after, .btn-outline-dark:active.dropdown-toggle::after, .btn-outline-dark.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-outline-indigo.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) no-repeat right center/1rem 1rem;
}

.btn-outline-indigo:hover.dropdown-toggle::after, .btn-outline-indigo:active.dropdown-toggle::after, .btn-outline-indigo.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

/* primary button :hover, :focus, :active effects */
.btn-primary[href]:hover, .btn-primary[href]:focus, .btn-primary[href]:active, .btn-primary[type]:hover, .btn-primary[type]:focus, .btn-primary[type]:active {
  box-shadow: 0 4px 11px rgba(55, 125, 255, 0.35);
}

.btn-primary:not(label.btn), .btn-primary:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-primary:not([href]), .btn-primary:not([href]):not([href]):not(:disabled):not(.disabled) {
  background-color: #377dff;
  border-color: #377dff;
}

.btn-primary:hover {
  background-color: #377dff;
  border-color: #377dff;
}

/* secondary button :hover, :focus, :active effects */
.btn-secondary[href]:hover, .btn-secondary[href]:focus, .btn-secondary[href]:active, .btn-secondary[type]:hover, .btn-secondary[type]:focus, .btn-secondary[type]:active {
  box-shadow: 0 4px 11px rgba(113, 134, 157, 0.35);
}

.btn-secondary:not(label.btn), .btn-secondary:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-secondary:not([href]), .btn-secondary:not([href]):not([href]):not(:disabled):not(.disabled) {
  background-color: #71869d;
  border-color: #71869d;
}

.btn-secondary:hover {
  background-color: #71869d;
  border-color: #71869d;
}

/* success button :hover, :focus, :active effects */
.btn-success[href]:hover, .btn-success[href]:focus, .btn-success[href]:active, .btn-success[type]:hover, .btn-success[type]:focus, .btn-success[type]:active {
  box-shadow: 0 4px 11px rgba(0, 201, 167, 0.35);
}

.btn-success:not(label.btn), .btn-success:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-success:not([href]), .btn-success:not([href]):not([href]):not(:disabled):not(.disabled) {
  background-color: #00c9a7;
  border-color: #00c9a7;
}

.btn-success:hover {
  background-color: #00c9a7;
  border-color: #00c9a7;
}

/* info button :hover, :focus, :active effects */
.btn-info[href]:hover, .btn-info[href]:focus, .btn-info[href]:active, .btn-info[type]:hover, .btn-info[type]:focus, .btn-info[type]:active {
  box-shadow: 0 4px 11px rgba(9, 165, 190, 0.35);
}

.btn-info:not(label.btn), .btn-info:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-info:not([href]), .btn-info:not([href]):not([href]):not(:disabled):not(.disabled) {
  background-color: #09a5be;
  border-color: #09a5be;
}

.btn-info:hover {
  background-color: #09a5be;
  border-color: #09a5be;
}

/* warning button :hover, :focus, :active effects */
.btn-warning[href]:hover, .btn-warning[href]:focus, .btn-warning[href]:active, .btn-warning[type]:hover, .btn-warning[type]:focus, .btn-warning[type]:active {
  box-shadow: 0 4px 11px rgba(245, 202, 153, 0.35);
}

.btn-warning:not(label.btn), .btn-warning:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-warning:not([href]), .btn-warning:not([href]):not([href]):not(:disabled):not(.disabled) {
  background-color: #f5ca99;
  border-color: #f5ca99;
}

.btn-warning:hover {
  background-color: #f5ca99;
  border-color: #f5ca99;
}

/* danger button :hover, :focus, :active effects */
.btn-danger[href]:hover, .btn-danger[href]:focus, .btn-danger[href]:active, .btn-danger[type]:hover, .btn-danger[type]:focus, .btn-danger[type]:active {
  box-shadow: 0 4px 11px rgba(237, 76, 120, 0.35);
}

.btn-danger:not(label.btn), .btn-danger:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-danger:not([href]), .btn-danger:not([href]):not([href]):not(:disabled):not(.disabled) {
  background-color: #ed4c78;
  border-color: #ed4c78;
}

.btn-danger:hover {
  background-color: #ed4c78;
  border-color: #ed4c78;
}

/* light button :hover, :focus, :active effects */
.btn-light[href]:hover, .btn-light[href]:focus, .btn-light[href]:active, .btn-light[type]:hover, .btn-light[type]:focus, .btn-light[type]:active {
  box-shadow: 0 4px 11px rgba(247, 250, 255, 0.35);
}

.btn-light:not(label.btn), .btn-light:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-light:not([href]), .btn-light:not([href]):not([href]):not(:disabled):not(.disabled) {
  background-color: #f7faff;
  border-color: #f7faff;
}

.btn-light:hover {
  background-color: #f7faff;
  border-color: #f7faff;
}

/* dark button :hover, :focus, :active effects */
.btn-dark[href]:hover, .btn-dark[href]:focus, .btn-dark[href]:active, .btn-dark[type]:hover, .btn-dark[type]:focus, .btn-dark[type]:active {
  box-shadow: 0 4px 11px rgba(33, 50, 91, 0.35);
}

.btn-dark:not(label.btn), .btn-dark:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-dark:not([href]), .btn-dark:not([href]):not([href]):not(:disabled):not(.disabled) {
  background-color: #21325b;
  border-color: #21325b;
}

.btn-dark:hover {
  background-color: #21325b;
  border-color: #21325b;
}

/* indigo button :hover, :focus, :active effects */
.btn-indigo[href]:hover, .btn-indigo[href]:focus, .btn-indigo[href]:active, .btn-indigo[type]:hover, .btn-indigo[type]:focus, .btn-indigo[type]:active {
  box-shadow: 0 4px 11px rgba(45, 21, 130, 0.35);
}

.btn-indigo:not(label.btn), .btn-indigo:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-indigo:not([href]), .btn-indigo:not([href]):not([href]):not(:disabled):not(.disabled) {
  background-color: #2d1582;
  border-color: #2d1582;
}

.btn-indigo:hover {
  background-color: #2d1582;
  border-color: #2d1582;
}

/*------------------------------------
  Custom Button Toggle
------------------------------------*/
/* primary custom toggle button */
.btn-custom-toggle-primary {
  color: #97a4af;
  border-color: #e7eaf3;
}

.btn-custom-toggle-primary:hover {
  color: #377dff;
  background-color: transparent;
  border-color: #377dff;
}

.btn-custom-toggle-primary:not(:disabled):not(.disabled):active, .btn-custom-toggle-primary:not(:disabled):not(.disabled).active, .btn-custom-toggle-primary:not(:disabled):not(.disabled):active, .btn-custom-toggle-primary:not(:disabled):not(.disabled).active {
  color: #fff;
  background-color: #377dff;
  border-color: #377dff;
}

/* secondary custom toggle button */
.btn-custom-toggle-secondary {
  color: #97a4af;
  border-color: #e7eaf3;
}

.btn-custom-toggle-secondary:hover {
  color: #71869d;
  background-color: transparent;
  border-color: #71869d;
}

.btn-custom-toggle-secondary:not(:disabled):not(.disabled):active, .btn-custom-toggle-secondary:not(:disabled):not(.disabled).active, .btn-custom-toggle-secondary:not(:disabled):not(.disabled):active, .btn-custom-toggle-secondary:not(:disabled):not(.disabled).active {
  color: #fff;
  background-color: #71869d;
  border-color: #71869d;
}

/* success custom toggle button */
.btn-custom-toggle-success {
  color: #97a4af;
  border-color: #e7eaf3;
}

.btn-custom-toggle-success:hover {
  color: #00c9a7;
  background-color: transparent;
  border-color: #00c9a7;
}

.btn-custom-toggle-success:not(:disabled):not(.disabled):active, .btn-custom-toggle-success:not(:disabled):not(.disabled).active, .btn-custom-toggle-success:not(:disabled):not(.disabled):active, .btn-custom-toggle-success:not(:disabled):not(.disabled).active {
  color: #fff;
  background-color: #00c9a7;
  border-color: #00c9a7;
}

/* info custom toggle button */
.btn-custom-toggle-info {
  color: #97a4af;
  border-color: #e7eaf3;
}

.btn-custom-toggle-info:hover {
  color: #09a5be;
  background-color: transparent;
  border-color: #09a5be;
}

.btn-custom-toggle-info:not(:disabled):not(.disabled):active, .btn-custom-toggle-info:not(:disabled):not(.disabled).active, .btn-custom-toggle-info:not(:disabled):not(.disabled):active, .btn-custom-toggle-info:not(:disabled):not(.disabled).active {
  color: #fff;
  background-color: #09a5be;
  border-color: #09a5be;
}

/* warning custom toggle button */
.btn-custom-toggle-warning {
  color: #97a4af;
  border-color: #e7eaf3;
}

.btn-custom-toggle-warning:hover {
  color: #f5ca99;
  background-color: transparent;
  border-color: #f5ca99;
}

.btn-custom-toggle-warning:not(:disabled):not(.disabled):active, .btn-custom-toggle-warning:not(:disabled):not(.disabled).active, .btn-custom-toggle-warning:not(:disabled):not(.disabled):active, .btn-custom-toggle-warning:not(:disabled):not(.disabled).active {
  color: #1e2022;
  background-color: #f5ca99;
  border-color: #f5ca99;
}

/* danger custom toggle button */
.btn-custom-toggle-danger {
  color: #97a4af;
  border-color: #e7eaf3;
}

.btn-custom-toggle-danger:hover {
  color: #ed4c78;
  background-color: transparent;
  border-color: #ed4c78;
}

.btn-custom-toggle-danger:not(:disabled):not(.disabled):active, .btn-custom-toggle-danger:not(:disabled):not(.disabled).active, .btn-custom-toggle-danger:not(:disabled):not(.disabled):active, .btn-custom-toggle-danger:not(:disabled):not(.disabled).active {
  color: #fff;
  background-color: #ed4c78;
  border-color: #ed4c78;
}

/* light custom toggle button */
.btn-custom-toggle-light {
  color: #97a4af;
  border-color: #e7eaf3;
}

.btn-custom-toggle-light:hover {
  color: #fff;
  background-color: transparent;
  border-color: #f7faff;
}

.btn-custom-toggle-light:not(:disabled):not(.disabled):active, .btn-custom-toggle-light:not(:disabled):not(.disabled).active, .btn-custom-toggle-light:not(:disabled):not(.disabled):active, .btn-custom-toggle-light:not(:disabled):not(.disabled).active {
  color: #1e2022;
  background-color: #f7faff;
  border-color: #f7faff;
}

/* dark custom toggle button */
.btn-custom-toggle-dark {
  color: #97a4af;
  border-color: #e7eaf3;
}

.btn-custom-toggle-dark:hover {
  color: #21325b;
  background-color: transparent;
  border-color: #21325b;
}

.btn-custom-toggle-dark:not(:disabled):not(.disabled):active, .btn-custom-toggle-dark:not(:disabled):not(.disabled).active, .btn-custom-toggle-dark:not(:disabled):not(.disabled):active, .btn-custom-toggle-dark:not(:disabled):not(.disabled).active {
  color: #fff;
  background-color: #21325b;
  border-color: #21325b;
}

/* indigo custom toggle button */
.btn-custom-toggle-indigo {
  color: #97a4af;
  border-color: #e7eaf3;
}

.btn-custom-toggle-indigo:hover {
  color: #2d1582;
  background-color: transparent;
  border-color: #2d1582;
}

.btn-custom-toggle-indigo:not(:disabled):not(.disabled):active, .btn-custom-toggle-indigo:not(:disabled):not(.disabled).active, .btn-custom-toggle-indigo:not(:disabled):not(.disabled):active, .btn-custom-toggle-indigo:not(:disabled):not(.disabled).active {
  color: #fff;
  background-color: #2d1582;
  border-color: #2d1582;
}

.btn-custom-toggle-light {
  color: rgba(255, 255, 255, 0.7);
  border-color: rgba(255, 255, 255, 0.7);
}

/*------------------------------------
  Soft Button Styles
------------------------------------*/
.btn-soft-primary {
  color: #377dff;
  background-color: rgba(55, 125, 255, 0.1);
  border-color: transparent;
}

.btn-soft-primary:hover, .btn-soft-primary:focus, .btn-soft-primary:active, .btn-soft-primary.active {
  color: #fff;
  background-color: #377dff;
  box-shadow: 0 4px 11px rgba(55, 125, 255, 0.1);
}

.btn-soft-primary.disabled, .btn-soft-primary:disabled {
  color: #377dff;
  background-color: rgba(55, 125, 255, 0.1);
  box-shadow: none;
}

.btn-soft-primary:not(:disabled):not(.disabled):active, .btn-soft-primary:not(:disabled):not(.disabled).active,
.show > .btn-soft-primary.dropdown-toggle {
  color: #fff;
  background-color: #377dff;
}

.btn-soft-secondary {
  color: #71869d;
  background-color: rgba(113, 134, 157, 0.1);
  border-color: transparent;
}

.btn-soft-secondary:hover, .btn-soft-secondary:focus, .btn-soft-secondary:active, .btn-soft-secondary.active {
  color: #fff;
  background-color: #71869d;
  box-shadow: 0 4px 11px rgba(113, 134, 157, 0.1);
}

.btn-soft-secondary.disabled, .btn-soft-secondary:disabled {
  color: #71869d;
  background-color: rgba(113, 134, 157, 0.1);
  box-shadow: none;
}

.btn-soft-secondary:not(:disabled):not(.disabled):active, .btn-soft-secondary:not(:disabled):not(.disabled).active,
.show > .btn-soft-secondary.dropdown-toggle {
  color: #fff;
  background-color: #71869d;
}

.btn-soft-success {
  color: #00c9a7;
  background-color: rgba(0, 201, 167, 0.1);
  border-color: transparent;
}

.btn-soft-success:hover, .btn-soft-success:focus, .btn-soft-success:active, .btn-soft-success.active {
  color: #fff;
  background-color: #00c9a7;
  box-shadow: 0 4px 11px rgba(0, 201, 167, 0.1);
}

.btn-soft-success.disabled, .btn-soft-success:disabled {
  color: #00c9a7;
  background-color: rgba(0, 201, 167, 0.1);
  box-shadow: none;
}

.btn-soft-success:not(:disabled):not(.disabled):active, .btn-soft-success:not(:disabled):not(.disabled).active,
.show > .btn-soft-success.dropdown-toggle {
  color: #fff;
  background-color: #00c9a7;
}

.btn-soft-info {
  color: #09a5be;
  background-color: rgba(9, 165, 190, 0.1);
  border-color: transparent;
}

.btn-soft-info:hover, .btn-soft-info:focus, .btn-soft-info:active, .btn-soft-info.active {
  color: #fff;
  background-color: #09a5be;
  box-shadow: 0 4px 11px rgba(9, 165, 190, 0.1);
}

.btn-soft-info.disabled, .btn-soft-info:disabled {
  color: #09a5be;
  background-color: rgba(9, 165, 190, 0.1);
  box-shadow: none;
}

.btn-soft-info:not(:disabled):not(.disabled):active, .btn-soft-info:not(:disabled):not(.disabled).active,
.show > .btn-soft-info.dropdown-toggle {
  color: #fff;
  background-color: #09a5be;
}

.btn-soft-warning {
  color: #f5ca99;
  background-color: rgba(245, 202, 153, 0.1);
  border-color: transparent;
}

.btn-soft-warning:hover, .btn-soft-warning:focus, .btn-soft-warning:active, .btn-soft-warning.active {
  color: #1e2022;
  background-color: #f5ca99;
  box-shadow: 0 4px 11px rgba(245, 202, 153, 0.1);
}

.btn-soft-warning.disabled, .btn-soft-warning:disabled {
  color: #f5ca99;
  background-color: rgba(245, 202, 153, 0.1);
  box-shadow: none;
}

.btn-soft-warning:not(:disabled):not(.disabled):active, .btn-soft-warning:not(:disabled):not(.disabled).active,
.show > .btn-soft-warning.dropdown-toggle {
  color: #1e2022;
  background-color: #f5ca99;
}

.btn-soft-danger {
  color: #ed4c78;
  background-color: rgba(237, 76, 120, 0.1);
  border-color: transparent;
}

.btn-soft-danger:hover, .btn-soft-danger:focus, .btn-soft-danger:active, .btn-soft-danger.active {
  color: #fff;
  background-color: #ed4c78;
  box-shadow: 0 4px 11px rgba(237, 76, 120, 0.1);
}

.btn-soft-danger.disabled, .btn-soft-danger:disabled {
  color: #ed4c78;
  background-color: rgba(237, 76, 120, 0.1);
  box-shadow: none;
}

.btn-soft-danger:not(:disabled):not(.disabled):active, .btn-soft-danger:not(:disabled):not(.disabled).active,
.show > .btn-soft-danger.dropdown-toggle {
  color: #fff;
  background-color: #ed4c78;
}

.btn-soft-light {
  color: #f7faff;
  background-color: rgba(247, 250, 255, 0.1);
  border-color: transparent;
}

.btn-soft-light:hover, .btn-soft-light:focus, .btn-soft-light:active, .btn-soft-light.active {
  color: #1e2022;
  background-color: #f7faff;
  box-shadow: 0 4px 11px rgba(247, 250, 255, 0.1);
}

.btn-soft-light.disabled, .btn-soft-light:disabled {
  color: #f7faff;
  background-color: rgba(247, 250, 255, 0.1);
  box-shadow: none;
}

.btn-soft-light:not(:disabled):not(.disabled):active, .btn-soft-light:not(:disabled):not(.disabled).active,
.show > .btn-soft-light.dropdown-toggle {
  color: #1e2022;
  background-color: #f7faff;
}

.btn-soft-dark {
  color: #21325b;
  background-color: rgba(33, 50, 91, 0.1);
  border-color: transparent;
}

.btn-soft-dark:hover, .btn-soft-dark:focus, .btn-soft-dark:active, .btn-soft-dark.active {
  color: #fff;
  background-color: #21325b;
  box-shadow: 0 4px 11px rgba(33, 50, 91, 0.1);
}

.btn-soft-dark.disabled, .btn-soft-dark:disabled {
  color: #21325b;
  background-color: rgba(33, 50, 91, 0.1);
  box-shadow: none;
}

.btn-soft-dark:not(:disabled):not(.disabled):active, .btn-soft-dark:not(:disabled):not(.disabled).active,
.show > .btn-soft-dark.dropdown-toggle {
  color: #fff;
  background-color: #21325b;
}

.btn-soft-indigo {
  color: #2d1582;
  background-color: rgba(45, 21, 130, 0.1);
  border-color: transparent;
}

.btn-soft-indigo:hover, .btn-soft-indigo:focus, .btn-soft-indigo:active, .btn-soft-indigo.active {
  color: #fff;
  background-color: #2d1582;
  box-shadow: 0 4px 11px rgba(45, 21, 130, 0.1);
}

.btn-soft-indigo.disabled, .btn-soft-indigo:disabled {
  color: #2d1582;
  background-color: rgba(45, 21, 130, 0.1);
  box-shadow: none;
}

.btn-soft-indigo:not(:disabled):not(.disabled):active, .btn-soft-indigo:not(:disabled):not(.disabled).active,
.show > .btn-soft-indigo.dropdown-toggle {
  color: #fff;
  background-color: #2d1582;
}

.btn-soft-primary.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___}) no-repeat right center/1rem 1rem;
  transition: all 0.2s ease-in-out;
}

.btn-soft-primary:hover.dropdown-toggle::after, .btn-soft-primary:focus.dropdown-toggle::after, .btn-soft-primary.focus.dropdown-toggle::after, .btn-soft-primary:active.dropdown-toggle::after, .btn-soft-primary.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-soft-secondary.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat right center/1rem 1rem;
  transition: all 0.2s ease-in-out;
}

.btn-soft-secondary:hover.dropdown-toggle::after, .btn-soft-secondary:focus.dropdown-toggle::after, .btn-soft-secondary.focus.dropdown-toggle::after, .btn-soft-secondary:active.dropdown-toggle::after, .btn-soft-secondary.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-soft-success.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) no-repeat right center/1rem 1rem;
  transition: all 0.2s ease-in-out;
}

.btn-soft-success:hover.dropdown-toggle::after, .btn-soft-success:focus.dropdown-toggle::after, .btn-soft-success.focus.dropdown-toggle::after, .btn-soft-success:active.dropdown-toggle::after, .btn-soft-success.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-soft-info.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) no-repeat right center/1rem 1rem;
  transition: all 0.2s ease-in-out;
}

.btn-soft-info:hover.dropdown-toggle::after, .btn-soft-info:focus.dropdown-toggle::after, .btn-soft-info.focus.dropdown-toggle::after, .btn-soft-info:active.dropdown-toggle::after, .btn-soft-info.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-soft-warning.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) no-repeat right center/1rem 1rem;
  transition: all 0.2s ease-in-out;
}

.btn-soft-warning:hover.dropdown-toggle::after, .btn-soft-warning:focus.dropdown-toggle::after, .btn-soft-warning.focus.dropdown-toggle::after, .btn-soft-warning:active.dropdown-toggle::after, .btn-soft-warning.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat right center/1rem 1rem;
}

.btn-soft-danger.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___}) no-repeat right center/1rem 1rem;
  transition: all 0.2s ease-in-out;
}

.btn-soft-danger:hover.dropdown-toggle::after, .btn-soft-danger:focus.dropdown-toggle::after, .btn-soft-danger.focus.dropdown-toggle::after, .btn-soft-danger:active.dropdown-toggle::after, .btn-soft-danger.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-soft-light.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) no-repeat right center/1rem 1rem;
  transition: all 0.2s ease-in-out;
}

.btn-soft-light:hover.dropdown-toggle::after, .btn-soft-light:focus.dropdown-toggle::after, .btn-soft-light.focus.dropdown-toggle::after, .btn-soft-light:active.dropdown-toggle::after, .btn-soft-light.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___}) no-repeat right center/1rem 1rem;
}

.btn-soft-dark.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___}) no-repeat right center/1rem 1rem;
  transition: all 0.2s ease-in-out;
}

.btn-soft-dark:hover.dropdown-toggle::after, .btn-soft-dark:focus.dropdown-toggle::after, .btn-soft-dark.focus.dropdown-toggle::after, .btn-soft-dark:active.dropdown-toggle::after, .btn-soft-dark.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

.btn-soft-indigo.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) no-repeat right center/1rem 1rem;
  transition: all 0.2s ease-in-out;
}

.btn-soft-indigo:hover.dropdown-toggle::after, .btn-soft-indigo:focus.dropdown-toggle::after, .btn-soft-indigo.focus.dropdown-toggle::after, .btn-soft-indigo:active.dropdown-toggle::after, .btn-soft-indigo.active.dropdown-toggle::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) no-repeat right center/1rem 1rem;
}

/*------------------------------------
  Outline Button Styles
------------------------------------*/
.btn-outline-secondary {
  border-color: #e7eaf3;
}

/*------------------------------------
  Button Sizes
------------------------------------*/
/* Wide */
.btn-wide {
  min-width: 10rem;
}

/* Extra Small */
.btn-xs {
  font-size: 0.75rem;
  font-weight: 400;
  padding: 0.275rem 0.75rem;
}

/* Icons */
.btn-icon.btn-xs {
  font-size: 0.75rem;
  width: 1.75rem;
  height: 1.75rem;
}

.btn-icon.btn-sm, .btn-group-sm > .btn-icon.btn {
  font-size: 0.8125rem;
  width: 2.6875rem;
  height: 2.6875rem;
}

.btn-icon.btn-lg, .btn-group-lg > .btn-icon.btn {
  font-size: 1.25rem;
  width: 4.25rem;
  height: 4.25rem;
}

/*------------------------------------
  Ghost Buttons Styles
------------------------------------*/
/* primary ghost button */
.btn-ghost-primary {
  color: #377dff;
  background-color: transparent;
}

.btn-ghost-primary:hover, .btn-ghost-primary:focus, .btn-ghost-primary:active, .btn-ghost-primary.active {
  color: #377dff;
  background-color: rgba(55, 125, 255, 0.1);
}

/* secondary ghost button */
.btn-ghost-secondary {
  color: #71869d;
  background-color: transparent;
}

.btn-ghost-secondary:hover, .btn-ghost-secondary:focus, .btn-ghost-secondary:active, .btn-ghost-secondary.active {
  color: #71869d;
  background-color: rgba(55, 125, 255, 0.1);
}

/* success ghost button */
.btn-ghost-success {
  color: #00c9a7;
  background-color: transparent;
}

.btn-ghost-success:hover, .btn-ghost-success:focus, .btn-ghost-success:active, .btn-ghost-success.active {
  color: #00c9a7;
  background-color: rgba(0, 201, 167, 0.1);
}

/* info ghost button */
.btn-ghost-info {
  color: #09a5be;
  background-color: transparent;
}

.btn-ghost-info:hover, .btn-ghost-info:focus, .btn-ghost-info:active, .btn-ghost-info.active {
  color: #09a5be;
  background-color: rgba(9, 165, 190, 0.1);
}

/* warning ghost button */
.btn-ghost-warning {
  color: #f5ca99;
  background-color: transparent;
}

.btn-ghost-warning:hover, .btn-ghost-warning:focus, .btn-ghost-warning:active, .btn-ghost-warning.active {
  color: #f5ca99;
  background-color: rgba(245, 202, 153, 0.1);
}

/* danger ghost button */
.btn-ghost-danger {
  color: #ed4c78;
  background-color: transparent;
}

.btn-ghost-danger:hover, .btn-ghost-danger:focus, .btn-ghost-danger:active, .btn-ghost-danger.active {
  color: #ed4c78;
  background-color: rgba(237, 76, 120, 0.1);
}

/* light ghost button */
.btn-ghost-light {
  color: #f7faff;
  background-color: transparent;
}

.btn-ghost-light:hover, .btn-ghost-light:focus, .btn-ghost-light:active, .btn-ghost-light.active {
  color: #f7faff;
  background-color: rgba(247, 250, 255, 0.1);
}

/* dark ghost button */
.btn-ghost-dark {
  color: #21325b;
  background-color: transparent;
}

.btn-ghost-dark:hover, .btn-ghost-dark:focus, .btn-ghost-dark:active, .btn-ghost-dark.active {
  color: #21325b;
  background-color: rgba(33, 50, 91, 0.1);
}

/* indigo ghost button */
.btn-ghost-indigo {
  color: #2d1582;
  background-color: transparent;
}

.btn-ghost-indigo:hover, .btn-ghost-indigo:focus, .btn-ghost-indigo:active, .btn-ghost-indigo.active {
  color: #2d1582;
  background-color: rgba(45, 21, 130, 0.1);
}

.btn-ghost-secondary:hover, .btn-ghost-secondary:focus, .btn-ghost-secondary:active {
  color: #377dff;
}

/*------------------------------------
  Button Groups
------------------------------------*/
.btn-group-segment {
  position: relative;
  display: inline-flex;
  justify-content: center;
  background-color: #f8fafd;
  border-radius: 0.3125rem;
  padding: 0.25rem 0.25rem;
}

.btn-group-segment .btn {
  color: #677788;
}

.btn-group-segment .btn:not(:last-child) {
  margin-right: 0.25rem;
}

.btn-group-segment .btn:hover {
  color: #377dff;
}

.btn-group-segment .btn.active {
  color: #1e2022;
  background-color: #fff;
  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);
}

.btn-group-segment .btn:not(:disabled):not(.disabled):active, .btn-group-segment .btn:not(:disabled):not(.disabled).active {
  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);
}

.btn-group-segment > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-segment > .btn-group:not(:last-child) > .btn,
.btn-group-segment > .btn:not(:first-child),
.btn-group-segment > .btn-group:not(:first-child) > .btn {
  border-radius: 0.3125rem;
}

.btn-group-segment.btn-group-pills {
  border-radius: 6.1875rem;
}

.btn-group-segment.btn-group-pills > .btn:not(:last-child):not(.dropdown-toggle),
.btn-group-segment.btn-group-pills > .btn-group:not(:last-child) > .btn,
.btn-group-segment.btn-group-pills > .btn:not(:first-child),
.btn-group-segment.btn-group-pills > .btn-group:not(:first-child) > .btn {
  border-radius: 6.1875rem;
}

/*------------------------------------
  Button Status
------------------------------------*/
.btn-status {
  position: absolute;
  top: -0.4375rem;
  right: -0.4375rem;
  display: inline-block;
  white-space: nowrap;
  text-align: center;
  vertical-align: baseline;
  width: 1.3125rem;
  height: 1.3125rem;
  line-height: 1;
  font-size: 0.625rem;
  border-radius: 50%;
}

.btn-status-initials {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

/*------------------------------------
  Buttons
------------------------------------*/
.btn svg {
  margin-bottom: 0;
}

label.btn {
  cursor: pointer !important;
}

.btn-pill {
  border-radius: 6.1875rem;
}

.btn-link {
  font-weight: 600;
}

.btn-icon {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  font-weight: 400;
  width: 3.125rem;
  height: 3.125rem;
  padding: 0;
}

/* Toggle */
.btn-toggle-default {
  display: inline-block;
}

.btn-toggle-toggled {
  display: none;
}

.btn.toggled .btn-toggle-default {
  display: none;
}

.btn.toggled .btn-toggle-toggled {
  display: inline-block;
}

/*------------------------------------
  Brand
------------------------------------*/
.brand {
  width: 100%;
  max-width: 7.5rem;
}

/*------------------------------------
  Breadcrumb
------------------------------------*/
.breadcrumb .breadcrumb-item {
  color: #1e2022;
  font-size: 0.875rem;
}

.breadcrumb .breadcrumb-link {
  color: #8c98a4;
}

.breadcrumb .breadcrumb-link:hover {
  color: #0052ea;
}

.breadcrumb-light .breadcrumb-item {
  color: #fff;
}

.breadcrumb-light .breadcrumb-item + .breadcrumb-item::before {
  color: rgba(255, 255, 255, 0.5);
}

.breadcrumb-light .breadcrumb-link {
  color: rgba(255, 255, 255, 0.5);
}

.breadcrumb-light .breadcrumb-link:hover {
  color: #fff;
}

.breadcrumb-no-gutter {
  padding: 0;
}

/*------------------------------------
  Card
------------------------------------*/
.card-2-count {
  column-count: 2;
}

.card-3-count {
  column-count: 3;
}

.card-4-count {
  column-count: 4;
}

.card-1-gap {
  column-gap: 0.5rem;
}

.card-2-gap {
  column-gap: 2rem;
}

.card-3-gap {
  column-gap: 3rem;
}

.card-4-gap {
  column-gap: 4rem;
}

.card-5-gap {
  column-gap: 5rem;
}

.card-columns {
  orphans: 1;
  widows: 1;
}

.card-columns .card {
  display: inline-block;
  width: 100%;
}

@media (min-width: 576px) {
  .card-sm-2-count {
    column-count: 2;
  }
  .card-sm-3-count {
    column-count: 3;
  }
  .card-sm-4-count {
    column-count: 4;
  }
  .card-sm-1-gap {
    column-gap: 0.5rem;
  }
  .card-sm-2-gap {
    column-gap: 2rem;
  }
  .card-sm-3-gap {
    column-gap: 3rem;
  }
  .card-sm-4-gap {
    column-gap: 4rem;
  }
  .card-sm-5-gap {
    column-gap: 5rem;
  }
  .card-sm-columns {
    orphans: 1;
    widows: 1;
  }
  .card-sm-columns .card {
    display: inline-block;
    width: 100%;
  }
}

@media (min-width: 768px) {
  .card-md-2-count {
    column-count: 2;
  }
  .card-md-3-count {
    column-count: 3;
  }
  .card-md-4-count {
    column-count: 4;
  }
  .card-md-1-gap {
    column-gap: 0.5rem;
  }
  .card-md-2-gap {
    column-gap: 2rem;
  }
  .card-md-3-gap {
    column-gap: 3rem;
  }
  .card-md-4-gap {
    column-gap: 4rem;
  }
  .card-md-5-gap {
    column-gap: 5rem;
  }
  .card-md-columns {
    orphans: 1;
    widows: 1;
  }
  .card-md-columns .card {
    display: inline-block;
    width: 100%;
  }
}

@media (min-width: 992px) {
  .card-lg-2-count {
    column-count: 2;
  }
  .card-lg-3-count {
    column-count: 3;
  }
  .card-lg-4-count {
    column-count: 4;
  }
  .card-lg-1-gap {
    column-gap: 0.5rem;
  }
  .card-lg-2-gap {
    column-gap: 2rem;
  }
  .card-lg-3-gap {
    column-gap: 3rem;
  }
  .card-lg-4-gap {
    column-gap: 4rem;
  }
  .card-lg-5-gap {
    column-gap: 5rem;
  }
  .card-lg-columns {
    orphans: 1;
    widows: 1;
  }
  .card-lg-columns .card {
    display: inline-block;
    width: 100%;
  }
}

@media (min-width: 1200px) {
  .card-xl-2-count {
    column-count: 2;
  }
  .card-xl-3-count {
    column-count: 3;
  }
  .card-xl-4-count {
    column-count: 4;
  }
  .card-xl-1-gap {
    column-gap: 0.5rem;
  }
  .card-xl-2-gap {
    column-gap: 2rem;
  }
  .card-xl-3-gap {
    column-gap: 3rem;
  }
  .card-xl-4-gap {
    column-gap: 4rem;
  }
  .card-xl-5-gap {
    column-gap: 5rem;
  }
  .card-xl-columns {
    orphans: 1;
    widows: 1;
  }
  .card-xl-columns .card {
    display: inline-block;
    width: 100%;
  }
}

.card {
  border-width: 0;
  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
}

.card-title {
  display: block;
  margin-bottom: 0;
}

.card-subtitle {
  display: block;
  color: #8c98a4;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.03125rem;
  margin-top: 0;
  margin-bottom: 0.5rem;
}

.card-text {
  display: block;
  color: #677788;
}

.card-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.card-header-title {
  margin-bottom: 0;
}

.card-footer {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

@media (min-width: 576px) {
  .card-group > .card + .card {
    border-left: 0.0625rem solid rgba(231, 234, 243, 0.7);
  }
}

/* Background Color */
.card-bg-light {
  background-color: #f8fafd;
}

.card-bg-light:hover {
  background-color: #f4f7fc;
}

/* Frame */
.card-frame {
  border: 0.0625rem solid rgba(231, 234, 243, 0.7);
  box-shadow: none;
  transition: 0.3s;
}

.card-frame-highlighted, .card-frame:hover {
  border-color: rgba(55, 125, 255, 0.7);
}

/* Shadow On Hover */
.card-hover-shadow {
  transition: 0.3s;
}

.card-hover-shadow:hover {
  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.175);
}

/* Collapse */
.card-collapse {
  padding: 0;
  transition: 0.3s ease-in-out;
}

.card-collapse:hover {
  background-color: #f8fafd;
}

.card-collapse .card-body {
  color: #677788;
}

.card-btn {
  color: #1e2022;
  text-align: left;
  white-space: inherit;
  border-radius: 0.75rem;
}

.card-btn-toggle {
  display: inline-block;
  color: #377dff;
}

.card-btn-toggle-default {
  display: none;
}

.card-btn-toggle-active {
  display: block;
}

.card-btn.collapsed .card-btn-toggle-default {
  display: block;
}

.card-btn.collapsed .card-btn-toggle-active {
  display: none;
}

.card-body-centered {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

/* Dashed */
.card-dashed {
  border-width: 0;
  min-height: 10rem;
}

.card-dashed:hover {
  border-color: rgba(55, 125, 255, 0.7);
}

.card-dashed:hover .card-dashed-body {
  color: #0052ea;
}

.card-dashed .card-dashed-body {
  color: #8c98a4;
  border: 0.0625rem dashed rgba(214, 219, 235, 0.7);
  border-radius: 0.75rem;
  transition: 0.3s;
}

/* Bordered */
.card-bordered {
  border-width: 0.0625rem;
}

/* IE image rendering fix */
.card-img-top,
.card-img-bottom {
  min-height: 1px;
}

/* Table */
.card .table {
  margin-bottom: 1px;
}

.card .table th, .card .table td {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}

.card .table-thead-bordered {
  margin-top: -0.0625rem;
}

/* Dropdown */
.card-dropdown {
  position: absolute;
  top: 1rem;
  right: 1rem;
}

/* No Gutters */
.card-no-gutters {
  box-shadow: none;
}

.card-no-gutters > .card-header,
.card-no-gutters > .card-body {
  padding-right: 0;
  padding-left: 0;
}

.card-no-gutters > .card-footer {
  border-width: 0;
  padding: 0;
}

/*------------------------------------
  Card Gutters
------------------------------------*/
@media (min-width: 576px) {
  .card-sm-gutters-1 {
    margin-right: -.25rem;
    margin-left: -.25rem;
  }
  .card-sm-gutters-1 .card {
    margin-right: .25rem;
    margin-left: .25rem;
  }
  .card-sm-gutters-2 {
    margin-right: -.5rem;
    margin-left: -.5rem;
  }
  .card-sm-gutters-2 .card {
    margin-right: .5rem;
    margin-left: .5rem;
  }
  .card-sm-gutters-3 {
    margin-right: -.9375rem;
    margin-left: -.9375rem;
  }
  .card-sm-gutters-3 .card {
    margin-right: .9375rem;
    margin-left: .9375rem;
  }
}

@media (min-width: 768px) {
  .card-md-gutters-1 {
    margin-right: -.25rem;
    margin-left: -.25rem;
  }
  .card-md-gutters-1 .card {
    margin-right: .25rem;
    margin-left: .25rem;
  }
  .card-md-gutters-2 {
    margin-right: -.5rem;
    margin-left: -.5rem;
  }
  .card-md-gutters-2 .card {
    margin-right: .5rem;
    margin-left: .5rem;
  }
  .card-md-gutters-3 {
    margin-right: -.9375rem;
    margin-left: -.9375rem;
  }
  .card-md-gutters-3 .card {
    margin-right: .9375rem;
    margin-left: .9375rem;
  }
}

@media (min-width: 992px) {
  .card-lg-gutters-1 {
    margin-right: -.25rem;
    margin-left: -.25rem;
  }
  .card-lg-gutters-1 .card {
    margin-right: .25rem;
    margin-left: .25rem;
  }
  .card-lg-gutters-2 {
    margin-right: -.5rem;
    margin-left: -.5rem;
  }
  .card-lg-gutters-2 .card {
    margin-right: .5rem;
    margin-left: .5rem;
  }
  .card-lg-gutters-3 {
    margin-right: -.9375rem;
    margin-left: -.9375rem;
  }
  .card-lg-gutters-3 .card {
    margin-right: .9375rem;
    margin-left: .9375rem;
  }
}

/*------------------------------------
  Card Group - Break
------------------------------------*/
@media (max-width: 767.98px) {
  .card-group-sm-break {
    display: block;
  }
  .card-group-sm-break > .card:not(:last-child) {
    margin-bottom: -1px;
  }
  .card-group-sm-break > .card + .card {
    border-left: 0.0625rem solid rgba(231, 234, 243, 0.7);
  }
  .card-group-sm-break > .card:first-child {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group-sm-break > .card:first-child .card-img-top,
  .card-group-sm-break > .card:first-child .card-header {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
  }
  .card-group-sm-break > .card:first-child .card-img-bottom,
  .card-group-sm-break > .card:first-child .card-footer {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group-sm-break > .card:last-child {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .card-group-sm-break > .card:last-child .card-img-top,
  .card-group-sm-break > .card:last-child .card-header {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .card-group-sm-break > .card:last-child .card-img-bottom,
  .card-group-sm-break > .card:last-child .card-footer {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
}

@media (max-width: 991.98px) {
  .card-group-md-break {
    display: block;
  }
  .card-group-md-break > .card:not(:last-child) {
    margin-bottom: -1px;
  }
  .card-group-md-break > .card + .card {
    border-left: 0.0625rem solid rgba(231, 234, 243, 0.7);
  }
  .card-group-md-break > .card:first-child {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group-md-break > .card:first-child .card-img-top,
  .card-group-md-break > .card:first-child .card-header {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
  }
  .card-group-md-break > .card:first-child .card-img-bottom,
  .card-group-md-break > .card:first-child .card-footer {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group-md-break > .card:last-child {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .card-group-md-break > .card:last-child .card-img-top,
  .card-group-md-break > .card:last-child .card-header {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .card-group-md-break > .card:last-child .card-img-bottom,
  .card-group-md-break > .card:last-child .card-footer {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
}

@media (max-width: 1199.98px) {
  .card-group-lg-break {
    display: block;
  }
  .card-group-lg-break > .card:not(:last-child) {
    margin-bottom: -1px;
  }
  .card-group-lg-break > .card + .card {
    border-left: 0.0625rem solid rgba(231, 234, 243, 0.7);
  }
  .card-group-lg-break > .card:first-child {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group-lg-break > .card:first-child .card-img-top,
  .card-group-lg-break > .card:first-child .card-header {
    border-top-left-radius: 0.75rem;
    border-top-right-radius: 0.75rem;
  }
  .card-group-lg-break > .card:first-child .card-img-bottom,
  .card-group-lg-break > .card:first-child .card-footer {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .card-group-lg-break > .card:last-child {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .card-group-lg-break > .card:last-child .card-img-top,
  .card-group-lg-break > .card:last-child .card-header {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }
  .card-group-lg-break > .card:last-child .card-img-bottom,
  .card-group-lg-break > .card:last-child .card-footer {
    border-bottom-right-radius: 0.75rem;
    border-bottom-left-radius: 0.75rem;
  }
}

/*------------------------------------
  Sidebar Navigation
------------------------------------*/
.sidebar {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 1003;
  width: 23.4375rem;
  height: 100%;
  background-color: #fff;
  box-shadow: -5px 0px 12px rgba(103, 119, 136, 0.1);
}

.sidebar-body, .sidebar-content {
  height: 100%;
}

.sidebar-left {
  right: auto;
  left: 0;
  box-shadow: 5px 0px 12px rgba(103, 119, 136, 0.1);
}

.sidebar-scroller {
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

.sidebar-container {
  position: relative;
  height: 100%;
  min-height: 100%;
}

.sidebar-footer {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
}

.sidebar-footer-offset {
  height: 100%;
  box-sizing: border-box;
}

/*------------------------------------
  Clients
------------------------------------*/
.clients {
  width: 100%;
  max-width: 6rem;
  height: auto;
  margin-left: auto;
  margin-right: auto;
}

/*------------------------------------
  Column Divider
------------------------------------*/
.column-divider {
  position: relative;
}

.column-divider::before {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  border-left: 0.0625rem solid #e7eaf3;
  content: "";
}

@media (min-width: 576px) {
  .column-divider-sm {
    position: relative;
  }
  .column-divider-sm::before {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border-left: 0.0625rem solid #e7eaf3;
    content: "";
  }
}

@media (min-width: 768px) {
  .column-divider-md {
    position: relative;
  }
  .column-divider-md::before {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border-left: 0.0625rem solid #e7eaf3;
    content: "";
  }
}

@media (min-width: 992px) {
  .column-divider-lg {
    position: relative;
  }
  .column-divider-lg::before {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border-left: 0.0625rem solid #e7eaf3;
    content: "";
  }
}

@media (min-width: 1200px) {
  .column-divider-xl {
    position: relative;
  }
  .column-divider-xl::before {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    border-left: 0.0625rem solid #e7eaf3;
    content: "";
  }
}

.column-divider-20deg::before {
  transform: rotate(20deg);
  left: -1rem;
}

/*------------------------------------
  Divider
------------------------------------*/
.divider {
  display: flex;
  align-items: center;
}

.divider::before, .divider::after {
  flex: 1 1;
  border-top: 0.0625rem solid #e7eaf3;
  content: "";
  margin-top: 0.0625rem;
}

.divider::before {
  margin-right: 1.5rem;
}

.divider::after {
  margin-left: 1.5rem;
}

/*------------------------------------
  Divider Styles
------------------------------------*/
/* Text */
.divider-text {
  color: #8c98a4;
}

/*------------------------------------
  Dropdown
------------------------------------*/
/* Menu */
.dropdown-menu {
  box-shadow: 0px 10px 40px 10px rgba(140, 152, 164, 0.175);
}

.dropdown-header {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
}

/* Nav Link */
.dropdown-nav-link {
  color: #1e2022;
  font-size: 0.875rem;
}

/* Item */
.dropdown-item {
  font-size: 0.875rem;
}

.dropdown-item:active {
  color: #1e2022;
  background-color: rgba(189, 197, 209, 0.3);
}

.dropdown-item.active:not(:focus):not(:active) {
  color: #1e2022;
  background-color: rgba(189, 197, 209, 0.3);
}

.dropdown-item-icon {
  display: inline-block;
  text-align: center;
  color: #677788;
  opacity: 0.7;
  font-size: 0.75rem;
  min-width: 1rem;
  max-width: 1rem;
  margin-right: 0.25rem;
}

/* Toggle */
.dropdown-toggle {
  display: flex;
  align-items: center;
}

.dropdown-toggle::after {
  display: inline-block;
  width: 1rem;
  height: 1rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) no-repeat right center/1rem 1rem;
  content: "";
}

.dropdown-toggle:not(.dropdown-toggle-empty)::after {
  margin-left: 0.5rem;
}

.dropdown-toggle-collapse::after {
  transition: 0.3s;
}

.dropdown-toggle-collapse[aria-expanded="true"]::after {
  transform: rotate(-180deg);
}

/* Card */
.dropdown-card {
  padding-top: 0;
  padding-bottom: 0;
}

/* Dropdown Positions */
.dropdown-menu-top {
  top: 0;
}

.dropdown-menu-bottom {
  top: auto;
  bottom: 0;
}

@media (min-width: 576px) {
  .dropdown-menu-sm-top {
    top: 0;
  }
  .dropdown-menu-sm-bottom {
    top: auto;
    bottom: 0;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-md-top {
    top: 0;
  }
  .dropdown-menu-md-bottom {
    top: auto;
    bottom: 0;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-lg-top {
    top: 0;
  }
  .dropdown-menu-lg-bottom {
    top: auto;
    bottom: 0;
  }
}

@media (min-width: 1200px) {
  .dropdown-menu-xl-top {
    top: 0;
  }
  .dropdown-menu-xl-bottom {
    top: auto;
    bottom: 0;
  }
}

/*------------------------------------
  Dropdown Card
------------------------------------*/
.dropdown-card {
  padding-top: 0;
  padding-bottom: 0;
  margin-bottom: 2rem;
}

@media (min-width: 768px) {
  .dropdown-card {
    min-width: 25rem;
  }
}

/*------------------------------------
  Dropdown Sizes
------------------------------------*/
@media (min-width: 576px) {
  .dropdown-menu-size-md {
    width: 440px;
  }
  .dropdown-menu-size-lg {
    width: 340px;
  }
}

@media (min-width: 768px) {
  .dropdown-menu-size-lg {
    width: 440px;
  }
}

@media (min-width: 992px) {
  .dropdown-menu-size-lg {
    width: 740px;
  }
}

/*------------------------------------
  Form
------------------------------------*/
.input-group .input-group-prepend,
.input-group .input-group-append {
  z-index: 4;
}

.custom-select:focus,
.form-control:focus {
  box-shadow: 0 0 10px rgba(55, 125, 255, 0.1);
}

.input-group-text {
  border-color: #e7eaf3;
}

/* Input Label */
.input-label {
  display: block;
  color: #1e2022;
  font-size: 0.875rem;
}

.input-label-secondary {
  color: #8c98a4;
  font-size: 0.875rem;
  margin-left: 0.25rem;
}

/* Form Link */
.form-link {
  display: inline-block;
  margin-top: 0.75rem;
}

/* Form Borderless */
.input-group-borderless .form-control,
.input-group-borderless .input-group-text {
  border: none;
}

.input-group-borderless .form-control:focus,
.input-group-borderless .input-group-text:focus {
  box-shadow: none;
}

.input-group-add-field {
  position: relative;
  margin-top: 1rem;
}

.input-group-add-field:hover .input-group-add-field-delete {
  opacity: 1;
}

.input-group-add-field-delete {
  position: absolute;
  top: 0.75rem;
  right: 0;
  width: 1rem;
  color: #ed4c78;
  opacity: 0;
  margin-right: -1rem;
  padding-left: 0.25rem;
}

.input-group-add-field-delete:hover {
  color: #ea2c60;
}

@media (max-width: 1199.98px) {
  .input-group-add-field-delete {
    opacity: 1;
  }
}

.input-group > .input-group-prepend .custom-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group > .input-group-append .custom-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

@media (max-width: 575.98px) {
  .input-group-sm-down-break {
    display: block;
  }
  .input-group-sm-down-break > .form-control,
  .input-group-sm-down-break > .custom-select {
    width: 100%;
  }
  .input-group-sm-down-break > .form-control:first-child,
  .input-group-sm-down-break > .custom-select:first-child {
    border-top-left-radius: 0.3125rem;
    border-top-right-radius: 0.3125rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .input-group-sm-down-break > .custom-select:not(:first-child):not(:last-child),
  .input-group-sm-down-break > .form-control:not(:first-child):not(:last-child) {
    border-radius: 0;
  }
  .input-group-sm-down-break > .custom-select:last-child,
  .input-group-sm-down-break > .form-control:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0.3125rem;
    border-bottom-left-radius: 0.3125rem;
  }
  .input-group-sm-down-break .form-control + .form-control,
  .input-group-sm-down-break .form-control + .custom-select,
  .input-group-sm-down-break .form-control + .custom-file,
  .input-group-sm-down-break .form-control-plaintext + .form-control,
  .input-group-sm-down-break .form-control-plaintext + .custom-select,
  .input-group-sm-down-break .form-control-plaintext + .custom-file,
  .input-group-sm-down-break .custom-select + .form-control,
  .input-group-sm-down-break .custom-select + .custom-select,
  .input-group-sm-down-break .custom-select + .custom-file,
  .input-group-sm-down-break .custom-file + .form-control,
  .input-group-sm-down-break .custom-file + .custom-select,
  .input-group-sm-down-break .custom-file + .custom-file {
    margin-left: 0;
    margin-top: -0.0625rem;
  }
}

@media (max-width: 767.98px) {
  .input-group-md-down-break {
    display: block;
  }
  .input-group-md-down-break > .form-control,
  .input-group-md-down-break > .custom-select {
    width: 100%;
  }
  .input-group-md-down-break > .form-control:first-child,
  .input-group-md-down-break > .custom-select:first-child {
    border-top-left-radius: 0.3125rem;
    border-top-right-radius: 0.3125rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .input-group-md-down-break > .custom-select:not(:first-child):not(:last-child),
  .input-group-md-down-break > .form-control:not(:first-child):not(:last-child) {
    border-radius: 0;
  }
  .input-group-md-down-break > .custom-select:last-child,
  .input-group-md-down-break > .form-control:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0.3125rem;
    border-bottom-left-radius: 0.3125rem;
  }
  .input-group-md-down-break .form-control + .form-control,
  .input-group-md-down-break .form-control + .custom-select,
  .input-group-md-down-break .form-control + .custom-file,
  .input-group-md-down-break .form-control-plaintext + .form-control,
  .input-group-md-down-break .form-control-plaintext + .custom-select,
  .input-group-md-down-break .form-control-plaintext + .custom-file,
  .input-group-md-down-break .custom-select + .form-control,
  .input-group-md-down-break .custom-select + .custom-select,
  .input-group-md-down-break .custom-select + .custom-file,
  .input-group-md-down-break .custom-file + .form-control,
  .input-group-md-down-break .custom-file + .custom-select,
  .input-group-md-down-break .custom-file + .custom-file {
    margin-left: 0;
    margin-top: -0.0625rem;
  }
}

@media (max-width: 991.98px) {
  .input-group-lg-down-break {
    display: block;
  }
  .input-group-lg-down-break > .form-control,
  .input-group-lg-down-break > .custom-select {
    width: 100%;
  }
  .input-group-lg-down-break > .form-control:first-child,
  .input-group-lg-down-break > .custom-select:first-child {
    border-top-left-radius: 0.3125rem;
    border-top-right-radius: 0.3125rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .input-group-lg-down-break > .custom-select:not(:first-child):not(:last-child),
  .input-group-lg-down-break > .form-control:not(:first-child):not(:last-child) {
    border-radius: 0;
  }
  .input-group-lg-down-break > .custom-select:last-child,
  .input-group-lg-down-break > .form-control:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0.3125rem;
    border-bottom-left-radius: 0.3125rem;
  }
  .input-group-lg-down-break .form-control + .form-control,
  .input-group-lg-down-break .form-control + .custom-select,
  .input-group-lg-down-break .form-control + .custom-file,
  .input-group-lg-down-break .form-control-plaintext + .form-control,
  .input-group-lg-down-break .form-control-plaintext + .custom-select,
  .input-group-lg-down-break .form-control-plaintext + .custom-file,
  .input-group-lg-down-break .custom-select + .form-control,
  .input-group-lg-down-break .custom-select + .custom-select,
  .input-group-lg-down-break .custom-select + .custom-file,
  .input-group-lg-down-break .custom-file + .form-control,
  .input-group-lg-down-break .custom-file + .custom-select,
  .input-group-lg-down-break .custom-file + .custom-file {
    margin-left: 0;
    margin-top: -0.0625rem;
  }
}

@media (max-width: 1199.98px) {
  .input-group-xl-down-break {
    display: block;
  }
  .input-group-xl-down-break > .form-control,
  .input-group-xl-down-break > .custom-select {
    width: 100%;
  }
  .input-group-xl-down-break > .form-control:first-child,
  .input-group-xl-down-break > .custom-select:first-child {
    border-top-left-radius: 0.3125rem;
    border-top-right-radius: 0.3125rem;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
  }
  .input-group-xl-down-break > .custom-select:not(:first-child):not(:last-child),
  .input-group-xl-down-break > .form-control:not(:first-child):not(:last-child) {
    border-radius: 0;
  }
  .input-group-xl-down-break > .custom-select:last-child,
  .input-group-xl-down-break > .form-control:last-child {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0.3125rem;
    border-bottom-left-radius: 0.3125rem;
  }
  .input-group-xl-down-break .form-control + .form-control,
  .input-group-xl-down-break .form-control + .custom-select,
  .input-group-xl-down-break .form-control + .custom-file,
  .input-group-xl-down-break .form-control-plaintext + .form-control,
  .input-group-xl-down-break .form-control-plaintext + .custom-select,
  .input-group-xl-down-break .form-control-plaintext + .custom-file,
  .input-group-xl-down-break .custom-select + .form-control,
  .input-group-xl-down-break .custom-select + .custom-select,
  .input-group-xl-down-break .custom-select + .custom-file,
  .input-group-xl-down-break .custom-file + .form-control,
  .input-group-xl-down-break .custom-file + .custom-select,
  .input-group-xl-down-break .custom-file + .custom-file {
    margin-left: 0;
    margin-top: -0.0625rem;
  }
}

.input-group-down-break {
  display: block;
}

.input-group-down-break > .form-control,
.input-group-down-break > .custom-select {
  width: 100%;
}

.input-group-down-break > .form-control:first-child,
.input-group-down-break > .custom-select:first-child {
  border-top-left-radius: 0.3125rem;
  border-top-right-radius: 0.3125rem;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group-down-break > .custom-select:not(:first-child):not(:last-child),
.input-group-down-break > .form-control:not(:first-child):not(:last-child) {
  border-radius: 0;
}

.input-group-down-break > .custom-select:last-child,
.input-group-down-break > .form-control:last-child {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
}

.input-group-down-break .form-control + .form-control,
.input-group-down-break .form-control + .custom-select,
.input-group-down-break .form-control + .custom-file,
.input-group-down-break .form-control-plaintext + .form-control,
.input-group-down-break .form-control-plaintext + .custom-select,
.input-group-down-break .form-control-plaintext + .custom-file,
.input-group-down-break .custom-select + .form-control,
.input-group-down-break .custom-select + .custom-select,
.input-group-down-break .custom-select + .custom-file,
.input-group-down-break .custom-file + .form-control,
.input-group-down-break .custom-file + .custom-select,
.input-group-down-break .custom-file + .custom-file {
  margin-left: 0;
  margin-top: -0.0625rem;
}

/*------------------------------------
  Merge
------------------------------------*/
.input-group-merge {
  position: relative;
}

.input-group-merge .input-group-prepend,
.input-group-merge .input-group-append {
  position: absolute;
  top: 0;
  bottom: 0;
}

.input-group-merge .input-group-prepend {
  left: 0;
}

.input-group-merge .input-group-prepend .input-group-text {
  padding: 0 0 0 1rem;
}

.input-group-merge .input-group-prepend .input-group-text:first-child {
  border-top-left-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.input-group-merge .input-group-append {
  right: 0;
}

.input-group-merge .input-group-append .input-group-text {
  padding: 0 1rem 0 0;
}

.input-group-merge .input-group-append .input-group-text:last-child {
  border-top-right-radius: 0.3125rem;
  border-bottom-right-radius: 0.3125rem;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.input-group-merge .input-group-text {
  z-index: 4;
  border: none;
}

.input-group-merge .custom-select:not(:first-child),
.input-group-merge .form-control:not(:first-child) {
  padding-left: 2.5rem;
  border-top-left-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
}

.input-group-merge .custom-select:not(:last-child),
.input-group-merge .form-control:not(:last-child) {
  padding-right: 2.5rem;
  border-top-right-radius: 0.3125rem;
  border-bottom-right-radius: 0.3125rem;
}

/*------------------------------------
  Form Pill
------------------------------------*/
.input-group-pill {
  border-radius: 6.1875rem;
}

.input-group-pill > .form-control:first-child {
  border-top-left-radius: 6.1875rem;
  border-bottom-left-radius: 6.1875rem;
}

.input-group-pill > .form-control:last-child {
  border-top-right-radius: 6.1875rem;
  border-bottom-right-radius: 6.1875rem;
}

.input-group-pill > .input-group-prepend > .btn {
  border-top-left-radius: 6.1875rem;
  border-bottom-left-radius: 6.1875rem;
}

.input-group-pill > .input-group-append > .btn {
  border-top-right-radius: 6.1875rem;
  border-bottom-right-radius: 6.1875rem;
}

.input-group-pill.input-group-merge .form-control:not(:last-child) {
  border-top-right-radius: 6.1875rem;
  border-bottom-right-radius: 6.1875rem;
}

.input-group-pill.input-group-merge .input-group-prepend > .input-group-text,
.input-group-pill.input-group-merge .input-group-prepend > .btn {
  border-top-left-radius: 6.1875rem;
  border-bottom-left-radius: 6.1875rem;
}

.input-group-pill.input-group-merge .form-control:not(:first-child) {
  border-top-left-radius: 6.1875rem;
  border-bottom-left-radius: 6.1875rem;
}

.input-group-pill.input-group-merge .input-group-append > .input-group-text,
.input-group-pill.input-group-merge .input-group-append > .btn {
  border-top-right-radius: 6.1875rem;
  border-bottom-right-radius: 6.1875rem;
}

/*------------------------------------
  Form Sizes
------------------------------------*/
.input-group-sm.input-group-merge .custom-select:not(:first-child),
.input-group-sm.input-group-merge .form-control:not(:first-child) {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.input-group-sm.input-group-merge .custom-select:not(:last-child),
.input-group-sm.input-group-merge .form-control:not(:last-child) {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.input-group-sm.input-group-merge .input-group-prepend .input-group-text:first-child {
  border-top-left-radius: 0.25rem;
  border-bottom-left-radius: 0.25rem;
}

.input-group-sm.input-group-merge .input-group-append .input-group-text:last-child {
  border-top-right-radius: 0.25rem;
  border-bottom-right-radius: 0.25rem;
}

.input-group-lg.input-group-merge .custom-select:not(:first-child),
.input-group-lg.input-group-merge .form-control:not(:first-child) {
  padding-left: 3rem;
  border-top-left-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
}

.input-group-lg.input-group-merge .custom-select:not(:last-child),
.input-group-lg.input-group-merge .form-control:not(:last-child) {
  padding-right: 3rem;
  border-top-right-radius: 0.3125rem;
  border-bottom-right-radius: 0.3125rem;
}

.input-group-lg.input-group-merge .input-group-prepend .input-group-text:first-child {
  border-top-left-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
}

.input-group-lg.input-group-merge .input-group-append .input-group-text:last-child {
  border-top-right-radius: 0.3125rem;
  border-bottom-right-radius: 0.3125rem;
}

/*------------------------------------
  Flush
------------------------------------*/
.input-group-flush .form-control {
  background-color: transparent;
  border-top: none;
  border-right: none;
  border-left: none;
  box-shadow: none;
  padding-right: 0;
  padding-left: 0;
  border-radius: 0;
}

.input-group-flush .form-control.is-valid, .input-group-flush .form-control.is-valid:focus, .input-group-flush .form-control.is-invalid, .input-group-flush .form-control.is-invalid:focus {
  box-shadow: none;
}

.input-group-flush.input-group-merge .input-group-append .input-group-text,
.input-group-flush.input-group-merge .input-group-prepend .input-group-text {
  padding: 0;
}

.input-group-flush.input-group-merge .custom-select:not(:first-child),
.input-group-flush.input-group-merge .form-control:not(:first-child) {
  padding-left: 2rem;
}

.input-group-flush.input-group-merge .custom-select:not(:last-child),
.input-group-flush.input-group-merge .form-control:not(:last-child) {
  padding-right: 2rem;
}

.input-group-flush.input-group .form-control:not(:first-child),
.input-group-flush.input-group .form-control:not(:last-child),
.input-group-flush.input-group .input-group-append .input-group-text:first-child,
.input-group-flush.input-group .input-group-append .input-group-text:last-child {
  border-radius: 0;
}

/*------------------------------------
  States
------------------------------------*/
.custom-select.is-valid,
.form-control.is-valid {
  background-size: 1rem 1rem;
}

.custom-select.is-valid, .custom-select.is-valid:focus,
.form-control.is-valid,
.form-control.is-valid:focus {
  box-shadow: 0 0 10px rgba(0, 201, 167, 0.1);
}

.custom-select.is-invalid,
.form-control.is-invalid {
  background-size: 1rem 1rem;
}

.custom-select.is-invalid, .custom-select.is-invalid:focus,
.form-control.is-invalid,
.form-control.is-invalid:focus {
  box-shadow: 0 0 10px rgba(237, 76, 120, 0.1);
}

/*------------------------------------
  Custom Select
------------------------------------*/
.custom-select,
.custom-control-label {
  cursor: pointer;
}

.form-control .custom-control-label {
  width: 100%;
}

/*------------------------------------
  Checkbox Bookmark
------------------------------------*/
.custom-checkbox-bookmark {
  padding-left: 0;
}

.custom-checkbox-bookmark-label {
  display: inline-flex;
  align-items: center;
  cursor: pointer;
  color: #bdc5d1;
  font-size: 1rem;
  margin-bottom: 0;
}

.custom-checkbox-bookmark-default,
.custom-checkbox-bookmark-active {
  margin-top: -1px;
}

.custom-checkbox-bookmark-active {
  color: #ffc107;
}

.custom-checkbox-bookmark-input ~ .custom-checkbox-bookmark-label .custom-checkbox-bookmark-default {
  display: block;
}

.custom-checkbox-bookmark-input ~ .custom-checkbox-bookmark-label .custom-checkbox-bookmark-active {
  display: none;
}

.custom-checkbox-bookmark-input:checked ~ .custom-checkbox-bookmark-label .custom-checkbox-bookmark-default {
  display: none;
}

.custom-checkbox-bookmark-input:checked ~ .custom-checkbox-bookmark-label .custom-checkbox-bookmark-active {
  display: block;
}

.custom-checkbox-bookmark-input:disabled ~ .custom-checkbox-bookmark-label {
  color: #e7eaf3;
}

/*------------------------------------
  Checkbox Outline
------------------------------------*/
.checkbox-outline {
  padding-left: 0;
  margin-right: 0;
}

.checkbox-outline-label {
  border: 0.0625rem solid #e7eaf3;
  cursor: pointer;
}

.checkbox-outline-input:checked ~ .checkbox-outline-label {
  border-color: #377dff;
}

/*------------------------------------
  Checkbox Icon
------------------------------------*/
.checkbox-icon-label::after {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 1rem;
  height: 1rem;
  color: #e7eaf3;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) no-repeat right center/1rem 1rem;
  content: "";
}

.checkbox-icon-input:checked ~ .checkbox-icon-label::after {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___}) no-repeat right center/1rem 1rem;
}

/*------------------------------------
  Custom Checkbox
------------------------------------*/
.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {
  border-color: rgba(55, 125, 255, 0);
}

/*------------------------------------
  Toggle Switch
------------------------------------*/
.toggle-switch {
  display: flex;
  cursor: pointer;
  margin-bottom: 0;
}

.toggle-switch-input {
  position: absolute;
  z-index: -1;
  opacity: 0;
}

.toggle-switch-content {
  flex: 1 1;
  margin-left: 0.5rem;
}

.toggle-switch-label {
  position: relative;
  display: block;
  width: 3rem;
  height: 2rem;
  background-color: #e7eaf3;
  background-clip: content-box;
  border: 0.125rem solid transparent;
  border-radius: 6.1875rem;
  transition: 0.3s;
}

.toggle-switch-indicator {
  position: absolute;
  left: 0.125rem;
  bottom: 50%;
  width: 1.5rem;
  height: 1.5rem;
  background-color: #fff;
  transform: initial;
  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);
  border-radius: 50%;
  transform: translate3d(0, 50%, 0);
  transition: 0.3s;
}

.toggle-switch-input:checked + .toggle-switch-label {
  background-color: #377dff;
}

.toggle-switch-input:checked + .toggle-switch-label .toggle-switch-indicator {
  transform: translate3d(1.025rem, 50%, 0);
}

.toggle-switch-input:disabled + .toggle-switch-label {
  background-color: rgba(231, 234, 243, 0.5);
}

.toggle-switch-input:checked:disabled + .toggle-switch-label {
  background-color: rgba(55, 125, 255, 0.5);
}

/*------------------------------------
  File Attachment Button
------------------------------------*/
.file-attachment-btn {
  position: relative;
  overflow: hidden;
  margin-bottom: 0;
}

.file-attachment-btn-label {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  min-width: 100%;
  min-height: 100%;
  cursor: inherit;
  opacity: 0;
}

/*------------------------------------
  File Attachment Input
------------------------------------*/
.file-attachment-input {
  position: relative;
  display: block;
  background-color: #f8fafd;
  border: 0.125rem dashed #e7eaf3;
  text-align: center;
  overflow: hidden;
  cursor: pointer;
  border-radius: 0.3125rem;
  padding: 4rem 4rem;
  margin-bottom: 0;
}

.file-attachment-input-label {
  position: absolute;
  top: 0;
  right: 0;
  display: block;
  min-width: 100%;
  min-height: 100%;
  cursor: inherit;
  opacity: 0;
}

.file-attachment-input:hover {
  background-color: #e7eaf3;
}

/*------------------------------------
  Go To
------------------------------------*/
.go-to {
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  z-index: 9999;
  width: 2.6875rem;
  height: 2.6875rem;
  background-color: rgba(113, 134, 157, 0.1);
  color: #677788;
  font-size: 0.8125rem;
  opacity: 0.5;
  border-radius: 50%;
  transition: 0.3s ease-out;
}

.go-to:hover, .go-to:focus:hover {
  color: #fff;
  background-color: #377dff;
  opacity: 1;
}

/*------------------------------------
  Hero v1
------------------------------------*/
.hero-v1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 40%;
  height: 100%;
  z-index: -1;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
}

.hero-v1::before {
  position: absolute;
  top: 50%;
  right: 100%;
  width: 80%;
  height: 80%;
  background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(55, 125, 255, 0.075) 50%, rgba(255, 255, 255, 0));
  background-repeat: no-repeat;
  content: "";
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

/*------------------------------------
  Icon
------------------------------------*/
.icon {
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  width: 3.125rem;
  height: 3.125rem;
  border-radius: 0.3125rem;
}

.icon-circle {
  border-radius: 50%;
}

.icon.icon-xs {
  font-size: 0.75rem;
  width: 1.75rem;
  height: 1.75rem;
}

.icon.icon-sm {
  font-size: 0.8125rem;
  width: 2.6875rem;
  height: 2.6875rem;
}

.icon.icon-lg {
  font-size: 1.25rem;
  width: 4.25rem;
  height: 4.25rem;
}

/*------------------------------------
  Icon
------------------------------------*/
/* primary */
.icon-primary {
  color: #fff;
  border-color: #377dff;
  background-color: #377dff;
}

/* secondary */
.icon-secondary {
  color: #fff;
  border-color: #71869d;
  background-color: #71869d;
}

/* success */
.icon-success {
  color: #fff;
  border-color: #00c9a7;
  background-color: #00c9a7;
}

/* info */
.icon-info {
  color: #fff;
  border-color: #09a5be;
  background-color: #09a5be;
}

/* warning */
.icon-warning {
  color: #1e2022;
  border-color: #f5ca99;
  background-color: #f5ca99;
}

/* danger */
.icon-danger {
  color: #fff;
  border-color: #ed4c78;
  background-color: #ed4c78;
}

/* light */
.icon-light {
  color: #1e2022;
  border-color: #f7faff;
  background-color: #f7faff;
}

/* dark */
.icon-dark {
  color: #fff;
  border-color: #21325b;
  background-color: #21325b;
}

/* indigo */
.icon-indigo {
  color: #fff;
  border-color: #2d1582;
  background-color: #2d1582;
}

/* primary soft */
.icon-soft-primary {
  color: #377dff;
  background: rgba(55, 125, 255, 0.1);
}

/* secondary soft */
.icon-soft-secondary {
  color: #71869d;
  background: rgba(113, 134, 157, 0.1);
}

/* success soft */
.icon-soft-success {
  color: #00c9a7;
  background: rgba(0, 201, 167, 0.1);
}

/* info soft */
.icon-soft-info {
  color: #09a5be;
  background: rgba(9, 165, 190, 0.1);
}

/* warning soft */
.icon-soft-warning {
  color: #f5ca99;
  background: rgba(245, 202, 153, 0.1);
}

/* danger soft */
.icon-soft-danger {
  color: #ed4c78;
  background: rgba(237, 76, 120, 0.1);
}

/* light soft */
.icon-soft-light {
  color: #f7faff;
  background: rgba(247, 250, 255, 0.1);
}

/* dark soft */
.icon-soft-dark {
  color: #21325b;
  background: rgba(33, 50, 91, 0.1);
}

/* indigo soft */
.icon-soft-indigo {
  color: #2d1582;
  background: rgba(45, 21, 130, 0.1);
}

/*------------------------------------
  Legend Indicator
------------------------------------*/
.legend-indicator {
  display: inline-block;
  width: 0.5rem;
  height: 0.5rem;
  background-color: #bdc5d1;
  border-radius: 50%;
  margin-right: 0.4375rem;
}

/*------------------------------------
  Media Viewer
------------------------------------*/
.media-viewer {
  position: relative;
  display: block;
}

.media-viewer:hover .media-viewer-icon {
  opacity: 1;
  transform: scale(1);
}

.media-viewer-container {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.media-viewer-icon {
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  text-align: center;
  width: 1.75rem;
  height: 1.75rem;
  font-size: 0.75rem;
  color: #fff;
  background-color: #377dff;
  border-radius: 50%;
  opacity: 0;
  transform: scale(0.7);
  transition: 0.3s;
}

.media-viewer-icon:hover, .media-viewer-icon:focus {
  color: #fff;
}

.media-viewer-icon-active {
  opacity: 1;
  transform: scale(1);
}

/*------------------------------------
  Video Player
------------------------------------*/
.video-player {
  position: relative;
}

.video-player-preview {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  opacity: 1;
  object-fit: cover;
  transition: opacity 0.3s ease-in-out;
}

.video-player-played .video-player-preview {
  opacity: 0;
  pointer-events: none;
}

.video-player-btn {
  z-index: 3;
  transition: transform 0.3s ease-in-out;
}

.video-player-played .video-player-btn {
  animation: videoPlayerButton 0.4s ease-in-out forwards;
  pointer-events: none;
}

.video-player-btn:hover .video-player-icon {
  color: #377dff;
  transform: scale(1.1);
}

.video-player-icon {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  text-align: center;
  width: 4.25rem;
  height: 4.25rem;
  font-size: 0.8125rem;
  border-radius: 50%;
  color: #1e2022;
  background-color: #fff;
  backface-visibility: hidden;
  transform: perspective(1px) translateZ(0);
  transition: 0.3s;
}

/* Positions */
.video-player-centered {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

@keyframes videoPlayerButton {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate(-50%, -50%) scale(1.3);
  }
}

/*------------------------------------
  Device Mockups
------------------------------------*/
.device {
  position: relative;
}

.device-pointer {
  width: 65%;
  text-align: center;
  margin-right: auto;
  margin-left: auto;
}

.device-macbook-screen {
  position: absolute;
  top: 6.8%;
  left: 12.3%;
  width: 75.1%;
  height: 81.1%;
  object-fit: cover;
}

.device-iphone-x {
  border-radius: 2.75rem;
  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
}

.device-iphone-x-frame {
  position: relative;
  z-index: 2;
  max-width: 100%;
  height: auto;
}

.device-iphone-x-screen {
  position: absolute;
  top: 2.4%;
  left: 4%;
  width: 92.4%;
  height: 96%;
  object-fit: cover;
  border-radius: 0.5rem;
}

.device-half-iphone-x {
  border-top-left-radius: 3rem;
  border-top-right-radius: 3rem;
  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
}

.device-half-iphone-x-frame {
  position: relative;
  z-index: 2;
  max-width: 100%;
  height: auto;
}

.device-half-iphone-x-screen {
  position: absolute;
  top: 2.6%;
  left: 4.1%;
  width: 91.8%;
  height: 97.1%;
  object-fit: cover;
  border-top-left-radius: 0.9375rem;
  border-top-right-radius: 0.9375rem;
}

.device-ipad {
  border-radius: 1.25rem;
  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
}

.device-ipad-frame {
  position: relative;
  z-index: 2;
  max-width: 100%;
  height: auto;
}

.device-ipad-screen {
  position: absolute;
  top: 2.6%;
  left: 4.2%;
  width: 91.8%;
  height: 94.2%;
  object-fit: cover;
}

.device-horizontal-ipad {
  border-radius: 1.5rem;
  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
}

.device-horizontal-ipad-frame {
  position: relative;
  z-index: 2;
  max-width: 100%;
  height: auto;
}

.device-horizontal-ipad-screen {
  position: absolute;
  top: 3.8%;
  left: 3.2%;
  width: 93.8%;
  height: 92%;
  object-fit: cover;
}

.device-browser {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  max-width: 85%;
  overflow: hidden;
  box-shadow: 0 0.625rem 2.5rem 0.625rem rgba(140, 152, 164, 0.175);
  border-radius: 0.75rem;
}

.device-browser-screen {
  position: absolute;
  top: 6%;
  left: 1.2%;
  width: 97.7%;
  height: 100%;
  object-fit: cover;
}

.device-wrapper {
  position: relative;
}

.device-wrapper .device-iphone-x {
  position: absolute;
  bottom: 0;
  right: 0;
  width: 22%;
}

/*------------------------------------
  Modal
------------------------------------*/
.modal-header {
  align-items: center;
  border-width: 0;
  padding-bottom: 0;
}

.modal-header .close {
  padding: 0.25rem 0.25rem;
  margin: 0 0 0 auto;
}

.modal-footer > * {
  margin-top: 0;
  margin-bottom: 0;
}

.modal-footer-text:last-child {
  font-size: 0.875rem;
  margin-bottom: 0;
}

/* Cover */
.modal-top-cover {
  position: relative;
  overflow: hidden;
  min-height: 8rem;
  border-top-right-radius: 0.6875rem;
  border-top-left-radius: 0.6875rem;
}

.modal-top-cover-avatar {
  position: relative;
  z-index: 2;
  margin-top: -3rem;
}

/* Close */
.modal-close {
  position: absolute;
  top: 0.75rem;
  right: 0.75rem;
  z-index: 2;
}

/*------------------------------------
  Page Header
------------------------------------*/
.page-header {
  border-bottom: 0.0625rem solid #e7eaf3;
  padding-bottom: 2rem;
  margin-bottom: 1rem;
}

.page-header .breadcrumb {
  margin-bottom: 0.25rem;
}

.page-header-title {
  margin-bottom: 0.25rem;
}

.page-header-text {
  margin-bottom: 0.25rem;
}

.page-header-tabs {
  margin-bottom: -2rem;
  border-bottom-width: 0;
}

.hs-nav-scroller-horizontal .page-header-tabs {
  margin-bottom: -2rem;
}

.page-header-reset {
  border-bottom-width: 0;
  padding-bottom: 0;
}

/*------------------------------------
  Page Preloader
------------------------------------*/
.page-preloader {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1002;
  background-color: #fff;
}

.page-preloader-content-centered {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

/*------------------------------------
  Pagination
------------------------------------*/
.page-link {
  cursor: pointer;
  text-align: center;
  min-width: 2.25rem;
}

.page-item {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.page-item .page-link {
  border-top-left-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
}

.page-item .page-link {
  border-top-right-radius: 0.3125rem;
  border-bottom-right-radius: 0.3125rem;
}

/* Sizes */
.pagination-sm .page-link {
  border-radius: 0.25rem;
}

.pagination-lg .page-link {
  border-radius: 0.75rem;
}

/*------------------------------------
  Navbar
------------------------------------*/
.navbar-vertical.show .card {
  box-shadow: none;
}

/*------------------------------------
  Navbar Vertical
------------------------------------*/
.navbar-vertical .nav {
  flex-direction: column;
  flex-wrap: wrap;
}

.navbar-vertical .nav-sub .nav-link {
  display: flex;
  align-items: center;
}

.navbar-vertical .nav-sub .nav-link .nav-link-badge {
  margin-left: auto;
}

.navbar-vertical .nav-tabs {
  border-bottom-width: 0;
}

.navbar-vertical .nav-tabs .nav-item {
  margin: 0;
}

.navbar-vertical .card .nav-tabs .nav-link {
  padding-right: 0;
  padding-left: 1.4375rem;
  margin-left: -1.5rem;
}

.navbar-vertical .nav-tabs .nav-link {
  padding-right: 1rem;
  padding-left: 1rem;
}

.navbar-vertical .nav-tabs .nav-link,
.navbar-vertical .nav-tabs .nav-link.active {
  border-bottom-width: 0;
  border-radius: 0;
}

.navbar-vertical .nav-tabs .nav-link:hover {
  border-color: transparent;
}

.navbar-vertical .nav-tabs .nav-link {
  border-width: 0 0 0 0.1875rem;
  margin-bottom: 0;
}

.navbar-vertical .nav-tabs .active.nav-link,
.navbar-vertical .nav-tabs .active .nav-link {
  border-left-color: #377dff;
}

/*------------------------------------
  Navs
------------------------------------*/
.nav .nav-link {
  color: #677788;
}

.nav .nav-link:not(.active):hover {
  color: #377dff;
}

.nav:not(.nav-pills) .nav-item.active .nav-link,
.nav:not(.nav-pills) .nav-link.active {
  color: #377dff;
}

/* Small Size */
.nav-sm .nav-link {
  font-size: 0.875rem;
}

/* No Gutters */
.nav-x-0 .nav-link {
  padding-right: 0;
  padding-left: 0;
}

.nav-y-0 .nav-link {
  padding-top: 0;
  padding-bottom: 0;
}

.nav-x-sm .nav-link {
  padding-right: .25rem;
  padding-left: .25rem;
}

/* Icon */
.nav-icon {
  width: 1.25rem;
  font-size: 0.8125rem;
  line-height: 1.4;
  opacity: 0.8;
  text-align: center;
  margin-right: 0.5rem;
}

/* Shadow */
.nav-shadow {
  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);
}

/* Classic */
.nav-classic {
  border-bottom: 0.0625rem solid #e7eaf3;
}

.nav-classic .nav-link {
  color: #677788;
  border-width: 0 0 0.1875rem 0;
  border-style: solid;
  border-color: transparent;
  padding: 1rem 1.5rem;
  margin-bottom: -0.125rem;
  border-radius: 0;
  transition: 0.3s;
}

.nav-classic .nav-link:hover {
  color: #377dff;
}

.nav-classic .nav-link.active {
  color: #377dff;
  border-bottom-color: #377dff;
}

/* Rounded */
.nav-rounded {
  border-radius: 0.3125rem;
}

.nav-rounded .nav-item:first-child .nav-link {
  border-bottom-left-radius: 0.3125rem;
}

.nav-rounded .nav-item:last-child .nav-link {
  border-bottom-right-radius: 0.3125rem;
}

/* White Color */
.nav-white .nav-link {
  color: rgba(255, 255, 255, 0.7);
}

.nav-white .nav-link.active {
  color: #377dff;
  background-color: #fff;
}

.nav-white .nav-link:not(.active):hover {
  color: #fff;
}

/* White Border Color */
.nav.nav-border-white .nav-link {
  color: rgba(255, 255, 255, 0.7);
  border-bottom: 0.125rem solid transparent;
}

.nav.nav-border-white .nav-link.active {
  color: #fff;
  border-bottom-color: #fff;
}

.nav.nav-border-white .nav-link:not(.active):hover {
  color: #fff;
}

/* Box */
.nav-box .nav-link {
  color: #1e2022;
  border-radius: 0.3125rem;
}

.nav-box .nav-link.active {
  color: #377dff;
  background-color: #fff;
  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
}

/* Segment */
.nav-segment {
  position: relative;
  background-color: #f8fafd;
  padding: 0.25rem 0.25rem;
  border-radius: 0.3125rem;
}

.nav-segment:not(.nav-fill) {
  display: inline-flex;
}

.nav-segment .nav-link {
  color: #677788;
  font-size: 0.875rem;
  font-weight: 600;
  padding: 0.375rem 0.875rem;
  border-radius: 0.3125rem;
}

.nav-segment .nav-link:hover {
  color: #377dff;
}

.nav-segment .nav-link.active {
  color: #1e2022;
  background-color: #fff;
  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);
}

.nav-segment.nav-pills {
  border-radius: 6.1875rem;
}

.nav-segment.nav-pills .nav-link {
  border-radius: 6.1875rem;
}

/* Tabs */
.nav-tabs .nav-item {
  margin-left: 1rem;
  margin-right: 1rem;
}

.nav-tabs .nav-link {
  color: #677788;
  border-bottom-width: 0.0625rem;
  border-left-width: 0;
  border-right-width: 0;
  border-top-width: 0;
  padding: 1rem 0;
  margin-bottom: -0.09375rem;
}

.nav-tabs .nav-link.active,
.nav-tabs .nav-item.active .nav-link,
.nav-tabs .nav-item.show .nav-link {
  border-bottom-width: 0.1875rem;
}

.nav-tabs .nav-item.active .nav-link {
  border-color: transparent transparent #377dff;
}

.nav-tabs .nav-item:first-child {
  margin-left: 0;
}

.nav-tabs .nav-item:last-child {
  margin-right: 0;
}

/*------------------------------------
  Nav List
------------------------------------*/
.nav-list-y-1 .nav-link {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important;
}

.nav-list-y-2 .nav-link {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}

/*------------------------------------
  Vertical Progress Bar
------------------------------------*/
.progress-vertical {
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-end;
  background-color: #f8fafd;
  height: 12.5rem;
}

/*------------------------------------
  Popover
------------------------------------*/
.popover {
  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);
}

.popover-header {
  font-weight: 600;
}

/*------------------------------------
  Profile Cover
------------------------------------*/
.profile-cover {
  position: relative;
  height: 7.5rem;
  padding: 1rem 1rem;
  border-radius: 0.75rem;
}

.profile-cover-content {
  position: relative;
  z-index: 1;
}

.profile-cover-img-wrapper {
  position: absolute;
  top: 0;
  right: 0;
  left: 0;
  height: 7.5rem;
  background-color: #e7eaf3;
  border-radius: 0.75rem;
}

.profile-cover-img {
  width: 100%;
  height: 7.5rem;
  object-fit: cover;
  vertical-align: top;
  border-radius: 0.75rem;
}

.profile-cover-avatar {
  display: flex;
  background-color: #fff;
  padding: 0.75rem 0.75rem;
  margin-top: -1.75rem;
}

.profile-cover-content {
  padding: 1rem 1rem;
}

.profile-cover-btn {
  position: absolute;
  bottom: 0;
  right: 0;
}

@media (min-width: 992px) {
  .profile-cover {
    height: 10rem;
  }
  .profile-cover-img-wrapper {
    height: 10rem;
  }
  .profile-cover-img {
    height: 10rem;
  }
}

/*------------------------------------
  Scrollbar
------------------------------------*/
.scrollbar {
  overflow: hidden;
  overflow-y: auto;
}

.scrollbar::-webkit-scrollbar {
  width: 0.5rem;
}

.scrollbar::-webkit-scrollbar-thumb {
  background-color: rgba(189, 197, 209, 0.6);
  visibility: hidden;
}

.scrollbar:hover::-webkit-scrollbar-thumb {
  visibility: visible;
}

.scrollbar-horizontal {
  display: flex;
  max-width: 100%;
  flex-wrap: nowrap;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
}

.scrollbar-horizontal::-webkit-scrollbar {
  height: 0.25rem;
}

.scrollbar-horizontal::-webkit-scrollbar-thumb {
  background-color: rgba(189, 197, 209, 0.6);
  visibility: hidden;
}

.scrollbar-horizontal:hover::-webkit-scrollbar-thumb {
  visibility: visible;
}

/*------------------------------------
  Search Form - Push Top
------------------------------------*/
.search-push-top {
  display: none;
  background-color: #f8fafd;
  padding-top: 3rem;
  padding-bottom: 3rem;
  box-shadow: inset 0 -10px 20px -10px rgba(151, 164, 175, 0.05);
}

.search-push-top-content {
  max-width: 50rem;
  margin-left: auto;
  margin-right: auto;
}

.search-push-top-close-btn {
  position: absolute;
  top: -1.5625rem;
  right: .4375rem;
}

@media (max-width: 575.98px) {
  .search-push-top {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
  }
}

/* Banner */
.search-push-top-banner {
  background-color: #fff;
  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);
  padding-right: 1.5625rem;
  padding-top: 1.875rem;
  overflow: hidden;
}

.search-push-top-banner-container {
  position: relative;
  width: 75%;
  min-height: 11.5625rem;
}

.search-push-top-banner-img {
  position: absolute;
  bottom: -.625rem;
  left: -.625rem;
  transition: all 0.3s ease-in-out;
}

.search-push-top-banner:hover .search-push-top-banner-img:first-child {
  bottom: 0;
  left: 0;
}

/*------------------------------------
  Search Form - Slide Down
------------------------------------*/
.search-slide-down {
  position: fixed;
  z-index: 1003;
  top: 5rem;
  left: calc(50% - 18rem) !important;
  width: 36rem;
}

@media (max-width: 767.98px) {
  .search-slide-down {
    left: 5% !important;
    right: 5% !important;
    width: 90%;
  }
}

.search-slide-down-trigger.active .search-slide-down-trigger-icon::before {
  content: "";
}

.search-slide-down-bg-overlay {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1002;
  display: none;
  width: 100%;
  height: 100%;
}

.search-slide-down .search-slide-down-input {
  opacity: 0;
  transform: translateY(-2rem);
  transition: transform 0.3s cubic-bezier(0.37, 0.41, 0.55, 0.98), opacity 0.2s;
}

.search-slide-down .search-slide-down-suggestions {
  opacity: 0;
  transform: translateY(-3rem);
  transition: transform 0.4s cubic-bezier(0.37, 0.41, 0.55, 0.98), opacity 0.2s;
}

.search-slide-down-show .search-slide-down-input,
.search-slide-down-show .search-slide-down-suggestions {
  opacity: 1;
  transform: none;
}

.search-slide-down-show .search-slide-down-suggestions {
  transition-delay: 0.2s;
}

/*------------------------------------
  Slick
------------------------------------*/
.slick {
  position: relative;
}

.slick-vertical .slick-slide {
  border-width: 0;
}

.slick-transform-off.slick-transform-off .slick-track {
  transform: none !important;
}

.slick-thumb-progress {
  width: 110%;
  height: 110%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.slick-center-mode-right {
  margin-right: calc(-1px - ((100vw - 100%) / 2) + 16px) !important;
}

.slick-center-mode-right-offset .draggable {
  padding-right: 5rem;
}

/*------------------------------------
  Slick Equal Height
------------------------------------*/
.slick-equal-height .slick-list {
  height: 100%;
}

.slick-equal-height .slick-track {
  display: flex;
  height: 100%;
}

.slick-equal-height .slick-track .slick-slide {
  display: flex;
  height: auto;
}

/*------------------------------------
  Slick Gutters
------------------------------------*/
/* Gutters X */
.slick-gutters-1 {
  margin-left: -.25rem;
  margin-right: -.25rem;
}

.slick-gutters-1 .slick-slide {
  margin-left: .25rem;
  margin-right: .25rem;
}

.slick-gutters-2 {
  margin-left: -.5rem;
  margin-right: -.5rem;
}

.slick-gutters-2 .slick-slide {
  margin-left: .5rem;
  margin-right: .5rem;
}

.slick-gutters-3 {
  margin-left: -.9375rem;
  margin-right: -.9375rem;
}

.slick-gutters-3 .slick-slide {
  margin-left: .9375rem;
  margin-right: .9375rem;
}

/*------------------------------------
  Slick Arrows
------------------------------------*/
.slick-arrow {
  z-index: 1;
  line-height: 0;
  display: inline-block;
  color: #1e2022;
  background-color: #fff;
  width: 2.6875rem;
  height: 2.6875rem;
  font-size: 0.8125rem;
  cursor: pointer;
  transition: 0.3s;
}

.slick-arrow:not(.slick-disabled):hover {
  color: #fff;
  background-color: #377dff;
}

.slick-arrow::before {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
}

.slick-arrow-left {
  left: 0;
}

.slick-arrow-right {
  right: 0;
}

.slick-arrow.slick-disabled {
  color: #677788;
}

/* Primary */
.slick-arrow-primary {
  color: #fff;
  background-color: rgba(55, 125, 255, 0.8);
}

/* Soft White */
.slick-arrow-soft-white {
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
}

.slick-arrow-soft-white:hover {
  color: #fff;
  background-color: #377dff;
}

/* Offset */
@media (min-width: 992px) {
  .slick-arrow-offset.slick-arrow-left {
    left: -2.6875rem;
  }
  .slick-arrow-offset.slick-arrow-right {
    right: -2.6875rem;
  }
}

/* Vertical Center Alignment */
.slick-arrow-centered-y {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

/*------------------------------------
  Slick Counter
------------------------------------*/
.slick-counter {
  position: absolute;
  bottom: 2rem;
  right: 0;
  padding-left: 0.9375rem;
  padding-right: 0.9375rem;
}

.slick-counter-current {
  color: #fff;
  font-size: 3.875rem;
  line-height: 1;
}

.slick-counter-divider {
  color: rgba(255, 255, 255, 0.7);
  margin-right: 0.5rem;
  margin-left: 0.5rem;
}

.slick-counter-total {
  font-size: 1.25rem;
  color: rgba(255, 255, 255, 0.7);
}

/*------------------------------------
  Slick Dot Lined
------------------------------------*/
.slick-dots {
  list-style: none;
  display: flex;
  align-items: center;
  justify-content: center;
}

.slick-dots li {
  cursor: pointer;
  margin: 0 .3125rem;
}

.slick-dots .dot-line {
  position: relative;
  display: block;
  width: 2.75rem;
  height: 0.1875rem;
  background-color: rgba(255, 255, 255, 0.2);
}

.slick-dots .dot-line-helper {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 0;
  height: 100%;
  background-color: #377dff;
  transition: none;
}

.slick-line-dots-ready .slick-dots li.slick-active .dot-line-helper {
  transition-property: width;
  transition-timing-function: linear;
  width: 100%;
}

/*------------------------------------
  Slick Pagination
------------------------------------*/
.slick-pagination {
  padding-left: 0;
  margin-bottom: 0;
}

.slick-pagination:not(.slick-pagination-vertical) {
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;
}

.slick-pagination li {
  display: flex;
  pointer-events: all;
  margin: 0 .25rem;
  cursor: pointer;
}

.slick-pagination li span {
  display: inline-block;
  width: 0.9375rem;
  height: 0.9375rem;
  box-sizing: border-box;
  background-color: #377dff;
  border: 0.1875rem solid transparent;
  border-radius: 50%;
  transform: scale(0.6);
  transition: 0.3s;
}

.slick-pagination li.slick-active span {
  background-color: transparent;
  border-color: #377dff;
  transform: scale(0.9);
}

/* White Version */
.slick-pagination-white li span {
  background-color: #fff;
}

.slick-pagination-white li.slick-active span {
  border-color: #fff;
}

.slick-pagination-vertical li {
  display: block;
}

/*------------------------------------
  Slick Pagination Interactive
------------------------------------*/
.slick-pagination-interactive-title {
  color: #fff;
}

.slick-pagination-interactive-text {
  color: rgba(255, 255, 255, 0.7);
}

.slick-pagination-interactive .slick-slide {
  cursor: pointer;
  color: #fff;
  background-color: rgba(255, 255, 255, 0.1);
  transition: 0.3s;
}

.slick-pagination-interactive .slick-slide:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.slick-pagination-interactive .slick-slide:hover.slick-center {
  background-color: #fff;
}

.slick-pagination-interactive .slick-center {
  background-color: #fff;
}

.slick-pagination-interactive .slick-center .slick-pagination-interactive-title {
  color: #377dff;
}

.slick-pagination-interactive .slick-center .slick-pagination-interactive-text {
  color: #677788;
}

/*------------------------------------
  Slick Pagination Modern
------------------------------------*/
.slick-pagination-modern {
  width: 100%;
  max-width: 12.5rem;
}

.slick-pagination-modern .slick-slide {
  cursor: pointer;
  opacity: 0.7;
  transform: scale(0.7);
  backface-visibility: hidden;
  transition: 0.3s;
}

.slick-pagination-modern .slick-current {
  opacity: 1;
  transform: scale(1);
}

/*------------------------------------
  Slick Pagination Line
------------------------------------*/
.slick-pagination-line .slick-slide {
  opacity: .5;
  cursor: pointer;
  font-weight: 400;
  padding-bottom: 0.25rem;
}

.slick-pagination-line .slick-slide.slick-current {
  opacity: 1;
}

.slick-pagination-line-progress {
  position: relative;
  display: block;
  width: 100%;
  height: 0.1875rem;
  background-color: #fff;
  margin-top: 0.5rem;
}

.slick-pagination-line-progress-helper {
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  width: 0;
  height: 100%;
  transition: none;
}

.slick-pagination-line.slick-dots-ready .slick-current .slick-pagination-line-progress-helper {
  width: 100%;
  background-color: #377dff;
  transition-property: width;
  transition-timing-function: linear;
}

@media (max-width: 991.98px) {
  .slick-pagination-line-wrapper {
    opacity: 0;
    pointer-events: none;
    overflow: hidden;
  }
}

/*------------------------------------
  Spinner
------------------------------------*/
.spinner-border,
.spinner-grow {
  vertical-align: middle;
}

/*------------------------------------
  Stats Progress
-------------------------------------*/
.stats-progress {
  position: relative;
  width: 13.75rem;
  height: 13.75rem;
  border-radius: 50%;
  box-shadow: 0px 0.375rem 1.5rem 0px rgba(140, 152, 164, 0.125);
  margin-left: auto;
  margin-right: auto;
}

.stats-progress-info {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  text-align: center;
  padding: 2rem 2rem;
  transform: translate(0, -50%);
}

/*------------------------------------
  Step
------------------------------------*/
.step {
  position: relative;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-right: -0.9375rem;
  margin-left: -0.9375rem;
}

.step.step-dashed .step-icon::after {
  border-left-style: dashed;
}

.step-title {
  display: block;
  color: #1e2022;
  font-weight: 600;
}

.step-text:last-child {
  color: #677788;
  margin-bottom: 0;
}

.step-border-last-0 .step-item:last-child .step-icon::after {
  display: none;
}

.step .step-item {
  display: flex;
  flex-direction: column;
  flex-basis: 0;
  flex: 0 0 100%;
  max-width: 100%;
  padding-right: 0.9375rem;
  padding-left: 0.9375rem;
  margin-bottom: 1.5rem;
}

.step-item-between .step-item:last-child {
  flex: 0 0 auto;
  width: auto;
}

.step .step-content-wrapper {
  position: relative;
  display: flex;
  width: 100%;
}

.step .step-content {
  flex: 1 1;
}

.step-item.collapse:not(.show) {
  display: none;
}

.step-item .step-title-description {
  display: none;
}

.step-item.focus .step-title-description {
  display: block;
}

/*------------------------------------
  Step Avatar
------------------------------------*/
.step .step-avatar {
  font-size: 1rem;
  font-weight: 600;
  width: 3.125rem;
  height: 3.125rem;
  border-radius: 50%;
  margin-right: 1rem;
}

.step .step-avatar-img {
  max-width: 100%;
  height: auto;
  border-radius: 50%;
}

.step .step-avatar::after {
  position: absolute;
  top: 3.59375rem;
  left: 1.5625rem;
  height: calc(100% - 2.65625rem);
  border-left: 0.125rem solid #e7eaf3;
  content: "";
}

/*------------------------------------
  Step Avatar
------------------------------------*/
.step-avatar-xs .step-avatar, .step-avatar-xs.step-avatar {
  font-size: 0.75rem;
  width: 1.75rem;
  height: 1.75rem;
}

.step-avatar-xs .step-avatar::after, .step-avatar-xs.step-avatar::after {
  top: 2.21875rem;
  left: 0.8125rem;
  width: 1.0625rem;
  height: calc(100% - 1.28125rem);
}

.step-avatar-xs .step-divider::after {
  left: 0.875rem;
}

.step-avatar-sm .step-avatar, .step-avatar-sm.step-avatar {
  font-size: 0.8125rem;
  width: 2.6875rem;
  height: 2.6875rem;
}

.step-avatar-sm .step-avatar::after, .step-avatar-sm.step-avatar::after {
  top: 3.15625rem;
  left: 1.28125rem;
  width: 1.0625rem;
  height: calc(100% - 2.21875rem);
}

.step-avatar-sm .step-divider::after {
  left: 1.34375rem;
}

.step-avatar-lg .step-avatar, .step-avatar-lg.step-avatar {
  font-size: 1.25rem;
  width: 4.25rem;
  height: 4.25rem;
}

.step-avatar-lg .step-avatar::after, .step-avatar-lg.step-avatar::after {
  top: 4.71875rem;
  left: 2.0625rem;
  width: 1.0625rem;
  height: calc(100% - 3.78125rem);
}

.step-avatar-lg .step-divider::after {
  left: 2.125rem;
}

/*------------------------------------
  Step Divider
------------------------------------*/
.step-divider {
  display: inline-flex;
  align-items: center;
  text-transform: uppercase;
  height: 1rem;
  font-weight: 600;
}

.step-divider::after {
  position: absolute;
  top: 1.46875rem;
  left: 1.5625rem;
  height: calc(100% - 0.53125rem);
  border-left: 0.125rem solid #e7eaf3;
  content: "";
}

/*------------------------------------
  Step Icon
------------------------------------*/
.step .step-icon {
  display: inline-flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  font-weight: 600;
  width: 3.125rem;
  height: 3.125rem;
  border-radius: 50%;
  margin-right: 1rem;
}

.step .step-icon::after {
  position: absolute;
  top: 3.59375rem;
  left: 1.5625rem;
  height: calc(100% - 2.65625rem);
  border-left: 0.125rem solid #e7eaf3;
  content: "";
}

.step .step-icon-pseudo::before {
  display: block;
  width: 0.25rem;
  height: 0.25rem;
  background-color: #97a4af;
  border-radius: 50%;
  content: "";
}

/*------------------------------------
  Step Icon Sizes
------------------------------------*/
.step-icon-xs .step-icon, .step-icon-xs.step-icon {
  font-size: 0.75rem;
  width: 1.75rem;
  height: 1.75rem;
}

.step-icon-xs .step-icon::after, .step-icon-xs.step-icon::after {
  top: 2.21875rem;
  left: 0.8125rem;
  width: 1.0625rem;
  height: calc(100% - 1.28125rem);
}

.step-icon-xs .step-divider::after {
  left: 0.875rem;
}

.step-icon-sm .step-icon, .step-icon-sm.step-icon {
  font-size: 0.8125rem;
  width: 2.6875rem;
  height: 2.6875rem;
}

.step-icon-sm .step-icon::after, .step-icon-sm.step-icon::after {
  top: 3.15625rem;
  left: 1.28125rem;
  width: 1.0625rem;
  height: calc(100% - 2.21875rem);
}

.step-icon-sm .step-divider::after {
  left: 1.34375rem;
}

.step-icon-lg .step-icon, .step-icon-lg.step-icon {
  font-size: 1.25rem;
  width: 4.25rem;
  height: 4.25rem;
}

.step-icon-lg .step-icon::after, .step-icon-lg.step-icon::after {
  top: 4.71875rem;
  left: 2.0625rem;
  width: 1.0625rem;
  height: calc(100% - 3.78125rem);
}

.step-icon-lg .step-divider::after {
  left: 2.125rem;
}

/*------------------------------------
  Step Breakpoints
------------------------------------*/
@media (min-width: 576px) {
  .step-sm.step-dashed .step-icon::after {
    border-left: none;
    border-top-style: dashed;
  }
  .step-sm .step-item {
    flex-grow: 1;
    flex: 1 1;
    margin-bottom: 0;
  }
  .step-sm:not(.step-inline) .step-content-wrapper {
    display: block;
  }
  .step-sm .step-icon {
    margin-bottom: 1rem;
  }
  .step-sm .step-icon::after {
    top: 1.5625rem;
    left: 4.0625rem;
    width: calc(100% - 4.0625rem);
    height: 1.0625rem;
    border-top: 0.125rem solid #e7eaf3;
    border-left: none;
  }
  .step-sm.step-icon-xs .step-icon::after,
  .step-sm .step-icon.step-icon-xs::after {
    top: 0.875rem;
    left: 2.6875rem;
    width: calc(100% - 2.6875rem);
  }
  .step-sm.step-icon-sm .step-icon::after,
  .step-sm .step-icon.step-icon-sm::after {
    top: 1.34375rem;
    left: 3.625rem;
    width: calc(100% - 3.625rem);
  }
  .step-sm.step-icon-lg .step-icon::after,
  .step-sm .step-icon.step-icon-lg::after {
    top: 2.125rem;
    left: 5.1875rem;
    width: calc(100% - 5.1875rem);
  }
}

@media (min-width: 768px) {
  .step-md.step-dashed .step-icon::after {
    border-left: none;
    border-top-style: dashed;
  }
  .step-md .step-item {
    flex-grow: 1;
    flex: 1 1;
    margin-bottom: 0;
  }
  .step-md:not(.step-inline) .step-content-wrapper {
    display: block;
  }
  .step-md .step-icon {
    margin-bottom: 1rem;
  }
  .step-md .step-icon::after {
    top: 1.5625rem;
    left: 4.0625rem;
    width: calc(100% - 4.0625rem);
    height: 1.0625rem;
    border-top: 0.125rem solid #e7eaf3;
    border-left: none;
  }
  .step-md.step-icon-xs .step-icon::after,
  .step-md .step-icon.step-icon-xs::after {
    top: 0.875rem;
    left: 2.6875rem;
    width: calc(100% - 2.6875rem);
  }
  .step-md.step-icon-sm .step-icon::after,
  .step-md .step-icon.step-icon-sm::after {
    top: 1.34375rem;
    left: 3.625rem;
    width: calc(100% - 3.625rem);
  }
  .step-md.step-icon-lg .step-icon::after,
  .step-md .step-icon.step-icon-lg::after {
    top: 2.125rem;
    left: 5.1875rem;
    width: calc(100% - 5.1875rem);
  }
}

@media (min-width: 992px) {
  .step-lg.step-dashed .step-icon::after {
    border-left: none;
    border-top-style: dashed;
  }
  .step-lg .step-item {
    flex-grow: 1;
    flex: 1 1;
    margin-bottom: 0;
  }
  .step-lg:not(.step-inline) .step-content-wrapper {
    display: block;
  }
  .step-lg .step-icon {
    margin-bottom: 1rem;
  }
  .step-lg .step-icon::after {
    top: 1.5625rem;
    left: 4.0625rem;
    width: calc(100% - 4.0625rem);
    height: 1.0625rem;
    border-top: 0.125rem solid #e7eaf3;
    border-left: none;
  }
  .step-lg.step-icon-xs .step-icon::after,
  .step-lg .step-icon.step-icon-xs::after {
    top: 0.875rem;
    left: 2.6875rem;
    width: calc(100% - 2.6875rem);
  }
  .step-lg.step-icon-sm .step-icon::after,
  .step-lg .step-icon.step-icon-sm::after {
    top: 1.34375rem;
    left: 3.625rem;
    width: calc(100% - 3.625rem);
  }
  .step-lg.step-icon-lg .step-icon::after,
  .step-lg .step-icon.step-icon-lg::after {
    top: 2.125rem;
    left: 5.1875rem;
    width: calc(100% - 5.1875rem);
  }
}

@media (min-width: 1200px) {
  .step-xl.step-dashed .step-icon::after {
    border-left: none;
    border-top-style: dashed;
  }
  .step-xl .step-item {
    flex-grow: 1;
    flex: 1 1;
    margin-bottom: 0;
  }
  .step-xl:not(.step-inline) .step-content-wrapper {
    display: block;
  }
  .step-xl .step-icon {
    margin-bottom: 1rem;
  }
  .step-xl .step-icon::after {
    top: 1.5625rem;
    left: 4.0625rem;
    width: calc(100% - 4.0625rem);
    height: 1.0625rem;
    border-top: 0.125rem solid #e7eaf3;
    border-left: none;
  }
  .step-xl.step-icon-xs .step-icon::after,
  .step-xl .step-icon.step-icon-xs::after {
    top: 0.875rem;
    left: 2.6875rem;
    width: calc(100% - 2.6875rem);
  }
  .step-xl.step-icon-sm .step-icon::after,
  .step-xl .step-icon.step-icon-sm::after {
    top: 1.34375rem;
    left: 3.625rem;
    width: calc(100% - 3.625rem);
  }
  .step-xl.step-icon-lg .step-icon::after,
  .step-xl .step-icon.step-icon-lg::after {
    top: 2.125rem;
    left: 5.1875rem;
    width: calc(100% - 5.1875rem);
  }
}

/*------------------------------------
  Step Centered
------------------------------------*/
@media (min-width: 576px) {
  .step-sm.step-centered {
    text-align: center;
  }
  .step-sm.step-centered .step-item:last-child .step-icon::after {
    display: none;
  }
  .step-sm.step-centered .step-icon {
    margin-left: auto;
    margin-right: auto;
  }
  .step-sm.step-centered .step-icon::after {
    width: calc(100% - 3.125rem);
    left: calc(50% + 2.5rem);
  }
  .step-sm.step-centered.step-icon-xs .step-icon::after,
  .step-sm.step-centered .step-icon.step-icon-xs::after {
    width: calc(100% - 1.75rem);
    left: calc(50% + 1.8125rem);
  }
  .step-sm.step-centered.step-icon-sm .step-icon::after,
  .step-sm.step-centered .step-icon.step-icon-sm::after {
    width: calc(100% - 2.6875rem);
    left: calc(50% + 2.28125rem);
  }
  .step-sm.step-centered.step-icon-lg .step-icon::after,
  .step-sm.step-centered .step-icon.step-icon-lg::after {
    width: calc(100% - 4.25rem);
    left: calc(50% + 3.0625rem);
  }
}

@media (min-width: 768px) {
  .step-md.step-centered {
    text-align: center;
  }
  .step-md.step-centered .step-item:last-child .step-icon::after {
    display: none;
  }
  .step-md.step-centered .step-icon {
    margin-left: auto;
    margin-right: auto;
  }
  .step-md.step-centered .step-icon::after {
    width: calc(100% - 3.125rem);
    left: calc(50% + 2.5rem);
  }
  .step-md.step-centered.step-icon-xs .step-icon::after,
  .step-md.step-centered .step-icon.step-icon-xs::after {
    width: calc(100% - 1.75rem);
    left: calc(50% + 1.8125rem);
  }
  .step-md.step-centered.step-icon-sm .step-icon::after,
  .step-md.step-centered .step-icon.step-icon-sm::after {
    width: calc(100% - 2.6875rem);
    left: calc(50% + 2.28125rem);
  }
  .step-md.step-centered.step-icon-lg .step-icon::after,
  .step-md.step-centered .step-icon.step-icon-lg::after {
    width: calc(100% - 4.25rem);
    left: calc(50% + 3.0625rem);
  }
}

@media (min-width: 992px) {
  .step-lg.step-centered {
    text-align: center;
  }
  .step-lg.step-centered .step-item:last-child .step-icon::after {
    display: none;
  }
  .step-lg.step-centered .step-icon {
    margin-left: auto;
    margin-right: auto;
  }
  .step-lg.step-centered .step-icon::after {
    width: calc(100% - 3.125rem);
    left: calc(50% + 2.5rem);
  }
  .step-lg.step-centered.step-icon-xs .step-icon::after,
  .step-lg.step-centered .step-icon.step-icon-xs::after {
    width: calc(100% - 1.75rem);
    left: calc(50% + 1.8125rem);
  }
  .step-lg.step-centered.step-icon-sm .step-icon::after,
  .step-lg.step-centered .step-icon.step-icon-sm::after {
    width: calc(100% - 2.6875rem);
    left: calc(50% + 2.28125rem);
  }
  .step-lg.step-centered.step-icon-lg .step-icon::after,
  .step-lg.step-centered .step-icon.step-icon-lg::after {
    width: calc(100% - 4.25rem);
    left: calc(50% + 3.0625rem);
  }
}

@media (min-width: 992px) {
  .step-lg.step-centered {
    text-align: center;
  }
  .step-lg.step-centered .step-item:last-child .step-icon::after {
    display: none;
  }
  .step-lg.step-centered .step-icon {
    margin-left: auto;
    margin-right: auto;
  }
  .step-lg.step-centered .step-icon::after {
    width: calc(100% - 3.125rem);
    left: calc(50% + 2.5rem);
  }
  .step-lg.step-centered.step-icon-xs .step-icon::after,
  .step-lg.step-centered .step-icon.step-icon-xs::after {
    width: calc(100% - 1.75rem);
    left: calc(50% + 1.8125rem);
  }
  .step-lg.step-centered.step-icon-sm .step-icon::after,
  .step-lg.step-centered .step-icon.step-icon-sm::after {
    width: calc(100% - 2.6875rem);
    left: calc(50% + 2.28125rem);
  }
  .step-lg.step-centered.step-icon-lg .step-icon::after,
  .step-lg.step-centered .step-icon.step-icon-lg::after {
    width: calc(100% - 4.25rem);
    left: calc(50% + 3.0625rem);
  }
}

/*------------------------------------
  Step States
------------------------------------*/
.step .step-is-valid-icon,
.step .step-is-invalid-icon {
  display: none;
}

.step .active .step-icon,
.step .active.is-valid .step-icon {
  color: #fff;
  background-color: #377dff;
}

.step .active .step-title,
.step .active.is-valid .step-title {
  color: #377dff;
}

.step .is-valid .step-icon {
  color: #fff;
  background-color: #377dff;
}

.step .is-valid .step-title {
  color: #377dff;
}

.step .is-valid .step-is-valid-icon {
  display: inline-flex;
}

.step .is-valid .step-is-default-icon,
.step .is-valid .step-is-invalid-icon {
  display: none;
}

.step .is-invalid .step-icon {
  color: #fff;
  background-color: #ed4c78;
}

.step .is-invalid .step-title {
  color: #ed4c78;
}

.step .is-invalid .step-is-invalid-icon {
  display: inline-flex;
}

.step .is-invalid .step-is-default-icon,
.step .is-invalid .step-is-valid-icon {
  display: none;
}

/*------------------------------------
  Step Colors
------------------------------------*/
.step-icon-primary {
  color: #fff;
  background-color: #377dff;
}

.step-icon-primary.step-icon-pseudo::before {
  background-color: #fff;
}

.step-icon-secondary {
  color: #fff;
  background-color: #71869d;
}

.step-icon-secondary.step-icon-pseudo::before {
  background-color: #fff;
}

.step-icon-success {
  color: #fff;
  background-color: #00c9a7;
}

.step-icon-success.step-icon-pseudo::before {
  background-color: #fff;
}

.step-icon-info {
  color: #fff;
  background-color: #09a5be;
}

.step-icon-info.step-icon-pseudo::before {
  background-color: #fff;
}

.step-icon-warning {
  color: #1e2022;
  background-color: #f5ca99;
}

.step-icon-warning.step-icon-pseudo::before {
  background-color: #1e2022;
}

.step-icon-danger {
  color: #fff;
  background-color: #ed4c78;
}

.step-icon-danger.step-icon-pseudo::before {
  background-color: #fff;
}

.step-icon-light {
  color: #1e2022;
  background-color: #f7faff;
}

.step-icon-light.step-icon-pseudo::before {
  background-color: #1e2022;
}

.step-icon-dark {
  color: #fff;
  background-color: #21325b;
}

.step-icon-dark.step-icon-pseudo::before {
  background-color: #fff;
}

.step-icon-indigo {
  color: #fff;
  background-color: #2d1582;
}

.step-icon-indigo.step-icon-pseudo::before {
  background-color: #fff;
}

.step-icon-soft-primary {
  color: #377dff;
  background-color: rgba(55, 125, 255, 0.1);
}

.step-icon-soft-primary.step-icon-pseudo::before {
  background-color: #377dff;
}

.step-icon-soft-secondary {
  color: #71869d;
  background-color: rgba(113, 134, 157, 0.1);
}

.step-icon-soft-secondary.step-icon-pseudo::before {
  background-color: #71869d;
}

.step-icon-soft-success {
  color: #00c9a7;
  background-color: rgba(0, 201, 167, 0.1);
}

.step-icon-soft-success.step-icon-pseudo::before {
  background-color: #00c9a7;
}

.step-icon-soft-info {
  color: #09a5be;
  background-color: rgba(9, 165, 190, 0.1);
}

.step-icon-soft-info.step-icon-pseudo::before {
  background-color: #09a5be;
}

.step-icon-soft-warning {
  color: #f5ca99;
  background-color: rgba(245, 202, 153, 0.1);
}

.step-icon-soft-warning.step-icon-pseudo::before {
  background-color: #f5ca99;
}

.step-icon-soft-danger {
  color: #ed4c78;
  background-color: rgba(237, 76, 120, 0.1);
}

.step-icon-soft-danger.step-icon-pseudo::before {
  background-color: #ed4c78;
}

.step-icon-soft-light {
  color: #f7faff;
  background-color: rgba(247, 250, 255, 0.1);
}

.step-icon-soft-light.step-icon-pseudo::before {
  background-color: #f7faff;
}

.step-icon-soft-dark {
  color: #21325b;
  background-color: rgba(33, 50, 91, 0.1);
}

.step-icon-soft-dark.step-icon-pseudo::before {
  background-color: #21325b;
}

.step-icon-soft-indigo {
  color: #2d1582;
  background-color: rgba(45, 21, 130, 0.1);
}

.step-icon-soft-indigo.step-icon-pseudo::before {
  background-color: #2d1582;
}

/*------------------------------------
  Step Inline
------------------------------------*/
.step-inline .step-content-wrapper {
  align-items: center;
}

.step-inline .step-item:last-child .step-title::after {
  display: none;
}

.step-inline .step-title {
  display: inline-block;
}

@media (min-width: 576px) {
  .step-sm.step-inline.step-dashed .step-title::after {
    border-top-style: dashed;
  }
  .step-sm.step-inline .step-item {
    overflow: hidden;
  }
  .step-sm.step-inline .step-icon {
    margin-bottom: 0;
  }
  .step-sm.step-inline .step-icon::after {
    display: none;
  }
  .step-sm.step-inline .step-title::after {
    position: absolute;
    top: 1.5625rem;
    width: 100%;
    height: 1.0625rem;
    border-top: 0.125rem solid #e7eaf3;
    margin-left: 0.9375rem;
    content: "";
  }
  .step-sm.step-inline.step-icon-xs .step-content .step-title::after,
  .step-sm.step-inline .step-icon-xs + .step-content .step-title::after {
    top: 0.875rem;
  }
  .step-sm.step-inline.step-icon-sm .step-content .step-title::after,
  .step-sm.step-inline .step-icon-sm + .step-content .step-title::after {
    top: 1.34375rem;
  }
  .step-sm.step-inline.step-icon-lg .step-content .step-title::after,
  .step-sm.step-inline .step-icon-lg + .step-content .step-title::after {
    top: 2.125rem;
  }
}

@media (min-width: 768px) {
  .step-md.step-inline.step-dashed .step-title::after {
    border-top-style: dashed;
  }
  .step-md.step-inline .step-item {
    overflow: hidden;
  }
  .step-md.step-inline .step-icon {
    margin-bottom: 0;
  }
  .step-md.step-inline .step-icon::after {
    display: none;
  }
  .step-md.step-inline .step-title::after {
    position: absolute;
    top: 1.5625rem;
    width: 100%;
    height: 1.0625rem;
    border-top: 0.125rem solid #e7eaf3;
    margin-left: 0.9375rem;
    content: "";
  }
  .step-md.step-inline.step-icon-xs .step-content .step-title::after,
  .step-md.step-inline .step-icon-xs + .step-content .step-title::after {
    top: 0.875rem;
  }
  .step-md.step-inline.step-icon-sm .step-content .step-title::after,
  .step-md.step-inline .step-icon-sm + .step-content .step-title::after {
    top: 1.34375rem;
  }
  .step-md.step-inline.step-icon-lg .step-content .step-title::after,
  .step-md.step-inline .step-icon-lg + .step-content .step-title::after {
    top: 2.125rem;
  }
}

@media (min-width: 992px) {
  .step-lg.step-inline.step-dashed .step-title::after {
    border-top-style: dashed;
  }
  .step-lg.step-inline .step-item {
    overflow: hidden;
  }
  .step-lg.step-inline .step-icon {
    margin-bottom: 0;
  }
  .step-lg.step-inline .step-icon::after {
    display: none;
  }
  .step-lg.step-inline .step-title::after {
    position: absolute;
    top: 1.5625rem;
    width: 100%;
    height: 1.0625rem;
    border-top: 0.125rem solid #e7eaf3;
    margin-left: 0.9375rem;
    content: "";
  }
  .step-lg.step-inline.step-icon-xs .step-content .step-title::after,
  .step-lg.step-inline .step-icon-xs + .step-content .step-title::after {
    top: 0.875rem;
  }
  .step-lg.step-inline.step-icon-sm .step-content .step-title::after,
  .step-lg.step-inline .step-icon-sm + .step-content .step-title::after {
    top: 1.34375rem;
  }
  .step-lg.step-inline.step-icon-lg .step-content .step-title::after,
  .step-lg.step-inline .step-icon-lg + .step-content .step-title::after {
    top: 2.125rem;
  }
}

@media (min-width: 1200px) {
  .step-xl.step-inline.step-dashed .step-title::after {
    border-top-style: dashed;
  }
  .step-xl.step-inline .step-item {
    overflow: hidden;
  }
  .step-xl.step-inline .step-icon {
    margin-bottom: 0;
  }
  .step-xl.step-inline .step-icon::after {
    display: none;
  }
  .step-xl.step-inline .step-title::after {
    position: absolute;
    top: 1.5625rem;
    width: 100%;
    height: 1.0625rem;
    border-top: 0.125rem solid #e7eaf3;
    margin-left: 0.9375rem;
    content: "";
  }
  .step-xl.step-inline.step-icon-xs .step-content .step-title::after,
  .step-xl.step-inline .step-icon-xs + .step-content .step-title::after {
    top: 0.875rem;
  }
  .step-xl.step-inline.step-icon-sm .step-content .step-title::after,
  .step-xl.step-inline .step-icon-sm + .step-content .step-title::after {
    top: 1.34375rem;
  }
  .step-xl.step-inline.step-icon-lg .step-content .step-title::after,
  .step-xl.step-inline .step-icon-lg + .step-content .step-title::after {
    top: 2.125rem;
  }
}

/*------------------------------------
  Step Timeline
------------------------------------*/
@media (min-width: 576px) {
  .step-timeline-sm {
    margin-left: 0;
    margin-right: 0;
  }
  .step-timeline-sm .step-item {
    flex: 0 0 50%;
    max-width: 50%;
    padding-left: 0;
    padding-right: 0;
    margin-left: 50%;
  }
  .step-timeline-sm .step-item:nth-child(even) {
    flex-direction: row-reverse;
    text-align: right;
    margin-left: auto;
    margin-right: 50%;
  }
  .step-timeline-sm .step-item:nth-child(even) .step-content-wrapper {
    flex-direction: row-reverse;
  }
  .step-timeline-sm .step-item:nth-child(even) .step-icon {
    margin-left: 0;
    margin-right: -1.5625rem;
  }
  .step-timeline-sm .step-item:nth-child(even) .step-icon-xs {
    margin-right: -0.875rem;
  }
  .step-timeline-sm .step-item:nth-child(even) .step-icon-sm {
    margin-right: -1.34375rem;
  }
  .step-timeline-sm .step-item:nth-child(even) .step-icon-lg {
    margin-right: -2.125rem;
  }
  .step-timeline-sm .step-item:nth-child(even) .step-content {
    margin-right: 1.5rem;
  }
  .step-timeline-sm .step-icon {
    margin-left: -1.5625rem;
  }
  .step-timeline-sm .step-icon::after {
    left: auto;
    width: auto;
  }
  .step-timeline-sm .step-icon-xs {
    margin-left: -0.875rem;
  }
  .step-timeline-sm .step-icon-sm {
    margin-left: -1.34375rem;
  }
  .step-timeline-sm .step-icon-lg {
    margin-left: -2.125rem;
  }
}

@media (min-width: 768px) {
  .step-timeline-md {
    margin-left: 0;
    margin-right: 0;
  }
  .step-timeline-md .step-item {
    flex: 0 0 50%;
    max-width: 50%;
    padding-left: 0;
    padding-right: 0;
    margin-left: 50%;
  }
  .step-timeline-md .step-item:nth-child(even) {
    flex-direction: row-reverse;
    text-align: right;
    margin-left: auto;
    margin-right: 50%;
  }
  .step-timeline-md .step-item:nth-child(even) .step-content-wrapper {
    flex-direction: row-reverse;
  }
  .step-timeline-md .step-item:nth-child(even) .step-icon {
    margin-left: 0;
    margin-right: -1.5625rem;
  }
  .step-timeline-md .step-item:nth-child(even) .step-icon-xs {
    margin-right: -0.875rem;
  }
  .step-timeline-md .step-item:nth-child(even) .step-icon-sm {
    margin-right: -1.34375rem;
  }
  .step-timeline-md .step-item:nth-child(even) .step-icon-lg {
    margin-right: -2.125rem;
  }
  .step-timeline-md .step-item:nth-child(even) .step-content {
    margin-right: 1.5rem;
  }
  .step-timeline-md .step-icon {
    margin-left: -1.5625rem;
  }
  .step-timeline-md .step-icon::after {
    left: auto;
    width: auto;
  }
  .step-timeline-md .step-icon-xs {
    margin-left: -0.875rem;
  }
  .step-timeline-md .step-icon-sm {
    margin-left: -1.34375rem;
  }
  .step-timeline-md .step-icon-lg {
    margin-left: -2.125rem;
  }
}

@media (min-width: 992px) {
  .step-timeline-lg {
    margin-left: 0;
    margin-right: 0;
  }
  .step-timeline-lg .step-item {
    flex: 0 0 50%;
    max-width: 50%;
    padding-left: 0;
    padding-right: 0;
    margin-left: 50%;
  }
  .step-timeline-lg .step-item:nth-child(even) {
    flex-direction: row-reverse;
    text-align: right;
    margin-left: auto;
    margin-right: 50%;
  }
  .step-timeline-lg .step-item:nth-child(even) .step-content-wrapper {
    flex-direction: row-reverse;
  }
  .step-timeline-lg .step-item:nth-child(even) .step-icon {
    margin-left: 0;
    margin-right: -1.5625rem;
  }
  .step-timeline-lg .step-item:nth-child(even) .step-icon-xs {
    margin-right: -0.875rem;
  }
  .step-timeline-lg .step-item:nth-child(even) .step-icon-sm {
    margin-right: -1.34375rem;
  }
  .step-timeline-lg .step-item:nth-child(even) .step-icon-lg {
    margin-right: -2.125rem;
  }
  .step-timeline-lg .step-item:nth-child(even) .step-content {
    margin-right: 1.5rem;
  }
  .step-timeline-lg .step-icon {
    margin-left: -1.5625rem;
  }
  .step-timeline-lg .step-icon::after {
    left: auto;
    width: auto;
  }
  .step-timeline-lg .step-icon-xs {
    margin-left: -0.875rem;
  }
  .step-timeline-lg .step-icon-sm {
    margin-left: -1.34375rem;
  }
  .step-timeline-lg .step-icon-lg {
    margin-left: -2.125rem;
  }
}

@media (min-width: 1200px) {
  .step-timeline-xl {
    margin-left: 0;
    margin-right: 0;
  }
  .step-timeline-xl .step-item {
    flex: 0 0 50%;
    max-width: 50%;
    padding-left: 0;
    padding-right: 0;
    margin-left: 50%;
  }
  .step-timeline-xl .step-item:nth-child(even) {
    flex-direction: row-reverse;
    text-align: right;
    margin-left: auto;
    margin-right: 50%;
  }
  .step-timeline-xl .step-item:nth-child(even) .step-content-wrapper {
    flex-direction: row-reverse;
  }
  .step-timeline-xl .step-item:nth-child(even) .step-icon {
    margin-left: 0;
    margin-right: -1.5625rem;
  }
  .step-timeline-xl .step-item:nth-child(even) .step-icon-xs {
    margin-right: -0.875rem;
  }
  .step-timeline-xl .step-item:nth-child(even) .step-icon-sm {
    margin-right: -1.34375rem;
  }
  .step-timeline-xl .step-item:nth-child(even) .step-icon-lg {
    margin-right: -2.125rem;
  }
  .step-timeline-xl .step-item:nth-child(even) .step-content {
    margin-right: 1.5rem;
  }
  .step-timeline-xl .step-icon {
    margin-left: -1.5625rem;
  }
  .step-timeline-xl .step-icon::after {
    left: auto;
    width: auto;
  }
  .step-timeline-xl .step-icon-xs {
    margin-left: -0.875rem;
  }
  .step-timeline-xl .step-icon-sm {
    margin-left: -1.34375rem;
  }
  .step-timeline-xl .step-icon-lg {
    margin-left: -2.125rem;
  }
}

/*------------------------------------
  Tables
------------------------------------*/
.table th {
  font-weight: 400;
}

.table thead th {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  border-width: 0;
}

.table .btn {
  white-space: nowrap;
}

.table-heighlighted thead th {
  border-bottom-color: #1e2022;
  border-top: none;
}

.table-heighlighted tfoot td {
  border-top: 0.125rem solid #1e2022;
}

.table-light-bordered {
  border-color: rgba(255, 255, 255, 0.3);
}

.table-light-bordered thead th,
.table-light-bordered th,
.table-light-bordered td {
  border-color: rgba(255, 255, 255, 0.3);
}

.table-nowrap th, .table-nowrap td {
  white-space: nowrap;
}

.table-align-middle tbody td {
  vertical-align: middle;
}

.table-thead-bordered thead th {
  border-top: 0.0625rem solid #e7eaf3;
  border-bottom: 0.0625rem solid #e7eaf3;
}

/*------------------------------------
  Text Highlight
------------------------------------*/
[class*=text-highlight-] {
  background: left 1em/1em 0.2em;
}

/* primary text highlight */
.text-highlight-primary {
  background-image: linear-gradient(to bottom, rgba(55, 125, 255, 0.5) 0%, rgba(55, 125, 255, 0.5) 100%);
  background-repeat: repeat-x;
}

/* secondary text highlight */
.text-highlight-secondary {
  background-image: linear-gradient(to bottom, rgba(113, 134, 157, 0.5) 0%, rgba(113, 134, 157, 0.5) 100%);
  background-repeat: repeat-x;
}

/* success text highlight */
.text-highlight-success {
  background-image: linear-gradient(to bottom, rgba(0, 201, 167, 0.5) 0%, rgba(0, 201, 167, 0.5) 100%);
  background-repeat: repeat-x;
}

/* info text highlight */
.text-highlight-info {
  background-image: linear-gradient(to bottom, rgba(9, 165, 190, 0.5) 0%, rgba(9, 165, 190, 0.5) 100%);
  background-repeat: repeat-x;
}

/* warning text highlight */
.text-highlight-warning {
  background-image: linear-gradient(to bottom, rgba(245, 202, 153, 0.5) 0%, rgba(245, 202, 153, 0.5) 100%);
  background-repeat: repeat-x;
}

/* danger text highlight */
.text-highlight-danger {
  background-image: linear-gradient(to bottom, rgba(237, 76, 120, 0.5) 0%, rgba(237, 76, 120, 0.5) 100%);
  background-repeat: repeat-x;
}

/* light text highlight */
.text-highlight-light {
  background-image: linear-gradient(to bottom, rgba(247, 250, 255, 0.5) 0%, rgba(247, 250, 255, 0.5) 100%);
  background-repeat: repeat-x;
}

/* dark text highlight */
.text-highlight-dark {
  background-image: linear-gradient(to bottom, rgba(33, 50, 91, 0.5) 0%, rgba(33, 50, 91, 0.5) 100%);
  background-repeat: repeat-x;
}

/* indigo text highlight */
.text-highlight-indigo {
  background-image: linear-gradient(to bottom, rgba(45, 21, 130, 0.5) 0%, rgba(45, 21, 130, 0.5) 100%);
  background-repeat: repeat-x;
}

/*------------------------------------
  Sticky Blocks
------------------------------------*/
[class*="sticky-block"] {
  max-width: 100%;
}

/*------------------------------------
  SVG IE10+ specific styles go here
------------------------------------*/
@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {
  .media {
    width: 100%;
  }
  .ie-slick-equal-height .slick-track .slick-slide {
    display: block;
  }
  .ie-main-hero {
    height: 686px;
  }
  .ie-showcase-mockup {
    height: 373px;
  }
  .ie-device-and-mobile {
    height: 638px;
  }
  .ie-curved-y {
    height: 26px;
  }
  .ie-curved-x {
    width: 26px;
    height: 370px;
    margin-right: -4px;
  }
}

/*------------------------------------
  Background Gradients
------------------------------------*/
.gradient-y-sm-primary {
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(55, 125, 255, 0.075) 100%);
  background-repeat: repeat-x;
}

.gradient-y-gray {
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(231, 234, 243, 0.5) 100%);
  background-repeat: repeat-x;
}

.gradient-y-lg-white {
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #fff 100%);
  background-repeat: repeat-x;
}

.gradient-y-three-sm-primary {
  background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(55, 125, 255, 0.075) 50%, rgba(255, 255, 255, 0));
  background-repeat: no-repeat;
}

.gradient-x-three-sm-primary {
  background-image: linear-gradient(to right, rgba(55, 125, 255, 0.03), rgba(9, 165, 190, 0.05) 50%, rgba(245, 202, 153, 0.05));
  background-repeat: no-repeat;
}

/*------------------------------------
  Background Overlay Gradients
------------------------------------*/
[class*="gradient-x-overlay-"],
[class*="gradient-y-overlay-"],
[class*="gradient-y-three-overlay-"] {
  position: relative;
  z-index: 1;
}

[class*="gradient-x-overlay-"]::before,
[class*="gradient-y-overlay-"]::before,
[class*="gradient-y-three-overlay-"]::before {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  right: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
  content: "";
}

.gradient-x-overlay-lg-dark-video::before {
  z-index: 2;
  background-image: linear-gradient(to right, rgba(33, 50, 91, 0.95) 0%, rgba(33, 50, 91, 0.95) 100%);
  background-repeat: repeat-x;
}

.gradient-x-overlay-sm-dark::before {
  background-image: linear-gradient(to right, rgba(33, 50, 91, 0.25) 0%, rgba(30, 32, 34, 0.25) 100%);
  background-repeat: repeat-x;
}

.gradient-x-overlay-lg-dark::before {
  background-image: linear-gradient(to right, rgba(33, 50, 91, 0.9) 0%, rgba(33, 50, 91, 0.9) 100%);
  background-repeat: repeat-x;
}

.gradient-y-overlay-lg-dark::before {
  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 40%, rgba(12, 13, 14, 0.6) 100%);
  background-repeat: repeat-x;
}

.gradient-x-overlay-sm-indigo::before {
  background-image: linear-gradient(45deg, transparent, rgba(45, 21, 130, 0.05));
  background-repeat: repeat-x;
}

.gradient-y-overlay-lg-white::before {
  background-image: linear-gradient(to bottom, #fff 0%, rgba(255, 255, 255, 0.9) 100%);
  background-repeat: repeat-x;
}

.gradient-y-overlay-sm-gray-900::before {
  background-image: linear-gradient(to bottom, rgba(30, 32, 34, 0.3) 0%, rgba(33, 50, 91, 0.2) 100%);
  background-repeat: repeat-x;
}

/*------------------------------------
  Background Image Style
------------------------------------*/
.bg-img-hero {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: top center;
}

.bg-img-hero-bottom {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: bottom center;
}

.bg-img-hero-center {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.bg-img-hero-fixed {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  background-attachment: fixed;
}

/*------------------------------------
  Background Soft Colors
------------------------------------*/
.bg-soft-primary {
  background-color: rgba(55, 125, 255, 0.1);
}

.bg-soft-secondary {
  background-color: rgba(113, 134, 157, 0.1);
}

.bg-soft-success {
  background-color: rgba(0, 201, 167, 0.1);
}

.bg-soft-info {
  background-color: rgba(9, 165, 190, 0.1);
}

.bg-soft-warning {
  background-color: rgba(245, 202, 153, 0.1);
}

.bg-soft-danger {
  background-color: rgba(237, 76, 120, 0.1);
}

.bg-soft-light {
  background-color: rgba(247, 250, 255, 0.1);
}

.bg-soft-dark {
  background-color: rgba(33, 50, 91, 0.1);
}

.bg-soft-indigo {
  background-color: rgba(45, 21, 130, 0.1);
}

/*------------------------------------
  Borders-radius
------------------------------------*/
.rounded-pseudo {
  border-radius: 0.3125rem;
}

.rounded-pseudo::before, .rounded-pseudo::after {
  border-radius: 0.3125rem;
}

.rounded-lg-pseudo {
  border-radius: 0.75rem;
}

.rounded-lg-pseudo::before, .rounded-lg-pseudo::after {
  border-radius: 0.75rem;
}

/*------------------------------------
  Borders
------------------------------------*/
.border-dashed {
  border: 0.0625rem dashed #e7eaf3;
}

.border-3 {
  border-width: 0.1875rem !important;
}

/*------------------------------------
  Position Spaces
------------------------------------*/
.top-auto {
  top: auto;
}

.bottom-auto {
  bottom: auto;
}

.right-auto {
  right: auto;
}

.left-auto {
  left: auto;
}

.top-0 {
  top: 0;
}

.right-0 {
  right: 0;
}

.bottom-0 {
  bottom: 0;
}

.left-0 {
  left: 0;
}

.top-50 {
  top: 50%;
}

.right-50 {
  right: 50%;
}

.bottom-50 {
  bottom: 50%;
}

.left-50 {
  left: 50%;
}

@media (min-width: 576px) {
  .position-sm-absolute {
    position: absolute;
  }
}

@media (min-width: 768px) {
  .top-md-0 {
    top: 0;
  }
  .right-md-0 {
    right: 0;
  }
  .bottom-md-0 {
    bottom: 0;
  }
  .left-md-0 {
    left: 0;
  }
  .position-md-absolute {
    position: absolute;
  }
}

@media (min-width: 992px) {
  .top-lg-0 {
    top: 0;
  }
  .right-lg-0 {
    right: 0;
  }
  .bottom-lg-0 {
    bottom: 0;
  }
  .left-lg-0 {
    left: 0;
  }
  .position-lg-absolute {
    position: absolute;
  }
}

/*------------------------------------
  Content Centered
------------------------------------*/
.content-centered-y {
  position: absolute;
  top: 50%;
  transform: translate(0, -50%);
}

@media (min-width: 768px) {
  .content-centered-y-md {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }
}

@media (min-width: 992px) {
  .content-centered-y-lg {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
  }
}

/*------------------------------------
  Opacity
------------------------------------*/
.opacity-xs {
  opacity: .2;
}

.opacity-sm {
  opacity: .4;
}

.opacity {
  opacity: .6;
}

.opacity-lg {
  opacity: .8;
}

/*------------------------------------
  Box Shadow
------------------------------------*/
.shadow-primary-lg {
  box-shadow: 0px 0px 50px rgba(55, 125, 255, 0.4) !important;
}

.shadow-soft {
  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25) !important;
}

/*------------------------------------
  Width
------------------------------------*/
.min-w-3rem {
  min-width: 1rem;
}

.min-w-4rem {
  min-width: 1.5rem;
}

.min-w-8rem {
  min-width: 3.5rem;
}

.min-w-21rem {
  min-width: 10rem;
}

.max-w-3rem {
  max-width: 1rem;
}

.max-w-4rem {
  max-width: 1.5rem;
}

.max-w-5rem {
  max-width: 2rem;
}

.max-w-6rem {
  max-width: 2.5rem;
}

.max-w-7rem {
  max-width: 3rem;
}

.max-w-8rem {
  max-width: 3.5rem;
}

.max-w-9rem {
  max-width: 4rem;
}

.max-w-10rem {
  max-width: 4.5rem;
}

.max-w-11rem {
  max-width: 5rem;
}

.max-w-13rem {
  max-width: 6rem;
}

.max-w-15rem {
  max-width: 7rem;
}

.max-w-19rem {
  max-width: 9rem;
}

.max-w-23rem {
  max-width: 11rem;
}

.max-w-27rem {
  max-width: 13rem;
}

.max-w-33rem {
  max-width: 16rem;
}

.max-w-35rem {
  max-width: 17rem;
}

.max-w-40rem {
  max-width: 19.5rem;
}

.max-w-50rem {
  max-width: 24.5rem;
}

/*------------------------------------
  Height
------------------------------------*/
.h-4rem {
  height: .25rem;
}

.h-250rem {
  height: 15.625rem;
}

.h-380rem {
  height: 23.75rem;
}

.min-h-270rem {
  min-height: 16.875rem;
}

.min-h-300rem {
  min-height: 18.75rem;
}

.min-h-380rem {
  min-height: 23.75rem;
}

.min-h-450rem {
  min-height: 28.125rem;
}

.min-h-500rem {
  min-height: 31.25rem;
}

.min-h-620rem {
  min-height: 38.75rem;
}

@media (min-width: 576px) {
  .max-w-sm-15rem {
    max-width: 7rem;
  }
  .max-w-sm-40rem {
    max-width: 19.5rem;
  }
}

@media (min-width: 768px) {
  .vh-md-30 {
    height: 30vh;
  }
  .vh-md-70 {
    height: 70vh;
  }
  .min-vh-md-100 {
    min-height: 100vh;
  }
  .max-w-md-13rem {
    max-width: 6rem;
  }
}

@media (min-width: 992px) {
  .vh-lg-100 {
    height: 100vh;
  }
  .min-vh-lg-100 {
    min-height: 100vh;
  }
  .min-h-lg-600rem {
    min-height: 37.5rem;
  }
}

/*------------------------------------
  Typography
------------------------------------*/
.text-inherit {
  color: inherit;
}

.text-cap {
  display: block;
  text-transform: uppercase;
  font-weight: 600;
  letter-spacing: 0.03125rem;
}

.text-lh-sm {
  line-height: 1.2;
}

.text-lh-lg {
  line-height: 1.8;
}

.font-size-1 {
  font-size: 0.875rem;
}

.font-size-2 {
  font-size: 1.5rem;
}

.font-size-3 {
  font-size: 2rem;
}

.font-size-4 {
  font-size: 2.5rem;
}

.font-size-5 {
  font-size: 3rem;
}

/*------------------------------------
  Text Colors
------------------------------------*/
.text-dark {
  color: #1e2022 !important;
}

.text-dark[href]:hover {
  color: #377dff !important;
}

.text-secondary[href]:hover {
  color: #377dff !important;
}

.text-muted[href]:hover,
.text-body[href]:hover {
  color: #0052ea !important;
}

.text-white-70 {
  color: rgba(255, 255, 255, 0.7);
}

.text-white-70[href]:hover {
  color: #fff;
}

a:hover .text-hover-primary {
  color: #0052ea !important;
}

.text-warning {
  color: #ec9a3c !important;
}

/*------------------------------------
  Transform Rotate
------------------------------------*/
.transform-rotate-1 {
  transform: rotate(-40deg);
  transform-origin: 30% 20%;
}

.transform-rotate-2 {
  transform: rotate(-17deg);
  transform-origin: 0% 0%;
}

.transform-rotate-3 {
  transform: rotate(15deg);
  transform-origin: 90% -20%;
}

.transform-rotate-4 {
  transform-origin: 100% 0;
  transform: translateY(-50%);
}

.transform-rotate-5 {
  transform: rotate(-22deg);
}

.transform-rotate-6 {
  transform: translate3d(20%, -55%, 0);
}

/*------------------------------------
  Transitions
------------------------------------*/
/* 3D Hover */
.transition-3d-hover {
  transition: all 0.2s ease-in-out;
}

.transition-3d-hover:hover, .transition-3d-hover:focus {
  transform: translateY(-3px);
}

/* Zoom Hover */
.transition-zoom-hover {
  transform: scale(1);
  transition: transform 0.3s;
}

.transition-zoom-hover:hover, .transition-zoom-hover:focus {
  transform: scale(1.05);
}

/*------------------------------------
  Z-Index
------------------------------------*/
.z-index-n1 {
  z-index: -1;
}

.z-index-2 {
  z-index: 2;
}

.z-index-4 {
  z-index: 4;
}

.z-index-999 {
  z-index: 999;
}

.z-index-9999 {
  z-index: 9999;
}

/*------------------------------------
  Unfold
------------------------------------*/
.hs-unfold {
  position: relative;
  display: inline-block;
}

.hs-unfold-content {
  display: block !important;
  opacity: 0;
  pointer-events: none;
}

.hs-unfold-content-initialized {
  opacity: 1;
  visibility: visible;
  pointer-events: auto;
}

.hs-unfold-hidden {
  display: none !important;
  opacity: 0;
  visibility: hidden;
}

.hs-unfold-overlay {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1002;
  background-color: rgba(33, 50, 91, 0.125);
}

.hs-unfold-content.hs-unfold-reverse-y {
  top: auto;
  bottom: 100%;
  margin-top: 0;
}

.hs-unfold-has-submenu {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: .5rem;
}

/*------------------------------------
  Video Background
------------------------------------*/
/*------------------------------------
  Video Background
------------------------------------*/
.hs-video-bg-video video {
  object-fit: cover;
}

/*------------------------------------
  Nav Scroll Horizontal
------------------------------------*/
.hs-nav-scroller-horizontal {
  position: relative;
  z-index: 2;
}

.hs-nav-scroller-horizontal .nav {
  overflow-x: auto;
  overflow-y: hidden;
  flex-wrap: nowrap;
  white-space: nowrap;
  scroll-behavior: smooth;
}

.hs-nav-scroller-horizontal .nav .nav-item {
  white-space: nowrap;
}

.hs-nav-scroller-horizontal .nav::-webkit-scrollbar {
  display: none;
}

.hs-nav-scroller-horizontal .nav-tabs {
  padding-bottom: 2px;
}

.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-prev,
.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-next {
  position: absolute;
  height: 100%;
  z-index: 1;
  font-size: 1rem;
  display: flex;
  align-items: center;
}

.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-link {
  width: 3.125rem;
  color: #677788;
}

.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-link:hover {
  color: #0052ea;
}

.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-prev {
  left: 0;
  margin-left: -0.125rem;
}

.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-prev .hs-nav-scroller-arrow-link {
  padding: 0.5rem 0;
  background-image: linear-gradient(to right, #fff 50%, rgba(255, 255, 255, 0) 100%);
  background-repeat: repeat-x;
}

.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-next {
  right: 0;
  margin-right: -0.125rem;
}

.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-next .hs-nav-scroller-arrow-link {
  padding: 0.5rem 0;
  background-image: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, #fff 50%);
  background-repeat: repeat-x;
  text-align: right;
}

.hs-nav-scroller-vertical {
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}

.hs-nav-scroller-vertical::-webkit-scrollbar {
  width: 0.5rem;
}

.hs-nav-scroller-vertical::-webkit-scrollbar-thumb {
  background-color: rgba(189, 197, 209, 0.6);
}

.hs-nav-scroller-unfold {
  position: static;
}

/*------------------------------------
  Chartjs
------------------------------------*/
.hs-chartjs-tooltip-wrap {
  position: absolute;
  z-index: 3;
  transition: opacity 0.2s ease-in-out;
}

.hs-chartjs-tooltip {
  background-color: #fff;
  border: 0.0625rem solid #e7eaf3;
  box-shadow: 0px 0.375rem 1.5rem 0px rgba(140, 152, 164, 0.125);
  border-radius: 0.3125rem;
  padding: 1rem 1rem;
}

.hs-chartjs-tooltip-header {
  font-weight: 600;
}

.hs-chartjs-tooltip-body {
  color: #677788;
}

/*------------------------------------
  Cubeportfolio
------------------------------------*/
@media (max-width: 991.98px) {
  .cbp-filter-scrollbar {
    max-width: 100%;
    display: flex;
    overflow-x: auto;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
  }
  .cbp-filter-scrollbar::-webkit-scrollbar {
    height: 0.25rem;
  }
  .cbp-filter-scrollbar::-webkit-scrollbar-thumb {
    background-color: rgba(189, 197, 209, 0.6);
    visibility: hidden;
  }
  .cbp-filter-scrollbar:hover::-webkit-scrollbar-thumb {
    visibility: visible;
  }
}

.cbp-filter-item-active.label.label-soft-secondary {
  color: #fff;
  background-color: #377dff;
}

.cbp-filter-item-active.nav-link {
  color: #377dff;
}

.cbp-l-loadMore-stop {
  pointer-events: none;
}

.cbp-caption-zoom .cbp-caption-defaultWrap {
  transition: transform .2s ease-out;
}

.cbp-caption-zoom .cbp-caption-activeWrap {
  background-color: rgba(33, 50, 91, 0.5);
}

.cbp-caption-zoom .cbp-caption:hover .cbp-caption-defaultWrap {
  transform: scale(1.1);
}

/*------------------------------------
  Dropzone
------------------------------------*/
.dz-dropzone {
  cursor: pointer;
}

.dz-dropzone-boxed {
  width: 100%;
  background-color: #f8fafd;
  border: 0.125rem dashed #e7eaf3;
  border-radius: 0.3125rem;
  padding: 3rem 3rem;
  display: flex;
  flex-wrap: wrap;
}

.dz-dropzone .dz-message {
  width: 100%;
  text-align: center;
}

.dz-dropzone .dz-details {
  margin-bottom: 1rem;
}

.dz-dropzone .dz-file-preview {
  background-color: #fff;
  border-radius: 0.3125rem;
  padding: 1rem 1rem;
  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);
}

.dz-dropzone .dz-file-wrapper {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dz-dropzone .dz-filename {
  margin-bottom: 0.25rem;
}

.dz-dropzone .dz-img {
  max-width: 3.125rem;
  border-radius: 0.3125rem;
  margin-right: 0.75rem;
}

.dz-dropzone .dz-img-inner {
  border-radius: 0.3125rem;
}

.dz-dropzone .dz-close-icon,
.dz-dropzone .dz-size {
  color: #677788;
}

.dz-dropzone .dz-title {
  font-size: 0.75rem;
  font-weight: 600;
}

.dz-dropzone .dz-size {
  font-size: 80%;
}

.dz-dropzone .dz-file-initials {
  display: inline-block;
  width: 3.125rem;
  height: 3.125rem;
  line-height: 3.125rem;
  font-weight: 600;
  font-size: 1rem;
  color: #377dff;
  text-align: center;
  background-color: rgba(55, 125, 255, 0.1);
  border-radius: 0.3125rem;
  margin-right: 0.75rem;
}

.dz-dropzone [data-dz-thumbnail]:not([src]) {
  display: none;
  margin-bottom: 0;
}

.dz-dropzone .dz-progress {
  margin-bottom: 1rem;
}

.dz-dropzone .dz-processing .dz-error-mark,
.dz-dropzone .dz-processing .dz-success-mark {
  display: none;
}

.dz-dropzone .dz-processing.dz-error .dz-error-mark,
.dz-dropzone .dz-processing.dz-success .dz-success-mark {
  display: block;
}

.dz-dropzone .dz-processing .dz-error-mark {
  color: #ed4c78;
}

.dz-dropzone .dz-processing .dz-success-mark {
  color: #00c9a7;
}

/*------------------------------------
  Dzsparallaxer
------------------------------------*/
.dzsparallaxer {
  color: inherit;
}

/*--------------------------------------------------
  Fancybox
----------------------------------------------------*/
.fancybox-theme .fancybox-slide.animated {
  display: block;
  opacity: 0;
  z-index: 0;
}

.fancybox-theme .fancybox-slide.animated.fancybox-slide--current {
  opacity: 1;
  z-index: 1;
}

.fancybox-theme .fancybox-content {
  background-color: transparent;
}

.fancybox-theme .fancybox-bg {
  background-color: #1e2022;
}

.fancybox-theme .fancybox-button svg {
  margin-bottom: 0;
}

.fancybox-theme .fancybox-progress {
  background-color: #377dff;
}

.blur-30 {
  filter: blur(30px);
}

/*------------------------------------
  Leaflet
------------------------------------*/
.leaflet-bar,
.leaflet-popup-content-wrapper,
.leaflet-popup-tip {
  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);
}

.leaflet-bar,
.leaflet-popup-content-wrapper {
  border-radius: 0.3125rem;
}

.leaflet-popup {
  margin-bottom: 3rem;
}

/*------------------------------------
  Summernote Editor
------------------------------------*/
.quill-custom .ql-container {
  position: static;
}

.quill-custom .ql-toolbar.ql-snow,
.quill-custom .ql-container.ql-snow {
  border-color: #e7eaf3;
}

.quill-custom .ql-toolbar.ql-snow {
  padding: 0.75rem 1.5rem;
  border-top-left-radius: 0.3125rem;
  border-top-right-radius: 0.3125rem;
}

.quill-custom .ql-container.ql-snow {
  border-bottom-right-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
}

.quill-custom .ql-formats:first-child {
  padding-left: 0;
}

.quill-custom .ql-formats:first-child button {
  margin-right: 0.5rem;
}

.quill-custom .ql-formats:first-child button:first-child {
  margin-left: -0.25rem;
}

.quill-custom .ql-editor {
  position: relative;
  padding: 1.5rem 1.5rem;
}

.quill-custom .ql-editor p {
  font-size: 1rem;
  font-family: "Open Sans", sans-serif;
  color: #1e2022;
}

.quill-custom .ql-editor.ql-blank::before {
  left: 1.5rem;
  color: #97a4af;
  font-family: "Open Sans", sans-serif;
  font-style: normal;
}

.quill-custom .ql-snow.ql-toolbar .ql-fill {
  fill: #677788;
}

.quill-custom .ql-snow.ql-toolbar .ql-stroke {
  stroke: #677788;
}

.quill-custom .ql-snow.ql-toolbar button:hover {
  color: #377dff;
}

.quill-custom .ql-snow.ql-toolbar button:hover .ql-fill {
  fill: #377dff;
}

.quill-custom .ql-snow.ql-toolbar button:hover .ql-stroke {
  stroke: #377dff;
}

.quill-custom .ql-snow.ql-toolbar button,
.quill-custom .ql-snow .ql-toolbar button {
  width: 1.75rem;
  height: 1.75rem;
  padding: 0.25rem 0.25rem;
}

.quill-custom .ql-snow.ql-toolbar button svg,
.quill-custom .ql-snow .ql-toolbar button svg {
  margin-bottom: 0;
}

.quill-custom .ql-snow .ql-tooltip {
  position: fixed;
  top: 50% !important;
  left: 50% !important;
  z-index: 1;
  min-width: 20rem;
  border-width: 0;
  text-align: center;
  box-shadow: 0px 10px 40px 10px rgba(140, 152, 164, 0.175);
  padding: 1.5rem 1.5rem;
  border-radius: 0.3125rem;
  transform: translate(-50%, -50%);
}

.quill-custom .ql-snow .ql-tooltip::before {
  display: block;
  text-align: center;
  font-family: "Open Sans", sans-serif;
  font-weight: 600;
  font-size: 1rem;
  border-bottom: 0.0625rem solid #e7eaf3;
  padding-bottom: 1rem;
  margin-bottom: 1.5rem;
  margin-right: 0;
}

.quill-custom .ql-snow .ql-tooltip.ql-editing a.ql-preview,
.quill-custom .ql-snow .ql-tooltip.ql-editing a.ql-remove {
  display: none;
}

.quill-custom .ql-snow .ql-tooltip a.ql-preview,
.quill-custom .ql-snow .ql-tooltip.ql-editing input[type=text] {
  min-width: 20rem;
  font-size: 1rem;
  line-height: normal;
  border: 0.0625rem solid #e7eaf3;
  padding: 0.75rem 1rem;
  margin-bottom: 1.5rem;
  border-radius: 0.3125rem;
  transition: 0.3s;
}

.quill-custom .ql-snow .ql-tooltip a.ql-preview {
  display: block;
}

.quill-custom .ql-snow .ql-tooltip a.ql-preview:hover {
  border-color: #377dff;
}

.quill-custom .ql-snow .ql-tooltip.ql-editing input[type=text] {
  height: auto;
  display: block;
  font-family: "Open Sans", sans-serif;
}

.quill-custom .ql-snow .ql-tooltip.ql-editing input[type=text]:focus {
  border-color: rgba(55, 125, 255, 0.4);
  box-shadow: 0 0 10px rgba(55, 125, 255, 0.1);
}

.quill-custom .ql-snow .ql-action {
  display: inline-block;
  color: #fff;
  background-color: #377dff;
  font-size: 1rem;
  line-height: normal;
  padding: 0.75rem 1rem;
  border-radius: 0.3125rem;
  transition: 0.3s;
}

.quill-custom .ql-snow .ql-action:hover {
  background-color: #1366ff;
}

.quill-custom .ql-snow .ql-tooltip a.ql-remove::before,
.quill-custom .ql-snow .ql-tooltip a.ql-action::after {
  padding-right: 0;
  margin-left: 0;
  border-right: none;
}

.quill-custom .ql-snow .ql-tooltip a.ql-remove {
  border: 0.0625rem solid #e7eaf3;
  font-size: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 0.3125rem;
  margin-left: 0.5rem;
  transition: 0.3s;
}

.quill-custom .ql-snow .ql-tooltip a.ql-remove:hover {
  color: #0052ea;
  box-shadow: 0px 3px 6px -2px rgba(140, 152, 164, 0.25);
}

/*------------------------------------
  Select2
------------------------------------*/
.select2-custom {
  position: relative;
}

.select2-custom .select2-custom-hide {
  display: none;
}

.select2-custom-right .select2-container--open {
  right: 0 !important;
  left: auto !important;
}

@media (min-width: 576px) {
  .select2-custom-sm-right .select2-container--open {
    right: 0 !important;
    left: auto !important;
  }
}

@media (min-width: 768px) {
  .select2-custom-md-right .select2-container--open {
    right: 0 !important;
    left: auto !important;
  }
}

@media (min-width: 992px) {
  .select2-custom-lg-right .select2-container--open {
    right: 0 !important;
    left: auto !important;
  }
}

@media (min-width: 1200px) {
  .select2-custom-xl-right .select2-container--open {
    right: 0 !important;
    left: auto !important;
  }
}

.select2-dropdown {
  border-color: #e7eaf3;
}

.select2-container--open .select2-dropdown--below {
  border-radius: 0.3125rem;
  border-top: 0.0625rem solid #e7eaf3;
  margin-top: 0.5rem;
}

.select2-container--default.select2-container--open.select2-container--below .select2-selection--single,
.select2-container--default.select2-container--open.select2-container--below .select2-selection--multiple {
  border-radius: 0.3125rem;
}

.select2-container--default.select2-container--focus .select2-selection--multiple {
  border-color: rgba(55, 125, 255, 0.4);
}

.select2-container--default .custom-select.select2-selection--multiple,
.select2-container--default .form-control.select2-selection--multiple {
  height: auto;
  min-height: calc(1.6em + 1.625rem);
}

.select2-container--default .custom-select-sm.select2-selection--multiple,
.select2-container--default .form-control-sm.select2-selection--multiple {
  min-height: calc(1.5em + 1.375rem);
}

.select2-container--default .form-control.select2-selection--multiple .select2-selection__choice {
  margin-top: 0.7rem;
}

.select2-container--default .custom-select-sm.select2-selection--multiple .select2-selection__choice,
.select2-container--default .form-control-sm.select2-selection--multiple .select2-selection__choice {
  margin-top: 0.5rem;
}

.select2-container--default .form-control.select2-selection--multiple .select2-search--inline {
  margin-top: 0.25rem;
}

.select2-container--default .form-control-lg.select2-selection--multiple .select2-selection__choice {
  margin-top: 0.6125rem;
}

.select2-container--default .select2-selection--multiple {
  border-color: #e7eaf3;
  padding: 0 0;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice {
  position: relative;
  background-color: #e7eaf3;
  border-color: transparent;
  padding-right: 1.125rem;
}

.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {
  position: absolute;
  right: 0.125rem;
  color: #71869d;
}

.select2-container--default .select2-search__field {
  width: 100% !important;
}

.select2-container--default .select2-search__field::placeholder {
  color: #97a4af;
}

.select2-container--default .select2-search--dropdown .select2-search__field {
  border-color: #e7eaf3;
  background-color: #f7faff;
  padding: 0.625rem 1.125rem;
  border-radius: 0.3125rem;
}

.select2-container--default .select2-search--dropdown .select2-search__field::placeholder {
  color: #97a4af;
}

.select2-container--default .select2-search--dropdown .select2-search__field:focus {
  border-color: rgba(55, 125, 255, 0.4);
  box-shadow: 0 0 10px rgba(55, 125, 255, 0.1);
}

.select2-container--default .select2-selection.active .select2-selection__placeholder {
  color: #1e2022;
}

.select2-container--default .custom-select .select2-search--inline .select2-search__field,
.select2-container--default .select2-selection--multiple .select2-selection__choice {
  margin-top: 0.7rem;
}

.select2-container--default .custom-select-sm .select2-search--inline .select2-search__field,
.select2-container--default .form-control-sm .select2-search--inline .select2-search__field {
  margin-top: 0.5rem;
}

.select2-container--default .select2-selection--multiple .select2-selection__rendered {
  padding-right: 1rem;
  padding-left: 1rem;
}

.select2-container--default .select2-results__option {
  padding: 0.5rem 3rem 0.5rem 0.5rem;
}

.select2-container--default .select2-results__option[aria-selected=true] {
  color: #1e2022;
  background-color: rgba(189, 197, 209, 0.3);
}

.select2-container--default .select2-results__option:first-child, .select2-container--default .select2-results__option:first-child:hover {
  border-top-left-radius: 0.3125rem;
  border-top-right-radius: 0.3125rem;
}

.select2-container--default .select2-results__option:last-child, .select2-container--default .select2-results__option:last-child:hover {
  border-bottom-right-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
}

.select2-container--default .select2-results__option {
  position: relative;
}

.select2-container--default .select2-results__option[aria-selected=true]::after {
  position: absolute;
  top: 50%;
  right: 0.5rem;
  width: 1rem;
  height: 1rem;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}) no-repeat right center/1rem 1rem;
  content: "";
  transform: translateY(-50%);
}

.select2-container--default .select2-results__option--highlighted[aria-selected]:not([aria-selected=true]) {
  color: #1e2022;
  background-color: rgba(189, 197, 209, 0.3);
}

.select2-container--default .select2-search--dropdown .select2-search__field {
  border-color: #e7eaf3;
}

.select2-selection__placeholder {
  color: #97a4af;
}

.select2-selection--multiple .select2-selection__placeholder {
  position: absolute;
  top: 50%;
  left: 0;
  padding-left: 0.75rem;
  transform: translateY(-50%);
}

/*------------------------------------
  Range Slider
------------------------------------*/
.range-slider-custom {
  height: 1.25rem;
}

.range-slider-custom .irs {
  height: 1.25rem;
}

.range-slider-custom .irs-line {
  height: 0.25rem;
}

.range-slider-custom .irs-bar {
  height: 0.25rem;
  background-color: #377dff;
}

.range-slider-custom .irs-handle {
  width: 1.75rem;
  height: 1.75rem;
  top: 0.875rem;
  background-color: #fff;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);
}

.range-slider-custom .irs-handle i:first-child {
  display: none;
}

.range-slider-custom .irs-handle.state_hover {
  transform: scale(1.3);
}

.range-slider-custom .irs-from,
.range-slider-custom .irs-to,
.range-slider-custom .irs-single {
  top: -2.25rem;
  display: inline-block;
  min-width: 2.5rem;
  background-color: #fff;
  color: #1e2022;
  font-size: 0.875rem;
  text-shadow: none;
  text-align: center;
  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);
  border-radius: 0.3125rem;
  padding: 0.5rem 0.5rem;
}

.range-slider-custom .irs-from::before,
.range-slider-custom .irs-to::before,
.range-slider-custom .irs-single::before {
  border-top-color: #fff;
}

/* Grid */
.range-slider-custom-grid .irs-grid-pol {
  top: 0.5rem;
  height: 0.75rem;
  background-color: #e7eaf3;
}

.range-slider-custom-grid .irs-grid-pol.small {
  display: none;
}

.range-slider-custom-grid .irs-grid-text {
  top: 2rem;
  font-size: 0.875rem;
}

/*------------------------------------
  Slick
------------------------------------*/
.slick-cloned [data-hs-slick-carousel-slide-animated-element-animation] {
  opacity: 0;
}

.slick {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_26___}) no-repeat 50% 50%;
}

.slick .js-next,
.slick .js-prev {
  opacity: 0;
}

.slick.slick-initialized {
  background: none;
}

.slick.slick-initialized .js-slide,
.slick.slick-initialized .js-thumb {
  visibility: visible;
  height: auto;
  overflow: visible;
}

.slick.slick-initialized .js-next,
.slick.slick-initialized .js-prev {
  opacity: 1;
}

.slick .js-slide,
.slick .js-thumb {
  height: 0;
  visibility: hidden;
  overflow: hidden;
}

.slick .js-slide:first-child,
.slick .js-thumb:first-child {
  height: auto;
}

/*------------------------------------
  Tagify
------------------------------------*/
.tagify {
  --tag-bg: unset;
  --tag-hover: unset;
  align-items: center;
  border-color: #e7eaf3;
  border-radius: 0.25rem;
}

.tagify:hover {
  border-color: #e7eaf3;
}

.tagify.tagify--focus {
  border-color: rgba(55, 125, 255, 0.4);
}

.tagify__tag {
  background-color: #e7eaf3;
  border-radius: 0.25rem;
}

.tagify__tag:first-child {
  margin-left: 0;
}

.tagify__tag > div {
  color: #1e2022;
  line-height: normal;
  padding: 0.3125rem 2rem 0.3125rem 1rem;
  border-radius: 0.25rem;
}

.tagify__tag > div * {
  display: inline-flex;
  vertical-align: baseline;
}

.tagify__tag__removeBtn {
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
}

.tagify__tag__removeBtn:hover {
  background-color: #ed4c78;
}

.tagify__tag__removeBtn:hover + div::before {
  box-shadow: none !important;
}

.tagify__tag__removeBtn:hover + div .tagify__tag-text {
  opacity: 1;
}

.tagify-form-control {
  display: flex;
  height: auto;
  padding-top: 0;
  padding-bottom: 0;
}

.tagify__input:first-child {
  padding-left: 0;
  margin-left: 0;
}

.tagify__input::before {
  line-height: 1.8;
}

.tagify__input .tagify__tag > div {
  padding: 0.3125rem 2rem 0.3125rem 1rem;
  line-height: normal;
}

.tagify__dropdown__menu {
  border: 0.0625rem solid #e7eaf3;
  border-bottom-right-radius: 0.3125rem;
  border-bottom-left-radius: 0.3125rem;
  margin-top: -1px;
}

.tagify__dropdown__item--active {
  color: #377dff;
  background-color: rgba(55, 125, 255, 0.1);
}

.tagify.tagify-form-control-list {
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
}

.tagify__dropdown__wrapper {
  border: none;
}

/*------------------------------------
  Typed.js
------------------------------------*/
.typed-cursor {
  opacity: 1;
  animation: blink 0.7s infinite;
}

@keyframes blink {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

/*------------------------------------
  File for your custom SCSS style
------------------------------------*/
`, "",{"version":3,"sources":["webpack://./src/assets/userTheme/assets/css/theme.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;;;;;EAKE;AACF;EACE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,+MAA+M;EAC/M,6GAA6G;AAC/G;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,8BAA8B;EAC9B,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,0BAA0B;EAC1B,yCAAyC;UACjC,iCAAiC;EACzC,YAAY;EACZ,gBAAgB;EAER,8BAA8B;AACxC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;;;EAIE,iGAAiG;EACjG,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,0CAA0C;AAC5C;;AAEA;;;;;EAKE,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;AACnB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;;;EAIE,0BAA0B;AAC5B;;AAEA;;;;EAIE,eAAe;AACjB;;AAEA;;;;EAIE,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,UAAU;EACV,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,oCAAoC;EACtC;AACF;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE;IACE,kCAAkC;EACpC;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,SAAS;EACT,mCAAmC;AACrC;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,+BAA+B;EAC/B,wBAAwB;EACxB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;;;;;EAME,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EAEE,aAAa;EAET,eAAe;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;;;;;;EAME,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EAEM,aAAa;EAEb,YAAY;EAChB,eAAe;AACjB;;AAEA;EAEM,cAAc;EAClB,eAAe;AACjB;;AAEA;EAEM,aAAa;EACjB,cAAc;AAChB;;AAEA;EAEM,mBAAmB;EACvB,oBAAoB;AACtB;;AAEA;EAEM,aAAa;EACjB,cAAc;AAChB;;AAEA;EAEM,aAAa;EACjB,cAAc;AAChB;;AAEA;EAEM,mBAAmB;EACvB,oBAAoB;AACtB;;AAEA;EAEM,cAAc;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EAEM,kBAAkB;EACtB,mBAAmB;AACrB;;AAEA;EAEM,mBAAmB;EACvB,oBAAoB;AACtB;;AAEA;EAEM,aAAa;EACjB,cAAc;AAChB;;AAEA;EAEM,mBAAmB;EACvB,oBAAoB;AACtB;;AAEA;EAEM,mBAAmB;EACvB,oBAAoB;AACtB;;AAEA;EAEM,aAAa;EACjB,cAAc;AAChB;;AAEA;EAEM,mBAAmB;EACvB,oBAAoB;AACtB;;AAEA;EAEM,mBAAmB;EACvB,oBAAoB;AACtB;;AAEA;EAEM,aAAa;EACjB,cAAc;AAChB;;AAEA;EAEM,mBAAmB;EACvB,oBAAoB;AACtB;;AAEA;EAEM,mBAAmB;EACvB,oBAAoB;AACtB;;AAEA;EAEM,cAAc;EAClB,eAAe;AACjB;;AAEA;EAEM,SAAS;AACf;;AAEA;EAEM,SAAS;AACf;;AAEA;EAEM,QAAQ;AACd;;AAEA;EAEM,QAAQ;AACd;;AAEA;EAEM,QAAQ;AACd;;AAEA;EAEM,QAAQ;AACd;;AAEA;EAEM,QAAQ;AACd;;AAEA;EAEM,QAAQ;AACd;;AAEA;EAEM,QAAQ;AACd;;AAEA;EAEM,QAAQ;AACd;;AAEA;EAEM,QAAQ;AACd;;AAEA;EAEM,QAAQ;AACd;;AAEA;EAEM,SAAS;AACf;;AAEA;EAEM,SAAS;AACf;;AAEA;EAEM,SAAS;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IAEM,aAAa;IAEb,YAAY;IAChB,eAAe;EACjB;EACA;IAEM,cAAc;IAClB,eAAe;EACjB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,cAAc;IAClB,WAAW;IACX,eAAe;EACjB;EACA;IAEM,kBAAkB;IACtB,mBAAmB;EACrB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,cAAc;IAClB,eAAe;EACjB;EACA;IAEM,SAAS;EACf;EACA;IAEM,SAAS;EACf;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,SAAS;EACf;EACA;IAEM,SAAS;EACf;EACA;IAEM,SAAS;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IAEM,aAAa;IAEb,YAAY;IAChB,eAAe;EACjB;EACA;IAEM,cAAc;IAClB,eAAe;EACjB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,cAAc;IAClB,WAAW;IACX,eAAe;EACjB;EACA;IAEM,kBAAkB;IACtB,mBAAmB;EACrB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,cAAc;IAClB,eAAe;EACjB;EACA;IAEM,SAAS;EACf;EACA;IAEM,SAAS;EACf;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,SAAS;EACf;EACA;IAEM,SAAS;EACf;EACA;IAEM,SAAS;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IAEM,aAAa;IAEb,YAAY;IAChB,eAAe;EACjB;EACA;IAEM,cAAc;IAClB,eAAe;EACjB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,cAAc;IAClB,WAAW;IACX,eAAe;EACjB;EACA;IAEM,kBAAkB;IACtB,mBAAmB;EACrB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,cAAc;IAClB,eAAe;EACjB;EACA;IAEM,SAAS;EACf;EACA;IAEM,SAAS;EACf;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,SAAS;EACf;EACA;IAEM,SAAS;EACf;EACA;IAEM,SAAS;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IAEM,aAAa;IAEb,YAAY;IAChB,eAAe;EACjB;EACA;IAEM,cAAc;IAClB,eAAe;EACjB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,cAAc;IAClB,WAAW;IACX,eAAe;EACjB;EACA;IAEM,kBAAkB;IACtB,mBAAmB;EACrB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,aAAa;IACjB,cAAc;EAChB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,mBAAmB;IACvB,oBAAoB;EACtB;EACA;IAEM,cAAc;IAClB,eAAe;EACjB;EACA;IAEM,SAAS;EACf;EACA;IAEM,SAAS;EACf;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;EACd;EACA;IAEM,SAAS;EACf;EACA;IAEM,SAAS;EACf;EACA;IAEM,SAAS;EACf;EACA;IACE,cAAc;EAChB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;;;EAIE,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,yBAAyB;AAC3B;;AAEA;;;;EAIE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;;EAGE,0CAA0C;AAC5C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;EAEE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;;EAGE,qBAAqB;AACvB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,4CAA4C;AAC9C;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE;IACE,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,iCAAiC;EACnC;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,WAAW;EACX,8BAA8B;EAC9B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,wBAAwB;EACxB,wEAAwE;AAC1E;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qCAAqC;EACrC,UAAU;EACV,4CAA4C;AAC9C;;AAsBA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;;;EAMU,gBAAgB;AAC1B;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EAEE,aAAa;EAET,eAAe;EACnB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,oBAAoB;EAEhB,mBAAmB;EACvB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,yDAAiR;EACjR,4BAA4B;EAC5B,wDAAwD;EACxD,4DAA4D;AAC9D;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,mCAAmC;EACnC,4EAA4E;AAC9E;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,iNAA0sB;AAC5sB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,UAAU;EACV,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,yDAA4U;EAC5U,4BAA4B;EAC5B,wDAAwD;EACxD,4DAA4D;AAC9D;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,mCAAmC;EACnC,4EAA4E;AAC9E;;AAEA;EACE,qBAAqB;EACrB,sCAAsC;EACtC,iNAAqwB;AACvwB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EAEE,aAAa;EAET,mBAAmB;EAEnB,mBAAmB;AACzB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;IAEE,aAAa;IAET,mBAAmB;IAEnB,uBAAuB;IAC3B,gBAAgB;EAClB;EACA;IAEE,aAAa;IAET,cAAc;IAEd,mBAAmB;IAEnB,mBAAmB;IACvB,gBAAgB;EAClB;EACA;IACE,qBAAqB;IACrB,WAAW;IACX,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,WAAW;EACb;EACA;IAEE,aAAa;IAET,mBAAmB;IAEnB,uBAAuB;IAC3B,WAAW;IACX,eAAe;EACjB;EACA;IACE,kBAAkB;IAEd,cAAc;IAClB,aAAa;IACb,qBAAqB;IACrB,cAAc;EAChB;EACA;IAEM,mBAAmB;IAEnB,uBAAuB;EAC7B;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;UAGjB,iBAAiB;EACzB,6BAA6B;EAC7B,mCAAmC;EACnC,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;EAEE,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;EAGE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;;EAIE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,4BAA4B;EAC5B,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,OAAO;AACT;;AAEA;EACE,QAAQ;EACR,UAAU;AACZ;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE;IACE,WAAW;IACX,OAAO;EACT;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,wBAAwB;EACxB,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,wBAAwB;EACxB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAElB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAEd,cAAc;AACpB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;EAIE,UAAU;AACZ;;AAEA;EAEE,aAAa;EAET,eAAe;EAEf,2BAA2B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,uBAAuB;AACzB;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EAEM,sBAAsB;EAEtB,uBAAuB;EAEvB,uBAAuB;AAC7B;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;;;EAIE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAElB,aAAa;EAET,eAAe;EAEf,oBAAoB;EACxB,WAAW;AACb;;AAEA;;;;EAIE,kBAAkB;EAEd,cAAc;EAClB,SAAS;EACT,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;EAYE,uBAAuB;AACzB;;AAEA;;;EAGE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;EAEE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EAEE,aAAa;EAET,mBAAmB;AACzB;;AAEA;;EAEE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;;EAGE,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;;;;;;;EAQE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EAEE,aAAa;EAET,mBAAmB;EACvB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;EAME,0BAA0B;EAC1B,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;;;;;EAME,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;;;EAME,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;;;;;;EAME,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EAEZ,mBAAmB;AAC7B;;AAEA;EAEE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,WAAW;EACX,WAAW;EACX,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,WAAW;EACX,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,cAAc;EACd,WAAW;EACX,YAAY;EACZ,WAAW;EACX,mCAAmC;AACrC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yDAAkO;AACpO;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,yDAA+K;AACjL;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yDAA8K;AAChL;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EAErB,yIAAyI;AAE3I;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;EAEd,8BAA8B;AACxC;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,8BAA8B;EAC9B,kCAAkC;EAClC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,gGAAiY;EACjY,+BAA+B;EAC/B,wBAAwB;EAGhB,gBAAgB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,8BAA8B;EAC9B,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,UAAU;EACV,8BAA8B;EAC9B,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,UAAU;EACV,cAAc;EACd,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,6BAA6B;EAC7B,oBAAoB;EACpB,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,cAAc;EACd,UAAU;EACV,6BAA6B;EAGrB,gBAAgB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EAEnB,oHAA4G;EAA5G,4GAA4G;EAEpG,gBAAgB;AAC1B;;AAEA;EACE;IAEE,wBAAgB;IAAhB,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EAEnB,iHAA4G;EAA5G,4GAA4G;EAEvG,gBAAgB;AACvB;;AAEA;EACE;IAEE,qBAAgB;IAAhB,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;EACT,mBAAmB;EAEnB,gHAA4G;EAA5G,4GAA4G;EAC5G,gBAAgB;AAClB;;AAEA;EACE;IAEE,oBAAgB;IAAhB,gBAAgB;EAClB;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,6BAA6B;EAC7B,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,4GAA4G;AAC9G;;AAEA;EACE;;;IAGE,gBAAgB;EAClB;AACF;;AAEA;EAEE,aAAa;EAET,eAAe;EACnB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAGM,cAAc;EAClB,kBAAkB;AACpB;;AAEA;;EAGM,aAAa;EAEb,YAAY;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAElB,aAAa;EAET,eAAe;EAEf,mBAAmB;EAEnB,8BAA8B;EAClC,YAAY;AACd;;AAEA;;EAGE,aAAa;EAET,eAAe;EAEf,mBAAmB;EAEnB,8BAA8B;AACpC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EAEE,aAAa;EAET,sBAAsB;EAC1B,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EAEM,gBAAgB;EAEhB,YAAY;EAEZ,mBAAmB;AACzB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;EACd,6BAA6B;EAC7B,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,mCAAmC;EACnC,0BAA0B;AAC5B;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IAEM,qBAAqB;IAErB,2BAA2B;EACjC;EACA;IAEM,mBAAmB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;EACA;;IAGM,iBAAiB;EACvB;EACA;IAEE,wBAAwB;IAEpB,gBAAgB;EACtB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IAEM,qBAAqB;IAErB,2BAA2B;EACjC;EACA;IAEM,mBAAmB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;EACA;;IAGM,iBAAiB;EACvB;EACA;IAEE,wBAAwB;IAEpB,gBAAgB;EACtB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IAEM,qBAAqB;IAErB,2BAA2B;EACjC;EACA;IAEM,mBAAmB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;EACA;;IAGM,iBAAiB;EACvB;EACA;IAEE,wBAAwB;IAEpB,gBAAgB;EACtB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IAEM,qBAAqB;IAErB,2BAA2B;EACjC;EACA;IAEM,mBAAmB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,qBAAqB;IACrB,oBAAoB;EACtB;EACA;;IAGM,iBAAiB;EACvB;EACA;IAEE,wBAAwB;IAEpB,gBAAgB;EACtB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EAEM,qBAAqB;EAErB,2BAA2B;AACjC;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EAEM,mBAAmB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;;EAGM,iBAAiB;AACvB;;AAEA;EAEE,wBAAwB;EAEpB,gBAAgB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,yDAAsQ;AACxQ;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC;;AAEA;;;;EAIE,WAAW;AACb;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,yDAAyR;AAC3R;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAElB,aAAa;EAET,sBAAsB;EAC1B,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;EACtB,2BAA2B;EAC3B,gDAAgD;EAChD,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;EAEE,aAAa;AACf;;AAEA;EAEM,cAAc;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,oDAAoD;AACtD;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;;EAIM,cAAc;EAClB,WAAW;AACb;;AAEA;;EAEE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;;EAEE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IAEE,aAAa;IAET,mBAAmB;IACvB,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IAEM,SAAY;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;EACnB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IAEE,aAAa;IAET,mBAAmB;EACzB;EACA;IAEM,SAAY;IAChB,gBAAgB;EAClB;EACA;IACE,cAAc;IACd,cAAc;EAChB;EACA;IACE,0BAA0B;IAC1B,6BAA6B;EAC/B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IAGU,eAAe;IAGf,mBAAmB;IAC3B,UAAU;IACV,SAAS;EACX;EACA;IACE,qBAAqB;IACrB,WAAW;EACb;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EAEE,aAAa;EAET,eAAe;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,wBAAwB;AAC1B;;AAEA;EAEE,aAAa;AACf;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,yCAAyC;EACzC,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,iDAAiD;AACnD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,mBAAmB;EACnB,mCAAmC;EACnC,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAWA;EACE;IACE,8BAA8B;EAChC;EACA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EAEE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EAEE,aAAa;EAET,sBAAsB;EAEtB,uBAAuB;EAC3B,gBAAgB;EAChB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,qMAAqM;EACrM,gCAAgC;AAClC;;AAEA;EAEU,kDAAkD;AAC5D;;AAEA;EACE;IAEU,eAAe;EACzB;AACF;;AAEA;EAEE,aAAa;EAET,uBAAuB;AAC7B;;AAEA;EAEM,SAAO;AACb;;AAEA;EAEE,aAAa;EAET,sBAAsB;EAC1B,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,wBAAwB;EACxB,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EAEM,mBAAmB;AACzB;;AAEA;EACE,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE;IAEM,mBAAmB;EACzB;EACA;IACE,oCAAoC;IACpC,0BAA0B;EAC5B;EACA;IACE,kCAAkC;IAClC,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;EACA;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;AACF;;AAEA;EACE;IAEM,mBAAmB;EACzB;EACA;IACE,oCAAoC;IACpC,0BAA0B;EAC5B;EACA;IACE,kCAAkC;IAClC,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;EACA;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;AACF;;AAEA;EACE;IAEM,mBAAmB;EACzB;EACA;IACE,oCAAoC;IACpC,0BAA0B;EAC5B;EACA;IACE,kCAAkC;IAClC,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;EACA;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;AACF;;AAEA;EACE;IAEM,mBAAmB;EACzB;EACA;IACE,oCAAoC;IACpC,0BAA0B;EAC5B;EACA;IACE,kCAAkC;IAClC,4BAA4B;EAC9B;EACA;IACE,aAAa;EACf;EACA;IACE,2BAA2B;IAC3B,oBAAoB;EACtB;EACA;IACE,uBAAuB;IACvB,4BAA4B;EAC9B;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;EACV,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EAEM,iBAAiB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,2CAA2C;EAC3C,4BAA4B;EAC5B,oCAAoC;EACpC,gDAAgD;EAChD,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EAEE,aAAa;EAET,mBAAmB;EACvB,wBAAwB;EACxB,cAAc;EACd,2CAA2C;EAC3C,4BAA4B;EAC5B,4CAA4C;EAC5C,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EAEE,mCAAmC;EAG3B,8BAA8B;AACxC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EAEU,eAAe;AACzB;;AAEA;EAEU,sBAAsB;AAChC;;AAEA;EAEE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;;EAGM,cAAc;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEE,aAAa;EAET,mBAAmB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,0BAA0B;EAG1B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EAEM,sBAAsB;EAEtB,uBAAuB;EAC3B,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAElB,aAAa;EAET,sBAAsB;EAC1B,WAAW;EACX,oBAAoB;EACpB,sBAAsB;EACtB,4BAA4B;EAC5B,mCAAmC;EACnC,sBAAsB;EACtB,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,aAAa;EAET,uBAAuB;EAEvB,8BAA8B;EAClC,oBAAoB;EACpB,sCAAsC;EACtC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAEd,cAAc;EAClB,eAAe;AACjB;;AAEA;EAEE,aAAa;EAET,eAAe;EAEf,mBAAmB;EAEnB,yBAAyB;EAC7B,gBAAgB;EAChB,mCAAmC;EACnC,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,oBAAoB;EACtB;EACA;IACE,+BAA+B;EACjC;EACA;IACE,gCAAgC;EAClC;EACA;IACE,+BAA+B;EACjC;EACA;IACE,4BAA4B;IAG5B,mBAAmB;EACrB;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc;EACd,SAAS;EACT,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,MAAM;EACN,6BAA6B;EAC7B,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,QAAQ;EACR,oCAAoC;EACpC,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,4BAA4B;EAC5B,mCAAmC;EACnC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,oCAAoC;EACpC,uCAAuC;AACzC;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,MAAM;EACN,oCAAoC;EACpC,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,WAAW;EACX,oBAAoB;EACpB,WAAW;EACX,sCAAsC;AACxC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,QAAQ;EACR,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sCAAsC;EACtC,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEM,mBAAmB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EAEX,2BAA2B;EAEnC,sCAAsC;AAExC;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;EAGU,2BAA2B;AACrC;;AAEA;;EAGU,4BAA4B;AACtC;;AAEA;EACE,UAAU;EACV,4BAA4B;EAEpB,eAAe;AACzB;;AAEA;;;EAGE,UAAU;EACV,UAAU;AACZ;;AAEA;;EAEE,UAAU;EACV,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EAEV,aAAa;EAET,mBAAmB;EAEnB,uBAAuB;EAC3B,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;;EAGE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;;EAEE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qCAAqC;AACvC;;AAEA;EACE,yDAAsN;AACxN;;AAEA;EACE,yDAAuN;AACzN;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EAEX,aAAa;EAET,uBAAuB;EAC3B,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EAEnB,cAAc;EAClB,WAAW;EACX,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,qCAAqC;EACrC,WAAW;EACX,6BAA6B;AAC/B;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;EACX,kBAAkB;AACpB;;AASA;EACE;IAEU,yBAAyB;EACnC;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,iCAAiC;EACjC,+BAA+B;EAC/B,kBAAkB;EAEV,8CAA8C;AACxD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAcA;EACE;IAEU,mBAAmB;EAC7B;EACA;IACE,UAAU;IAEF,eAAe;EACzB;AACF;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;EAClB,UAAU;EAEF,4CAA4C;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;;;EAGE,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4CAA4C;EAC5C,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;EAC7C,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,+CAA+C;AACjD;;AAEA;EACE,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EAEE,wBAAwB;AAC1B;;AAEA;EAEE,+BAA+B;AACjC;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IAEE,wBAAwB;EAC1B;EACA;IAEE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IAEE,wBAAwB;EAC1B;EACA;IAEE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IAEE,wBAAwB;EAC1B;EACA;IAEE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IAEE,wBAAwB;EAC1B;EACA;IAEE,+BAA+B;EACjC;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,gCAAgC;EAClC;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,8BAA8B;EAChC;EACA;IAEE,wBAAwB;EAC1B;EACA;IAEE,+BAA+B;EACjC;AACF;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;;;;EAKE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EAEM,8BAA8B;AACpC;;AAEA;EAEM,iCAAiC;AACvC;;AAEA;EAEM,sCAAsC;AAC5C;;AAEA;EAEM,yCAAyC;AAC/C;;AAEA;EAEM,0BAA0B;AAChC;;AAEA;EAEM,4BAA4B;AAClC;;AAEA;EAEM,kCAAkC;AACxC;;AAEA;EAEM,yBAAyB;AAC/B;;AAEA;EAEM,uBAAuB;AAC7B;;AAEA;EAEM,uBAAuB;AAC7B;;AAEA;EAEM,yBAAyB;AAC/B;;AAEA;EAEM,yBAAyB;AAC/B;;AAEA;EAEM,sCAAsC;AAC5C;;AAEA;EAEM,oCAAoC;AAC1C;;AAEA;EAEM,kCAAkC;AACxC;;AAEA;EAEM,yCAAyC;AAC/C;;AAEA;EAEM,wCAAwC;AAC9C;;AAEA;EAEM,kCAAkC;AACxC;;AAEA;EAEM,gCAAgC;AACtC;;AAEA;EAEM,8BAA8B;AACpC;;AAEA;EAEM,gCAAgC;AACtC;;AAEA;EAEM,+BAA+B;AACrC;;AAEA;EAEM,oCAAoC;AAC1C;;AAEA;EAEM,kCAAkC;AACxC;;AAEA;EAEM,gCAAgC;AACtC;;AAEA;EAEM,uCAAuC;AAC7C;;AAEA;EAEM,sCAAsC;AAC5C;;AAEA;EAEM,iCAAiC;AACvC;;AAEA;EAEM,2BAA2B;AACjC;;AAEA;EAEM,iCAAiC;AACvC;;AAEA;EAEM,+BAA+B;AACrC;;AAEA;EAEM,6BAA6B;AACnC;;AAEA;EAEM,+BAA+B;AACrC;;AAEA;EAEM,8BAA8B;AACpC;;AAEA;EACE;IAEM,8BAA8B;EACpC;EACA;IAEM,iCAAiC;EACvC;EACA;IAEM,sCAAsC;EAC5C;EACA;IAEM,yCAAyC;EAC/C;EACA;IAEM,0BAA0B;EAChC;EACA;IAEM,4BAA4B;EAClC;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,yBAAyB;EAC/B;EACA;IAEM,uBAAuB;EAC7B;EACA;IAEM,uBAAuB;EAC7B;EACA;IAEM,yBAAyB;EAC/B;EACA;IAEM,yBAAyB;EAC/B;EACA;IAEM,sCAAsC;EAC5C;EACA;IAEM,oCAAoC;EAC1C;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,yCAAyC;EAC/C;EACA;IAEM,wCAAwC;EAC9C;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,gCAAgC;EACtC;EACA;IAEM,8BAA8B;EACpC;EACA;IAEM,gCAAgC;EACtC;EACA;IAEM,+BAA+B;EACrC;EACA;IAEM,oCAAoC;EAC1C;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,gCAAgC;EACtC;EACA;IAEM,uCAAuC;EAC7C;EACA;IAEM,sCAAsC;EAC5C;EACA;IAEM,iCAAiC;EACvC;EACA;IAEM,2BAA2B;EACjC;EACA;IAEM,iCAAiC;EACvC;EACA;IAEM,+BAA+B;EACrC;EACA;IAEM,6BAA6B;EACnC;EACA;IAEM,+BAA+B;EACrC;EACA;IAEM,8BAA8B;EACpC;AACF;;AAEA;EACE;IAEM,8BAA8B;EACpC;EACA;IAEM,iCAAiC;EACvC;EACA;IAEM,sCAAsC;EAC5C;EACA;IAEM,yCAAyC;EAC/C;EACA;IAEM,0BAA0B;EAChC;EACA;IAEM,4BAA4B;EAClC;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,yBAAyB;EAC/B;EACA;IAEM,uBAAuB;EAC7B;EACA;IAEM,uBAAuB;EAC7B;EACA;IAEM,yBAAyB;EAC/B;EACA;IAEM,yBAAyB;EAC/B;EACA;IAEM,sCAAsC;EAC5C;EACA;IAEM,oCAAoC;EAC1C;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,yCAAyC;EAC/C;EACA;IAEM,wCAAwC;EAC9C;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,gCAAgC;EACtC;EACA;IAEM,8BAA8B;EACpC;EACA;IAEM,gCAAgC;EACtC;EACA;IAEM,+BAA+B;EACrC;EACA;IAEM,oCAAoC;EAC1C;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,gCAAgC;EACtC;EACA;IAEM,uCAAuC;EAC7C;EACA;IAEM,sCAAsC;EAC5C;EACA;IAEM,iCAAiC;EACvC;EACA;IAEM,2BAA2B;EACjC;EACA;IAEM,iCAAiC;EACvC;EACA;IAEM,+BAA+B;EACrC;EACA;IAEM,6BAA6B;EACnC;EACA;IAEM,+BAA+B;EACrC;EACA;IAEM,8BAA8B;EACpC;AACF;;AAEA;EACE;IAEM,8BAA8B;EACpC;EACA;IAEM,iCAAiC;EACvC;EACA;IAEM,sCAAsC;EAC5C;EACA;IAEM,yCAAyC;EAC/C;EACA;IAEM,0BAA0B;EAChC;EACA;IAEM,4BAA4B;EAClC;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,yBAAyB;EAC/B;EACA;IAEM,uBAAuB;EAC7B;EACA;IAEM,uBAAuB;EAC7B;EACA;IAEM,yBAAyB;EAC/B;EACA;IAEM,yBAAyB;EAC/B;EACA;IAEM,sCAAsC;EAC5C;EACA;IAEM,oCAAoC;EAC1C;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,yCAAyC;EAC/C;EACA;IAEM,wCAAwC;EAC9C;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,gCAAgC;EACtC;EACA;IAEM,8BAA8B;EACpC;EACA;IAEM,gCAAgC;EACtC;EACA;IAEM,+BAA+B;EACrC;EACA;IAEM,oCAAoC;EAC1C;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,gCAAgC;EACtC;EACA;IAEM,uCAAuC;EAC7C;EACA;IAEM,sCAAsC;EAC5C;EACA;IAEM,iCAAiC;EACvC;EACA;IAEM,2BAA2B;EACjC;EACA;IAEM,iCAAiC;EACvC;EACA;IAEM,+BAA+B;EACrC;EACA;IAEM,6BAA6B;EACnC;EACA;IAEM,+BAA+B;EACrC;EACA;IAEM,8BAA8B;EACpC;AACF;;AAEA;EACE;IAEM,8BAA8B;EACpC;EACA;IAEM,iCAAiC;EACvC;EACA;IAEM,sCAAsC;EAC5C;EACA;IAEM,yCAAyC;EAC/C;EACA;IAEM,0BAA0B;EAChC;EACA;IAEM,4BAA4B;EAClC;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,yBAAyB;EAC/B;EACA;IAEM,uBAAuB;EAC7B;EACA;IAEM,uBAAuB;EAC7B;EACA;IAEM,yBAAyB;EAC/B;EACA;IAEM,yBAAyB;EAC/B;EACA;IAEM,sCAAsC;EAC5C;EACA;IAEM,oCAAoC;EAC1C;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,yCAAyC;EAC/C;EACA;IAEM,wCAAwC;EAC9C;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,gCAAgC;EACtC;EACA;IAEM,8BAA8B;EACpC;EACA;IAEM,gCAAgC;EACtC;EACA;IAEM,+BAA+B;EACrC;EACA;IAEM,oCAAoC;EAC1C;EACA;IAEM,kCAAkC;EACxC;EACA;IAEM,gCAAgC;EACtC;EACA;IAEM,uCAAuC;EAC7C;EACA;IAEM,sCAAsC;EAC5C;EACA;IAEM,iCAAiC;EACvC;EACA;IAEM,2BAA2B;EACjC;EACA;IAEM,iCAAiC;EACvC;EACA;IAEM,+BAA+B;EACrC;EACA;IAEM,6BAA6B;EACnC;EACA;IAEM,+BAA+B;EACrC;EACA;IAEM,8BAA8B;EACpC;AACF;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,mCAAmC;UAG3B,2BAA2B;AACrC;;AAEA;EACE,oCAAoC;UAG5B,4BAA4B;AACtC;;AAEA;EACE,oCAAoC;UAG5B,4BAA4B;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EAEE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;AACf;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,aAAa;AACf;;AAEA;EACE;IAEE,gBAAgB;IAChB,MAAM;IACN,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,yEAAyE;AAC3E;;AAEA;EACE,oEAAoE;AACtE;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;;EAEE,iCAAiC;AACnC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,oBAAoB;EACtB;EACA;;IAEE,wBAAwB;EAC1B;EACA;;IAEE,0BAA0B;EAC5B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,yBAAyB;EAC3B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,yBAAyB;EAC3B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;EACA;IACE,qBAAqB;EACvB;EACA;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,0BAA0B;EAC5B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,gCAAgC;EAClC;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,0BAA0B;EAC5B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,gCAAgC;EAClC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,+BAA+B;EACjC;EACA;IACE,wBAAwB;EAC1B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,6BAA6B;EAC/B;EACA;IACE,uBAAuB;EACzB;EACA;;IAEE,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,8BAA8B;EAChC;EACA;;IAEE,4BAA4B;EAC9B;AACF;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,oBAAoB;EACpB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE,4GAA4G;AAC9G;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,iCAAiC;EACjC,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;;;IAGE,4BAA4B;IAC5B,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;EACA;IACE,6BAA6B;EAC/B;EACA;IACE,gCAAgC;EAClC;EACA;;IAEE,+BAA+B;IAC/B,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;;IAEE,wBAAwB;EAC1B;EACA;;;IAGE,UAAU;IACV,SAAS;EACX;EACA;;IAEE,uBAAuB;EACzB;EACA;IACE,QAAQ;EACV;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,aAAa;EACf;EACA;IACE,4BAA4B;EAC9B;EACA;IACE,oCAAoC;EACtC;EACA;;IAEE,iCAAiC;EACnC;EACA;;IAEE,oCAAoC;EACtC;EACA;IACE,cAAc;EAChB;EACA;;;;IAIE,qBAAqB;EACvB;EACA;IACE,cAAc;IACd,qBAAqB;EACvB;AACF;;AAEA;;;;yEAIyE;AACzE;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,sBAAsB;EACxB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,4BAA4B;AAC9B;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;;EAEE,gCAAgC;AAClC;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,gCAAgC;EAClC;AACF;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,gCAAgC;EAClC;AACF;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,gCAAgC;EAClC;AACF;;AAEA;EACE;;IAEE,yBAAyB;EAC3B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,kCAAkC;EACpC;EACA;;IAEE,6BAA6B;EAC/B;EACA;;IAEE,gCAAgC;EAClC;AACF;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;AACf;;AAEA;;qCAEqC;;AAMrC;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAOA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;qCAEqC;AACrC;;;EAGE,UAAU;AACZ;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;;EAGE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;qCAEqC;AACrC;EACE;IACE,aAAa;EACf;AACF;;AAEA;;qCAEqC;AACrC;EACE,aAAa;AACf;;AAEA;;qCAEqC;AACrC;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;qCAEqC;AACrC;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,aAAa;EACb,oBAAoB;AACtB;;AAEA;;qCAEqC;AACrC;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,wBAAwB;EACxB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EACE,mBAAmB;EAEnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EAEd,oBAAoB;EAEhB,cAAc;EAEd,uBAAuB;EAEvB,mBAAmB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EAEU,wBAAwB;AAClC;;AAEA,aAAa;AACb;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,+BAA+B;EAC/B,wDAAwD;AAC1D;;AAEA;EACE,WAAW;EACX,sCAAsC;AACxC;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,uDAAuD;AACzD;;AAEA;EACE,iDAAiD;AACnD;;AAEA;EACE,iDAAiD;AACnD;;AAEA,iBAAiB;AACjB;;EAEE,aAAa;AACf;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;AAC3B;;AAEA;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EAEE,aAAa;AACf;;AAEA,aAAa;AACb;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA,aAAa;AACb;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,aAAa;EAET,mBAAmB;AACzB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qFAAqX;EACrX,WAAW;EACX,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,aAAa;AACb;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EAEE,aAAa;EAET,mBAAmB;AACzB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qFAAqX;EACrX,WAAW;EACX,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA,UAAU;AACV;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,aAAa;EAET,sBAAsB;EAC1B,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEM,cAAc;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,qCAAqC;EACrC,oCAAoC;EACpC,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,qCAAqC;EACrC,WAAW;AACb;;AAEA,WAAW;AACX;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;EAC/B,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,uCAAuC;EACvC,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EAEA,6BAA6B;AACvC;;AAEA,mBAAmB;AACnB;EACE,yBAAyB;EACzB,qCAAqC;EACrC,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;qCAEqC;AACrC;EACE,aAAa;AACf;;AAEA;EAEU,mCAAmC;AAC7C;;AAEA;EAEU,mCAAmC;AAC7C;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;qCAEqC;AACrC;EACE;;IAEE,iBAAiB;EACnB;EACA;;IAEE,WAAW;IACX,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,cAAc;IACd,kBAAkB;EACpB;EACA;IACE,iBAAiB;EACnB;EACA;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;;qCAEqC;AACrC;EACE,WAAW;EAEX,aAAa;EAET,mBAAmB;EAEnB,eAAe;AACrB;;AAEA;EAEM,8BAA8B;AACpC;;AAEA;EAEM,QAAQ;AACd;;AAEA;EAEM,QAAQ;EACZ,iBAAiB;AACnB;;AAEA;EAEM,QAAQ;AACd;;AAEA;EACE;IAEM,8BAA8B;EACpC;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;IACZ,iBAAiB;EACnB;EACA;IAEM,QAAQ;EACd;AACF;;AAEA;EACE;IAEM,8BAA8B;EACpC;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;IACZ,iBAAiB;EACnB;EACA;IAEM,QAAQ;EACd;AACF;;AAEA;EACE;IAEM,8BAA8B;EACpC;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;IACZ,iBAAiB;EACnB;EACA;IAEM,QAAQ;EACd;AACF;;AAEA;EACE;IAEM,8BAA8B;EACpC;EACA;IAEM,QAAQ;EACd;EACA;IAEM,QAAQ;IACZ,iBAAiB;EACnB;EACA;IAEM,QAAQ;EACd;AACF;;AAEA;EACE;IAEM,yBAAyB;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE;IAEM,yBAAyB;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE;IAEM,yBAAyB;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EACE;IAEM,yBAAyB;EAC/B;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,oBAAoB;EACtB;AACF;;AAEA;EAEM,yBAAyB;AAC/B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE;IAEM,cAAc;IAClB,eAAe;EACjB;AACF;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EAEZ,aAAa;EAET,mBAAmB;EAEnB,uBAAuB;EAC3B,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,iGAAiG;EACjG,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EAEE,oBAAoB;EACpB,aAAa;AACf;;AAEA;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EAEE,aAAa;AACf;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,oDAAoD;EACpD,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,oDAAoD;EACpD,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;;qCAEqC;AACrC;EACE,sBAAsB;AACxB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;EACA;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,qBAAqB;EACvB;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;;EAEE,aAAa;AACf;;AAEA;EAEE,aAAa;AACf;;AAEA;EACE;;;;IAIE,sBAAsB;IACtB,wBAAwB;EAC1B;AACF;;AAEA;;qCAEqC;AACrC;EACE,sBAAsB;AACxB;;AAEA;;qCAEqC;AACrC;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,qFAAoY;AACtY;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,+BAA+B;EACjC;EACA;IACE,WAAW;EACb;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,WAAW;EACb;EACA;IACE,qFAAoY;EACtY;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,+BAA+B;EACjC;EACA;IACE,WAAW;EACb;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,WAAW;EACb;EACA;IACE,qFAAoY;EACtY;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,+BAA+B;EACjC;EACA;IACE,WAAW;EACb;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,WAAW;EACb;EACA;IACE,qFAAoY;EACtY;AACF;;AAEA;EACE;IACE,WAAW;EACb;EACA;IACE,+BAA+B;EACjC;EACA;IACE,WAAW;EACb;EACA;;IAEE,+BAA+B;EACjC;EACA;;IAEE,WAAW;EACb;EACA;IACE,qFAAoY;EACtY;AACF;;AAEA;;qCAEqC;AACrC;EAEM,eAAe;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EAEM,mBAAmB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,yBAAyB;EACzB,0BAA0B;EAC1B,qCAAqC;EACrC,oCAAoC;EACpC,kDAAkD;AACpD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EAEE,aAAa;EAET,SAAY;EAEZ,sBAAsB;AAC5B;;AAEA;EAEE,aAAa;EAET,mBAAmB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,qBAAqB;EACrB,qCAAqC;EACrC,YAAY;EACZ,WAAW;AACb;;AAEA;EACE;IAEM,eAAe;EACrB;EACA;IACE,aAAa;EACf;EACA;IAEM,mBAAmB;EACzB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,mCAAmC;IACnC,yBAAyB;IACzB,0BAA0B;IAC1B,qCAAqC;IACrC,oCAAoC;IACpC,kDAAkD;EACpD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,cAAc;IACd,eAAe;EACjB;EACA;IACE,qCAAqC;EACvC;EACA;IAEE,aAAa;IAET,SAAY;IAEZ,sBAAsB;EAC5B;EACA;IAEE,aAAa;IAET,mBAAmB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,qBAAqB;IACrB,qCAAqC;IACrC,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IAEM,eAAe;EACrB;EACA;IACE,aAAa;EACf;EACA;IAEM,mBAAmB;EACzB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,mCAAmC;IACnC,yBAAyB;IACzB,0BAA0B;IAC1B,qCAAqC;IACrC,oCAAoC;IACpC,kDAAkD;EACpD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,cAAc;IACd,eAAe;EACjB;EACA;IACE,qCAAqC;EACvC;EACA;IAEE,aAAa;IAET,SAAY;IAEZ,sBAAsB;EAC5B;EACA;IAEE,aAAa;IAET,mBAAmB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,qBAAqB;IACrB,qCAAqC;IACrC,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IAEM,eAAe;EACrB;EACA;IACE,aAAa;EACf;EACA;IAEM,mBAAmB;EACzB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,mCAAmC;IACnC,yBAAyB;IACzB,0BAA0B;IAC1B,qCAAqC;IACrC,oCAAoC;IACpC,kDAAkD;EACpD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,cAAc;IACd,eAAe;EACjB;EACA;IACE,qCAAqC;EACvC;EACA;IAEE,aAAa;IAET,SAAY;IAEZ,sBAAsB;EAC5B;EACA;IAEE,aAAa;IAET,mBAAmB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,qBAAqB;IACrB,qCAAqC;IACrC,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IAEM,eAAe;EACrB;EACA;IACE,aAAa;EACf;EACA;IAEM,mBAAmB;EACzB;EACA;IACE,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;EACvB;EACA;IACE,mCAAmC;IACnC,yBAAyB;IACzB,0BAA0B;IAC1B,qCAAqC;IACrC,oCAAoC;IACpC,kDAAkD;EACpD;EACA;IACE,sBAAsB;EACxB;EACA;IACE,UAAU;IACV,UAAU;EACZ;EACA;IACE,sBAAsB;IACtB,cAAc;IACd,eAAe;EACjB;EACA;IACE,qCAAqC;EACvC;EACA;IAEE,aAAa;IAET,SAAY;IAEZ,sBAAsB;EAC5B;EACA;IAEE,aAAa;IAET,mBAAmB;EACzB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,qBAAqB;IACrB,qCAAqC;IACrC,YAAY;IACZ,WAAW;EACb;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;;IAEE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IAEE,aAAa;IAET,mBAAmB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;;IAGU,0BAA0B;EACpC;EACA;IAEU,wBAAwB;EAClC;EACA;IAEU,yBAAyB;EACnC;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;;IAEE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IAEE,aAAa;IAET,mBAAmB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;;IAGU,0BAA0B;EACpC;EACA;IAEU,wBAAwB;EAClC;EACA;IAEU,yBAAyB;EACnC;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;;IAEE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IAEE,aAAa;IAET,mBAAmB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;;IAGU,0BAA0B;EACpC;EACA;IAEU,wBAAwB;EAClC;EACA;IAEU,yBAAyB;EACnC;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;;IAEE,WAAW;EACb;EACA;IACE,gBAAgB;IAChB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,uBAAuB;EACzB;EACA;IAEE,aAAa;IAET,mBAAmB;EACzB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,0BAA0B;EAC5B;EACA;;IAGU,0BAA0B;EACpC;EACA;IAEU,wBAAwB;EAClC;EACA;IAEU,yBAAyB;EACnC;EACA;IACE,mBAAmB;IACnB,sBAAsB;EACxB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,oCAAoC;IACpC,yBAAyB;IACzB,4BAA4B;EAC9B;EACA;IACE,oBAAoB;EACtB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sCAAsC;EACxC;AACF;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EAEE,aAAa;EAET,mBAAmB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;;EAGU,0BAA0B;AACpC;;AAEA;EAEU,wBAAwB;AAClC;;AAEA;EAEU,yBAAyB;AACnC;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE;;;;;;;;IAQE,aAAa;EACf;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IAEM,iBAAiB;EACvB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,iDAAiD;EACjD,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,iDAAiD;IACjD,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,iDAAiD;IACjD,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,iDAAiD;IACjD,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IACR,OAAO;IACP,kBAAkB;EACpB;EACA;IACE,eAAe;IACf,sBAAsB;IACtB,iDAAiD;IACjD,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;EACA;IACE,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,iDAAiD;EACnD;EACA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,iDAAiD;EACnD;EACA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,iDAAiD;EACnD;EACA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,iDAAiD;EACnD;EACA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;EACE,sBAAsB;EACtB,iDAAiD;AACnD;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE;IACE,gBAAgB;IAChB,eAAe;EACjB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;;IAGE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,0CAA0C;IAC1C,kBAAkB;EACpB;EACA;;;IAGE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,MAAM;IACN,YAAY;EACd;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;;IAGE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,0CAA0C;IAC1C,kBAAkB;EACpB;EACA;;;IAGE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,YAAY;EACZ,MAAM;AACR;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,MAAM;EACR;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,MAAM;EACR;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,MAAM;EACR;AACF;;AAEA;EACE;IACE,eAAe;IACf,YAAY;IACZ,MAAM;EACR;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE;;;IAGE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;;;IAGE,aAAa;EACf;EACA;;;IAGE,0CAA0C;IAC1C,kBAAkB;EACpB;EACA;;;IAGE,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;;qCAEqC;AACrC;EAEU,sBAAsB;EAEtB,yBAAyB;AACnC;;AAWA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EAEU,sBAAsB;AAChC;;AAeA;EACE;IACE,UAAU;IAEF,kCAAkC;EAC5C;EACA;IACE,UAAU;IAEF,eAAe;EACzB;AACF;;AAEA;EAEU,wBAAwB;AAClC;;AAWA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;EAEU,uBAAuB;AACjC;;AAaA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IAEF,mCAAmC;EAC7C;AACF;;AAEA;EAEU,yBAAyB;AACnC;;AAaA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IAEF,kCAAkC;EAC5C;AACF;;AAEA;EAEU,2BAA2B;AACrC;;AAcA;EACE;IAEU,kCAAkC;IAC1C,mBAAmB;EACrB;EACA;IAEU,+BAA+B;EACzC;AACF;;AAEA;EAEU,yBAAyB;AACnC;;AAcA;EACE;IAEU,mCAAmC;IAC3C,mBAAmB;EACrB;EACA;IAEU,+BAA+B;EACzC;AACF;;AAEA;EAEU,2BAA2B;AACrC;;AAeA;EACE;IACE,UAAU;IAEF,mCAAmC;EAC7C;EACA;IACE,UAAU;IAEF,+BAA+B;EACzC;AACF;;AAEA;EAEU,0BAA0B;AACpC;;AAeA;EACE;IACE,UAAU;IAEF,kCAAkC;EAC5C;EACA;IACE,UAAU;IAEF,+BAA+B;EACzC;AACF;;AAEA;EAEU,2BAA2B;AACrC;;AAaA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IAEF,mCAAmC;EAC7C;AACF;;AAEA;EAEU,2BAA2B;AACrC;;AAaA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IAEF,kCAAkC;EAC5C;AACF;;AAEA;EAEU,4BAA4B;AACtC;;AAEA;;qCAEqC;AACrC;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,YAAY;EAET,iBAAiB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EAEE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;;qCAEqC;AACrC;EAEE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;;;;;EAME,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;;EAEE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;qCAEqC;AACrC;EAEE,aAAa;EAET,uBAAuB;EAEvB,mBAAmB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;;qCAEqC;AACrC;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAEhB,oBAAoB;EAEhB,cAAc;EAEd,uBAAuB;EAEvB,mBAAmB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,2BAA2B;EAC3B,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;qCAEqC;AACrC,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA,cAAc;AACd;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA,eAAe;AACf;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA,cAAc;AACd;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,oCAAoC;EACpC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;qCAEqC;AACrC,iBAAiB;AACjB;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,eAAe;AACf;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;qCAEqC;AACrC;EAEE,oBAAoB;EAEhB,mBAAmB;AACzB;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,oFAAqX;AACvX;;AAEA;EACE,cAAc;EACd,sDAAsD;AACxD;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,oFAAqX;AACvX;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAkX;AACpX;;AAEA,mDAAmD;AACnD;EACE,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,qDAAqD;AACrD;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mDAAmD;AACnD;EACE,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;EACE,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mDAAmD;AACnD;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,kDAAkD;AAClD;EACE,+CAA+C;AACjD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;EACE,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,kDAAkD;AAClD;EACE,8CAA8C;AAChD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;;qCAEqC;AACrC,iCAAiC;AACjC;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,mCAAmC;AACnC;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,gCAAgC;AAChC;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;;qCAEqC;AACrC;EACE,cAAc;EACd,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;EACE,cAAc;EACd,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,4CAA4C;AAC9C;;AAEA;EACE,cAAc;EACd,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,wCAAwC;EACxC,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qFAAqX;EACrX,gCAAgC;AAClC;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,oFAAqX;EACrX,gCAAgC;AAClC;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;EACrX,gCAAgC;AAClC;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;EACrX,gCAAgC;AAClC;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;EACrX,gCAAgC;AAClC;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAqX;EACrX,gCAAgC;AAClC;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;EACrX,gCAAgC;AAClC;;AAEA;EACE,qFAAqX;AACvX;;AAEA;EACE,qFAAqX;EACrX,gCAAgC;AAClC;;AAEA;EACE,qFAAkX;AACpX;;AAEA;EACE,qFAAqX;EACrX,gCAAgC;AAClC;;AAEA;EACE,qFAAkX;AACpX;;AAEA;;qCAEqC;AACrC;EACE,qBAAqB;AACvB;;AAEA;;qCAEqC;AACrC,SAAS;AACT;EACE,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;qCAEqC;AACrC,yBAAyB;AACzB;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA,uBAAuB;AACvB;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA,sBAAsB;AACtB;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAElB,oBAAoB;EAEhB,uBAAuB;EAC3B,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,wBAAwB;EACxB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EAEE,aAAa;EAET,uBAAuB;EAEvB,mBAAmB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;;qCAEqC;AACrC;EACE,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAElB,oBAAoB;EAEhB,cAAc;EAEd,uBAAuB;EAEvB,mBAAmB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,UAAU;AACZ;;AAEA,WAAW;AACX;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;qCAEqC;AACrC;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;;qCAEqC;AACrC;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;;qCAEqC;AACrC;EAGU,eAAe;AACzB;;AAEA;EAGU,eAAe;AACzB;;AAEA;EAGU,eAAe;AACzB;;AAEA;EAGU,kBAAkB;AAC5B;;AAEA;EAGU,gBAAgB;AAC1B;;AAEA;EAGU,gBAAgB;AAC1B;;AAEA;EAGU,gBAAgB;AAC1B;;AAEA;EAGU,gBAAgB;AAC1B;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE;IAGU,eAAe;EACzB;EACA;IAGU,eAAe;EACzB;EACA;IAGU,eAAe;EACzB;EACA;IAGU,kBAAkB;EAC5B;EACA;IAGU,gBAAgB;EAC1B;EACA;IAGU,gBAAgB;EAC1B;EACA;IAGU,gBAAgB;EAC1B;EACA;IAGU,gBAAgB;EAC1B;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,qBAAqB;IACrB,WAAW;EACb;AACF;;AAEA;EACE;IAGU,eAAe;EACzB;EACA;IAGU,eAAe;EACzB;EACA;IAGU,eAAe;EACzB;EACA;IAGU,kBAAkB;EAC5B;EACA;IAGU,gBAAgB;EAC1B;EACA;IAGU,gBAAgB;EAC1B;EACA;IAGU,gBAAgB;EAC1B;EACA;IAGU,gBAAgB;EAC1B;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,qBAAqB;IACrB,WAAW;EACb;AACF;;AAEA;EACE;IAGU,eAAe;EACzB;EACA;IAGU,eAAe;EACzB;EACA;IAGU,eAAe;EACzB;EACA;IAGU,kBAAkB;EAC5B;EACA;IAGU,gBAAgB;EAC1B;EACA;IAGU,gBAAgB;EAC1B;EACA;IAGU,gBAAgB;EAC1B;EACA;IAGU,gBAAgB;EAC1B;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,qBAAqB;IACrB,WAAW;EACb;AACF;;AAEA;EACE;IAGU,eAAe;EACzB;EACA;IAGU,eAAe;EACzB;EACA;IAGU,eAAe;EACzB;EACA;IAGU,kBAAkB;EAC5B;EACA;IAGU,gBAAgB;EAC1B;EACA;IAGU,gBAAgB;EAC1B;EACA;IAGU,gBAAgB;EAC1B;EACA;IAGU,gBAAgB;EAC1B;EACA;IACE,UAAU;IACV,SAAS;EACX;EACA;IACE,qBAAqB;IACrB,WAAW;EACb;AACF;;AAEA;EACE,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,0BAA0B;EAC1B,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EAEE,aAAa;EAET,mBAAmB;EAEnB,mBAAmB;EAEnB,8BAA8B;EAClC,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE;IACE,qDAAqD;EACvD;AACF;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,gDAAgD;EAChD,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,oBAAoB;AACpB;EACE,gBAAgB;AAClB;;AAEA;EACE,oDAAoD;AACtD;;AAEA,aAAa;AACb;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EAEE,aAAa;EAET,uBAAuB;EAEvB,mBAAmB;EAEnB,sBAAsB;AAC5B;;AAEA,WAAW;AACX;EACE,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iDAAiD;EACjD,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,aAAa;AACb;EACE,uBAAuB;AACzB;;AAEA,2BAA2B;AAC3B;;EAEE,eAAe;AACjB;;AAEA,UAAU;AACV;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA,aAAa;AACb;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA,eAAe;AACf;EACE,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,UAAU;AACZ;;AAEA;;qCAEqC;AACrC;EACE;IACE,qBAAqB;IACrB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,qBAAqB;IACrB,oBAAoB;EACtB;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,oBAAoB;IACpB,mBAAmB;EACrB;EACA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,sBAAsB;IACtB,qBAAqB;EACvB;AACF;;AAEA;;qCAEqC;AACrC;EACE;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qDAAqD;EACvD;EACA;IACE,+BAA+B;IAC/B,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;;IAEE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,mCAAmC;IACnC,kCAAkC;IAClC,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;;IAEE,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;;IAEE,mCAAmC;IACnC,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qDAAqD;EACvD;EACA;IACE,+BAA+B;IAC/B,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;;IAEE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,mCAAmC;IACnC,kCAAkC;IAClC,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;;IAEE,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;;IAEE,mCAAmC;IACnC,kCAAkC;EACpC;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,qDAAqD;EACvD;EACA;IACE,+BAA+B;IAC/B,gCAAgC;IAChC,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;;IAEE,+BAA+B;IAC/B,gCAAgC;EAClC;EACA;;IAEE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;IACE,mCAAmC;IACnC,kCAAkC;IAClC,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;;IAEE,yBAAyB;IACzB,0BAA0B;EAC5B;EACA;;IAEE,mCAAmC;IACnC,kCAAkC;EACpC;AACF;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;EACX,OAAO;EACP,iDAAiD;AACnD;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;AACT;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;;qCAEqC;AACrC;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,YAAY;EACZ,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,oCAAoC;IACpC,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,oCAAoC;IACpC,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,oCAAoC;IACpC,WAAW;EACb;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,oCAAoC;IACpC,WAAW;EACb;AACF;;AAEA;EAEU,wBAAwB;EAChC,WAAW;AACb;;AAEA;;qCAEqC;AACrC;EAEE,aAAa;EAET,mBAAmB;AACzB;;AAEA;EAEM,SAAY;EAChB,mCAAmC;EACnC,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;qCAEqC;AACrC,SAAS;AACT;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC,SAAS;AACT;EACE,yDAAyD;AAC3D;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,aAAa;AACb;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,qBAAqB;AACvB;;AAEA,WAAW;AACX;EAEE,aAAa;EAET,mBAAmB;AACzB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,qFAAqX;EACrX,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EAEU,0BAA0B;AACpC;;AAEA,SAAS;AACT;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,MAAM;AACR;;AAEA;EACE,SAAS;EACT,SAAS;AACX;;AAEA;EACE;IACE,MAAM;EACR;EACA;IACE,SAAS;IACT,SAAS;EACX;AACF;;AAEA;EACE;IACE,MAAM;EACR;EACA;IACE,SAAS;IACT,SAAS;EACX;AACF;;AAEA;EACE;IACE,MAAM;EACR;EACA;IACE,SAAS;IACT,SAAS;EACX;AACF;;AAEA;EACE;IACE,MAAM;EACR;EACA;IACE,SAAS;IACT,SAAS;EACX;AACF;;AAEA;;qCAEqC;AACrC;EACE,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE;IACE,gBAAgB;EAClB;AACF;;AAEA;;qCAEqC;AACrC;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;;qCAEqC;AACrC;;EAEE,UAAU;AACZ;;AAEA;;EAEE,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA,cAAc;AACd;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;;EAEE,YAAY;AACd;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,WAAW;EACX,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE;IACE,cAAc;EAChB;EACA;;IAEE,WAAW;EACb;EACA;;IAEE,iCAAiC;IACjC,kCAAkC;IAClC,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,yBAAyB;IACzB,0BAA0B;IAC1B,qCAAqC;IACrC,oCAAoC;EACtC;EACA;;;;;;;;;;;;IAYE,cAAc;IACd,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;;IAEE,WAAW;EACb;EACA;;IAEE,iCAAiC;IACjC,kCAAkC;IAClC,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,yBAAyB;IACzB,0BAA0B;IAC1B,qCAAqC;IACrC,oCAAoC;EACtC;EACA;;;;;;;;;;;;IAYE,cAAc;IACd,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;;IAEE,WAAW;EACb;EACA;;IAEE,iCAAiC;IACjC,kCAAkC;IAClC,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,yBAAyB;IACzB,0BAA0B;IAC1B,qCAAqC;IACrC,oCAAoC;EACtC;EACA;;;;;;;;;;;;IAYE,cAAc;IACd,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;EACA;;IAEE,WAAW;EACb;EACA;;IAEE,iCAAiC;IACjC,kCAAkC;IAClC,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;;IAEE,gBAAgB;EAClB;EACA;;IAEE,yBAAyB;IACzB,0BAA0B;IAC1B,qCAAqC;IACrC,oCAAoC;EACtC;EACA;;;;;;;;;;;;IAYE,cAAc;IACd,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;AACb;;AAEA;;EAEE,iCAAiC;EACjC,kCAAkC;EAClC,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,0BAA0B;EAC1B,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;;;;;;;;;;;;EAYE,cAAc;EACd,sBAAsB;AACxB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;EACpC,0BAA0B;EAC1B,6BAA6B;AAC/B;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;EACrC,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,UAAU;EACV,YAAY;AACd;;AAEA;;EAEE,oBAAoB;EACpB,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;;EAEE,qBAAqB;EACrB,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;;qCAEqC;AACrC;EACE,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;;EAEE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;;EAEE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;;qCAEqC;AACrC;;EAEE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;;EAEE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,gCAAgC;EAChC,mCAAmC;AACrC;;AAEA;;EAEE,kBAAkB;EAClB,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;;EAEE,mBAAmB;EACnB,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA;;qCAEqC;AACrC;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;;;;EAIE,gBAAgB;AAClB;;AAEA;;qCAEqC;AACrC;;EAEE,0BAA0B;AAC5B;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;;EAGE,4CAA4C;AAC9C;;AAEA;;qCAEqC;AACrC;;EAEE,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;;qCAEqC;AACrC;EACE,eAAe;AACjB;;AAEA;EAEE,oBAAoB;EAEhB,mBAAmB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qFAA6d;EAC7d,WAAW;AACb;;AAEA;EACE,qFAA6d;AAC/d;;AAEA;;qCAEqC;AACrC;EACE,mCAAmC;AACrC;;AAEA;;qCAEqC;AACrC;EAEE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;;AAEA;EAEM,SAAO;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,4BAA4B;EAC5B,kCAAkC;EAClC,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,aAAa;EACb,cAAc;EACd,sBAAsB;EAEd,kBAAkB;EAC1B,qDAAqD;EACrD,kBAAkB;EAEV,iCAAiC;EACzC,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEU,wCAAwC;AAClD;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;qCAEqC;AACrC;EAEE,oBAAoB;EAEhB,cAAc;EAEd,uBAAuB;EAEvB,mBAAmB;EACvB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,0CAA0C;EAC1C,cAAc;EACd,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,UAAU;AACZ;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,UAAU;EACV,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,gHAAgH;EAChH,4BAA4B;EAC5B,WAAW;EACX,kBAAkB;EAClB,QAAQ;EAEA,6BAA6B;AACvC;;AAEA;;qCAEqC;AACrC;EAEE,oBAAoB;EAEhB,cAAc;EAEd,uBAAuB;EAEvB,mBAAmB;EACvB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;;qCAEqC;AACrC,YAAY;AACZ;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,cAAc;AACd;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,YAAY;AACZ;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,cAAc;EACd,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE,WAAW;EACX,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA,mBAAmB;AACnB;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,cAAc;AACd;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE,cAAc;EACd,oCAAoC;AACtC;;AAEA,cAAc;AACd;EACE,cAAc;EACd,iCAAiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,kCAAkC;AACpC;;AAEA;;qCAEqC;AACrC;EACE,qBAAqB;EACrB,aAAa;EACb,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU;EAEF,mBAAmB;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAED,gCAAgC;AAC1C;;AAEA;EAEE,oBAAoB;EAEhB,cAAc;EAEd,uBAAuB;EAEvB,mBAAmB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,UAAU;EAEF,qBAAqB;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;EAEF,mBAAmB;AAC7B;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EAEP,iBAAiB;EACpB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;EAEV,sCAAsC;AAExC;;AAEA;EAEU,sDAAsD;EAC9D,oBAAoB;AACtB;;AAEA;EACE,cAAc;EAEN,qBAAqB;AAC/B;;AAEA;EACE,kBAAkB;EAElB,oBAAoB;EAEhB,cAAc;EAEd,uBAAuB;EAEvB,mBAAmB;EACvB,sBAAsB;EACtB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EAEd,2BAA2B;EAE3B,yCAAyC;EACjD,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAED,gCAAgC;AAC1C;;AAaA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;IAEF,2CAA2C;EACrD;AACF;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EAEV,iBAAiB;AACtB;;AAEA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,WAAW;EAER,iBAAiB;EACpB,qBAAqB;AACvB;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EAEV,iBAAiB;EACpB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,aAAa;EAEV,iBAAiB;AACtB;;AAEA;EACE,qBAAqB;EACrB,kDAAkD;AACpD;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,WAAW;EAER,iBAAiB;AACtB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAED,gCAAgC;EACxC,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,iEAAiE;EACjE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,UAAU;EACV,YAAY;EACZ,YAAY;EAET,iBAAiB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;AACZ;;AAEA;;qCAEqC;AACrC;EAEM,mBAAmB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;;AAEA,UAAU;AACV;EACE,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,UAAU;AACZ;;AAEA;;qCAEqC;AACrC;EACE,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;AACxB;;AAEA;EAEE,aAAa;EAET,uBAAuB;EAEvB,mBAAmB;EACvB,YAAY;AACd;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,iCAAiC;EACjC,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,qCAAqC;AACvC;;AAEA,UAAU;AACV;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;qCAEqC;AACrC;EACE,gBAAgB;AAClB;;AAEA;;qCAEqC;AACrC;EAEM,sBAAsB;EAEtB,eAAe;AACrB;;AAEA;EAEE,aAAa;EAET,mBAAmB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;;qCAEqC;AACrC;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,SAAS;AACT;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA,WAAW;AACX;EACE,qDAAqD;AACvD;;AAEA,YAAY;AACZ;EACE,sCAAsC;AACxC;;AAEA;EACE,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA,YAAY;AACZ;EACE,wBAAwB;AAC1B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,gBAAgB;AAChB;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,WAAW;AACb;;AAEA,QAAQ;AACR;EACE,cAAc;EACd,wBAAwB;AAC1B;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,kDAAkD;AACpD;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,yBAAyB;EACzB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,SAAS;AACT;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;qCAEqC;AACrC;EACE,+BAA+B;EAC/B,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;qCAEqC;AACrC;EAEE,aAAa;EAET,wBAAwB;EAExB,yBAAyB;EAC7B,yBAAyB;EACzB,eAAe;AACjB;;AAEA;;qCAEqC;AACrC;EACE,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,OAAO;EACP,cAAc;EACd,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,cAAc;EAEX,iBAAiB;EACpB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EAEE,aAAa;EACb,sBAAsB;EACtB,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;AACV;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;AACF;;AAEA;;qCAEqC;AACrC;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EAEE,aAAa;EACb,eAAe;EAEX,iBAAiB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;qCAEqC;AACrC;EACE,aAAa;EACb,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,8DAA8D;AAChE;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE;IACE,mBAAmB;IACnB,sBAAsB;EACxB;AACF;;AAEA,WAAW;AACX;EACE,sBAAsB;EACtB,kDAAkD;EAClD,wBAAwB;EACxB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,OAAO;AACT;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE;IACE,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,aAAa;EACb,aAAa;EACb,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EAEF,4BAA4B;EAEpC,6EAA6E;AAE/E;;AAEA;EACE,UAAU;EAEF,4BAA4B;EAEpC,6EAA6E;AAE/E;;AAEA;;EAEE,UAAU;EAEF,eAAe;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EAEU,0BAA0B;AACpC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EAED,gCAAgC;AAC1C;;AAEA;EACE,iEAAiE;AACnE;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;qCAEqC;AACrC;EACE,YAAY;AACd;;AAEA;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;EAEE,aAAa;EACb,YAAY;AACd;;AAEA;;qCAEqC;AACrC,cAAc;AACd;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;;qCAEqC;AACrC;EACE,UAAU;EACV,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EAEE,aAAa;EAET,uBAAuB;EAEvB,mBAAmB;EACvB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,yCAAyC;AAC3C;;AAEA,eAAe;AACf;EACE,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA,WAAW;AACX;EACE;IACE,gBAAgB;EAClB;EACA;IACE,iBAAiB;EACnB;AACF;;AAEA,8BAA8B;AAC9B;EACE,kBAAkB;EAClB,QAAQ;EAEA,6BAA6B;AACvC;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;;qCAEqC;AACrC;EACE,gBAAgB;EAEhB,aAAa;EAET,mBAAmB;EAEnB,uBAAuB;AAC7B;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,iBAAiB;EACjB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,QAAQ;EACR,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,kCAAkC;EAClC,WAAW;AACb;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EAEE,aAAa;EAET,uBAAuB;EAEvB,mBAAmB;EACvB,oBAAoB;AACtB;;AAEA;EAEE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,kBAAkB;EAEV,qBAAqB;EAC7B,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EAEb,qBAAqB;AAC/B;;AAEA,kBAAkB;AAClB;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EACE,WAAW;AACb;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EAEJ,qBAAqB;EAErB,2BAA2B;EACnC,gBAAgB;AAClB;;AAEA;EACE,UAAU;EAEF,mBAAmB;AAC7B;;AAEA;;qCAEqC;AACrC;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,cAAc;EACd,QAAQ;EACR,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,oBAAoB;IACpB,gBAAgB;EAClB;AACF;;AAEA;;qCAEqC;AACrC;;EAEE,sBAAsB;AACxB;;AAEA;;sCAEsC;AACtC;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,8DAA8D;EAC9D,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,QAAQ;EACR,kBAAkB;EAClB,kBAAkB;EAEV,6BAA6B;AACvC;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,gBAAgB;EAEhB,aAAa;EAET,eAAe;EACnB,eAAe;EACf,wBAAwB;EACxB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EAEE,aAAa;EAET,sBAAsB;EAEtB,aAAa;EAEb,cAAc;EAClB,eAAe;EACf,wBAAwB;EACxB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EAEM,cAAc;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAElB,aAAa;EACb,WAAW;AACb;;AAEA;EAEM,SAAO;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,mCAAmC;EACnC,WAAW;AACb;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EAEE,oBAAoB;EAEhB,mBAAmB;EACvB,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,mCAAmC;EACnC,WAAW;AACb;;AAEA;;qCAEqC;AACrC;EAEE,oBAAoB;EAEhB,cAAc;EAEd,uBAAuB;EAEvB,mBAAmB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,+BAA+B;EAC/B,mCAAmC;EACnC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;AACb;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EACE;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IAEM,YAAY;IAEZ,SAAO;IACX,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,kCAAkC;IAClC,iBAAiB;EACnB;EACA;;IAEE,aAAa;IACb,eAAe;IACf,6BAA6B;EAC/B;EACA;;IAEE,eAAe;IACf,cAAc;IACd,4BAA4B;EAC9B;EACA;;IAEE,aAAa;IACb,eAAe;IACf,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IAEM,YAAY;IAEZ,SAAO;IACX,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,kCAAkC;IAClC,iBAAiB;EACnB;EACA;;IAEE,aAAa;IACb,eAAe;IACf,6BAA6B;EAC/B;EACA;;IAEE,eAAe;IACf,cAAc;IACd,4BAA4B;EAC9B;EACA;;IAEE,aAAa;IACb,eAAe;IACf,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IAEM,YAAY;IAEZ,SAAO;IACX,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,kCAAkC;IAClC,iBAAiB;EACnB;EACA;;IAEE,aAAa;IACb,eAAe;IACf,6BAA6B;EAC/B;EACA;;IAEE,eAAe;IACf,cAAc;IACd,4BAA4B;EAC9B;EACA;;IAEE,aAAa;IACb,eAAe;IACf,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,wBAAwB;EAC1B;EACA;IAEM,YAAY;IAEZ,SAAO;IACX,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,mBAAmB;EACrB;EACA;IACE,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,iBAAiB;IACjB,kCAAkC;IAClC,iBAAiB;EACnB;EACA;;IAEE,aAAa;IACb,eAAe;IACf,6BAA6B;EAC/B;EACA;;IAEE,eAAe;IACf,cAAc;IACd,4BAA4B;EAC9B;EACA;;IAEE,aAAa;IACb,eAAe;IACf,6BAA6B;EAC/B;AACF;;AAEA;;qCAEqC;AACrC;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;EACA;;IAEE,2BAA2B;IAC3B,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;;IAEE,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;EACA;;IAEE,2BAA2B;IAC3B,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;;IAEE,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;EACA;;IAEE,2BAA2B;IAC3B,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;;IAEE,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;EACA;IACE,aAAa;EACf;EACA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;EACA;IACE,4BAA4B;IAC5B,wBAAwB;EAC1B;EACA;;IAEE,2BAA2B;IAC3B,2BAA2B;EAC7B;EACA;;IAEE,6BAA6B;IAC7B,4BAA4B;EAC9B;EACA;;IAEE,2BAA2B;IAC3B,2BAA2B;EAC7B;AACF;;AAEA;;qCAEqC;AACrC;;EAEE,aAAa;AACf;;AAEA;;EAEE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EAEE,oBAAoB;AACtB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;qCAEqC;AACrC;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;qCAEqC;AACrC;EAEM,mBAAmB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,kCAAkC;IAClC,sBAAsB;IACtB,WAAW;EACb;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,kCAAkC;IAClC,sBAAsB;IACtB,WAAW;EACb;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,kCAAkC;IAClC,sBAAsB;IACtB,WAAW;EACb;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,aAAa;EACf;EACA;IACE,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,iBAAiB;IACjB,kCAAkC;IAClC,sBAAsB;IACtB,WAAW;EACb;EACA;;IAEE,aAAa;EACf;EACA;;IAEE,eAAe;EACjB;EACA;;IAEE,aAAa;EACf;AACF;;AAEA;;qCAEqC;AACrC;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IAEM,aAAa;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IAEM,2BAA2B;IAC/B,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IAEM,2BAA2B;EACjC;EACA;IACE,cAAc;IACd,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IAEM,aAAa;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IAEM,2BAA2B;IAC/B,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IAEM,2BAA2B;EACjC;EACA;IACE,cAAc;IACd,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IAEM,aAAa;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IAEM,2BAA2B;IAC/B,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IAEM,2BAA2B;EACjC;EACA;IACE,cAAc;IACd,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IAEM,aAAa;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;EACA;IAEM,2BAA2B;IAC/B,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;EACnB;EACA;IAEM,2BAA2B;EACjC;EACA;IACE,cAAc;IACd,wBAAwB;EAC1B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;EACA;IACE,uBAAuB;EACzB;EACA;IACE,oBAAoB;EACtB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,UAAU;IACV,WAAW;EACb;EACA;IACE,sBAAsB;EACxB;EACA;IACE,wBAAwB;EAC1B;EACA;IACE,sBAAsB;EACxB;AACF;;AAEA;;qCAEqC;AACrC;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;;;EAGE,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mCAAmC;EACnC,sCAAsC;AACxC;;AAEA;;qCAEqC;AACrC;EACE,8BAA8B;AAChC;;AAEA,2BAA2B;AAC3B;EACE,sGAAsG;EACtG,2BAA2B;AAC7B;;AAEA,6BAA6B;AAC7B;EACE,wGAAwG;EACxG,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,oGAAoG;EACpG,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,oGAAoG;EACpG,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,wGAAwG;EACxG,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,sGAAsG;EACtG,2BAA2B;AAC7B;;AAEA,yBAAyB;AACzB;EACE,wGAAwG;EACxG,2BAA2B;AAC7B;;AAEA,wBAAwB;AACxB;EACE,kGAAkG;EAClG,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE,oGAAoG;EACpG,2BAA2B;AAC7B;;AAEA;;qCAEqC;AACrC;EACE,eAAe;AACjB;;AAEA;;qCAEqC;AACrC;EACE;IACE,WAAW;EACb;EACA;IACE,cAAc;EAChB;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,aAAa;EACf;EACA;IACE,YAAY;EACd;EACA;IACE,WAAW;IACX,aAAa;IACb,kBAAkB;EACpB;AACF;;AAEA;;qCAEqC;AACrC;EACE,uGAAuG;EACvG,2BAA2B;AAC7B;;AAEA;EACE,sGAAsG;EACtG,2BAA2B;AAC7B;;AAEA;EACE,kFAAkF;EAClF,2BAA2B;AAC7B;;AAEA;EACE,gHAAgH;EAChH,4BAA4B;AAC9B;;AAEA;EACE,6HAA6H;EAC7H,4BAA4B;AAC9B;;AAEA;;qCAEqC;AACrC;;;EAGE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;EACV,mGAAmG;EACnG,2BAA2B;AAC7B;;AAEA;EACE,mGAAmG;EACnG,2BAA2B;AAC7B;;AAEA;EACE,iGAAiG;EACjG,2BAA2B;AAC7B;;AAEA;EACE,oGAAoG;EACpG,2BAA2B;AAC7B;;AAEA;EACE,8EAA8E;EAC9E,2BAA2B;AAC7B;;AAEA;EACE,oFAAoF;EACpF,2BAA2B;AAC7B;;AAEA;EACE,kGAAkG;EAClG,2BAA2B;AAC7B;;AAEA;;qCAEqC;AACrC;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,kCAAkC;EAClC,4BAA4B;AAC9B;;AAEA;;qCAEqC;AACrC;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;;qCAEqC;AACrC;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;qCAEqC;AACrC;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;qCAEqC;AACrC;EACE,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,MAAM;EACR;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,OAAO;EACT;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,MAAM;EACR;EACA;IACE,QAAQ;EACV;EACA;IACE,SAAS;EACX;EACA;IACE,OAAO;EACT;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,QAAQ;EAEA,6BAA6B;AACvC;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IAEA,6BAA6B;EACvC;AACF;;AAEA;EACE;IACE,kBAAkB;IAClB,QAAQ;IAEA,6BAA6B;EACvC;AACF;;AAEA;;qCAEqC;AACrC;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;;qCAEqC;AACrC;EACE,2DAA2D;AAC7D;;AAEA;EACE,gEAAgE;AAClE;;AAEA;;qCAEqC;AACrC;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;qCAEqC;AACrC;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,iBAAiB;EACnB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;;qCAEqC;AACrC;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;;qCAEqC;AACrC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;qCAEqC;AACrC;EAEU,yBAAyB;EAEzB,yBAAyB;AACnC;;AAEA;EAEU,yBAAyB;EAEzB,uBAAuB;AACjC;;AAEA;EAEU,wBAAwB;EAExB,0BAA0B;AACpC;;AAEA;EAEU,wBAAwB;EAExB,2BAA2B;AACrC;;AAEA;EAEU,yBAAyB;AACnC;;AAEA;EAEU,oCAAoC;AAC9C;;AAEA;;qCAEqC;AACrC,aAAa;AACb;EACE,gCAAgC;AAClC;;AAEA;EAEU,2BAA2B;AACrC;;AAEA,eAAe;AACf;EAEU,mBAAmB;EAE3B,0BAA0B;AAE5B;;AAEA;EAEU,sBAAsB;AAChC;;AAEA;;qCAEqC;AACrC;EACE,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,wBAAwB;EACxB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,mBAAmB;AACrB;;AAEA;;qCAEqC;AACrC;;qCAEqC;AACrC;EAEK,iBAAiB;AACtB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAEd,iBAAiB;EACrB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,eAAe;EAEf,aAAa;EAET,mBAAmB;AACzB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,kFAAkF;EAClF,2BAA2B;AAC7B;;AAEA;EACE,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gFAAgF;EAChF,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;EAClB,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;EACtB,+BAA+B;EAC/B,8DAA8D;EAC9D,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EACE;IACE,eAAe;IAEf,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,iCAAiC;EACnC;EACA;IACE,eAAe;EACjB;EACA;IACE,0CAA0C;IAC1C,kBAAkB;EACpB;EACA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EAEE,kCAAkC;AAEpC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EAEU,qBAAqB;AAC/B;;AAEA;;qCAEqC;AACrC;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAElB,aAAa;EAET,eAAe;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,yCAAyC;EACzC,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;qCAEqC;AACrC;EACE,cAAc;AAChB;;AAEA;;qDAEqD;AACrD;EACE,cAAc;EACd,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,UAAU;AACZ;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EAEU,kBAAkB;AAC5B;;AAEA;;qCAEqC;AACrC;;;EAGE,qDAAqD;AACvD;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;qCAEqC;AACrC;EACE,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,eAAe;EACf,wBAAwB;AAC1B;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,yDAAyD;EACzD,sBAAsB;EACtB,wBAAwB;EAEhB,gCAAgC;AAC1C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,sCAAsC;EACtC,oBAAoB;EACpB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,+BAA+B;EAC/B,qBAAqB;EACrB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,qBAAqB;EACrB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,sDAAsD;AACxD;;AAEA;;qCAEqC;AACrC;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA;EACE;IACE,mBAAmB;IACnB,qBAAqB;EACvB;AACF;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;;EAEE,YAAY;EACZ,kCAAkC;AACpC;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAkBA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,0BAA0B;EAC1B,wBAAwB;AAC1B;;AAkBA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,4CAA4C;AAC9C;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,WAAW;EACX,YAAY;EACZ,qFAAqY;EACrY,WAAW;EAEH,2BAA2B;AACrC;;AAEA;EACE,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,OAAO;EACP,qBAAqB;EAEb,2BAA2B;AACrC;;AAEA;;qCAEqC;AACrC;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,qDAAqD;AACvD;;AAEA;EACE,aAAa;AACf;;AAEA;EAEU,qBAAqB;AAC/B;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,qDAAqD;EACrD,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA,SAAS;AACT;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,SAAS;EACT,mBAAmB;AACrB;;AAEA;;qCAEqC;AACrC;EACE,UAAU;AACZ;;AAEA;EACE,sEAAyE;AAC3E;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;AACd;;AAEA;;qCAEqC;AACrC;EACE,eAAe;EACf,kBAAkB;EAEd,mBAAmB;EACvB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EAEE,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA;EAEE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,qCAAqC;EACrC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;;qCAEqC;AACrC;EACE,UAAU;EAEF,8BAA8B;AACxC;;AAcA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;;AAEA;;qCAEqC","sourcesContent":["@charset \"UTF-8\";\n/*!\n * Bootstrap v4.5.3 (https://getbootstrap.com/)\n * Copyright 2011-2020 The Bootstrap Authors\n * Copyright 2011-2020 Twitter, Inc.\n * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n */\n:root {\n  --blue: #377dff;\n  --indigo: #2d1582;\n  --purple: #6f42c1;\n  --pink: #e83e8c;\n  --red: #ed4c78;\n  --orange: #fd7e14;\n  --yellow: #f5ca99;\n  --green: #28a745;\n  --teal: #00c9a7;\n  --cyan: #09a5be;\n  --white: #fff;\n  --gray: #8c98a4;\n  --gray-dark: #71869d;\n  --primary: #377dff;\n  --secondary: #71869d;\n  --success: #00c9a7;\n  --info: #09a5be;\n  --warning: #f5ca99;\n  --danger: #ed4c78;\n  --light: #f7faff;\n  --dark: #21325b;\n  --indigo: #2d1582;\n  --breakpoint-xs: 0;\n  --breakpoint-sm: 576px;\n  --breakpoint-md: 768px;\n  --breakpoint-lg: 992px;\n  --breakpoint-xl: 1200px;\n  --font-family-sans-serif: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n  --font-family-monospace: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n}\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nhtml {\n  font-family: sans-serif;\n  line-height: 1.15;\n  -webkit-text-size-adjust: 100%;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n}\n\narticle, aside, figcaption, figure, footer, header, hgroup, main, nav, section {\n  display: block;\n}\n\nbody {\n  margin: 0;\n  font-family: \"Open Sans\", sans-serif;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #677788;\n  text-align: left;\n  background-color: #fff;\n}\n\n[tabindex=\"-1\"]:focus:not(:focus-visible) {\n  outline: 0 !important;\n}\n\nhr {\n  box-sizing: content-box;\n  height: 0;\n  overflow: visible;\n}\n\nh1, h2, h3, h4, h5, h6 {\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n\np {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nabbr[title],\nabbr[data-original-title] {\n  text-decoration: underline;\n  -webkit-text-decoration: underline dotted;\n          text-decoration: underline dotted;\n  cursor: help;\n  border-bottom: 0;\n  -webkit-text-decoration-skip-ink: none;\n          text-decoration-skip-ink: none;\n}\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: 600;\n}\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0;\n}\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\nb,\nstrong {\n  font-weight: bolder;\n}\n\nsmall {\n  font-size: 80%;\n}\n\nsub,\nsup {\n  position: relative;\n  font-size: 75%;\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub {\n  bottom: -.25em;\n}\n\nsup {\n  top: -.5em;\n}\n\na {\n  color: #377dff;\n  text-decoration: none;\n  background-color: transparent;\n}\n\na:hover {\n  color: #0052ea;\n  text-decoration: none;\n}\n\na:not([href]):not([class]) {\n  color: inherit;\n  text-decoration: none;\n}\n\na:not([href]):not([class]):hover {\n  color: inherit;\n  text-decoration: none;\n}\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  font-size: 1em;\n}\n\npre {\n  margin-top: 0;\n  margin-bottom: 1rem;\n  overflow: auto;\n  -ms-overflow-style: scrollbar;\n}\n\nfigure {\n  margin: 0 0 1rem;\n}\n\nimg {\n  vertical-align: middle;\n  border-style: none;\n}\n\nsvg {\n  overflow: hidden;\n  vertical-align: middle;\n}\n\ntable {\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n  color: #8c98a4;\n  text-align: left;\n  caption-side: bottom;\n}\n\nth {\n  text-align: inherit;\n  text-align: -webkit-match-parent;\n}\n\nlabel {\n  display: inline-block;\n  margin-bottom: 0.5rem;\n}\n\nbutton {\n  border-radius: 0;\n}\n\nbutton:focus {\n  outline: 1px dotted;\n  outline: 5px auto -webkit-focus-ring-color;\n}\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0;\n  font-family: inherit;\n  font-size: inherit;\n  line-height: inherit;\n}\n\nbutton,\ninput {\n  overflow: visible;\n}\n\nbutton,\nselect {\n  text-transform: none;\n}\n\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  word-wrap: normal;\n}\n\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button;\n}\n\nbutton:not(:disabled),\n[type=\"button\"]:not(:disabled),\n[type=\"reset\"]:not(:disabled),\n[type=\"submit\"]:not(:disabled) {\n  cursor: pointer;\n}\n\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\ninput[type=\"radio\"],\ninput[type=\"checkbox\"] {\n  box-sizing: border-box;\n  padding: 0;\n}\n\ntextarea {\n  overflow: auto;\n  resize: vertical;\n}\n\nfieldset {\n  min-width: 0;\n  padding: 0;\n  margin: 0;\n  border: 0;\n}\n\nlegend {\n  display: block;\n  width: 100%;\n  max-width: 100%;\n  padding: 0;\n  margin-bottom: .5rem;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: inherit;\n  white-space: normal;\n}\n\n@media (max-width: 1200px) {\n  legend {\n    font-size: calc(1.275rem + 0.3vw) ;\n  }\n}\n\nprogress {\n  vertical-align: baseline;\n}\n\n[type=\"number\"]::-webkit-inner-spin-button,\n[type=\"number\"]::-webkit-outer-spin-button {\n  height: auto;\n}\n\n[type=\"search\"] {\n  outline-offset: -2px;\n  -webkit-appearance: none;\n}\n\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n::-webkit-file-upload-button {\n  font: inherit;\n  -webkit-appearance: button;\n}\n\noutput {\n  display: inline-block;\n}\n\nsummary {\n  display: list-item;\n  cursor: pointer;\n}\n\ntemplate {\n  display: none;\n}\n\n[hidden] {\n  display: none !important;\n}\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n  line-height: 1.4;\n  color: #1e2022;\n}\n\nh1, .h1 {\n  font-size: 2.5rem;\n}\n\n@media (max-width: 1200px) {\n  h1, .h1 {\n    font-size: calc(1.375rem + 1.5vw) ;\n  }\n}\n\nh2, .h2 {\n  font-size: 1.875rem;\n}\n\n@media (max-width: 1200px) {\n  h2, .h2 {\n    font-size: calc(1.3125rem + 0.75vw) ;\n  }\n}\n\nh3, .h3 {\n  font-size: 1.3125rem;\n}\n\n@media (max-width: 1200px) {\n  h3, .h3 {\n    font-size: calc(1.25625rem + 0.075vw) ;\n  }\n}\n\nh4, .h4 {\n  font-size: 1.125rem;\n}\n\nh5, .h5 {\n  font-size: 1rem;\n}\n\nh6, .h6 {\n  font-size: 0.875rem;\n}\n\n.lead {\n  font-size: 1.25rem;\n  font-weight: 400;\n}\n\n.display-1 {\n  font-size: 6rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n@media (max-width: 1200px) {\n  .display-1 {\n    font-size: calc(1.725rem + 5.7vw) ;\n  }\n}\n\n.display-2 {\n  font-size: 5.5rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n@media (max-width: 1200px) {\n  .display-2 {\n    font-size: calc(1.675rem + 5.1vw) ;\n  }\n}\n\n.display-3 {\n  font-size: 4.5rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n@media (max-width: 1200px) {\n  .display-3 {\n    font-size: calc(1.575rem + 3.9vw) ;\n  }\n}\n\n.display-4 {\n  font-size: 3.5rem;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n@media (max-width: 1200px) {\n  .display-4 {\n    font-size: calc(1.475rem + 2.7vw) ;\n  }\n}\n\nhr {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  border: 0;\n  border-top: 0.0625rem solid #e7eaf3;\n}\n\nsmall,\n.small {\n  font-size: 80%;\n  font-weight: 400;\n}\n\nmark,\n.mark {\n  padding: 0.2em;\n  background-color: rgba(55, 125, 255, 0.1);\n}\n\n.list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline {\n  padding-left: 0;\n  list-style: none;\n}\n\n.list-inline-item {\n  display: inline-block;\n}\n\n.list-inline-item:not(:last-child) {\n  margin-right: 0.5rem;\n}\n\n.initialism {\n  font-size: 90%;\n  text-transform: uppercase;\n}\n\n.blockquote {\n  margin-bottom: 1rem;\n  font-size: 1rem;\n}\n\n.blockquote-footer {\n  display: block;\n  font-size: 80%;\n  color: #8c98a4;\n}\n\n.blockquote-footer::before {\n  content: \"\\2014\\00A0\";\n}\n\n.img-fluid {\n  max-width: 100%;\n  height: auto;\n}\n\n.img-thumbnail {\n  padding: 0.25rem;\n  background-color: #fff;\n  border: 0.0625rem solid #e7eaf3;\n  border-radius: 0.3125rem;\n  max-width: 100%;\n  height: auto;\n}\n\n.figure {\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: 0.5rem;\n  line-height: 1;\n}\n\n.figure-caption {\n  font-size: 90%;\n  color: #8c98a4;\n}\n\ncode {\n  font-size: 87.5%;\n  color: #e83e8c;\n  word-wrap: break-word;\n}\n\na > code {\n  color: inherit;\n}\n\nkbd {\n  padding: 0.2rem 0.4rem;\n  font-size: 87.5%;\n  color: #1e2022;\n  background-color: #e7eaf3;\n  border-radius: 0.25rem;\n}\n\nkbd kbd {\n  padding: 0;\n  font-size: 100%;\n  font-weight: 600;\n}\n\npre {\n  display: block;\n  font-size: 87.5%;\n  color: #1e2022;\n}\n\npre code {\n  font-size: inherit;\n  color: inherit;\n  word-break: normal;\n}\n\n.pre-scrollable {\n  max-height: 340px;\n  overflow-y: scroll;\n}\n\n.container,\n.container-fluid,\n.container-sm,\n.container-md,\n.container-lg,\n.container-xl {\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n@media (min-width: 576px) {\n  .container, .container-sm {\n    max-width: 540px;\n  }\n}\n\n@media (min-width: 768px) {\n  .container, .container-sm, .container-md {\n    max-width: 720px;\n  }\n}\n\n@media (min-width: 992px) {\n  .container, .container-sm, .container-md, .container-lg {\n    max-width: 960px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .container, .container-sm, .container-md, .container-lg, .container-xl {\n    max-width: 1140px;\n  }\n}\n\n.row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-right: -15px;\n  margin-left: -15px;\n}\n\n.no-gutters {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.no-gutters > .col,\n.no-gutters > [class*=\"col-\"] {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.col-1, .col-2, .col-3, .col-4, .col-5, .col-6, .col-7, .col-8, .col-9, .col-10, .col-11, .col-12, .col,\n.col-auto, .col-sm-1, .col-sm-2, .col-sm-3, .col-sm-4, .col-sm-5, .col-sm-6, .col-sm-7, .col-sm-8, .col-sm-9, .col-sm-10, .col-sm-11, .col-sm-12, .col-sm,\n.col-sm-auto, .col-md-1, .col-md-2, .col-md-3, .col-md-4, .col-md-5, .col-md-6, .col-md-7, .col-md-8, .col-md-9, .col-md-10, .col-md-11, .col-md-12, .col-md,\n.col-md-auto, .col-lg-1, .col-lg-2, .col-lg-3, .col-lg-4, .col-lg-5, .col-lg-6, .col-lg-7, .col-lg-8, .col-lg-9, .col-lg-10, .col-lg-11, .col-lg-12, .col-lg,\n.col-lg-auto, .col-xl-1, .col-xl-2, .col-xl-3, .col-xl-4, .col-xl-5, .col-xl-6, .col-xl-7, .col-xl-8, .col-xl-9, .col-xl-10, .col-xl-11, .col-xl-12, .col-xl,\n.col-xl-auto {\n  position: relative;\n  width: 100%;\n  padding-right: 15px;\n  padding-left: 15px;\n}\n\n.col {\n  -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  max-width: 100%;\n}\n\n.row-cols-1 > * {\n  -ms-flex: 0 0 100%;\n      flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.row-cols-2 > * {\n  -ms-flex: 0 0 50%;\n      flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.row-cols-3 > * {\n  -ms-flex: 0 0 33.33333%;\n      flex: 0 0 33.33333%;\n  max-width: 33.33333%;\n}\n\n.row-cols-4 > * {\n  -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.row-cols-5 > * {\n  -ms-flex: 0 0 20%;\n      flex: 0 0 20%;\n  max-width: 20%;\n}\n\n.row-cols-6 > * {\n  -ms-flex: 0 0 16.66667%;\n      flex: 0 0 16.66667%;\n  max-width: 16.66667%;\n}\n\n.col-auto {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  width: auto;\n  max-width: 100%;\n}\n\n.col-1 {\n  -ms-flex: 0 0 8.33333%;\n      flex: 0 0 8.33333%;\n  max-width: 8.33333%;\n}\n\n.col-2 {\n  -ms-flex: 0 0 16.66667%;\n      flex: 0 0 16.66667%;\n  max-width: 16.66667%;\n}\n\n.col-3 {\n  -ms-flex: 0 0 25%;\n      flex: 0 0 25%;\n  max-width: 25%;\n}\n\n.col-4 {\n  -ms-flex: 0 0 33.33333%;\n      flex: 0 0 33.33333%;\n  max-width: 33.33333%;\n}\n\n.col-5 {\n  -ms-flex: 0 0 41.66667%;\n      flex: 0 0 41.66667%;\n  max-width: 41.66667%;\n}\n\n.col-6 {\n  -ms-flex: 0 0 50%;\n      flex: 0 0 50%;\n  max-width: 50%;\n}\n\n.col-7 {\n  -ms-flex: 0 0 58.33333%;\n      flex: 0 0 58.33333%;\n  max-width: 58.33333%;\n}\n\n.col-8 {\n  -ms-flex: 0 0 66.66667%;\n      flex: 0 0 66.66667%;\n  max-width: 66.66667%;\n}\n\n.col-9 {\n  -ms-flex: 0 0 75%;\n      flex: 0 0 75%;\n  max-width: 75%;\n}\n\n.col-10 {\n  -ms-flex: 0 0 83.33333%;\n      flex: 0 0 83.33333%;\n  max-width: 83.33333%;\n}\n\n.col-11 {\n  -ms-flex: 0 0 91.66667%;\n      flex: 0 0 91.66667%;\n  max-width: 91.66667%;\n}\n\n.col-12 {\n  -ms-flex: 0 0 100%;\n      flex: 0 0 100%;\n  max-width: 100%;\n}\n\n.order-first {\n  -ms-flex-order: -1;\n      order: -1;\n}\n\n.order-last {\n  -ms-flex-order: 13;\n      order: 13;\n}\n\n.order-0 {\n  -ms-flex-order: 0;\n      order: 0;\n}\n\n.order-1 {\n  -ms-flex-order: 1;\n      order: 1;\n}\n\n.order-2 {\n  -ms-flex-order: 2;\n      order: 2;\n}\n\n.order-3 {\n  -ms-flex-order: 3;\n      order: 3;\n}\n\n.order-4 {\n  -ms-flex-order: 4;\n      order: 4;\n}\n\n.order-5 {\n  -ms-flex-order: 5;\n      order: 5;\n}\n\n.order-6 {\n  -ms-flex-order: 6;\n      order: 6;\n}\n\n.order-7 {\n  -ms-flex-order: 7;\n      order: 7;\n}\n\n.order-8 {\n  -ms-flex-order: 8;\n      order: 8;\n}\n\n.order-9 {\n  -ms-flex-order: 9;\n      order: 9;\n}\n\n.order-10 {\n  -ms-flex-order: 10;\n      order: 10;\n}\n\n.order-11 {\n  -ms-flex-order: 11;\n      order: 11;\n}\n\n.order-12 {\n  -ms-flex-order: 12;\n      order: 12;\n}\n\n.offset-1 {\n  margin-left: 8.33333%;\n}\n\n.offset-2 {\n  margin-left: 16.66667%;\n}\n\n.offset-3 {\n  margin-left: 25%;\n}\n\n.offset-4 {\n  margin-left: 33.33333%;\n}\n\n.offset-5 {\n  margin-left: 41.66667%;\n}\n\n.offset-6 {\n  margin-left: 50%;\n}\n\n.offset-7 {\n  margin-left: 58.33333%;\n}\n\n.offset-8 {\n  margin-left: 66.66667%;\n}\n\n.offset-9 {\n  margin-left: 75%;\n}\n\n.offset-10 {\n  margin-left: 83.33333%;\n}\n\n.offset-11 {\n  margin-left: 91.66667%;\n}\n\n@media (min-width: 576px) {\n  .col-sm {\n    -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-sm-1 > * {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-sm-2 > * {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-sm-3 > * {\n    -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n  .row-cols-sm-4 > * {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-sm-5 > * {\n    -ms-flex: 0 0 20%;\n        flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-sm-6 > * {\n    -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n  .col-sm-auto {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-sm-1 {\n    -ms-flex: 0 0 8.33333%;\n        flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n  .col-sm-2 {\n    -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n  .col-sm-3 {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-sm-4 {\n    -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n  .col-sm-5 {\n    -ms-flex: 0 0 41.66667%;\n        flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n  .col-sm-6 {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-sm-7 {\n    -ms-flex: 0 0 58.33333%;\n        flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n  .col-sm-8 {\n    -ms-flex: 0 0 66.66667%;\n        flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n  .col-sm-9 {\n    -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-sm-10 {\n    -ms-flex: 0 0 83.33333%;\n        flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n  .col-sm-11 {\n    -ms-flex: 0 0 91.66667%;\n        flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n  .col-sm-12 {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-sm-first {\n    -ms-flex-order: -1;\n        order: -1;\n  }\n  .order-sm-last {\n    -ms-flex-order: 13;\n        order: 13;\n  }\n  .order-sm-0 {\n    -ms-flex-order: 0;\n        order: 0;\n  }\n  .order-sm-1 {\n    -ms-flex-order: 1;\n        order: 1;\n  }\n  .order-sm-2 {\n    -ms-flex-order: 2;\n        order: 2;\n  }\n  .order-sm-3 {\n    -ms-flex-order: 3;\n        order: 3;\n  }\n  .order-sm-4 {\n    -ms-flex-order: 4;\n        order: 4;\n  }\n  .order-sm-5 {\n    -ms-flex-order: 5;\n        order: 5;\n  }\n  .order-sm-6 {\n    -ms-flex-order: 6;\n        order: 6;\n  }\n  .order-sm-7 {\n    -ms-flex-order: 7;\n        order: 7;\n  }\n  .order-sm-8 {\n    -ms-flex-order: 8;\n        order: 8;\n  }\n  .order-sm-9 {\n    -ms-flex-order: 9;\n        order: 9;\n  }\n  .order-sm-10 {\n    -ms-flex-order: 10;\n        order: 10;\n  }\n  .order-sm-11 {\n    -ms-flex-order: 11;\n        order: 11;\n  }\n  .order-sm-12 {\n    -ms-flex-order: 12;\n        order: 12;\n  }\n  .offset-sm-0 {\n    margin-left: 0;\n  }\n  .offset-sm-1 {\n    margin-left: 8.33333%;\n  }\n  .offset-sm-2 {\n    margin-left: 16.66667%;\n  }\n  .offset-sm-3 {\n    margin-left: 25%;\n  }\n  .offset-sm-4 {\n    margin-left: 33.33333%;\n  }\n  .offset-sm-5 {\n    margin-left: 41.66667%;\n  }\n  .offset-sm-6 {\n    margin-left: 50%;\n  }\n  .offset-sm-7 {\n    margin-left: 58.33333%;\n  }\n  .offset-sm-8 {\n    margin-left: 66.66667%;\n  }\n  .offset-sm-9 {\n    margin-left: 75%;\n  }\n  .offset-sm-10 {\n    margin-left: 83.33333%;\n  }\n  .offset-sm-11 {\n    margin-left: 91.66667%;\n  }\n}\n\n@media (min-width: 768px) {\n  .col-md {\n    -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-md-1 > * {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-md-2 > * {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-md-3 > * {\n    -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n  .row-cols-md-4 > * {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-md-5 > * {\n    -ms-flex: 0 0 20%;\n        flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-md-6 > * {\n    -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n  .col-md-auto {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-md-1 {\n    -ms-flex: 0 0 8.33333%;\n        flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n  .col-md-2 {\n    -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n  .col-md-3 {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-md-4 {\n    -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n  .col-md-5 {\n    -ms-flex: 0 0 41.66667%;\n        flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n  .col-md-6 {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-md-7 {\n    -ms-flex: 0 0 58.33333%;\n        flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n  .col-md-8 {\n    -ms-flex: 0 0 66.66667%;\n        flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n  .col-md-9 {\n    -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-md-10 {\n    -ms-flex: 0 0 83.33333%;\n        flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n  .col-md-11 {\n    -ms-flex: 0 0 91.66667%;\n        flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n  .col-md-12 {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-md-first {\n    -ms-flex-order: -1;\n        order: -1;\n  }\n  .order-md-last {\n    -ms-flex-order: 13;\n        order: 13;\n  }\n  .order-md-0 {\n    -ms-flex-order: 0;\n        order: 0;\n  }\n  .order-md-1 {\n    -ms-flex-order: 1;\n        order: 1;\n  }\n  .order-md-2 {\n    -ms-flex-order: 2;\n        order: 2;\n  }\n  .order-md-3 {\n    -ms-flex-order: 3;\n        order: 3;\n  }\n  .order-md-4 {\n    -ms-flex-order: 4;\n        order: 4;\n  }\n  .order-md-5 {\n    -ms-flex-order: 5;\n        order: 5;\n  }\n  .order-md-6 {\n    -ms-flex-order: 6;\n        order: 6;\n  }\n  .order-md-7 {\n    -ms-flex-order: 7;\n        order: 7;\n  }\n  .order-md-8 {\n    -ms-flex-order: 8;\n        order: 8;\n  }\n  .order-md-9 {\n    -ms-flex-order: 9;\n        order: 9;\n  }\n  .order-md-10 {\n    -ms-flex-order: 10;\n        order: 10;\n  }\n  .order-md-11 {\n    -ms-flex-order: 11;\n        order: 11;\n  }\n  .order-md-12 {\n    -ms-flex-order: 12;\n        order: 12;\n  }\n  .offset-md-0 {\n    margin-left: 0;\n  }\n  .offset-md-1 {\n    margin-left: 8.33333%;\n  }\n  .offset-md-2 {\n    margin-left: 16.66667%;\n  }\n  .offset-md-3 {\n    margin-left: 25%;\n  }\n  .offset-md-4 {\n    margin-left: 33.33333%;\n  }\n  .offset-md-5 {\n    margin-left: 41.66667%;\n  }\n  .offset-md-6 {\n    margin-left: 50%;\n  }\n  .offset-md-7 {\n    margin-left: 58.33333%;\n  }\n  .offset-md-8 {\n    margin-left: 66.66667%;\n  }\n  .offset-md-9 {\n    margin-left: 75%;\n  }\n  .offset-md-10 {\n    margin-left: 83.33333%;\n  }\n  .offset-md-11 {\n    margin-left: 91.66667%;\n  }\n}\n\n@media (min-width: 992px) {\n  .col-lg {\n    -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-lg-1 > * {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-lg-2 > * {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-lg-3 > * {\n    -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n  .row-cols-lg-4 > * {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-lg-5 > * {\n    -ms-flex: 0 0 20%;\n        flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-lg-6 > * {\n    -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n  .col-lg-auto {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-lg-1 {\n    -ms-flex: 0 0 8.33333%;\n        flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n  .col-lg-2 {\n    -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n  .col-lg-3 {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-lg-4 {\n    -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n  .col-lg-5 {\n    -ms-flex: 0 0 41.66667%;\n        flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n  .col-lg-6 {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-lg-7 {\n    -ms-flex: 0 0 58.33333%;\n        flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n  .col-lg-8 {\n    -ms-flex: 0 0 66.66667%;\n        flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n  .col-lg-9 {\n    -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-lg-10 {\n    -ms-flex: 0 0 83.33333%;\n        flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n  .col-lg-11 {\n    -ms-flex: 0 0 91.66667%;\n        flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n  .col-lg-12 {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-lg-first {\n    -ms-flex-order: -1;\n        order: -1;\n  }\n  .order-lg-last {\n    -ms-flex-order: 13;\n        order: 13;\n  }\n  .order-lg-0 {\n    -ms-flex-order: 0;\n        order: 0;\n  }\n  .order-lg-1 {\n    -ms-flex-order: 1;\n        order: 1;\n  }\n  .order-lg-2 {\n    -ms-flex-order: 2;\n        order: 2;\n  }\n  .order-lg-3 {\n    -ms-flex-order: 3;\n        order: 3;\n  }\n  .order-lg-4 {\n    -ms-flex-order: 4;\n        order: 4;\n  }\n  .order-lg-5 {\n    -ms-flex-order: 5;\n        order: 5;\n  }\n  .order-lg-6 {\n    -ms-flex-order: 6;\n        order: 6;\n  }\n  .order-lg-7 {\n    -ms-flex-order: 7;\n        order: 7;\n  }\n  .order-lg-8 {\n    -ms-flex-order: 8;\n        order: 8;\n  }\n  .order-lg-9 {\n    -ms-flex-order: 9;\n        order: 9;\n  }\n  .order-lg-10 {\n    -ms-flex-order: 10;\n        order: 10;\n  }\n  .order-lg-11 {\n    -ms-flex-order: 11;\n        order: 11;\n  }\n  .order-lg-12 {\n    -ms-flex-order: 12;\n        order: 12;\n  }\n  .offset-lg-0 {\n    margin-left: 0;\n  }\n  .offset-lg-1 {\n    margin-left: 8.33333%;\n  }\n  .offset-lg-2 {\n    margin-left: 16.66667%;\n  }\n  .offset-lg-3 {\n    margin-left: 25%;\n  }\n  .offset-lg-4 {\n    margin-left: 33.33333%;\n  }\n  .offset-lg-5 {\n    margin-left: 41.66667%;\n  }\n  .offset-lg-6 {\n    margin-left: 50%;\n  }\n  .offset-lg-7 {\n    margin-left: 58.33333%;\n  }\n  .offset-lg-8 {\n    margin-left: 66.66667%;\n  }\n  .offset-lg-9 {\n    margin-left: 75%;\n  }\n  .offset-lg-10 {\n    margin-left: 83.33333%;\n  }\n  .offset-lg-11 {\n    margin-left: 91.66667%;\n  }\n}\n\n@media (min-width: 1200px) {\n  .col-xl {\n    -ms-flex-preferred-size: 0;\n        flex-basis: 0;\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    max-width: 100%;\n  }\n  .row-cols-xl-1 > * {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .row-cols-xl-2 > * {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .row-cols-xl-3 > * {\n    -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n  .row-cols-xl-4 > * {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .row-cols-xl-5 > * {\n    -ms-flex: 0 0 20%;\n        flex: 0 0 20%;\n    max-width: 20%;\n  }\n  .row-cols-xl-6 > * {\n    -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n  .col-xl-auto {\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    width: auto;\n    max-width: 100%;\n  }\n  .col-xl-1 {\n    -ms-flex: 0 0 8.33333%;\n        flex: 0 0 8.33333%;\n    max-width: 8.33333%;\n  }\n  .col-xl-2 {\n    -ms-flex: 0 0 16.66667%;\n        flex: 0 0 16.66667%;\n    max-width: 16.66667%;\n  }\n  .col-xl-3 {\n    -ms-flex: 0 0 25%;\n        flex: 0 0 25%;\n    max-width: 25%;\n  }\n  .col-xl-4 {\n    -ms-flex: 0 0 33.33333%;\n        flex: 0 0 33.33333%;\n    max-width: 33.33333%;\n  }\n  .col-xl-5 {\n    -ms-flex: 0 0 41.66667%;\n        flex: 0 0 41.66667%;\n    max-width: 41.66667%;\n  }\n  .col-xl-6 {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n  }\n  .col-xl-7 {\n    -ms-flex: 0 0 58.33333%;\n        flex: 0 0 58.33333%;\n    max-width: 58.33333%;\n  }\n  .col-xl-8 {\n    -ms-flex: 0 0 66.66667%;\n        flex: 0 0 66.66667%;\n    max-width: 66.66667%;\n  }\n  .col-xl-9 {\n    -ms-flex: 0 0 75%;\n        flex: 0 0 75%;\n    max-width: 75%;\n  }\n  .col-xl-10 {\n    -ms-flex: 0 0 83.33333%;\n        flex: 0 0 83.33333%;\n    max-width: 83.33333%;\n  }\n  .col-xl-11 {\n    -ms-flex: 0 0 91.66667%;\n        flex: 0 0 91.66667%;\n    max-width: 91.66667%;\n  }\n  .col-xl-12 {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n  }\n  .order-xl-first {\n    -ms-flex-order: -1;\n        order: -1;\n  }\n  .order-xl-last {\n    -ms-flex-order: 13;\n        order: 13;\n  }\n  .order-xl-0 {\n    -ms-flex-order: 0;\n        order: 0;\n  }\n  .order-xl-1 {\n    -ms-flex-order: 1;\n        order: 1;\n  }\n  .order-xl-2 {\n    -ms-flex-order: 2;\n        order: 2;\n  }\n  .order-xl-3 {\n    -ms-flex-order: 3;\n        order: 3;\n  }\n  .order-xl-4 {\n    -ms-flex-order: 4;\n        order: 4;\n  }\n  .order-xl-5 {\n    -ms-flex-order: 5;\n        order: 5;\n  }\n  .order-xl-6 {\n    -ms-flex-order: 6;\n        order: 6;\n  }\n  .order-xl-7 {\n    -ms-flex-order: 7;\n        order: 7;\n  }\n  .order-xl-8 {\n    -ms-flex-order: 8;\n        order: 8;\n  }\n  .order-xl-9 {\n    -ms-flex-order: 9;\n        order: 9;\n  }\n  .order-xl-10 {\n    -ms-flex-order: 10;\n        order: 10;\n  }\n  .order-xl-11 {\n    -ms-flex-order: 11;\n        order: 11;\n  }\n  .order-xl-12 {\n    -ms-flex-order: 12;\n        order: 12;\n  }\n  .offset-xl-0 {\n    margin-left: 0;\n  }\n  .offset-xl-1 {\n    margin-left: 8.33333%;\n  }\n  .offset-xl-2 {\n    margin-left: 16.66667%;\n  }\n  .offset-xl-3 {\n    margin-left: 25%;\n  }\n  .offset-xl-4 {\n    margin-left: 33.33333%;\n  }\n  .offset-xl-5 {\n    margin-left: 41.66667%;\n  }\n  .offset-xl-6 {\n    margin-left: 50%;\n  }\n  .offset-xl-7 {\n    margin-left: 58.33333%;\n  }\n  .offset-xl-8 {\n    margin-left: 66.66667%;\n  }\n  .offset-xl-9 {\n    margin-left: 75%;\n  }\n  .offset-xl-10 {\n    margin-left: 83.33333%;\n  }\n  .offset-xl-11 {\n    margin-left: 91.66667%;\n  }\n}\n\n.table {\n  width: 100%;\n  margin-bottom: 1rem;\n  color: #677788;\n}\n\n.table th,\n.table td {\n  padding: 0.75rem;\n  vertical-align: top;\n  border-top: 0.0625rem solid #e7eaf3;\n}\n\n.table thead th {\n  vertical-align: bottom;\n  border-bottom: 0.125rem solid #e7eaf3;\n}\n\n.table tbody + tbody {\n  border-top: 0.125rem solid #e7eaf3;\n}\n\n.table-sm th,\n.table-sm td {\n  padding: 0.3rem;\n}\n\n.table-bordered {\n  border: 0.0625rem solid #e7eaf3;\n}\n\n.table-bordered th,\n.table-bordered td {\n  border: 0.0625rem solid #e7eaf3;\n}\n\n.table-bordered thead th,\n.table-bordered thead td {\n  border-bottom-width: 0.125rem;\n}\n\n.table-borderless th,\n.table-borderless td,\n.table-borderless thead th,\n.table-borderless tbody + tbody {\n  border: 0;\n}\n\n.table-striped tbody tr:nth-of-type(odd) {\n  background-color: #f8fafd;\n}\n\n.table-hover tbody tr:hover {\n  color: #677788;\n  background-color: rgba(231, 234, 243, 0.4);\n}\n\n.table-primary,\n.table-primary > th,\n.table-primary > td {\n  background-color: #c7dbff;\n}\n\n.table-primary th,\n.table-primary td,\n.table-primary thead th,\n.table-primary tbody + tbody {\n  border-color: #97bbff;\n}\n\n.table-hover .table-primary:hover {\n  background-color: #aecbff;\n}\n\n.table-hover .table-primary:hover > td,\n.table-hover .table-primary:hover > th {\n  background-color: #aecbff;\n}\n\n.table-secondary,\n.table-secondary > th,\n.table-secondary > td {\n  background-color: #d7dde4;\n}\n\n.table-secondary th,\n.table-secondary td,\n.table-secondary thead th,\n.table-secondary tbody + tbody {\n  border-color: #b5c0cc;\n}\n\n.table-hover .table-secondary:hover {\n  background-color: #c8d0da;\n}\n\n.table-hover .table-secondary:hover > td,\n.table-hover .table-secondary:hover > th {\n  background-color: #c8d0da;\n}\n\n.table-success,\n.table-success > th,\n.table-success > td {\n  background-color: #b8f0e6;\n}\n\n.table-success th,\n.table-success td,\n.table-success thead th,\n.table-success tbody + tbody {\n  border-color: #7ae3d1;\n}\n\n.table-hover .table-success:hover {\n  background-color: #a3ecdf;\n}\n\n.table-hover .table-success:hover > td,\n.table-hover .table-success:hover > th {\n  background-color: #a3ecdf;\n}\n\n.table-info,\n.table-info > th,\n.table-info > td {\n  background-color: #bae6ed;\n}\n\n.table-info th,\n.table-info td,\n.table-info thead th,\n.table-info tbody + tbody {\n  border-color: #7fd0dd;\n}\n\n.table-hover .table-info:hover {\n  background-color: #a6dfe8;\n}\n\n.table-hover .table-info:hover > td,\n.table-hover .table-info:hover > th {\n  background-color: #a6dfe8;\n}\n\n.table-warning,\n.table-warning > th,\n.table-warning > td {\n  background-color: #fcf0e2;\n}\n\n.table-warning th,\n.table-warning td,\n.table-warning thead th,\n.table-warning tbody + tbody {\n  border-color: #fae3ca;\n}\n\n.table-hover .table-warning:hover {\n  background-color: #fae4cb;\n}\n\n.table-hover .table-warning:hover > td,\n.table-hover .table-warning:hover > th {\n  background-color: #fae4cb;\n}\n\n.table-danger,\n.table-danger > th,\n.table-danger > td {\n  background-color: #facdd9;\n}\n\n.table-danger th,\n.table-danger td,\n.table-danger thead th,\n.table-danger tbody + tbody {\n  border-color: #f6a2b9;\n}\n\n.table-hover .table-danger:hover {\n  background-color: #f8b6c7;\n}\n\n.table-hover .table-danger:hover > td,\n.table-hover .table-danger:hover > th {\n  background-color: #f8b6c7;\n}\n\n.table-light,\n.table-light > th,\n.table-light > td {\n  background-color: #fdfeff;\n}\n\n.table-light th,\n.table-light td,\n.table-light thead th,\n.table-light tbody + tbody {\n  border-color: #fbfcff;\n}\n\n.table-hover .table-light:hover {\n  background-color: #e4f1ff;\n}\n\n.table-hover .table-light:hover > td,\n.table-hover .table-light:hover > th {\n  background-color: #e4f1ff;\n}\n\n.table-dark,\n.table-dark > th,\n.table-dark > td {\n  background-color: #c1c6d1;\n}\n\n.table-dark th,\n.table-dark td,\n.table-dark thead th,\n.table-dark tbody + tbody {\n  border-color: #8c94aa;\n}\n\n.table-hover .table-dark:hover {\n  background-color: #b2b9c6;\n}\n\n.table-hover .table-dark:hover > td,\n.table-hover .table-dark:hover > th {\n  background-color: #b2b9c6;\n}\n\n.table-indigo,\n.table-indigo > th,\n.table-indigo > td {\n  background-color: #c4bddc;\n}\n\n.table-indigo th,\n.table-indigo td,\n.table-indigo thead th,\n.table-indigo tbody + tbody {\n  border-color: #9285be;\n}\n\n.table-hover .table-indigo:hover {\n  background-color: #b5acd3;\n}\n\n.table-hover .table-indigo:hover > td,\n.table-hover .table-indigo:hover > th {\n  background-color: #b5acd3;\n}\n\n.table-active,\n.table-active > th,\n.table-active > td {\n  background-color: rgba(231, 234, 243, 0.4);\n}\n\n.table-hover .table-active:hover {\n  background-color: rgba(214, 219, 235, 0.4);\n}\n\n.table-hover .table-active:hover > td,\n.table-hover .table-active:hover > th {\n  background-color: rgba(214, 219, 235, 0.4);\n}\n\n.table .thead-dark th {\n  color: #fff;\n  background-color: #21325b;\n  border-color: #2b4177;\n}\n\n.table .thead-light th {\n  color: #677788;\n  background-color: #f8fafd;\n  border-color: #e7eaf3;\n}\n\n.table-dark {\n  color: #fff;\n  background-color: #21325b;\n}\n\n.table-dark th,\n.table-dark td,\n.table-dark thead th {\n  border-color: #2b4177;\n}\n\n.table-dark.table-bordered {\n  border: 0;\n}\n\n.table-dark.table-striped tbody tr:nth-of-type(odd) {\n  background-color: rgba(255, 255, 255, 0.05);\n}\n\n.table-dark.table-hover tbody tr:hover {\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.075);\n}\n\n@media (max-width: 575.98px) {\n  .table-responsive-sm {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-sm > .table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .table-responsive-md {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-md > .table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .table-responsive-lg {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-lg > .table-bordered {\n    border: 0;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .table-responsive-xl {\n    display: block;\n    width: 100%;\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n  }\n  .table-responsive-xl > .table-bordered {\n    border: 0;\n  }\n}\n\n.table-responsive {\n  display: block;\n  width: 100%;\n  overflow-x: auto;\n  -webkit-overflow-scrolling: touch;\n}\n\n.table-responsive > .table-bordered {\n  border: 0;\n}\n\n.form-control {\n  display: block;\n  width: 100%;\n  height: calc(1.6em + 1.625rem);\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #1e2022;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0.0625rem solid #e7eaf3;\n  border-radius: 0.3125rem;\n  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .form-control {\n    transition: none;\n  }\n}\n\n.form-control::-ms-expand {\n  background-color: transparent;\n  border: 0;\n}\n\n.form-control:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #1e2022;\n}\n\n.form-control:focus {\n  color: #1e2022;\n  background-color: #fff;\n  border-color: rgba(55, 125, 255, 0.4);\n  outline: 0;\n  box-shadow: 0 0 10px rgba(55, 125, 255, 0.1);\n}\n\n.form-control::-webkit-input-placeholder {\n  color: #97a4af;\n  opacity: 1;\n}\n\n.form-control::-moz-placeholder {\n  color: #97a4af;\n  opacity: 1;\n}\n\n.form-control:-ms-input-placeholder {\n  color: #97a4af;\n  opacity: 1;\n}\n\n.form-control::-ms-input-placeholder {\n  color: #97a4af;\n  opacity: 1;\n}\n\n.form-control::placeholder {\n  color: #97a4af;\n  opacity: 1;\n}\n\n.form-control:disabled, .form-control[readonly] {\n  background-color: #f8fafd;\n  opacity: 1;\n}\n\ninput[type=\"date\"].form-control,\ninput[type=\"time\"].form-control,\ninput[type=\"datetime-local\"].form-control,\ninput[type=\"month\"].form-control {\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n\nselect.form-control:focus::-ms-value {\n  color: #1e2022;\n  background-color: #fff;\n}\n\n.form-control-file,\n.form-control-range {\n  display: block;\n  width: 100%;\n}\n\n.col-form-label {\n  padding-top: 0.8125rem;\n  padding-bottom: 0.8125rem;\n  margin-bottom: 0;\n  font-size: inherit;\n  line-height: 1.6;\n}\n\n.col-form-label-lg {\n  padding-top: 1.1875rem;\n  padding-bottom: 1.1875rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n\n.col-form-label-sm {\n  padding-top: 0.6875rem;\n  padding-bottom: 0.6875rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: 0.75rem 0;\n  margin-bottom: 0;\n  font-size: 1rem;\n  line-height: 1.6;\n  color: #677788;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: 0.0625rem 0;\n}\n\n.form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.form-control-sm {\n  height: calc(1.5em + 1.375rem);\n  padding: 0.625rem 1.125rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n}\n\n.form-control-lg {\n  height: calc(1.5em + 2.375rem);\n  padding: 1.125rem 1.125rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.75rem;\n}\n\nselect.form-control[size], select.form-control[multiple] {\n  height: auto;\n}\n\ntextarea.form-control {\n  height: auto;\n}\n\n.form-group {\n  margin-bottom: 1.5rem;\n}\n\n.form-text {\n  display: block;\n  margin-top: 0.25rem;\n}\n\n.form-row {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-right: -5px;\n  margin-left: -5px;\n}\n\n.form-row > .col,\n.form-row > [class*=\"col-\"] {\n  padding-right: 5px;\n  padding-left: 5px;\n}\n\n.form-check {\n  position: relative;\n  display: block;\n  padding-left: 1.25rem;\n}\n\n.form-check-input {\n  position: absolute;\n  margin-top: 0.3rem;\n  margin-left: -1.25rem;\n}\n\n.form-check-input[disabled] ~ .form-check-label,\n.form-check-input:disabled ~ .form-check-label {\n  color: #8c98a4;\n}\n\n.form-check-label {\n  margin-bottom: 0;\n}\n\n.form-check-inline {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding-left: 0;\n  margin-right: 0.75rem;\n}\n\n.form-check-inline .form-check-input {\n  position: static;\n  margin-top: 0;\n  margin-right: 0.3125rem;\n  margin-left: 0;\n}\n\n.valid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #00c9a7;\n}\n\n.valid-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: .1rem;\n  font-size: 0.875rem;\n  line-height: 1.6;\n  color: #fff;\n  background-color: #00c9a7;\n  border-radius: 0.3125rem;\n}\n\n.was-validated :valid ~ .valid-feedback,\n.was-validated :valid ~ .valid-tooltip,\n.is-valid ~ .valid-feedback,\n.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:valid, .form-control.is-valid {\n  border-color: #00c9a7;\n  padding-right: calc(1.6em + 1.5rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300c9a7' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.4em + 0.375rem) center;\n  background-size: calc(0.8em + 0.75rem) calc(0.8em + 0.75rem);\n}\n\n.was-validated .form-control:valid:focus, .form-control.is-valid:focus {\n  border-color: #00c9a7;\n  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.25);\n}\n\n.was-validated textarea.form-control:valid, textarea.form-control.is-valid {\n  padding-right: calc(1.6em + 1.5rem);\n  background-position: top calc(0.4em + 0.375rem) right calc(0.4em + 0.375rem);\n}\n\n.was-validated .custom-select:valid, .custom-select.is-valid {\n  border-color: #00c9a7;\n  padding-right: calc(0.75em + 3.125rem);\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%2371869d' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right 0.5rem center/1rem 1rem, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%2300c9a7' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/%3e%3c/svg%3e\") #fff no-repeat center right 2rem/calc(0.8em + 0.75rem) calc(0.8em + 0.75rem);\n}\n\n.was-validated .custom-select:valid:focus, .custom-select.is-valid:focus {\n  border-color: #00c9a7;\n  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.25);\n}\n\n.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {\n  color: #00c9a7;\n}\n\n.was-validated .form-check-input:valid ~ .valid-feedback,\n.was-validated .form-check-input:valid ~ .valid-tooltip, .form-check-input.is-valid ~ .valid-feedback,\n.form-check-input.is-valid ~ .valid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:valid ~ .custom-control-label, .custom-control-input.is-valid ~ .custom-control-label {\n  color: #00c9a7;\n}\n\n.was-validated .custom-control-input:valid ~ .custom-control-label::before, .custom-control-input.is-valid ~ .custom-control-label::before {\n  border-color: #00c9a7;\n}\n\n.was-validated .custom-control-input:valid:checked ~ .custom-control-label::before, .custom-control-input.is-valid:checked ~ .custom-control-label::before {\n  border-color: #00fcd1;\n  background-color: #00fcd1;\n}\n\n.was-validated .custom-control-input:valid:focus ~ .custom-control-label::before, .custom-control-input.is-valid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.25);\n}\n\n.was-validated .custom-control-input:valid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-valid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #00c9a7;\n}\n\n.was-validated .custom-file-input:valid ~ .custom-file-label, .custom-file-input.is-valid ~ .custom-file-label {\n  border-color: #00c9a7;\n}\n\n.was-validated .custom-file-input:valid:focus ~ .custom-file-label, .custom-file-input.is-valid:focus ~ .custom-file-label {\n  border-color: #00c9a7;\n  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.25);\n}\n\n.invalid-feedback {\n  display: none;\n  width: 100%;\n  margin-top: 0.25rem;\n  font-size: 80%;\n  color: #ed4c78;\n}\n\n.invalid-tooltip {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 5;\n  display: none;\n  max-width: 100%;\n  padding: 0.25rem 0.5rem;\n  margin-top: .1rem;\n  font-size: 0.875rem;\n  line-height: 1.6;\n  color: #fff;\n  background-color: #ed4c78;\n  border-radius: 0.3125rem;\n}\n\n.was-validated :invalid ~ .invalid-feedback,\n.was-validated :invalid ~ .invalid-tooltip,\n.is-invalid ~ .invalid-feedback,\n.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .form-control:invalid, .form-control.is-invalid {\n  border-color: #ed4c78;\n  padding-right: calc(1.6em + 1.5rem);\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ed4c78' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ed4c78' stroke='none'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right calc(0.4em + 0.375rem) center;\n  background-size: calc(0.8em + 0.75rem) calc(0.8em + 0.75rem);\n}\n\n.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {\n  border-color: #ed4c78;\n  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.25);\n}\n\n.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {\n  padding-right: calc(1.6em + 1.5rem);\n  background-position: top calc(0.4em + 0.375rem) right calc(0.4em + 0.375rem);\n}\n\n.was-validated .custom-select:invalid, .custom-select.is-invalid {\n  border-color: #ed4c78;\n  padding-right: calc(0.75em + 3.125rem);\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%2371869d' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right 0.5rem center/1rem 1rem, url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='none' stroke='%23ed4c78' viewBox='0 0 12 12'%3e%3ccircle cx='6' cy='6' r='4.5'/%3e%3cpath stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/%3e%3ccircle cx='6' cy='8.2' r='.6' fill='%23ed4c78' stroke='none'/%3e%3c/svg%3e\") #fff no-repeat center right 2rem/calc(0.8em + 0.75rem) calc(0.8em + 0.75rem);\n}\n\n.was-validated .custom-select:invalid:focus, .custom-select.is-invalid:focus {\n  border-color: #ed4c78;\n  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.25);\n}\n\n.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {\n  color: #ed4c78;\n}\n\n.was-validated .form-check-input:invalid ~ .invalid-feedback,\n.was-validated .form-check-input:invalid ~ .invalid-tooltip, .form-check-input.is-invalid ~ .invalid-feedback,\n.form-check-input.is-invalid ~ .invalid-tooltip {\n  display: block;\n}\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label, .custom-control-input.is-invalid ~ .custom-control-label {\n  color: #ed4c78;\n}\n\n.was-validated .custom-control-input:invalid ~ .custom-control-label::before, .custom-control-input.is-invalid ~ .custom-control-label::before {\n  border-color: #ed4c78;\n}\n\n.was-validated .custom-control-input:invalid:checked ~ .custom-control-label::before, .custom-control-input.is-invalid:checked ~ .custom-control-label::before {\n  border-color: #f27a9b;\n  background-color: #f27a9b;\n}\n\n.was-validated .custom-control-input:invalid:focus ~ .custom-control-label::before, .custom-control-input.is-invalid:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.25);\n}\n\n.was-validated .custom-control-input:invalid:focus:not(:checked) ~ .custom-control-label::before, .custom-control-input.is-invalid:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: #ed4c78;\n}\n\n.was-validated .custom-file-input:invalid ~ .custom-file-label, .custom-file-input.is-invalid ~ .custom-file-label {\n  border-color: #ed4c78;\n}\n\n.was-validated .custom-file-input:invalid:focus ~ .custom-file-label, .custom-file-input.is-invalid:focus ~ .custom-file-label {\n  border-color: #ed4c78;\n  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.25);\n}\n\n.form-inline {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row wrap;\n      flex-flow: row wrap;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.form-inline .form-check {\n  width: 100%;\n}\n\n@media (min-width: 576px) {\n  .form-inline label {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-group {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex: 0 0 auto;\n        flex: 0 0 auto;\n    -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n    -ms-flex-align: center;\n        align-items: center;\n    margin-bottom: 0;\n  }\n  .form-inline .form-control {\n    display: inline-block;\n    width: auto;\n    vertical-align: middle;\n  }\n  .form-inline .form-control-plaintext {\n    display: inline-block;\n  }\n  .form-inline .input-group,\n  .form-inline .custom-select {\n    width: auto;\n  }\n  .form-inline .form-check {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n    width: auto;\n    padding-left: 0;\n  }\n  .form-inline .form-check-input {\n    position: relative;\n    -ms-flex-negative: 0;\n        flex-shrink: 0;\n    margin-top: 0;\n    margin-right: 0.25rem;\n    margin-left: 0;\n  }\n  .form-inline .custom-control {\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n  }\n  .form-inline .custom-control-label {\n    margin-bottom: 0;\n  }\n}\n\n.btn {\n  display: inline-block;\n  font-weight: 600;\n  color: #677788;\n  text-align: center;\n  vertical-align: middle;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  background-color: transparent;\n  border: 0.0625rem solid transparent;\n  padding: 0.75rem 1rem;\n  font-size: 1rem;\n  line-height: 1.6;\n  border-radius: 0.3125rem;\n  transition: all 0.2s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .btn {\n    transition: none;\n  }\n}\n\n.btn:hover {\n  color: #677788;\n  text-decoration: none;\n}\n\n.btn:focus, .btn.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(55, 125, 255, 0.25);\n}\n\n.btn.disabled, .btn:disabled {\n  opacity: 0.65;\n}\n\n.btn:not(:disabled):not(.disabled) {\n  cursor: pointer;\n}\n\na.btn.disabled,\nfieldset:disabled a.btn {\n  pointer-events: none;\n}\n\n.btn-primary {\n  color: #fff;\n  background-color: #377dff;\n  border-color: #377dff;\n}\n\n.btn-primary:hover {\n  color: #fff;\n  background-color: #1164ff;\n  border-color: #045cff;\n}\n\n.btn-primary:focus, .btn-primary.focus {\n  color: #fff;\n  background-color: #1164ff;\n  border-color: #045cff;\n  box-shadow: 0 0 0 0.2rem rgba(85, 145, 255, 0.5);\n}\n\n.btn-primary.disabled, .btn-primary:disabled {\n  color: #fff;\n  background-color: #377dff;\n  border-color: #377dff;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active, .btn-primary:not(:disabled):not(.disabled).active,\n.show > .btn-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #045cff;\n  border-color: #0056f6;\n}\n\n.btn-primary:not(:disabled):not(.disabled):active:focus, .btn-primary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(85, 145, 255, 0.5);\n}\n\n.btn-secondary {\n  color: #fff;\n  background-color: #71869d;\n  border-color: #71869d;\n}\n\n.btn-secondary:hover {\n  color: #fff;\n  background-color: #5f7389;\n  border-color: #596d82;\n}\n\n.btn-secondary:focus, .btn-secondary.focus {\n  color: #fff;\n  background-color: #5f7389;\n  border-color: #596d82;\n  box-shadow: 0 0 0 0.2rem rgba(134, 152, 172, 0.5);\n}\n\n.btn-secondary.disabled, .btn-secondary:disabled {\n  color: #fff;\n  background-color: #71869d;\n  border-color: #71869d;\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active, .btn-secondary:not(:disabled):not(.disabled).active,\n.show > .btn-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #596d82;\n  border-color: #54667a;\n}\n\n.btn-secondary:not(:disabled):not(.disabled):active:focus, .btn-secondary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(134, 152, 172, 0.5);\n}\n\n.btn-success {\n  color: #fff;\n  background-color: #00c9a7;\n  border-color: #00c9a7;\n}\n\n.btn-success:hover {\n  color: #fff;\n  background-color: #00a387;\n  border-color: #00967d;\n}\n\n.btn-success:focus, .btn-success.focus {\n  color: #fff;\n  background-color: #00a387;\n  border-color: #00967d;\n  box-shadow: 0 0 0 0.2rem rgba(38, 209, 180, 0.5);\n}\n\n.btn-success.disabled, .btn-success:disabled {\n  color: #fff;\n  background-color: #00c9a7;\n  border-color: #00c9a7;\n}\n\n.btn-success:not(:disabled):not(.disabled):active, .btn-success:not(:disabled):not(.disabled).active,\n.show > .btn-success.dropdown-toggle {\n  color: #fff;\n  background-color: #00967d;\n  border-color: #008972;\n}\n\n.btn-success:not(:disabled):not(.disabled):active:focus, .btn-success:not(:disabled):not(.disabled).active:focus,\n.show > .btn-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(38, 209, 180, 0.5);\n}\n\n.btn-info {\n  color: #fff;\n  background-color: #09a5be;\n  border-color: #09a5be;\n}\n\n.btn-info:hover {\n  color: #fff;\n  background-color: #078599;\n  border-color: #077b8d;\n}\n\n.btn-info:focus, .btn-info.focus {\n  color: #fff;\n  background-color: #078599;\n  border-color: #077b8d;\n  box-shadow: 0 0 0 0.2rem rgba(46, 179, 200, 0.5);\n}\n\n.btn-info.disabled, .btn-info:disabled {\n  color: #fff;\n  background-color: #09a5be;\n  border-color: #09a5be;\n}\n\n.btn-info:not(:disabled):not(.disabled):active, .btn-info:not(:disabled):not(.disabled).active,\n.show > .btn-info.dropdown-toggle {\n  color: #fff;\n  background-color: #077b8d;\n  border-color: #067081;\n}\n\n.btn-info:not(:disabled):not(.disabled):active:focus, .btn-info:not(:disabled):not(.disabled).active:focus,\n.show > .btn-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(46, 179, 200, 0.5);\n}\n\n.btn-warning {\n  color: #1e2022;\n  background-color: #f5ca99;\n  border-color: #f5ca99;\n}\n\n.btn-warning:hover {\n  color: #1e2022;\n  background-color: #f2b876;\n  border-color: #f0b26b;\n}\n\n.btn-warning:focus, .btn-warning.focus {\n  color: #1e2022;\n  background-color: #f2b876;\n  border-color: #f0b26b;\n  box-shadow: 0 0 0 0.2rem rgba(213, 177, 135, 0.5);\n}\n\n.btn-warning.disabled, .btn-warning:disabled {\n  color: #1e2022;\n  background-color: #f5ca99;\n  border-color: #f5ca99;\n}\n\n.btn-warning:not(:disabled):not(.disabled):active, .btn-warning:not(:disabled):not(.disabled).active,\n.show > .btn-warning.dropdown-toggle {\n  color: #1e2022;\n  background-color: #f0b26b;\n  border-color: #efac5f;\n}\n\n.btn-warning:not(:disabled):not(.disabled):active:focus, .btn-warning:not(:disabled):not(.disabled).active:focus,\n.show > .btn-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(213, 177, 135, 0.5);\n}\n\n.btn-danger {\n  color: #fff;\n  background-color: #ed4c78;\n  border-color: #ed4c78;\n}\n\n.btn-danger:hover {\n  color: #fff;\n  background-color: #ea295e;\n  border-color: #e81e55;\n}\n\n.btn-danger:focus, .btn-danger.focus {\n  color: #fff;\n  background-color: #ea295e;\n  border-color: #e81e55;\n  box-shadow: 0 0 0 0.2rem rgba(240, 103, 140, 0.5);\n}\n\n.btn-danger.disabled, .btn-danger:disabled {\n  color: #fff;\n  background-color: #ed4c78;\n  border-color: #ed4c78;\n}\n\n.btn-danger:not(:disabled):not(.disabled):active, .btn-danger:not(:disabled):not(.disabled).active,\n.show > .btn-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #e81e55;\n  border-color: #e2174e;\n}\n\n.btn-danger:not(:disabled):not(.disabled):active:focus, .btn-danger:not(:disabled):not(.disabled).active:focus,\n.show > .btn-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(240, 103, 140, 0.5);\n}\n\n.btn-light {\n  color: #1e2022;\n  background-color: #f7faff;\n  border-color: #f7faff;\n}\n\n.btn-light:hover {\n  color: #1e2022;\n  background-color: #d1e2ff;\n  border-color: #c4daff;\n}\n\n.btn-light:focus, .btn-light.focus {\n  color: #1e2022;\n  background-color: #d1e2ff;\n  border-color: #c4daff;\n  box-shadow: 0 0 0 0.2rem rgba(214, 217, 222, 0.5);\n}\n\n.btn-light.disabled, .btn-light:disabled {\n  color: #1e2022;\n  background-color: #f7faff;\n  border-color: #f7faff;\n}\n\n.btn-light:not(:disabled):not(.disabled):active, .btn-light:not(:disabled):not(.disabled).active,\n.show > .btn-light.dropdown-toggle {\n  color: #1e2022;\n  background-color: #c4daff;\n  border-color: #b7d2ff;\n}\n\n.btn-light:not(:disabled):not(.disabled):active:focus, .btn-light:not(:disabled):not(.disabled).active:focus,\n.show > .btn-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(214, 217, 222, 0.5);\n}\n\n.btn-dark {\n  color: #fff;\n  background-color: #21325b;\n  border-color: #21325b;\n}\n\n.btn-dark:hover {\n  color: #fff;\n  background-color: #17233f;\n  border-color: #131d36;\n}\n\n.btn-dark:focus, .btn-dark.focus {\n  color: #fff;\n  background-color: #17233f;\n  border-color: #131d36;\n  box-shadow: 0 0 0 0.2rem rgba(66, 81, 116, 0.5);\n}\n\n.btn-dark.disabled, .btn-dark:disabled {\n  color: #fff;\n  background-color: #21325b;\n  border-color: #21325b;\n}\n\n.btn-dark:not(:disabled):not(.disabled):active, .btn-dark:not(:disabled):not(.disabled).active,\n.show > .btn-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #131d36;\n  border-color: #10182c;\n}\n\n.btn-dark:not(:disabled):not(.disabled):active:focus, .btn-dark:not(:disabled):not(.disabled).active:focus,\n.show > .btn-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(66, 81, 116, 0.5);\n}\n\n.btn-indigo {\n  color: #fff;\n  background-color: #2d1582;\n  border-color: #2d1582;\n}\n\n.btn-indigo:hover {\n  color: #fff;\n  background-color: #221061;\n  border-color: #1e0e56;\n}\n\n.btn-indigo:focus, .btn-indigo.focus {\n  color: #fff;\n  background-color: #221061;\n  border-color: #1e0e56;\n  box-shadow: 0 0 0 0.2rem rgba(77, 56, 149, 0.5);\n}\n\n.btn-indigo.disabled, .btn-indigo:disabled {\n  color: #fff;\n  background-color: #2d1582;\n  border-color: #2d1582;\n}\n\n.btn-indigo:not(:disabled):not(.disabled):active, .btn-indigo:not(:disabled):not(.disabled).active,\n.show > .btn-indigo.dropdown-toggle {\n  color: #fff;\n  background-color: #1e0e56;\n  border-color: #1a0c4b;\n}\n\n.btn-indigo:not(:disabled):not(.disabled):active:focus, .btn-indigo:not(:disabled):not(.disabled).active:focus,\n.show > .btn-indigo.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(77, 56, 149, 0.5);\n}\n\n.btn-outline-primary {\n  color: #377dff;\n  border-color: #377dff;\n}\n\n.btn-outline-primary:hover {\n  color: #fff;\n  background-color: #377dff;\n  border-color: #377dff;\n}\n\n.btn-outline-primary:focus, .btn-outline-primary.focus {\n  box-shadow: 0 0 0 0.2rem rgba(55, 125, 255, 0.5);\n}\n\n.btn-outline-primary.disabled, .btn-outline-primary:disabled {\n  color: #377dff;\n  background-color: transparent;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled):active, .btn-outline-primary:not(:disabled):not(.disabled).active,\n.show > .btn-outline-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #377dff;\n  border-color: #377dff;\n}\n\n.btn-outline-primary:not(:disabled):not(.disabled):active:focus, .btn-outline-primary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-primary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(55, 125, 255, 0.5);\n}\n\n.btn-outline-secondary {\n  color: #71869d;\n  border-color: #71869d;\n}\n\n.btn-outline-secondary:hover {\n  color: #fff;\n  background-color: #71869d;\n  border-color: #71869d;\n}\n\n.btn-outline-secondary:focus, .btn-outline-secondary.focus {\n  box-shadow: 0 0 0 0.2rem rgba(113, 134, 157, 0.5);\n}\n\n.btn-outline-secondary.disabled, .btn-outline-secondary:disabled {\n  color: #71869d;\n  background-color: transparent;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled):active, .btn-outline-secondary:not(:disabled):not(.disabled).active,\n.show > .btn-outline-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #71869d;\n  border-color: #71869d;\n}\n\n.btn-outline-secondary:not(:disabled):not(.disabled):active:focus, .btn-outline-secondary:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-secondary.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(113, 134, 157, 0.5);\n}\n\n.btn-outline-success {\n  color: #00c9a7;\n  border-color: #00c9a7;\n}\n\n.btn-outline-success:hover {\n  color: #fff;\n  background-color: #00c9a7;\n  border-color: #00c9a7;\n}\n\n.btn-outline-success:focus, .btn-outline-success.focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.5);\n}\n\n.btn-outline-success.disabled, .btn-outline-success:disabled {\n  color: #00c9a7;\n  background-color: transparent;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled):active, .btn-outline-success:not(:disabled):not(.disabled).active,\n.show > .btn-outline-success.dropdown-toggle {\n  color: #fff;\n  background-color: #00c9a7;\n  border-color: #00c9a7;\n}\n\n.btn-outline-success:not(:disabled):not(.disabled):active:focus, .btn-outline-success:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-success.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.5);\n}\n\n.btn-outline-info {\n  color: #09a5be;\n  border-color: #09a5be;\n}\n\n.btn-outline-info:hover {\n  color: #fff;\n  background-color: #09a5be;\n  border-color: #09a5be;\n}\n\n.btn-outline-info:focus, .btn-outline-info.focus {\n  box-shadow: 0 0 0 0.2rem rgba(9, 165, 190, 0.5);\n}\n\n.btn-outline-info.disabled, .btn-outline-info:disabled {\n  color: #09a5be;\n  background-color: transparent;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled):active, .btn-outline-info:not(:disabled):not(.disabled).active,\n.show > .btn-outline-info.dropdown-toggle {\n  color: #fff;\n  background-color: #09a5be;\n  border-color: #09a5be;\n}\n\n.btn-outline-info:not(:disabled):not(.disabled):active:focus, .btn-outline-info:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-info.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(9, 165, 190, 0.5);\n}\n\n.btn-outline-warning {\n  color: #f5ca99;\n  border-color: #f5ca99;\n}\n\n.btn-outline-warning:hover {\n  color: #1e2022;\n  background-color: #f5ca99;\n  border-color: #f5ca99;\n}\n\n.btn-outline-warning:focus, .btn-outline-warning.focus {\n  box-shadow: 0 0 0 0.2rem rgba(245, 202, 153, 0.5);\n}\n\n.btn-outline-warning.disabled, .btn-outline-warning:disabled {\n  color: #f5ca99;\n  background-color: transparent;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled):active, .btn-outline-warning:not(:disabled):not(.disabled).active,\n.show > .btn-outline-warning.dropdown-toggle {\n  color: #1e2022;\n  background-color: #f5ca99;\n  border-color: #f5ca99;\n}\n\n.btn-outline-warning:not(:disabled):not(.disabled):active:focus, .btn-outline-warning:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-warning.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(245, 202, 153, 0.5);\n}\n\n.btn-outline-danger {\n  color: #ed4c78;\n  border-color: #ed4c78;\n}\n\n.btn-outline-danger:hover {\n  color: #fff;\n  background-color: #ed4c78;\n  border-color: #ed4c78;\n}\n\n.btn-outline-danger:focus, .btn-outline-danger.focus {\n  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.5);\n}\n\n.btn-outline-danger.disabled, .btn-outline-danger:disabled {\n  color: #ed4c78;\n  background-color: transparent;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled):active, .btn-outline-danger:not(:disabled):not(.disabled).active,\n.show > .btn-outline-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #ed4c78;\n  border-color: #ed4c78;\n}\n\n.btn-outline-danger:not(:disabled):not(.disabled):active:focus, .btn-outline-danger:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-danger.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.5);\n}\n\n.btn-outline-light {\n  color: #f7faff;\n  border-color: #f7faff;\n}\n\n.btn-outline-light:hover {\n  color: #1e2022;\n  background-color: #f7faff;\n  border-color: #f7faff;\n}\n\n.btn-outline-light:focus, .btn-outline-light.focus {\n  box-shadow: 0 0 0 0.2rem rgba(247, 250, 255, 0.5);\n}\n\n.btn-outline-light.disabled, .btn-outline-light:disabled {\n  color: #f7faff;\n  background-color: transparent;\n}\n\n.btn-outline-light:not(:disabled):not(.disabled):active, .btn-outline-light:not(:disabled):not(.disabled).active,\n.show > .btn-outline-light.dropdown-toggle {\n  color: #1e2022;\n  background-color: #f7faff;\n  border-color: #f7faff;\n}\n\n.btn-outline-light:not(:disabled):not(.disabled):active:focus, .btn-outline-light:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-light.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(247, 250, 255, 0.5);\n}\n\n.btn-outline-dark {\n  color: #21325b;\n  border-color: #21325b;\n}\n\n.btn-outline-dark:hover {\n  color: #fff;\n  background-color: #21325b;\n  border-color: #21325b;\n}\n\n.btn-outline-dark:focus, .btn-outline-dark.focus {\n  box-shadow: 0 0 0 0.2rem rgba(33, 50, 91, 0.5);\n}\n\n.btn-outline-dark.disabled, .btn-outline-dark:disabled {\n  color: #21325b;\n  background-color: transparent;\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled):active, .btn-outline-dark:not(:disabled):not(.disabled).active,\n.show > .btn-outline-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #21325b;\n  border-color: #21325b;\n}\n\n.btn-outline-dark:not(:disabled):not(.disabled):active:focus, .btn-outline-dark:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-dark.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(33, 50, 91, 0.5);\n}\n\n.btn-outline-indigo {\n  color: #2d1582;\n  border-color: #2d1582;\n}\n\n.btn-outline-indigo:hover {\n  color: #fff;\n  background-color: #2d1582;\n  border-color: #2d1582;\n}\n\n.btn-outline-indigo:focus, .btn-outline-indigo.focus {\n  box-shadow: 0 0 0 0.2rem rgba(45, 21, 130, 0.5);\n}\n\n.btn-outline-indigo.disabled, .btn-outline-indigo:disabled {\n  color: #2d1582;\n  background-color: transparent;\n}\n\n.btn-outline-indigo:not(:disabled):not(.disabled):active, .btn-outline-indigo:not(:disabled):not(.disabled).active,\n.show > .btn-outline-indigo.dropdown-toggle {\n  color: #fff;\n  background-color: #2d1582;\n  border-color: #2d1582;\n}\n\n.btn-outline-indigo:not(:disabled):not(.disabled):active:focus, .btn-outline-indigo:not(:disabled):not(.disabled).active:focus,\n.show > .btn-outline-indigo.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0.2rem rgba(45, 21, 130, 0.5);\n}\n\n.btn-link {\n  font-weight: 400;\n  color: #377dff;\n  text-decoration: none;\n}\n\n.btn-link:hover {\n  color: #0052ea;\n  text-decoration: none;\n}\n\n.btn-link:focus, .btn-link.focus {\n  text-decoration: none;\n}\n\n.btn-link:disabled, .btn-link.disabled {\n  color: #8c98a4;\n  pointer-events: none;\n}\n\n.btn-lg, .btn-group-lg > .btn {\n  padding: 1.125rem 1.125rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.75rem;\n}\n\n.btn-sm, .btn-group-sm > .btn {\n  padding: 0.625rem 1.125rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n}\n\n.btn-block {\n  display: block;\n  width: 100%;\n}\n\n.btn-block + .btn-block {\n  margin-top: 0.5rem;\n}\n\ninput[type=\"submit\"].btn-block,\ninput[type=\"reset\"].btn-block,\ninput[type=\"button\"].btn-block {\n  width: 100%;\n}\n\n.fade {\n  transition: opacity 0.15s linear;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fade {\n    transition: none;\n  }\n}\n\n.fade:not(.show) {\n  opacity: 0;\n}\n\n.collapse:not(.show) {\n  display: none;\n}\n\n.collapsing {\n  position: relative;\n  height: 0;\n  overflow: hidden;\n  transition: height 0.35s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .collapsing {\n    transition: none;\n  }\n}\n\n.dropup,\n.dropright,\n.dropdown,\n.dropleft {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n}\n\n.dropdown-menu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  z-index: 1000;\n  display: none;\n  float: left;\n  min-width: 8.4375rem;\n  padding: 1rem 0;\n  margin: 0.5rem 0 0;\n  font-size: 1rem;\n  color: #677788;\n  text-align: left;\n  list-style: none;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0 solid rgba(0, 0, 0, 0.15);\n  border-radius: 0.75rem;\n}\n\n.dropdown-menu-left {\n  right: auto;\n  left: 0;\n}\n\n.dropdown-menu-right {\n  right: 0;\n  left: auto;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-sm-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 768px) {\n  .dropdown-menu-md-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-md-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 992px) {\n  .dropdown-menu-lg-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-lg-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-left {\n    right: auto;\n    left: 0;\n  }\n  .dropdown-menu-xl-right {\n    right: 0;\n    left: auto;\n  }\n}\n\n.dropup .dropdown-menu {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n\n.dropright .dropdown-menu {\n  top: 0;\n  right: auto;\n  left: 100%;\n  margin-top: 0;\n  margin-left: 0.5rem;\n}\n\n.dropright .dropdown-toggle::after {\n  vertical-align: 0;\n}\n\n.dropleft .dropdown-menu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: 0.5rem;\n}\n\n.dropleft .dropdown-toggle::before {\n  vertical-align: 0;\n}\n\n.dropdown-menu[x-placement^=\"top\"], .dropdown-menu[x-placement^=\"right\"], .dropdown-menu[x-placement^=\"bottom\"], .dropdown-menu[x-placement^=\"left\"] {\n  right: auto;\n  bottom: auto;\n}\n\n.dropdown-divider {\n  height: 0;\n  margin: 0.5rem 0;\n  overflow: hidden;\n  border-top: 1px solid #e7eaf3;\n}\n\n.dropdown-item {\n  display: block;\n  width: 100%;\n  padding: 0.375rem 1.5rem;\n  clear: both;\n  font-weight: 400;\n  color: #1e2022;\n  text-align: inherit;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0;\n}\n\n.dropdown-item:hover, .dropdown-item:focus {\n  color: #121314;\n  text-decoration: none;\n  background-color: rgba(189, 197, 209, 0.3);\n}\n\n.dropdown-item.active, .dropdown-item:active {\n  color: #1e2022;\n  text-decoration: none;\n  background-color: rgba(189, 197, 209, 0.3);\n}\n\n.dropdown-item.disabled, .dropdown-item:disabled {\n  color: #8c98a4;\n  pointer-events: none;\n  background-color: transparent;\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n.dropdown-header {\n  display: block;\n  padding: 1rem 1.5rem;\n  margin-bottom: 0;\n  font-size: 0.875rem;\n  color: #8c98a4;\n  white-space: nowrap;\n}\n\n.dropdown-item-text {\n  display: block;\n  padding: 0.375rem 1.5rem;\n  color: #1e2022;\n}\n\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: middle;\n}\n\n.btn-group > .btn,\n.btn-group-vertical > .btn {\n  position: relative;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n}\n\n.btn-group > .btn:hover,\n.btn-group-vertical > .btn:hover {\n  z-index: 1;\n}\n\n.btn-group > .btn:focus, .btn-group > .btn:active, .btn-group > .btn.active,\n.btn-group-vertical > .btn:focus,\n.btn-group-vertical > .btn:active,\n.btn-group-vertical > .btn.active {\n  z-index: 1;\n}\n\n.btn-toolbar {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n}\n\n.btn-toolbar .input-group {\n  width: auto;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) {\n  margin-left: -0.0625rem;\n}\n\n.btn-group > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group > .btn-group:not(:last-child) > .btn {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.btn-group > .btn:not(:first-child),\n.btn-group > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.dropdown-toggle-split {\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.dropdown-toggle-split::after,\n.dropup .dropdown-toggle-split::after,\n.dropright .dropdown-toggle-split::after {\n  margin-left: 0;\n}\n\n.dropleft .dropdown-toggle-split::before {\n  margin-right: 0;\n}\n\n.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {\n  padding-right: 0.84375rem;\n  padding-left: 0.84375rem;\n}\n\n.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {\n  padding-right: 0.84375rem;\n  padding-left: 0.84375rem;\n}\n\n.btn-group-vertical {\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n\n.btn-group-vertical > .btn,\n.btn-group-vertical > .btn-group {\n  width: 100%;\n}\n\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) {\n  margin-top: -0.0625rem;\n}\n\n.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-vertical > .btn-group:not(:last-child) > .btn {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.btn-group-vertical > .btn:not(:first-child),\n.btn-group-vertical > .btn-group:not(:first-child) > .btn {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.btn-group-toggle > .btn,\n.btn-group-toggle > .btn-group > .btn {\n  margin-bottom: 0;\n}\n\n.btn-group-toggle > .btn input[type=\"radio\"],\n.btn-group-toggle > .btn input[type=\"checkbox\"],\n.btn-group-toggle > .btn-group > .btn input[type=\"radio\"],\n.btn-group-toggle > .btn-group > .btn input[type=\"checkbox\"] {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n\n.input-group {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-align: stretch;\n      align-items: stretch;\n  width: 100%;\n}\n\n.input-group > .form-control,\n.input-group > .form-control-plaintext,\n.input-group > .custom-select,\n.input-group > .custom-file {\n  position: relative;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  width: 1%;\n  min-width: 0;\n  margin-bottom: 0;\n}\n\n.input-group > .form-control + .form-control,\n.input-group > .form-control + .custom-select,\n.input-group > .form-control + .custom-file,\n.input-group > .form-control-plaintext + .form-control,\n.input-group > .form-control-plaintext + .custom-select,\n.input-group > .form-control-plaintext + .custom-file,\n.input-group > .custom-select + .form-control,\n.input-group > .custom-select + .custom-select,\n.input-group > .custom-select + .custom-file,\n.input-group > .custom-file + .form-control,\n.input-group > .custom-file + .custom-select,\n.input-group > .custom-file + .custom-file {\n  margin-left: -0.0625rem;\n}\n\n.input-group > .form-control:focus,\n.input-group > .custom-select:focus,\n.input-group > .custom-file .custom-file-input:focus ~ .custom-file-label {\n  z-index: 3;\n}\n\n.input-group > .custom-file .custom-file-input:focus {\n  z-index: 4;\n}\n\n.input-group > .form-control:not(:last-child),\n.input-group > .custom-select:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .form-control:not(:first-child),\n.input-group > .custom-select:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group > .custom-file {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.input-group > .custom-file:not(:last-child) .custom-file-label,\n.input-group > .custom-file:not(:last-child) .custom-file-label::after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .custom-file:not(:first-child) .custom-file-label {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group-prepend,\n.input-group-append {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.input-group-prepend .btn,\n.input-group-append .btn {\n  position: relative;\n  z-index: 2;\n}\n\n.input-group-prepend .btn:focus,\n.input-group-append .btn:focus {\n  z-index: 3;\n}\n\n.input-group-prepend .btn + .btn,\n.input-group-prepend .btn + .input-group-text,\n.input-group-prepend .input-group-text + .input-group-text,\n.input-group-prepend .input-group-text + .btn,\n.input-group-append .btn + .btn,\n.input-group-append .btn + .input-group-text,\n.input-group-append .input-group-text + .input-group-text,\n.input-group-append .input-group-text + .btn {\n  margin-left: -0.0625rem;\n}\n\n.input-group-prepend {\n  margin-right: -0.0625rem;\n}\n\n.input-group-append {\n  margin-left: -0.0625rem;\n}\n\n.input-group-text {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0.75rem 1rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #97a4af;\n  text-align: center;\n  white-space: nowrap;\n  background-color: transparent;\n  border: 0.0625rem solid #e7eaf3;\n  border-radius: 0.3125rem;\n}\n\n.input-group-text input[type=\"radio\"],\n.input-group-text input[type=\"checkbox\"] {\n  margin-top: 0;\n}\n\n.input-group-lg > .form-control:not(textarea),\n.input-group-lg > .custom-select {\n  height: calc(1.5em + 2.375rem);\n}\n\n.input-group-lg > .form-control,\n.input-group-lg > .custom-select,\n.input-group-lg > .input-group-prepend > .input-group-text,\n.input-group-lg > .input-group-append > .input-group-text,\n.input-group-lg > .input-group-prepend > .btn,\n.input-group-lg > .input-group-append > .btn {\n  padding: 1.125rem 1.125rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n  border-radius: 0.75rem;\n}\n\n.input-group-sm > .form-control:not(textarea),\n.input-group-sm > .custom-select {\n  height: calc(1.5em + 1.375rem);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .custom-select,\n.input-group-sm > .input-group-prepend > .input-group-text,\n.input-group-sm > .input-group-append > .input-group-text,\n.input-group-sm > .input-group-prepend > .btn,\n.input-group-sm > .input-group-append > .btn {\n  padding: 0.625rem 1.125rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n  border-radius: 0.25rem;\n}\n\n.input-group-lg > .custom-select,\n.input-group-sm > .custom-select {\n  padding-right: 2rem;\n}\n\n.input-group > .input-group-prepend > .btn,\n.input-group > .input-group-prepend > .input-group-text,\n.input-group > .input-group-append:not(:last-child) > .btn,\n.input-group > .input-group-append:not(:last-child) > .input-group-text,\n.input-group > .input-group-append:last-child > .btn:not(:last-child):not(.dropdown-toggle),\n.input-group > .input-group-append:last-child > .input-group-text:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .input-group-append > .btn,\n.input-group > .input-group-append > .input-group-text,\n.input-group > .input-group-prepend:not(:first-child) > .btn,\n.input-group > .input-group-prepend:not(:first-child) > .input-group-text,\n.input-group > .input-group-prepend:first-child > .btn:not(:first-child),\n.input-group > .input-group-prepend:first-child > .input-group-text:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.custom-control {\n  position: relative;\n  z-index: 1;\n  display: block;\n  min-height: 1.6rem;\n  padding-left: 1.5rem;\n  -webkit-print-color-adjust: exact;\n          color-adjust: exact;\n}\n\n.custom-control-inline {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  margin-right: 1rem;\n}\n\n.custom-control-input {\n  position: absolute;\n  left: 0;\n  z-index: -1;\n  width: 1rem;\n  height: 1.3rem;\n  opacity: 0;\n}\n\n.custom-control-input:checked ~ .custom-control-label::before {\n  color: #fff;\n  border-color: #377dff;\n  background-color: #377dff;\n}\n\n.custom-control-input:focus ~ .custom-control-label::before {\n  box-shadow: 0 0 10px rgba(55, 125, 255, 0.1);\n}\n\n.custom-control-input:focus:not(:checked) ~ .custom-control-label::before {\n  border-color: rgba(55, 125, 255, 0.4);\n}\n\n.custom-control-input:not(:disabled):active ~ .custom-control-label::before {\n  color: #fff;\n  background-color: #eaf1ff;\n  border-color: #eaf1ff;\n}\n\n.custom-control-input[disabled] ~ .custom-control-label, .custom-control-input:disabled ~ .custom-control-label {\n  color: #8c98a4;\n}\n\n.custom-control-input[disabled] ~ .custom-control-label::before, .custom-control-input:disabled ~ .custom-control-label::before {\n  background-color: #f8fafd;\n}\n\n.custom-control-label {\n  position: relative;\n  margin-bottom: 0;\n  vertical-align: top;\n}\n\n.custom-control-label::before {\n  position: absolute;\n  top: 0.3rem;\n  left: -1.5rem;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  pointer-events: none;\n  content: \"\";\n  background-color: #fff;\n  border: #d6dbeb solid 0.0625rem;\n}\n\n.custom-control-label::after {\n  position: absolute;\n  top: 0.3rem;\n  left: -1.5rem;\n  display: block;\n  width: 1rem;\n  height: 1rem;\n  content: \"\";\n  background: no-repeat 50% / 50% 50%;\n}\n\n.custom-checkbox .custom-control-label::before {\n  border-radius: 0.25rem;\n}\n\n.custom-checkbox .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath fill='%23fff' d='M6.564.75l-3.59 3.612-1.538-1.55L0 4.26l2.974 2.99L8 2.193z'/%3e%3c/svg%3e\");\n}\n\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::before {\n  border-color: #377dff;\n  background-color: #377dff;\n}\n\n.custom-checkbox .custom-control-input:indeterminate ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='4' height='4' viewBox='0 0 4 4'%3e%3cpath stroke='%23fff' d='M0 2h4'/%3e%3c/svg%3e\");\n}\n\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(55, 125, 255, 0.5);\n}\n\n.custom-checkbox .custom-control-input:disabled:indeterminate ~ .custom-control-label::before {\n  background-color: rgba(55, 125, 255, 0.5);\n}\n\n.custom-radio .custom-control-label::before {\n  border-radius: 50%;\n}\n\n.custom-radio .custom-control-input:checked ~ .custom-control-label::after {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='-4 -4 8 8'%3e%3ccircle r='3' fill='%23fff'/%3e%3c/svg%3e\");\n}\n\n.custom-radio .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(55, 125, 255, 0.5);\n}\n\n.custom-switch {\n  padding-left: 2.25rem;\n}\n\n.custom-switch .custom-control-label::before {\n  left: -2.25rem;\n  width: 1.75rem;\n  pointer-events: all;\n  border-radius: 0.5rem;\n}\n\n.custom-switch .custom-control-label::after {\n  top: 0.425rem;\n  left: -2.125rem;\n  width: 0.75rem;\n  height: 0.75rem;\n  background-color: #d6dbeb;\n  border-radius: 0.5rem;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-transform 0.15s ease-in-out;\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: transform 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, -webkit-transform 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-switch .custom-control-label::after {\n    transition: none;\n  }\n}\n\n.custom-switch .custom-control-input:checked ~ .custom-control-label::after {\n  background-color: #fff;\n  -webkit-transform: translateX(0.75rem);\n          transform: translateX(0.75rem);\n}\n\n.custom-switch .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  background-color: rgba(55, 125, 255, 0.5);\n}\n\n.custom-select {\n  display: inline-block;\n  width: 100%;\n  height: calc(1.6em + 1.625rem);\n  padding: 0.75rem 2rem 0.75rem 1rem;\n  font-size: 1rem;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #1e2022;\n  vertical-align: middle;\n  background: #fff url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%2371869d' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right 0.5rem center/1rem 1rem;\n  border: 0.0625rem solid #e7eaf3;\n  border-radius: 0.3125rem;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n\n.custom-select:focus {\n  border-color: rgba(55, 125, 255, 0.4);\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(55, 125, 255, 0.25);\n}\n\n.custom-select:focus::-ms-value {\n  color: #1e2022;\n  background-color: #fff;\n}\n\n.custom-select[multiple], .custom-select[size]:not([size=\"1\"]) {\n  height: auto;\n  padding-right: 1rem;\n  background-image: none;\n}\n\n.custom-select:disabled {\n  color: #8c98a4;\n  background-color: #f8fafd;\n}\n\n.custom-select::-ms-expand {\n  display: none;\n}\n\n.custom-select:-moz-focusring {\n  color: transparent;\n  text-shadow: 0 0 0 #1e2022;\n}\n\n.custom-select-sm {\n  height: calc(1.5em + 1.375rem);\n  padding-top: 0.625rem;\n  padding-bottom: 0.625rem;\n  padding-left: 1.125rem;\n  font-size: 0.875rem;\n}\n\n.custom-select-lg {\n  height: calc(1.5em + 2.375rem);\n  padding-top: 1.125rem;\n  padding-bottom: 1.125rem;\n  padding-left: 1.125rem;\n  font-size: 1.25rem;\n}\n\n.custom-file {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  height: calc(1.6em + 1.625rem);\n  margin-bottom: 0;\n}\n\n.custom-file-input {\n  position: relative;\n  z-index: 2;\n  width: 100%;\n  height: calc(1.6em + 1.625rem);\n  margin: 0;\n  opacity: 0;\n}\n\n.custom-file-input:focus ~ .custom-file-label {\n  border-color: rgba(55, 125, 255, 0.4);\n  box-shadow: 0 0 10px rgba(55, 125, 255, 0.1);\n}\n\n.custom-file-input[disabled] ~ .custom-file-label,\n.custom-file-input:disabled ~ .custom-file-label {\n  background-color: #f8fafd;\n}\n\n.custom-file-input:lang(en) ~ .custom-file-label::after {\n  content: \"Browse\";\n}\n\n.custom-file-input ~ .custom-file-label[data-browse]::after {\n  content: attr(data-browse);\n}\n\n.custom-file-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1;\n  height: calc(1.6em + 1.625rem);\n  padding: 0.75rem 1rem;\n  font-weight: 400;\n  line-height: 1.6;\n  color: #8c98a4;\n  background-color: #fff;\n  border: 0.0625rem solid #e7eaf3;\n  border-radius: 0.3125rem;\n}\n\n.custom-file-label::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 3;\n  display: block;\n  height: calc(1.6em + 1.5rem);\n  padding: 0.75rem 1rem;\n  line-height: 1.6;\n  color: #8c98a4;\n  content: \"Browse\";\n  background-color: transparent;\n  border-left: inherit;\n  border-radius: 0 0.3125rem 0.3125rem 0;\n}\n\n.custom-range {\n  width: 100%;\n  height: 1.4rem;\n  padding: 0;\n  background-color: transparent;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n}\n\n.custom-range:focus {\n  outline: none;\n}\n\n.custom-range:focus::-webkit-slider-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 10px rgba(55, 125, 255, 0.1);\n}\n\n.custom-range:focus::-moz-range-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 10px rgba(55, 125, 255, 0.1);\n}\n\n.custom-range:focus::-ms-thumb {\n  box-shadow: 0 0 0 1px #fff, 0 0 10px rgba(55, 125, 255, 0.1);\n}\n\n.custom-range::-moz-focus-outer {\n  border: 0;\n}\n\n.custom-range::-webkit-slider-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: -0.25rem;\n  background-color: #377dff;\n  border: 0;\n  border-radius: 1rem;\n  -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  -webkit-appearance: none;\n          appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-webkit-slider-thumb {\n    -webkit-transition: none;\n    transition: none;\n  }\n}\n\n.custom-range::-webkit-slider-thumb:active {\n  background-color: #eaf1ff;\n}\n\n.custom-range::-webkit-slider-runnable-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #e7eaf3;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n\n.custom-range::-moz-range-thumb {\n  width: 1rem;\n  height: 1rem;\n  background-color: #377dff;\n  border: 0;\n  border-radius: 1rem;\n  -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  -moz-appearance: none;\n       appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-moz-range-thumb {\n    -moz-transition: none;\n    transition: none;\n  }\n}\n\n.custom-range::-moz-range-thumb:active {\n  background-color: #eaf1ff;\n}\n\n.custom-range::-moz-range-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: #e7eaf3;\n  border-color: transparent;\n  border-radius: 1rem;\n}\n\n.custom-range::-ms-thumb {\n  width: 1rem;\n  height: 1rem;\n  margin-top: 0;\n  margin-right: 0.2rem;\n  margin-left: 0.2rem;\n  background-color: #377dff;\n  border: 0;\n  border-radius: 1rem;\n  -ms-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n  appearance: none;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-range::-ms-thumb {\n    -ms-transition: none;\n    transition: none;\n  }\n}\n\n.custom-range::-ms-thumb:active {\n  background-color: #eaf1ff;\n}\n\n.custom-range::-ms-track {\n  width: 100%;\n  height: 0.5rem;\n  color: transparent;\n  cursor: pointer;\n  background-color: transparent;\n  border-color: transparent;\n  border-width: 0.5rem;\n}\n\n.custom-range::-ms-fill-lower {\n  background-color: #e7eaf3;\n  border-radius: 1rem;\n}\n\n.custom-range::-ms-fill-upper {\n  margin-right: 15px;\n  background-color: #e7eaf3;\n  border-radius: 1rem;\n}\n\n.custom-range:disabled::-webkit-slider-thumb {\n  background-color: #97a4af;\n}\n\n.custom-range:disabled::-webkit-slider-runnable-track {\n  cursor: default;\n}\n\n.custom-range:disabled::-moz-range-thumb {\n  background-color: #97a4af;\n}\n\n.custom-range:disabled::-moz-range-track {\n  cursor: default;\n}\n\n.custom-range:disabled::-ms-thumb {\n  background-color: #97a4af;\n}\n\n.custom-control-label::before,\n.custom-file-label,\n.custom-select {\n  transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-control-label::before,\n  .custom-file-label,\n  .custom-select {\n    transition: none;\n  }\n}\n\n.nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: 0.5rem 1rem;\n}\n\n.nav-link:hover, .nav-link:focus {\n  text-decoration: none;\n}\n\n.nav-link.disabled {\n  color: #8c98a4;\n  pointer-events: none;\n  cursor: default;\n}\n\n.nav-tabs {\n  border-bottom: 0.0625rem solid #e7eaf3;\n}\n\n.nav-tabs .nav-item {\n  margin-bottom: -0.0625rem;\n}\n\n.nav-tabs .nav-link {\n  border: 0.0625rem solid transparent;\n  border-top-left-radius: 0.3125rem;\n  border-top-right-radius: 0.3125rem;\n}\n\n.nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {\n  border-color: transparent;\n}\n\n.nav-tabs .nav-link.disabled {\n  color: #8c98a4;\n  background-color: transparent;\n  border-color: transparent;\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.show .nav-link {\n  color: #377dff;\n  background-color: #fff;\n  border-color: transparent transparent #377dff;\n}\n\n.nav-tabs .dropdown-menu {\n  margin-top: -0.0625rem;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.nav-pills .nav-link {\n  border-radius: 0.3125rem;\n}\n\n.nav-pills .nav-link.active,\n.nav-pills .show > .nav-link {\n  color: #fff;\n  background-color: #377dff;\n}\n\n.nav-fill > .nav-link,\n.nav-fill .nav-item {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  text-align: center;\n}\n\n.nav-justified > .nav-link,\n.nav-justified .nav-item {\n  -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  text-align: center;\n}\n\n.tab-content > .tab-pane {\n  display: none;\n}\n\n.tab-content > .active {\n  display: block;\n}\n\n.navbar {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 0 0;\n}\n\n.navbar .container,\n.navbar .container-fluid, .navbar .container-sm, .navbar .container-md, .navbar .container-lg, .navbar .container-xl {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n\n.navbar-brand {\n  display: inline-block;\n  padding-top: 0.3rem;\n  padding-bottom: 0.3rem;\n  margin-right: 0;\n  font-size: 1.25rem;\n  line-height: inherit;\n  white-space: nowrap;\n}\n\n.navbar-brand:hover, .navbar-brand:focus {\n  text-decoration: none;\n}\n\n.navbar-nav {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.navbar-nav .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-nav .dropdown-menu {\n  position: static;\n  float: none;\n}\n\n.navbar-text {\n  display: inline-block;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.navbar-collapse {\n  -ms-flex-preferred-size: 100%;\n      flex-basis: 100%;\n  -ms-flex-positive: 1;\n      flex-grow: 1;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.navbar-toggler {\n  padding: 0.75rem 0.75rem;\n  font-size: 1.25rem;\n  line-height: 1;\n  background-color: transparent;\n  border: 0.0625rem solid transparent;\n  border-radius: 0.3125rem;\n}\n\n.navbar-toggler:hover, .navbar-toggler:focus {\n  text-decoration: none;\n}\n\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  content: \"\";\n  background: no-repeat center center;\n  background-size: 100% 100%;\n}\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    -ms-flex-flow: row nowrap;\n        flex-flow: row nowrap;\n    -ms-flex-pack: start;\n        justify-content: flex-start;\n  }\n  .navbar-expand-sm .navbar-nav {\n    -ms-flex-direction: row;\n        flex-direction: row;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-sm > .container,\n  .navbar-expand-sm > .container-fluid, .navbar-expand-sm > .container-sm, .navbar-expand-sm > .container-md, .navbar-expand-sm > .container-lg, .navbar-expand-sm > .container-xl {\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n  }\n  .navbar-expand-sm .navbar-collapse {\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n  }\n  .navbar-expand-sm .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    -ms-flex-flow: row nowrap;\n        flex-flow: row nowrap;\n    -ms-flex-pack: start;\n        justify-content: flex-start;\n  }\n  .navbar-expand-md .navbar-nav {\n    -ms-flex-direction: row;\n        flex-direction: row;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-md > .container,\n  .navbar-expand-md > .container-fluid, .navbar-expand-md > .container-sm, .navbar-expand-md > .container-md, .navbar-expand-md > .container-lg, .navbar-expand-md > .container-xl {\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n  }\n  .navbar-expand-md .navbar-collapse {\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n  }\n  .navbar-expand-md .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    -ms-flex-flow: row nowrap;\n        flex-flow: row nowrap;\n    -ms-flex-pack: start;\n        justify-content: flex-start;\n  }\n  .navbar-expand-lg .navbar-nav {\n    -ms-flex-direction: row;\n        flex-direction: row;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-lg > .container,\n  .navbar-expand-lg > .container-fluid, .navbar-expand-lg > .container-sm, .navbar-expand-lg > .container-md, .navbar-expand-lg > .container-lg, .navbar-expand-lg > .container-xl {\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n  }\n  .navbar-expand-lg .navbar-collapse {\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n  }\n  .navbar-expand-lg .navbar-toggler {\n    display: none;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    -ms-flex-flow: row nowrap;\n        flex-flow: row nowrap;\n    -ms-flex-pack: start;\n        justify-content: flex-start;\n  }\n  .navbar-expand-xl .navbar-nav {\n    -ms-flex-direction: row;\n        flex-direction: row;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    position: absolute;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-right: 0.5rem;\n    padding-left: 0.5rem;\n  }\n  .navbar-expand-xl > .container,\n  .navbar-expand-xl > .container-fluid, .navbar-expand-xl > .container-sm, .navbar-expand-xl > .container-md, .navbar-expand-xl > .container-lg, .navbar-expand-xl > .container-xl {\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n  }\n  .navbar-expand-xl .navbar-collapse {\n    display: -ms-flexbox !important;\n    display: flex !important;\n    -ms-flex-preferred-size: auto;\n        flex-basis: auto;\n  }\n  .navbar-expand-xl .navbar-toggler {\n    display: none;\n  }\n}\n\n.navbar-expand {\n  -ms-flex-flow: row nowrap;\n      flex-flow: row nowrap;\n  -ms-flex-pack: start;\n      justify-content: flex-start;\n}\n\n.navbar-expand > .container,\n.navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.navbar-expand .navbar-nav {\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.navbar-expand .navbar-nav .dropdown-menu {\n  position: absolute;\n}\n\n.navbar-expand .navbar-nav .nav-link {\n  padding-right: 0.5rem;\n  padding-left: 0.5rem;\n}\n\n.navbar-expand > .container,\n.navbar-expand > .container-fluid, .navbar-expand > .container-sm, .navbar-expand > .container-md, .navbar-expand > .container-lg, .navbar-expand > .container-xl {\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n}\n\n.navbar-expand .navbar-collapse {\n  display: -ms-flexbox !important;\n  display: flex !important;\n  -ms-flex-preferred-size: auto;\n      flex-basis: auto;\n}\n\n.navbar-expand .navbar-toggler {\n  display: none;\n}\n\n.navbar-light .navbar-brand {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-brand:hover, .navbar-light .navbar-brand:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-nav .nav-link {\n  color: #677788;\n}\n\n.navbar-light .navbar-nav .nav-link:hover, .navbar-light .navbar-nav .nav-link:focus {\n  color: #0052ea;\n}\n\n.navbar-light .navbar-nav .nav-link.disabled {\n  color: rgba(0, 0, 0, 0.3);\n}\n\n.navbar-light .navbar-nav .show > .nav-link,\n.navbar-light .navbar-nav .active > .nav-link,\n.navbar-light .navbar-nav .nav-link.show,\n.navbar-light .navbar-nav .nav-link.active {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-toggler {\n  color: #677788;\n  border-color: rgba(0, 0, 0, 0.1);\n}\n\n.navbar-light .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='%23677788' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-light .navbar-text {\n  color: #677788;\n}\n\n.navbar-light .navbar-text a {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-light .navbar-text a:hover, .navbar-light .navbar-text a:focus {\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.navbar-dark .navbar-brand {\n  color: #fff;\n}\n\n.navbar-dark .navbar-brand:hover, .navbar-dark .navbar-brand:focus {\n  color: #fff;\n}\n\n.navbar-dark .navbar-nav .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.navbar-dark .navbar-nav .nav-link:hover, .navbar-dark .navbar-nav .nav-link:focus {\n  color: #fff;\n}\n\n.navbar-dark .navbar-nav .nav-link.disabled {\n  color: rgba(255, 255, 255, 0.25);\n}\n\n.navbar-dark .navbar-nav .show > .nav-link,\n.navbar-dark .navbar-nav .active > .nav-link,\n.navbar-dark .navbar-nav .nav-link.show,\n.navbar-dark .navbar-nav .nav-link.active {\n  color: #fff;\n}\n\n.navbar-dark .navbar-toggler {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.1);\n}\n\n.navbar-dark .navbar-toggler-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='30' height='30' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%28255, 255, 255, 0.7%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e\");\n}\n\n.navbar-dark .navbar-text {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.navbar-dark .navbar-text a {\n  color: #fff;\n}\n\n.navbar-dark .navbar-text a:hover, .navbar-dark .navbar-text a:focus {\n  color: #fff;\n}\n\n.card {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: border-box;\n  border: 0.0625rem solid rgba(231, 234, 243, 0.7);\n  border-radius: 0.75rem;\n}\n\n.card > hr {\n  margin-right: 0;\n  margin-left: 0;\n}\n\n.card > .list-group {\n  border-top: inherit;\n  border-bottom: inherit;\n}\n\n.card > .list-group:first-child {\n  border-top-width: 0;\n  border-top-left-radius: 0.75rem;\n  border-top-right-radius: 0.75rem;\n}\n\n.card > .list-group:last-child {\n  border-bottom-width: 0;\n  border-bottom-right-radius: 0.75rem;\n  border-bottom-left-radius: 0.75rem;\n}\n\n.card > .card-header + .list-group,\n.card > .list-group + .card-footer {\n  border-top: 0;\n}\n\n.card-body {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  min-height: 1px;\n  padding: 1.5rem;\n}\n\n.card-title {\n  margin-bottom: 1.5rem;\n}\n\n.card-subtitle {\n  margin-top: -0.75rem;\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link:hover {\n  text-decoration: none;\n}\n\n.card-link + .card-link {\n  margin-left: 1.5rem;\n}\n\n.card-header {\n  padding: 1.5rem 1.5rem;\n  margin-bottom: 0;\n  background-color: #fff;\n  border-bottom: 0.0625rem solid rgba(231, 234, 243, 0.7);\n}\n\n.card-header:first-child {\n  border-radius: 0.75rem 0.75rem 0 0;\n}\n\n.card-footer {\n  padding: 1.5rem 1.5rem;\n  background-color: #fff;\n  border-top: 0.0625rem solid rgba(231, 234, 243, 0.7);\n}\n\n.card-footer:last-child {\n  border-radius: 0 0 0.75rem 0.75rem;\n}\n\n.card-header-tabs {\n  margin-right: -0.75rem;\n  margin-bottom: -1.5rem;\n  margin-left: -0.75rem;\n  border-bottom: 0;\n}\n\n.card-header-pills {\n  margin-right: -0.75rem;\n  margin-left: -0.75rem;\n}\n\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: 1.25rem;\n  border-radius: 0.75rem;\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  width: 100%;\n}\n\n.card-img,\n.card-img-top {\n  border-top-left-radius: 0.75rem;\n  border-top-right-radius: 0.75rem;\n}\n\n.card-img,\n.card-img-bottom {\n  border-bottom-right-radius: 0.75rem;\n  border-bottom-left-radius: 0.75rem;\n}\n\n.card-deck .card {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n  .card-deck {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n    margin-right: -15px;\n    margin-left: -15px;\n  }\n  .card-deck .card {\n    -ms-flex: 1 0 0%;\n        flex: 1 0 0%;\n    margin-right: 15px;\n    margin-bottom: 0;\n    margin-left: 15px;\n  }\n}\n\n.card-group > .card {\n  margin-bottom: 15px;\n}\n\n@media (min-width: 576px) {\n  .card-group {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n  }\n  .card-group > .card {\n    -ms-flex: 1 0 0%;\n        flex: 1 0 0%;\n    margin-bottom: 0;\n  }\n  .card-group > .card + .card {\n    margin-left: 0;\n    border-left: 0;\n  }\n  .card-group > .card:not(:last-child) {\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-top,\n  .card-group > .card:not(:last-child) .card-header {\n    border-top-right-radius: 0;\n  }\n  .card-group > .card:not(:last-child) .card-img-bottom,\n  .card-group > .card:not(:last-child) .card-footer {\n    border-bottom-right-radius: 0;\n  }\n  .card-group > .card:not(:first-child) {\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-top,\n  .card-group > .card:not(:first-child) .card-header {\n    border-top-left-radius: 0;\n  }\n  .card-group > .card:not(:first-child) .card-img-bottom,\n  .card-group > .card:not(:first-child) .card-footer {\n    border-bottom-left-radius: 0;\n  }\n}\n\n.card-columns .card {\n  margin-bottom: 1.5rem;\n}\n\n@media (min-width: 576px) {\n  .card-columns {\n    -webkit-column-count: 3;\n       -moz-column-count: 3;\n            column-count: 3;\n    -webkit-column-gap: 1.25rem;\n       -moz-column-gap: 1.25rem;\n            column-gap: 1.25rem;\n    orphans: 1;\n    widows: 1;\n  }\n  .card-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n.accordion {\n  overflow-anchor: none;\n}\n\n.accordion > .card {\n  overflow: hidden;\n}\n\n.accordion > .card:not(:last-of-type) {\n  border-bottom: 0;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.accordion > .card:not(:first-of-type) {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n\n.accordion > .card > .card-header {\n  border-radius: 0;\n  margin-bottom: -0.0625rem;\n}\n\n.breadcrumb {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1rem;\n  list-style: none;\n  background-color: transparent;\n  border-radius: 0.3125rem;\n}\n\n.breadcrumb-item {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.breadcrumb-item + .breadcrumb-item {\n  padding-left: 0.5rem;\n}\n\n.breadcrumb-item + .breadcrumb-item::before {\n  display: inline-block;\n  padding-right: 0.5rem;\n  color: #8c98a4;\n  content: \"/\";\n}\n\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: underline;\n}\n\n.breadcrumb-item + .breadcrumb-item:hover::before {\n  text-decoration: none;\n}\n\n.breadcrumb-item.active {\n  color: #1e2022;\n}\n\n.pagination {\n  display: -ms-flexbox;\n  display: flex;\n  padding-left: 0;\n  list-style: none;\n  border-radius: 0.3125rem;\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: 0.5rem 0.75rem;\n  margin-left: 0;\n  line-height: 1.25;\n  color: #677788;\n  background-color: #fff;\n  border: 0 solid #e7eaf3;\n}\n\n.page-link:hover {\n  z-index: 2;\n  color: #377dff;\n  text-decoration: none;\n  background-color: rgba(55, 125, 255, 0.1);\n  border-color: rgba(55, 125, 255, 0.1);\n}\n\n.page-link:focus {\n  z-index: 3;\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(55, 125, 255, 0.25);\n}\n\n.page-item:first-child .page-link {\n  margin-left: 0;\n  border-top-left-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n}\n\n.page-item:last-child .page-link {\n  border-top-right-radius: 0.3125rem;\n  border-bottom-right-radius: 0.3125rem;\n}\n\n.page-item.active .page-link {\n  z-index: 3;\n  color: #fff;\n  background-color: #377dff;\n  border-color: #377dff;\n}\n\n.page-item.disabled .page-link {\n  color: #8c98a4;\n  pointer-events: none;\n  cursor: auto;\n  background-color: #fff;\n  border-color: #e7eaf3;\n}\n\n.pagination-lg .page-link {\n  padding: 0.75rem 1.5rem;\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n\n.pagination-lg .page-item:first-child .page-link {\n  border-top-left-radius: 0.75rem;\n  border-bottom-left-radius: 0.75rem;\n}\n\n.pagination-lg .page-item:last-child .page-link {\n  border-top-right-radius: 0.75rem;\n  border-bottom-right-radius: 0.75rem;\n}\n\n.pagination-sm .page-link {\n  padding: 0.25rem 0.5rem;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.pagination-sm .page-item:first-child .page-link {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.pagination-sm .page-item:last-child .page-link {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.badge {\n  display: inline-block;\n  padding: 0.275rem 0.5em;\n  font-size: 75%;\n  font-weight: 600;\n  line-height: 1;\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  border-radius: 0.3125rem;\n  transition: all 0.2s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .badge {\n    transition: none;\n  }\n}\n\na.badge:hover, a.badge:focus {\n  text-decoration: none;\n}\n\n.badge:empty {\n  display: none;\n}\n\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n\n.badge-pill {\n  padding-right: 0.6em;\n  padding-left: 0.6em;\n  border-radius: 10rem;\n}\n\n.badge-primary {\n  color: #fff;\n  background-color: #377dff;\n}\n\na.badge-primary:hover, a.badge-primary:focus {\n  color: #fff;\n  background-color: #045cff;\n}\n\na.badge-primary:focus, a.badge-primary.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(55, 125, 255, 0.5);\n}\n\n.badge-secondary {\n  color: #fff;\n  background-color: #71869d;\n}\n\na.badge-secondary:hover, a.badge-secondary:focus {\n  color: #fff;\n  background-color: #596d82;\n}\n\na.badge-secondary:focus, a.badge-secondary.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(113, 134, 157, 0.5);\n}\n\n.badge-success {\n  color: #fff;\n  background-color: #00c9a7;\n}\n\na.badge-success:hover, a.badge-success:focus {\n  color: #fff;\n  background-color: #00967d;\n}\n\na.badge-success:focus, a.badge-success.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(0, 201, 167, 0.5);\n}\n\n.badge-info {\n  color: #fff;\n  background-color: #09a5be;\n}\n\na.badge-info:hover, a.badge-info:focus {\n  color: #fff;\n  background-color: #077b8d;\n}\n\na.badge-info:focus, a.badge-info.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(9, 165, 190, 0.5);\n}\n\n.badge-warning {\n  color: #1e2022;\n  background-color: #f5ca99;\n}\n\na.badge-warning:hover, a.badge-warning:focus {\n  color: #1e2022;\n  background-color: #f0b26b;\n}\n\na.badge-warning:focus, a.badge-warning.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(245, 202, 153, 0.5);\n}\n\n.badge-danger {\n  color: #fff;\n  background-color: #ed4c78;\n}\n\na.badge-danger:hover, a.badge-danger:focus {\n  color: #fff;\n  background-color: #e81e55;\n}\n\na.badge-danger:focus, a.badge-danger.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(237, 76, 120, 0.5);\n}\n\n.badge-light {\n  color: #1e2022;\n  background-color: #f7faff;\n}\n\na.badge-light:hover, a.badge-light:focus {\n  color: #1e2022;\n  background-color: #c4daff;\n}\n\na.badge-light:focus, a.badge-light.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(247, 250, 255, 0.5);\n}\n\n.badge-dark {\n  color: #fff;\n  background-color: #21325b;\n}\n\na.badge-dark:hover, a.badge-dark:focus {\n  color: #fff;\n  background-color: #131d36;\n}\n\na.badge-dark:focus, a.badge-dark.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(33, 50, 91, 0.5);\n}\n\n.badge-indigo {\n  color: #fff;\n  background-color: #2d1582;\n}\n\na.badge-indigo:hover, a.badge-indigo:focus {\n  color: #fff;\n  background-color: #1e0e56;\n}\n\na.badge-indigo:focus, a.badge-indigo.focus {\n  outline: 0;\n  box-shadow: 0 0 0 0.2rem rgba(45, 21, 130, 0.5);\n}\n\n.jumbotron {\n  padding: 2rem 1rem;\n  margin-bottom: 2rem;\n  background-color: #f8fafd;\n  border-radius: 0.75rem;\n}\n\n@media (min-width: 576px) {\n  .jumbotron {\n    padding: 4rem 2rem;\n  }\n}\n\n.jumbotron-fluid {\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n\n.alert {\n  position: relative;\n  padding: 0.75rem 1.25rem;\n  margin-bottom: 1rem;\n  border: 0.0625rem solid transparent;\n  border-radius: 0.3125rem;\n}\n\n.alert-heading {\n  color: inherit;\n}\n\n.alert-link {\n  font-weight: 600;\n}\n\n.alert-dismissible {\n  padding-right: 3.75rem;\n}\n\n.alert-dismissible .close {\n  position: absolute;\n  top: 0;\n  right: 0;\n  z-index: 2;\n  padding: 0.75rem 1.25rem;\n  color: inherit;\n}\n\n.alert-primary {\n  color: #1d4185;\n  background-color: #d7e5ff;\n  border-color: #c7dbff;\n}\n\n.alert-primary hr {\n  border-top-color: #aecbff;\n}\n\n.alert-primary .alert-link {\n  color: #142d5b;\n}\n\n.alert-secondary {\n  color: #3b4652;\n  background-color: #e3e7eb;\n  border-color: #d7dde4;\n}\n\n.alert-secondary hr {\n  border-top-color: #c8d0da;\n}\n\n.alert-secondary .alert-link {\n  color: #262d34;\n}\n\n.alert-success {\n  color: #006957;\n  background-color: #ccf4ed;\n  border-color: #b8f0e6;\n}\n\n.alert-success hr {\n  border-top-color: #a3ecdf;\n}\n\n.alert-success .alert-link {\n  color: #00362d;\n}\n\n.alert-info {\n  color: #055663;\n  background-color: #ceedf2;\n  border-color: #bae6ed;\n}\n\n.alert-info hr {\n  border-top-color: #a6dfe8;\n}\n\n.alert-info .alert-link {\n  color: #032c32;\n}\n\n.alert-warning {\n  color: #7f6950;\n  background-color: #fdf4eb;\n  border-color: #fcf0e2;\n}\n\n.alert-warning hr {\n  border-top-color: #fae4cb;\n}\n\n.alert-warning .alert-link {\n  color: #604f3c;\n}\n\n.alert-danger {\n  color: #7b283e;\n  background-color: #fbdbe4;\n  border-color: #facdd9;\n}\n\n.alert-danger hr {\n  border-top-color: #f8b6c7;\n}\n\n.alert-danger .alert-link {\n  color: #551b2b;\n}\n\n.alert-light {\n  color: #808285;\n  background-color: #fdfeff;\n  border-color: #fdfeff;\n}\n\n.alert-light hr {\n  border-top-color: #e4f1ff;\n}\n\n.alert-light .alert-link {\n  color: #67696b;\n}\n\n.alert-dark {\n  color: #111a2f;\n  background-color: #d3d6de;\n  border-color: #c1c6d1;\n}\n\n.alert-dark hr {\n  border-top-color: #b2b9c6;\n}\n\n.alert-dark .alert-link {\n  color: #03050a;\n}\n\n.alert-indigo {\n  color: #170b44;\n  background-color: #d5d0e6;\n  border-color: #c4bddc;\n}\n\n.alert-indigo hr {\n  border-top-color: #b5acd3;\n}\n\n.alert-indigo .alert-link {\n  color: #080418;\n}\n\n@-webkit-keyframes progress-bar-stripes {\n  from {\n    background-position: 0.75rem 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n\n@keyframes progress-bar-stripes {\n  from {\n    background-position: 0.75rem 0;\n  }\n  to {\n    background-position: 0 0;\n  }\n}\n\n.progress {\n  display: -ms-flexbox;\n  display: flex;\n  height: 0.75rem;\n  overflow: hidden;\n  line-height: 0;\n  font-size: 0.75rem;\n  background-color: #e7eaf3;\n  border-radius: 0.3125rem;\n}\n\n.progress-bar {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  overflow: hidden;\n  color: #fff;\n  text-align: center;\n  white-space: nowrap;\n  background-color: #377dff;\n  transition: width 0.6s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar {\n    transition: none;\n  }\n}\n\n.progress-bar-striped {\n  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);\n  background-size: 0.75rem 0.75rem;\n}\n\n.progress-bar-animated {\n  -webkit-animation: progress-bar-stripes 1s linear infinite;\n          animation: progress-bar-stripes 1s linear infinite;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .progress-bar-animated {\n    -webkit-animation: none;\n            animation: none;\n  }\n}\n\n.media {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n      align-items: flex-start;\n}\n\n.media-body {\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.list-group {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  padding-left: 0;\n  margin-bottom: 0;\n  border-radius: 0.3125rem;\n}\n\n.list-group-item-action {\n  width: 100%;\n  color: #677788;\n  text-align: inherit;\n}\n\n.list-group-item-action:hover, .list-group-item-action:focus {\n  z-index: 1;\n  color: #677788;\n  text-decoration: none;\n  background-color: #f7faff;\n}\n\n.list-group-item-action:active {\n  color: #677788;\n  background-color: #f8fafd;\n}\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: 0.75rem 1.25rem;\n  background-color: #fff;\n  border: 0.0625rem solid #e7eaf3;\n}\n\n.list-group-item:first-child {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n\n.list-group-item:last-child {\n  border-bottom-right-radius: inherit;\n  border-bottom-left-radius: inherit;\n}\n\n.list-group-item.disabled, .list-group-item:disabled {\n  color: #8c98a4;\n  pointer-events: none;\n  background-color: #fff;\n}\n\n.list-group-item.active {\n  z-index: 2;\n  color: #fff;\n  background-color: #377dff;\n  border-color: #377dff;\n}\n\n.list-group-item + .list-group-item {\n  border-top-width: 0;\n}\n\n.list-group-item + .list-group-item.active {\n  margin-top: -0.0625rem;\n  border-top-width: 0.0625rem;\n}\n\n.list-group-horizontal {\n  -ms-flex-direction: row;\n      flex-direction: row;\n}\n\n.list-group-horizontal > .list-group-item:first-child {\n  border-bottom-left-radius: 0.3125rem;\n  border-top-right-radius: 0;\n}\n\n.list-group-horizontal > .list-group-item:last-child {\n  border-top-right-radius: 0.3125rem;\n  border-bottom-left-radius: 0;\n}\n\n.list-group-horizontal > .list-group-item.active {\n  margin-top: 0;\n}\n\n.list-group-horizontal > .list-group-item + .list-group-item {\n  border-top-width: 0.0625rem;\n  border-left-width: 0;\n}\n\n.list-group-horizontal > .list-group-item + .list-group-item.active {\n  margin-left: -0.0625rem;\n  border-left-width: 0.0625rem;\n}\n\n@media (min-width: 576px) {\n  .list-group-horizontal-sm {\n    -ms-flex-direction: row;\n        flex-direction: row;\n  }\n  .list-group-horizontal-sm > .list-group-item:first-child {\n    border-bottom-left-radius: 0.3125rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item:last-child {\n    border-top-right-radius: 0.3125rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item {\n    border-top-width: 0.0625rem;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-sm > .list-group-item + .list-group-item.active {\n    margin-left: -0.0625rem;\n    border-left-width: 0.0625rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .list-group-horizontal-md {\n    -ms-flex-direction: row;\n        flex-direction: row;\n  }\n  .list-group-horizontal-md > .list-group-item:first-child {\n    border-bottom-left-radius: 0.3125rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item:last-child {\n    border-top-right-radius: 0.3125rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-md > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item {\n    border-top-width: 0.0625rem;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-md > .list-group-item + .list-group-item.active {\n    margin-left: -0.0625rem;\n    border-left-width: 0.0625rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .list-group-horizontal-lg {\n    -ms-flex-direction: row;\n        flex-direction: row;\n  }\n  .list-group-horizontal-lg > .list-group-item:first-child {\n    border-bottom-left-radius: 0.3125rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item:last-child {\n    border-top-right-radius: 0.3125rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item {\n    border-top-width: 0.0625rem;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-lg > .list-group-item + .list-group-item.active {\n    margin-left: -0.0625rem;\n    border-left-width: 0.0625rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .list-group-horizontal-xl {\n    -ms-flex-direction: row;\n        flex-direction: row;\n  }\n  .list-group-horizontal-xl > .list-group-item:first-child {\n    border-bottom-left-radius: 0.3125rem;\n    border-top-right-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item:last-child {\n    border-top-right-radius: 0.3125rem;\n    border-bottom-left-radius: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item.active {\n    margin-top: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item {\n    border-top-width: 0.0625rem;\n    border-left-width: 0;\n  }\n  .list-group-horizontal-xl > .list-group-item + .list-group-item.active {\n    margin-left: -0.0625rem;\n    border-left-width: 0.0625rem;\n  }\n}\n\n.list-group-flush {\n  border-radius: 0;\n}\n\n.list-group-flush > .list-group-item {\n  border-width: 0 0 0.0625rem;\n}\n\n.list-group-flush > .list-group-item:last-child {\n  border-bottom-width: 0;\n}\n\n.list-group-item-primary {\n  color: #1d4185;\n  background-color: #c7dbff;\n}\n\n.list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {\n  color: #1d4185;\n  background-color: #aecbff;\n}\n\n.list-group-item-primary.list-group-item-action.active {\n  color: #fff;\n  background-color: #1d4185;\n  border-color: #1d4185;\n}\n\n.list-group-item-secondary {\n  color: #3b4652;\n  background-color: #d7dde4;\n}\n\n.list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {\n  color: #3b4652;\n  background-color: #c8d0da;\n}\n\n.list-group-item-secondary.list-group-item-action.active {\n  color: #fff;\n  background-color: #3b4652;\n  border-color: #3b4652;\n}\n\n.list-group-item-success {\n  color: #006957;\n  background-color: #b8f0e6;\n}\n\n.list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {\n  color: #006957;\n  background-color: #a3ecdf;\n}\n\n.list-group-item-success.list-group-item-action.active {\n  color: #fff;\n  background-color: #006957;\n  border-color: #006957;\n}\n\n.list-group-item-info {\n  color: #055663;\n  background-color: #bae6ed;\n}\n\n.list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {\n  color: #055663;\n  background-color: #a6dfe8;\n}\n\n.list-group-item-info.list-group-item-action.active {\n  color: #fff;\n  background-color: #055663;\n  border-color: #055663;\n}\n\n.list-group-item-warning {\n  color: #7f6950;\n  background-color: #fcf0e2;\n}\n\n.list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {\n  color: #7f6950;\n  background-color: #fae4cb;\n}\n\n.list-group-item-warning.list-group-item-action.active {\n  color: #fff;\n  background-color: #7f6950;\n  border-color: #7f6950;\n}\n\n.list-group-item-danger {\n  color: #7b283e;\n  background-color: #facdd9;\n}\n\n.list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {\n  color: #7b283e;\n  background-color: #f8b6c7;\n}\n\n.list-group-item-danger.list-group-item-action.active {\n  color: #fff;\n  background-color: #7b283e;\n  border-color: #7b283e;\n}\n\n.list-group-item-light {\n  color: #808285;\n  background-color: #fdfeff;\n}\n\n.list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {\n  color: #808285;\n  background-color: #e4f1ff;\n}\n\n.list-group-item-light.list-group-item-action.active {\n  color: #fff;\n  background-color: #808285;\n  border-color: #808285;\n}\n\n.list-group-item-dark {\n  color: #111a2f;\n  background-color: #c1c6d1;\n}\n\n.list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {\n  color: #111a2f;\n  background-color: #b2b9c6;\n}\n\n.list-group-item-dark.list-group-item-action.active {\n  color: #fff;\n  background-color: #111a2f;\n  border-color: #111a2f;\n}\n\n.list-group-item-indigo {\n  color: #170b44;\n  background-color: #c4bddc;\n}\n\n.list-group-item-indigo.list-group-item-action:hover, .list-group-item-indigo.list-group-item-action:focus {\n  color: #170b44;\n  background-color: #b5acd3;\n}\n\n.list-group-item-indigo.list-group-item-action.active {\n  color: #fff;\n  background-color: #170b44;\n  border-color: #170b44;\n}\n\n.close {\n  float: right;\n  font-size: 1.25rem;\n  font-weight: 600;\n  line-height: 1;\n  color: #1e2022;\n  text-shadow: 0 1px 0 #fff;\n  opacity: .5;\n}\n\n.close:hover {\n  color: #1e2022;\n  text-decoration: none;\n}\n\n.close:not(:disabled):not(.disabled):hover, .close:not(:disabled):not(.disabled):focus {\n  opacity: .75;\n}\n\nbutton.close {\n  padding: 0;\n  background-color: transparent;\n  border: 0;\n}\n\na.close.disabled {\n  pointer-events: none;\n}\n\n.toast {\n  -ms-flex-preferred-size: 350px;\n      flex-basis: 350px;\n  max-width: 350px;\n  font-size: 0.875rem;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border: 1px solid rgba(0, 0, 0, 0.1);\n  box-shadow: 0 0.25rem 0.75rem rgba(0, 0, 0, 0.1);\n  opacity: 0;\n  border-radius: 0.25rem;\n}\n\n.toast:not(:last-child) {\n  margin-bottom: 0.75rem;\n}\n\n.toast.showing {\n  opacity: 1;\n}\n\n.toast.show {\n  display: block;\n  opacity: 1;\n}\n\n.toast.hide {\n  display: none;\n}\n\n.toast-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  padding: 0.25rem 0.75rem;\n  color: #8c98a4;\n  background-color: rgba(255, 255, 255, 0.85);\n  background-clip: padding-box;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n  border-top-left-radius: calc(0.25rem - 1px);\n  border-top-right-radius: calc(0.25rem - 1px);\n}\n\n.toast-body {\n  padding: 0.75rem;\n}\n\n.modal-open {\n  overflow: hidden;\n}\n\n.modal-open .modal {\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.modal {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1005;\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  outline: 0;\n}\n\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: 0.5rem;\n  pointer-events: none;\n}\n\n.modal.fade .modal-dialog {\n  transition: -webkit-transform 0.3s ease-out;\n  transition: transform 0.3s ease-out;\n  transition: transform 0.3s ease-out, -webkit-transform 0.3s ease-out;\n  -webkit-transform: translate(0, -50px);\n          transform: translate(0, -50px);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .modal.fade .modal-dialog {\n    transition: none;\n  }\n}\n\n.modal.show .modal-dialog {\n  -webkit-transform: none;\n          transform: none;\n}\n\n.modal.modal-static .modal-dialog {\n  -webkit-transform: scale(1.02);\n          transform: scale(1.02);\n}\n\n.modal-dialog-scrollable {\n  display: -ms-flexbox;\n  display: flex;\n  max-height: calc(100% - 1rem);\n}\n\n.modal-dialog-scrollable .modal-content {\n  max-height: calc(100vh - 1rem);\n  overflow: hidden;\n}\n\n.modal-dialog-scrollable .modal-header,\n.modal-dialog-scrollable .modal-footer {\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n}\n\n.modal-dialog-scrollable .modal-body {\n  overflow-y: auto;\n}\n\n.modal-dialog-centered {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  min-height: calc(100% - 1rem);\n}\n\n.modal-dialog-centered::before {\n  display: block;\n  height: calc(100vh - 1rem);\n  height: -webkit-min-content;\n  height: -moz-min-content;\n  height: min-content;\n  content: \"\";\n}\n\n.modal-dialog-centered.modal-dialog-scrollable {\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-pack: center;\n      justify-content: center;\n  height: 100%;\n}\n\n.modal-dialog-centered.modal-dialog-scrollable .modal-content {\n  max-height: none;\n}\n\n.modal-dialog-centered.modal-dialog-scrollable::before {\n  content: none;\n}\n\n.modal-content {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  width: 100%;\n  pointer-events: auto;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0.0625rem solid transparent;\n  border-radius: 0.75rem;\n  outline: 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1004;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(33, 50, 91, 0.125);\n}\n\n.modal-backdrop.fade {\n  opacity: 0;\n}\n\n.modal-backdrop.show {\n  opacity: 1;\n}\n\n.modal-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: start;\n      align-items: flex-start;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding: 1rem 1.5rem;\n  border-bottom: 0.0625rem solid #e7eaf3;\n  border-top-left-radius: 0.6875rem;\n  border-top-right-radius: 0.6875rem;\n}\n\n.modal-header .close {\n  padding: 1rem 1.5rem;\n  margin: -1rem -1.5rem -1rem auto;\n}\n\n.modal-title {\n  margin-bottom: 0;\n  line-height: 1.6;\n}\n\n.modal-body {\n  position: relative;\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n  padding: 1.5rem;\n}\n\n.modal-footer {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  padding: 1.25rem;\n  border-top: 0.0625rem solid #e7eaf3;\n  border-bottom-right-radius: 0.6875rem;\n  border-bottom-left-radius: 0.6875rem;\n}\n\n.modal-footer > * {\n  margin: 0.25rem;\n}\n\n.modal-scrollbar-measure {\n  position: absolute;\n  top: -9999px;\n  width: 50px;\n  height: 50px;\n  overflow: scroll;\n}\n\n@media (min-width: 576px) {\n  .modal-dialog {\n    max-width: 550px;\n    margin: 1.75rem auto;\n  }\n  .modal-dialog-scrollable {\n    max-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-scrollable .modal-content {\n    max-height: calc(100vh - 3.5rem);\n  }\n  .modal-dialog-centered {\n    min-height: calc(100% - 3.5rem);\n  }\n  .modal-dialog-centered::before {\n    height: calc(100vh - 3.5rem);\n    height: -webkit-min-content;\n    height: -moz-min-content;\n    height: min-content;\n  }\n  .modal-sm {\n    max-width: 400px;\n  }\n}\n\n@media (min-width: 992px) {\n  .modal-lg,\n  .modal-xl {\n    max-width: 800px;\n  }\n}\n\n@media (min-width: 1200px) {\n  .modal-xl {\n    max-width: 1140px;\n  }\n}\n\n.tooltip {\n  position: absolute;\n  z-index: 9999;\n  display: block;\n  margin: 0;\n  font-family: \"Open Sans\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.6;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  opacity: 0;\n}\n\n.tooltip.show {\n  opacity: 1;\n}\n\n.tooltip .arrow {\n  position: absolute;\n  display: block;\n  width: 0.8rem;\n  height: 0.4rem;\n}\n\n.tooltip .arrow::before {\n  position: absolute;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-tooltip-top, .bs-tooltip-auto[x-placement^=\"top\"] {\n  padding: 0.4rem 0;\n}\n\n.bs-tooltip-top .arrow, .bs-tooltip-auto[x-placement^=\"top\"] .arrow {\n  bottom: 0;\n}\n\n.bs-tooltip-top .arrow::before, .bs-tooltip-auto[x-placement^=\"top\"] .arrow::before {\n  top: 0;\n  border-width: 0.4rem 0.4rem 0;\n  border-top-color: #21325b;\n}\n\n.bs-tooltip-right, .bs-tooltip-auto[x-placement^=\"right\"] {\n  padding: 0 0.4rem;\n}\n\n.bs-tooltip-right .arrow, .bs-tooltip-auto[x-placement^=\"right\"] .arrow {\n  left: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n\n.bs-tooltip-right .arrow::before, .bs-tooltip-auto[x-placement^=\"right\"] .arrow::before {\n  right: 0;\n  border-width: 0.4rem 0.4rem 0.4rem 0;\n  border-right-color: #21325b;\n}\n\n.bs-tooltip-bottom, .bs-tooltip-auto[x-placement^=\"bottom\"] {\n  padding: 0.4rem 0;\n}\n\n.bs-tooltip-bottom .arrow, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow {\n  top: 0;\n}\n\n.bs-tooltip-bottom .arrow::before, .bs-tooltip-auto[x-placement^=\"bottom\"] .arrow::before {\n  bottom: 0;\n  border-width: 0 0.4rem 0.4rem;\n  border-bottom-color: #21325b;\n}\n\n.bs-tooltip-left, .bs-tooltip-auto[x-placement^=\"left\"] {\n  padding: 0 0.4rem;\n}\n\n.bs-tooltip-left .arrow, .bs-tooltip-auto[x-placement^=\"left\"] .arrow {\n  right: 0;\n  width: 0.4rem;\n  height: 0.8rem;\n}\n\n.bs-tooltip-left .arrow::before, .bs-tooltip-auto[x-placement^=\"left\"] .arrow::before {\n  left: 0;\n  border-width: 0.4rem 0 0.4rem 0.4rem;\n  border-left-color: #21325b;\n}\n\n.tooltip-inner {\n  max-width: 200px;\n  padding: 0.25rem 0.5rem;\n  color: #fff;\n  text-align: center;\n  background-color: #21325b;\n  border-radius: 0.3125rem;\n}\n\n.popover {\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 1060;\n  display: block;\n  max-width: 276px;\n  font-family: \"Open Sans\", sans-serif;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 1.6;\n  text-align: left;\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  word-spacing: normal;\n  white-space: normal;\n  line-break: auto;\n  font-size: 0.875rem;\n  word-wrap: break-word;\n  background-color: #fff;\n  background-clip: padding-box;\n  border: 0.0625rem solid transparent;\n  border-radius: 0.75rem;\n}\n\n.popover .arrow {\n  position: absolute;\n  display: block;\n  width: 1rem;\n  height: 0.5rem;\n  margin: 0 0.75rem;\n}\n\n.popover .arrow::before, .popover .arrow::after {\n  position: absolute;\n  display: block;\n  content: \"\";\n  border-color: transparent;\n  border-style: solid;\n}\n\n.bs-popover-top, .bs-popover-auto[x-placement^=\"top\"] {\n  margin-bottom: 0.5rem;\n}\n\n.bs-popover-top > .arrow, .bs-popover-auto[x-placement^=\"top\"] > .arrow {\n  bottom: -0.5625rem;\n}\n\n.bs-popover-top > .arrow::before, .bs-popover-auto[x-placement^=\"top\"] > .arrow::before {\n  bottom: 0;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: rgba(0, 0, 0, 0.05);\n}\n\n.bs-popover-top > .arrow::after, .bs-popover-auto[x-placement^=\"top\"] > .arrow::after {\n  bottom: 0.0625rem;\n  border-width: 0.5rem 0.5rem 0;\n  border-top-color: #fff;\n}\n\n.bs-popover-right, .bs-popover-auto[x-placement^=\"right\"] {\n  margin-left: 0.5rem;\n}\n\n.bs-popover-right > .arrow, .bs-popover-auto[x-placement^=\"right\"] > .arrow {\n  left: -0.5625rem;\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.75rem 0;\n}\n\n.bs-popover-right > .arrow::before, .bs-popover-auto[x-placement^=\"right\"] > .arrow::before {\n  left: 0;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: rgba(0, 0, 0, 0.05);\n}\n\n.bs-popover-right > .arrow::after, .bs-popover-auto[x-placement^=\"right\"] > .arrow::after {\n  left: 0.0625rem;\n  border-width: 0.5rem 0.5rem 0.5rem 0;\n  border-right-color: #fff;\n}\n\n.bs-popover-bottom, .bs-popover-auto[x-placement^=\"bottom\"] {\n  margin-top: 0.5rem;\n}\n\n.bs-popover-bottom > .arrow, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow {\n  top: -0.5625rem;\n}\n\n.bs-popover-bottom > .arrow::before, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow::before {\n  top: 0;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: rgba(0, 0, 0, 0.05);\n}\n\n.bs-popover-bottom > .arrow::after, .bs-popover-auto[x-placement^=\"bottom\"] > .arrow::after {\n  top: 0.0625rem;\n  border-width: 0 0.5rem 0.5rem 0.5rem;\n  border-bottom-color: #fff;\n}\n\n.bs-popover-bottom .popover-header::before, .bs-popover-auto[x-placement^=\"bottom\"] .popover-header::before {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  display: block;\n  width: 1rem;\n  margin-left: -0.5rem;\n  content: \"\";\n  border-bottom: 0.0625rem solid #f8fafd;\n}\n\n.bs-popover-left, .bs-popover-auto[x-placement^=\"left\"] {\n  margin-right: 0.5rem;\n}\n\n.bs-popover-left > .arrow, .bs-popover-auto[x-placement^=\"left\"] > .arrow {\n  right: -0.5625rem;\n  width: 0.5rem;\n  height: 1rem;\n  margin: 0.75rem 0;\n}\n\n.bs-popover-left > .arrow::before, .bs-popover-auto[x-placement^=\"left\"] > .arrow::before {\n  right: 0;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: rgba(0, 0, 0, 0.05);\n}\n\n.bs-popover-left > .arrow::after, .bs-popover-auto[x-placement^=\"left\"] > .arrow::after {\n  right: 0.0625rem;\n  border-width: 0.5rem 0 0.5rem 0.5rem;\n  border-left-color: #fff;\n}\n\n.popover-header {\n  padding: 0.75rem 1rem;\n  margin-bottom: 0;\n  font-size: 1rem;\n  color: #1e2022;\n  background-color: #f8fafd;\n  border-bottom: 0.0625rem solid #e4ecf7;\n  border-top-left-radius: 0.6875rem;\n  border-top-right-radius: 0.6875rem;\n}\n\n.popover-header:empty {\n  display: none;\n}\n\n.popover-body {\n  padding: 1.125rem 1rem;\n  color: #677788;\n}\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  -ms-touch-action: pan-y;\n      touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n}\n\n.carousel-inner::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  transition: -webkit-transform 0.6s ease-in-out;\n  transition: transform 0.6s ease-in-out;\n  transition: transform 0.6s ease-in-out, -webkit-transform 0.6s ease-in-out;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-item {\n    transition: none;\n  }\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-left),\n.active.carousel-item-right {\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-right),\n.active.carousel-item-left {\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n\n.carousel-fade .carousel-item {\n  opacity: 0;\n  transition-property: opacity;\n  -webkit-transform: none;\n          transform: none;\n}\n\n.carousel-fade .carousel-item.active,\n.carousel-fade .carousel-item-next.carousel-item-left,\n.carousel-fade .carousel-item-prev.carousel-item-right {\n  z-index: 1;\n  opacity: 1;\n}\n\n.carousel-fade .active.carousel-item-left,\n.carousel-fade .active.carousel-item-right {\n  z-index: 0;\n  opacity: 0;\n  transition: opacity 0s 0.6s;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-fade .active.carousel-item-left,\n  .carousel-fade .active.carousel-item-right {\n    transition: none;\n  }\n}\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  width: 15%;\n  color: #fff;\n  text-align: center;\n  opacity: 0.5;\n  transition: opacity 0.15s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-control-prev,\n  .carousel-control-next {\n    transition: none;\n  }\n}\n\n.carousel-control-prev:hover, .carousel-control-prev:focus,\n.carousel-control-next:hover,\n.carousel-control-next:focus {\n  color: #fff;\n  text-decoration: none;\n  outline: 0;\n  opacity: 0.9;\n}\n\n.carousel-control-prev {\n  left: 0;\n}\n\n.carousel-control-next {\n  right: 0;\n}\n\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  background: no-repeat 50% / 100% 100%;\n}\n\n.carousel-control-prev-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M5.25 0l-4 4 4 4 1.5-1.5L4.25 4l2.5-2.5L5.25 0z'/%3e%3c/svg%3e\");\n}\n\n.carousel-control-next-icon {\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e\");\n}\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 15;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  padding-left: 0;\n  margin-right: 15%;\n  margin-left: 15%;\n  list-style: none;\n}\n\n.carousel-indicators li {\n  box-sizing: content-box;\n  -ms-flex: 0 1 auto;\n      flex: 0 1 auto;\n  width: 30px;\n  height: 3px;\n  margin-right: 3px;\n  margin-left: 3px;\n  text-indent: -999px;\n  cursor: pointer;\n  background-color: #fff;\n  background-clip: padding-box;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  opacity: .5;\n  transition: opacity 0.6s ease;\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .carousel-indicators li {\n    transition: none;\n  }\n}\n\n.carousel-indicators .active {\n  opacity: 1;\n}\n\n.carousel-caption {\n  position: absolute;\n  right: 15%;\n  bottom: 20px;\n  left: 15%;\n  z-index: 10;\n  padding-top: 20px;\n  padding-bottom: 20px;\n  color: #fff;\n  text-align: center;\n}\n\n@-webkit-keyframes spinner-border {\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n@keyframes spinner-border {\n  to {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n.spinner-border {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  border: 0.25em solid currentColor;\n  border-right-color: transparent;\n  border-radius: 50%;\n  -webkit-animation: spinner-border .75s linear infinite;\n          animation: spinner-border .75s linear infinite;\n}\n\n.spinner-border-sm {\n  width: 1rem;\n  height: 1rem;\n  border-width: 0.2em;\n}\n\n@-webkit-keyframes spinner-grow {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n  }\n}\n\n@keyframes spinner-grow {\n  0% {\n    -webkit-transform: scale(0);\n            transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n  }\n}\n\n.spinner-grow {\n  display: inline-block;\n  width: 2rem;\n  height: 2rem;\n  vertical-align: text-bottom;\n  background-color: currentColor;\n  border-radius: 50%;\n  opacity: 0;\n  -webkit-animation: spinner-grow .75s linear infinite;\n          animation: spinner-grow .75s linear infinite;\n}\n\n.spinner-grow-sm {\n  width: 1rem;\n  height: 1rem;\n}\n\n.align-baseline {\n  vertical-align: baseline !important;\n}\n\n.align-top {\n  vertical-align: top !important;\n}\n\n.align-middle {\n  vertical-align: middle !important;\n}\n\n.align-bottom {\n  vertical-align: bottom !important;\n}\n\n.align-text-bottom {\n  vertical-align: text-bottom !important;\n}\n\n.align-text-top {\n  vertical-align: text-top !important;\n}\n\n.bg-primary {\n  background-color: #377dff !important;\n}\n\na.bg-primary:hover, a.bg-primary:focus,\nbutton.bg-primary:hover,\nbutton.bg-primary:focus {\n  background-color: #045cff !important;\n}\n\n.bg-secondary {\n  background-color: #71869d !important;\n}\n\na.bg-secondary:hover, a.bg-secondary:focus,\nbutton.bg-secondary:hover,\nbutton.bg-secondary:focus {\n  background-color: #596d82 !important;\n}\n\n.bg-success {\n  background-color: #00c9a7 !important;\n}\n\na.bg-success:hover, a.bg-success:focus,\nbutton.bg-success:hover,\nbutton.bg-success:focus {\n  background-color: #00967d !important;\n}\n\n.bg-info {\n  background-color: #09a5be !important;\n}\n\na.bg-info:hover, a.bg-info:focus,\nbutton.bg-info:hover,\nbutton.bg-info:focus {\n  background-color: #077b8d !important;\n}\n\n.bg-warning {\n  background-color: #f5ca99 !important;\n}\n\na.bg-warning:hover, a.bg-warning:focus,\nbutton.bg-warning:hover,\nbutton.bg-warning:focus {\n  background-color: #f0b26b !important;\n}\n\n.bg-danger {\n  background-color: #ed4c78 !important;\n}\n\na.bg-danger:hover, a.bg-danger:focus,\nbutton.bg-danger:hover,\nbutton.bg-danger:focus {\n  background-color: #e81e55 !important;\n}\n\n.bg-light {\n  background-color: #f7faff !important;\n}\n\na.bg-light:hover, a.bg-light:focus,\nbutton.bg-light:hover,\nbutton.bg-light:focus {\n  background-color: #c4daff !important;\n}\n\n.bg-dark {\n  background-color: #21325b !important;\n}\n\na.bg-dark:hover, a.bg-dark:focus,\nbutton.bg-dark:hover,\nbutton.bg-dark:focus {\n  background-color: #131d36 !important;\n}\n\n.bg-indigo {\n  background-color: #2d1582 !important;\n}\n\na.bg-indigo:hover, a.bg-indigo:focus,\nbutton.bg-indigo:hover,\nbutton.bg-indigo:focus {\n  background-color: #1e0e56 !important;\n}\n\n.bg-white {\n  background-color: #fff !important;\n}\n\n.bg-transparent {\n  background-color: transparent !important;\n}\n\n.border {\n  border: 0.0625rem solid #e7eaf3 !important;\n}\n\n.border-top {\n  border-top: 0.0625rem solid #e7eaf3 !important;\n}\n\n.border-right {\n  border-right: 0.0625rem solid #e7eaf3 !important;\n}\n\n.border-bottom {\n  border-bottom: 0.0625rem solid #e7eaf3 !important;\n}\n\n.border-left {\n  border-left: 0.0625rem solid #e7eaf3 !important;\n}\n\n.border-0 {\n  border: 0 !important;\n}\n\n.border-top-0 {\n  border-top: 0 !important;\n}\n\n.border-right-0 {\n  border-right: 0 !important;\n}\n\n.border-bottom-0 {\n  border-bottom: 0 !important;\n}\n\n.border-left-0 {\n  border-left: 0 !important;\n}\n\n.border-primary {\n  border-color: #377dff !important;\n}\n\n.border-secondary {\n  border-color: #71869d !important;\n}\n\n.border-success {\n  border-color: #00c9a7 !important;\n}\n\n.border-info {\n  border-color: #09a5be !important;\n}\n\n.border-warning {\n  border-color: #f5ca99 !important;\n}\n\n.border-danger {\n  border-color: #ed4c78 !important;\n}\n\n.border-light {\n  border-color: #f7faff !important;\n}\n\n.border-dark {\n  border-color: #21325b !important;\n}\n\n.border-indigo {\n  border-color: #2d1582 !important;\n}\n\n.border-white {\n  border-color: #fff !important;\n}\n\n.rounded-sm {\n  border-radius: 0.25rem !important;\n}\n\n.rounded {\n  border-radius: 0.3125rem !important;\n}\n\n.rounded-top {\n  border-top-left-radius: 0.3125rem !important;\n  border-top-right-radius: 0.3125rem !important;\n}\n\n.rounded-right {\n  border-top-right-radius: 0.3125rem !important;\n  border-bottom-right-radius: 0.3125rem !important;\n}\n\n.rounded-bottom {\n  border-bottom-right-radius: 0.3125rem !important;\n  border-bottom-left-radius: 0.3125rem !important;\n}\n\n.rounded-left {\n  border-top-left-radius: 0.3125rem !important;\n  border-bottom-left-radius: 0.3125rem !important;\n}\n\n.rounded-lg {\n  border-radius: 0.75rem !important;\n}\n\n.rounded-circle {\n  border-radius: 50% !important;\n}\n\n.rounded-pill {\n  border-radius: 50rem !important;\n}\n\n.rounded-0 {\n  border-radius: 0 !important;\n}\n\n.clearfix::after {\n  display: block;\n  clear: both;\n  content: \"\";\n}\n\n.d-none {\n  display: none !important;\n}\n\n.d-inline {\n  display: inline !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-table {\n  display: table !important;\n}\n\n.d-table-row {\n  display: table-row !important;\n}\n\n.d-table-cell {\n  display: table-cell !important;\n}\n\n.d-flex {\n  display: -ms-flexbox !important;\n  display: flex !important;\n}\n\n.d-inline-flex {\n  display: -ms-inline-flexbox !important;\n  display: inline-flex !important;\n}\n\n@media (min-width: 576px) {\n  .d-sm-none {\n    display: none !important;\n  }\n  .d-sm-inline {\n    display: inline !important;\n  }\n  .d-sm-inline-block {\n    display: inline-block !important;\n  }\n  .d-sm-block {\n    display: block !important;\n  }\n  .d-sm-table {\n    display: table !important;\n  }\n  .d-sm-table-row {\n    display: table-row !important;\n  }\n  .d-sm-table-cell {\n    display: table-cell !important;\n  }\n  .d-sm-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n  .d-sm-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .d-md-none {\n    display: none !important;\n  }\n  .d-md-inline {\n    display: inline !important;\n  }\n  .d-md-inline-block {\n    display: inline-block !important;\n  }\n  .d-md-block {\n    display: block !important;\n  }\n  .d-md-table {\n    display: table !important;\n  }\n  .d-md-table-row {\n    display: table-row !important;\n  }\n  .d-md-table-cell {\n    display: table-cell !important;\n  }\n  .d-md-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n  .d-md-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .d-lg-none {\n    display: none !important;\n  }\n  .d-lg-inline {\n    display: inline !important;\n  }\n  .d-lg-inline-block {\n    display: inline-block !important;\n  }\n  .d-lg-block {\n    display: block !important;\n  }\n  .d-lg-table {\n    display: table !important;\n  }\n  .d-lg-table-row {\n    display: table-row !important;\n  }\n  .d-lg-table-cell {\n    display: table-cell !important;\n  }\n  .d-lg-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n  .d-lg-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .d-xl-none {\n    display: none !important;\n  }\n  .d-xl-inline {\n    display: inline !important;\n  }\n  .d-xl-inline-block {\n    display: inline-block !important;\n  }\n  .d-xl-block {\n    display: block !important;\n  }\n  .d-xl-table {\n    display: table !important;\n  }\n  .d-xl-table-row {\n    display: table-row !important;\n  }\n  .d-xl-table-cell {\n    display: table-cell !important;\n  }\n  .d-xl-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n  .d-xl-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n}\n\n@media print {\n  .d-print-none {\n    display: none !important;\n  }\n  .d-print-inline {\n    display: inline !important;\n  }\n  .d-print-inline-block {\n    display: inline-block !important;\n  }\n  .d-print-block {\n    display: block !important;\n  }\n  .d-print-table {\n    display: table !important;\n  }\n  .d-print-table-row {\n    display: table-row !important;\n  }\n  .d-print-table-cell {\n    display: table-cell !important;\n  }\n  .d-print-flex {\n    display: -ms-flexbox !important;\n    display: flex !important;\n  }\n  .d-print-inline-flex {\n    display: -ms-inline-flexbox !important;\n    display: inline-flex !important;\n  }\n}\n\n.embed-responsive {\n  position: relative;\n  display: block;\n  width: 100%;\n  padding: 0;\n  overflow: hidden;\n}\n\n.embed-responsive::before {\n  display: block;\n  content: \"\";\n}\n\n.embed-responsive .embed-responsive-item,\n.embed-responsive iframe,\n.embed-responsive embed,\n.embed-responsive object,\n.embed-responsive video {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border: 0;\n}\n\n.embed-responsive-21by9::before {\n  padding-top: 42.85714%;\n}\n\n.embed-responsive-16by9::before {\n  padding-top: 56.25%;\n}\n\n.embed-responsive-4by3::before {\n  padding-top: 75%;\n}\n\n.embed-responsive-1by1::before {\n  padding-top: 100%;\n}\n\n.flex-row {\n  -ms-flex-direction: row !important;\n      flex-direction: row !important;\n}\n\n.flex-column {\n  -ms-flex-direction: column !important;\n      flex-direction: column !important;\n}\n\n.flex-row-reverse {\n  -ms-flex-direction: row-reverse !important;\n      flex-direction: row-reverse !important;\n}\n\n.flex-column-reverse {\n  -ms-flex-direction: column-reverse !important;\n      flex-direction: column-reverse !important;\n}\n\n.flex-wrap {\n  -ms-flex-wrap: wrap !important;\n      flex-wrap: wrap !important;\n}\n\n.flex-nowrap {\n  -ms-flex-wrap: nowrap !important;\n      flex-wrap: nowrap !important;\n}\n\n.flex-wrap-reverse {\n  -ms-flex-wrap: wrap-reverse !important;\n      flex-wrap: wrap-reverse !important;\n}\n\n.flex-fill {\n  -ms-flex: 1 1 auto !important;\n      flex: 1 1 auto !important;\n}\n\n.flex-grow-0 {\n  -ms-flex-positive: 0 !important;\n      flex-grow: 0 !important;\n}\n\n.flex-grow-1 {\n  -ms-flex-positive: 1 !important;\n      flex-grow: 1 !important;\n}\n\n.flex-shrink-0 {\n  -ms-flex-negative: 0 !important;\n      flex-shrink: 0 !important;\n}\n\n.flex-shrink-1 {\n  -ms-flex-negative: 1 !important;\n      flex-shrink: 1 !important;\n}\n\n.justify-content-start {\n  -ms-flex-pack: start !important;\n      justify-content: flex-start !important;\n}\n\n.justify-content-end {\n  -ms-flex-pack: end !important;\n      justify-content: flex-end !important;\n}\n\n.justify-content-center {\n  -ms-flex-pack: center !important;\n      justify-content: center !important;\n}\n\n.justify-content-between {\n  -ms-flex-pack: justify !important;\n      justify-content: space-between !important;\n}\n\n.justify-content-around {\n  -ms-flex-pack: distribute !important;\n      justify-content: space-around !important;\n}\n\n.align-items-start {\n  -ms-flex-align: start !important;\n      align-items: flex-start !important;\n}\n\n.align-items-end {\n  -ms-flex-align: end !important;\n      align-items: flex-end !important;\n}\n\n.align-items-center {\n  -ms-flex-align: center !important;\n      align-items: center !important;\n}\n\n.align-items-baseline {\n  -ms-flex-align: baseline !important;\n      align-items: baseline !important;\n}\n\n.align-items-stretch {\n  -ms-flex-align: stretch !important;\n      align-items: stretch !important;\n}\n\n.align-content-start {\n  -ms-flex-line-pack: start !important;\n      align-content: flex-start !important;\n}\n\n.align-content-end {\n  -ms-flex-line-pack: end !important;\n      align-content: flex-end !important;\n}\n\n.align-content-center {\n  -ms-flex-line-pack: center !important;\n      align-content: center !important;\n}\n\n.align-content-between {\n  -ms-flex-line-pack: justify !important;\n      align-content: space-between !important;\n}\n\n.align-content-around {\n  -ms-flex-line-pack: distribute !important;\n      align-content: space-around !important;\n}\n\n.align-content-stretch {\n  -ms-flex-line-pack: stretch !important;\n      align-content: stretch !important;\n}\n\n.align-self-auto {\n  -ms-flex-item-align: auto !important;\n      align-self: auto !important;\n}\n\n.align-self-start {\n  -ms-flex-item-align: start !important;\n      align-self: flex-start !important;\n}\n\n.align-self-end {\n  -ms-flex-item-align: end !important;\n      align-self: flex-end !important;\n}\n\n.align-self-center {\n  -ms-flex-item-align: center !important;\n      align-self: center !important;\n}\n\n.align-self-baseline {\n  -ms-flex-item-align: baseline !important;\n      align-self: baseline !important;\n}\n\n.align-self-stretch {\n  -ms-flex-item-align: stretch !important;\n      align-self: stretch !important;\n}\n\n@media (min-width: 576px) {\n  .flex-sm-row {\n    -ms-flex-direction: row !important;\n        flex-direction: row !important;\n  }\n  .flex-sm-column {\n    -ms-flex-direction: column !important;\n        flex-direction: column !important;\n  }\n  .flex-sm-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n        flex-direction: row-reverse !important;\n  }\n  .flex-sm-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n        flex-direction: column-reverse !important;\n  }\n  .flex-sm-wrap {\n    -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n  }\n  .flex-sm-nowrap {\n    -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n  }\n  .flex-sm-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n  }\n  .flex-sm-fill {\n    -ms-flex: 1 1 auto !important;\n        flex: 1 1 auto !important;\n  }\n  .flex-sm-grow-0 {\n    -ms-flex-positive: 0 !important;\n        flex-grow: 0 !important;\n  }\n  .flex-sm-grow-1 {\n    -ms-flex-positive: 1 !important;\n        flex-grow: 1 !important;\n  }\n  .flex-sm-shrink-0 {\n    -ms-flex-negative: 0 !important;\n        flex-shrink: 0 !important;\n  }\n  .flex-sm-shrink-1 {\n    -ms-flex-negative: 1 !important;\n        flex-shrink: 1 !important;\n  }\n  .justify-content-sm-start {\n    -ms-flex-pack: start !important;\n        justify-content: flex-start !important;\n  }\n  .justify-content-sm-end {\n    -ms-flex-pack: end !important;\n        justify-content: flex-end !important;\n  }\n  .justify-content-sm-center {\n    -ms-flex-pack: center !important;\n        justify-content: center !important;\n  }\n  .justify-content-sm-between {\n    -ms-flex-pack: justify !important;\n        justify-content: space-between !important;\n  }\n  .justify-content-sm-around {\n    -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n  }\n  .align-items-sm-start {\n    -ms-flex-align: start !important;\n        align-items: flex-start !important;\n  }\n  .align-items-sm-end {\n    -ms-flex-align: end !important;\n        align-items: flex-end !important;\n  }\n  .align-items-sm-center {\n    -ms-flex-align: center !important;\n        align-items: center !important;\n  }\n  .align-items-sm-baseline {\n    -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n  }\n  .align-items-sm-stretch {\n    -ms-flex-align: stretch !important;\n        align-items: stretch !important;\n  }\n  .align-content-sm-start {\n    -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n  }\n  .align-content-sm-end {\n    -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n  }\n  .align-content-sm-center {\n    -ms-flex-line-pack: center !important;\n        align-content: center !important;\n  }\n  .align-content-sm-between {\n    -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n  }\n  .align-content-sm-around {\n    -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n  }\n  .align-content-sm-stretch {\n    -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n  }\n  .align-self-sm-auto {\n    -ms-flex-item-align: auto !important;\n        align-self: auto !important;\n  }\n  .align-self-sm-start {\n    -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n  }\n  .align-self-sm-end {\n    -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n  }\n  .align-self-sm-center {\n    -ms-flex-item-align: center !important;\n        align-self: center !important;\n  }\n  .align-self-sm-baseline {\n    -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n  }\n  .align-self-sm-stretch {\n    -ms-flex-item-align: stretch !important;\n        align-self: stretch !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .flex-md-row {\n    -ms-flex-direction: row !important;\n        flex-direction: row !important;\n  }\n  .flex-md-column {\n    -ms-flex-direction: column !important;\n        flex-direction: column !important;\n  }\n  .flex-md-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n        flex-direction: row-reverse !important;\n  }\n  .flex-md-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n        flex-direction: column-reverse !important;\n  }\n  .flex-md-wrap {\n    -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n  }\n  .flex-md-nowrap {\n    -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n  }\n  .flex-md-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n  }\n  .flex-md-fill {\n    -ms-flex: 1 1 auto !important;\n        flex: 1 1 auto !important;\n  }\n  .flex-md-grow-0 {\n    -ms-flex-positive: 0 !important;\n        flex-grow: 0 !important;\n  }\n  .flex-md-grow-1 {\n    -ms-flex-positive: 1 !important;\n        flex-grow: 1 !important;\n  }\n  .flex-md-shrink-0 {\n    -ms-flex-negative: 0 !important;\n        flex-shrink: 0 !important;\n  }\n  .flex-md-shrink-1 {\n    -ms-flex-negative: 1 !important;\n        flex-shrink: 1 !important;\n  }\n  .justify-content-md-start {\n    -ms-flex-pack: start !important;\n        justify-content: flex-start !important;\n  }\n  .justify-content-md-end {\n    -ms-flex-pack: end !important;\n        justify-content: flex-end !important;\n  }\n  .justify-content-md-center {\n    -ms-flex-pack: center !important;\n        justify-content: center !important;\n  }\n  .justify-content-md-between {\n    -ms-flex-pack: justify !important;\n        justify-content: space-between !important;\n  }\n  .justify-content-md-around {\n    -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n  }\n  .align-items-md-start {\n    -ms-flex-align: start !important;\n        align-items: flex-start !important;\n  }\n  .align-items-md-end {\n    -ms-flex-align: end !important;\n        align-items: flex-end !important;\n  }\n  .align-items-md-center {\n    -ms-flex-align: center !important;\n        align-items: center !important;\n  }\n  .align-items-md-baseline {\n    -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n  }\n  .align-items-md-stretch {\n    -ms-flex-align: stretch !important;\n        align-items: stretch !important;\n  }\n  .align-content-md-start {\n    -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n  }\n  .align-content-md-end {\n    -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n  }\n  .align-content-md-center {\n    -ms-flex-line-pack: center !important;\n        align-content: center !important;\n  }\n  .align-content-md-between {\n    -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n  }\n  .align-content-md-around {\n    -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n  }\n  .align-content-md-stretch {\n    -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n  }\n  .align-self-md-auto {\n    -ms-flex-item-align: auto !important;\n        align-self: auto !important;\n  }\n  .align-self-md-start {\n    -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n  }\n  .align-self-md-end {\n    -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n  }\n  .align-self-md-center {\n    -ms-flex-item-align: center !important;\n        align-self: center !important;\n  }\n  .align-self-md-baseline {\n    -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n  }\n  .align-self-md-stretch {\n    -ms-flex-item-align: stretch !important;\n        align-self: stretch !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .flex-lg-row {\n    -ms-flex-direction: row !important;\n        flex-direction: row !important;\n  }\n  .flex-lg-column {\n    -ms-flex-direction: column !important;\n        flex-direction: column !important;\n  }\n  .flex-lg-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n        flex-direction: row-reverse !important;\n  }\n  .flex-lg-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n        flex-direction: column-reverse !important;\n  }\n  .flex-lg-wrap {\n    -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n  }\n  .flex-lg-nowrap {\n    -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n  }\n  .flex-lg-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n  }\n  .flex-lg-fill {\n    -ms-flex: 1 1 auto !important;\n        flex: 1 1 auto !important;\n  }\n  .flex-lg-grow-0 {\n    -ms-flex-positive: 0 !important;\n        flex-grow: 0 !important;\n  }\n  .flex-lg-grow-1 {\n    -ms-flex-positive: 1 !important;\n        flex-grow: 1 !important;\n  }\n  .flex-lg-shrink-0 {\n    -ms-flex-negative: 0 !important;\n        flex-shrink: 0 !important;\n  }\n  .flex-lg-shrink-1 {\n    -ms-flex-negative: 1 !important;\n        flex-shrink: 1 !important;\n  }\n  .justify-content-lg-start {\n    -ms-flex-pack: start !important;\n        justify-content: flex-start !important;\n  }\n  .justify-content-lg-end {\n    -ms-flex-pack: end !important;\n        justify-content: flex-end !important;\n  }\n  .justify-content-lg-center {\n    -ms-flex-pack: center !important;\n        justify-content: center !important;\n  }\n  .justify-content-lg-between {\n    -ms-flex-pack: justify !important;\n        justify-content: space-between !important;\n  }\n  .justify-content-lg-around {\n    -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n  }\n  .align-items-lg-start {\n    -ms-flex-align: start !important;\n        align-items: flex-start !important;\n  }\n  .align-items-lg-end {\n    -ms-flex-align: end !important;\n        align-items: flex-end !important;\n  }\n  .align-items-lg-center {\n    -ms-flex-align: center !important;\n        align-items: center !important;\n  }\n  .align-items-lg-baseline {\n    -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n  }\n  .align-items-lg-stretch {\n    -ms-flex-align: stretch !important;\n        align-items: stretch !important;\n  }\n  .align-content-lg-start {\n    -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n  }\n  .align-content-lg-end {\n    -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n  }\n  .align-content-lg-center {\n    -ms-flex-line-pack: center !important;\n        align-content: center !important;\n  }\n  .align-content-lg-between {\n    -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n  }\n  .align-content-lg-around {\n    -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n  }\n  .align-content-lg-stretch {\n    -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n  }\n  .align-self-lg-auto {\n    -ms-flex-item-align: auto !important;\n        align-self: auto !important;\n  }\n  .align-self-lg-start {\n    -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n  }\n  .align-self-lg-end {\n    -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n  }\n  .align-self-lg-center {\n    -ms-flex-item-align: center !important;\n        align-self: center !important;\n  }\n  .align-self-lg-baseline {\n    -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n  }\n  .align-self-lg-stretch {\n    -ms-flex-item-align: stretch !important;\n        align-self: stretch !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .flex-xl-row {\n    -ms-flex-direction: row !important;\n        flex-direction: row !important;\n  }\n  .flex-xl-column {\n    -ms-flex-direction: column !important;\n        flex-direction: column !important;\n  }\n  .flex-xl-row-reverse {\n    -ms-flex-direction: row-reverse !important;\n        flex-direction: row-reverse !important;\n  }\n  .flex-xl-column-reverse {\n    -ms-flex-direction: column-reverse !important;\n        flex-direction: column-reverse !important;\n  }\n  .flex-xl-wrap {\n    -ms-flex-wrap: wrap !important;\n        flex-wrap: wrap !important;\n  }\n  .flex-xl-nowrap {\n    -ms-flex-wrap: nowrap !important;\n        flex-wrap: nowrap !important;\n  }\n  .flex-xl-wrap-reverse {\n    -ms-flex-wrap: wrap-reverse !important;\n        flex-wrap: wrap-reverse !important;\n  }\n  .flex-xl-fill {\n    -ms-flex: 1 1 auto !important;\n        flex: 1 1 auto !important;\n  }\n  .flex-xl-grow-0 {\n    -ms-flex-positive: 0 !important;\n        flex-grow: 0 !important;\n  }\n  .flex-xl-grow-1 {\n    -ms-flex-positive: 1 !important;\n        flex-grow: 1 !important;\n  }\n  .flex-xl-shrink-0 {\n    -ms-flex-negative: 0 !important;\n        flex-shrink: 0 !important;\n  }\n  .flex-xl-shrink-1 {\n    -ms-flex-negative: 1 !important;\n        flex-shrink: 1 !important;\n  }\n  .justify-content-xl-start {\n    -ms-flex-pack: start !important;\n        justify-content: flex-start !important;\n  }\n  .justify-content-xl-end {\n    -ms-flex-pack: end !important;\n        justify-content: flex-end !important;\n  }\n  .justify-content-xl-center {\n    -ms-flex-pack: center !important;\n        justify-content: center !important;\n  }\n  .justify-content-xl-between {\n    -ms-flex-pack: justify !important;\n        justify-content: space-between !important;\n  }\n  .justify-content-xl-around {\n    -ms-flex-pack: distribute !important;\n        justify-content: space-around !important;\n  }\n  .align-items-xl-start {\n    -ms-flex-align: start !important;\n        align-items: flex-start !important;\n  }\n  .align-items-xl-end {\n    -ms-flex-align: end !important;\n        align-items: flex-end !important;\n  }\n  .align-items-xl-center {\n    -ms-flex-align: center !important;\n        align-items: center !important;\n  }\n  .align-items-xl-baseline {\n    -ms-flex-align: baseline !important;\n        align-items: baseline !important;\n  }\n  .align-items-xl-stretch {\n    -ms-flex-align: stretch !important;\n        align-items: stretch !important;\n  }\n  .align-content-xl-start {\n    -ms-flex-line-pack: start !important;\n        align-content: flex-start !important;\n  }\n  .align-content-xl-end {\n    -ms-flex-line-pack: end !important;\n        align-content: flex-end !important;\n  }\n  .align-content-xl-center {\n    -ms-flex-line-pack: center !important;\n        align-content: center !important;\n  }\n  .align-content-xl-between {\n    -ms-flex-line-pack: justify !important;\n        align-content: space-between !important;\n  }\n  .align-content-xl-around {\n    -ms-flex-line-pack: distribute !important;\n        align-content: space-around !important;\n  }\n  .align-content-xl-stretch {\n    -ms-flex-line-pack: stretch !important;\n        align-content: stretch !important;\n  }\n  .align-self-xl-auto {\n    -ms-flex-item-align: auto !important;\n        align-self: auto !important;\n  }\n  .align-self-xl-start {\n    -ms-flex-item-align: start !important;\n        align-self: flex-start !important;\n  }\n  .align-self-xl-end {\n    -ms-flex-item-align: end !important;\n        align-self: flex-end !important;\n  }\n  .align-self-xl-center {\n    -ms-flex-item-align: center !important;\n        align-self: center !important;\n  }\n  .align-self-xl-baseline {\n    -ms-flex-item-align: baseline !important;\n        align-self: baseline !important;\n  }\n  .align-self-xl-stretch {\n    -ms-flex-item-align: stretch !important;\n        align-self: stretch !important;\n  }\n}\n\n.float-left {\n  float: left !important;\n}\n\n.float-right {\n  float: right !important;\n}\n\n.float-none {\n  float: none !important;\n}\n\n@media (min-width: 576px) {\n  .float-sm-left {\n    float: left !important;\n  }\n  .float-sm-right {\n    float: right !important;\n  }\n  .float-sm-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .float-md-left {\n    float: left !important;\n  }\n  .float-md-right {\n    float: right !important;\n  }\n  .float-md-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .float-lg-left {\n    float: left !important;\n  }\n  .float-lg-right {\n    float: right !important;\n  }\n  .float-lg-none {\n    float: none !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .float-xl-left {\n    float: left !important;\n  }\n  .float-xl-right {\n    float: right !important;\n  }\n  .float-xl-none {\n    float: none !important;\n  }\n}\n\n.user-select-all {\n  -webkit-user-select: all !important;\n     -moz-user-select: all !important;\n      -ms-user-select: all !important;\n          user-select: all !important;\n}\n\n.user-select-auto {\n  -webkit-user-select: auto !important;\n     -moz-user-select: auto !important;\n      -ms-user-select: auto !important;\n          user-select: auto !important;\n}\n\n.user-select-none {\n  -webkit-user-select: none !important;\n     -moz-user-select: none !important;\n      -ms-user-select: none !important;\n          user-select: none !important;\n}\n\n.overflow-auto {\n  overflow: auto !important;\n}\n\n.overflow-hidden {\n  overflow: hidden !important;\n}\n\n.position-static {\n  position: static !important;\n}\n\n.position-relative {\n  position: relative !important;\n}\n\n.position-absolute {\n  position: absolute !important;\n}\n\n.position-fixed {\n  position: fixed !important;\n}\n\n.position-sticky {\n  position: -webkit-sticky !important;\n  position: sticky !important;\n}\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1030;\n}\n\n@supports ((position: -webkit-sticky) or (position: sticky)) {\n  .sticky-top {\n    position: -webkit-sticky;\n    position: sticky;\n    top: 0;\n    z-index: 1020;\n  }\n}\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  position: static;\n  width: auto;\n  height: auto;\n  overflow: visible;\n  clip: auto;\n  white-space: normal;\n}\n\n.shadow-sm {\n  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1) !important;\n}\n\n.shadow {\n  box-shadow: 0px 0.375rem 1.5rem 0px rgba(140, 152, 164, 0.125) !important;\n}\n\n.shadow-lg {\n  box-shadow: 0px 10px 40px 10px rgba(140, 152, 164, 0.175) !important;\n}\n\n.shadow-none {\n  box-shadow: none !important;\n}\n\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.w-15 {\n  width: 15% !important;\n}\n\n.w-20 {\n  width: 20% !important;\n}\n\n.w-30 {\n  width: 30% !important;\n}\n\n.w-35 {\n  width: 35% !important;\n}\n\n.w-40 {\n  width: 40% !important;\n}\n\n.w-60 {\n  width: 60% !important;\n}\n\n.w-65 {\n  width: 65% !important;\n}\n\n.w-80 {\n  width: 80% !important;\n}\n\n.w-85 {\n  width: 85% !important;\n}\n\n.w-90 {\n  width: 90% !important;\n}\n\n.h-25 {\n  height: 25% !important;\n}\n\n.h-50 {\n  height: 50% !important;\n}\n\n.h-75 {\n  height: 75% !important;\n}\n\n.h-100 {\n  height: 100% !important;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.h-15 {\n  height: 15% !important;\n}\n\n.h-20 {\n  height: 20% !important;\n}\n\n.h-30 {\n  height: 30% !important;\n}\n\n.h-35 {\n  height: 35% !important;\n}\n\n.h-40 {\n  height: 40% !important;\n}\n\n.h-60 {\n  height: 60% !important;\n}\n\n.h-65 {\n  height: 65% !important;\n}\n\n.h-80 {\n  height: 80% !important;\n}\n\n.h-85 {\n  height: 85% !important;\n}\n\n.h-90 {\n  height: 90% !important;\n}\n\n.mw-100 {\n  max-width: 100% !important;\n}\n\n.mh-100 {\n  max-height: 100% !important;\n}\n\n.min-vw-100 {\n  min-width: 100vw !important;\n}\n\n.min-vh-100 {\n  min-height: 100vh !important;\n}\n\n.vw-100 {\n  width: 100vw !important;\n}\n\n.vh-100 {\n  height: 100vh !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.mt-0,\n.my-0 {\n  margin-top: 0 !important;\n}\n\n.mr-0,\n.mx-0 {\n  margin-right: 0 !important;\n}\n\n.mb-0,\n.my-0 {\n  margin-bottom: 0 !important;\n}\n\n.ml-0,\n.mx-0 {\n  margin-left: 0 !important;\n}\n\n.m-1 {\n  margin: 0.25rem !important;\n}\n\n.mt-1,\n.my-1 {\n  margin-top: 0.25rem !important;\n}\n\n.mr-1,\n.mx-1 {\n  margin-right: 0.25rem !important;\n}\n\n.mb-1,\n.my-1 {\n  margin-bottom: 0.25rem !important;\n}\n\n.ml-1,\n.mx-1 {\n  margin-left: 0.25rem !important;\n}\n\n.m-2 {\n  margin: 0.5rem !important;\n}\n\n.mt-2,\n.my-2 {\n  margin-top: 0.5rem !important;\n}\n\n.mr-2,\n.mx-2 {\n  margin-right: 0.5rem !important;\n}\n\n.mb-2,\n.my-2 {\n  margin-bottom: 0.5rem !important;\n}\n\n.ml-2,\n.mx-2 {\n  margin-left: 0.5rem !important;\n}\n\n.m-3 {\n  margin: 1rem !important;\n}\n\n.mt-3,\n.my-3 {\n  margin-top: 1rem !important;\n}\n\n.mr-3,\n.mx-3 {\n  margin-right: 1rem !important;\n}\n\n.mb-3,\n.my-3 {\n  margin-bottom: 1rem !important;\n}\n\n.ml-3,\n.mx-3 {\n  margin-left: 1rem !important;\n}\n\n.m-4 {\n  margin: 1.5rem !important;\n}\n\n.mt-4,\n.my-4 {\n  margin-top: 1.5rem !important;\n}\n\n.mr-4,\n.mx-4 {\n  margin-right: 1.5rem !important;\n}\n\n.mb-4,\n.my-4 {\n  margin-bottom: 1.5rem !important;\n}\n\n.ml-4,\n.mx-4 {\n  margin-left: 1.5rem !important;\n}\n\n.m-5 {\n  margin: 2rem !important;\n}\n\n.mt-5,\n.my-5 {\n  margin-top: 2rem !important;\n}\n\n.mr-5,\n.mx-5 {\n  margin-right: 2rem !important;\n}\n\n.mb-5,\n.my-5 {\n  margin-bottom: 2rem !important;\n}\n\n.ml-5,\n.mx-5 {\n  margin-left: 2rem !important;\n}\n\n.m-6 {\n  margin: 2.5rem !important;\n}\n\n.mt-6,\n.my-6 {\n  margin-top: 2.5rem !important;\n}\n\n.mr-6,\n.mx-6 {\n  margin-right: 2.5rem !important;\n}\n\n.mb-6,\n.my-6 {\n  margin-bottom: 2.5rem !important;\n}\n\n.ml-6,\n.mx-6 {\n  margin-left: 2.5rem !important;\n}\n\n.m-7 {\n  margin: 3rem !important;\n}\n\n.mt-7,\n.my-7 {\n  margin-top: 3rem !important;\n}\n\n.mr-7,\n.mx-7 {\n  margin-right: 3rem !important;\n}\n\n.mb-7,\n.my-7 {\n  margin-bottom: 3rem !important;\n}\n\n.ml-7,\n.mx-7 {\n  margin-left: 3rem !important;\n}\n\n.m-8 {\n  margin: 3.5rem !important;\n}\n\n.mt-8,\n.my-8 {\n  margin-top: 3.5rem !important;\n}\n\n.mr-8,\n.mx-8 {\n  margin-right: 3.5rem !important;\n}\n\n.mb-8,\n.my-8 {\n  margin-bottom: 3.5rem !important;\n}\n\n.ml-8,\n.mx-8 {\n  margin-left: 3.5rem !important;\n}\n\n.m-9 {\n  margin: 4rem !important;\n}\n\n.mt-9,\n.my-9 {\n  margin-top: 4rem !important;\n}\n\n.mr-9,\n.mx-9 {\n  margin-right: 4rem !important;\n}\n\n.mb-9,\n.my-9 {\n  margin-bottom: 4rem !important;\n}\n\n.ml-9,\n.mx-9 {\n  margin-left: 4rem !important;\n}\n\n.m-10 {\n  margin: 4.5rem !important;\n}\n\n.mt-10,\n.my-10 {\n  margin-top: 4.5rem !important;\n}\n\n.mr-10,\n.mx-10 {\n  margin-right: 4.5rem !important;\n}\n\n.mb-10,\n.my-10 {\n  margin-bottom: 4.5rem !important;\n}\n\n.ml-10,\n.mx-10 {\n  margin-left: 4.5rem !important;\n}\n\n.m-11 {\n  margin: 5rem !important;\n}\n\n.mt-11,\n.my-11 {\n  margin-top: 5rem !important;\n}\n\n.mr-11,\n.mx-11 {\n  margin-right: 5rem !important;\n}\n\n.mb-11,\n.my-11 {\n  margin-bottom: 5rem !important;\n}\n\n.ml-11,\n.mx-11 {\n  margin-left: 5rem !important;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n\n.pt-0,\n.py-0 {\n  padding-top: 0 !important;\n}\n\n.pr-0,\n.px-0 {\n  padding-right: 0 !important;\n}\n\n.pb-0,\n.py-0 {\n  padding-bottom: 0 !important;\n}\n\n.pl-0,\n.px-0 {\n  padding-left: 0 !important;\n}\n\n.p-1 {\n  padding: 0.25rem !important;\n}\n\n.pt-1,\n.py-1 {\n  padding-top: 0.25rem !important;\n}\n\n.pr-1,\n.px-1 {\n  padding-right: 0.25rem !important;\n}\n\n.pb-1,\n.py-1 {\n  padding-bottom: 0.25rem !important;\n}\n\n.pl-1,\n.px-1 {\n  padding-left: 0.25rem !important;\n}\n\n.p-2 {\n  padding: 0.5rem !important;\n}\n\n.pt-2,\n.py-2 {\n  padding-top: 0.5rem !important;\n}\n\n.pr-2,\n.px-2 {\n  padding-right: 0.5rem !important;\n}\n\n.pb-2,\n.py-2 {\n  padding-bottom: 0.5rem !important;\n}\n\n.pl-2,\n.px-2 {\n  padding-left: 0.5rem !important;\n}\n\n.p-3 {\n  padding: 1rem !important;\n}\n\n.pt-3,\n.py-3 {\n  padding-top: 1rem !important;\n}\n\n.pr-3,\n.px-3 {\n  padding-right: 1rem !important;\n}\n\n.pb-3,\n.py-3 {\n  padding-bottom: 1rem !important;\n}\n\n.pl-3,\n.px-3 {\n  padding-left: 1rem !important;\n}\n\n.p-4 {\n  padding: 1.5rem !important;\n}\n\n.pt-4,\n.py-4 {\n  padding-top: 1.5rem !important;\n}\n\n.pr-4,\n.px-4 {\n  padding-right: 1.5rem !important;\n}\n\n.pb-4,\n.py-4 {\n  padding-bottom: 1.5rem !important;\n}\n\n.pl-4,\n.px-4 {\n  padding-left: 1.5rem !important;\n}\n\n.p-5 {\n  padding: 2rem !important;\n}\n\n.pt-5,\n.py-5 {\n  padding-top: 2rem !important;\n}\n\n.pr-5,\n.px-5 {\n  padding-right: 2rem !important;\n}\n\n.pb-5,\n.py-5 {\n  padding-bottom: 2rem !important;\n}\n\n.pl-5,\n.px-5 {\n  padding-left: 2rem !important;\n}\n\n.p-6 {\n  padding: 2.5rem !important;\n}\n\n.pt-6,\n.py-6 {\n  padding-top: 2.5rem !important;\n}\n\n.pr-6,\n.px-6 {\n  padding-right: 2.5rem !important;\n}\n\n.pb-6,\n.py-6 {\n  padding-bottom: 2.5rem !important;\n}\n\n.pl-6,\n.px-6 {\n  padding-left: 2.5rem !important;\n}\n\n.p-7 {\n  padding: 3rem !important;\n}\n\n.pt-7,\n.py-7 {\n  padding-top: 3rem !important;\n}\n\n.pr-7,\n.px-7 {\n  padding-right: 3rem !important;\n}\n\n.pb-7,\n.py-7 {\n  padding-bottom: 3rem !important;\n}\n\n.pl-7,\n.px-7 {\n  padding-left: 3rem !important;\n}\n\n.p-8 {\n  padding: 3.5rem !important;\n}\n\n.pt-8,\n.py-8 {\n  padding-top: 3.5rem !important;\n}\n\n.pr-8,\n.px-8 {\n  padding-right: 3.5rem !important;\n}\n\n.pb-8,\n.py-8 {\n  padding-bottom: 3.5rem !important;\n}\n\n.pl-8,\n.px-8 {\n  padding-left: 3.5rem !important;\n}\n\n.p-9 {\n  padding: 4rem !important;\n}\n\n.pt-9,\n.py-9 {\n  padding-top: 4rem !important;\n}\n\n.pr-9,\n.px-9 {\n  padding-right: 4rem !important;\n}\n\n.pb-9,\n.py-9 {\n  padding-bottom: 4rem !important;\n}\n\n.pl-9,\n.px-9 {\n  padding-left: 4rem !important;\n}\n\n.p-10 {\n  padding: 4.5rem !important;\n}\n\n.pt-10,\n.py-10 {\n  padding-top: 4.5rem !important;\n}\n\n.pr-10,\n.px-10 {\n  padding-right: 4.5rem !important;\n}\n\n.pb-10,\n.py-10 {\n  padding-bottom: 4.5rem !important;\n}\n\n.pl-10,\n.px-10 {\n  padding-left: 4.5rem !important;\n}\n\n.p-11 {\n  padding: 5rem !important;\n}\n\n.pt-11,\n.py-11 {\n  padding-top: 5rem !important;\n}\n\n.pr-11,\n.px-11 {\n  padding-right: 5rem !important;\n}\n\n.pb-11,\n.py-11 {\n  padding-bottom: 5rem !important;\n}\n\n.pl-11,\n.px-11 {\n  padding-left: 5rem !important;\n}\n\n.m-n1 {\n  margin: -0.25rem !important;\n}\n\n.mt-n1,\n.my-n1 {\n  margin-top: -0.25rem !important;\n}\n\n.mr-n1,\n.mx-n1 {\n  margin-right: -0.25rem !important;\n}\n\n.mb-n1,\n.my-n1 {\n  margin-bottom: -0.25rem !important;\n}\n\n.ml-n1,\n.mx-n1 {\n  margin-left: -0.25rem !important;\n}\n\n.m-n2 {\n  margin: -0.5rem !important;\n}\n\n.mt-n2,\n.my-n2 {\n  margin-top: -0.5rem !important;\n}\n\n.mr-n2,\n.mx-n2 {\n  margin-right: -0.5rem !important;\n}\n\n.mb-n2,\n.my-n2 {\n  margin-bottom: -0.5rem !important;\n}\n\n.ml-n2,\n.mx-n2 {\n  margin-left: -0.5rem !important;\n}\n\n.m-n3 {\n  margin: -1rem !important;\n}\n\n.mt-n3,\n.my-n3 {\n  margin-top: -1rem !important;\n}\n\n.mr-n3,\n.mx-n3 {\n  margin-right: -1rem !important;\n}\n\n.mb-n3,\n.my-n3 {\n  margin-bottom: -1rem !important;\n}\n\n.ml-n3,\n.mx-n3 {\n  margin-left: -1rem !important;\n}\n\n.m-n4 {\n  margin: -1.5rem !important;\n}\n\n.mt-n4,\n.my-n4 {\n  margin-top: -1.5rem !important;\n}\n\n.mr-n4,\n.mx-n4 {\n  margin-right: -1.5rem !important;\n}\n\n.mb-n4,\n.my-n4 {\n  margin-bottom: -1.5rem !important;\n}\n\n.ml-n4,\n.mx-n4 {\n  margin-left: -1.5rem !important;\n}\n\n.m-n5 {\n  margin: -2rem !important;\n}\n\n.mt-n5,\n.my-n5 {\n  margin-top: -2rem !important;\n}\n\n.mr-n5,\n.mx-n5 {\n  margin-right: -2rem !important;\n}\n\n.mb-n5,\n.my-n5 {\n  margin-bottom: -2rem !important;\n}\n\n.ml-n5,\n.mx-n5 {\n  margin-left: -2rem !important;\n}\n\n.m-n6 {\n  margin: -2.5rem !important;\n}\n\n.mt-n6,\n.my-n6 {\n  margin-top: -2.5rem !important;\n}\n\n.mr-n6,\n.mx-n6 {\n  margin-right: -2.5rem !important;\n}\n\n.mb-n6,\n.my-n6 {\n  margin-bottom: -2.5rem !important;\n}\n\n.ml-n6,\n.mx-n6 {\n  margin-left: -2.5rem !important;\n}\n\n.m-n7 {\n  margin: -3rem !important;\n}\n\n.mt-n7,\n.my-n7 {\n  margin-top: -3rem !important;\n}\n\n.mr-n7,\n.mx-n7 {\n  margin-right: -3rem !important;\n}\n\n.mb-n7,\n.my-n7 {\n  margin-bottom: -3rem !important;\n}\n\n.ml-n7,\n.mx-n7 {\n  margin-left: -3rem !important;\n}\n\n.m-n8 {\n  margin: -3.5rem !important;\n}\n\n.mt-n8,\n.my-n8 {\n  margin-top: -3.5rem !important;\n}\n\n.mr-n8,\n.mx-n8 {\n  margin-right: -3.5rem !important;\n}\n\n.mb-n8,\n.my-n8 {\n  margin-bottom: -3.5rem !important;\n}\n\n.ml-n8,\n.mx-n8 {\n  margin-left: -3.5rem !important;\n}\n\n.m-n9 {\n  margin: -4rem !important;\n}\n\n.mt-n9,\n.my-n9 {\n  margin-top: -4rem !important;\n}\n\n.mr-n9,\n.mx-n9 {\n  margin-right: -4rem !important;\n}\n\n.mb-n9,\n.my-n9 {\n  margin-bottom: -4rem !important;\n}\n\n.ml-n9,\n.mx-n9 {\n  margin-left: -4rem !important;\n}\n\n.m-n10 {\n  margin: -4.5rem !important;\n}\n\n.mt-n10,\n.my-n10 {\n  margin-top: -4.5rem !important;\n}\n\n.mr-n10,\n.mx-n10 {\n  margin-right: -4.5rem !important;\n}\n\n.mb-n10,\n.my-n10 {\n  margin-bottom: -4.5rem !important;\n}\n\n.ml-n10,\n.mx-n10 {\n  margin-left: -4.5rem !important;\n}\n\n.m-n11 {\n  margin: -5rem !important;\n}\n\n.mt-n11,\n.my-n11 {\n  margin-top: -5rem !important;\n}\n\n.mr-n11,\n.mx-n11 {\n  margin-right: -5rem !important;\n}\n\n.mb-n11,\n.my-n11 {\n  margin-bottom: -5rem !important;\n}\n\n.ml-n11,\n.mx-n11 {\n  margin-left: -5rem !important;\n}\n\n.m-auto {\n  margin: auto !important;\n}\n\n.mt-auto,\n.my-auto {\n  margin-top: auto !important;\n}\n\n.mr-auto,\n.mx-auto {\n  margin-right: auto !important;\n}\n\n.mb-auto,\n.my-auto {\n  margin-bottom: auto !important;\n}\n\n.ml-auto,\n.mx-auto {\n  margin-left: auto !important;\n}\n\n@media (min-width: 576px) {\n  .m-sm-0 {\n    margin: 0 !important;\n  }\n  .mt-sm-0,\n  .my-sm-0 {\n    margin-top: 0 !important;\n  }\n  .mr-sm-0,\n  .mx-sm-0 {\n    margin-right: 0 !important;\n  }\n  .mb-sm-0,\n  .my-sm-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-sm-0,\n  .mx-sm-0 {\n    margin-left: 0 !important;\n  }\n  .m-sm-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-sm-1,\n  .my-sm-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-sm-1,\n  .mx-sm-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-sm-1,\n  .my-sm-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-sm-1,\n  .mx-sm-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-sm-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-sm-2,\n  .my-sm-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-sm-2,\n  .mx-sm-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-sm-2,\n  .my-sm-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-sm-2,\n  .mx-sm-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-sm-3 {\n    margin: 1rem !important;\n  }\n  .mt-sm-3,\n  .my-sm-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-sm-3,\n  .mx-sm-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-sm-3,\n  .my-sm-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-sm-3,\n  .mx-sm-3 {\n    margin-left: 1rem !important;\n  }\n  .m-sm-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-sm-4,\n  .my-sm-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-sm-4,\n  .mx-sm-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-sm-4,\n  .my-sm-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-sm-4,\n  .mx-sm-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-sm-5 {\n    margin: 2rem !important;\n  }\n  .mt-sm-5,\n  .my-sm-5 {\n    margin-top: 2rem !important;\n  }\n  .mr-sm-5,\n  .mx-sm-5 {\n    margin-right: 2rem !important;\n  }\n  .mb-sm-5,\n  .my-sm-5 {\n    margin-bottom: 2rem !important;\n  }\n  .ml-sm-5,\n  .mx-sm-5 {\n    margin-left: 2rem !important;\n  }\n  .m-sm-6 {\n    margin: 2.5rem !important;\n  }\n  .mt-sm-6,\n  .my-sm-6 {\n    margin-top: 2.5rem !important;\n  }\n  .mr-sm-6,\n  .mx-sm-6 {\n    margin-right: 2.5rem !important;\n  }\n  .mb-sm-6,\n  .my-sm-6 {\n    margin-bottom: 2.5rem !important;\n  }\n  .ml-sm-6,\n  .mx-sm-6 {\n    margin-left: 2.5rem !important;\n  }\n  .m-sm-7 {\n    margin: 3rem !important;\n  }\n  .mt-sm-7,\n  .my-sm-7 {\n    margin-top: 3rem !important;\n  }\n  .mr-sm-7,\n  .mx-sm-7 {\n    margin-right: 3rem !important;\n  }\n  .mb-sm-7,\n  .my-sm-7 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-sm-7,\n  .mx-sm-7 {\n    margin-left: 3rem !important;\n  }\n  .m-sm-8 {\n    margin: 3.5rem !important;\n  }\n  .mt-sm-8,\n  .my-sm-8 {\n    margin-top: 3.5rem !important;\n  }\n  .mr-sm-8,\n  .mx-sm-8 {\n    margin-right: 3.5rem !important;\n  }\n  .mb-sm-8,\n  .my-sm-8 {\n    margin-bottom: 3.5rem !important;\n  }\n  .ml-sm-8,\n  .mx-sm-8 {\n    margin-left: 3.5rem !important;\n  }\n  .m-sm-9 {\n    margin: 4rem !important;\n  }\n  .mt-sm-9,\n  .my-sm-9 {\n    margin-top: 4rem !important;\n  }\n  .mr-sm-9,\n  .mx-sm-9 {\n    margin-right: 4rem !important;\n  }\n  .mb-sm-9,\n  .my-sm-9 {\n    margin-bottom: 4rem !important;\n  }\n  .ml-sm-9,\n  .mx-sm-9 {\n    margin-left: 4rem !important;\n  }\n  .m-sm-10 {\n    margin: 4.5rem !important;\n  }\n  .mt-sm-10,\n  .my-sm-10 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-sm-10,\n  .mx-sm-10 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-sm-10,\n  .my-sm-10 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-sm-10,\n  .mx-sm-10 {\n    margin-left: 4.5rem !important;\n  }\n  .m-sm-11 {\n    margin: 5rem !important;\n  }\n  .mt-sm-11,\n  .my-sm-11 {\n    margin-top: 5rem !important;\n  }\n  .mr-sm-11,\n  .mx-sm-11 {\n    margin-right: 5rem !important;\n  }\n  .mb-sm-11,\n  .my-sm-11 {\n    margin-bottom: 5rem !important;\n  }\n  .ml-sm-11,\n  .mx-sm-11 {\n    margin-left: 5rem !important;\n  }\n  .p-sm-0 {\n    padding: 0 !important;\n  }\n  .pt-sm-0,\n  .py-sm-0 {\n    padding-top: 0 !important;\n  }\n  .pr-sm-0,\n  .px-sm-0 {\n    padding-right: 0 !important;\n  }\n  .pb-sm-0,\n  .py-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-sm-0,\n  .px-sm-0 {\n    padding-left: 0 !important;\n  }\n  .p-sm-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-sm-1,\n  .py-sm-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-sm-1,\n  .px-sm-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-sm-1,\n  .py-sm-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-sm-1,\n  .px-sm-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-sm-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-sm-2,\n  .py-sm-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-sm-2,\n  .px-sm-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-sm-2,\n  .py-sm-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-sm-2,\n  .px-sm-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-sm-3 {\n    padding: 1rem !important;\n  }\n  .pt-sm-3,\n  .py-sm-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-sm-3,\n  .px-sm-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-sm-3,\n  .py-sm-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-sm-3,\n  .px-sm-3 {\n    padding-left: 1rem !important;\n  }\n  .p-sm-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-sm-4,\n  .py-sm-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-sm-4,\n  .px-sm-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-sm-4,\n  .py-sm-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-sm-4,\n  .px-sm-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-sm-5 {\n    padding: 2rem !important;\n  }\n  .pt-sm-5,\n  .py-sm-5 {\n    padding-top: 2rem !important;\n  }\n  .pr-sm-5,\n  .px-sm-5 {\n    padding-right: 2rem !important;\n  }\n  .pb-sm-5,\n  .py-sm-5 {\n    padding-bottom: 2rem !important;\n  }\n  .pl-sm-5,\n  .px-sm-5 {\n    padding-left: 2rem !important;\n  }\n  .p-sm-6 {\n    padding: 2.5rem !important;\n  }\n  .pt-sm-6,\n  .py-sm-6 {\n    padding-top: 2.5rem !important;\n  }\n  .pr-sm-6,\n  .px-sm-6 {\n    padding-right: 2.5rem !important;\n  }\n  .pb-sm-6,\n  .py-sm-6 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pl-sm-6,\n  .px-sm-6 {\n    padding-left: 2.5rem !important;\n  }\n  .p-sm-7 {\n    padding: 3rem !important;\n  }\n  .pt-sm-7,\n  .py-sm-7 {\n    padding-top: 3rem !important;\n  }\n  .pr-sm-7,\n  .px-sm-7 {\n    padding-right: 3rem !important;\n  }\n  .pb-sm-7,\n  .py-sm-7 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-sm-7,\n  .px-sm-7 {\n    padding-left: 3rem !important;\n  }\n  .p-sm-8 {\n    padding: 3.5rem !important;\n  }\n  .pt-sm-8,\n  .py-sm-8 {\n    padding-top: 3.5rem !important;\n  }\n  .pr-sm-8,\n  .px-sm-8 {\n    padding-right: 3.5rem !important;\n  }\n  .pb-sm-8,\n  .py-sm-8 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pl-sm-8,\n  .px-sm-8 {\n    padding-left: 3.5rem !important;\n  }\n  .p-sm-9 {\n    padding: 4rem !important;\n  }\n  .pt-sm-9,\n  .py-sm-9 {\n    padding-top: 4rem !important;\n  }\n  .pr-sm-9,\n  .px-sm-9 {\n    padding-right: 4rem !important;\n  }\n  .pb-sm-9,\n  .py-sm-9 {\n    padding-bottom: 4rem !important;\n  }\n  .pl-sm-9,\n  .px-sm-9 {\n    padding-left: 4rem !important;\n  }\n  .p-sm-10 {\n    padding: 4.5rem !important;\n  }\n  .pt-sm-10,\n  .py-sm-10 {\n    padding-top: 4.5rem !important;\n  }\n  .pr-sm-10,\n  .px-sm-10 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-sm-10,\n  .py-sm-10 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pl-sm-10,\n  .px-sm-10 {\n    padding-left: 4.5rem !important;\n  }\n  .p-sm-11 {\n    padding: 5rem !important;\n  }\n  .pt-sm-11,\n  .py-sm-11 {\n    padding-top: 5rem !important;\n  }\n  .pr-sm-11,\n  .px-sm-11 {\n    padding-right: 5rem !important;\n  }\n  .pb-sm-11,\n  .py-sm-11 {\n    padding-bottom: 5rem !important;\n  }\n  .pl-sm-11,\n  .px-sm-11 {\n    padding-left: 5rem !important;\n  }\n  .m-sm-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-sm-n1,\n  .my-sm-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-sm-n1,\n  .mx-sm-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-sm-n1,\n  .my-sm-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-sm-n1,\n  .mx-sm-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-sm-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-sm-n2,\n  .my-sm-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-sm-n2,\n  .mx-sm-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-sm-n2,\n  .my-sm-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-sm-n2,\n  .mx-sm-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-sm-n3 {\n    margin: -1rem !important;\n  }\n  .mt-sm-n3,\n  .my-sm-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-sm-n3,\n  .mx-sm-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-sm-n3,\n  .my-sm-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-sm-n3,\n  .mx-sm-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-sm-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-sm-n4,\n  .my-sm-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-sm-n4,\n  .mx-sm-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-sm-n4,\n  .my-sm-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-sm-n4,\n  .mx-sm-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-sm-n5 {\n    margin: -2rem !important;\n  }\n  .mt-sm-n5,\n  .my-sm-n5 {\n    margin-top: -2rem !important;\n  }\n  .mr-sm-n5,\n  .mx-sm-n5 {\n    margin-right: -2rem !important;\n  }\n  .mb-sm-n5,\n  .my-sm-n5 {\n    margin-bottom: -2rem !important;\n  }\n  .ml-sm-n5,\n  .mx-sm-n5 {\n    margin-left: -2rem !important;\n  }\n  .m-sm-n6 {\n    margin: -2.5rem !important;\n  }\n  .mt-sm-n6,\n  .my-sm-n6 {\n    margin-top: -2.5rem !important;\n  }\n  .mr-sm-n6,\n  .mx-sm-n6 {\n    margin-right: -2.5rem !important;\n  }\n  .mb-sm-n6,\n  .my-sm-n6 {\n    margin-bottom: -2.5rem !important;\n  }\n  .ml-sm-n6,\n  .mx-sm-n6 {\n    margin-left: -2.5rem !important;\n  }\n  .m-sm-n7 {\n    margin: -3rem !important;\n  }\n  .mt-sm-n7,\n  .my-sm-n7 {\n    margin-top: -3rem !important;\n  }\n  .mr-sm-n7,\n  .mx-sm-n7 {\n    margin-right: -3rem !important;\n  }\n  .mb-sm-n7,\n  .my-sm-n7 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-sm-n7,\n  .mx-sm-n7 {\n    margin-left: -3rem !important;\n  }\n  .m-sm-n8 {\n    margin: -3.5rem !important;\n  }\n  .mt-sm-n8,\n  .my-sm-n8 {\n    margin-top: -3.5rem !important;\n  }\n  .mr-sm-n8,\n  .mx-sm-n8 {\n    margin-right: -3.5rem !important;\n  }\n  .mb-sm-n8,\n  .my-sm-n8 {\n    margin-bottom: -3.5rem !important;\n  }\n  .ml-sm-n8,\n  .mx-sm-n8 {\n    margin-left: -3.5rem !important;\n  }\n  .m-sm-n9 {\n    margin: -4rem !important;\n  }\n  .mt-sm-n9,\n  .my-sm-n9 {\n    margin-top: -4rem !important;\n  }\n  .mr-sm-n9,\n  .mx-sm-n9 {\n    margin-right: -4rem !important;\n  }\n  .mb-sm-n9,\n  .my-sm-n9 {\n    margin-bottom: -4rem !important;\n  }\n  .ml-sm-n9,\n  .mx-sm-n9 {\n    margin-left: -4rem !important;\n  }\n  .m-sm-n10 {\n    margin: -4.5rem !important;\n  }\n  .mt-sm-n10,\n  .my-sm-n10 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-sm-n10,\n  .mx-sm-n10 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-sm-n10,\n  .my-sm-n10 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-sm-n10,\n  .mx-sm-n10 {\n    margin-left: -4.5rem !important;\n  }\n  .m-sm-n11 {\n    margin: -5rem !important;\n  }\n  .mt-sm-n11,\n  .my-sm-n11 {\n    margin-top: -5rem !important;\n  }\n  .mr-sm-n11,\n  .mx-sm-n11 {\n    margin-right: -5rem !important;\n  }\n  .mb-sm-n11,\n  .my-sm-n11 {\n    margin-bottom: -5rem !important;\n  }\n  .ml-sm-n11,\n  .mx-sm-n11 {\n    margin-left: -5rem !important;\n  }\n  .m-sm-auto {\n    margin: auto !important;\n  }\n  .mt-sm-auto,\n  .my-sm-auto {\n    margin-top: auto !important;\n  }\n  .mr-sm-auto,\n  .mx-sm-auto {\n    margin-right: auto !important;\n  }\n  .mb-sm-auto,\n  .my-sm-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-sm-auto,\n  .mx-sm-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .m-md-0 {\n    margin: 0 !important;\n  }\n  .mt-md-0,\n  .my-md-0 {\n    margin-top: 0 !important;\n  }\n  .mr-md-0,\n  .mx-md-0 {\n    margin-right: 0 !important;\n  }\n  .mb-md-0,\n  .my-md-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-md-0,\n  .mx-md-0 {\n    margin-left: 0 !important;\n  }\n  .m-md-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-md-1,\n  .my-md-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-md-1,\n  .mx-md-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-md-1,\n  .my-md-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-md-1,\n  .mx-md-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-md-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-md-2,\n  .my-md-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-md-2,\n  .mx-md-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-md-2,\n  .my-md-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-md-2,\n  .mx-md-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-md-3 {\n    margin: 1rem !important;\n  }\n  .mt-md-3,\n  .my-md-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-md-3,\n  .mx-md-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-md-3,\n  .my-md-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-md-3,\n  .mx-md-3 {\n    margin-left: 1rem !important;\n  }\n  .m-md-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-md-4,\n  .my-md-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-md-4,\n  .mx-md-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-md-4,\n  .my-md-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-md-4,\n  .mx-md-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-md-5 {\n    margin: 2rem !important;\n  }\n  .mt-md-5,\n  .my-md-5 {\n    margin-top: 2rem !important;\n  }\n  .mr-md-5,\n  .mx-md-5 {\n    margin-right: 2rem !important;\n  }\n  .mb-md-5,\n  .my-md-5 {\n    margin-bottom: 2rem !important;\n  }\n  .ml-md-5,\n  .mx-md-5 {\n    margin-left: 2rem !important;\n  }\n  .m-md-6 {\n    margin: 2.5rem !important;\n  }\n  .mt-md-6,\n  .my-md-6 {\n    margin-top: 2.5rem !important;\n  }\n  .mr-md-6,\n  .mx-md-6 {\n    margin-right: 2.5rem !important;\n  }\n  .mb-md-6,\n  .my-md-6 {\n    margin-bottom: 2.5rem !important;\n  }\n  .ml-md-6,\n  .mx-md-6 {\n    margin-left: 2.5rem !important;\n  }\n  .m-md-7 {\n    margin: 3rem !important;\n  }\n  .mt-md-7,\n  .my-md-7 {\n    margin-top: 3rem !important;\n  }\n  .mr-md-7,\n  .mx-md-7 {\n    margin-right: 3rem !important;\n  }\n  .mb-md-7,\n  .my-md-7 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-md-7,\n  .mx-md-7 {\n    margin-left: 3rem !important;\n  }\n  .m-md-8 {\n    margin: 3.5rem !important;\n  }\n  .mt-md-8,\n  .my-md-8 {\n    margin-top: 3.5rem !important;\n  }\n  .mr-md-8,\n  .mx-md-8 {\n    margin-right: 3.5rem !important;\n  }\n  .mb-md-8,\n  .my-md-8 {\n    margin-bottom: 3.5rem !important;\n  }\n  .ml-md-8,\n  .mx-md-8 {\n    margin-left: 3.5rem !important;\n  }\n  .m-md-9 {\n    margin: 4rem !important;\n  }\n  .mt-md-9,\n  .my-md-9 {\n    margin-top: 4rem !important;\n  }\n  .mr-md-9,\n  .mx-md-9 {\n    margin-right: 4rem !important;\n  }\n  .mb-md-9,\n  .my-md-9 {\n    margin-bottom: 4rem !important;\n  }\n  .ml-md-9,\n  .mx-md-9 {\n    margin-left: 4rem !important;\n  }\n  .m-md-10 {\n    margin: 4.5rem !important;\n  }\n  .mt-md-10,\n  .my-md-10 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-md-10,\n  .mx-md-10 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-md-10,\n  .my-md-10 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-md-10,\n  .mx-md-10 {\n    margin-left: 4.5rem !important;\n  }\n  .m-md-11 {\n    margin: 5rem !important;\n  }\n  .mt-md-11,\n  .my-md-11 {\n    margin-top: 5rem !important;\n  }\n  .mr-md-11,\n  .mx-md-11 {\n    margin-right: 5rem !important;\n  }\n  .mb-md-11,\n  .my-md-11 {\n    margin-bottom: 5rem !important;\n  }\n  .ml-md-11,\n  .mx-md-11 {\n    margin-left: 5rem !important;\n  }\n  .p-md-0 {\n    padding: 0 !important;\n  }\n  .pt-md-0,\n  .py-md-0 {\n    padding-top: 0 !important;\n  }\n  .pr-md-0,\n  .px-md-0 {\n    padding-right: 0 !important;\n  }\n  .pb-md-0,\n  .py-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-md-0,\n  .px-md-0 {\n    padding-left: 0 !important;\n  }\n  .p-md-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-md-1,\n  .py-md-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-md-1,\n  .px-md-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-md-1,\n  .py-md-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-md-1,\n  .px-md-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-md-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-md-2,\n  .py-md-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-md-2,\n  .px-md-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-md-2,\n  .py-md-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-md-2,\n  .px-md-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-md-3 {\n    padding: 1rem !important;\n  }\n  .pt-md-3,\n  .py-md-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-md-3,\n  .px-md-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-md-3,\n  .py-md-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-md-3,\n  .px-md-3 {\n    padding-left: 1rem !important;\n  }\n  .p-md-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-md-4,\n  .py-md-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-md-4,\n  .px-md-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-md-4,\n  .py-md-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-md-4,\n  .px-md-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-md-5 {\n    padding: 2rem !important;\n  }\n  .pt-md-5,\n  .py-md-5 {\n    padding-top: 2rem !important;\n  }\n  .pr-md-5,\n  .px-md-5 {\n    padding-right: 2rem !important;\n  }\n  .pb-md-5,\n  .py-md-5 {\n    padding-bottom: 2rem !important;\n  }\n  .pl-md-5,\n  .px-md-5 {\n    padding-left: 2rem !important;\n  }\n  .p-md-6 {\n    padding: 2.5rem !important;\n  }\n  .pt-md-6,\n  .py-md-6 {\n    padding-top: 2.5rem !important;\n  }\n  .pr-md-6,\n  .px-md-6 {\n    padding-right: 2.5rem !important;\n  }\n  .pb-md-6,\n  .py-md-6 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pl-md-6,\n  .px-md-6 {\n    padding-left: 2.5rem !important;\n  }\n  .p-md-7 {\n    padding: 3rem !important;\n  }\n  .pt-md-7,\n  .py-md-7 {\n    padding-top: 3rem !important;\n  }\n  .pr-md-7,\n  .px-md-7 {\n    padding-right: 3rem !important;\n  }\n  .pb-md-7,\n  .py-md-7 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-md-7,\n  .px-md-7 {\n    padding-left: 3rem !important;\n  }\n  .p-md-8 {\n    padding: 3.5rem !important;\n  }\n  .pt-md-8,\n  .py-md-8 {\n    padding-top: 3.5rem !important;\n  }\n  .pr-md-8,\n  .px-md-8 {\n    padding-right: 3.5rem !important;\n  }\n  .pb-md-8,\n  .py-md-8 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pl-md-8,\n  .px-md-8 {\n    padding-left: 3.5rem !important;\n  }\n  .p-md-9 {\n    padding: 4rem !important;\n  }\n  .pt-md-9,\n  .py-md-9 {\n    padding-top: 4rem !important;\n  }\n  .pr-md-9,\n  .px-md-9 {\n    padding-right: 4rem !important;\n  }\n  .pb-md-9,\n  .py-md-9 {\n    padding-bottom: 4rem !important;\n  }\n  .pl-md-9,\n  .px-md-9 {\n    padding-left: 4rem !important;\n  }\n  .p-md-10 {\n    padding: 4.5rem !important;\n  }\n  .pt-md-10,\n  .py-md-10 {\n    padding-top: 4.5rem !important;\n  }\n  .pr-md-10,\n  .px-md-10 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-md-10,\n  .py-md-10 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pl-md-10,\n  .px-md-10 {\n    padding-left: 4.5rem !important;\n  }\n  .p-md-11 {\n    padding: 5rem !important;\n  }\n  .pt-md-11,\n  .py-md-11 {\n    padding-top: 5rem !important;\n  }\n  .pr-md-11,\n  .px-md-11 {\n    padding-right: 5rem !important;\n  }\n  .pb-md-11,\n  .py-md-11 {\n    padding-bottom: 5rem !important;\n  }\n  .pl-md-11,\n  .px-md-11 {\n    padding-left: 5rem !important;\n  }\n  .m-md-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-md-n1,\n  .my-md-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-md-n1,\n  .mx-md-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-md-n1,\n  .my-md-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-md-n1,\n  .mx-md-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-md-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-md-n2,\n  .my-md-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-md-n2,\n  .mx-md-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-md-n2,\n  .my-md-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-md-n2,\n  .mx-md-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-md-n3 {\n    margin: -1rem !important;\n  }\n  .mt-md-n3,\n  .my-md-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-md-n3,\n  .mx-md-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-md-n3,\n  .my-md-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-md-n3,\n  .mx-md-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-md-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-md-n4,\n  .my-md-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-md-n4,\n  .mx-md-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-md-n4,\n  .my-md-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-md-n4,\n  .mx-md-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-md-n5 {\n    margin: -2rem !important;\n  }\n  .mt-md-n5,\n  .my-md-n5 {\n    margin-top: -2rem !important;\n  }\n  .mr-md-n5,\n  .mx-md-n5 {\n    margin-right: -2rem !important;\n  }\n  .mb-md-n5,\n  .my-md-n5 {\n    margin-bottom: -2rem !important;\n  }\n  .ml-md-n5,\n  .mx-md-n5 {\n    margin-left: -2rem !important;\n  }\n  .m-md-n6 {\n    margin: -2.5rem !important;\n  }\n  .mt-md-n6,\n  .my-md-n6 {\n    margin-top: -2.5rem !important;\n  }\n  .mr-md-n6,\n  .mx-md-n6 {\n    margin-right: -2.5rem !important;\n  }\n  .mb-md-n6,\n  .my-md-n6 {\n    margin-bottom: -2.5rem !important;\n  }\n  .ml-md-n6,\n  .mx-md-n6 {\n    margin-left: -2.5rem !important;\n  }\n  .m-md-n7 {\n    margin: -3rem !important;\n  }\n  .mt-md-n7,\n  .my-md-n7 {\n    margin-top: -3rem !important;\n  }\n  .mr-md-n7,\n  .mx-md-n7 {\n    margin-right: -3rem !important;\n  }\n  .mb-md-n7,\n  .my-md-n7 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-md-n7,\n  .mx-md-n7 {\n    margin-left: -3rem !important;\n  }\n  .m-md-n8 {\n    margin: -3.5rem !important;\n  }\n  .mt-md-n8,\n  .my-md-n8 {\n    margin-top: -3.5rem !important;\n  }\n  .mr-md-n8,\n  .mx-md-n8 {\n    margin-right: -3.5rem !important;\n  }\n  .mb-md-n8,\n  .my-md-n8 {\n    margin-bottom: -3.5rem !important;\n  }\n  .ml-md-n8,\n  .mx-md-n8 {\n    margin-left: -3.5rem !important;\n  }\n  .m-md-n9 {\n    margin: -4rem !important;\n  }\n  .mt-md-n9,\n  .my-md-n9 {\n    margin-top: -4rem !important;\n  }\n  .mr-md-n9,\n  .mx-md-n9 {\n    margin-right: -4rem !important;\n  }\n  .mb-md-n9,\n  .my-md-n9 {\n    margin-bottom: -4rem !important;\n  }\n  .ml-md-n9,\n  .mx-md-n9 {\n    margin-left: -4rem !important;\n  }\n  .m-md-n10 {\n    margin: -4.5rem !important;\n  }\n  .mt-md-n10,\n  .my-md-n10 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-md-n10,\n  .mx-md-n10 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-md-n10,\n  .my-md-n10 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-md-n10,\n  .mx-md-n10 {\n    margin-left: -4.5rem !important;\n  }\n  .m-md-n11 {\n    margin: -5rem !important;\n  }\n  .mt-md-n11,\n  .my-md-n11 {\n    margin-top: -5rem !important;\n  }\n  .mr-md-n11,\n  .mx-md-n11 {\n    margin-right: -5rem !important;\n  }\n  .mb-md-n11,\n  .my-md-n11 {\n    margin-bottom: -5rem !important;\n  }\n  .ml-md-n11,\n  .mx-md-n11 {\n    margin-left: -5rem !important;\n  }\n  .m-md-auto {\n    margin: auto !important;\n  }\n  .mt-md-auto,\n  .my-md-auto {\n    margin-top: auto !important;\n  }\n  .mr-md-auto,\n  .mx-md-auto {\n    margin-right: auto !important;\n  }\n  .mb-md-auto,\n  .my-md-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-md-auto,\n  .mx-md-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .m-lg-0 {\n    margin: 0 !important;\n  }\n  .mt-lg-0,\n  .my-lg-0 {\n    margin-top: 0 !important;\n  }\n  .mr-lg-0,\n  .mx-lg-0 {\n    margin-right: 0 !important;\n  }\n  .mb-lg-0,\n  .my-lg-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-lg-0,\n  .mx-lg-0 {\n    margin-left: 0 !important;\n  }\n  .m-lg-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-lg-1,\n  .my-lg-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-lg-1,\n  .mx-lg-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-lg-1,\n  .my-lg-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-lg-1,\n  .mx-lg-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-lg-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-lg-2,\n  .my-lg-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-lg-2,\n  .mx-lg-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-lg-2,\n  .my-lg-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-lg-2,\n  .mx-lg-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-lg-3 {\n    margin: 1rem !important;\n  }\n  .mt-lg-3,\n  .my-lg-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-lg-3,\n  .mx-lg-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-lg-3,\n  .my-lg-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-lg-3,\n  .mx-lg-3 {\n    margin-left: 1rem !important;\n  }\n  .m-lg-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-lg-4,\n  .my-lg-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-lg-4,\n  .mx-lg-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-lg-4,\n  .my-lg-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-lg-4,\n  .mx-lg-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-lg-5 {\n    margin: 2rem !important;\n  }\n  .mt-lg-5,\n  .my-lg-5 {\n    margin-top: 2rem !important;\n  }\n  .mr-lg-5,\n  .mx-lg-5 {\n    margin-right: 2rem !important;\n  }\n  .mb-lg-5,\n  .my-lg-5 {\n    margin-bottom: 2rem !important;\n  }\n  .ml-lg-5,\n  .mx-lg-5 {\n    margin-left: 2rem !important;\n  }\n  .m-lg-6 {\n    margin: 2.5rem !important;\n  }\n  .mt-lg-6,\n  .my-lg-6 {\n    margin-top: 2.5rem !important;\n  }\n  .mr-lg-6,\n  .mx-lg-6 {\n    margin-right: 2.5rem !important;\n  }\n  .mb-lg-6,\n  .my-lg-6 {\n    margin-bottom: 2.5rem !important;\n  }\n  .ml-lg-6,\n  .mx-lg-6 {\n    margin-left: 2.5rem !important;\n  }\n  .m-lg-7 {\n    margin: 3rem !important;\n  }\n  .mt-lg-7,\n  .my-lg-7 {\n    margin-top: 3rem !important;\n  }\n  .mr-lg-7,\n  .mx-lg-7 {\n    margin-right: 3rem !important;\n  }\n  .mb-lg-7,\n  .my-lg-7 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-lg-7,\n  .mx-lg-7 {\n    margin-left: 3rem !important;\n  }\n  .m-lg-8 {\n    margin: 3.5rem !important;\n  }\n  .mt-lg-8,\n  .my-lg-8 {\n    margin-top: 3.5rem !important;\n  }\n  .mr-lg-8,\n  .mx-lg-8 {\n    margin-right: 3.5rem !important;\n  }\n  .mb-lg-8,\n  .my-lg-8 {\n    margin-bottom: 3.5rem !important;\n  }\n  .ml-lg-8,\n  .mx-lg-8 {\n    margin-left: 3.5rem !important;\n  }\n  .m-lg-9 {\n    margin: 4rem !important;\n  }\n  .mt-lg-9,\n  .my-lg-9 {\n    margin-top: 4rem !important;\n  }\n  .mr-lg-9,\n  .mx-lg-9 {\n    margin-right: 4rem !important;\n  }\n  .mb-lg-9,\n  .my-lg-9 {\n    margin-bottom: 4rem !important;\n  }\n  .ml-lg-9,\n  .mx-lg-9 {\n    margin-left: 4rem !important;\n  }\n  .m-lg-10 {\n    margin: 4.5rem !important;\n  }\n  .mt-lg-10,\n  .my-lg-10 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-lg-10,\n  .mx-lg-10 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-lg-10,\n  .my-lg-10 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-lg-10,\n  .mx-lg-10 {\n    margin-left: 4.5rem !important;\n  }\n  .m-lg-11 {\n    margin: 5rem !important;\n  }\n  .mt-lg-11,\n  .my-lg-11 {\n    margin-top: 5rem !important;\n  }\n  .mr-lg-11,\n  .mx-lg-11 {\n    margin-right: 5rem !important;\n  }\n  .mb-lg-11,\n  .my-lg-11 {\n    margin-bottom: 5rem !important;\n  }\n  .ml-lg-11,\n  .mx-lg-11 {\n    margin-left: 5rem !important;\n  }\n  .p-lg-0 {\n    padding: 0 !important;\n  }\n  .pt-lg-0,\n  .py-lg-0 {\n    padding-top: 0 !important;\n  }\n  .pr-lg-0,\n  .px-lg-0 {\n    padding-right: 0 !important;\n  }\n  .pb-lg-0,\n  .py-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-lg-0,\n  .px-lg-0 {\n    padding-left: 0 !important;\n  }\n  .p-lg-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-lg-1,\n  .py-lg-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-lg-1,\n  .px-lg-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-lg-1,\n  .py-lg-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-lg-1,\n  .px-lg-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-lg-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-lg-2,\n  .py-lg-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-lg-2,\n  .px-lg-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-lg-2,\n  .py-lg-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-lg-2,\n  .px-lg-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-lg-3 {\n    padding: 1rem !important;\n  }\n  .pt-lg-3,\n  .py-lg-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-lg-3,\n  .px-lg-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-lg-3,\n  .py-lg-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-lg-3,\n  .px-lg-3 {\n    padding-left: 1rem !important;\n  }\n  .p-lg-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-lg-4,\n  .py-lg-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-lg-4,\n  .px-lg-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-lg-4,\n  .py-lg-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-lg-4,\n  .px-lg-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-lg-5 {\n    padding: 2rem !important;\n  }\n  .pt-lg-5,\n  .py-lg-5 {\n    padding-top: 2rem !important;\n  }\n  .pr-lg-5,\n  .px-lg-5 {\n    padding-right: 2rem !important;\n  }\n  .pb-lg-5,\n  .py-lg-5 {\n    padding-bottom: 2rem !important;\n  }\n  .pl-lg-5,\n  .px-lg-5 {\n    padding-left: 2rem !important;\n  }\n  .p-lg-6 {\n    padding: 2.5rem !important;\n  }\n  .pt-lg-6,\n  .py-lg-6 {\n    padding-top: 2.5rem !important;\n  }\n  .pr-lg-6,\n  .px-lg-6 {\n    padding-right: 2.5rem !important;\n  }\n  .pb-lg-6,\n  .py-lg-6 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pl-lg-6,\n  .px-lg-6 {\n    padding-left: 2.5rem !important;\n  }\n  .p-lg-7 {\n    padding: 3rem !important;\n  }\n  .pt-lg-7,\n  .py-lg-7 {\n    padding-top: 3rem !important;\n  }\n  .pr-lg-7,\n  .px-lg-7 {\n    padding-right: 3rem !important;\n  }\n  .pb-lg-7,\n  .py-lg-7 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-lg-7,\n  .px-lg-7 {\n    padding-left: 3rem !important;\n  }\n  .p-lg-8 {\n    padding: 3.5rem !important;\n  }\n  .pt-lg-8,\n  .py-lg-8 {\n    padding-top: 3.5rem !important;\n  }\n  .pr-lg-8,\n  .px-lg-8 {\n    padding-right: 3.5rem !important;\n  }\n  .pb-lg-8,\n  .py-lg-8 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pl-lg-8,\n  .px-lg-8 {\n    padding-left: 3.5rem !important;\n  }\n  .p-lg-9 {\n    padding: 4rem !important;\n  }\n  .pt-lg-9,\n  .py-lg-9 {\n    padding-top: 4rem !important;\n  }\n  .pr-lg-9,\n  .px-lg-9 {\n    padding-right: 4rem !important;\n  }\n  .pb-lg-9,\n  .py-lg-9 {\n    padding-bottom: 4rem !important;\n  }\n  .pl-lg-9,\n  .px-lg-9 {\n    padding-left: 4rem !important;\n  }\n  .p-lg-10 {\n    padding: 4.5rem !important;\n  }\n  .pt-lg-10,\n  .py-lg-10 {\n    padding-top: 4.5rem !important;\n  }\n  .pr-lg-10,\n  .px-lg-10 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-lg-10,\n  .py-lg-10 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pl-lg-10,\n  .px-lg-10 {\n    padding-left: 4.5rem !important;\n  }\n  .p-lg-11 {\n    padding: 5rem !important;\n  }\n  .pt-lg-11,\n  .py-lg-11 {\n    padding-top: 5rem !important;\n  }\n  .pr-lg-11,\n  .px-lg-11 {\n    padding-right: 5rem !important;\n  }\n  .pb-lg-11,\n  .py-lg-11 {\n    padding-bottom: 5rem !important;\n  }\n  .pl-lg-11,\n  .px-lg-11 {\n    padding-left: 5rem !important;\n  }\n  .m-lg-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-lg-n1,\n  .my-lg-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-lg-n1,\n  .mx-lg-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-lg-n1,\n  .my-lg-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-lg-n1,\n  .mx-lg-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-lg-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-lg-n2,\n  .my-lg-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-lg-n2,\n  .mx-lg-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-lg-n2,\n  .my-lg-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-lg-n2,\n  .mx-lg-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-lg-n3 {\n    margin: -1rem !important;\n  }\n  .mt-lg-n3,\n  .my-lg-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-lg-n3,\n  .mx-lg-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-lg-n3,\n  .my-lg-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-lg-n3,\n  .mx-lg-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-lg-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-lg-n4,\n  .my-lg-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-lg-n4,\n  .mx-lg-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-lg-n4,\n  .my-lg-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-lg-n4,\n  .mx-lg-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-lg-n5 {\n    margin: -2rem !important;\n  }\n  .mt-lg-n5,\n  .my-lg-n5 {\n    margin-top: -2rem !important;\n  }\n  .mr-lg-n5,\n  .mx-lg-n5 {\n    margin-right: -2rem !important;\n  }\n  .mb-lg-n5,\n  .my-lg-n5 {\n    margin-bottom: -2rem !important;\n  }\n  .ml-lg-n5,\n  .mx-lg-n5 {\n    margin-left: -2rem !important;\n  }\n  .m-lg-n6 {\n    margin: -2.5rem !important;\n  }\n  .mt-lg-n6,\n  .my-lg-n6 {\n    margin-top: -2.5rem !important;\n  }\n  .mr-lg-n6,\n  .mx-lg-n6 {\n    margin-right: -2.5rem !important;\n  }\n  .mb-lg-n6,\n  .my-lg-n6 {\n    margin-bottom: -2.5rem !important;\n  }\n  .ml-lg-n6,\n  .mx-lg-n6 {\n    margin-left: -2.5rem !important;\n  }\n  .m-lg-n7 {\n    margin: -3rem !important;\n  }\n  .mt-lg-n7,\n  .my-lg-n7 {\n    margin-top: -3rem !important;\n  }\n  .mr-lg-n7,\n  .mx-lg-n7 {\n    margin-right: -3rem !important;\n  }\n  .mb-lg-n7,\n  .my-lg-n7 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-lg-n7,\n  .mx-lg-n7 {\n    margin-left: -3rem !important;\n  }\n  .m-lg-n8 {\n    margin: -3.5rem !important;\n  }\n  .mt-lg-n8,\n  .my-lg-n8 {\n    margin-top: -3.5rem !important;\n  }\n  .mr-lg-n8,\n  .mx-lg-n8 {\n    margin-right: -3.5rem !important;\n  }\n  .mb-lg-n8,\n  .my-lg-n8 {\n    margin-bottom: -3.5rem !important;\n  }\n  .ml-lg-n8,\n  .mx-lg-n8 {\n    margin-left: -3.5rem !important;\n  }\n  .m-lg-n9 {\n    margin: -4rem !important;\n  }\n  .mt-lg-n9,\n  .my-lg-n9 {\n    margin-top: -4rem !important;\n  }\n  .mr-lg-n9,\n  .mx-lg-n9 {\n    margin-right: -4rem !important;\n  }\n  .mb-lg-n9,\n  .my-lg-n9 {\n    margin-bottom: -4rem !important;\n  }\n  .ml-lg-n9,\n  .mx-lg-n9 {\n    margin-left: -4rem !important;\n  }\n  .m-lg-n10 {\n    margin: -4.5rem !important;\n  }\n  .mt-lg-n10,\n  .my-lg-n10 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-lg-n10,\n  .mx-lg-n10 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-lg-n10,\n  .my-lg-n10 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-lg-n10,\n  .mx-lg-n10 {\n    margin-left: -4.5rem !important;\n  }\n  .m-lg-n11 {\n    margin: -5rem !important;\n  }\n  .mt-lg-n11,\n  .my-lg-n11 {\n    margin-top: -5rem !important;\n  }\n  .mr-lg-n11,\n  .mx-lg-n11 {\n    margin-right: -5rem !important;\n  }\n  .mb-lg-n11,\n  .my-lg-n11 {\n    margin-bottom: -5rem !important;\n  }\n  .ml-lg-n11,\n  .mx-lg-n11 {\n    margin-left: -5rem !important;\n  }\n  .m-lg-auto {\n    margin: auto !important;\n  }\n  .mt-lg-auto,\n  .my-lg-auto {\n    margin-top: auto !important;\n  }\n  .mr-lg-auto,\n  .mx-lg-auto {\n    margin-right: auto !important;\n  }\n  .mb-lg-auto,\n  .my-lg-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-lg-auto,\n  .mx-lg-auto {\n    margin-left: auto !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .m-xl-0 {\n    margin: 0 !important;\n  }\n  .mt-xl-0,\n  .my-xl-0 {\n    margin-top: 0 !important;\n  }\n  .mr-xl-0,\n  .mx-xl-0 {\n    margin-right: 0 !important;\n  }\n  .mb-xl-0,\n  .my-xl-0 {\n    margin-bottom: 0 !important;\n  }\n  .ml-xl-0,\n  .mx-xl-0 {\n    margin-left: 0 !important;\n  }\n  .m-xl-1 {\n    margin: 0.25rem !important;\n  }\n  .mt-xl-1,\n  .my-xl-1 {\n    margin-top: 0.25rem !important;\n  }\n  .mr-xl-1,\n  .mx-xl-1 {\n    margin-right: 0.25rem !important;\n  }\n  .mb-xl-1,\n  .my-xl-1 {\n    margin-bottom: 0.25rem !important;\n  }\n  .ml-xl-1,\n  .mx-xl-1 {\n    margin-left: 0.25rem !important;\n  }\n  .m-xl-2 {\n    margin: 0.5rem !important;\n  }\n  .mt-xl-2,\n  .my-xl-2 {\n    margin-top: 0.5rem !important;\n  }\n  .mr-xl-2,\n  .mx-xl-2 {\n    margin-right: 0.5rem !important;\n  }\n  .mb-xl-2,\n  .my-xl-2 {\n    margin-bottom: 0.5rem !important;\n  }\n  .ml-xl-2,\n  .mx-xl-2 {\n    margin-left: 0.5rem !important;\n  }\n  .m-xl-3 {\n    margin: 1rem !important;\n  }\n  .mt-xl-3,\n  .my-xl-3 {\n    margin-top: 1rem !important;\n  }\n  .mr-xl-3,\n  .mx-xl-3 {\n    margin-right: 1rem !important;\n  }\n  .mb-xl-3,\n  .my-xl-3 {\n    margin-bottom: 1rem !important;\n  }\n  .ml-xl-3,\n  .mx-xl-3 {\n    margin-left: 1rem !important;\n  }\n  .m-xl-4 {\n    margin: 1.5rem !important;\n  }\n  .mt-xl-4,\n  .my-xl-4 {\n    margin-top: 1.5rem !important;\n  }\n  .mr-xl-4,\n  .mx-xl-4 {\n    margin-right: 1.5rem !important;\n  }\n  .mb-xl-4,\n  .my-xl-4 {\n    margin-bottom: 1.5rem !important;\n  }\n  .ml-xl-4,\n  .mx-xl-4 {\n    margin-left: 1.5rem !important;\n  }\n  .m-xl-5 {\n    margin: 2rem !important;\n  }\n  .mt-xl-5,\n  .my-xl-5 {\n    margin-top: 2rem !important;\n  }\n  .mr-xl-5,\n  .mx-xl-5 {\n    margin-right: 2rem !important;\n  }\n  .mb-xl-5,\n  .my-xl-5 {\n    margin-bottom: 2rem !important;\n  }\n  .ml-xl-5,\n  .mx-xl-5 {\n    margin-left: 2rem !important;\n  }\n  .m-xl-6 {\n    margin: 2.5rem !important;\n  }\n  .mt-xl-6,\n  .my-xl-6 {\n    margin-top: 2.5rem !important;\n  }\n  .mr-xl-6,\n  .mx-xl-6 {\n    margin-right: 2.5rem !important;\n  }\n  .mb-xl-6,\n  .my-xl-6 {\n    margin-bottom: 2.5rem !important;\n  }\n  .ml-xl-6,\n  .mx-xl-6 {\n    margin-left: 2.5rem !important;\n  }\n  .m-xl-7 {\n    margin: 3rem !important;\n  }\n  .mt-xl-7,\n  .my-xl-7 {\n    margin-top: 3rem !important;\n  }\n  .mr-xl-7,\n  .mx-xl-7 {\n    margin-right: 3rem !important;\n  }\n  .mb-xl-7,\n  .my-xl-7 {\n    margin-bottom: 3rem !important;\n  }\n  .ml-xl-7,\n  .mx-xl-7 {\n    margin-left: 3rem !important;\n  }\n  .m-xl-8 {\n    margin: 3.5rem !important;\n  }\n  .mt-xl-8,\n  .my-xl-8 {\n    margin-top: 3.5rem !important;\n  }\n  .mr-xl-8,\n  .mx-xl-8 {\n    margin-right: 3.5rem !important;\n  }\n  .mb-xl-8,\n  .my-xl-8 {\n    margin-bottom: 3.5rem !important;\n  }\n  .ml-xl-8,\n  .mx-xl-8 {\n    margin-left: 3.5rem !important;\n  }\n  .m-xl-9 {\n    margin: 4rem !important;\n  }\n  .mt-xl-9,\n  .my-xl-9 {\n    margin-top: 4rem !important;\n  }\n  .mr-xl-9,\n  .mx-xl-9 {\n    margin-right: 4rem !important;\n  }\n  .mb-xl-9,\n  .my-xl-9 {\n    margin-bottom: 4rem !important;\n  }\n  .ml-xl-9,\n  .mx-xl-9 {\n    margin-left: 4rem !important;\n  }\n  .m-xl-10 {\n    margin: 4.5rem !important;\n  }\n  .mt-xl-10,\n  .my-xl-10 {\n    margin-top: 4.5rem !important;\n  }\n  .mr-xl-10,\n  .mx-xl-10 {\n    margin-right: 4.5rem !important;\n  }\n  .mb-xl-10,\n  .my-xl-10 {\n    margin-bottom: 4.5rem !important;\n  }\n  .ml-xl-10,\n  .mx-xl-10 {\n    margin-left: 4.5rem !important;\n  }\n  .m-xl-11 {\n    margin: 5rem !important;\n  }\n  .mt-xl-11,\n  .my-xl-11 {\n    margin-top: 5rem !important;\n  }\n  .mr-xl-11,\n  .mx-xl-11 {\n    margin-right: 5rem !important;\n  }\n  .mb-xl-11,\n  .my-xl-11 {\n    margin-bottom: 5rem !important;\n  }\n  .ml-xl-11,\n  .mx-xl-11 {\n    margin-left: 5rem !important;\n  }\n  .p-xl-0 {\n    padding: 0 !important;\n  }\n  .pt-xl-0,\n  .py-xl-0 {\n    padding-top: 0 !important;\n  }\n  .pr-xl-0,\n  .px-xl-0 {\n    padding-right: 0 !important;\n  }\n  .pb-xl-0,\n  .py-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .pl-xl-0,\n  .px-xl-0 {\n    padding-left: 0 !important;\n  }\n  .p-xl-1 {\n    padding: 0.25rem !important;\n  }\n  .pt-xl-1,\n  .py-xl-1 {\n    padding-top: 0.25rem !important;\n  }\n  .pr-xl-1,\n  .px-xl-1 {\n    padding-right: 0.25rem !important;\n  }\n  .pb-xl-1,\n  .py-xl-1 {\n    padding-bottom: 0.25rem !important;\n  }\n  .pl-xl-1,\n  .px-xl-1 {\n    padding-left: 0.25rem !important;\n  }\n  .p-xl-2 {\n    padding: 0.5rem !important;\n  }\n  .pt-xl-2,\n  .py-xl-2 {\n    padding-top: 0.5rem !important;\n  }\n  .pr-xl-2,\n  .px-xl-2 {\n    padding-right: 0.5rem !important;\n  }\n  .pb-xl-2,\n  .py-xl-2 {\n    padding-bottom: 0.5rem !important;\n  }\n  .pl-xl-2,\n  .px-xl-2 {\n    padding-left: 0.5rem !important;\n  }\n  .p-xl-3 {\n    padding: 1rem !important;\n  }\n  .pt-xl-3,\n  .py-xl-3 {\n    padding-top: 1rem !important;\n  }\n  .pr-xl-3,\n  .px-xl-3 {\n    padding-right: 1rem !important;\n  }\n  .pb-xl-3,\n  .py-xl-3 {\n    padding-bottom: 1rem !important;\n  }\n  .pl-xl-3,\n  .px-xl-3 {\n    padding-left: 1rem !important;\n  }\n  .p-xl-4 {\n    padding: 1.5rem !important;\n  }\n  .pt-xl-4,\n  .py-xl-4 {\n    padding-top: 1.5rem !important;\n  }\n  .pr-xl-4,\n  .px-xl-4 {\n    padding-right: 1.5rem !important;\n  }\n  .pb-xl-4,\n  .py-xl-4 {\n    padding-bottom: 1.5rem !important;\n  }\n  .pl-xl-4,\n  .px-xl-4 {\n    padding-left: 1.5rem !important;\n  }\n  .p-xl-5 {\n    padding: 2rem !important;\n  }\n  .pt-xl-5,\n  .py-xl-5 {\n    padding-top: 2rem !important;\n  }\n  .pr-xl-5,\n  .px-xl-5 {\n    padding-right: 2rem !important;\n  }\n  .pb-xl-5,\n  .py-xl-5 {\n    padding-bottom: 2rem !important;\n  }\n  .pl-xl-5,\n  .px-xl-5 {\n    padding-left: 2rem !important;\n  }\n  .p-xl-6 {\n    padding: 2.5rem !important;\n  }\n  .pt-xl-6,\n  .py-xl-6 {\n    padding-top: 2.5rem !important;\n  }\n  .pr-xl-6,\n  .px-xl-6 {\n    padding-right: 2.5rem !important;\n  }\n  .pb-xl-6,\n  .py-xl-6 {\n    padding-bottom: 2.5rem !important;\n  }\n  .pl-xl-6,\n  .px-xl-6 {\n    padding-left: 2.5rem !important;\n  }\n  .p-xl-7 {\n    padding: 3rem !important;\n  }\n  .pt-xl-7,\n  .py-xl-7 {\n    padding-top: 3rem !important;\n  }\n  .pr-xl-7,\n  .px-xl-7 {\n    padding-right: 3rem !important;\n  }\n  .pb-xl-7,\n  .py-xl-7 {\n    padding-bottom: 3rem !important;\n  }\n  .pl-xl-7,\n  .px-xl-7 {\n    padding-left: 3rem !important;\n  }\n  .p-xl-8 {\n    padding: 3.5rem !important;\n  }\n  .pt-xl-8,\n  .py-xl-8 {\n    padding-top: 3.5rem !important;\n  }\n  .pr-xl-8,\n  .px-xl-8 {\n    padding-right: 3.5rem !important;\n  }\n  .pb-xl-8,\n  .py-xl-8 {\n    padding-bottom: 3.5rem !important;\n  }\n  .pl-xl-8,\n  .px-xl-8 {\n    padding-left: 3.5rem !important;\n  }\n  .p-xl-9 {\n    padding: 4rem !important;\n  }\n  .pt-xl-9,\n  .py-xl-9 {\n    padding-top: 4rem !important;\n  }\n  .pr-xl-9,\n  .px-xl-9 {\n    padding-right: 4rem !important;\n  }\n  .pb-xl-9,\n  .py-xl-9 {\n    padding-bottom: 4rem !important;\n  }\n  .pl-xl-9,\n  .px-xl-9 {\n    padding-left: 4rem !important;\n  }\n  .p-xl-10 {\n    padding: 4.5rem !important;\n  }\n  .pt-xl-10,\n  .py-xl-10 {\n    padding-top: 4.5rem !important;\n  }\n  .pr-xl-10,\n  .px-xl-10 {\n    padding-right: 4.5rem !important;\n  }\n  .pb-xl-10,\n  .py-xl-10 {\n    padding-bottom: 4.5rem !important;\n  }\n  .pl-xl-10,\n  .px-xl-10 {\n    padding-left: 4.5rem !important;\n  }\n  .p-xl-11 {\n    padding: 5rem !important;\n  }\n  .pt-xl-11,\n  .py-xl-11 {\n    padding-top: 5rem !important;\n  }\n  .pr-xl-11,\n  .px-xl-11 {\n    padding-right: 5rem !important;\n  }\n  .pb-xl-11,\n  .py-xl-11 {\n    padding-bottom: 5rem !important;\n  }\n  .pl-xl-11,\n  .px-xl-11 {\n    padding-left: 5rem !important;\n  }\n  .m-xl-n1 {\n    margin: -0.25rem !important;\n  }\n  .mt-xl-n1,\n  .my-xl-n1 {\n    margin-top: -0.25rem !important;\n  }\n  .mr-xl-n1,\n  .mx-xl-n1 {\n    margin-right: -0.25rem !important;\n  }\n  .mb-xl-n1,\n  .my-xl-n1 {\n    margin-bottom: -0.25rem !important;\n  }\n  .ml-xl-n1,\n  .mx-xl-n1 {\n    margin-left: -0.25rem !important;\n  }\n  .m-xl-n2 {\n    margin: -0.5rem !important;\n  }\n  .mt-xl-n2,\n  .my-xl-n2 {\n    margin-top: -0.5rem !important;\n  }\n  .mr-xl-n2,\n  .mx-xl-n2 {\n    margin-right: -0.5rem !important;\n  }\n  .mb-xl-n2,\n  .my-xl-n2 {\n    margin-bottom: -0.5rem !important;\n  }\n  .ml-xl-n2,\n  .mx-xl-n2 {\n    margin-left: -0.5rem !important;\n  }\n  .m-xl-n3 {\n    margin: -1rem !important;\n  }\n  .mt-xl-n3,\n  .my-xl-n3 {\n    margin-top: -1rem !important;\n  }\n  .mr-xl-n3,\n  .mx-xl-n3 {\n    margin-right: -1rem !important;\n  }\n  .mb-xl-n3,\n  .my-xl-n3 {\n    margin-bottom: -1rem !important;\n  }\n  .ml-xl-n3,\n  .mx-xl-n3 {\n    margin-left: -1rem !important;\n  }\n  .m-xl-n4 {\n    margin: -1.5rem !important;\n  }\n  .mt-xl-n4,\n  .my-xl-n4 {\n    margin-top: -1.5rem !important;\n  }\n  .mr-xl-n4,\n  .mx-xl-n4 {\n    margin-right: -1.5rem !important;\n  }\n  .mb-xl-n4,\n  .my-xl-n4 {\n    margin-bottom: -1.5rem !important;\n  }\n  .ml-xl-n4,\n  .mx-xl-n4 {\n    margin-left: -1.5rem !important;\n  }\n  .m-xl-n5 {\n    margin: -2rem !important;\n  }\n  .mt-xl-n5,\n  .my-xl-n5 {\n    margin-top: -2rem !important;\n  }\n  .mr-xl-n5,\n  .mx-xl-n5 {\n    margin-right: -2rem !important;\n  }\n  .mb-xl-n5,\n  .my-xl-n5 {\n    margin-bottom: -2rem !important;\n  }\n  .ml-xl-n5,\n  .mx-xl-n5 {\n    margin-left: -2rem !important;\n  }\n  .m-xl-n6 {\n    margin: -2.5rem !important;\n  }\n  .mt-xl-n6,\n  .my-xl-n6 {\n    margin-top: -2.5rem !important;\n  }\n  .mr-xl-n6,\n  .mx-xl-n6 {\n    margin-right: -2.5rem !important;\n  }\n  .mb-xl-n6,\n  .my-xl-n6 {\n    margin-bottom: -2.5rem !important;\n  }\n  .ml-xl-n6,\n  .mx-xl-n6 {\n    margin-left: -2.5rem !important;\n  }\n  .m-xl-n7 {\n    margin: -3rem !important;\n  }\n  .mt-xl-n7,\n  .my-xl-n7 {\n    margin-top: -3rem !important;\n  }\n  .mr-xl-n7,\n  .mx-xl-n7 {\n    margin-right: -3rem !important;\n  }\n  .mb-xl-n7,\n  .my-xl-n7 {\n    margin-bottom: -3rem !important;\n  }\n  .ml-xl-n7,\n  .mx-xl-n7 {\n    margin-left: -3rem !important;\n  }\n  .m-xl-n8 {\n    margin: -3.5rem !important;\n  }\n  .mt-xl-n8,\n  .my-xl-n8 {\n    margin-top: -3.5rem !important;\n  }\n  .mr-xl-n8,\n  .mx-xl-n8 {\n    margin-right: -3.5rem !important;\n  }\n  .mb-xl-n8,\n  .my-xl-n8 {\n    margin-bottom: -3.5rem !important;\n  }\n  .ml-xl-n8,\n  .mx-xl-n8 {\n    margin-left: -3.5rem !important;\n  }\n  .m-xl-n9 {\n    margin: -4rem !important;\n  }\n  .mt-xl-n9,\n  .my-xl-n9 {\n    margin-top: -4rem !important;\n  }\n  .mr-xl-n9,\n  .mx-xl-n9 {\n    margin-right: -4rem !important;\n  }\n  .mb-xl-n9,\n  .my-xl-n9 {\n    margin-bottom: -4rem !important;\n  }\n  .ml-xl-n9,\n  .mx-xl-n9 {\n    margin-left: -4rem !important;\n  }\n  .m-xl-n10 {\n    margin: -4.5rem !important;\n  }\n  .mt-xl-n10,\n  .my-xl-n10 {\n    margin-top: -4.5rem !important;\n  }\n  .mr-xl-n10,\n  .mx-xl-n10 {\n    margin-right: -4.5rem !important;\n  }\n  .mb-xl-n10,\n  .my-xl-n10 {\n    margin-bottom: -4.5rem !important;\n  }\n  .ml-xl-n10,\n  .mx-xl-n10 {\n    margin-left: -4.5rem !important;\n  }\n  .m-xl-n11 {\n    margin: -5rem !important;\n  }\n  .mt-xl-n11,\n  .my-xl-n11 {\n    margin-top: -5rem !important;\n  }\n  .mr-xl-n11,\n  .mx-xl-n11 {\n    margin-right: -5rem !important;\n  }\n  .mb-xl-n11,\n  .my-xl-n11 {\n    margin-bottom: -5rem !important;\n  }\n  .ml-xl-n11,\n  .mx-xl-n11 {\n    margin-left: -5rem !important;\n  }\n  .m-xl-auto {\n    margin: auto !important;\n  }\n  .mt-xl-auto,\n  .my-xl-auto {\n    margin-top: auto !important;\n  }\n  .mr-xl-auto,\n  .mx-xl-auto {\n    margin-right: auto !important;\n  }\n  .mb-xl-auto,\n  .my-xl-auto {\n    margin-bottom: auto !important;\n  }\n  .ml-xl-auto,\n  .mx-xl-auto {\n    margin-left: auto !important;\n  }\n}\n\n.stretched-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 1;\n  pointer-events: auto;\n  content: \"\";\n  background-color: rgba(0, 0, 0, 0);\n}\n\n.text-monospace {\n  font-family: SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !important;\n}\n\n.text-justify {\n  text-align: justify !important;\n}\n\n.text-wrap {\n  white-space: normal !important;\n}\n\n.text-nowrap {\n  white-space: nowrap !important;\n}\n\n.text-truncate {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.text-left {\n  text-align: left !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n\n.text-center {\n  text-align: center !important;\n}\n\n@media (min-width: 576px) {\n  .text-sm-left {\n    text-align: left !important;\n  }\n  .text-sm-right {\n    text-align: right !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .text-md-left {\n    text-align: left !important;\n  }\n  .text-md-right {\n    text-align: right !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .text-lg-left {\n    text-align: left !important;\n  }\n  .text-lg-right {\n    text-align: right !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .text-xl-left {\n    text-align: left !important;\n  }\n  .text-xl-right {\n    text-align: right !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n}\n\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n\n.font-weight-light {\n  font-weight: 300 !important;\n}\n\n.font-weight-lighter {\n  font-weight: lighter !important;\n}\n\n.font-weight-normal {\n  font-weight: 400 !important;\n}\n\n.font-weight-bold {\n  font-weight: 600 !important;\n}\n\n.font-weight-bolder {\n  font-weight: bolder !important;\n}\n\n.font-italic {\n  font-style: italic !important;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\n.text-primary {\n  color: #377dff !important;\n}\n\na.text-primary:hover, a.text-primary:focus {\n  color: #0052ea !important;\n}\n\n.text-secondary {\n  color: #71869d !important;\n}\n\na.text-secondary:hover, a.text-secondary:focus {\n  color: #4f6072 !important;\n}\n\n.text-success {\n  color: #00c9a7 !important;\n}\n\na.text-success:hover, a.text-success:focus {\n  color: #007d67 !important;\n}\n\n.text-info {\n  color: #09a5be !important;\n}\n\na.text-info:hover, a.text-info:focus {\n  color: #066675 !important;\n}\n\n.text-warning {\n  color: #f5ca99 !important;\n}\n\na.text-warning:hover, a.text-warning:focus {\n  color: #eea653 !important;\n}\n\n.text-danger {\n  color: #ed4c78 !important;\n}\n\na.text-danger:hover, a.text-danger:focus {\n  color: #d7164a !important;\n}\n\n.text-light {\n  color: #f7faff !important;\n}\n\na.text-light:hover, a.text-light:focus {\n  color: #abcaff !important;\n}\n\n.text-dark {\n  color: #21325b !important;\n}\n\na.text-dark:hover, a.text-dark:focus {\n  color: #0d1323 !important;\n}\n\n.text-indigo {\n  color: #2d1582 !important;\n}\n\na.text-indigo:hover, a.text-indigo:focus {\n  color: #160a40 !important;\n}\n\n.text-body {\n  color: #677788 !important;\n}\n\n.text-muted {\n  color: #8c98a4 !important;\n}\n\n.text-black-50 {\n  color: rgba(0, 0, 0, 0.5) !important;\n}\n\n.text-white-50 {\n  color: rgba(255, 255, 255, 0.5) !important;\n}\n\n.text-hide {\n  font: 0/0 a;\n  color: transparent;\n  text-shadow: none;\n  background-color: transparent;\n  border: 0;\n}\n\n.text-decoration-none {\n  text-decoration: none !important;\n}\n\n.text-break {\n  word-break: break-word !important;\n  word-wrap: break-word !important;\n}\n\n.text-reset {\n  color: inherit !important;\n}\n\n.visible {\n  visibility: visible !important;\n}\n\n.invisible {\n  visibility: hidden !important;\n}\n\n@media print {\n  *,\n  *::before,\n  *::after {\n    text-shadow: none !important;\n    box-shadow: none !important;\n  }\n  a:not(.btn) {\n    text-decoration: underline;\n  }\n  abbr[title]::after {\n    content: \" (\" attr(title) \")\";\n  }\n  pre {\n    white-space: pre-wrap !important;\n  }\n  pre,\n  blockquote {\n    border: 0.0625rem solid #97a4af;\n    page-break-inside: avoid;\n  }\n  thead {\n    display: table-header-group;\n  }\n  tr,\n  img {\n    page-break-inside: avoid;\n  }\n  p,\n  h2,\n  h3 {\n    orphans: 3;\n    widows: 3;\n  }\n  h2,\n  h3 {\n    page-break-after: avoid;\n  }\n  @page {\n    size: a3;\n  }\n  body {\n    min-width: 992px !important;\n  }\n  .container {\n    min-width: 992px !important;\n  }\n  .navbar {\n    display: none;\n  }\n  .badge {\n    border: 0.0625rem solid #000;\n  }\n  .table {\n    border-collapse: collapse !important;\n  }\n  .table td,\n  .table th {\n    background-color: #fff !important;\n  }\n  .table-bordered th,\n  .table-bordered td {\n    border: 1px solid #e7eaf3 !important;\n  }\n  .table-dark {\n    color: inherit;\n  }\n  .table-dark th,\n  .table-dark td,\n  .table-dark thead th,\n  .table-dark tbody + tbody {\n    border-color: #e7eaf3;\n  }\n  .table .thead-dark th {\n    color: inherit;\n    border-color: #e7eaf3;\n  }\n}\n\n/*----------------------------------------------------------------------\n  * Front - Responsive Website Template version v3.3.0\n  * Copyright 2018 Htmlstream\n  * Licensed under Bootstrap Themes (https://themes.getbootstrap.com/licenses/)\n------------------------------------------------------------------------*/\n.w-25 {\n  width: 25% !important;\n}\n\n.w-50 {\n  width: 50% !important;\n}\n\n.w-75 {\n  width: 75% !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.w-auto {\n  width: auto !important;\n}\n\n.w-15 {\n  width: 15% !important;\n}\n\n.w-20 {\n  width: 20% !important;\n}\n\n.w-30 {\n  width: 30% !important;\n}\n\n.w-35 {\n  width: 35% !important;\n}\n\n.w-40 {\n  width: 40% !important;\n}\n\n.w-60 {\n  width: 60% !important;\n}\n\n.w-65 {\n  width: 65% !important;\n}\n\n.w-80 {\n  width: 80% !important;\n}\n\n.w-85 {\n  width: 85% !important;\n}\n\n.w-90 {\n  width: 90% !important;\n}\n\n@media (min-width: 576px) {\n  .w-sm-25 {\n    width: 25% !important;\n  }\n  .w-sm-50 {\n    width: 50% !important;\n  }\n  .w-sm-75 {\n    width: 75% !important;\n  }\n  .w-sm-100 {\n    width: 100% !important;\n  }\n  .w-sm-auto {\n    width: auto !important;\n  }\n  .w-sm-15 {\n    width: 15% !important;\n  }\n  .w-sm-20 {\n    width: 20% !important;\n  }\n  .w-sm-30 {\n    width: 30% !important;\n  }\n  .w-sm-35 {\n    width: 35% !important;\n  }\n  .w-sm-40 {\n    width: 40% !important;\n  }\n  .w-sm-60 {\n    width: 60% !important;\n  }\n  .w-sm-65 {\n    width: 65% !important;\n  }\n  .w-sm-80 {\n    width: 80% !important;\n  }\n  .w-sm-85 {\n    width: 85% !important;\n  }\n  .w-sm-90 {\n    width: 90% !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .w-md-25 {\n    width: 25% !important;\n  }\n  .w-md-50 {\n    width: 50% !important;\n  }\n  .w-md-75 {\n    width: 75% !important;\n  }\n  .w-md-100 {\n    width: 100% !important;\n  }\n  .w-md-auto {\n    width: auto !important;\n  }\n  .w-md-15 {\n    width: 15% !important;\n  }\n  .w-md-20 {\n    width: 20% !important;\n  }\n  .w-md-30 {\n    width: 30% !important;\n  }\n  .w-md-35 {\n    width: 35% !important;\n  }\n  .w-md-40 {\n    width: 40% !important;\n  }\n  .w-md-60 {\n    width: 60% !important;\n  }\n  .w-md-65 {\n    width: 65% !important;\n  }\n  .w-md-80 {\n    width: 80% !important;\n  }\n  .w-md-85 {\n    width: 85% !important;\n  }\n  .w-md-90 {\n    width: 90% !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .w-lg-25 {\n    width: 25% !important;\n  }\n  .w-lg-50 {\n    width: 50% !important;\n  }\n  .w-lg-75 {\n    width: 75% !important;\n  }\n  .w-lg-100 {\n    width: 100% !important;\n  }\n  .w-lg-auto {\n    width: auto !important;\n  }\n  .w-lg-15 {\n    width: 15% !important;\n  }\n  .w-lg-20 {\n    width: 20% !important;\n  }\n  .w-lg-30 {\n    width: 30% !important;\n  }\n  .w-lg-35 {\n    width: 35% !important;\n  }\n  .w-lg-40 {\n    width: 40% !important;\n  }\n  .w-lg-60 {\n    width: 60% !important;\n  }\n  .w-lg-65 {\n    width: 65% !important;\n  }\n  .w-lg-80 {\n    width: 80% !important;\n  }\n  .w-lg-85 {\n    width: 85% !important;\n  }\n  .w-lg-90 {\n    width: 90% !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .w-xl-25 {\n    width: 25% !important;\n  }\n  .w-xl-50 {\n    width: 50% !important;\n  }\n  .w-xl-75 {\n    width: 75% !important;\n  }\n  .w-xl-100 {\n    width: 100% !important;\n  }\n  .w-xl-auto {\n    width: auto !important;\n  }\n  .w-xl-15 {\n    width: 15% !important;\n  }\n  .w-xl-20 {\n    width: 20% !important;\n  }\n  .w-xl-30 {\n    width: 30% !important;\n  }\n  .w-xl-35 {\n    width: 35% !important;\n  }\n  .w-xl-40 {\n    width: 40% !important;\n  }\n  .w-xl-60 {\n    width: 60% !important;\n  }\n  .w-xl-65 {\n    width: 65% !important;\n  }\n  .w-xl-80 {\n    width: 80% !important;\n  }\n  .w-xl-85 {\n    width: 85% !important;\n  }\n  .w-xl-90 {\n    width: 90% !important;\n  }\n}\n\n.space-0,\n.space-top-0 {\n  padding-top: 0 !important;\n}\n\n.space-0,\n.space-bottom-0 {\n  padding-bottom: 0 !important;\n}\n\n.space-1,\n.space-top-1 {\n  padding-top: 2rem !important;\n}\n\n.space-1,\n.space-bottom-1 {\n  padding-bottom: 2rem !important;\n}\n\n.space-2,\n.space-top-2 {\n  padding-top: 4rem !important;\n}\n\n.space-2,\n.space-bottom-2 {\n  padding-bottom: 4rem !important;\n}\n\n.space-3,\n.space-top-3 {\n  padding-top: 8rem !important;\n}\n\n.space-3,\n.space-bottom-3 {\n  padding-bottom: 8rem !important;\n}\n\n.space-4,\n.space-top-4 {\n  padding-top: 12.5rem !important;\n}\n\n.space-4,\n.space-bottom-4 {\n  padding-bottom: 12.5rem !important;\n}\n\n.space-5,\n.space-top-5 {\n  padding-top: 15rem !important;\n}\n\n.space-5,\n.space-bottom-5 {\n  padding-bottom: 15rem !important;\n}\n\n@media (min-width: 576px) {\n  .space-sm-0,\n  .space-top-sm-0 {\n    padding-top: 0 !important;\n  }\n  .space-sm-0,\n  .space-bottom-sm-0 {\n    padding-bottom: 0 !important;\n  }\n  .space-sm-1,\n  .space-top-sm-1 {\n    padding-top: 2rem !important;\n  }\n  .space-sm-1,\n  .space-bottom-sm-1 {\n    padding-bottom: 2rem !important;\n  }\n  .space-sm-2,\n  .space-top-sm-2 {\n    padding-top: 4rem !important;\n  }\n  .space-sm-2,\n  .space-bottom-sm-2 {\n    padding-bottom: 4rem !important;\n  }\n  .space-sm-3,\n  .space-top-sm-3 {\n    padding-top: 8rem !important;\n  }\n  .space-sm-3,\n  .space-bottom-sm-3 {\n    padding-bottom: 8rem !important;\n  }\n  .space-sm-4,\n  .space-top-sm-4 {\n    padding-top: 12.5rem !important;\n  }\n  .space-sm-4,\n  .space-bottom-sm-4 {\n    padding-bottom: 12.5rem !important;\n  }\n  .space-sm-5,\n  .space-top-sm-5 {\n    padding-top: 15rem !important;\n  }\n  .space-sm-5,\n  .space-bottom-sm-5 {\n    padding-bottom: 15rem !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .space-md-0,\n  .space-top-md-0 {\n    padding-top: 0 !important;\n  }\n  .space-md-0,\n  .space-bottom-md-0 {\n    padding-bottom: 0 !important;\n  }\n  .space-md-1,\n  .space-top-md-1 {\n    padding-top: 2rem !important;\n  }\n  .space-md-1,\n  .space-bottom-md-1 {\n    padding-bottom: 2rem !important;\n  }\n  .space-md-2,\n  .space-top-md-2 {\n    padding-top: 4rem !important;\n  }\n  .space-md-2,\n  .space-bottom-md-2 {\n    padding-bottom: 4rem !important;\n  }\n  .space-md-3,\n  .space-top-md-3 {\n    padding-top: 8rem !important;\n  }\n  .space-md-3,\n  .space-bottom-md-3 {\n    padding-bottom: 8rem !important;\n  }\n  .space-md-4,\n  .space-top-md-4 {\n    padding-top: 12.5rem !important;\n  }\n  .space-md-4,\n  .space-bottom-md-4 {\n    padding-bottom: 12.5rem !important;\n  }\n  .space-md-5,\n  .space-top-md-5 {\n    padding-top: 15rem !important;\n  }\n  .space-md-5,\n  .space-bottom-md-5 {\n    padding-bottom: 15rem !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .space-lg-0,\n  .space-top-lg-0 {\n    padding-top: 0 !important;\n  }\n  .space-lg-0,\n  .space-bottom-lg-0 {\n    padding-bottom: 0 !important;\n  }\n  .space-lg-1,\n  .space-top-lg-1 {\n    padding-top: 2rem !important;\n  }\n  .space-lg-1,\n  .space-bottom-lg-1 {\n    padding-bottom: 2rem !important;\n  }\n  .space-lg-2,\n  .space-top-lg-2 {\n    padding-top: 4rem !important;\n  }\n  .space-lg-2,\n  .space-bottom-lg-2 {\n    padding-bottom: 4rem !important;\n  }\n  .space-lg-3,\n  .space-top-lg-3 {\n    padding-top: 8rem !important;\n  }\n  .space-lg-3,\n  .space-bottom-lg-3 {\n    padding-bottom: 8rem !important;\n  }\n  .space-lg-4,\n  .space-top-lg-4 {\n    padding-top: 12.5rem !important;\n  }\n  .space-lg-4,\n  .space-bottom-lg-4 {\n    padding-bottom: 12.5rem !important;\n  }\n  .space-lg-5,\n  .space-top-lg-5 {\n    padding-top: 15rem !important;\n  }\n  .space-lg-5,\n  .space-bottom-lg-5 {\n    padding-bottom: 15rem !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .space-xl-0,\n  .space-top-xl-0 {\n    padding-top: 0 !important;\n  }\n  .space-xl-0,\n  .space-bottom-xl-0 {\n    padding-bottom: 0 !important;\n  }\n  .space-xl-1,\n  .space-top-xl-1 {\n    padding-top: 2rem !important;\n  }\n  .space-xl-1,\n  .space-bottom-xl-1 {\n    padding-bottom: 2rem !important;\n  }\n  .space-xl-2,\n  .space-top-xl-2 {\n    padding-top: 4rem !important;\n  }\n  .space-xl-2,\n  .space-bottom-xl-2 {\n    padding-bottom: 4rem !important;\n  }\n  .space-xl-3,\n  .space-top-xl-3 {\n    padding-top: 8rem !important;\n  }\n  .space-xl-3,\n  .space-bottom-xl-3 {\n    padding-bottom: 8rem !important;\n  }\n  .space-xl-4,\n  .space-top-xl-4 {\n    padding-top: 12.5rem !important;\n  }\n  .space-xl-4,\n  .space-bottom-xl-4 {\n    padding-bottom: 12.5rem !important;\n  }\n  .space-xl-5,\n  .space-top-xl-5 {\n    padding-top: 15rem !important;\n  }\n  .space-xl-5,\n  .space-bottom-xl-5 {\n    padding-bottom: 15rem !important;\n  }\n}\n\n/*------------------------------------\n  Default Styles\n------------------------------------*/\nmain {\n  position: relative;\n}\n\nh1, h2, h3, h4, h5, h6,\n.h1, .h2, .h3, .h4, .h5, .h6 {\n  color: #1e2022;\n}\n\nfigure {\n  margin-bottom: 0;\n}\n\nsvg {\n  margin-bottom: -8px;\n  vertical-align: baseline;\n}\n\nsup {\n  right: -.5rem;\n}\n\n/*------------------------------------\n  Highlight Color\n------------------------------------*/\n::-moz-selection {\n  color: #fff;\n  background-color: #377dff;\n}\n\n::selection {\n  color: #fff;\n  background-color: #377dff;\n}\n\n.bg-primary ::-moz-selection {\n  color: #377dff;\n  background-color: #fff;\n}\n\n.bg-primary ::selection {\n  color: #377dff;\n  background-color: #fff;\n}\n\n/*------------------------------------\n  Accessibility\n------------------------------------*/\n:focus,\na:focus,\nbutton:focus {\n  outline: 0;\n}\n\n.form-control:focus {\n  box-shadow: 0 0 0 0 transparent;\n}\n\n.btn:focus, .btn.focus, .btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus, .btn:not([disabled]):not(.disabled):active, .btn:not([disabled]):not(.disabled).active {\n  box-shadow: 0 0 0 0 transparent;\n}\n\n.btn:not(:disabled):not(.disabled):active:focus, .btn:not(:disabled):not(.disabled).active:focus,\n.show > .btn.dropdown-toggle:focus {\n  box-shadow: 0 0 0 0 transparent;\n}\n\n.custom-select:focus,\n.page-link:focus {\n  box-shadow: 0 0 0 0 transparent;\n}\n\n.custom-control-input:checked ~ .custom-control-label::before,\n.custom-control-input:focus ~ .custom-control-label::before,\n.custom-control-input:active ~ .custom-control-label::before {\n  box-shadow: 0 0 0 0 transparent;\n}\n\n.custom-file-input:focus ~ .custom-file-label {\n  box-shadow: 0 0 0 0 transparent;\n}\n\n.bootstrap-select .dropdown-toggle:focus {\n  outline: 0 !important;\n}\n\n/*------------------------------------\n  Print styles\n------------------------------------*/\n@media print {\n  header, footer, .btn {\n    display: none;\n  }\n}\n\n/*------------------------------------\n  Skippy\n------------------------------------*/\n.skippy {\n  display: none;\n}\n\n/*------------------------------------\n  List Article\n------------------------------------*/\n.list-article > li:not(:last-child) {\n  padding-bottom: 1rem;\n}\n\n.list-article .list-article > li:first-child {\n  padding-top: 1rem;\n}\n\n.list-article .list-article > li:last-child {\n  padding-bottom: 0;\n}\n\n.list-sm-article > li:not(:last-child) {\n  padding-bottom: 0.5rem;\n}\n\n.list-sm-article .list-sm-article > li:first-child {\n  padding-top: 0.5rem;\n}\n\n.list-sm-article .list-sm-article > li:last-child {\n  padding-bottom: 0;\n}\n\n.list-lg-article > li:not(:last-child) {\n  padding-bottom: 2rem;\n}\n\n.list-lg-article .list-lg-article > li:first-child {\n  padding-top: 2rem;\n}\n\n.list-lg-article .list-lg-article > li:last-child {\n  padding-bottom: 0;\n}\n\n/*------------------------------------\n  List Group\n------------------------------------*/\n.list-group-item:first-child {\n  border-top-left-radius: 0.3125rem;\n  border-top-right-radius: 0.3125rem;\n}\n\n.list-group-item:last-child {\n  border-bottom-right-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n}\n\n.list-group-icon {\n  width: 1.25rem;\n  text-align: center;\n  margin-right: 0.25rem;\n}\n\n.list-group-no-gutters .list-group-item {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.list-group-item-light {\n  background-color: #f7faff;\n}\n\n/* Sizes */\n.list-group-lg .list-group-icon {\n  font-size: 1.25rem;\n  width: 2.5rem;\n  margin-right: 0.5rem;\n}\n\n/*------------------------------------\n  List Separator\n------------------------------------*/\n.list-separator {\n  margin-bottom: 0;\n}\n\n.list-separator .list-inline-item {\n  position: relative;\n  margin-left: 0;\n  margin-right: -0.25rem;\n}\n\n.list-separator .list-inline-item:not(:last-child) {\n  padding-right: 2rem;\n}\n\n.list-separator .list-inline-item:not(:last-child)::after {\n  position: absolute;\n  top: calc(50% - 0.15625rem);\n  right: 0.84375rem;\n  width: 0.3125rem;\n  height: 0.3125rem;\n  background-color: #bdc5d1;\n  border-radius: 0.3125rem;\n  content: \"\";\n}\n\n.list-separator .list-separator-link {\n  color: #677788;\n}\n\n.list-separator .list-separator-link:hover {\n  color: #0052ea;\n}\n\n/*------------------------------------\n  Links\n------------------------------------*/\n.link {\n  font-size: 0.875rem;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.link-icon {\n  position: relative;\n  line-height: 1;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  vertical-align: middle;\n  text-align: center;\n  width: 1.375rem;\n  height: 1.375rem;\n  font-size: 1rem;\n  color: #377dff;\n  background-color: rgba(55, 125, 255, 0.1);\n  border-radius: 50%;\n  transition: 0.3s;\n}\n\n.link:hover .link-icon {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n/* Collapse */\n.link-collapse[aria-expanded=\"false\"] .link-collapse-default {\n  display: inline-block;\n}\n\n.link-collapse[aria-expanded=\"false\"] .link-collapse-active {\n  display: none;\n}\n\n.link-collapse[aria-expanded=\"true\"] .link-collapse-default {\n  display: none;\n}\n\n.link-collapse[aria-expanded=\"true\"] .link-collapse-active {\n  display: inline-block;\n}\n\n/* Link Underline */\n.link-underline {\n  color: #8c98a4;\n  border-bottom: 0.0625rem dashed #97a4af;\n}\n\n.link-underline:hover {\n  border-color: #0052ea;\n}\n\n.link-underline-toggle-default {\n  display: inline-block;\n}\n\n.link-underline-toggle-toggled {\n  display: none;\n}\n\n.link-underline.toggled .link-underline-toggle-default {\n  display: none;\n}\n\n.link-underline.toggled .link-underline-toggle-toggled {\n  display: inline-block;\n}\n\n/* Link Underline Light */\n.link-underline-light {\n  color: rgba(255, 255, 255, 0.7);\n  border-bottom: 0.0625rem dashed rgba(255, 255, 255, 0.7);\n}\n\n.link-underline-light:hover {\n  color: #fff;\n  border-color: rgba(255, 255, 255, 0.7);\n}\n\n/*------------------------------------\n  Header Default\n------------------------------------*/\n.header {\n  position: relative;\n  right: 0;\n  left: 0;\n  width: 100%;\n  z-index: 1001;\n}\n\n.header-section {\n  position: relative;\n  z-index: 1;\n  background-color: #fff;\n}\n\n.header-section-divider {\n  border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.2);\n}\n\n.header-box-shadow .header-section {\n  box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);\n}\n\n.header-box-shadow-on-scroll.scrolled .header-section {\n  box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);\n}\n\n/* Navbar Brand */\n.navbar-brand,\n.navbar-brand > img {\n  width: 7.5rem;\n}\n\n/* Navbar Toggler */\n.navbar-toggler {\n  background-color: #f8fafd;\n}\n\n.navbar-toggler .navbar-toggler-default {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.navbar-toggler .navbar-toggler-toggled {\n  display: none;\n}\n\n.navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-default {\n  display: none;\n}\n\n.navbar-toggler[aria-expanded=\"true\"] .navbar-toggler-toggled {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n/* Nav Item */\n.header .navbar-nav-item:first-child .nav-link {\n  padding-left: 0;\n}\n\n.navbar-nav-item:hover .nav-link, .navbar-nav-item:focus .nav-link {\n  color: #377dff;\n}\n\n/* Nav Link */\n.header .navbar-nav-item.active .nav-link,\n.header .nav-link.active {\n  color: #377dff;\n}\n\n.header .nav-link {\n  color: #677788;\n}\n\n.header .nav-link-toggle {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.header .nav-link-toggle::after {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23677788' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  content: \"\";\n  margin-left: 0.5rem;\n  transition: 0.3s ease;\n}\n\n/* Dropdown */\n.header .navbar-nav .dropdown-menu {\n  margin-top: -0.125rem;\n}\n\n.header .navbar-nav .dropdown-menu.hs-mega-menu {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.header .navbar-nav .dropdown-item {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.header .dropdown-item-toggle {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.header .dropdown-item-toggle::after {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23677788' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M15.78,11.28a.75.75,0,0,1,.22.53v.38a.77.77,0,0,1-.22.53l-5.14,5.13a.5.5,0,0,1-.71,0l-.71-.71a.49.49,0,0,1,0-.7L13.67,12,9.22,7.56a.5.5,0,0,1,0-.71l.71-.7a.5.5,0,0,1,.71,0Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  content: \"\";\n  margin-left: auto;\n  transition: 0.3s ease;\n}\n\n.header .hs-mega-menu .dropdown-item {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n[class*=\"navbar-expand\"] .dropdown-item {\n  background-color: transparent;\n}\n\n[class*=\"navbar-expand\"] .dropdown-item.active:not(:focus):not(:active), [class*=\"navbar-expand\"] .dropdown-item:hover {\n  color: #377dff;\n  background-color: transparent;\n}\n\n/* Promo */\n.navbar-promo {\n  background-color: #f8fafd;\n}\n\n.navbar-promo-inner {\n  color: inherit;\n  padding: 2rem 2rem;\n}\n\n.navbar-promo-item {\n  margin-left: 1.5rem;\n  margin-right: 1.5rem;\n}\n\n.navbar-promo-item ~ .navbar-promo-item {\n  border-top: 0.0625rem solid #e7eaf3;\n}\n\n.navbar-promo-link {\n  display: block;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  margin-top: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.navbar-promo-link.disabled {\n  opacity: .7;\n  pointer-events: none;\n}\n\n.navbar-promo-link:hover .navbar-promo-title {\n  color: #377dff;\n}\n\n.navbar-promo-card {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-clip: border-box;\n}\n\n.navbar-promo-card-deck {\n  display: block;\n}\n\n.navbar-promo-card-deck:not(:last-child) .navbar-promo-item {\n  border-bottom: 0.0625rem solid #e7eaf3;\n}\n\n.navbar-promo-card-deck .navbar-promo-item {\n  border-top: none;\n}\n\n.navbar-promo-card-body {\n  -ms-flex: 1 1 auto;\n      flex: 1 1 auto;\n}\n\n.navbar-promo-icon {\n  width: 100%;\n  max-width: 2.75rem;\n  margin-right: 1rem;\n}\n\n.navbar-promo-title {\n  display: block;\n  color: #1e2022;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.navbar-promo-text {\n  display: block;\n  font-size: 0.875rem;\n  color: #677788;\n}\n\n.navbar-promo-footer {\n  background-color: #f8fafd;\n  border-bottom-right-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n.navbar-promo-footer-item {\n  padding-left: 1.5rem;\n  padding-right: 1.5rem;\n}\n\n.navbar-promo-footer-text {\n  display: block;\n  font-size: 0.8125rem;\n}\n\n.navbar-promo-footer-ver-divider {\n  position: relative;\n}\n\n.navbar-promo-footer-ver-divider::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  border-right: 0.0625rem solid #e7eaf3;\n  content: \"\";\n}\n\n/* Banner */\n.navbar-banner {\n  position: relative;\n  height: 100%;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: top center;\n  border-bottom-left-radius: 0.3125rem;\n}\n\n.navbar-banner::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  background-color: rgba(30, 32, 34, 0.5);\n  border-bottom-left-radius: 0.3125rem;\n  content: \"\";\n}\n\n.navbar-banner-content {\n  z-index: 1;\n  width: 100%;\n  text-align: center;\n  padding: 2rem 2rem;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n}\n\n/* Product Banner */\n.navbar-product-banner {\n  background-color: #f8fafd;\n  border-bottom-right-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n  padding-right: 1.5rem;\n}\n\n.navbar-product-banner-content {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n/*------------------------------------\n  Header Helpers\n------------------------------------*/\n.header-invisible {\n  display: none;\n}\n\n.header-moved-up {\n  -webkit-transform: translate3d(0, -100%, 0);\n          transform: translate3d(0, -100%, 0);\n}\n\n.header-moved-up.header-hide-topbar {\n  -webkit-transform: translate3d(0, -36px, 0);\n          transform: translate3d(0, -36px, 0);\n}\n\n.header-faded {\n  opacity: 0;\n  visibility: hidden;\n}\n\n.header-section-hidden {\n  position: relative;\n}\n\n.header[data-hs-header-options*=\"fixMoment\"] {\n  transition: 0.3s ease;\n}\n\n.header.header-untransitioned {\n  transition: none;\n}\n\n.header.js-header-fix-moment {\n  position: fixed;\n  top: 0;\n  bottom: auto;\n}\n\n.header.js-header-fix-moment .header-hide-content {\n  display: none;\n}\n\n.header-fix-top {\n  position: fixed;\n}\n\n.header.header-fix-top[data-hs-header-options*=\"effectCompensation\"] {\n  transition: none;\n}\n\n/*------------------------------------\n  Nav Alignments\n------------------------------------*/\n@media (min-width: 992px) {\n  .header .navbar-body,\n  .header .navbar-nav {\n    margin-left: auto;\n  }\n  .left-aligned-navbar .navbar-body,\n  .left-aligned-navbar .navbar-nav {\n    width: 100%;\n    margin-left: 0;\n    margin-right: auto;\n  }\n  .left-aligned-navbar .navbar-brand {\n    margin-left: 0;\n    margin-right: 3rem;\n  }\n  .left-aligned-navbar .navbar-nav-last-item {\n    margin-left: auto;\n  }\n  .center-aligned-navbar .navbar-body,\n  .center-aligned-navbar .navbar-nav {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n@media (min-width: 768px) {\n  .center-aligned-navbar.header-abs-top-sm .navbar-body,\n  .center-aligned-navbar.header-abs-top-sm .navbar-nav {\n    margin-left: auto;\n    margin-right: auto;\n  }\n}\n\n/*------------------------------------\n  Header Default\n------------------------------------*/\n.navbar-nav-scroll {\n  max-width: 100%;\n  height: 4.625rem;\n  overflow: hidden;\n}\n\n.navbar-nav-scroll .navbar-nav {\n  overflow-x: auto;\n  white-space: nowrap;\n  -webkit-overflow-scrolling: touch;\n}\n\n/*------------------------------------\n  Nav Wrap\n------------------------------------*/\n.navbar-nav-wrap {\n  width: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.navbar-expand .navbar-nav-wrap {\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n}\n\n.navbar-expand .navbar-nav-wrap-content {\n  -ms-flex-order: 3;\n      order: 3;\n}\n\n.navbar-expand .navbar-nav-wrap-toggler {\n  -ms-flex-order: 3;\n      order: 3;\n  text-align: right;\n}\n\n.navbar-expand .navbar-nav-wrap-collapse {\n  -ms-flex-order: 2;\n      order: 2;\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm .navbar-nav-wrap {\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n  }\n  .navbar-expand-sm .navbar-nav-wrap-content {\n    -ms-flex-order: 3;\n        order: 3;\n  }\n  .navbar-expand-sm .navbar-nav-wrap-toggler {\n    -ms-flex-order: 3;\n        order: 3;\n    text-align: right;\n  }\n  .navbar-expand-sm .navbar-nav-wrap-collapse {\n    -ms-flex-order: 2;\n        order: 2;\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-expand-md .navbar-nav-wrap {\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n  }\n  .navbar-expand-md .navbar-nav-wrap-content {\n    -ms-flex-order: 3;\n        order: 3;\n  }\n  .navbar-expand-md .navbar-nav-wrap-toggler {\n    -ms-flex-order: 3;\n        order: 3;\n    text-align: right;\n  }\n  .navbar-expand-md .navbar-nav-wrap-collapse {\n    -ms-flex-order: 2;\n        order: 2;\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-expand-lg .navbar-nav-wrap {\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n  }\n  .navbar-expand-lg .navbar-nav-wrap-content {\n    -ms-flex-order: 3;\n        order: 3;\n  }\n  .navbar-expand-lg .navbar-nav-wrap-toggler {\n    -ms-flex-order: 3;\n        order: 3;\n    text-align: right;\n  }\n  .navbar-expand-lg .navbar-nav-wrap-collapse {\n    -ms-flex-order: 2;\n        order: 2;\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar-expand-xl .navbar-nav-wrap {\n    -ms-flex-pack: justify;\n        justify-content: space-between;\n  }\n  .navbar-expand-xl .navbar-nav-wrap-content {\n    -ms-flex-order: 3;\n        order: 3;\n  }\n  .navbar-expand-xl .navbar-nav-wrap-toggler {\n    -ms-flex-order: 3;\n        order: 3;\n    text-align: right;\n  }\n  .navbar-expand-xl .navbar-nav-wrap-collapse {\n    -ms-flex-order: 2;\n        order: 2;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm .navbar-nav-wrap {\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n  }\n  .navbar-expand-sm .navbar-nav-wrap-brand {\n    margin-right: auto;\n  }\n  .navbar-expand-sm .navbar-nav-wrap-content {\n    text-align: center;\n    margin-right: 0.5rem;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .navbar-expand-md .navbar-nav-wrap {\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n  }\n  .navbar-expand-md .navbar-nav-wrap-brand {\n    margin-right: auto;\n  }\n  .navbar-expand-md .navbar-nav-wrap-content {\n    text-align: center;\n    margin-right: 0.5rem;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .navbar-expand-lg .navbar-nav-wrap {\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n  }\n  .navbar-expand-lg .navbar-nav-wrap-brand {\n    margin-right: auto;\n  }\n  .navbar-expand-lg .navbar-nav-wrap-content {\n    text-align: center;\n    margin-right: 0.5rem;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl .navbar-nav-wrap {\n    -ms-flex-pack: end;\n        justify-content: flex-end;\n  }\n  .navbar-expand-xl .navbar-nav-wrap-brand {\n    margin-right: auto;\n  }\n  .navbar-expand-xl .navbar-nav-wrap-content {\n    text-align: center;\n    margin-right: 0.5rem;\n  }\n}\n\n.navbar-expand .navbar-nav-wrap {\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n}\n\n.navbar-expand .navbar-nav-wrap-brand {\n  margin-right: auto;\n}\n\n.navbar-expand .navbar-nav-wrap-content {\n  text-align: center;\n  margin-right: 0.5rem;\n}\n\n@media (min-width: 768px) and (max-width: 991.98px) {\n  .navbar-expand-md .navbar-nav-wrap-brand {\n    -ms-flex: 0 0 100%;\n        flex: 0 0 100%;\n    max-width: 100%;\n  }\n}\n\n/*------------------------------------\n  Fullscreen\n------------------------------------*/\n.fullscreen {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  visibility: hidden;\n}\n\n.fullscreen-container, .fullscreen-overlay {\n  transition: opacity 0.4s ease-in-out, visibility 0.4s ease-in-out;\n}\n\n.fullscreen-container {\n  position: relative;\n  z-index: 1000;\n  height: 100%;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n  opacity: 0;\n  visibility: hidden;\n}\n\n.fullscreen-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 999;\n  opacity: 0;\n  visibility: hidden;\n  background-image: linear-gradient(to right, rgba(33, 50, 91, 0.9) 0%, rgba(33, 50, 91, 0.9) 100%);\n  background-repeat: repeat-x;\n  transition-delay: 0.5s;\n}\n\n.fullscreen-body {\n  max-height: 75vh;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.fullscreen-body::-webkit-scrollbar {\n  width: 0.5rem;\n}\n\n.fullscreen-body::-webkit-scrollbar-thumb {\n  background-color: rgba(189, 197, 209, 0.6);\n  visibility: hidden;\n}\n\n.fullscreen-body:hover::-webkit-scrollbar-thumb {\n  visibility: visible;\n}\n\n.fullscreen.fullscreen-showed {\n  visibility: visible;\n}\n\n.fullscreen.fullscreen-showed .fullscreen-container,\n.fullscreen.fullscreen-showed .fullscreen-overlay {\n  opacity: 1;\n  visibility: visible;\n}\n\n.fullscreen.fullscreen-showed .fullscreen-overlay {\n  transition-delay: 0s;\n}\n\n.fullscreen.fullscreen-showed .fullscreen-container {\n  transition-delay: 0.5s;\n}\n\n.header .fullscreen-toggler.navbar-toggler {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  z-index: 1001;\n}\n\n.header .fullscreen-toggler.navbar-toggler .navbar-toggler-default {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.header .fullscreen-toggler.navbar-toggler .navbar-toggler-toggled {\n  display: none;\n}\n\n.header .fullscreen-toggler.navbar-toggler[aria-pressed=\"true\"] .navbar-toggler-default {\n  display: none;\n}\n\n.header .fullscreen-toggler.navbar-toggler[aria-pressed=\"true\"] .navbar-toggler-toggled {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n/*------------------------------------\n  Header Fullscreen Style\n------------------------------------*/\n.fullscreen-nav {\n  padding-left: 0;\n  list-style: none;\n  margin-bottom: 0;\n}\n\n.fullscreen-nav-list {\n  list-style: none;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.fullscreen-nav-link {\n  display: inline-block;\n  font-size: 1.375rem;\n  color: #fff;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n@media (min-width: 992px) {\n  .fullscreen-nav-link {\n    font-size: 1.75rem;\n  }\n}\n\n.fullscreen-nav-link:hover {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.fullscreen-submenu {\n  position: relative;\n  transition: 0.3s ease-in-out;\n}\n\n.fullscreen-submenu .fullscreen-submenu .fullscreen-submenu-list {\n  margin-left: 1rem;\n}\n\n.fullscreen-submenu .fullscreen-nav-list {\n  border-left: 0.125rem solid rgba(255, 255, 255, 0.6);\n  padding-left: 0;\n}\n\n.fullscreen-submenu-nav-link {\n  display: inline-block;\n  color: #fff;\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n  padding-right: 1rem;\n  padding-left: 1rem;\n}\n\n.fullscreen-submenu-nav-link.disabled {\n  color: rgba(255, 255, 255, 0.7);\n  pointer-events: none;\n}\n\n.fullscreen-submenu-nav-link:hover {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.fullscreen-submenu-list {\n  list-style: none;\n  border-left: 0.125rem solid rgba(255, 255, 255, 0.6);\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.fullscreen .fullscreen-submenu-list-link {\n  display: inline-block;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.fullscreen .fullscreen-submenu-list-link:hover {\n  color: #fff;\n}\n\n/*------------------------------------\n  Transparent Header\n------------------------------------*/\n.header-bg-transparent:not(.js-header-fix-moment) .search-push-top[style*=\"display: block\"] + .header-section {\n  background-color: #fff;\n}\n\n.header-bg-transparent:not(.js-header-fix-moment) .header-section {\n  background-color: transparent;\n}\n\n.header-bg-transparent .navbar-brand-collapsed,\n.header-bg-transparent .navbar-brand-on-scroll {\n  display: none;\n}\n\n.header-bg-transparent.js-header-fix-moment .navbar-brand-default {\n  display: none;\n}\n\n.header-bg-transparent.js-header-fix-moment .navbar-brand-on-scroll {\n  display: inline-block;\n}\n\n@media (min-width: 576px) and (min-width: 576px) {\n  .header-bg-transparent-sm:not(.js-header-fix-moment) .search-push-top[style*=\"display: block\"] + .header-section {\n    background-color: #fff;\n  }\n  .header-bg-transparent-sm:not(.js-header-fix-moment) .header-section {\n    background-color: transparent;\n  }\n}\n\n@media (min-width: 576px) {\n  .header-bg-transparent-sm .navbar-brand-collapsed,\n  .header-bg-transparent-sm .navbar-brand-on-scroll {\n    display: none;\n  }\n  .header-bg-transparent-sm.js-header-fix-moment .navbar-brand-default {\n    display: none;\n  }\n  .header-bg-transparent-sm.js-header-fix-moment .navbar-brand-on-scroll {\n    display: inline-block;\n  }\n}\n\n@media (min-width: 768px) and (min-width: 768px) {\n  .header-bg-transparent-md:not(.js-header-fix-moment) .search-push-top[style*=\"display: block\"] + .header-section {\n    background-color: #fff;\n  }\n  .header-bg-transparent-md:not(.js-header-fix-moment) .header-section {\n    background-color: transparent;\n  }\n}\n\n@media (min-width: 768px) {\n  .header-bg-transparent-md .navbar-brand-collapsed,\n  .header-bg-transparent-md .navbar-brand-on-scroll {\n    display: none;\n  }\n  .header-bg-transparent-md.js-header-fix-moment .navbar-brand-default {\n    display: none;\n  }\n  .header-bg-transparent-md.js-header-fix-moment .navbar-brand-on-scroll {\n    display: inline-block;\n  }\n}\n\n@media (min-width: 992px) and (min-width: 992px) {\n  .header-bg-transparent-lg:not(.js-header-fix-moment) .search-push-top[style*=\"display: block\"] + .header-section {\n    background-color: #fff;\n  }\n  .header-bg-transparent-lg:not(.js-header-fix-moment) .header-section {\n    background-color: transparent;\n  }\n}\n\n@media (min-width: 992px) {\n  .header-bg-transparent-lg .navbar-brand-collapsed,\n  .header-bg-transparent-lg .navbar-brand-on-scroll {\n    display: none;\n  }\n  .header-bg-transparent-lg.js-header-fix-moment .navbar-brand-default {\n    display: none;\n  }\n  .header-bg-transparent-lg.js-header-fix-moment .navbar-brand-on-scroll {\n    display: inline-block;\n  }\n}\n\n@media (min-width: 1200px) and (min-width: 1200px) {\n  .header-bg-transparent-xl:not(.js-header-fix-moment) .search-push-top[style*=\"display: block\"] + .header-section {\n    background-color: #fff;\n  }\n  .header-bg-transparent-xl:not(.js-header-fix-moment) .header-section {\n    background-color: transparent;\n  }\n}\n\n@media (min-width: 1200px) {\n  .header-bg-transparent-xl .navbar-brand-collapsed,\n  .header-bg-transparent-xl .navbar-brand-on-scroll {\n    display: none;\n  }\n  .header-bg-transparent-xl.js-header-fix-moment .navbar-brand-default {\n    display: none;\n  }\n  .header-bg-transparent-xl.js-header-fix-moment .navbar-brand-on-scroll {\n    display: inline-block;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .header-bg-transparent-sm .navbar-brand-default,\n  .header-bg-transparent-sm .navbar-brand-on-scroll {\n    display: none;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .header-bg-transparent-md .navbar-brand-default,\n  .header-bg-transparent-md .navbar-brand-on-scroll {\n    display: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .header-bg-transparent-lg .navbar-brand-default,\n  .header-bg-transparent-lg .navbar-brand-on-scroll {\n    display: none;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .header-bg-transparent-xl .navbar-brand-default,\n  .header-bg-transparent-xl .navbar-brand-on-scroll {\n    display: none;\n  }\n}\n\n.header-bg-transparent .navbar-brand-default,\n.header-bg-transparent .navbar-brand-on-scroll {\n  display: none;\n}\n\n.header-bg-transparent .navbar-brand-default {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n@media (max-width: 991.98px) {\n  .header-bg-transparent .navbar-nav,\n  .header-bg-transparent-sm .navbar-nav,\n  .header-bg-transparent-md .navbar-nav,\n  .header-bg-transparent-lg .navbar-nav {\n    background-color: #fff;\n    padding: 0.875rem 1.5rem;\n  }\n}\n\n/*------------------------------------\n  Header On Scroll\n------------------------------------*/\n.header-white-bg-on-scroll.scrolled .header-section {\n  background-color: #fff;\n}\n\n/*------------------------------------\n  Header White Nav Links\n------------------------------------*/\n.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .navbar-nav-item:hover .nav-link {\n  color: #fff;\n}\n\n.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .nav-link.active, .header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .nav-link:hover {\n  color: #fff;\n}\n\n.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link,\n.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link:hover,\n.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary:hover {\n  color: #fff;\n}\n\n.header-white-nav-links:not(.bg-white):not(.js-header-fix-moment) .nav-link-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='rgba(255, 255, 255, 0.7)' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n@media (min-width: 576px) {\n  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .navbar-nav-item:hover .nav-link {\n    color: #fff;\n  }\n  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .nav-link {\n    color: rgba(255, 255, 255, 0.7);\n  }\n  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .nav-link.active, .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .nav-link:hover {\n    color: #fff;\n  }\n  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link,\n  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary {\n    color: rgba(255, 255, 255, 0.7);\n  }\n  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link:hover,\n  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary:hover {\n    color: #fff;\n  }\n  .header-white-nav-links-sm:not(.bg-white):not(.js-header-fix-moment) .nav-link-toggle::after {\n    background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='rgba(255, 255, 255, 0.7)' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .navbar-nav-item:hover .nav-link {\n    color: #fff;\n  }\n  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .nav-link {\n    color: rgba(255, 255, 255, 0.7);\n  }\n  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .nav-link.active, .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .nav-link:hover {\n    color: #fff;\n  }\n  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link,\n  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary {\n    color: rgba(255, 255, 255, 0.7);\n  }\n  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link:hover,\n  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary:hover {\n    color: #fff;\n  }\n  .header-white-nav-links-md:not(.bg-white):not(.js-header-fix-moment) .nav-link-toggle::after {\n    background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='rgba(255, 255, 255, 0.7)' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .navbar-nav-item:hover .nav-link {\n    color: #fff;\n  }\n  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .nav-link {\n    color: rgba(255, 255, 255, 0.7);\n  }\n  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .nav-link.active, .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .nav-link:hover {\n    color: #fff;\n  }\n  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link,\n  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary {\n    color: rgba(255, 255, 255, 0.7);\n  }\n  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link:hover,\n  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary:hover {\n    color: #fff;\n  }\n  .header-white-nav-links-lg:not(.bg-white):not(.js-header-fix-moment) .nav-link-toggle::after {\n    background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='rgba(255, 255, 255, 0.7)' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .navbar-nav-item:hover .nav-link {\n    color: #fff;\n  }\n  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .nav-link {\n    color: rgba(255, 255, 255, 0.7);\n  }\n  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .nav-link.active, .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .nav-link:hover {\n    color: #fff;\n  }\n  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link,\n  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary {\n    color: rgba(255, 255, 255, 0.7);\n  }\n  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .dropdown-nav-link:hover,\n  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .btn-text-secondary:hover {\n    color: #fff;\n  }\n  .header-white-nav-links-xl:not(.bg-white):not(.js-header-fix-moment) .nav-link-toggle::after {\n    background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='rgba(255, 255, 255, 0.7)' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  }\n}\n\n/*------------------------------------\n  Navbar Expand\n------------------------------------*/\n.navbar-expand {\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.navbar-expand .navbar-navbar-toggler {\n  display: none;\n}\n\n.navbar-expand .navbar-nav {\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.navbar-expand .navbar-nav .navbar-nav-last-item {\n  text-align: right;\n  padding-left: 1rem;\n  padding-right: 0;\n}\n\n.navbar-expand .navbar-nav .nav-link {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n  padding-right: 0.75rem;\n  padding-left: 0.75rem;\n}\n\n.navbar-expand .navbar-nav .dropdown-menu {\n  border-top: 0.1875rem solid #377dff;\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);\n}\n\n.navbar-expand .navbar-nav .dropdown-menu .hs-has-sub-menu .dropdown-menu {\n  margin-top: -1.1875rem;\n}\n\n.navbar-expand .mega-menu-position-right-fix.dropdown-menu, .navbar-expand .mega-menu-position-right-fix.hs-mega-menu.hs-position-right {\n  right: 20%;\n  left: auto;\n}\n\n.navbar-expand .mega-menu-body {\n  padding: 2.5rem 2.5rem;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.navbar-expand .navbar-promo {\n  border-bottom-right-radius: 0.3125rem;\n}\n\n.navbar-expand .navbar-promo-card {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex: 1 0 0%;\n      flex: 1 0 0%;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n.navbar-expand .navbar-promo-card-deck {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: row wrap;\n      flex-flow: row wrap;\n}\n\n.navbar-expand .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link {\n  position: relative;\n}\n\n.navbar-expand .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  margin-right: -1.5rem;\n  border-right: 0.0625rem solid #e7eaf3;\n  height: 100%;\n  content: \"\";\n}\n\n@media (min-width: 576px) {\n  .navbar-expand-sm {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n  }\n  .navbar-expand-sm .navbar-navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-sm .navbar-nav {\n    -ms-flex-align: center;\n        align-items: center;\n  }\n  .navbar-expand-sm .navbar-nav .navbar-nav-last-item {\n    text-align: right;\n    padding-left: 1rem;\n    padding-right: 0;\n  }\n  .navbar-expand-sm .navbar-nav .nav-link {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n    padding-right: 0.75rem;\n    padding-left: 0.75rem;\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu {\n    border-top: 0.1875rem solid #377dff;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0.3125rem;\n    border-bottom-left-radius: 0.3125rem;\n    box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);\n  }\n  .navbar-expand-sm .navbar-nav .dropdown-menu .hs-has-sub-menu .dropdown-menu {\n    margin-top: -1.1875rem;\n  }\n  .navbar-expand-sm .mega-menu-position-right-fix.dropdown-menu, .navbar-expand-sm .mega-menu-position-right-fix.hs-mega-menu.hs-position-right {\n    right: 20%;\n    left: auto;\n  }\n  .navbar-expand-sm .mega-menu-body {\n    padding: 2.5rem 2.5rem;\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .navbar-expand-sm .navbar-promo {\n    border-bottom-right-radius: 0.3125rem;\n  }\n  .navbar-expand-sm .navbar-promo-card {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex: 1 0 0%;\n        flex: 1 0 0%;\n    -ms-flex-direction: column;\n        flex-direction: column;\n  }\n  .navbar-expand-sm .navbar-promo-card-deck {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n  }\n  .navbar-expand-sm .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link {\n    position: relative;\n  }\n  .navbar-expand-sm .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin-right: -1.5rem;\n    border-right: 0.0625rem solid #e7eaf3;\n    height: 100%;\n    content: \"\";\n  }\n}\n\n@media (min-width: 768px) {\n  .navbar-expand-md {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n  }\n  .navbar-expand-md .navbar-navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-md .navbar-nav {\n    -ms-flex-align: center;\n        align-items: center;\n  }\n  .navbar-expand-md .navbar-nav .navbar-nav-last-item {\n    text-align: right;\n    padding-left: 1rem;\n    padding-right: 0;\n  }\n  .navbar-expand-md .navbar-nav .nav-link {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n    padding-right: 0.75rem;\n    padding-left: 0.75rem;\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu {\n    border-top: 0.1875rem solid #377dff;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0.3125rem;\n    border-bottom-left-radius: 0.3125rem;\n    box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);\n  }\n  .navbar-expand-md .navbar-nav .dropdown-menu .hs-has-sub-menu .dropdown-menu {\n    margin-top: -1.1875rem;\n  }\n  .navbar-expand-md .mega-menu-position-right-fix.dropdown-menu, .navbar-expand-md .mega-menu-position-right-fix.hs-mega-menu.hs-position-right {\n    right: 20%;\n    left: auto;\n  }\n  .navbar-expand-md .mega-menu-body {\n    padding: 2.5rem 2.5rem;\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .navbar-expand-md .navbar-promo {\n    border-bottom-right-radius: 0.3125rem;\n  }\n  .navbar-expand-md .navbar-promo-card {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex: 1 0 0%;\n        flex: 1 0 0%;\n    -ms-flex-direction: column;\n        flex-direction: column;\n  }\n  .navbar-expand-md .navbar-promo-card-deck {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n  }\n  .navbar-expand-md .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link {\n    position: relative;\n  }\n  .navbar-expand-md .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin-right: -1.5rem;\n    border-right: 0.0625rem solid #e7eaf3;\n    height: 100%;\n    content: \"\";\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar-expand-lg {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n  }\n  .navbar-expand-lg .navbar-navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-lg .navbar-nav {\n    -ms-flex-align: center;\n        align-items: center;\n  }\n  .navbar-expand-lg .navbar-nav .navbar-nav-last-item {\n    text-align: right;\n    padding-left: 1rem;\n    padding-right: 0;\n  }\n  .navbar-expand-lg .navbar-nav .nav-link {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n    padding-right: 0.75rem;\n    padding-left: 0.75rem;\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu {\n    border-top: 0.1875rem solid #377dff;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0.3125rem;\n    border-bottom-left-radius: 0.3125rem;\n    box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);\n  }\n  .navbar-expand-lg .navbar-nav .dropdown-menu .hs-has-sub-menu .dropdown-menu {\n    margin-top: -1.1875rem;\n  }\n  .navbar-expand-lg .mega-menu-position-right-fix.dropdown-menu, .navbar-expand-lg .mega-menu-position-right-fix.hs-mega-menu.hs-position-right {\n    right: 20%;\n    left: auto;\n  }\n  .navbar-expand-lg .mega-menu-body {\n    padding: 2.5rem 2.5rem;\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .navbar-expand-lg .navbar-promo {\n    border-bottom-right-radius: 0.3125rem;\n  }\n  .navbar-expand-lg .navbar-promo-card {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex: 1 0 0%;\n        flex: 1 0 0%;\n    -ms-flex-direction: column;\n        flex-direction: column;\n  }\n  .navbar-expand-lg .navbar-promo-card-deck {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n  }\n  .navbar-expand-lg .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link {\n    position: relative;\n  }\n  .navbar-expand-lg .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin-right: -1.5rem;\n    border-right: 0.0625rem solid #e7eaf3;\n    height: 100%;\n    content: \"\";\n  }\n}\n\n@media (min-width: 1200px) {\n  .navbar-expand-xl {\n    -ms-flex-wrap: wrap;\n        flex-wrap: wrap;\n  }\n  .navbar-expand-xl .navbar-navbar-toggler {\n    display: none;\n  }\n  .navbar-expand-xl .navbar-nav {\n    -ms-flex-align: center;\n        align-items: center;\n  }\n  .navbar-expand-xl .navbar-nav .navbar-nav-last-item {\n    text-align: right;\n    padding-left: 1rem;\n    padding-right: 0;\n  }\n  .navbar-expand-xl .navbar-nav .nav-link {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n    padding-right: 0.75rem;\n    padding-left: 0.75rem;\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu {\n    border-top: 0.1875rem solid #377dff;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0.3125rem;\n    border-bottom-left-radius: 0.3125rem;\n    box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);\n  }\n  .navbar-expand-xl .navbar-nav .dropdown-menu .hs-has-sub-menu .dropdown-menu {\n    margin-top: -1.1875rem;\n  }\n  .navbar-expand-xl .mega-menu-position-right-fix.dropdown-menu, .navbar-expand-xl .mega-menu-position-right-fix.hs-mega-menu.hs-position-right {\n    right: 20%;\n    left: auto;\n  }\n  .navbar-expand-xl .mega-menu-body {\n    padding: 2.5rem 2.5rem;\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .navbar-expand-xl .navbar-promo {\n    border-bottom-right-radius: 0.3125rem;\n  }\n  .navbar-expand-xl .navbar-promo-card {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex: 1 0 0%;\n        flex: 1 0 0%;\n    -ms-flex-direction: column;\n        flex-direction: column;\n  }\n  .navbar-expand-xl .navbar-promo-card-deck {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: row wrap;\n        flex-flow: row wrap;\n  }\n  .navbar-expand-xl .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link {\n    position: relative;\n  }\n  .navbar-expand-xl .navbar-promo-card-deck .navbar-promo-item:not(:last-child) .navbar-promo-link::after {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin-right: -1.5rem;\n    border-right: 0.0625rem solid #e7eaf3;\n    height: 100%;\n    content: \"\";\n  }\n}\n\n@media (max-width: 575.98px) {\n  .navbar-expand-sm.navbar {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .navbar-expand-sm .navbar-brand,\n  .navbar-expand-sm .navbar-brand > img {\n    width: 7rem;\n  }\n  .navbar-expand-sm .navbar-nav {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .navbar-expand-sm .navbar-nav-last-item {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .navbar-expand-sm .nav-link {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n  }\n  .navbar-expand-sm .nav-link-toggle::after {\n    margin-left: auto;\n  }\n  .navbar-expand-sm .hs-mega-menu {\n    max-width: 100% !important;\n  }\n  .navbar-expand-sm .hs-mega-menu-opened .nav-link-toggle::after,\n  .navbar-expand-sm .hs-sub-menu-opened .nav-link-toggle::after {\n    -webkit-transform: rotate(-180deg);\n            transform: rotate(-180deg);\n  }\n  .navbar-expand-sm .dropdown-item-toggle::after {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg);\n  }\n  .navbar-expand-sm .hs-sub-menu-opened > .dropdown-item-toggle::after {\n    -webkit-transform: rotate(-90deg);\n            transform: rotate(-90deg);\n  }\n  .navbar-expand-sm .mega-menu-body {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .navbar-expand-sm .dropdown-menu {\n    box-shadow: none;\n  }\n  .navbar-expand-sm .dropdown-menu:not(.navbar-promo):not(.dropdown-menu-no-border-on-mobile) {\n    border-left: 0.1875rem solid #e7eaf3;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .navbar-expand-sm .dropdown-menu .mega-menu-body {\n    padding-left: 1.5rem;\n  }\n  .navbar-expand-sm .hs-has-sub-menu .hs-sub-menu .hs-sub-menu {\n    margin-left: 1.5rem;\n  }\n  .navbar-expand-sm .hs-has-sub-menu .hs-sub-menu .hs-has-sub-menu .dropdown-item-toggle {\n    padding-right: 0.6125rem;\n  }\n  .navbar-expand-sm .navbar-promo-card-deck:last-child .navbar-promo-item:not(:last-child) {\n    border-bottom: 0.0625rem solid #e7eaf3;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .navbar-expand-md.navbar {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .navbar-expand-md .navbar-brand,\n  .navbar-expand-md .navbar-brand > img {\n    width: 7rem;\n  }\n  .navbar-expand-md .navbar-nav {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .navbar-expand-md .navbar-nav-last-item {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .navbar-expand-md .nav-link {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n  }\n  .navbar-expand-md .nav-link-toggle::after {\n    margin-left: auto;\n  }\n  .navbar-expand-md .hs-mega-menu {\n    max-width: 100% !important;\n  }\n  .navbar-expand-md .hs-mega-menu-opened .nav-link-toggle::after,\n  .navbar-expand-md .hs-sub-menu-opened .nav-link-toggle::after {\n    -webkit-transform: rotate(-180deg);\n            transform: rotate(-180deg);\n  }\n  .navbar-expand-md .dropdown-item-toggle::after {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg);\n  }\n  .navbar-expand-md .hs-sub-menu-opened > .dropdown-item-toggle::after {\n    -webkit-transform: rotate(-90deg);\n            transform: rotate(-90deg);\n  }\n  .navbar-expand-md .mega-menu-body {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .navbar-expand-md .dropdown-menu {\n    box-shadow: none;\n  }\n  .navbar-expand-md .dropdown-menu:not(.navbar-promo):not(.dropdown-menu-no-border-on-mobile) {\n    border-left: 0.1875rem solid #e7eaf3;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .navbar-expand-md .dropdown-menu .mega-menu-body {\n    padding-left: 1.5rem;\n  }\n  .navbar-expand-md .hs-has-sub-menu .hs-sub-menu .hs-sub-menu {\n    margin-left: 1.5rem;\n  }\n  .navbar-expand-md .hs-has-sub-menu .hs-sub-menu .hs-has-sub-menu .dropdown-item-toggle {\n    padding-right: 0.6125rem;\n  }\n  .navbar-expand-md .navbar-promo-card-deck:last-child .navbar-promo-item:not(:last-child) {\n    border-bottom: 0.0625rem solid #e7eaf3;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .navbar-expand-lg.navbar {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .navbar-expand-lg .navbar-brand,\n  .navbar-expand-lg .navbar-brand > img {\n    width: 7rem;\n  }\n  .navbar-expand-lg .navbar-nav {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .navbar-expand-lg .navbar-nav-last-item {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .navbar-expand-lg .nav-link {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n  }\n  .navbar-expand-lg .nav-link-toggle::after {\n    margin-left: auto;\n  }\n  .navbar-expand-lg .hs-mega-menu {\n    max-width: 100% !important;\n  }\n  .navbar-expand-lg .hs-mega-menu-opened .nav-link-toggle::after,\n  .navbar-expand-lg .hs-sub-menu-opened .nav-link-toggle::after {\n    -webkit-transform: rotate(-180deg);\n            transform: rotate(-180deg);\n  }\n  .navbar-expand-lg .dropdown-item-toggle::after {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg);\n  }\n  .navbar-expand-lg .hs-sub-menu-opened > .dropdown-item-toggle::after {\n    -webkit-transform: rotate(-90deg);\n            transform: rotate(-90deg);\n  }\n  .navbar-expand-lg .mega-menu-body {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .navbar-expand-lg .dropdown-menu {\n    box-shadow: none;\n  }\n  .navbar-expand-lg .dropdown-menu:not(.navbar-promo):not(.dropdown-menu-no-border-on-mobile) {\n    border-left: 0.1875rem solid #e7eaf3;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .navbar-expand-lg .dropdown-menu .mega-menu-body {\n    padding-left: 1.5rem;\n  }\n  .navbar-expand-lg .hs-has-sub-menu .hs-sub-menu .hs-sub-menu {\n    margin-left: 1.5rem;\n  }\n  .navbar-expand-lg .hs-has-sub-menu .hs-sub-menu .hs-has-sub-menu .dropdown-item-toggle {\n    padding-right: 0.6125rem;\n  }\n  .navbar-expand-lg .navbar-promo-card-deck:last-child .navbar-promo-item:not(:last-child) {\n    border-bottom: 0.0625rem solid #e7eaf3;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl.navbar {\n    padding-top: 0.5rem;\n    padding-bottom: 0.5rem;\n  }\n  .navbar-expand-xl .navbar-brand,\n  .navbar-expand-xl .navbar-brand > img {\n    width: 7rem;\n  }\n  .navbar-expand-xl .navbar-nav {\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n  }\n  .navbar-expand-xl .navbar-nav-last-item {\n    padding-top: 0.75rem;\n    padding-bottom: 0.75rem;\n  }\n  .navbar-expand-xl .nav-link {\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n  }\n  .navbar-expand-xl .nav-link-toggle::after {\n    margin-left: auto;\n  }\n  .navbar-expand-xl .hs-mega-menu {\n    max-width: 100% !important;\n  }\n  .navbar-expand-xl .hs-mega-menu-opened .nav-link-toggle::after,\n  .navbar-expand-xl .hs-sub-menu-opened .nav-link-toggle::after {\n    -webkit-transform: rotate(-180deg);\n            transform: rotate(-180deg);\n  }\n  .navbar-expand-xl .dropdown-item-toggle::after {\n    -webkit-transform: rotate(90deg);\n            transform: rotate(90deg);\n  }\n  .navbar-expand-xl .hs-sub-menu-opened > .dropdown-item-toggle::after {\n    -webkit-transform: rotate(-90deg);\n            transform: rotate(-90deg);\n  }\n  .navbar-expand-xl .mega-menu-body {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n  .navbar-expand-xl .dropdown-menu {\n    box-shadow: none;\n  }\n  .navbar-expand-xl .dropdown-menu:not(.navbar-promo):not(.dropdown-menu-no-border-on-mobile) {\n    border-left: 0.1875rem solid #e7eaf3;\n    border-top-left-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .navbar-expand-xl .dropdown-menu .mega-menu-body {\n    padding-left: 1.5rem;\n  }\n  .navbar-expand-xl .hs-has-sub-menu .hs-sub-menu .hs-sub-menu {\n    margin-left: 1.5rem;\n  }\n  .navbar-expand-xl .hs-has-sub-menu .hs-sub-menu .hs-has-sub-menu .dropdown-item-toggle {\n    padding-right: 0.6125rem;\n  }\n  .navbar-expand-xl .navbar-promo-card-deck:last-child .navbar-promo-item:not(:last-child) {\n    border-bottom: 0.0625rem solid #e7eaf3;\n  }\n}\n\n.navbar-expand.navbar {\n  padding-top: 0.5rem;\n  padding-bottom: 0.5rem;\n}\n\n.navbar-expand .navbar-brand,\n.navbar-expand .navbar-brand > img {\n  width: 7rem;\n}\n\n.navbar-expand .navbar-nav {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n\n.navbar-expand .navbar-nav-last-item {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n\n.navbar-expand .nav-link {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.navbar-expand .nav-link-toggle::after {\n  margin-left: auto;\n}\n\n.navbar-expand .hs-mega-menu {\n  max-width: 100% !important;\n}\n\n.navbar-expand .hs-mega-menu-opened .nav-link-toggle::after,\n.navbar-expand .hs-sub-menu-opened .nav-link-toggle::after {\n  -webkit-transform: rotate(-180deg);\n          transform: rotate(-180deg);\n}\n\n.navbar-expand .dropdown-item-toggle::after {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n\n.navbar-expand .hs-sub-menu-opened > .dropdown-item-toggle::after {\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n\n.navbar-expand .mega-menu-body {\n  padding-top: 1.5rem;\n  padding-bottom: 1.5rem;\n}\n\n.navbar-expand .dropdown-menu {\n  box-shadow: none;\n}\n\n.navbar-expand .dropdown-menu:not(.navbar-promo):not(.dropdown-menu-no-border-on-mobile) {\n  border-left: 0.1875rem solid #e7eaf3;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.navbar-expand .dropdown-menu .mega-menu-body {\n  padding-left: 1.5rem;\n}\n\n.navbar-expand .hs-has-sub-menu .hs-sub-menu .hs-sub-menu {\n  margin-left: 1.5rem;\n}\n\n.navbar-expand .hs-has-sub-menu .hs-sub-menu .hs-has-sub-menu .dropdown-item-toggle {\n  padding-right: 0.6125rem;\n}\n\n.navbar-expand .navbar-promo-card-deck:last-child .navbar-promo-item:not(:last-child) {\n  border-bottom: 0.0625rem solid #e7eaf3;\n}\n\n@media (max-width: 767.98px) {\n  .navbar-expand-sm .header-nav-last-item {\n    display: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .navbar-expand-xs .navbar-banner,\n  .navbar-expand-xs .navbar-product-banner,\n  .navbar-expand-sm .navbar-banner,\n  .navbar-expand-sm .navbar-product-banner,\n  .navbar-expand-md .navbar-banner,\n  .navbar-expand-md .navbar-product-banner,\n  .navbar-expand-lg .navbar-banner,\n  .navbar-expand-lg .navbar-product-banner {\n    display: none;\n  }\n  .navbar-expand .navbar-brand {\n    padding-top: 0.5rem;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .navbar-expand-xl .navbar-banner,\n  .navbar-expand-xl .navbar-product-banner {\n    display: none;\n  }\n}\n\n@media (min-width: 1200px) {\n  .header .mega-menu-position-right-fix-xl.hs-mega-menu.hs-position-right {\n    right: 20%;\n  }\n}\n\n@media (min-width: 768px) and (max-width: 991.98px) {\n  .navbar-expand-md .navbar-brand {\n    padding-top: 0.5rem;\n  }\n  .header .mega-menu-position-right-fix-md.hs-mega-menu.hs-position-right {\n    right: 20%;\n  }\n}\n\n@media (min-width: 992px) {\n  [class*=\"navbar-expand\"]:not(.navbar-expand-xl) {\n    -ms-flex-wrap: nowrap;\n        flex-wrap: nowrap;\n  }\n  .navbar-expand-lg-collapse-block .navbar-collapse {\n    display: block !important;\n  }\n}\n\n/*------------------------------------\n  Header Floating\n------------------------------------*/\n.header-floating {\n  position: absolute;\n  right: 0;\n  left: 0;\n  margin-top: 2.5rem;\n}\n\n.header-floating.js-header-fix-moment {\n  position: fixed;\n  background-color: #fff;\n  box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);\n  margin-top: 0;\n}\n\n.header-floating.js-header-fix-moment .header-floating-inner {\n  box-shadow: none;\n}\n\n.header-floating-inner {\n  border-radius: 0.3125rem;\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n@media (min-width: 576px) {\n  .header-floating-sm {\n    position: absolute;\n    right: 0;\n    left: 0;\n    margin-top: 2.5rem;\n  }\n  .header-floating-sm.js-header-fix-moment {\n    position: fixed;\n    background-color: #fff;\n    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);\n    margin-top: 0;\n  }\n  .header-floating-sm.js-header-fix-moment .header-floating-inner {\n    box-shadow: none;\n  }\n  .header-floating-inner {\n    border-radius: 0.3125rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .header-floating-md {\n    position: absolute;\n    right: 0;\n    left: 0;\n    margin-top: 2.5rem;\n  }\n  .header-floating-md.js-header-fix-moment {\n    position: fixed;\n    background-color: #fff;\n    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);\n    margin-top: 0;\n  }\n  .header-floating-md.js-header-fix-moment .header-floating-inner {\n    box-shadow: none;\n  }\n  .header-floating-inner {\n    border-radius: 0.3125rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .header-floating-lg {\n    position: absolute;\n    right: 0;\n    left: 0;\n    margin-top: 2.5rem;\n  }\n  .header-floating-lg.js-header-fix-moment {\n    position: fixed;\n    background-color: #fff;\n    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);\n    margin-top: 0;\n  }\n  .header-floating-lg.js-header-fix-moment .header-floating-inner {\n    box-shadow: none;\n  }\n  .header-floating-inner {\n    border-radius: 0.3125rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .header-floating-xl {\n    position: absolute;\n    right: 0;\n    left: 0;\n    margin-top: 2.5rem;\n  }\n  .header-floating-xl.js-header-fix-moment {\n    position: fixed;\n    background-color: #fff;\n    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);\n    margin-top: 0;\n  }\n  .header-floating-xl.js-header-fix-moment .header-floating-inner {\n    box-shadow: none;\n  }\n  .header-floating-inner {\n    border-radius: 0.3125rem;\n    padding-left: 1rem;\n    padding-right: 1rem;\n  }\n}\n\n@media (max-width: 575.98px) {\n  .header-floating-sm {\n    background-color: #fff;\n    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);\n  }\n  .header-floating-sm.header-box-shadow .header-section,\n  .header-floating-sm.header-box-shadow-on-scroll.scrolled .header-section {\n    box-shadow: none;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .header-floating-md {\n    background-color: #fff;\n    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);\n  }\n  .header-floating-md.header-box-shadow .header-section,\n  .header-floating-md.header-box-shadow-on-scroll.scrolled .header-section {\n    box-shadow: none;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .header-floating-lg {\n    background-color: #fff;\n    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);\n  }\n  .header-floating-lg.header-box-shadow .header-section,\n  .header-floating-lg.header-box-shadow-on-scroll.scrolled .header-section {\n    box-shadow: none;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .header-floating-xl {\n    background-color: #fff;\n    box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);\n  }\n  .header-floating-xl.header-box-shadow .header-section,\n  .header-floating-xl.header-box-shadow-on-scroll.scrolled .header-section {\n    box-shadow: none;\n  }\n}\n\n.header-floating {\n  background-color: #fff;\n  box-shadow: 0 1px 10px rgba(140, 152, 164, 0.125);\n}\n\n.header-floating.header-box-shadow .header-section,\n.header-floating.header-box-shadow-on-scroll.scrolled .header-section {\n  box-shadow: none;\n}\n\n@media (max-width: 991.98px) {\n  .header-floating-inner {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .header-floating-md .header-floating-inner {\n    max-height: 75vh;\n    overflow: hidden;\n    overflow-y: auto;\n  }\n  .header-floating-md .header-floating-inner::-webkit-scrollbar {\n    width: 0.5rem;\n  }\n  .header-floating-md .header-floating-inner::-webkit-scrollbar-thumb {\n    background-color: rgba(189, 197, 209, 0.6);\n    visibility: hidden;\n  }\n  .header-floating-md .header-floating-inner:hover::-webkit-scrollbar-thumb {\n    visibility: visible;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .header-floating .header-floating-inner,\n  .header-floating-sm .header-floating-inner,\n  .header-floating-lg .header-floating-inner {\n    max-height: 75vh;\n    overflow: hidden;\n    overflow-y: auto;\n  }\n  .header-floating .header-floating-inner::-webkit-scrollbar,\n  .header-floating-sm .header-floating-inner::-webkit-scrollbar,\n  .header-floating-lg .header-floating-inner::-webkit-scrollbar {\n    width: 0.5rem;\n  }\n  .header-floating .header-floating-inner::-webkit-scrollbar-thumb,\n  .header-floating-sm .header-floating-inner::-webkit-scrollbar-thumb,\n  .header-floating-lg .header-floating-inner::-webkit-scrollbar-thumb {\n    background-color: rgba(189, 197, 209, 0.6);\n    visibility: hidden;\n  }\n  .header-floating .header-floating-inner:hover::-webkit-scrollbar-thumb,\n  .header-floating-sm .header-floating-inner:hover::-webkit-scrollbar-thumb,\n  .header-floating-lg .header-floating-inner:hover::-webkit-scrollbar-thumb {\n    visibility: visible;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .header-floating-xl .header-floating-inner {\n    max-height: 75vh;\n    overflow: hidden;\n    overflow-y: auto;\n  }\n  .header-floating-xl .header-floating-inner::-webkit-scrollbar {\n    width: 0.5rem;\n  }\n  .header-floating-xl .header-floating-inner::-webkit-scrollbar-thumb {\n    background-color: rgba(189, 197, 209, 0.6);\n    visibility: hidden;\n  }\n  .header-floating-xl .header-floating-inner:hover::-webkit-scrollbar-thumb {\n    visibility: visible;\n  }\n}\n\n/*------------------------------------\n  Absolute Positions\n------------------------------------*/\n.header-abs-top {\n  position: absolute;\n  top: 0;\n  bottom: auto;\n}\n\n@media (min-width: 576px) {\n  .header-abs-top-sm {\n    position: absolute;\n    top: 0;\n    bottom: auto;\n  }\n}\n\n@media (min-width: 768px) {\n  .header-abs-top-md {\n    position: absolute;\n    top: 0;\n    bottom: auto;\n  }\n}\n\n@media (min-width: 992px) {\n  .header-abs-top-lg {\n    position: absolute;\n    top: 0;\n    bottom: auto;\n  }\n}\n\n@media (min-width: 1200px) {\n  .header-abs-top-xl {\n    position: absolute;\n    top: 0;\n    bottom: auto;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .header-abs-top-md .header-abs-top-inner {\n    max-height: 75vh;\n    overflow: hidden;\n    overflow-y: auto;\n  }\n  .header-abs-top-md .header-abs-top-inner::-webkit-scrollbar {\n    width: 0.5rem;\n  }\n  .header-abs-top-md .header-abs-top-inner::-webkit-scrollbar-thumb {\n    background-color: rgba(189, 197, 209, 0.6);\n    visibility: hidden;\n  }\n  .header-abs-top-md .header-abs-top-inner:hover::-webkit-scrollbar-thumb {\n    visibility: visible;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .header-abs-top .header-abs-top-inner,\n  .header-abs-top-sm .header-abs-top-inner,\n  .header-abs-top-lg .header-abs-top-inner {\n    max-height: 75vh;\n    overflow: hidden;\n    overflow-y: auto;\n  }\n  .header-abs-top .header-abs-top-inner::-webkit-scrollbar,\n  .header-abs-top-sm .header-abs-top-inner::-webkit-scrollbar,\n  .header-abs-top-lg .header-abs-top-inner::-webkit-scrollbar {\n    width: 0.5rem;\n  }\n  .header-abs-top .header-abs-top-inner::-webkit-scrollbar-thumb,\n  .header-abs-top-sm .header-abs-top-inner::-webkit-scrollbar-thumb,\n  .header-abs-top-lg .header-abs-top-inner::-webkit-scrollbar-thumb {\n    background-color: rgba(189, 197, 209, 0.6);\n    visibility: hidden;\n  }\n  .header-abs-top .header-abs-top-inner:hover::-webkit-scrollbar-thumb,\n  .header-abs-top-sm .header-abs-top-inner:hover::-webkit-scrollbar-thumb,\n  .header-abs-top-lg .header-abs-top-inner:hover::-webkit-scrollbar-thumb {\n    visibility: visible;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .header-abs-top-xl .header-abs-top-inner {\n    max-height: 75vh;\n    overflow: hidden;\n    overflow-y: auto;\n  }\n  .header-abs-top-xl .header-abs-top-inner::-webkit-scrollbar {\n    width: 0.5rem;\n  }\n  .header-abs-top-xl .header-abs-top-inner::-webkit-scrollbar-thumb {\n    background-color: rgba(189, 197, 209, 0.6);\n    visibility: hidden;\n  }\n  .header-abs-top-xl .header-abs-top-inner:hover::-webkit-scrollbar-thumb {\n    visibility: visible;\n  }\n}\n\n/*------------------------------------\n  Sticky Positions\n------------------------------------*/\n.header-sticky-top {\n  position: fixed;\n  bottom: auto;\n  top: 0;\n}\n\n@media (min-width: 576px) {\n  .header-sticky-top-sm {\n    position: fixed;\n    bottom: auto;\n    top: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .header-sticky-top-md {\n    position: fixed;\n    bottom: auto;\n    top: 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .header-sticky-top-lg {\n    position: fixed;\n    bottom: auto;\n    top: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .header-sticky-top-xl {\n    position: fixed;\n    bottom: auto;\n    top: 0;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .header-sticky-top-md .header-sticky-top-inner {\n    max-height: 75vh;\n    overflow: hidden;\n    overflow-y: auto;\n  }\n  .header-sticky-top-md .header-sticky-top-inner::-webkit-scrollbar {\n    width: 0.5rem;\n  }\n  .header-sticky-top-md .header-sticky-top-inner::-webkit-scrollbar-thumb {\n    background-color: rgba(189, 197, 209, 0.6);\n    visibility: hidden;\n  }\n  .header-sticky-top-md .header-sticky-top-inner:hover::-webkit-scrollbar-thumb {\n    visibility: visible;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .header-sticky-top .header-sticky-top-inner,\n  .header-sticky-top-sm .header-sticky-top-inner,\n  .header-sticky-top-lg .header-sticky-top-inner {\n    max-height: 75vh;\n    overflow: hidden;\n    overflow-y: auto;\n  }\n  .header-sticky-top .header-sticky-top-inner::-webkit-scrollbar,\n  .header-sticky-top-sm .header-sticky-top-inner::-webkit-scrollbar,\n  .header-sticky-top-lg .header-sticky-top-inner::-webkit-scrollbar {\n    width: 0.5rem;\n  }\n  .header-sticky-top .header-sticky-top-inner::-webkit-scrollbar-thumb,\n  .header-sticky-top-sm .header-sticky-top-inner::-webkit-scrollbar-thumb,\n  .header-sticky-top-lg .header-sticky-top-inner::-webkit-scrollbar-thumb {\n    background-color: rgba(189, 197, 209, 0.6);\n    visibility: hidden;\n  }\n  .header-sticky-top .header-sticky-top-inner:hover::-webkit-scrollbar-thumb,\n  .header-sticky-top-sm .header-sticky-top-inner:hover::-webkit-scrollbar-thumb,\n  .header-sticky-top-lg .header-sticky-top-inner:hover::-webkit-scrollbar-thumb {\n    visibility: visible;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .header-sticky-top-xl .header-sticky-top-inner {\n    max-height: 75vh;\n    overflow: hidden;\n    overflow-y: auto;\n  }\n  .header-sticky-top-xl .header-sticky-top-inner::-webkit-scrollbar {\n    width: 0.5rem;\n  }\n  .header-sticky-top-xl .header-sticky-top-inner::-webkit-scrollbar-thumb {\n    background-color: rgba(189, 197, 209, 0.6);\n    visibility: hidden;\n  }\n  .header-sticky-top-xl .header-sticky-top-inner:hover::-webkit-scrollbar-thumb {\n    visibility: visible;\n  }\n}\n\n/*------------------------------------\n  Animation\n------------------------------------*/\n.animated {\n  -webkit-animation-duration: 1s;\n          animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n          animation-fill-mode: both;\n}\n\n@-webkit-keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n\n.fadeIn {\n  -webkit-animation-name: fadeIn;\n          animation-name: fadeIn;\n}\n\n@-webkit-keyframes fadeInUp {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 15px, 0);\n            transform: translate3d(0, 15px, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n  }\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 15px, 0);\n            transform: translate3d(0, 15px, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n            transform: none;\n  }\n}\n\n.fadeInUp {\n  -webkit-animation-name: fadeInUp;\n          animation-name: fadeInUp;\n}\n\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n  }\n}\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n          animation-name: fadeOut;\n}\n\n@-webkit-keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n            transform: translate3d(0, -100%, 0);\n  }\n}\n\n@keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n            transform: translate3d(0, -100%, 0);\n  }\n}\n\n.fadeOutUp {\n  -webkit-animation-name: fadeOutUp;\n          animation-name: fadeOutUp;\n}\n\n@-webkit-keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n            transform: translate3d(0, 100%, 0);\n  }\n}\n\n@keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n            transform: translate3d(0, 100%, 0);\n  }\n}\n\n.fadeOutDown {\n  -webkit-animation-name: fadeOutDown;\n          animation-name: fadeOutDown;\n}\n\n@-webkit-keyframes slideInUp {\n  from {\n    -webkit-transform: translate3d(0, 10px, 0);\n            transform: translate3d(0, 10px, 0);\n    visibility: visible;\n  }\n  to {\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes slideInUp {\n  from {\n    -webkit-transform: translate3d(0, 10px, 0);\n            transform: translate3d(0, 10px, 0);\n    visibility: visible;\n  }\n  to {\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n\n.slideInUp {\n  -webkit-animation-name: slideInUp;\n          animation-name: slideInUp;\n}\n\n@-webkit-keyframes slideInDown {\n  from {\n    -webkit-transform: translate3d(0, -10px, 0);\n            transform: translate3d(0, -10px, 0);\n    visibility: visible;\n  }\n  to {\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes slideInDown {\n  from {\n    -webkit-transform: translate3d(0, -10px, 0);\n            transform: translate3d(0, -10px, 0);\n    visibility: visible;\n  }\n  to {\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n\n.slideInDown {\n  -webkit-animation-name: slideInDown;\n          animation-name: slideInDown;\n}\n\n@-webkit-keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n            transform: translate3d(-100%, 0, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fadeInLeft {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n            transform: translate3d(-100%, 0, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n\n.fadeInLeft {\n  -webkit-animation-name: fadeInLeft;\n          animation-name: fadeInLeft;\n}\n\n@-webkit-keyframes fadeInRight {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n            transform: translate3d(100%, 0, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n\n@keyframes fadeInRight {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n            transform: translate3d(100%, 0, 0);\n  }\n  to {\n    opacity: 1;\n    -webkit-transform: translate3d(0, 0, 0);\n            transform: translate3d(0, 0, 0);\n  }\n}\n\n.fadeInRight {\n  -webkit-animation-name: fadeInRight;\n          animation-name: fadeInRight;\n}\n\n@-webkit-keyframes fadeOutLeft {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n            transform: translate3d(-100%, 0, 0);\n  }\n}\n\n@keyframes fadeOutLeft {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(-100%, 0, 0);\n            transform: translate3d(-100%, 0, 0);\n  }\n}\n\n.fadeOutLeft {\n  -webkit-animation-name: fadeOutLeft;\n          animation-name: fadeOutLeft;\n}\n\n@-webkit-keyframes fadeOutRight {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n            transform: translate3d(100%, 0, 0);\n  }\n}\n\n@keyframes fadeOutRight {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(100%, 0, 0);\n            transform: translate3d(100%, 0, 0);\n  }\n}\n\n.fadeOutRight {\n  -webkit-animation-name: fadeOutRight;\n          animation-name: fadeOutRight;\n}\n\n/*------------------------------------\n  Alert Styles\n------------------------------------*/\n.alert-primary {\n  color: #fff;\n  background-color: #377dff;\n  border-color: #377dff;\n}\n\n.alert-primary hr {\n  border-top-color: #1e6cff;\n}\n\n.alert-primary .alert-link {\n  color: #fff;\n}\n\n.alert-secondary {\n  color: #fff;\n  background-color: #71869d;\n  border-color: #71869d;\n}\n\n.alert-secondary hr {\n  border-top-color: #647991;\n}\n\n.alert-secondary .alert-link {\n  color: #fff;\n}\n\n.alert-success {\n  color: #fff;\n  background-color: #00c9a7;\n  border-color: #00c9a7;\n}\n\n.alert-success hr {\n  border-top-color: #00b092;\n}\n\n.alert-success .alert-link {\n  color: #fff;\n}\n\n.alert-info {\n  color: #fff;\n  background-color: #09a5be;\n  border-color: #09a5be;\n}\n\n.alert-info hr {\n  border-top-color: #0890a6;\n}\n\n.alert-info .alert-link {\n  color: #fff;\n}\n\n.alert-warning {\n  color: #1e2022;\n  background-color: #f5ca99;\n  border-color: #f5ca99;\n}\n\n.alert-warning hr {\n  border-top-color: #f3be82;\n}\n\n.alert-warning .alert-link {\n  color: #1e2022;\n}\n\n.alert-danger {\n  color: #fff;\n  background-color: #ed4c78;\n  border-color: #ed4c78;\n}\n\n.alert-danger hr {\n  border-top-color: #eb3567;\n}\n\n.alert-danger .alert-link {\n  color: #fff;\n}\n\n.alert-light {\n  color: #1e2022;\n  background-color: #f7faff;\n  border-color: #f7faff;\n}\n\n.alert-light hr {\n  border-top-color: #deeaff;\n}\n\n.alert-light .alert-link {\n  color: #1e2022;\n}\n\n.alert-dark {\n  color: #fff;\n  background-color: #21325b;\n  border-color: #21325b;\n}\n\n.alert-dark hr {\n  border-top-color: #1a2848;\n}\n\n.alert-dark .alert-link {\n  color: #fff;\n}\n\n.alert-indigo {\n  color: #fff;\n  background-color: #2d1582;\n  border-color: #2d1582;\n}\n\n.alert-indigo hr {\n  border-top-color: #25116c;\n}\n\n.alert-indigo .alert-link {\n  color: #fff;\n}\n\n/* primary soft */\n.alert-soft-primary {\n  color: #377dff;\n  background-color: rgba(55, 125, 255, 0.1);\n}\n\n.alert-soft-primary .alert-link {\n  color: #377dff;\n}\n\n.alert-soft-primary .alert-link:hover {\n  color: #1366ff;\n}\n\n/* secondary soft */\n.alert-soft-secondary {\n  color: #71869d;\n  background-color: rgba(113, 134, 157, 0.1);\n}\n\n.alert-soft-secondary .alert-link {\n  color: #71869d;\n}\n\n.alert-soft-secondary .alert-link:hover {\n  color: #60748b;\n}\n\n/* success soft */\n.alert-soft-success {\n  color: #00c9a7;\n  background-color: rgba(0, 201, 167, 0.1);\n}\n\n.alert-soft-success .alert-link {\n  color: #00c9a7;\n}\n\n.alert-soft-success .alert-link:hover {\n  color: #00a589;\n}\n\n/* info soft */\n.alert-soft-info {\n  color: #09a5be;\n  background-color: rgba(9, 165, 190, 0.1);\n}\n\n.alert-soft-info .alert-link {\n  color: #09a5be;\n}\n\n.alert-soft-info .alert-link:hover {\n  color: #07879c;\n}\n\n/* warning soft */\n.alert-soft-warning {\n  color: #f5ca99;\n  background-color: rgba(245, 202, 153, 0.1);\n}\n\n.alert-soft-warning .alert-link {\n  color: #f5ca99;\n}\n\n.alert-soft-warning .alert-link:hover {\n  color: #f2b978;\n}\n\n/* danger soft */\n.alert-soft-danger {\n  color: #ed4c78;\n  background-color: rgba(237, 76, 120, 0.1);\n}\n\n.alert-soft-danger .alert-link {\n  color: #ed4c78;\n}\n\n.alert-soft-danger .alert-link:hover {\n  color: #ea2c60;\n}\n\n/* light soft */\n.alert-soft-light {\n  color: #f7faff;\n  background-color: rgba(247, 250, 255, 0.1);\n}\n\n.alert-soft-light .alert-link {\n  color: #f7faff;\n}\n\n.alert-soft-light .alert-link:hover {\n  color: #d3e4ff;\n}\n\n/* dark soft */\n.alert-soft-dark {\n  color: #21325b;\n  background-color: rgba(33, 50, 91, 0.1);\n}\n\n.alert-soft-dark .alert-link {\n  color: #21325b;\n}\n\n.alert-soft-dark .alert-link:hover {\n  color: #172441;\n}\n\n/* indigo soft */\n.alert-soft-indigo {\n  color: #2d1582;\n  background-color: rgba(45, 21, 130, 0.1);\n}\n\n.alert-soft-indigo .alert-link {\n  color: #2d1582;\n}\n\n.alert-soft-indigo .alert-link:hover {\n  color: #221063;\n}\n\n/*------------------------------------\n  Avatar\n------------------------------------*/\n.avatar {\n  position: relative;\n  display: inline-block;\n  width: 3.125rem;\n  height: 3.125rem;\n  border-radius: 0.3125rem;\n}\n\n.avatar-img {\n  max-width: 100%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  border-radius: 0.3125rem;\n}\n\n.avatar-initials {\n  font-size: 1rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n.avatar-circle {\n  border-radius: 50%;\n}\n\n.avatar-circle .avatar-img {\n  border-radius: 50%;\n}\n\n.avatar-centered {\n  display: -ms-flexbox;\n  display: flex;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.avatar-border-lg {\n  border: 0.1875rem solid #fff;\n}\n\n/*------------------------------------\n  Avatar Group\n------------------------------------*/\n.avatar-group {\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.avatar-group .avatar-circle .avatar-initials {\n  border-radius: 50%;\n}\n\n.avatar-group .avatar-xs .avatar-img,\n.avatar-group .avatar-xs .avatar-initials,\n.avatar-group .avatar-sm .avatar-img,\n.avatar-group .avatar-sm .avatar-initials,\n.avatar-group .avatar .avatar-img,\n.avatar-group .avatar .avatar-initials {\n  border: 2px solid #fff;\n}\n\n.avatar-group .avatar-lg .avatar-img,\n.avatar-group .avatar-lg .avatar-initials {\n  border: 5px solid #fff;\n}\n\n.avatar-group .avatar-xl .avatar-img,\n.avatar-group .avatar-xl .avatar-initials {\n  border: 7px solid #fff;\n}\n\n.avatar-group .avatar + .avatar {\n  margin-left: -1rem;\n}\n\n.avatar-group .avatar-xs + .avatar-xs {\n  margin-left: -0.6125rem;\n}\n\n.avatar-group .avatar-sm + .avatar-sm {\n  margin-left: -0.875rem;\n}\n\n.avatar-group .avatar-lg + .avatar-lg {\n  margin-left: -1.5rem;\n}\n\n.avatar-group .avatar-xl + .avatar-xl {\n  margin-left: -2rem;\n}\n\n/*------------------------------------\n  Avatar Initials\n------------------------------------*/\n.avatar-initials {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n/*------------------------------------\n  Avatar Sizes\n------------------------------------*/\n.avatar.avatar-circle .avatar-status {\n  bottom: -0.21875rem;\n  right: -0.21875rem;\n}\n\n.avatar.avatar-circle .avatar-sm-status {\n  bottom: 0;\n  right: 0;\n}\n\n.avatar.avatar-circle .avatar-lg-status {\n  bottom: -0.325rem;\n  right: -0.325rem;\n}\n\n.avatar-xss {\n  width: 1rem;\n  height: 1rem;\n}\n\n.avatar-xss .avatar-initials {\n  font-size: 0.75rem;\n}\n\n.avatar-xs {\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.avatar-xs .avatar-initials {\n  font-size: 0.75rem;\n}\n\n.avatar-xs.avatar-circle .avatar-status {\n  bottom: -0.21875rem;\n  right: -0.21875rem;\n}\n\n.avatar-xs.avatar-circle .avatar-sm-status {\n  bottom: -0.11719rem;\n  right: -0.11719rem;\n}\n\n.avatar-xs.avatar-circle .avatar-lg-status {\n  bottom: -0.325rem;\n  right: -0.325rem;\n}\n\n.avatar-xs {\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.avatar-xs .avatar-initials {\n  font-size: 0.75rem;\n}\n\n.avatar-xs.avatar-circle .avatar-status {\n  bottom: -0.21875rem;\n  right: -0.21875rem;\n}\n\n.avatar-xs.avatar-circle .avatar-sm-status {\n  bottom: -0.11719rem;\n  right: -0.11719rem;\n}\n\n.avatar-xs.avatar-circle .avatar-lg-status {\n  bottom: -0.325rem;\n  right: -0.325rem;\n}\n\n.avatar-sm {\n  width: 2.6875rem;\n  height: 2.6875rem;\n}\n\n.avatar-sm .avatar-initials {\n  font-size: 0.8125rem;\n}\n\n.avatar-sm.avatar-circle .avatar-status {\n  bottom: -0.21875rem;\n  right: -0.21875rem;\n}\n\n.avatar-sm.avatar-circle .avatar-sm-status {\n  bottom: -0.09375rem;\n  right: -0.09375rem;\n}\n\n.avatar-sm.avatar-circle .avatar-lg-status {\n  bottom: -0.40625rem;\n  right: -0.40625rem;\n}\n\n.avatar-lg {\n  width: 4.25rem;\n  height: 4.25rem;\n}\n\n.avatar-lg .avatar-initials {\n  font-size: 1.25rem;\n}\n\n.avatar-lg.avatar-circle .avatar-status {\n  bottom: -0.13125rem;\n  right: -0.13125rem;\n}\n\n.avatar-lg.avatar-circle .avatar-sm-status {\n  bottom: 0.09375rem;\n  right: 0.09375rem;\n}\n\n.avatar-lg.avatar-circle .avatar-lg-status {\n  bottom: -0.20312rem;\n  right: -0.20312rem;\n}\n\n.avatar-xl {\n  width: 5.625rem;\n  height: 5.625rem;\n}\n\n.avatar-xl .avatar-initials {\n  font-size: 2rem;\n}\n\n.avatar-xl.avatar-circle .avatar-status {\n  bottom: 0.16406rem;\n  right: 0.16406rem;\n}\n\n.avatar-xl.avatar-circle .avatar-sm-status {\n  bottom: 0.23438rem;\n  right: 0.23438rem;\n}\n\n.avatar-xl.avatar-circle .avatar-lg-status {\n  bottom: 0.13542rem;\n  right: 0.13542rem;\n}\n\n.avatar-xxl {\n  width: 7rem;\n  height: 7rem;\n}\n\n.avatar-xxl .avatar-initials {\n  font-size: 3rem;\n}\n\n.avatar-xxl.avatar-circle .avatar-status {\n  bottom: 0.4375rem;\n  right: 0.4375rem;\n}\n\n.avatar-xxl.avatar-circle .avatar-sm-status {\n  bottom: 0.58333rem;\n  right: 0.58333rem;\n}\n\n.avatar-xxl.avatar-circle .avatar-lg-status {\n  bottom: 0.29545rem;\n  right: 0.29545rem;\n}\n\n/*------------------------------------\n  Avatar Status\n------------------------------------*/\n.avatar-status {\n  position: absolute;\n  bottom: -0.525rem;\n  right: -0.525rem;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  white-space: nowrap;\n  text-align: center;\n  vertical-align: baseline;\n  border: 0.125rem solid #fff;\n  width: 1.3125rem;\n  height: 1.3125rem;\n  line-height: 1;\n  font-size: 0.625rem;\n  border-radius: 50%;\n}\n\n.avatar-sm-status {\n  bottom: -0.2625rem;\n  right: -0.2625rem;\n  width: 0.9375rem;\n  height: 0.9375rem;\n  font-size: 0.5rem;\n}\n\n.avatar-lg-status {\n  width: 1.625rem;\n  height: 1.625rem;\n  font-size: 0.75rem;\n}\n\n/*------------------------------------\n  Avatar Styles\n------------------------------------*/\n/* primary soft */\n.avatar-primary {\n  color: #fff;\n  background-color: #377dff;\n}\n\n/* secondary soft */\n.avatar-secondary {\n  color: #fff;\n  background-color: #71869d;\n}\n\n/* success soft */\n.avatar-success {\n  color: #fff;\n  background-color: #00c9a7;\n}\n\n/* info soft */\n.avatar-info {\n  color: #fff;\n  background-color: #09a5be;\n}\n\n/* warning soft */\n.avatar-warning {\n  color: #1e2022;\n  background-color: #f5ca99;\n}\n\n/* danger soft */\n.avatar-danger {\n  color: #fff;\n  background-color: #ed4c78;\n}\n\n/* light soft */\n.avatar-light {\n  color: #1e2022;\n  background-color: #f7faff;\n}\n\n/* dark soft */\n.avatar-dark {\n  color: #fff;\n  background-color: #21325b;\n}\n\n/* indigo soft */\n.avatar-indigo {\n  color: #fff;\n  background-color: #2d1582;\n}\n\n/* primary soft */\n.avatar-soft-primary {\n  color: #377dff;\n  background-color: rgba(55, 125, 255, 0.1);\n}\n\n/* secondary soft */\n.avatar-soft-secondary {\n  color: #71869d;\n  background-color: rgba(113, 134, 157, 0.1);\n}\n\n/* success soft */\n.avatar-soft-success {\n  color: #00c9a7;\n  background-color: rgba(0, 201, 167, 0.1);\n}\n\n/* info soft */\n.avatar-soft-info {\n  color: #09a5be;\n  background-color: rgba(9, 165, 190, 0.1);\n}\n\n/* warning soft */\n.avatar-soft-warning {\n  color: #f5ca99;\n  background-color: rgba(245, 202, 153, 0.1);\n}\n\n/* danger soft */\n.avatar-soft-danger {\n  color: #ed4c78;\n  background-color: rgba(237, 76, 120, 0.1);\n}\n\n/* light soft */\n.avatar-soft-light {\n  color: #f7faff;\n  background-color: rgba(247, 250, 255, 0.1);\n}\n\n/* dark soft */\n.avatar-soft-dark {\n  color: #21325b;\n  background-color: rgba(33, 50, 91, 0.1);\n}\n\n/* indigo soft */\n.avatar-soft-indigo {\n  color: #2d1582;\n  background-color: rgba(45, 21, 130, 0.1);\n}\n\n/*------------------------------------\n  Blockquote\n------------------------------------*/\n.blockquote {\n  font-size: 1rem;\n  border-left: 0.1875rem solid #e7eaf3;\n  padding-left: 0.75rem;\n  margin-bottom: 0;\n}\n\n.blockquote-footer {\n  margin-top: 1rem;\n}\n\n/*------------------------------------\n  Badge Soft\n------------------------------------*/\n/* primary soft */\n.badge-soft-primary {\n  color: #377dff;\n  background-color: rgba(55, 125, 255, 0.1);\n}\n\na.badge-soft-primary:hover, a.badge-soft-primary:focus {\n  color: #fff;\n  background-color: #377dff;\n}\n\n/* secondary soft */\n.badge-soft-secondary {\n  color: #71869d;\n  background-color: rgba(113, 134, 157, 0.1);\n}\n\na.badge-soft-secondary:hover, a.badge-soft-secondary:focus {\n  color: #fff;\n  background-color: #71869d;\n}\n\n/* success soft */\n.badge-soft-success {\n  color: #00c9a7;\n  background-color: rgba(0, 201, 167, 0.1);\n}\n\na.badge-soft-success:hover, a.badge-soft-success:focus {\n  color: #fff;\n  background-color: #00c9a7;\n}\n\n/* info soft */\n.badge-soft-info {\n  color: #09a5be;\n  background-color: rgba(9, 165, 190, 0.1);\n}\n\na.badge-soft-info:hover, a.badge-soft-info:focus {\n  color: #fff;\n  background-color: #09a5be;\n}\n\n/* warning soft */\n.badge-soft-warning {\n  color: #f5ca99;\n  background-color: rgba(245, 202, 153, 0.1);\n}\n\na.badge-soft-warning:hover, a.badge-soft-warning:focus {\n  color: #1e2022;\n  background-color: #f5ca99;\n}\n\n/* danger soft */\n.badge-soft-danger {\n  color: #ed4c78;\n  background-color: rgba(237, 76, 120, 0.1);\n}\n\na.badge-soft-danger:hover, a.badge-soft-danger:focus {\n  color: #fff;\n  background-color: #ed4c78;\n}\n\n/* light soft */\n.badge-soft-light {\n  color: #f7faff;\n  background-color: rgba(247, 250, 255, 0.1);\n}\n\na.badge-soft-light:hover, a.badge-soft-light:focus {\n  color: #1e2022;\n  background-color: #f7faff;\n}\n\n/* dark soft */\n.badge-soft-dark {\n  color: #21325b;\n  background-color: rgba(33, 50, 91, 0.1);\n}\n\na.badge-soft-dark:hover, a.badge-soft-dark:focus {\n  color: #fff;\n  background-color: #21325b;\n}\n\n/* indigo soft */\n.badge-soft-indigo {\n  color: #2d1582;\n  background-color: rgba(45, 21, 130, 0.1);\n}\n\na.badge-soft-indigo:hover, a.badge-soft-indigo:focus {\n  color: #fff;\n  background-color: #2d1582;\n}\n\n.badge-soft-warning {\n  color: #ec9a3c !important;\n}\n\n/*------------------------------------\n  Custom Buttons\n------------------------------------*/\n.btn.dropdown-toggle {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.btn-white {\n  font-weight: 400;\n  background-color: #fff;\n  border-color: #e7eaf3;\n}\n\n.btn-white.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%2371869d' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-white:hover, .btn-white:focus, .btn-white.focus, .btn-white:active, .btn-white.active {\n  color: #0052ea;\n  box-shadow: 0px 3px 6px -2px rgba(140, 152, 164, 0.25);\n}\n\n.btn-white:hover.dropdown-toggle::after, .btn-white:focus.dropdown-toggle::after, .btn-white.focus.dropdown-toggle::after, .btn-white:active.dropdown-toggle::after, .btn-white.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23377dff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-white.disabled, .btn-white:disabled {\n  color: #677788;\n  background-color: rgba(231, 234, 243, 0.5);\n}\n\n.btn-primary.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-secondary.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-success.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-info.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-warning.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%231e2022' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-danger.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-light.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%231e2022' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-dark.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-indigo.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-primary.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23377dff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-primary:hover.dropdown-toggle::after, .btn-outline-primary:active.dropdown-toggle::after, .btn-outline-primary.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-secondary.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%2371869d' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-secondary:hover.dropdown-toggle::after, .btn-outline-secondary:active.dropdown-toggle::after, .btn-outline-secondary.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-success.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%2300c9a7' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-success:hover.dropdown-toggle::after, .btn-outline-success:active.dropdown-toggle::after, .btn-outline-success.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-info.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%2309a5be' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-info:hover.dropdown-toggle::after, .btn-outline-info:active.dropdown-toggle::after, .btn-outline-info.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-warning.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23f5ca99' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-warning:hover.dropdown-toggle::after, .btn-outline-warning:active.dropdown-toggle::after, .btn-outline-warning.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%231e2022' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-danger.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23ed4c78' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-danger:hover.dropdown-toggle::after, .btn-outline-danger:active.dropdown-toggle::after, .btn-outline-danger.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-light.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23f7faff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-light:hover.dropdown-toggle::after, .btn-outline-light:active.dropdown-toggle::after, .btn-outline-light.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%231e2022' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-dark.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%2321325b' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-dark:hover.dropdown-toggle::after, .btn-outline-dark:active.dropdown-toggle::after, .btn-outline-dark.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-indigo.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%232d1582' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-outline-indigo:hover.dropdown-toggle::after, .btn-outline-indigo:active.dropdown-toggle::after, .btn-outline-indigo.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n/* primary button :hover, :focus, :active effects */\n.btn-primary[href]:hover, .btn-primary[href]:focus, .btn-primary[href]:active, .btn-primary[type]:hover, .btn-primary[type]:focus, .btn-primary[type]:active {\n  box-shadow: 0 4px 11px rgba(55, 125, 255, 0.35);\n}\n\n.btn-primary:not(label.btn), .btn-primary:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-primary:not([href]), .btn-primary:not([href]):not([href]):not(:disabled):not(.disabled) {\n  background-color: #377dff;\n  border-color: #377dff;\n}\n\n.btn-primary:hover {\n  background-color: #377dff;\n  border-color: #377dff;\n}\n\n/* secondary button :hover, :focus, :active effects */\n.btn-secondary[href]:hover, .btn-secondary[href]:focus, .btn-secondary[href]:active, .btn-secondary[type]:hover, .btn-secondary[type]:focus, .btn-secondary[type]:active {\n  box-shadow: 0 4px 11px rgba(113, 134, 157, 0.35);\n}\n\n.btn-secondary:not(label.btn), .btn-secondary:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-secondary:not([href]), .btn-secondary:not([href]):not([href]):not(:disabled):not(.disabled) {\n  background-color: #71869d;\n  border-color: #71869d;\n}\n\n.btn-secondary:hover {\n  background-color: #71869d;\n  border-color: #71869d;\n}\n\n/* success button :hover, :focus, :active effects */\n.btn-success[href]:hover, .btn-success[href]:focus, .btn-success[href]:active, .btn-success[type]:hover, .btn-success[type]:focus, .btn-success[type]:active {\n  box-shadow: 0 4px 11px rgba(0, 201, 167, 0.35);\n}\n\n.btn-success:not(label.btn), .btn-success:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-success:not([href]), .btn-success:not([href]):not([href]):not(:disabled):not(.disabled) {\n  background-color: #00c9a7;\n  border-color: #00c9a7;\n}\n\n.btn-success:hover {\n  background-color: #00c9a7;\n  border-color: #00c9a7;\n}\n\n/* info button :hover, :focus, :active effects */\n.btn-info[href]:hover, .btn-info[href]:focus, .btn-info[href]:active, .btn-info[type]:hover, .btn-info[type]:focus, .btn-info[type]:active {\n  box-shadow: 0 4px 11px rgba(9, 165, 190, 0.35);\n}\n\n.btn-info:not(label.btn), .btn-info:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-info:not([href]), .btn-info:not([href]):not([href]):not(:disabled):not(.disabled) {\n  background-color: #09a5be;\n  border-color: #09a5be;\n}\n\n.btn-info:hover {\n  background-color: #09a5be;\n  border-color: #09a5be;\n}\n\n/* warning button :hover, :focus, :active effects */\n.btn-warning[href]:hover, .btn-warning[href]:focus, .btn-warning[href]:active, .btn-warning[type]:hover, .btn-warning[type]:focus, .btn-warning[type]:active {\n  box-shadow: 0 4px 11px rgba(245, 202, 153, 0.35);\n}\n\n.btn-warning:not(label.btn), .btn-warning:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-warning:not([href]), .btn-warning:not([href]):not([href]):not(:disabled):not(.disabled) {\n  background-color: #f5ca99;\n  border-color: #f5ca99;\n}\n\n.btn-warning:hover {\n  background-color: #f5ca99;\n  border-color: #f5ca99;\n}\n\n/* danger button :hover, :focus, :active effects */\n.btn-danger[href]:hover, .btn-danger[href]:focus, .btn-danger[href]:active, .btn-danger[type]:hover, .btn-danger[type]:focus, .btn-danger[type]:active {\n  box-shadow: 0 4px 11px rgba(237, 76, 120, 0.35);\n}\n\n.btn-danger:not(label.btn), .btn-danger:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-danger:not([href]), .btn-danger:not([href]):not([href]):not(:disabled):not(.disabled) {\n  background-color: #ed4c78;\n  border-color: #ed4c78;\n}\n\n.btn-danger:hover {\n  background-color: #ed4c78;\n  border-color: #ed4c78;\n}\n\n/* light button :hover, :focus, :active effects */\n.btn-light[href]:hover, .btn-light[href]:focus, .btn-light[href]:active, .btn-light[type]:hover, .btn-light[type]:focus, .btn-light[type]:active {\n  box-shadow: 0 4px 11px rgba(247, 250, 255, 0.35);\n}\n\n.btn-light:not(label.btn), .btn-light:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-light:not([href]), .btn-light:not([href]):not([href]):not(:disabled):not(.disabled) {\n  background-color: #f7faff;\n  border-color: #f7faff;\n}\n\n.btn-light:hover {\n  background-color: #f7faff;\n  border-color: #f7faff;\n}\n\n/* dark button :hover, :focus, :active effects */\n.btn-dark[href]:hover, .btn-dark[href]:focus, .btn-dark[href]:active, .btn-dark[type]:hover, .btn-dark[type]:focus, .btn-dark[type]:active {\n  box-shadow: 0 4px 11px rgba(33, 50, 91, 0.35);\n}\n\n.btn-dark:not(label.btn), .btn-dark:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-dark:not([href]), .btn-dark:not([href]):not([href]):not(:disabled):not(.disabled) {\n  background-color: #21325b;\n  border-color: #21325b;\n}\n\n.btn-dark:hover {\n  background-color: #21325b;\n  border-color: #21325b;\n}\n\n/* indigo button :hover, :focus, :active effects */\n.btn-indigo[href]:hover, .btn-indigo[href]:focus, .btn-indigo[href]:active, .btn-indigo[type]:hover, .btn-indigo[type]:focus, .btn-indigo[type]:active {\n  box-shadow: 0 4px 11px rgba(45, 21, 130, 0.35);\n}\n\n.btn-indigo:not(label.btn), .btn-indigo:not(label.btn):not([href]):not(:disabled):not(.disabled), .btn-indigo:not([href]), .btn-indigo:not([href]):not([href]):not(:disabled):not(.disabled) {\n  background-color: #2d1582;\n  border-color: #2d1582;\n}\n\n.btn-indigo:hover {\n  background-color: #2d1582;\n  border-color: #2d1582;\n}\n\n/*------------------------------------\n  Custom Button Toggle\n------------------------------------*/\n/* primary custom toggle button */\n.btn-custom-toggle-primary {\n  color: #97a4af;\n  border-color: #e7eaf3;\n}\n\n.btn-custom-toggle-primary:hover {\n  color: #377dff;\n  background-color: transparent;\n  border-color: #377dff;\n}\n\n.btn-custom-toggle-primary:not(:disabled):not(.disabled):active, .btn-custom-toggle-primary:not(:disabled):not(.disabled).active, .btn-custom-toggle-primary:not(:disabled):not(.disabled):active, .btn-custom-toggle-primary:not(:disabled):not(.disabled).active {\n  color: #fff;\n  background-color: #377dff;\n  border-color: #377dff;\n}\n\n/* secondary custom toggle button */\n.btn-custom-toggle-secondary {\n  color: #97a4af;\n  border-color: #e7eaf3;\n}\n\n.btn-custom-toggle-secondary:hover {\n  color: #71869d;\n  background-color: transparent;\n  border-color: #71869d;\n}\n\n.btn-custom-toggle-secondary:not(:disabled):not(.disabled):active, .btn-custom-toggle-secondary:not(:disabled):not(.disabled).active, .btn-custom-toggle-secondary:not(:disabled):not(.disabled):active, .btn-custom-toggle-secondary:not(:disabled):not(.disabled).active {\n  color: #fff;\n  background-color: #71869d;\n  border-color: #71869d;\n}\n\n/* success custom toggle button */\n.btn-custom-toggle-success {\n  color: #97a4af;\n  border-color: #e7eaf3;\n}\n\n.btn-custom-toggle-success:hover {\n  color: #00c9a7;\n  background-color: transparent;\n  border-color: #00c9a7;\n}\n\n.btn-custom-toggle-success:not(:disabled):not(.disabled):active, .btn-custom-toggle-success:not(:disabled):not(.disabled).active, .btn-custom-toggle-success:not(:disabled):not(.disabled):active, .btn-custom-toggle-success:not(:disabled):not(.disabled).active {\n  color: #fff;\n  background-color: #00c9a7;\n  border-color: #00c9a7;\n}\n\n/* info custom toggle button */\n.btn-custom-toggle-info {\n  color: #97a4af;\n  border-color: #e7eaf3;\n}\n\n.btn-custom-toggle-info:hover {\n  color: #09a5be;\n  background-color: transparent;\n  border-color: #09a5be;\n}\n\n.btn-custom-toggle-info:not(:disabled):not(.disabled):active, .btn-custom-toggle-info:not(:disabled):not(.disabled).active, .btn-custom-toggle-info:not(:disabled):not(.disabled):active, .btn-custom-toggle-info:not(:disabled):not(.disabled).active {\n  color: #fff;\n  background-color: #09a5be;\n  border-color: #09a5be;\n}\n\n/* warning custom toggle button */\n.btn-custom-toggle-warning {\n  color: #97a4af;\n  border-color: #e7eaf3;\n}\n\n.btn-custom-toggle-warning:hover {\n  color: #f5ca99;\n  background-color: transparent;\n  border-color: #f5ca99;\n}\n\n.btn-custom-toggle-warning:not(:disabled):not(.disabled):active, .btn-custom-toggle-warning:not(:disabled):not(.disabled).active, .btn-custom-toggle-warning:not(:disabled):not(.disabled):active, .btn-custom-toggle-warning:not(:disabled):not(.disabled).active {\n  color: #1e2022;\n  background-color: #f5ca99;\n  border-color: #f5ca99;\n}\n\n/* danger custom toggle button */\n.btn-custom-toggle-danger {\n  color: #97a4af;\n  border-color: #e7eaf3;\n}\n\n.btn-custom-toggle-danger:hover {\n  color: #ed4c78;\n  background-color: transparent;\n  border-color: #ed4c78;\n}\n\n.btn-custom-toggle-danger:not(:disabled):not(.disabled):active, .btn-custom-toggle-danger:not(:disabled):not(.disabled).active, .btn-custom-toggle-danger:not(:disabled):not(.disabled):active, .btn-custom-toggle-danger:not(:disabled):not(.disabled).active {\n  color: #fff;\n  background-color: #ed4c78;\n  border-color: #ed4c78;\n}\n\n/* light custom toggle button */\n.btn-custom-toggle-light {\n  color: #97a4af;\n  border-color: #e7eaf3;\n}\n\n.btn-custom-toggle-light:hover {\n  color: #fff;\n  background-color: transparent;\n  border-color: #f7faff;\n}\n\n.btn-custom-toggle-light:not(:disabled):not(.disabled):active, .btn-custom-toggle-light:not(:disabled):not(.disabled).active, .btn-custom-toggle-light:not(:disabled):not(.disabled):active, .btn-custom-toggle-light:not(:disabled):not(.disabled).active {\n  color: #1e2022;\n  background-color: #f7faff;\n  border-color: #f7faff;\n}\n\n/* dark custom toggle button */\n.btn-custom-toggle-dark {\n  color: #97a4af;\n  border-color: #e7eaf3;\n}\n\n.btn-custom-toggle-dark:hover {\n  color: #21325b;\n  background-color: transparent;\n  border-color: #21325b;\n}\n\n.btn-custom-toggle-dark:not(:disabled):not(.disabled):active, .btn-custom-toggle-dark:not(:disabled):not(.disabled).active, .btn-custom-toggle-dark:not(:disabled):not(.disabled):active, .btn-custom-toggle-dark:not(:disabled):not(.disabled).active {\n  color: #fff;\n  background-color: #21325b;\n  border-color: #21325b;\n}\n\n/* indigo custom toggle button */\n.btn-custom-toggle-indigo {\n  color: #97a4af;\n  border-color: #e7eaf3;\n}\n\n.btn-custom-toggle-indigo:hover {\n  color: #2d1582;\n  background-color: transparent;\n  border-color: #2d1582;\n}\n\n.btn-custom-toggle-indigo:not(:disabled):not(.disabled):active, .btn-custom-toggle-indigo:not(:disabled):not(.disabled).active, .btn-custom-toggle-indigo:not(:disabled):not(.disabled):active, .btn-custom-toggle-indigo:not(:disabled):not(.disabled).active {\n  color: #fff;\n  background-color: #2d1582;\n  border-color: #2d1582;\n}\n\n.btn-custom-toggle-light {\n  color: rgba(255, 255, 255, 0.7);\n  border-color: rgba(255, 255, 255, 0.7);\n}\n\n/*------------------------------------\n  Soft Button Styles\n------------------------------------*/\n.btn-soft-primary {\n  color: #377dff;\n  background-color: rgba(55, 125, 255, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-primary:hover, .btn-soft-primary:focus, .btn-soft-primary:active, .btn-soft-primary.active {\n  color: #fff;\n  background-color: #377dff;\n  box-shadow: 0 4px 11px rgba(55, 125, 255, 0.1);\n}\n\n.btn-soft-primary.disabled, .btn-soft-primary:disabled {\n  color: #377dff;\n  background-color: rgba(55, 125, 255, 0.1);\n  box-shadow: none;\n}\n\n.btn-soft-primary:not(:disabled):not(.disabled):active, .btn-soft-primary:not(:disabled):not(.disabled).active,\n.show > .btn-soft-primary.dropdown-toggle {\n  color: #fff;\n  background-color: #377dff;\n}\n\n.btn-soft-secondary {\n  color: #71869d;\n  background-color: rgba(113, 134, 157, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-secondary:hover, .btn-soft-secondary:focus, .btn-soft-secondary:active, .btn-soft-secondary.active {\n  color: #fff;\n  background-color: #71869d;\n  box-shadow: 0 4px 11px rgba(113, 134, 157, 0.1);\n}\n\n.btn-soft-secondary.disabled, .btn-soft-secondary:disabled {\n  color: #71869d;\n  background-color: rgba(113, 134, 157, 0.1);\n  box-shadow: none;\n}\n\n.btn-soft-secondary:not(:disabled):not(.disabled):active, .btn-soft-secondary:not(:disabled):not(.disabled).active,\n.show > .btn-soft-secondary.dropdown-toggle {\n  color: #fff;\n  background-color: #71869d;\n}\n\n.btn-soft-success {\n  color: #00c9a7;\n  background-color: rgba(0, 201, 167, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-success:hover, .btn-soft-success:focus, .btn-soft-success:active, .btn-soft-success.active {\n  color: #fff;\n  background-color: #00c9a7;\n  box-shadow: 0 4px 11px rgba(0, 201, 167, 0.1);\n}\n\n.btn-soft-success.disabled, .btn-soft-success:disabled {\n  color: #00c9a7;\n  background-color: rgba(0, 201, 167, 0.1);\n  box-shadow: none;\n}\n\n.btn-soft-success:not(:disabled):not(.disabled):active, .btn-soft-success:not(:disabled):not(.disabled).active,\n.show > .btn-soft-success.dropdown-toggle {\n  color: #fff;\n  background-color: #00c9a7;\n}\n\n.btn-soft-info {\n  color: #09a5be;\n  background-color: rgba(9, 165, 190, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-info:hover, .btn-soft-info:focus, .btn-soft-info:active, .btn-soft-info.active {\n  color: #fff;\n  background-color: #09a5be;\n  box-shadow: 0 4px 11px rgba(9, 165, 190, 0.1);\n}\n\n.btn-soft-info.disabled, .btn-soft-info:disabled {\n  color: #09a5be;\n  background-color: rgba(9, 165, 190, 0.1);\n  box-shadow: none;\n}\n\n.btn-soft-info:not(:disabled):not(.disabled):active, .btn-soft-info:not(:disabled):not(.disabled).active,\n.show > .btn-soft-info.dropdown-toggle {\n  color: #fff;\n  background-color: #09a5be;\n}\n\n.btn-soft-warning {\n  color: #f5ca99;\n  background-color: rgba(245, 202, 153, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-warning:hover, .btn-soft-warning:focus, .btn-soft-warning:active, .btn-soft-warning.active {\n  color: #1e2022;\n  background-color: #f5ca99;\n  box-shadow: 0 4px 11px rgba(245, 202, 153, 0.1);\n}\n\n.btn-soft-warning.disabled, .btn-soft-warning:disabled {\n  color: #f5ca99;\n  background-color: rgba(245, 202, 153, 0.1);\n  box-shadow: none;\n}\n\n.btn-soft-warning:not(:disabled):not(.disabled):active, .btn-soft-warning:not(:disabled):not(.disabled).active,\n.show > .btn-soft-warning.dropdown-toggle {\n  color: #1e2022;\n  background-color: #f5ca99;\n}\n\n.btn-soft-danger {\n  color: #ed4c78;\n  background-color: rgba(237, 76, 120, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-danger:hover, .btn-soft-danger:focus, .btn-soft-danger:active, .btn-soft-danger.active {\n  color: #fff;\n  background-color: #ed4c78;\n  box-shadow: 0 4px 11px rgba(237, 76, 120, 0.1);\n}\n\n.btn-soft-danger.disabled, .btn-soft-danger:disabled {\n  color: #ed4c78;\n  background-color: rgba(237, 76, 120, 0.1);\n  box-shadow: none;\n}\n\n.btn-soft-danger:not(:disabled):not(.disabled):active, .btn-soft-danger:not(:disabled):not(.disabled).active,\n.show > .btn-soft-danger.dropdown-toggle {\n  color: #fff;\n  background-color: #ed4c78;\n}\n\n.btn-soft-light {\n  color: #f7faff;\n  background-color: rgba(247, 250, 255, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-light:hover, .btn-soft-light:focus, .btn-soft-light:active, .btn-soft-light.active {\n  color: #1e2022;\n  background-color: #f7faff;\n  box-shadow: 0 4px 11px rgba(247, 250, 255, 0.1);\n}\n\n.btn-soft-light.disabled, .btn-soft-light:disabled {\n  color: #f7faff;\n  background-color: rgba(247, 250, 255, 0.1);\n  box-shadow: none;\n}\n\n.btn-soft-light:not(:disabled):not(.disabled):active, .btn-soft-light:not(:disabled):not(.disabled).active,\n.show > .btn-soft-light.dropdown-toggle {\n  color: #1e2022;\n  background-color: #f7faff;\n}\n\n.btn-soft-dark {\n  color: #21325b;\n  background-color: rgba(33, 50, 91, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-dark:hover, .btn-soft-dark:focus, .btn-soft-dark:active, .btn-soft-dark.active {\n  color: #fff;\n  background-color: #21325b;\n  box-shadow: 0 4px 11px rgba(33, 50, 91, 0.1);\n}\n\n.btn-soft-dark.disabled, .btn-soft-dark:disabled {\n  color: #21325b;\n  background-color: rgba(33, 50, 91, 0.1);\n  box-shadow: none;\n}\n\n.btn-soft-dark:not(:disabled):not(.disabled):active, .btn-soft-dark:not(:disabled):not(.disabled).active,\n.show > .btn-soft-dark.dropdown-toggle {\n  color: #fff;\n  background-color: #21325b;\n}\n\n.btn-soft-indigo {\n  color: #2d1582;\n  background-color: rgba(45, 21, 130, 0.1);\n  border-color: transparent;\n}\n\n.btn-soft-indigo:hover, .btn-soft-indigo:focus, .btn-soft-indigo:active, .btn-soft-indigo.active {\n  color: #fff;\n  background-color: #2d1582;\n  box-shadow: 0 4px 11px rgba(45, 21, 130, 0.1);\n}\n\n.btn-soft-indigo.disabled, .btn-soft-indigo:disabled {\n  color: #2d1582;\n  background-color: rgba(45, 21, 130, 0.1);\n  box-shadow: none;\n}\n\n.btn-soft-indigo:not(:disabled):not(.disabled):active, .btn-soft-indigo:not(:disabled):not(.disabled).active,\n.show > .btn-soft-indigo.dropdown-toggle {\n  color: #fff;\n  background-color: #2d1582;\n}\n\n.btn-soft-primary.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23377dff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  transition: all 0.2s ease-in-out;\n}\n\n.btn-soft-primary:hover.dropdown-toggle::after, .btn-soft-primary:focus.dropdown-toggle::after, .btn-soft-primary.focus.dropdown-toggle::after, .btn-soft-primary:active.dropdown-toggle::after, .btn-soft-primary.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-soft-secondary.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%2371869d' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  transition: all 0.2s ease-in-out;\n}\n\n.btn-soft-secondary:hover.dropdown-toggle::after, .btn-soft-secondary:focus.dropdown-toggle::after, .btn-soft-secondary.focus.dropdown-toggle::after, .btn-soft-secondary:active.dropdown-toggle::after, .btn-soft-secondary.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-soft-success.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%2300c9a7' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  transition: all 0.2s ease-in-out;\n}\n\n.btn-soft-success:hover.dropdown-toggle::after, .btn-soft-success:focus.dropdown-toggle::after, .btn-soft-success.focus.dropdown-toggle::after, .btn-soft-success:active.dropdown-toggle::after, .btn-soft-success.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-soft-info.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%2309a5be' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  transition: all 0.2s ease-in-out;\n}\n\n.btn-soft-info:hover.dropdown-toggle::after, .btn-soft-info:focus.dropdown-toggle::after, .btn-soft-info.focus.dropdown-toggle::after, .btn-soft-info:active.dropdown-toggle::after, .btn-soft-info.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-soft-warning.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23f5ca99' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  transition: all 0.2s ease-in-out;\n}\n\n.btn-soft-warning:hover.dropdown-toggle::after, .btn-soft-warning:focus.dropdown-toggle::after, .btn-soft-warning.focus.dropdown-toggle::after, .btn-soft-warning:active.dropdown-toggle::after, .btn-soft-warning.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%231e2022' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-soft-danger.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23ed4c78' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  transition: all 0.2s ease-in-out;\n}\n\n.btn-soft-danger:hover.dropdown-toggle::after, .btn-soft-danger:focus.dropdown-toggle::after, .btn-soft-danger.focus.dropdown-toggle::after, .btn-soft-danger:active.dropdown-toggle::after, .btn-soft-danger.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-soft-light.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23f7faff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  transition: all 0.2s ease-in-out;\n}\n\n.btn-soft-light:hover.dropdown-toggle::after, .btn-soft-light:focus.dropdown-toggle::after, .btn-soft-light.focus.dropdown-toggle::after, .btn-soft-light:active.dropdown-toggle::after, .btn-soft-light.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%231e2022' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-soft-dark.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%2321325b' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  transition: all 0.2s ease-in-out;\n}\n\n.btn-soft-dark:hover.dropdown-toggle::after, .btn-soft-dark:focus.dropdown-toggle::after, .btn-soft-dark.focus.dropdown-toggle::after, .btn-soft-dark:active.dropdown-toggle::after, .btn-soft-dark.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n.btn-soft-indigo.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%232d1582' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  transition: all 0.2s ease-in-out;\n}\n\n.btn-soft-indigo:hover.dropdown-toggle::after, .btn-soft-indigo:focus.dropdown-toggle::after, .btn-soft-indigo.focus.dropdown-toggle::after, .btn-soft-indigo:active.dropdown-toggle::after, .btn-soft-indigo.active.dropdown-toggle::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23fff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n/*------------------------------------\n  Outline Button Styles\n------------------------------------*/\n.btn-outline-secondary {\n  border-color: #e7eaf3;\n}\n\n/*------------------------------------\n  Button Sizes\n------------------------------------*/\n/* Wide */\n.btn-wide {\n  min-width: 10rem;\n}\n\n/* Extra Small */\n.btn-xs {\n  font-size: 0.75rem;\n  font-weight: 400;\n  padding: 0.275rem 0.75rem;\n}\n\n/* Icons */\n.btn-icon.btn-xs {\n  font-size: 0.75rem;\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.btn-icon.btn-sm, .btn-group-sm > .btn-icon.btn {\n  font-size: 0.8125rem;\n  width: 2.6875rem;\n  height: 2.6875rem;\n}\n\n.btn-icon.btn-lg, .btn-group-lg > .btn-icon.btn {\n  font-size: 1.25rem;\n  width: 4.25rem;\n  height: 4.25rem;\n}\n\n/*------------------------------------\n  Ghost Buttons Styles\n------------------------------------*/\n/* primary ghost button */\n.btn-ghost-primary {\n  color: #377dff;\n  background-color: transparent;\n}\n\n.btn-ghost-primary:hover, .btn-ghost-primary:focus, .btn-ghost-primary:active, .btn-ghost-primary.active {\n  color: #377dff;\n  background-color: rgba(55, 125, 255, 0.1);\n}\n\n/* secondary ghost button */\n.btn-ghost-secondary {\n  color: #71869d;\n  background-color: transparent;\n}\n\n.btn-ghost-secondary:hover, .btn-ghost-secondary:focus, .btn-ghost-secondary:active, .btn-ghost-secondary.active {\n  color: #71869d;\n  background-color: rgba(55, 125, 255, 0.1);\n}\n\n/* success ghost button */\n.btn-ghost-success {\n  color: #00c9a7;\n  background-color: transparent;\n}\n\n.btn-ghost-success:hover, .btn-ghost-success:focus, .btn-ghost-success:active, .btn-ghost-success.active {\n  color: #00c9a7;\n  background-color: rgba(0, 201, 167, 0.1);\n}\n\n/* info ghost button */\n.btn-ghost-info {\n  color: #09a5be;\n  background-color: transparent;\n}\n\n.btn-ghost-info:hover, .btn-ghost-info:focus, .btn-ghost-info:active, .btn-ghost-info.active {\n  color: #09a5be;\n  background-color: rgba(9, 165, 190, 0.1);\n}\n\n/* warning ghost button */\n.btn-ghost-warning {\n  color: #f5ca99;\n  background-color: transparent;\n}\n\n.btn-ghost-warning:hover, .btn-ghost-warning:focus, .btn-ghost-warning:active, .btn-ghost-warning.active {\n  color: #f5ca99;\n  background-color: rgba(245, 202, 153, 0.1);\n}\n\n/* danger ghost button */\n.btn-ghost-danger {\n  color: #ed4c78;\n  background-color: transparent;\n}\n\n.btn-ghost-danger:hover, .btn-ghost-danger:focus, .btn-ghost-danger:active, .btn-ghost-danger.active {\n  color: #ed4c78;\n  background-color: rgba(237, 76, 120, 0.1);\n}\n\n/* light ghost button */\n.btn-ghost-light {\n  color: #f7faff;\n  background-color: transparent;\n}\n\n.btn-ghost-light:hover, .btn-ghost-light:focus, .btn-ghost-light:active, .btn-ghost-light.active {\n  color: #f7faff;\n  background-color: rgba(247, 250, 255, 0.1);\n}\n\n/* dark ghost button */\n.btn-ghost-dark {\n  color: #21325b;\n  background-color: transparent;\n}\n\n.btn-ghost-dark:hover, .btn-ghost-dark:focus, .btn-ghost-dark:active, .btn-ghost-dark.active {\n  color: #21325b;\n  background-color: rgba(33, 50, 91, 0.1);\n}\n\n/* indigo ghost button */\n.btn-ghost-indigo {\n  color: #2d1582;\n  background-color: transparent;\n}\n\n.btn-ghost-indigo:hover, .btn-ghost-indigo:focus, .btn-ghost-indigo:active, .btn-ghost-indigo.active {\n  color: #2d1582;\n  background-color: rgba(45, 21, 130, 0.1);\n}\n\n.btn-ghost-secondary:hover, .btn-ghost-secondary:focus, .btn-ghost-secondary:active {\n  color: #377dff;\n}\n\n/*------------------------------------\n  Button Groups\n------------------------------------*/\n.btn-group-segment {\n  position: relative;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  background-color: #f8fafd;\n  border-radius: 0.3125rem;\n  padding: 0.25rem 0.25rem;\n}\n\n.btn-group-segment .btn {\n  color: #677788;\n}\n\n.btn-group-segment .btn:not(:last-child) {\n  margin-right: 0.25rem;\n}\n\n.btn-group-segment .btn:hover {\n  color: #377dff;\n}\n\n.btn-group-segment .btn.active {\n  color: #1e2022;\n  background-color: #fff;\n  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);\n}\n\n.btn-group-segment .btn:not(:disabled):not(.disabled):active, .btn-group-segment .btn:not(:disabled):not(.disabled).active {\n  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);\n}\n\n.btn-group-segment > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-segment > .btn-group:not(:last-child) > .btn,\n.btn-group-segment > .btn:not(:first-child),\n.btn-group-segment > .btn-group:not(:first-child) > .btn {\n  border-radius: 0.3125rem;\n}\n\n.btn-group-segment.btn-group-pills {\n  border-radius: 6.1875rem;\n}\n\n.btn-group-segment.btn-group-pills > .btn:not(:last-child):not(.dropdown-toggle),\n.btn-group-segment.btn-group-pills > .btn-group:not(:last-child) > .btn,\n.btn-group-segment.btn-group-pills > .btn:not(:first-child),\n.btn-group-segment.btn-group-pills > .btn-group:not(:first-child) > .btn {\n  border-radius: 6.1875rem;\n}\n\n/*------------------------------------\n  Button Status\n------------------------------------*/\n.btn-status {\n  position: absolute;\n  top: -0.4375rem;\n  right: -0.4375rem;\n  display: inline-block;\n  white-space: nowrap;\n  text-align: center;\n  vertical-align: baseline;\n  width: 1.3125rem;\n  height: 1.3125rem;\n  line-height: 1;\n  font-size: 0.625rem;\n  border-radius: 50%;\n}\n\n.btn-status-initials {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n/*------------------------------------\n  Buttons\n------------------------------------*/\n.btn svg {\n  margin-bottom: 0;\n}\n\nlabel.btn {\n  cursor: pointer !important;\n}\n\n.btn-pill {\n  border-radius: 6.1875rem;\n}\n\n.btn-link {\n  font-weight: 600;\n}\n\n.btn-icon {\n  position: relative;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 1rem;\n  font-weight: 400;\n  width: 3.125rem;\n  height: 3.125rem;\n  padding: 0;\n}\n\n/* Toggle */\n.btn-toggle-default {\n  display: inline-block;\n}\n\n.btn-toggle-toggled {\n  display: none;\n}\n\n.btn.toggled .btn-toggle-default {\n  display: none;\n}\n\n.btn.toggled .btn-toggle-toggled {\n  display: inline-block;\n}\n\n/*------------------------------------\n  Brand\n------------------------------------*/\n.brand {\n  width: 100%;\n  max-width: 7.5rem;\n}\n\n/*------------------------------------\n  Breadcrumb\n------------------------------------*/\n.breadcrumb .breadcrumb-item {\n  color: #1e2022;\n  font-size: 0.875rem;\n}\n\n.breadcrumb .breadcrumb-link {\n  color: #8c98a4;\n}\n\n.breadcrumb .breadcrumb-link:hover {\n  color: #0052ea;\n}\n\n.breadcrumb-light .breadcrumb-item {\n  color: #fff;\n}\n\n.breadcrumb-light .breadcrumb-item + .breadcrumb-item::before {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.breadcrumb-light .breadcrumb-link {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.breadcrumb-light .breadcrumb-link:hover {\n  color: #fff;\n}\n\n.breadcrumb-no-gutter {\n  padding: 0;\n}\n\n/*------------------------------------\n  Card\n------------------------------------*/\n.card-2-count {\n  -webkit-column-count: 2;\n     -moz-column-count: 2;\n          column-count: 2;\n}\n\n.card-3-count {\n  -webkit-column-count: 3;\n     -moz-column-count: 3;\n          column-count: 3;\n}\n\n.card-4-count {\n  -webkit-column-count: 4;\n     -moz-column-count: 4;\n          column-count: 4;\n}\n\n.card-1-gap {\n  -webkit-column-gap: 0.5rem;\n     -moz-column-gap: 0.5rem;\n          column-gap: 0.5rem;\n}\n\n.card-2-gap {\n  -webkit-column-gap: 2rem;\n     -moz-column-gap: 2rem;\n          column-gap: 2rem;\n}\n\n.card-3-gap {\n  -webkit-column-gap: 3rem;\n     -moz-column-gap: 3rem;\n          column-gap: 3rem;\n}\n\n.card-4-gap {\n  -webkit-column-gap: 4rem;\n     -moz-column-gap: 4rem;\n          column-gap: 4rem;\n}\n\n.card-5-gap {\n  -webkit-column-gap: 5rem;\n     -moz-column-gap: 5rem;\n          column-gap: 5rem;\n}\n\n.card-columns {\n  orphans: 1;\n  widows: 1;\n}\n\n.card-columns .card {\n  display: inline-block;\n  width: 100%;\n}\n\n@media (min-width: 576px) {\n  .card-sm-2-count {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n  }\n  .card-sm-3-count {\n    -webkit-column-count: 3;\n       -moz-column-count: 3;\n            column-count: 3;\n  }\n  .card-sm-4-count {\n    -webkit-column-count: 4;\n       -moz-column-count: 4;\n            column-count: 4;\n  }\n  .card-sm-1-gap {\n    -webkit-column-gap: 0.5rem;\n       -moz-column-gap: 0.5rem;\n            column-gap: 0.5rem;\n  }\n  .card-sm-2-gap {\n    -webkit-column-gap: 2rem;\n       -moz-column-gap: 2rem;\n            column-gap: 2rem;\n  }\n  .card-sm-3-gap {\n    -webkit-column-gap: 3rem;\n       -moz-column-gap: 3rem;\n            column-gap: 3rem;\n  }\n  .card-sm-4-gap {\n    -webkit-column-gap: 4rem;\n       -moz-column-gap: 4rem;\n            column-gap: 4rem;\n  }\n  .card-sm-5-gap {\n    -webkit-column-gap: 5rem;\n       -moz-column-gap: 5rem;\n            column-gap: 5rem;\n  }\n  .card-sm-columns {\n    orphans: 1;\n    widows: 1;\n  }\n  .card-sm-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n@media (min-width: 768px) {\n  .card-md-2-count {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n  }\n  .card-md-3-count {\n    -webkit-column-count: 3;\n       -moz-column-count: 3;\n            column-count: 3;\n  }\n  .card-md-4-count {\n    -webkit-column-count: 4;\n       -moz-column-count: 4;\n            column-count: 4;\n  }\n  .card-md-1-gap {\n    -webkit-column-gap: 0.5rem;\n       -moz-column-gap: 0.5rem;\n            column-gap: 0.5rem;\n  }\n  .card-md-2-gap {\n    -webkit-column-gap: 2rem;\n       -moz-column-gap: 2rem;\n            column-gap: 2rem;\n  }\n  .card-md-3-gap {\n    -webkit-column-gap: 3rem;\n       -moz-column-gap: 3rem;\n            column-gap: 3rem;\n  }\n  .card-md-4-gap {\n    -webkit-column-gap: 4rem;\n       -moz-column-gap: 4rem;\n            column-gap: 4rem;\n  }\n  .card-md-5-gap {\n    -webkit-column-gap: 5rem;\n       -moz-column-gap: 5rem;\n            column-gap: 5rem;\n  }\n  .card-md-columns {\n    orphans: 1;\n    widows: 1;\n  }\n  .card-md-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n@media (min-width: 992px) {\n  .card-lg-2-count {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n  }\n  .card-lg-3-count {\n    -webkit-column-count: 3;\n       -moz-column-count: 3;\n            column-count: 3;\n  }\n  .card-lg-4-count {\n    -webkit-column-count: 4;\n       -moz-column-count: 4;\n            column-count: 4;\n  }\n  .card-lg-1-gap {\n    -webkit-column-gap: 0.5rem;\n       -moz-column-gap: 0.5rem;\n            column-gap: 0.5rem;\n  }\n  .card-lg-2-gap {\n    -webkit-column-gap: 2rem;\n       -moz-column-gap: 2rem;\n            column-gap: 2rem;\n  }\n  .card-lg-3-gap {\n    -webkit-column-gap: 3rem;\n       -moz-column-gap: 3rem;\n            column-gap: 3rem;\n  }\n  .card-lg-4-gap {\n    -webkit-column-gap: 4rem;\n       -moz-column-gap: 4rem;\n            column-gap: 4rem;\n  }\n  .card-lg-5-gap {\n    -webkit-column-gap: 5rem;\n       -moz-column-gap: 5rem;\n            column-gap: 5rem;\n  }\n  .card-lg-columns {\n    orphans: 1;\n    widows: 1;\n  }\n  .card-lg-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n@media (min-width: 1200px) {\n  .card-xl-2-count {\n    -webkit-column-count: 2;\n       -moz-column-count: 2;\n            column-count: 2;\n  }\n  .card-xl-3-count {\n    -webkit-column-count: 3;\n       -moz-column-count: 3;\n            column-count: 3;\n  }\n  .card-xl-4-count {\n    -webkit-column-count: 4;\n       -moz-column-count: 4;\n            column-count: 4;\n  }\n  .card-xl-1-gap {\n    -webkit-column-gap: 0.5rem;\n       -moz-column-gap: 0.5rem;\n            column-gap: 0.5rem;\n  }\n  .card-xl-2-gap {\n    -webkit-column-gap: 2rem;\n       -moz-column-gap: 2rem;\n            column-gap: 2rem;\n  }\n  .card-xl-3-gap {\n    -webkit-column-gap: 3rem;\n       -moz-column-gap: 3rem;\n            column-gap: 3rem;\n  }\n  .card-xl-4-gap {\n    -webkit-column-gap: 4rem;\n       -moz-column-gap: 4rem;\n            column-gap: 4rem;\n  }\n  .card-xl-5-gap {\n    -webkit-column-gap: 5rem;\n       -moz-column-gap: 5rem;\n            column-gap: 5rem;\n  }\n  .card-xl-columns {\n    orphans: 1;\n    widows: 1;\n  }\n  .card-xl-columns .card {\n    display: inline-block;\n    width: 100%;\n  }\n}\n\n.card {\n  border-width: 0;\n  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);\n}\n\n.card-title {\n  display: block;\n  margin-bottom: 0;\n}\n\n.card-subtitle {\n  display: block;\n  color: #8c98a4;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.03125rem;\n  margin-top: 0;\n  margin-bottom: 0.5rem;\n}\n\n.card-text {\n  display: block;\n  color: #677788;\n}\n\n.card-header {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: row;\n      flex-direction: row;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: justify;\n      justify-content: space-between;\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.card-header-title {\n  margin-bottom: 0;\n}\n\n.card-footer {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n@media (min-width: 576px) {\n  .card-group > .card + .card {\n    border-left: 0.0625rem solid rgba(231, 234, 243, 0.7);\n  }\n}\n\n/* Background Color */\n.card-bg-light {\n  background-color: #f8fafd;\n}\n\n.card-bg-light:hover {\n  background-color: #f4f7fc;\n}\n\n/* Frame */\n.card-frame {\n  border: 0.0625rem solid rgba(231, 234, 243, 0.7);\n  box-shadow: none;\n  transition: 0.3s;\n}\n\n.card-frame-highlighted, .card-frame:hover {\n  border-color: rgba(55, 125, 255, 0.7);\n}\n\n/* Shadow On Hover */\n.card-hover-shadow {\n  transition: 0.3s;\n}\n\n.card-hover-shadow:hover {\n  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.175);\n}\n\n/* Collapse */\n.card-collapse {\n  padding: 0;\n  transition: 0.3s ease-in-out;\n}\n\n.card-collapse:hover {\n  background-color: #f8fafd;\n}\n\n.card-collapse .card-body {\n  color: #677788;\n}\n\n.card-btn {\n  color: #1e2022;\n  text-align: left;\n  white-space: inherit;\n  border-radius: 0.75rem;\n}\n\n.card-btn-toggle {\n  display: inline-block;\n  color: #377dff;\n}\n\n.card-btn-toggle-default {\n  display: none;\n}\n\n.card-btn-toggle-active {\n  display: block;\n}\n\n.card-btn.collapsed .card-btn-toggle-default {\n  display: block;\n}\n\n.card-btn.collapsed .card-btn-toggle-active {\n  display: none;\n}\n\n.card-body-centered {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-direction: column;\n      flex-direction: column;\n}\n\n/* Dashed */\n.card-dashed {\n  border-width: 0;\n  min-height: 10rem;\n}\n\n.card-dashed:hover {\n  border-color: rgba(55, 125, 255, 0.7);\n}\n\n.card-dashed:hover .card-dashed-body {\n  color: #0052ea;\n}\n\n.card-dashed .card-dashed-body {\n  color: #8c98a4;\n  border: 0.0625rem dashed rgba(214, 219, 235, 0.7);\n  border-radius: 0.75rem;\n  transition: 0.3s;\n}\n\n/* Bordered */\n.card-bordered {\n  border-width: 0.0625rem;\n}\n\n/* IE image rendering fix */\n.card-img-top,\n.card-img-bottom {\n  min-height: 1px;\n}\n\n/* Table */\n.card .table {\n  margin-bottom: 1px;\n}\n\n.card .table th, .card .table td {\n  padding-right: 1.5rem;\n  padding-left: 1.5rem;\n}\n\n.card .table-thead-bordered {\n  margin-top: -0.0625rem;\n}\n\n/* Dropdown */\n.card-dropdown {\n  position: absolute;\n  top: 1rem;\n  right: 1rem;\n}\n\n/* No Gutters */\n.card-no-gutters {\n  box-shadow: none;\n}\n\n.card-no-gutters > .card-header,\n.card-no-gutters > .card-body {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.card-no-gutters > .card-footer {\n  border-width: 0;\n  padding: 0;\n}\n\n/*------------------------------------\n  Card Gutters\n------------------------------------*/\n@media (min-width: 576px) {\n  .card-sm-gutters-1 {\n    margin-right: -.25rem;\n    margin-left: -.25rem;\n  }\n  .card-sm-gutters-1 .card {\n    margin-right: .25rem;\n    margin-left: .25rem;\n  }\n  .card-sm-gutters-2 {\n    margin-right: -.5rem;\n    margin-left: -.5rem;\n  }\n  .card-sm-gutters-2 .card {\n    margin-right: .5rem;\n    margin-left: .5rem;\n  }\n  .card-sm-gutters-3 {\n    margin-right: -.9375rem;\n    margin-left: -.9375rem;\n  }\n  .card-sm-gutters-3 .card {\n    margin-right: .9375rem;\n    margin-left: .9375rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .card-md-gutters-1 {\n    margin-right: -.25rem;\n    margin-left: -.25rem;\n  }\n  .card-md-gutters-1 .card {\n    margin-right: .25rem;\n    margin-left: .25rem;\n  }\n  .card-md-gutters-2 {\n    margin-right: -.5rem;\n    margin-left: -.5rem;\n  }\n  .card-md-gutters-2 .card {\n    margin-right: .5rem;\n    margin-left: .5rem;\n  }\n  .card-md-gutters-3 {\n    margin-right: -.9375rem;\n    margin-left: -.9375rem;\n  }\n  .card-md-gutters-3 .card {\n    margin-right: .9375rem;\n    margin-left: .9375rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .card-lg-gutters-1 {\n    margin-right: -.25rem;\n    margin-left: -.25rem;\n  }\n  .card-lg-gutters-1 .card {\n    margin-right: .25rem;\n    margin-left: .25rem;\n  }\n  .card-lg-gutters-2 {\n    margin-right: -.5rem;\n    margin-left: -.5rem;\n  }\n  .card-lg-gutters-2 .card {\n    margin-right: .5rem;\n    margin-left: .5rem;\n  }\n  .card-lg-gutters-3 {\n    margin-right: -.9375rem;\n    margin-left: -.9375rem;\n  }\n  .card-lg-gutters-3 .card {\n    margin-right: .9375rem;\n    margin-left: .9375rem;\n  }\n}\n\n/*------------------------------------\n  Card Group - Break\n------------------------------------*/\n@media (max-width: 767.98px) {\n  .card-group-sm-break {\n    display: block;\n  }\n  .card-group-sm-break > .card:not(:last-child) {\n    margin-bottom: -1px;\n  }\n  .card-group-sm-break > .card + .card {\n    border-left: 0.0625rem solid rgba(231, 234, 243, 0.7);\n  }\n  .card-group-sm-break > .card:first-child {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group-sm-break > .card:first-child .card-img-top,\n  .card-group-sm-break > .card:first-child .card-header {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n  }\n  .card-group-sm-break > .card:first-child .card-img-bottom,\n  .card-group-sm-break > .card:first-child .card-footer {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group-sm-break > .card:last-child {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .card-group-sm-break > .card:last-child .card-img-top,\n  .card-group-sm-break > .card:last-child .card-header {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .card-group-sm-break > .card:last-child .card-img-bottom,\n  .card-group-sm-break > .card:last-child .card-footer {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .card-group-md-break {\n    display: block;\n  }\n  .card-group-md-break > .card:not(:last-child) {\n    margin-bottom: -1px;\n  }\n  .card-group-md-break > .card + .card {\n    border-left: 0.0625rem solid rgba(231, 234, 243, 0.7);\n  }\n  .card-group-md-break > .card:first-child {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group-md-break > .card:first-child .card-img-top,\n  .card-group-md-break > .card:first-child .card-header {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n  }\n  .card-group-md-break > .card:first-child .card-img-bottom,\n  .card-group-md-break > .card:first-child .card-footer {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group-md-break > .card:last-child {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .card-group-md-break > .card:last-child .card-img-top,\n  .card-group-md-break > .card:last-child .card-header {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .card-group-md-break > .card:last-child .card-img-bottom,\n  .card-group-md-break > .card:last-child .card-footer {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .card-group-lg-break {\n    display: block;\n  }\n  .card-group-lg-break > .card:not(:last-child) {\n    margin-bottom: -1px;\n  }\n  .card-group-lg-break > .card + .card {\n    border-left: 0.0625rem solid rgba(231, 234, 243, 0.7);\n  }\n  .card-group-lg-break > .card:first-child {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group-lg-break > .card:first-child .card-img-top,\n  .card-group-lg-break > .card:first-child .card-header {\n    border-top-left-radius: 0.75rem;\n    border-top-right-radius: 0.75rem;\n  }\n  .card-group-lg-break > .card:first-child .card-img-bottom,\n  .card-group-lg-break > .card:first-child .card-footer {\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .card-group-lg-break > .card:last-child {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .card-group-lg-break > .card:last-child .card-img-top,\n  .card-group-lg-break > .card:last-child .card-header {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n  }\n  .card-group-lg-break > .card:last-child .card-img-bottom,\n  .card-group-lg-break > .card:last-child .card-footer {\n    border-bottom-right-radius: 0.75rem;\n    border-bottom-left-radius: 0.75rem;\n  }\n}\n\n/*------------------------------------\n  Sidebar Navigation\n------------------------------------*/\n.sidebar {\n  position: fixed;\n  top: 0;\n  right: 0;\n  z-index: 1003;\n  width: 23.4375rem;\n  height: 100%;\n  background-color: #fff;\n  box-shadow: -5px 0px 12px rgba(103, 119, 136, 0.1);\n}\n\n.sidebar-body, .sidebar-content {\n  height: 100%;\n}\n\n.sidebar-left {\n  right: auto;\n  left: 0;\n  box-shadow: 5px 0px 12px rgba(103, 119, 136, 0.1);\n}\n\n.sidebar-scroller {\n  height: 100%;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.sidebar-container {\n  position: relative;\n  height: 100%;\n  min-height: 100%;\n}\n\n.sidebar-footer {\n  width: 100%;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n}\n\n.sidebar-footer-offset {\n  height: 100%;\n  box-sizing: border-box;\n}\n\n/*------------------------------------\n  Clients\n------------------------------------*/\n.clients {\n  width: 100%;\n  max-width: 6rem;\n  height: auto;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n/*------------------------------------\n  Column Divider\n------------------------------------*/\n.column-divider {\n  position: relative;\n}\n\n.column-divider::before {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  border-left: 0.0625rem solid #e7eaf3;\n  content: \"\";\n}\n\n@media (min-width: 576px) {\n  .column-divider-sm {\n    position: relative;\n  }\n  .column-divider-sm::before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    border-left: 0.0625rem solid #e7eaf3;\n    content: \"\";\n  }\n}\n\n@media (min-width: 768px) {\n  .column-divider-md {\n    position: relative;\n  }\n  .column-divider-md::before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    border-left: 0.0625rem solid #e7eaf3;\n    content: \"\";\n  }\n}\n\n@media (min-width: 992px) {\n  .column-divider-lg {\n    position: relative;\n  }\n  .column-divider-lg::before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    border-left: 0.0625rem solid #e7eaf3;\n    content: \"\";\n  }\n}\n\n@media (min-width: 1200px) {\n  .column-divider-xl {\n    position: relative;\n  }\n  .column-divider-xl::before {\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    border-left: 0.0625rem solid #e7eaf3;\n    content: \"\";\n  }\n}\n\n.column-divider-20deg::before {\n  -webkit-transform: rotate(20deg);\n          transform: rotate(20deg);\n  left: -1rem;\n}\n\n/*------------------------------------\n  Divider\n------------------------------------*/\n.divider {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.divider::before, .divider::after {\n  -ms-flex: 1 1 0%;\n      flex: 1 1 0%;\n  border-top: 0.0625rem solid #e7eaf3;\n  content: \"\";\n  margin-top: 0.0625rem;\n}\n\n.divider::before {\n  margin-right: 1.5rem;\n}\n\n.divider::after {\n  margin-left: 1.5rem;\n}\n\n/*------------------------------------\n  Divider Styles\n------------------------------------*/\n/* Text */\n.divider-text {\n  color: #8c98a4;\n}\n\n/*------------------------------------\n  Dropdown\n------------------------------------*/\n/* Menu */\n.dropdown-menu {\n  box-shadow: 0px 10px 40px 10px rgba(140, 152, 164, 0.175);\n}\n\n.dropdown-header {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n}\n\n/* Nav Link */\n.dropdown-nav-link {\n  color: #1e2022;\n  font-size: 0.875rem;\n}\n\n/* Item */\n.dropdown-item {\n  font-size: 0.875rem;\n}\n\n.dropdown-item:active {\n  color: #1e2022;\n  background-color: rgba(189, 197, 209, 0.3);\n}\n\n.dropdown-item.active:not(:focus):not(:active) {\n  color: #1e2022;\n  background-color: rgba(189, 197, 209, 0.3);\n}\n\n.dropdown-item-icon {\n  display: inline-block;\n  text-align: center;\n  color: #677788;\n  opacity: 0.7;\n  font-size: 0.75rem;\n  min-width: 1rem;\n  max-width: 1rem;\n  margin-right: 0.25rem;\n}\n\n/* Toggle */\n.dropdown-toggle {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.dropdown-toggle::after {\n  display: inline-block;\n  width: 1rem;\n  height: 1rem;\n  background: url(\"data:image/svg+xml,%3Csvg width='24' height='24' viewBox='0 0 24 24' fill='%23677788' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M12.72,15.78a.75.75,0,0,1-.53.22h-.38a.77.77,0,0,1-.53-.22L6.15,10.64a.5.5,0,0,1,0-.71l.71-.71a.49.49,0,0,1,.7,0L12,13.67l4.44-4.45a.5.5,0,0,1,.71,0l.7.71a.5.5,0,0,1,0,.71Z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  content: \"\";\n}\n\n.dropdown-toggle:not(.dropdown-toggle-empty)::after {\n  margin-left: 0.5rem;\n}\n\n.dropdown-toggle-collapse::after {\n  transition: 0.3s;\n}\n\n.dropdown-toggle-collapse[aria-expanded=\"true\"]::after {\n  -webkit-transform: rotate(-180deg);\n          transform: rotate(-180deg);\n}\n\n/* Card */\n.dropdown-card {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n/* Dropdown Positions */\n.dropdown-menu-top {\n  top: 0;\n}\n\n.dropdown-menu-bottom {\n  top: auto;\n  bottom: 0;\n}\n\n@media (min-width: 576px) {\n  .dropdown-menu-sm-top {\n    top: 0;\n  }\n  .dropdown-menu-sm-bottom {\n    top: auto;\n    bottom: 0;\n  }\n}\n\n@media (min-width: 768px) {\n  .dropdown-menu-md-top {\n    top: 0;\n  }\n  .dropdown-menu-md-bottom {\n    top: auto;\n    bottom: 0;\n  }\n}\n\n@media (min-width: 992px) {\n  .dropdown-menu-lg-top {\n    top: 0;\n  }\n  .dropdown-menu-lg-bottom {\n    top: auto;\n    bottom: 0;\n  }\n}\n\n@media (min-width: 1200px) {\n  .dropdown-menu-xl-top {\n    top: 0;\n  }\n  .dropdown-menu-xl-bottom {\n    top: auto;\n    bottom: 0;\n  }\n}\n\n/*------------------------------------\n  Dropdown Card\n------------------------------------*/\n.dropdown-card {\n  padding-top: 0;\n  padding-bottom: 0;\n  margin-bottom: 2rem;\n}\n\n@media (min-width: 768px) {\n  .dropdown-card {\n    min-width: 25rem;\n  }\n}\n\n/*------------------------------------\n  Dropdown Sizes\n------------------------------------*/\n@media (min-width: 576px) {\n  .dropdown-menu-size-md {\n    width: 440px;\n  }\n  .dropdown-menu-size-lg {\n    width: 340px;\n  }\n}\n\n@media (min-width: 768px) {\n  .dropdown-menu-size-lg {\n    width: 440px;\n  }\n}\n\n@media (min-width: 992px) {\n  .dropdown-menu-size-lg {\n    width: 740px;\n  }\n}\n\n/*------------------------------------\n  Form\n------------------------------------*/\n.input-group .input-group-prepend,\n.input-group .input-group-append {\n  z-index: 4;\n}\n\n.custom-select:focus,\n.form-control:focus {\n  box-shadow: 0 0 10px rgba(55, 125, 255, 0.1);\n}\n\n.input-group-text {\n  border-color: #e7eaf3;\n}\n\n/* Input Label */\n.input-label {\n  display: block;\n  color: #1e2022;\n  font-size: 0.875rem;\n}\n\n.input-label-secondary {\n  color: #8c98a4;\n  font-size: 0.875rem;\n  margin-left: 0.25rem;\n}\n\n/* Form Link */\n.form-link {\n  display: inline-block;\n  margin-top: 0.75rem;\n}\n\n/* Form Borderless */\n.input-group-borderless .form-control,\n.input-group-borderless .input-group-text {\n  border: none;\n}\n\n.input-group-borderless .form-control:focus,\n.input-group-borderless .input-group-text:focus {\n  box-shadow: none;\n}\n\n.input-group-add-field {\n  position: relative;\n  margin-top: 1rem;\n}\n\n.input-group-add-field:hover .input-group-add-field-delete {\n  opacity: 1;\n}\n\n.input-group-add-field-delete {\n  position: absolute;\n  top: 0.75rem;\n  right: 0;\n  width: 1rem;\n  color: #ed4c78;\n  opacity: 0;\n  margin-right: -1rem;\n  padding-left: 0.25rem;\n}\n\n.input-group-add-field-delete:hover {\n  color: #ea2c60;\n}\n\n@media (max-width: 1199.98px) {\n  .input-group-add-field-delete {\n    opacity: 1;\n  }\n}\n\n.input-group > .input-group-prepend .custom-select {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group > .input-group-append .custom-select {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n@media (max-width: 575.98px) {\n  .input-group-sm-down-break {\n    display: block;\n  }\n  .input-group-sm-down-break > .form-control,\n  .input-group-sm-down-break > .custom-select {\n    width: 100%;\n  }\n  .input-group-sm-down-break > .form-control:first-child,\n  .input-group-sm-down-break > .custom-select:first-child {\n    border-top-left-radius: 0.3125rem;\n    border-top-right-radius: 0.3125rem;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .input-group-sm-down-break > .custom-select:not(:first-child):not(:last-child),\n  .input-group-sm-down-break > .form-control:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n  .input-group-sm-down-break > .custom-select:last-child,\n  .input-group-sm-down-break > .form-control:last-child {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0.3125rem;\n    border-bottom-left-radius: 0.3125rem;\n  }\n  .input-group-sm-down-break .form-control + .form-control,\n  .input-group-sm-down-break .form-control + .custom-select,\n  .input-group-sm-down-break .form-control + .custom-file,\n  .input-group-sm-down-break .form-control-plaintext + .form-control,\n  .input-group-sm-down-break .form-control-plaintext + .custom-select,\n  .input-group-sm-down-break .form-control-plaintext + .custom-file,\n  .input-group-sm-down-break .custom-select + .form-control,\n  .input-group-sm-down-break .custom-select + .custom-select,\n  .input-group-sm-down-break .custom-select + .custom-file,\n  .input-group-sm-down-break .custom-file + .form-control,\n  .input-group-sm-down-break .custom-file + .custom-select,\n  .input-group-sm-down-break .custom-file + .custom-file {\n    margin-left: 0;\n    margin-top: -0.0625rem;\n  }\n}\n\n@media (max-width: 767.98px) {\n  .input-group-md-down-break {\n    display: block;\n  }\n  .input-group-md-down-break > .form-control,\n  .input-group-md-down-break > .custom-select {\n    width: 100%;\n  }\n  .input-group-md-down-break > .form-control:first-child,\n  .input-group-md-down-break > .custom-select:first-child {\n    border-top-left-radius: 0.3125rem;\n    border-top-right-radius: 0.3125rem;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .input-group-md-down-break > .custom-select:not(:first-child):not(:last-child),\n  .input-group-md-down-break > .form-control:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n  .input-group-md-down-break > .custom-select:last-child,\n  .input-group-md-down-break > .form-control:last-child {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0.3125rem;\n    border-bottom-left-radius: 0.3125rem;\n  }\n  .input-group-md-down-break .form-control + .form-control,\n  .input-group-md-down-break .form-control + .custom-select,\n  .input-group-md-down-break .form-control + .custom-file,\n  .input-group-md-down-break .form-control-plaintext + .form-control,\n  .input-group-md-down-break .form-control-plaintext + .custom-select,\n  .input-group-md-down-break .form-control-plaintext + .custom-file,\n  .input-group-md-down-break .custom-select + .form-control,\n  .input-group-md-down-break .custom-select + .custom-select,\n  .input-group-md-down-break .custom-select + .custom-file,\n  .input-group-md-down-break .custom-file + .form-control,\n  .input-group-md-down-break .custom-file + .custom-select,\n  .input-group-md-down-break .custom-file + .custom-file {\n    margin-left: 0;\n    margin-top: -0.0625rem;\n  }\n}\n\n@media (max-width: 991.98px) {\n  .input-group-lg-down-break {\n    display: block;\n  }\n  .input-group-lg-down-break > .form-control,\n  .input-group-lg-down-break > .custom-select {\n    width: 100%;\n  }\n  .input-group-lg-down-break > .form-control:first-child,\n  .input-group-lg-down-break > .custom-select:first-child {\n    border-top-left-radius: 0.3125rem;\n    border-top-right-radius: 0.3125rem;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .input-group-lg-down-break > .custom-select:not(:first-child):not(:last-child),\n  .input-group-lg-down-break > .form-control:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n  .input-group-lg-down-break > .custom-select:last-child,\n  .input-group-lg-down-break > .form-control:last-child {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0.3125rem;\n    border-bottom-left-radius: 0.3125rem;\n  }\n  .input-group-lg-down-break .form-control + .form-control,\n  .input-group-lg-down-break .form-control + .custom-select,\n  .input-group-lg-down-break .form-control + .custom-file,\n  .input-group-lg-down-break .form-control-plaintext + .form-control,\n  .input-group-lg-down-break .form-control-plaintext + .custom-select,\n  .input-group-lg-down-break .form-control-plaintext + .custom-file,\n  .input-group-lg-down-break .custom-select + .form-control,\n  .input-group-lg-down-break .custom-select + .custom-select,\n  .input-group-lg-down-break .custom-select + .custom-file,\n  .input-group-lg-down-break .custom-file + .form-control,\n  .input-group-lg-down-break .custom-file + .custom-select,\n  .input-group-lg-down-break .custom-file + .custom-file {\n    margin-left: 0;\n    margin-top: -0.0625rem;\n  }\n}\n\n@media (max-width: 1199.98px) {\n  .input-group-xl-down-break {\n    display: block;\n  }\n  .input-group-xl-down-break > .form-control,\n  .input-group-xl-down-break > .custom-select {\n    width: 100%;\n  }\n  .input-group-xl-down-break > .form-control:first-child,\n  .input-group-xl-down-break > .custom-select:first-child {\n    border-top-left-radius: 0.3125rem;\n    border-top-right-radius: 0.3125rem;\n    border-bottom-right-radius: 0;\n    border-bottom-left-radius: 0;\n  }\n  .input-group-xl-down-break > .custom-select:not(:first-child):not(:last-child),\n  .input-group-xl-down-break > .form-control:not(:first-child):not(:last-child) {\n    border-radius: 0;\n  }\n  .input-group-xl-down-break > .custom-select:last-child,\n  .input-group-xl-down-break > .form-control:last-child {\n    border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0.3125rem;\n    border-bottom-left-radius: 0.3125rem;\n  }\n  .input-group-xl-down-break .form-control + .form-control,\n  .input-group-xl-down-break .form-control + .custom-select,\n  .input-group-xl-down-break .form-control + .custom-file,\n  .input-group-xl-down-break .form-control-plaintext + .form-control,\n  .input-group-xl-down-break .form-control-plaintext + .custom-select,\n  .input-group-xl-down-break .form-control-plaintext + .custom-file,\n  .input-group-xl-down-break .custom-select + .form-control,\n  .input-group-xl-down-break .custom-select + .custom-select,\n  .input-group-xl-down-break .custom-select + .custom-file,\n  .input-group-xl-down-break .custom-file + .form-control,\n  .input-group-xl-down-break .custom-file + .custom-select,\n  .input-group-xl-down-break .custom-file + .custom-file {\n    margin-left: 0;\n    margin-top: -0.0625rem;\n  }\n}\n\n.input-group-down-break {\n  display: block;\n}\n\n.input-group-down-break > .form-control,\n.input-group-down-break > .custom-select {\n  width: 100%;\n}\n\n.input-group-down-break > .form-control:first-child,\n.input-group-down-break > .custom-select:first-child {\n  border-top-left-radius: 0.3125rem;\n  border-top-right-radius: 0.3125rem;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group-down-break > .custom-select:not(:first-child):not(:last-child),\n.input-group-down-break > .form-control:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n\n.input-group-down-break > .custom-select:last-child,\n.input-group-down-break > .form-control:last-child {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n}\n\n.input-group-down-break .form-control + .form-control,\n.input-group-down-break .form-control + .custom-select,\n.input-group-down-break .form-control + .custom-file,\n.input-group-down-break .form-control-plaintext + .form-control,\n.input-group-down-break .form-control-plaintext + .custom-select,\n.input-group-down-break .form-control-plaintext + .custom-file,\n.input-group-down-break .custom-select + .form-control,\n.input-group-down-break .custom-select + .custom-select,\n.input-group-down-break .custom-select + .custom-file,\n.input-group-down-break .custom-file + .form-control,\n.input-group-down-break .custom-file + .custom-select,\n.input-group-down-break .custom-file + .custom-file {\n  margin-left: 0;\n  margin-top: -0.0625rem;\n}\n\n/*------------------------------------\n  Merge\n------------------------------------*/\n.input-group-merge {\n  position: relative;\n}\n\n.input-group-merge .input-group-prepend,\n.input-group-merge .input-group-append {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n}\n\n.input-group-merge .input-group-prepend {\n  left: 0;\n}\n\n.input-group-merge .input-group-prepend .input-group-text {\n  padding: 0 0 0 1rem;\n}\n\n.input-group-merge .input-group-prepend .input-group-text:first-child {\n  border-top-left-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n\n.input-group-merge .input-group-append {\n  right: 0;\n}\n\n.input-group-merge .input-group-append .input-group-text {\n  padding: 0 1rem 0 0;\n}\n\n.input-group-merge .input-group-append .input-group-text:last-child {\n  border-top-right-radius: 0.3125rem;\n  border-bottom-right-radius: 0.3125rem;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.input-group-merge .input-group-text {\n  z-index: 4;\n  border: none;\n}\n\n.input-group-merge .custom-select:not(:first-child),\n.input-group-merge .form-control:not(:first-child) {\n  padding-left: 2.5rem;\n  border-top-left-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n}\n\n.input-group-merge .custom-select:not(:last-child),\n.input-group-merge .form-control:not(:last-child) {\n  padding-right: 2.5rem;\n  border-top-right-radius: 0.3125rem;\n  border-bottom-right-radius: 0.3125rem;\n}\n\n/*------------------------------------\n  Form Pill\n------------------------------------*/\n.input-group-pill {\n  border-radius: 6.1875rem;\n}\n\n.input-group-pill > .form-control:first-child {\n  border-top-left-radius: 6.1875rem;\n  border-bottom-left-radius: 6.1875rem;\n}\n\n.input-group-pill > .form-control:last-child {\n  border-top-right-radius: 6.1875rem;\n  border-bottom-right-radius: 6.1875rem;\n}\n\n.input-group-pill > .input-group-prepend > .btn {\n  border-top-left-radius: 6.1875rem;\n  border-bottom-left-radius: 6.1875rem;\n}\n\n.input-group-pill > .input-group-append > .btn {\n  border-top-right-radius: 6.1875rem;\n  border-bottom-right-radius: 6.1875rem;\n}\n\n.input-group-pill.input-group-merge .form-control:not(:last-child) {\n  border-top-right-radius: 6.1875rem;\n  border-bottom-right-radius: 6.1875rem;\n}\n\n.input-group-pill.input-group-merge .input-group-prepend > .input-group-text,\n.input-group-pill.input-group-merge .input-group-prepend > .btn {\n  border-top-left-radius: 6.1875rem;\n  border-bottom-left-radius: 6.1875rem;\n}\n\n.input-group-pill.input-group-merge .form-control:not(:first-child) {\n  border-top-left-radius: 6.1875rem;\n  border-bottom-left-radius: 6.1875rem;\n}\n\n.input-group-pill.input-group-merge .input-group-append > .input-group-text,\n.input-group-pill.input-group-merge .input-group-append > .btn {\n  border-top-right-radius: 6.1875rem;\n  border-bottom-right-radius: 6.1875rem;\n}\n\n/*------------------------------------\n  Form Sizes\n------------------------------------*/\n.input-group-sm.input-group-merge .custom-select:not(:first-child),\n.input-group-sm.input-group-merge .form-control:not(:first-child) {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.input-group-sm.input-group-merge .custom-select:not(:last-child),\n.input-group-sm.input-group-merge .form-control:not(:last-child) {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.input-group-sm.input-group-merge .input-group-prepend .input-group-text:first-child {\n  border-top-left-radius: 0.25rem;\n  border-bottom-left-radius: 0.25rem;\n}\n\n.input-group-sm.input-group-merge .input-group-append .input-group-text:last-child {\n  border-top-right-radius: 0.25rem;\n  border-bottom-right-radius: 0.25rem;\n}\n\n.input-group-lg.input-group-merge .custom-select:not(:first-child),\n.input-group-lg.input-group-merge .form-control:not(:first-child) {\n  padding-left: 3rem;\n  border-top-left-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n}\n\n.input-group-lg.input-group-merge .custom-select:not(:last-child),\n.input-group-lg.input-group-merge .form-control:not(:last-child) {\n  padding-right: 3rem;\n  border-top-right-radius: 0.3125rem;\n  border-bottom-right-radius: 0.3125rem;\n}\n\n.input-group-lg.input-group-merge .input-group-prepend .input-group-text:first-child {\n  border-top-left-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n}\n\n.input-group-lg.input-group-merge .input-group-append .input-group-text:last-child {\n  border-top-right-radius: 0.3125rem;\n  border-bottom-right-radius: 0.3125rem;\n}\n\n/*------------------------------------\n  Flush\n------------------------------------*/\n.input-group-flush .form-control {\n  background-color: transparent;\n  border-top: none;\n  border-right: none;\n  border-left: none;\n  box-shadow: none;\n  padding-right: 0;\n  padding-left: 0;\n  border-radius: 0;\n}\n\n.input-group-flush .form-control.is-valid, .input-group-flush .form-control.is-valid:focus, .input-group-flush .form-control.is-invalid, .input-group-flush .form-control.is-invalid:focus {\n  box-shadow: none;\n}\n\n.input-group-flush.input-group-merge .input-group-append .input-group-text,\n.input-group-flush.input-group-merge .input-group-prepend .input-group-text {\n  padding: 0;\n}\n\n.input-group-flush.input-group-merge .custom-select:not(:first-child),\n.input-group-flush.input-group-merge .form-control:not(:first-child) {\n  padding-left: 2rem;\n}\n\n.input-group-flush.input-group-merge .custom-select:not(:last-child),\n.input-group-flush.input-group-merge .form-control:not(:last-child) {\n  padding-right: 2rem;\n}\n\n.input-group-flush.input-group .form-control:not(:first-child),\n.input-group-flush.input-group .form-control:not(:last-child),\n.input-group-flush.input-group .input-group-append .input-group-text:first-child,\n.input-group-flush.input-group .input-group-append .input-group-text:last-child {\n  border-radius: 0;\n}\n\n/*------------------------------------\n  States\n------------------------------------*/\n.custom-select.is-valid,\n.form-control.is-valid {\n  background-size: 1rem 1rem;\n}\n\n.custom-select.is-valid, .custom-select.is-valid:focus,\n.form-control.is-valid,\n.form-control.is-valid:focus {\n  box-shadow: 0 0 10px rgba(0, 201, 167, 0.1);\n}\n\n.custom-select.is-invalid,\n.form-control.is-invalid {\n  background-size: 1rem 1rem;\n}\n\n.custom-select.is-invalid, .custom-select.is-invalid:focus,\n.form-control.is-invalid,\n.form-control.is-invalid:focus {\n  box-shadow: 0 0 10px rgba(237, 76, 120, 0.1);\n}\n\n/*------------------------------------\n  Custom Select\n------------------------------------*/\n.custom-select,\n.custom-control-label {\n  cursor: pointer;\n}\n\n.form-control .custom-control-label {\n  width: 100%;\n}\n\n/*------------------------------------\n  Checkbox Bookmark\n------------------------------------*/\n.custom-checkbox-bookmark {\n  padding-left: 0;\n}\n\n.custom-checkbox-bookmark-label {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  cursor: pointer;\n  color: #bdc5d1;\n  font-size: 1rem;\n  margin-bottom: 0;\n}\n\n.custom-checkbox-bookmark-default,\n.custom-checkbox-bookmark-active {\n  margin-top: -1px;\n}\n\n.custom-checkbox-bookmark-active {\n  color: #ffc107;\n}\n\n.custom-checkbox-bookmark-input ~ .custom-checkbox-bookmark-label .custom-checkbox-bookmark-default {\n  display: block;\n}\n\n.custom-checkbox-bookmark-input ~ .custom-checkbox-bookmark-label .custom-checkbox-bookmark-active {\n  display: none;\n}\n\n.custom-checkbox-bookmark-input:checked ~ .custom-checkbox-bookmark-label .custom-checkbox-bookmark-default {\n  display: none;\n}\n\n.custom-checkbox-bookmark-input:checked ~ .custom-checkbox-bookmark-label .custom-checkbox-bookmark-active {\n  display: block;\n}\n\n.custom-checkbox-bookmark-input:disabled ~ .custom-checkbox-bookmark-label {\n  color: #e7eaf3;\n}\n\n/*------------------------------------\n  Checkbox Outline\n------------------------------------*/\n.checkbox-outline {\n  padding-left: 0;\n  margin-right: 0;\n}\n\n.checkbox-outline-label {\n  border: 0.0625rem solid #e7eaf3;\n  cursor: pointer;\n}\n\n.checkbox-outline-input:checked ~ .checkbox-outline-label {\n  border-color: #377dff;\n}\n\n/*------------------------------------\n  Checkbox Icon\n------------------------------------*/\n.checkbox-icon-label::after {\n  position: absolute;\n  top: 0.5rem;\n  right: 0.5rem;\n  width: 1rem;\n  height: 1rem;\n  color: #e7eaf3;\n  background: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 110 110' fill='%23e7eaf3' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M55,110L55,110C24.6,110,0,85.4,0,55v0C0,24.6,24.6,0,55,0h0c30.4,0,55,24.6,55,55v0C110,85.4,85.4,110,55,110zM81.6,31c-1.5-1.4-3.9-1.4-5.4,0.1L43.7,64.3l-8-9.6c-1.8-2.2-4.9-2.6-6.9-0.9c-1.8,1.5-2.1,4.1-0.9,6.2l10.2,17.3c2,3.3,6.7,3.6,9,0.5L82,36.2C83.3,34.7,83.1,32.4,81.6,31z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n  content: \"\";\n}\n\n.checkbox-icon-input:checked ~ .checkbox-icon-label::after {\n  background: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 110 110' fill='%23377dff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M55,110L55,110C24.6,110,0,85.4,0,55v0C0,24.6,24.6,0,55,0h0c30.4,0,55,24.6,55,55v0C110,85.4,85.4,110,55,110zM81.6,31c-1.5-1.4-3.9-1.4-5.4,0.1L43.7,64.3l-8-9.6c-1.8-2.2-4.9-2.6-6.9-0.9c-1.8,1.5-2.1,4.1-0.9,6.2l10.2,17.3c2,3.3,6.7,3.6,9,0.5L82,36.2C83.3,34.7,83.1,32.4,81.6,31z'/%3E%3C/svg%3E\") no-repeat right center/1rem 1rem;\n}\n\n/*------------------------------------\n  Custom Checkbox\n------------------------------------*/\n.custom-checkbox .custom-control-input:disabled:checked ~ .custom-control-label::before {\n  border-color: rgba(55, 125, 255, 0);\n}\n\n/*------------------------------------\n  Toggle Switch\n------------------------------------*/\n.toggle-switch {\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n  margin-bottom: 0;\n}\n\n.toggle-switch-input {\n  position: absolute;\n  z-index: -1;\n  opacity: 0;\n}\n\n.toggle-switch-content {\n  -ms-flex: 1;\n      flex: 1;\n  margin-left: 0.5rem;\n}\n\n.toggle-switch-label {\n  position: relative;\n  display: block;\n  width: 3rem;\n  height: 2rem;\n  background-color: #e7eaf3;\n  background-clip: content-box;\n  border: 0.125rem solid transparent;\n  border-radius: 6.1875rem;\n  transition: 0.3s;\n}\n\n.toggle-switch-indicator {\n  position: absolute;\n  left: 0.125rem;\n  bottom: 50%;\n  width: 1.5rem;\n  height: 1.5rem;\n  background-color: #fff;\n  -webkit-transform: initial;\n          transform: initial;\n  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);\n  border-radius: 50%;\n  -webkit-transform: translate3d(0, 50%, 0);\n          transform: translate3d(0, 50%, 0);\n  transition: 0.3s;\n}\n\n.toggle-switch-input:checked + .toggle-switch-label {\n  background-color: #377dff;\n}\n\n.toggle-switch-input:checked + .toggle-switch-label .toggle-switch-indicator {\n  -webkit-transform: translate3d(1.025rem, 50%, 0);\n          transform: translate3d(1.025rem, 50%, 0);\n}\n\n.toggle-switch-input:disabled + .toggle-switch-label {\n  background-color: rgba(231, 234, 243, 0.5);\n}\n\n.toggle-switch-input:checked:disabled + .toggle-switch-label {\n  background-color: rgba(55, 125, 255, 0.5);\n}\n\n/*------------------------------------\n  File Attachment Button\n------------------------------------*/\n.file-attachment-btn {\n  position: relative;\n  overflow: hidden;\n  margin-bottom: 0;\n}\n\n.file-attachment-btn-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: block;\n  min-width: 100%;\n  min-height: 100%;\n  cursor: inherit;\n  opacity: 0;\n}\n\n/*------------------------------------\n  File Attachment Input\n------------------------------------*/\n.file-attachment-input {\n  position: relative;\n  display: block;\n  background-color: #f8fafd;\n  border: 0.125rem dashed #e7eaf3;\n  text-align: center;\n  overflow: hidden;\n  cursor: pointer;\n  border-radius: 0.3125rem;\n  padding: 4rem 4rem;\n  margin-bottom: 0;\n}\n\n.file-attachment-input-label {\n  position: absolute;\n  top: 0;\n  right: 0;\n  display: block;\n  min-width: 100%;\n  min-height: 100%;\n  cursor: inherit;\n  opacity: 0;\n}\n\n.file-attachment-input:hover {\n  background-color: #e7eaf3;\n}\n\n/*------------------------------------\n  Go To\n------------------------------------*/\n.go-to {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  z-index: 9999;\n  width: 2.6875rem;\n  height: 2.6875rem;\n  background-color: rgba(113, 134, 157, 0.1);\n  color: #677788;\n  font-size: 0.8125rem;\n  opacity: 0.5;\n  border-radius: 50%;\n  transition: 0.3s ease-out;\n}\n\n.go-to:hover, .go-to:focus:hover {\n  color: #fff;\n  background-color: #377dff;\n  opacity: 1;\n}\n\n/*------------------------------------\n  Hero v1\n------------------------------------*/\n.hero-v1 {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 40%;\n  height: 100%;\n  z-index: -1;\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: top center;\n}\n\n.hero-v1::before {\n  position: absolute;\n  top: 50%;\n  right: 100%;\n  width: 80%;\n  height: 80%;\n  background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(55, 125, 255, 0.075) 50%, rgba(255, 255, 255, 0));\n  background-repeat: no-repeat;\n  content: \"\";\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n}\n\n/*------------------------------------\n  Icon\n------------------------------------*/\n.icon {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 1rem;\n  width: 3.125rem;\n  height: 3.125rem;\n  border-radius: 0.3125rem;\n}\n\n.icon-circle {\n  border-radius: 50%;\n}\n\n.icon.icon-xs {\n  font-size: 0.75rem;\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.icon.icon-sm {\n  font-size: 0.8125rem;\n  width: 2.6875rem;\n  height: 2.6875rem;\n}\n\n.icon.icon-lg {\n  font-size: 1.25rem;\n  width: 4.25rem;\n  height: 4.25rem;\n}\n\n/*------------------------------------\n  Icon\n------------------------------------*/\n/* primary */\n.icon-primary {\n  color: #fff;\n  border-color: #377dff;\n  background-color: #377dff;\n}\n\n/* secondary */\n.icon-secondary {\n  color: #fff;\n  border-color: #71869d;\n  background-color: #71869d;\n}\n\n/* success */\n.icon-success {\n  color: #fff;\n  border-color: #00c9a7;\n  background-color: #00c9a7;\n}\n\n/* info */\n.icon-info {\n  color: #fff;\n  border-color: #09a5be;\n  background-color: #09a5be;\n}\n\n/* warning */\n.icon-warning {\n  color: #1e2022;\n  border-color: #f5ca99;\n  background-color: #f5ca99;\n}\n\n/* danger */\n.icon-danger {\n  color: #fff;\n  border-color: #ed4c78;\n  background-color: #ed4c78;\n}\n\n/* light */\n.icon-light {\n  color: #1e2022;\n  border-color: #f7faff;\n  background-color: #f7faff;\n}\n\n/* dark */\n.icon-dark {\n  color: #fff;\n  border-color: #21325b;\n  background-color: #21325b;\n}\n\n/* indigo */\n.icon-indigo {\n  color: #fff;\n  border-color: #2d1582;\n  background-color: #2d1582;\n}\n\n/* primary soft */\n.icon-soft-primary {\n  color: #377dff;\n  background: rgba(55, 125, 255, 0.1);\n}\n\n/* secondary soft */\n.icon-soft-secondary {\n  color: #71869d;\n  background: rgba(113, 134, 157, 0.1);\n}\n\n/* success soft */\n.icon-soft-success {\n  color: #00c9a7;\n  background: rgba(0, 201, 167, 0.1);\n}\n\n/* info soft */\n.icon-soft-info {\n  color: #09a5be;\n  background: rgba(9, 165, 190, 0.1);\n}\n\n/* warning soft */\n.icon-soft-warning {\n  color: #f5ca99;\n  background: rgba(245, 202, 153, 0.1);\n}\n\n/* danger soft */\n.icon-soft-danger {\n  color: #ed4c78;\n  background: rgba(237, 76, 120, 0.1);\n}\n\n/* light soft */\n.icon-soft-light {\n  color: #f7faff;\n  background: rgba(247, 250, 255, 0.1);\n}\n\n/* dark soft */\n.icon-soft-dark {\n  color: #21325b;\n  background: rgba(33, 50, 91, 0.1);\n}\n\n/* indigo soft */\n.icon-soft-indigo {\n  color: #2d1582;\n  background: rgba(45, 21, 130, 0.1);\n}\n\n/*------------------------------------\n  Legend Indicator\n------------------------------------*/\n.legend-indicator {\n  display: inline-block;\n  width: 0.5rem;\n  height: 0.5rem;\n  background-color: #bdc5d1;\n  border-radius: 50%;\n  margin-right: 0.4375rem;\n}\n\n/*------------------------------------\n  Media Viewer\n------------------------------------*/\n.media-viewer {\n  position: relative;\n  display: block;\n}\n\n.media-viewer:hover .media-viewer-icon {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n\n.media-viewer-container {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n\n.media-viewer-icon {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  vertical-align: middle;\n  text-align: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  font-size: 0.75rem;\n  color: #fff;\n  background-color: #377dff;\n  border-radius: 50%;\n  opacity: 0;\n  -webkit-transform: scale(0.7);\n          transform: scale(0.7);\n  transition: 0.3s;\n}\n\n.media-viewer-icon:hover, .media-viewer-icon:focus {\n  color: #fff;\n}\n\n.media-viewer-icon-active {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n\n/*------------------------------------\n  Video Player\n------------------------------------*/\n.video-player {\n  position: relative;\n}\n\n.video-player-preview {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 2;\n  width: 100%;\n  height: 100%;\n  opacity: 1;\n  -o-object-fit: cover;\n     object-fit: cover;\n  transition: opacity 0.3s ease-in-out;\n}\n\n.video-player-played .video-player-preview {\n  opacity: 0;\n  pointer-events: none;\n}\n\n.video-player-btn {\n  z-index: 3;\n  transition: -webkit-transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out;\n  transition: transform 0.3s ease-in-out, -webkit-transform 0.3s ease-in-out;\n}\n\n.video-player-played .video-player-btn {\n  -webkit-animation: videoPlayerButton 0.4s ease-in-out forwards;\n          animation: videoPlayerButton 0.4s ease-in-out forwards;\n  pointer-events: none;\n}\n\n.video-player-btn:hover .video-player-icon {\n  color: #377dff;\n  -webkit-transform: scale(1.1);\n          transform: scale(1.1);\n}\n\n.video-player-icon {\n  position: relative;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  vertical-align: middle;\n  text-align: center;\n  width: 4.25rem;\n  height: 4.25rem;\n  font-size: 0.8125rem;\n  border-radius: 50%;\n  color: #1e2022;\n  background-color: #fff;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  -webkit-transform: perspective(1px) translateZ(0);\n          transform: perspective(1px) translateZ(0);\n  transition: 0.3s;\n}\n\n/* Positions */\n.video-player-centered {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n\n@-webkit-keyframes videoPlayerButton {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate(-50%, -50%) scale(1.3);\n            transform: translate(-50%, -50%) scale(1.3);\n  }\n}\n\n@keyframes videoPlayerButton {\n  from {\n    opacity: 1;\n  }\n  to {\n    opacity: 0;\n    -webkit-transform: translate(-50%, -50%) scale(1.3);\n            transform: translate(-50%, -50%) scale(1.3);\n  }\n}\n\n/*------------------------------------\n  Device Mockups\n------------------------------------*/\n.device {\n  position: relative;\n}\n\n.device-pointer {\n  width: 65%;\n  text-align: center;\n  margin-right: auto;\n  margin-left: auto;\n}\n\n.device-macbook-screen {\n  position: absolute;\n  top: 6.8%;\n  left: 12.3%;\n  width: 75.1%;\n  height: 81.1%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n.device-iphone-x {\n  border-radius: 2.75rem;\n  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);\n}\n\n.device-iphone-x-frame {\n  position: relative;\n  z-index: 2;\n  max-width: 100%;\n  height: auto;\n}\n\n.device-iphone-x-screen {\n  position: absolute;\n  top: 2.4%;\n  left: 4%;\n  width: 92.4%;\n  height: 96%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  border-radius: 0.5rem;\n}\n\n.device-half-iphone-x {\n  border-top-left-radius: 3rem;\n  border-top-right-radius: 3rem;\n  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);\n}\n\n.device-half-iphone-x-frame {\n  position: relative;\n  z-index: 2;\n  max-width: 100%;\n  height: auto;\n}\n\n.device-half-iphone-x-screen {\n  position: absolute;\n  top: 2.6%;\n  left: 4.1%;\n  width: 91.8%;\n  height: 97.1%;\n  -o-object-fit: cover;\n     object-fit: cover;\n  border-top-left-radius: 0.9375rem;\n  border-top-right-radius: 0.9375rem;\n}\n\n.device-ipad {\n  border-radius: 1.25rem;\n  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);\n}\n\n.device-ipad-frame {\n  position: relative;\n  z-index: 2;\n  max-width: 100%;\n  height: auto;\n}\n\n.device-ipad-screen {\n  position: absolute;\n  top: 2.6%;\n  left: 4.2%;\n  width: 91.8%;\n  height: 94.2%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n.device-horizontal-ipad {\n  border-radius: 1.5rem;\n  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);\n}\n\n.device-horizontal-ipad-frame {\n  position: relative;\n  z-index: 2;\n  max-width: 100%;\n  height: auto;\n}\n\n.device-horizontal-ipad-screen {\n  position: absolute;\n  top: 3.8%;\n  left: 3.2%;\n  width: 93.8%;\n  height: 92%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n.device-browser {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  width: 100%;\n  max-width: 85%;\n  overflow: hidden;\n  box-shadow: 0 0.625rem 2.5rem 0.625rem rgba(140, 152, 164, 0.175);\n  border-radius: 0.75rem;\n}\n\n.device-browser-screen {\n  position: absolute;\n  top: 6%;\n  left: 1.2%;\n  width: 97.7%;\n  height: 100%;\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n.device-wrapper {\n  position: relative;\n}\n\n.device-wrapper .device-iphone-x {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: 22%;\n}\n\n/*------------------------------------\n  Modal\n------------------------------------*/\n.modal-header {\n  -ms-flex-align: center;\n      align-items: center;\n  border-width: 0;\n  padding-bottom: 0;\n}\n\n.modal-header .close {\n  padding: 0.25rem 0.25rem;\n  margin: 0 0 0 auto;\n}\n\n.modal-footer > * {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n\n.modal-footer-text:last-child {\n  font-size: 0.875rem;\n  margin-bottom: 0;\n}\n\n/* Cover */\n.modal-top-cover {\n  position: relative;\n  overflow: hidden;\n  min-height: 8rem;\n  border-top-right-radius: 0.6875rem;\n  border-top-left-radius: 0.6875rem;\n}\n\n.modal-top-cover-avatar {\n  position: relative;\n  z-index: 2;\n  margin-top: -3rem;\n}\n\n/* Close */\n.modal-close {\n  position: absolute;\n  top: 0.75rem;\n  right: 0.75rem;\n  z-index: 2;\n}\n\n/*------------------------------------\n  Page Header\n------------------------------------*/\n.page-header {\n  border-bottom: 0.0625rem solid #e7eaf3;\n  padding-bottom: 2rem;\n  margin-bottom: 1rem;\n}\n\n.page-header .breadcrumb {\n  margin-bottom: 0.25rem;\n}\n\n.page-header-title {\n  margin-bottom: 0.25rem;\n}\n\n.page-header-text {\n  margin-bottom: 0.25rem;\n}\n\n.page-header-tabs {\n  margin-bottom: -2rem;\n  border-bottom-width: 0;\n}\n\n.hs-nav-scroller-horizontal .page-header-tabs {\n  margin-bottom: -2rem;\n}\n\n.page-header-reset {\n  border-bottom-width: 0;\n  padding-bottom: 0;\n}\n\n/*------------------------------------\n  Page Preloader\n------------------------------------*/\n.page-preloader {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1002;\n  background-color: #fff;\n}\n\n.page-preloader-content-centered {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  height: 100%;\n}\n\n/*------------------------------------\n  Pagination\n------------------------------------*/\n.page-link {\n  cursor: pointer;\n  text-align: center;\n  min-width: 2.25rem;\n}\n\n.page-item {\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n\n.page-item .page-link {\n  border-top-left-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n}\n\n.page-item .page-link {\n  border-top-right-radius: 0.3125rem;\n  border-bottom-right-radius: 0.3125rem;\n}\n\n/* Sizes */\n.pagination-sm .page-link {\n  border-radius: 0.25rem;\n}\n\n.pagination-lg .page-link {\n  border-radius: 0.75rem;\n}\n\n/*------------------------------------\n  Navbar\n------------------------------------*/\n.navbar-vertical.show .card {\n  box-shadow: none;\n}\n\n/*------------------------------------\n  Navbar Vertical\n------------------------------------*/\n.navbar-vertical .nav {\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.navbar-vertical .nav-sub .nav-link {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.navbar-vertical .nav-sub .nav-link .nav-link-badge {\n  margin-left: auto;\n}\n\n.navbar-vertical .nav-tabs {\n  border-bottom-width: 0;\n}\n\n.navbar-vertical .nav-tabs .nav-item {\n  margin: 0;\n}\n\n.navbar-vertical .card .nav-tabs .nav-link {\n  padding-right: 0;\n  padding-left: 1.4375rem;\n  margin-left: -1.5rem;\n}\n\n.navbar-vertical .nav-tabs .nav-link {\n  padding-right: 1rem;\n  padding-left: 1rem;\n}\n\n.navbar-vertical .nav-tabs .nav-link,\n.navbar-vertical .nav-tabs .nav-link.active {\n  border-bottom-width: 0;\n  border-radius: 0;\n}\n\n.navbar-vertical .nav-tabs .nav-link:hover {\n  border-color: transparent;\n}\n\n.navbar-vertical .nav-tabs .nav-link {\n  border-width: 0 0 0 0.1875rem;\n  margin-bottom: 0;\n}\n\n.navbar-vertical .nav-tabs .active.nav-link,\n.navbar-vertical .nav-tabs .active .nav-link {\n  border-left-color: #377dff;\n}\n\n/*------------------------------------\n  Navs\n------------------------------------*/\n.nav .nav-link {\n  color: #677788;\n}\n\n.nav .nav-link:not(.active):hover {\n  color: #377dff;\n}\n\n.nav:not(.nav-pills) .nav-item.active .nav-link,\n.nav:not(.nav-pills) .nav-link.active {\n  color: #377dff;\n}\n\n/* Small Size */\n.nav-sm .nav-link {\n  font-size: 0.875rem;\n}\n\n/* No Gutters */\n.nav-x-0 .nav-link {\n  padding-right: 0;\n  padding-left: 0;\n}\n\n.nav-y-0 .nav-link {\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.nav-x-sm .nav-link {\n  padding-right: .25rem;\n  padding-left: .25rem;\n}\n\n/* Icon */\n.nav-icon {\n  width: 1.25rem;\n  font-size: 0.8125rem;\n  line-height: 1.4;\n  opacity: 0.8;\n  text-align: center;\n  margin-right: 0.5rem;\n}\n\n/* Shadow */\n.nav-shadow {\n  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);\n}\n\n/* Classic */\n.nav-classic {\n  border-bottom: 0.0625rem solid #e7eaf3;\n}\n\n.nav-classic .nav-link {\n  color: #677788;\n  border-width: 0 0 0.1875rem 0;\n  border-style: solid;\n  border-color: transparent;\n  padding: 1rem 1.5rem;\n  margin-bottom: -0.125rem;\n  border-radius: 0;\n  transition: 0.3s;\n}\n\n.nav-classic .nav-link:hover {\n  color: #377dff;\n}\n\n.nav-classic .nav-link.active {\n  color: #377dff;\n  border-bottom-color: #377dff;\n}\n\n/* Rounded */\n.nav-rounded {\n  border-radius: 0.3125rem;\n}\n\n.nav-rounded .nav-item:first-child .nav-link {\n  border-bottom-left-radius: 0.3125rem;\n}\n\n.nav-rounded .nav-item:last-child .nav-link {\n  border-bottom-right-radius: 0.3125rem;\n}\n\n/* White Color */\n.nav-white .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.nav-white .nav-link.active {\n  color: #377dff;\n  background-color: #fff;\n}\n\n.nav-white .nav-link:not(.active):hover {\n  color: #fff;\n}\n\n/* White Border Color */\n.nav.nav-border-white .nav-link {\n  color: rgba(255, 255, 255, 0.7);\n  border-bottom: 0.125rem solid transparent;\n}\n\n.nav.nav-border-white .nav-link.active {\n  color: #fff;\n  border-bottom-color: #fff;\n}\n\n.nav.nav-border-white .nav-link:not(.active):hover {\n  color: #fff;\n}\n\n/* Box */\n.nav-box .nav-link {\n  color: #1e2022;\n  border-radius: 0.3125rem;\n}\n\n.nav-box .nav-link.active {\n  color: #377dff;\n  background-color: #fff;\n  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);\n}\n\n/* Segment */\n.nav-segment {\n  position: relative;\n  background-color: #f8fafd;\n  padding: 0.25rem 0.25rem;\n  border-radius: 0.3125rem;\n}\n\n.nav-segment:not(.nav-fill) {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.nav-segment .nav-link {\n  color: #677788;\n  font-size: 0.875rem;\n  font-weight: 600;\n  padding: 0.375rem 0.875rem;\n  border-radius: 0.3125rem;\n}\n\n.nav-segment .nav-link:hover {\n  color: #377dff;\n}\n\n.nav-segment .nav-link.active {\n  color: #1e2022;\n  background-color: #fff;\n  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);\n}\n\n.nav-segment.nav-pills {\n  border-radius: 6.1875rem;\n}\n\n.nav-segment.nav-pills .nav-link {\n  border-radius: 6.1875rem;\n}\n\n/* Tabs */\n.nav-tabs .nav-item {\n  margin-left: 1rem;\n  margin-right: 1rem;\n}\n\n.nav-tabs .nav-link {\n  color: #677788;\n  border-bottom-width: 0.0625rem;\n  border-left-width: 0;\n  border-right-width: 0;\n  border-top-width: 0;\n  padding: 1rem 0;\n  margin-bottom: -0.09375rem;\n}\n\n.nav-tabs .nav-link.active,\n.nav-tabs .nav-item.active .nav-link,\n.nav-tabs .nav-item.show .nav-link {\n  border-bottom-width: 0.1875rem;\n}\n\n.nav-tabs .nav-item.active .nav-link {\n  border-color: transparent transparent #377dff;\n}\n\n.nav-tabs .nav-item:first-child {\n  margin-left: 0;\n}\n\n.nav-tabs .nav-item:last-child {\n  margin-right: 0;\n}\n\n/*------------------------------------\n  Nav List\n------------------------------------*/\n.nav-list-y-1 .nav-link {\n  padding-top: 0.25rem !important;\n  padding-bottom: 0.25rem !important;\n}\n\n.nav-list-y-2 .nav-link {\n  padding-top: 0.5rem !important;\n  padding-bottom: 0.5rem !important;\n}\n\n/*------------------------------------\n  Vertical Progress Bar\n------------------------------------*/\n.progress-vertical {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-flow: column nowrap;\n      flex-flow: column nowrap;\n  -ms-flex-pack: end;\n      justify-content: flex-end;\n  background-color: #f8fafd;\n  height: 12.5rem;\n}\n\n/*------------------------------------\n  Popover\n------------------------------------*/\n.popover {\n  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);\n}\n\n.popover-header {\n  font-weight: 600;\n}\n\n/*------------------------------------\n  Profile Cover\n------------------------------------*/\n.profile-cover {\n  position: relative;\n  height: 7.5rem;\n  padding: 1rem 1rem;\n  border-radius: 0.75rem;\n}\n\n.profile-cover-content {\n  position: relative;\n  z-index: 1;\n}\n\n.profile-cover-img-wrapper {\n  position: absolute;\n  top: 0;\n  right: 0;\n  left: 0;\n  height: 7.5rem;\n  background-color: #e7eaf3;\n  border-radius: 0.75rem;\n}\n\n.profile-cover-img {\n  width: 100%;\n  height: 7.5rem;\n  -o-object-fit: cover;\n     object-fit: cover;\n  vertical-align: top;\n  border-radius: 0.75rem;\n}\n\n.profile-cover-avatar {\n  display: -ms-flexbox;\n  display: flex;\n  background-color: #fff;\n  padding: 0.75rem 0.75rem;\n  margin-top: -1.75rem;\n}\n\n.profile-cover-content {\n  padding: 1rem 1rem;\n}\n\n.profile-cover-btn {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n}\n\n@media (min-width: 992px) {\n  .profile-cover {\n    height: 10rem;\n  }\n  .profile-cover-img-wrapper {\n    height: 10rem;\n  }\n  .profile-cover-img {\n    height: 10rem;\n  }\n}\n\n/*------------------------------------\n  Scrollbar\n------------------------------------*/\n.scrollbar {\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.scrollbar::-webkit-scrollbar {\n  width: 0.5rem;\n}\n\n.scrollbar::-webkit-scrollbar-thumb {\n  background-color: rgba(189, 197, 209, 0.6);\n  visibility: hidden;\n}\n\n.scrollbar:hover::-webkit-scrollbar-thumb {\n  visibility: visible;\n}\n\n.scrollbar-horizontal {\n  display: -ms-flexbox;\n  display: flex;\n  max-width: 100%;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  overflow-x: auto;\n  white-space: nowrap;\n  -webkit-overflow-scrolling: touch;\n}\n\n.scrollbar-horizontal::-webkit-scrollbar {\n  height: 0.25rem;\n}\n\n.scrollbar-horizontal::-webkit-scrollbar-thumb {\n  background-color: rgba(189, 197, 209, 0.6);\n  visibility: hidden;\n}\n\n.scrollbar-horizontal:hover::-webkit-scrollbar-thumb {\n  visibility: visible;\n}\n\n/*------------------------------------\n  Search Form - Push Top\n------------------------------------*/\n.search-push-top {\n  display: none;\n  background-color: #f8fafd;\n  padding-top: 3rem;\n  padding-bottom: 3rem;\n  box-shadow: inset 0 -10px 20px -10px rgba(151, 164, 175, 0.05);\n}\n\n.search-push-top-content {\n  max-width: 50rem;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.search-push-top-close-btn {\n  position: absolute;\n  top: -1.5625rem;\n  right: .4375rem;\n}\n\n@media (max-width: 575.98px) {\n  .search-push-top {\n    padding-top: 1.5rem;\n    padding-bottom: 1.5rem;\n  }\n}\n\n/* Banner */\n.search-push-top-banner {\n  background-color: #fff;\n  box-shadow: 0px 12px 15px rgba(140, 152, 164, 0.1);\n  padding-right: 1.5625rem;\n  padding-top: 1.875rem;\n  overflow: hidden;\n}\n\n.search-push-top-banner-container {\n  position: relative;\n  width: 75%;\n  min-height: 11.5625rem;\n}\n\n.search-push-top-banner-img {\n  position: absolute;\n  bottom: -.625rem;\n  left: -.625rem;\n  transition: all 0.3s ease-in-out;\n}\n\n.search-push-top-banner:hover .search-push-top-banner-img:first-child {\n  bottom: 0;\n  left: 0;\n}\n\n/*------------------------------------\n  Search Form - Slide Down\n------------------------------------*/\n.search-slide-down {\n  position: fixed;\n  z-index: 1003;\n  top: 5rem;\n  left: calc(50% - 18rem) !important;\n  width: 36rem;\n}\n\n@media (max-width: 767.98px) {\n  .search-slide-down {\n    left: 5% !important;\n    right: 5% !important;\n    width: 90%;\n  }\n}\n\n.search-slide-down-trigger.active .search-slide-down-trigger-icon::before {\n  content: \"\";\n}\n\n.search-slide-down-bg-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: 1002;\n  display: none;\n  width: 100%;\n  height: 100%;\n}\n\n.search-slide-down .search-slide-down-input {\n  opacity: 0;\n  -webkit-transform: translateY(-2rem);\n          transform: translateY(-2rem);\n  transition: opacity 0.2s, -webkit-transform 0.3s cubic-bezier(0.37, 0.41, 0.55, 0.98);\n  transition: transform 0.3s cubic-bezier(0.37, 0.41, 0.55, 0.98), opacity 0.2s;\n  transition: transform 0.3s cubic-bezier(0.37, 0.41, 0.55, 0.98), opacity 0.2s, -webkit-transform 0.3s cubic-bezier(0.37, 0.41, 0.55, 0.98);\n}\n\n.search-slide-down .search-slide-down-suggestions {\n  opacity: 0;\n  -webkit-transform: translateY(-3rem);\n          transform: translateY(-3rem);\n  transition: opacity 0.2s, -webkit-transform 0.4s cubic-bezier(0.37, 0.41, 0.55, 0.98);\n  transition: transform 0.4s cubic-bezier(0.37, 0.41, 0.55, 0.98), opacity 0.2s;\n  transition: transform 0.4s cubic-bezier(0.37, 0.41, 0.55, 0.98), opacity 0.2s, -webkit-transform 0.4s cubic-bezier(0.37, 0.41, 0.55, 0.98);\n}\n\n.search-slide-down-show .search-slide-down-input,\n.search-slide-down-show .search-slide-down-suggestions {\n  opacity: 1;\n  -webkit-transform: none;\n          transform: none;\n}\n\n.search-slide-down-show .search-slide-down-suggestions {\n  transition-delay: 0.2s;\n}\n\n/*------------------------------------\n  Slick\n------------------------------------*/\n.slick {\n  position: relative;\n}\n\n.slick-vertical .slick-slide {\n  border-width: 0;\n}\n\n.slick-transform-off.slick-transform-off .slick-track {\n  -webkit-transform: none !important;\n          transform: none !important;\n}\n\n.slick-thumb-progress {\n  width: 110%;\n  height: 110%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n\n.slick-center-mode-right {\n  margin-right: calc(-1px - ((100vw - 100%) / 2) + 16px) !important;\n}\n\n.slick-center-mode-right-offset .draggable {\n  padding-right: 5rem;\n}\n\n/*------------------------------------\n  Slick Equal Height\n------------------------------------*/\n.slick-equal-height .slick-list {\n  height: 100%;\n}\n\n.slick-equal-height .slick-track {\n  display: -ms-flexbox;\n  display: flex;\n  height: 100%;\n}\n\n.slick-equal-height .slick-track .slick-slide {\n  display: -ms-flexbox;\n  display: flex;\n  height: auto;\n}\n\n/*------------------------------------\n  Slick Gutters\n------------------------------------*/\n/* Gutters X */\n.slick-gutters-1 {\n  margin-left: -.25rem;\n  margin-right: -.25rem;\n}\n\n.slick-gutters-1 .slick-slide {\n  margin-left: .25rem;\n  margin-right: .25rem;\n}\n\n.slick-gutters-2 {\n  margin-left: -.5rem;\n  margin-right: -.5rem;\n}\n\n.slick-gutters-2 .slick-slide {\n  margin-left: .5rem;\n  margin-right: .5rem;\n}\n\n.slick-gutters-3 {\n  margin-left: -.9375rem;\n  margin-right: -.9375rem;\n}\n\n.slick-gutters-3 .slick-slide {\n  margin-left: .9375rem;\n  margin-right: .9375rem;\n}\n\n/*------------------------------------\n  Slick Arrows\n------------------------------------*/\n.slick-arrow {\n  z-index: 1;\n  line-height: 0;\n  display: inline-block;\n  color: #1e2022;\n  background-color: #fff;\n  width: 2.6875rem;\n  height: 2.6875rem;\n  font-size: 0.8125rem;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.slick-arrow:not(.slick-disabled):hover {\n  color: #fff;\n  background-color: #377dff;\n}\n\n.slick-arrow::before {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  width: 100%;\n  height: 100%;\n}\n\n.slick-arrow-left {\n  left: 0;\n}\n\n.slick-arrow-right {\n  right: 0;\n}\n\n.slick-arrow.slick-disabled {\n  color: #677788;\n}\n\n/* Primary */\n.slick-arrow-primary {\n  color: #fff;\n  background-color: rgba(55, 125, 255, 0.8);\n}\n\n/* Soft White */\n.slick-arrow-soft-white {\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.1);\n}\n\n.slick-arrow-soft-white:hover {\n  color: #fff;\n  background-color: #377dff;\n}\n\n/* Offset */\n@media (min-width: 992px) {\n  .slick-arrow-offset.slick-arrow-left {\n    left: -2.6875rem;\n  }\n  .slick-arrow-offset.slick-arrow-right {\n    right: -2.6875rem;\n  }\n}\n\n/* Vertical Center Alignment */\n.slick-arrow-centered-y {\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n}\n\n/*------------------------------------\n  Slick Counter\n------------------------------------*/\n.slick-counter {\n  position: absolute;\n  bottom: 2rem;\n  right: 0;\n  padding-left: 0.9375rem;\n  padding-right: 0.9375rem;\n}\n\n.slick-counter-current {\n  color: #fff;\n  font-size: 3.875rem;\n  line-height: 1;\n}\n\n.slick-counter-divider {\n  color: rgba(255, 255, 255, 0.7);\n  margin-right: 0.5rem;\n  margin-left: 0.5rem;\n}\n\n.slick-counter-total {\n  font-size: 1.25rem;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n/*------------------------------------\n  Slick Dot Lined\n------------------------------------*/\n.slick-dots {\n  list-style: none;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n  -ms-flex-pack: center;\n      justify-content: center;\n}\n\n.slick-dots li {\n  cursor: pointer;\n  margin: 0 .3125rem;\n}\n\n.slick-dots .dot-line {\n  position: relative;\n  display: block;\n  width: 2.75rem;\n  height: 0.1875rem;\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.slick-dots .dot-line-helper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 0;\n  height: 100%;\n  background-color: #377dff;\n  transition: none;\n}\n\n.slick-line-dots-ready .slick-dots li.slick-active .dot-line-helper {\n  transition-property: width;\n  transition-timing-function: linear;\n  width: 100%;\n}\n\n/*------------------------------------\n  Slick Pagination\n------------------------------------*/\n.slick-pagination {\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.slick-pagination:not(.slick-pagination-vertical) {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  pointer-events: none;\n}\n\n.slick-pagination li {\n  display: -ms-flexbox;\n  display: flex;\n  pointer-events: all;\n  margin: 0 .25rem;\n  cursor: pointer;\n}\n\n.slick-pagination li span {\n  display: inline-block;\n  width: 0.9375rem;\n  height: 0.9375rem;\n  box-sizing: border-box;\n  background-color: #377dff;\n  border: 0.1875rem solid transparent;\n  border-radius: 50%;\n  -webkit-transform: scale(0.6);\n          transform: scale(0.6);\n  transition: 0.3s;\n}\n\n.slick-pagination li.slick-active span {\n  background-color: transparent;\n  border-color: #377dff;\n  -webkit-transform: scale(0.9);\n          transform: scale(0.9);\n}\n\n/* White Version */\n.slick-pagination-white li span {\n  background-color: #fff;\n}\n\n.slick-pagination-white li.slick-active span {\n  border-color: #fff;\n}\n\n.slick-pagination-vertical li {\n  display: block;\n}\n\n/*------------------------------------\n  Slick Pagination Interactive\n------------------------------------*/\n.slick-pagination-interactive-title {\n  color: #fff;\n}\n\n.slick-pagination-interactive-text {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.slick-pagination-interactive .slick-slide {\n  cursor: pointer;\n  color: #fff;\n  background-color: rgba(255, 255, 255, 0.1);\n  transition: 0.3s;\n}\n\n.slick-pagination-interactive .slick-slide:hover {\n  background-color: rgba(255, 255, 255, 0.2);\n}\n\n.slick-pagination-interactive .slick-slide:hover.slick-center {\n  background-color: #fff;\n}\n\n.slick-pagination-interactive .slick-center {\n  background-color: #fff;\n}\n\n.slick-pagination-interactive .slick-center .slick-pagination-interactive-title {\n  color: #377dff;\n}\n\n.slick-pagination-interactive .slick-center .slick-pagination-interactive-text {\n  color: #677788;\n}\n\n/*------------------------------------\n  Slick Pagination Modern\n------------------------------------*/\n.slick-pagination-modern {\n  width: 100%;\n  max-width: 12.5rem;\n}\n\n.slick-pagination-modern .slick-slide {\n  cursor: pointer;\n  opacity: 0.7;\n  -webkit-transform: scale(0.7);\n          transform: scale(0.7);\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  transition: 0.3s;\n}\n\n.slick-pagination-modern .slick-current {\n  opacity: 1;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n\n/*------------------------------------\n  Slick Pagination Line\n------------------------------------*/\n.slick-pagination-line .slick-slide {\n  opacity: .5;\n  cursor: pointer;\n  font-weight: 400;\n  padding-bottom: 0.25rem;\n}\n\n.slick-pagination-line .slick-slide.slick-current {\n  opacity: 1;\n}\n\n.slick-pagination-line-progress {\n  position: relative;\n  display: block;\n  width: 100%;\n  height: 0.1875rem;\n  background-color: #fff;\n  margin-top: 0.5rem;\n}\n\n.slick-pagination-line-progress-helper {\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  width: 0;\n  height: 100%;\n  transition: none;\n}\n\n.slick-pagination-line.slick-dots-ready .slick-current .slick-pagination-line-progress-helper {\n  width: 100%;\n  background-color: #377dff;\n  transition-property: width;\n  transition-timing-function: linear;\n}\n\n@media (max-width: 991.98px) {\n  .slick-pagination-line-wrapper {\n    opacity: 0;\n    pointer-events: none;\n    overflow: hidden;\n  }\n}\n\n/*------------------------------------\n  Spinner\n------------------------------------*/\n.spinner-border,\n.spinner-grow {\n  vertical-align: middle;\n}\n\n/*------------------------------------\n  Stats Progress\n-------------------------------------*/\n.stats-progress {\n  position: relative;\n  width: 13.75rem;\n  height: 13.75rem;\n  border-radius: 50%;\n  box-shadow: 0px 0.375rem 1.5rem 0px rgba(140, 152, 164, 0.125);\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.stats-progress-info {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  right: 0;\n  text-align: center;\n  padding: 2rem 2rem;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n}\n\n/*------------------------------------\n  Step\n------------------------------------*/\n.step {\n  position: relative;\n  list-style: none;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  padding-left: 0;\n  margin-right: -0.9375rem;\n  margin-left: -0.9375rem;\n}\n\n.step.step-dashed .step-icon::after {\n  border-left-style: dashed;\n}\n\n.step-title {\n  display: block;\n  color: #1e2022;\n  font-weight: 600;\n}\n\n.step-text:last-child {\n  color: #677788;\n  margin-bottom: 0;\n}\n\n.step-border-last-0 .step-item:last-child .step-icon::after {\n  display: none;\n}\n\n.step .step-item {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-direction: column;\n      flex-direction: column;\n  -ms-flex-preferred-size: 0;\n      flex-basis: 0;\n  -ms-flex: 0 0 100%;\n      flex: 0 0 100%;\n  max-width: 100%;\n  padding-right: 0.9375rem;\n  padding-left: 0.9375rem;\n  margin-bottom: 1.5rem;\n}\n\n.step-item-between .step-item:last-child {\n  -ms-flex: 0 0 auto;\n      flex: 0 0 auto;\n  width: auto;\n}\n\n.step .step-content-wrapper {\n  position: relative;\n  display: -ms-flexbox;\n  display: flex;\n  width: 100%;\n}\n\n.step .step-content {\n  -ms-flex: 1;\n      flex: 1;\n}\n\n.step-item.collapse:not(.show) {\n  display: none;\n}\n\n.step-item .step-title-description {\n  display: none;\n}\n\n.step-item.focus .step-title-description {\n  display: block;\n}\n\n/*------------------------------------\n  Step Avatar\n------------------------------------*/\n.step .step-avatar {\n  font-size: 1rem;\n  font-weight: 600;\n  width: 3.125rem;\n  height: 3.125rem;\n  border-radius: 50%;\n  margin-right: 1rem;\n}\n\n.step .step-avatar-img {\n  max-width: 100%;\n  height: auto;\n  border-radius: 50%;\n}\n\n.step .step-avatar::after {\n  position: absolute;\n  top: 3.59375rem;\n  left: 1.5625rem;\n  height: calc(100% - 2.65625rem);\n  border-left: 0.125rem solid #e7eaf3;\n  content: \"\";\n}\n\n/*------------------------------------\n  Step Avatar\n------------------------------------*/\n.step-avatar-xs .step-avatar, .step-avatar-xs.step-avatar {\n  font-size: 0.75rem;\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.step-avatar-xs .step-avatar::after, .step-avatar-xs.step-avatar::after {\n  top: 2.21875rem;\n  left: 0.8125rem;\n  width: 1.0625rem;\n  height: calc(100% - 1.28125rem);\n}\n\n.step-avatar-xs .step-divider::after {\n  left: 0.875rem;\n}\n\n.step-avatar-sm .step-avatar, .step-avatar-sm.step-avatar {\n  font-size: 0.8125rem;\n  width: 2.6875rem;\n  height: 2.6875rem;\n}\n\n.step-avatar-sm .step-avatar::after, .step-avatar-sm.step-avatar::after {\n  top: 3.15625rem;\n  left: 1.28125rem;\n  width: 1.0625rem;\n  height: calc(100% - 2.21875rem);\n}\n\n.step-avatar-sm .step-divider::after {\n  left: 1.34375rem;\n}\n\n.step-avatar-lg .step-avatar, .step-avatar-lg.step-avatar {\n  font-size: 1.25rem;\n  width: 4.25rem;\n  height: 4.25rem;\n}\n\n.step-avatar-lg .step-avatar::after, .step-avatar-lg.step-avatar::after {\n  top: 4.71875rem;\n  left: 2.0625rem;\n  width: 1.0625rem;\n  height: calc(100% - 3.78125rem);\n}\n\n.step-avatar-lg .step-divider::after {\n  left: 2.125rem;\n}\n\n/*------------------------------------\n  Step Divider\n------------------------------------*/\n.step-divider {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-align: center;\n      align-items: center;\n  text-transform: uppercase;\n  height: 1rem;\n  font-weight: 600;\n}\n\n.step-divider::after {\n  position: absolute;\n  top: 1.46875rem;\n  left: 1.5625rem;\n  height: calc(100% - 0.53125rem);\n  border-left: 0.125rem solid #e7eaf3;\n  content: \"\";\n}\n\n/*------------------------------------\n  Step Icon\n------------------------------------*/\n.step .step-icon {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  -ms-flex-negative: 0;\n      flex-shrink: 0;\n  -ms-flex-pack: center;\n      justify-content: center;\n  -ms-flex-align: center;\n      align-items: center;\n  font-size: 1rem;\n  font-weight: 600;\n  width: 3.125rem;\n  height: 3.125rem;\n  border-radius: 50%;\n  margin-right: 1rem;\n}\n\n.step .step-icon::after {\n  position: absolute;\n  top: 3.59375rem;\n  left: 1.5625rem;\n  height: calc(100% - 2.65625rem);\n  border-left: 0.125rem solid #e7eaf3;\n  content: \"\";\n}\n\n.step .step-icon-pseudo::before {\n  display: block;\n  width: 0.25rem;\n  height: 0.25rem;\n  background-color: #97a4af;\n  border-radius: 50%;\n  content: \"\";\n}\n\n/*------------------------------------\n  Step Icon Sizes\n------------------------------------*/\n.step-icon-xs .step-icon, .step-icon-xs.step-icon {\n  font-size: 0.75rem;\n  width: 1.75rem;\n  height: 1.75rem;\n}\n\n.step-icon-xs .step-icon::after, .step-icon-xs.step-icon::after {\n  top: 2.21875rem;\n  left: 0.8125rem;\n  width: 1.0625rem;\n  height: calc(100% - 1.28125rem);\n}\n\n.step-icon-xs .step-divider::after {\n  left: 0.875rem;\n}\n\n.step-icon-sm .step-icon, .step-icon-sm.step-icon {\n  font-size: 0.8125rem;\n  width: 2.6875rem;\n  height: 2.6875rem;\n}\n\n.step-icon-sm .step-icon::after, .step-icon-sm.step-icon::after {\n  top: 3.15625rem;\n  left: 1.28125rem;\n  width: 1.0625rem;\n  height: calc(100% - 2.21875rem);\n}\n\n.step-icon-sm .step-divider::after {\n  left: 1.34375rem;\n}\n\n.step-icon-lg .step-icon, .step-icon-lg.step-icon {\n  font-size: 1.25rem;\n  width: 4.25rem;\n  height: 4.25rem;\n}\n\n.step-icon-lg .step-icon::after, .step-icon-lg.step-icon::after {\n  top: 4.71875rem;\n  left: 2.0625rem;\n  width: 1.0625rem;\n  height: calc(100% - 3.78125rem);\n}\n\n.step-icon-lg .step-divider::after {\n  left: 2.125rem;\n}\n\n/*------------------------------------\n  Step Breakpoints\n------------------------------------*/\n@media (min-width: 576px) {\n  .step-sm.step-dashed .step-icon::after {\n    border-left: none;\n    border-top-style: dashed;\n  }\n  .step-sm .step-item {\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    -ms-flex: 1;\n        flex: 1;\n    margin-bottom: 0;\n  }\n  .step-sm:not(.step-inline) .step-content-wrapper {\n    display: block;\n  }\n  .step-sm .step-icon {\n    margin-bottom: 1rem;\n  }\n  .step-sm .step-icon::after {\n    top: 1.5625rem;\n    left: 4.0625rem;\n    width: calc(100% - 4.0625rem);\n    height: 1.0625rem;\n    border-top: 0.125rem solid #e7eaf3;\n    border-left: none;\n  }\n  .step-sm.step-icon-xs .step-icon::after,\n  .step-sm .step-icon.step-icon-xs::after {\n    top: 0.875rem;\n    left: 2.6875rem;\n    width: calc(100% - 2.6875rem);\n  }\n  .step-sm.step-icon-sm .step-icon::after,\n  .step-sm .step-icon.step-icon-sm::after {\n    top: 1.34375rem;\n    left: 3.625rem;\n    width: calc(100% - 3.625rem);\n  }\n  .step-sm.step-icon-lg .step-icon::after,\n  .step-sm .step-icon.step-icon-lg::after {\n    top: 2.125rem;\n    left: 5.1875rem;\n    width: calc(100% - 5.1875rem);\n  }\n}\n\n@media (min-width: 768px) {\n  .step-md.step-dashed .step-icon::after {\n    border-left: none;\n    border-top-style: dashed;\n  }\n  .step-md .step-item {\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    -ms-flex: 1;\n        flex: 1;\n    margin-bottom: 0;\n  }\n  .step-md:not(.step-inline) .step-content-wrapper {\n    display: block;\n  }\n  .step-md .step-icon {\n    margin-bottom: 1rem;\n  }\n  .step-md .step-icon::after {\n    top: 1.5625rem;\n    left: 4.0625rem;\n    width: calc(100% - 4.0625rem);\n    height: 1.0625rem;\n    border-top: 0.125rem solid #e7eaf3;\n    border-left: none;\n  }\n  .step-md.step-icon-xs .step-icon::after,\n  .step-md .step-icon.step-icon-xs::after {\n    top: 0.875rem;\n    left: 2.6875rem;\n    width: calc(100% - 2.6875rem);\n  }\n  .step-md.step-icon-sm .step-icon::after,\n  .step-md .step-icon.step-icon-sm::after {\n    top: 1.34375rem;\n    left: 3.625rem;\n    width: calc(100% - 3.625rem);\n  }\n  .step-md.step-icon-lg .step-icon::after,\n  .step-md .step-icon.step-icon-lg::after {\n    top: 2.125rem;\n    left: 5.1875rem;\n    width: calc(100% - 5.1875rem);\n  }\n}\n\n@media (min-width: 992px) {\n  .step-lg.step-dashed .step-icon::after {\n    border-left: none;\n    border-top-style: dashed;\n  }\n  .step-lg .step-item {\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    -ms-flex: 1;\n        flex: 1;\n    margin-bottom: 0;\n  }\n  .step-lg:not(.step-inline) .step-content-wrapper {\n    display: block;\n  }\n  .step-lg .step-icon {\n    margin-bottom: 1rem;\n  }\n  .step-lg .step-icon::after {\n    top: 1.5625rem;\n    left: 4.0625rem;\n    width: calc(100% - 4.0625rem);\n    height: 1.0625rem;\n    border-top: 0.125rem solid #e7eaf3;\n    border-left: none;\n  }\n  .step-lg.step-icon-xs .step-icon::after,\n  .step-lg .step-icon.step-icon-xs::after {\n    top: 0.875rem;\n    left: 2.6875rem;\n    width: calc(100% - 2.6875rem);\n  }\n  .step-lg.step-icon-sm .step-icon::after,\n  .step-lg .step-icon.step-icon-sm::after {\n    top: 1.34375rem;\n    left: 3.625rem;\n    width: calc(100% - 3.625rem);\n  }\n  .step-lg.step-icon-lg .step-icon::after,\n  .step-lg .step-icon.step-icon-lg::after {\n    top: 2.125rem;\n    left: 5.1875rem;\n    width: calc(100% - 5.1875rem);\n  }\n}\n\n@media (min-width: 1200px) {\n  .step-xl.step-dashed .step-icon::after {\n    border-left: none;\n    border-top-style: dashed;\n  }\n  .step-xl .step-item {\n    -ms-flex-positive: 1;\n        flex-grow: 1;\n    -ms-flex: 1;\n        flex: 1;\n    margin-bottom: 0;\n  }\n  .step-xl:not(.step-inline) .step-content-wrapper {\n    display: block;\n  }\n  .step-xl .step-icon {\n    margin-bottom: 1rem;\n  }\n  .step-xl .step-icon::after {\n    top: 1.5625rem;\n    left: 4.0625rem;\n    width: calc(100% - 4.0625rem);\n    height: 1.0625rem;\n    border-top: 0.125rem solid #e7eaf3;\n    border-left: none;\n  }\n  .step-xl.step-icon-xs .step-icon::after,\n  .step-xl .step-icon.step-icon-xs::after {\n    top: 0.875rem;\n    left: 2.6875rem;\n    width: calc(100% - 2.6875rem);\n  }\n  .step-xl.step-icon-sm .step-icon::after,\n  .step-xl .step-icon.step-icon-sm::after {\n    top: 1.34375rem;\n    left: 3.625rem;\n    width: calc(100% - 3.625rem);\n  }\n  .step-xl.step-icon-lg .step-icon::after,\n  .step-xl .step-icon.step-icon-lg::after {\n    top: 2.125rem;\n    left: 5.1875rem;\n    width: calc(100% - 5.1875rem);\n  }\n}\n\n/*------------------------------------\n  Step Centered\n------------------------------------*/\n@media (min-width: 576px) {\n  .step-sm.step-centered {\n    text-align: center;\n  }\n  .step-sm.step-centered .step-item:last-child .step-icon::after {\n    display: none;\n  }\n  .step-sm.step-centered .step-icon {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .step-sm.step-centered .step-icon::after {\n    width: calc(100% - 3.125rem);\n    left: calc(50% + 2.5rem);\n  }\n  .step-sm.step-centered.step-icon-xs .step-icon::after,\n  .step-sm.step-centered .step-icon.step-icon-xs::after {\n    width: calc(100% - 1.75rem);\n    left: calc(50% + 1.8125rem);\n  }\n  .step-sm.step-centered.step-icon-sm .step-icon::after,\n  .step-sm.step-centered .step-icon.step-icon-sm::after {\n    width: calc(100% - 2.6875rem);\n    left: calc(50% + 2.28125rem);\n  }\n  .step-sm.step-centered.step-icon-lg .step-icon::after,\n  .step-sm.step-centered .step-icon.step-icon-lg::after {\n    width: calc(100% - 4.25rem);\n    left: calc(50% + 3.0625rem);\n  }\n}\n\n@media (min-width: 768px) {\n  .step-md.step-centered {\n    text-align: center;\n  }\n  .step-md.step-centered .step-item:last-child .step-icon::after {\n    display: none;\n  }\n  .step-md.step-centered .step-icon {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .step-md.step-centered .step-icon::after {\n    width: calc(100% - 3.125rem);\n    left: calc(50% + 2.5rem);\n  }\n  .step-md.step-centered.step-icon-xs .step-icon::after,\n  .step-md.step-centered .step-icon.step-icon-xs::after {\n    width: calc(100% - 1.75rem);\n    left: calc(50% + 1.8125rem);\n  }\n  .step-md.step-centered.step-icon-sm .step-icon::after,\n  .step-md.step-centered .step-icon.step-icon-sm::after {\n    width: calc(100% - 2.6875rem);\n    left: calc(50% + 2.28125rem);\n  }\n  .step-md.step-centered.step-icon-lg .step-icon::after,\n  .step-md.step-centered .step-icon.step-icon-lg::after {\n    width: calc(100% - 4.25rem);\n    left: calc(50% + 3.0625rem);\n  }\n}\n\n@media (min-width: 992px) {\n  .step-lg.step-centered {\n    text-align: center;\n  }\n  .step-lg.step-centered .step-item:last-child .step-icon::after {\n    display: none;\n  }\n  .step-lg.step-centered .step-icon {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .step-lg.step-centered .step-icon::after {\n    width: calc(100% - 3.125rem);\n    left: calc(50% + 2.5rem);\n  }\n  .step-lg.step-centered.step-icon-xs .step-icon::after,\n  .step-lg.step-centered .step-icon.step-icon-xs::after {\n    width: calc(100% - 1.75rem);\n    left: calc(50% + 1.8125rem);\n  }\n  .step-lg.step-centered.step-icon-sm .step-icon::after,\n  .step-lg.step-centered .step-icon.step-icon-sm::after {\n    width: calc(100% - 2.6875rem);\n    left: calc(50% + 2.28125rem);\n  }\n  .step-lg.step-centered.step-icon-lg .step-icon::after,\n  .step-lg.step-centered .step-icon.step-icon-lg::after {\n    width: calc(100% - 4.25rem);\n    left: calc(50% + 3.0625rem);\n  }\n}\n\n@media (min-width: 992px) {\n  .step-lg.step-centered {\n    text-align: center;\n  }\n  .step-lg.step-centered .step-item:last-child .step-icon::after {\n    display: none;\n  }\n  .step-lg.step-centered .step-icon {\n    margin-left: auto;\n    margin-right: auto;\n  }\n  .step-lg.step-centered .step-icon::after {\n    width: calc(100% - 3.125rem);\n    left: calc(50% + 2.5rem);\n  }\n  .step-lg.step-centered.step-icon-xs .step-icon::after,\n  .step-lg.step-centered .step-icon.step-icon-xs::after {\n    width: calc(100% - 1.75rem);\n    left: calc(50% + 1.8125rem);\n  }\n  .step-lg.step-centered.step-icon-sm .step-icon::after,\n  .step-lg.step-centered .step-icon.step-icon-sm::after {\n    width: calc(100% - 2.6875rem);\n    left: calc(50% + 2.28125rem);\n  }\n  .step-lg.step-centered.step-icon-lg .step-icon::after,\n  .step-lg.step-centered .step-icon.step-icon-lg::after {\n    width: calc(100% - 4.25rem);\n    left: calc(50% + 3.0625rem);\n  }\n}\n\n/*------------------------------------\n  Step States\n------------------------------------*/\n.step .step-is-valid-icon,\n.step .step-is-invalid-icon {\n  display: none;\n}\n\n.step .active .step-icon,\n.step .active.is-valid .step-icon {\n  color: #fff;\n  background-color: #377dff;\n}\n\n.step .active .step-title,\n.step .active.is-valid .step-title {\n  color: #377dff;\n}\n\n.step .is-valid .step-icon {\n  color: #fff;\n  background-color: #377dff;\n}\n\n.step .is-valid .step-title {\n  color: #377dff;\n}\n\n.step .is-valid .step-is-valid-icon {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.step .is-valid .step-is-default-icon,\n.step .is-valid .step-is-invalid-icon {\n  display: none;\n}\n\n.step .is-invalid .step-icon {\n  color: #fff;\n  background-color: #ed4c78;\n}\n\n.step .is-invalid .step-title {\n  color: #ed4c78;\n}\n\n.step .is-invalid .step-is-invalid-icon {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n}\n\n.step .is-invalid .step-is-default-icon,\n.step .is-invalid .step-is-valid-icon {\n  display: none;\n}\n\n/*------------------------------------\n  Step Colors\n------------------------------------*/\n.step-icon-primary {\n  color: #fff;\n  background-color: #377dff;\n}\n\n.step-icon-primary.step-icon-pseudo::before {\n  background-color: #fff;\n}\n\n.step-icon-secondary {\n  color: #fff;\n  background-color: #71869d;\n}\n\n.step-icon-secondary.step-icon-pseudo::before {\n  background-color: #fff;\n}\n\n.step-icon-success {\n  color: #fff;\n  background-color: #00c9a7;\n}\n\n.step-icon-success.step-icon-pseudo::before {\n  background-color: #fff;\n}\n\n.step-icon-info {\n  color: #fff;\n  background-color: #09a5be;\n}\n\n.step-icon-info.step-icon-pseudo::before {\n  background-color: #fff;\n}\n\n.step-icon-warning {\n  color: #1e2022;\n  background-color: #f5ca99;\n}\n\n.step-icon-warning.step-icon-pseudo::before {\n  background-color: #1e2022;\n}\n\n.step-icon-danger {\n  color: #fff;\n  background-color: #ed4c78;\n}\n\n.step-icon-danger.step-icon-pseudo::before {\n  background-color: #fff;\n}\n\n.step-icon-light {\n  color: #1e2022;\n  background-color: #f7faff;\n}\n\n.step-icon-light.step-icon-pseudo::before {\n  background-color: #1e2022;\n}\n\n.step-icon-dark {\n  color: #fff;\n  background-color: #21325b;\n}\n\n.step-icon-dark.step-icon-pseudo::before {\n  background-color: #fff;\n}\n\n.step-icon-indigo {\n  color: #fff;\n  background-color: #2d1582;\n}\n\n.step-icon-indigo.step-icon-pseudo::before {\n  background-color: #fff;\n}\n\n.step-icon-soft-primary {\n  color: #377dff;\n  background-color: rgba(55, 125, 255, 0.1);\n}\n\n.step-icon-soft-primary.step-icon-pseudo::before {\n  background-color: #377dff;\n}\n\n.step-icon-soft-secondary {\n  color: #71869d;\n  background-color: rgba(113, 134, 157, 0.1);\n}\n\n.step-icon-soft-secondary.step-icon-pseudo::before {\n  background-color: #71869d;\n}\n\n.step-icon-soft-success {\n  color: #00c9a7;\n  background-color: rgba(0, 201, 167, 0.1);\n}\n\n.step-icon-soft-success.step-icon-pseudo::before {\n  background-color: #00c9a7;\n}\n\n.step-icon-soft-info {\n  color: #09a5be;\n  background-color: rgba(9, 165, 190, 0.1);\n}\n\n.step-icon-soft-info.step-icon-pseudo::before {\n  background-color: #09a5be;\n}\n\n.step-icon-soft-warning {\n  color: #f5ca99;\n  background-color: rgba(245, 202, 153, 0.1);\n}\n\n.step-icon-soft-warning.step-icon-pseudo::before {\n  background-color: #f5ca99;\n}\n\n.step-icon-soft-danger {\n  color: #ed4c78;\n  background-color: rgba(237, 76, 120, 0.1);\n}\n\n.step-icon-soft-danger.step-icon-pseudo::before {\n  background-color: #ed4c78;\n}\n\n.step-icon-soft-light {\n  color: #f7faff;\n  background-color: rgba(247, 250, 255, 0.1);\n}\n\n.step-icon-soft-light.step-icon-pseudo::before {\n  background-color: #f7faff;\n}\n\n.step-icon-soft-dark {\n  color: #21325b;\n  background-color: rgba(33, 50, 91, 0.1);\n}\n\n.step-icon-soft-dark.step-icon-pseudo::before {\n  background-color: #21325b;\n}\n\n.step-icon-soft-indigo {\n  color: #2d1582;\n  background-color: rgba(45, 21, 130, 0.1);\n}\n\n.step-icon-soft-indigo.step-icon-pseudo::before {\n  background-color: #2d1582;\n}\n\n/*------------------------------------\n  Step Inline\n------------------------------------*/\n.step-inline .step-content-wrapper {\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.step-inline .step-item:last-child .step-title::after {\n  display: none;\n}\n\n.step-inline .step-title {\n  display: inline-block;\n}\n\n@media (min-width: 576px) {\n  .step-sm.step-inline.step-dashed .step-title::after {\n    border-top-style: dashed;\n  }\n  .step-sm.step-inline .step-item {\n    overflow: hidden;\n  }\n  .step-sm.step-inline .step-icon {\n    margin-bottom: 0;\n  }\n  .step-sm.step-inline .step-icon::after {\n    display: none;\n  }\n  .step-sm.step-inline .step-title::after {\n    position: absolute;\n    top: 1.5625rem;\n    width: 100%;\n    height: 1.0625rem;\n    border-top: 0.125rem solid #e7eaf3;\n    margin-left: 0.9375rem;\n    content: \"\";\n  }\n  .step-sm.step-inline.step-icon-xs .step-content .step-title::after,\n  .step-sm.step-inline .step-icon-xs + .step-content .step-title::after {\n    top: 0.875rem;\n  }\n  .step-sm.step-inline.step-icon-sm .step-content .step-title::after,\n  .step-sm.step-inline .step-icon-sm + .step-content .step-title::after {\n    top: 1.34375rem;\n  }\n  .step-sm.step-inline.step-icon-lg .step-content .step-title::after,\n  .step-sm.step-inline .step-icon-lg + .step-content .step-title::after {\n    top: 2.125rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .step-md.step-inline.step-dashed .step-title::after {\n    border-top-style: dashed;\n  }\n  .step-md.step-inline .step-item {\n    overflow: hidden;\n  }\n  .step-md.step-inline .step-icon {\n    margin-bottom: 0;\n  }\n  .step-md.step-inline .step-icon::after {\n    display: none;\n  }\n  .step-md.step-inline .step-title::after {\n    position: absolute;\n    top: 1.5625rem;\n    width: 100%;\n    height: 1.0625rem;\n    border-top: 0.125rem solid #e7eaf3;\n    margin-left: 0.9375rem;\n    content: \"\";\n  }\n  .step-md.step-inline.step-icon-xs .step-content .step-title::after,\n  .step-md.step-inline .step-icon-xs + .step-content .step-title::after {\n    top: 0.875rem;\n  }\n  .step-md.step-inline.step-icon-sm .step-content .step-title::after,\n  .step-md.step-inline .step-icon-sm + .step-content .step-title::after {\n    top: 1.34375rem;\n  }\n  .step-md.step-inline.step-icon-lg .step-content .step-title::after,\n  .step-md.step-inline .step-icon-lg + .step-content .step-title::after {\n    top: 2.125rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .step-lg.step-inline.step-dashed .step-title::after {\n    border-top-style: dashed;\n  }\n  .step-lg.step-inline .step-item {\n    overflow: hidden;\n  }\n  .step-lg.step-inline .step-icon {\n    margin-bottom: 0;\n  }\n  .step-lg.step-inline .step-icon::after {\n    display: none;\n  }\n  .step-lg.step-inline .step-title::after {\n    position: absolute;\n    top: 1.5625rem;\n    width: 100%;\n    height: 1.0625rem;\n    border-top: 0.125rem solid #e7eaf3;\n    margin-left: 0.9375rem;\n    content: \"\";\n  }\n  .step-lg.step-inline.step-icon-xs .step-content .step-title::after,\n  .step-lg.step-inline .step-icon-xs + .step-content .step-title::after {\n    top: 0.875rem;\n  }\n  .step-lg.step-inline.step-icon-sm .step-content .step-title::after,\n  .step-lg.step-inline .step-icon-sm + .step-content .step-title::after {\n    top: 1.34375rem;\n  }\n  .step-lg.step-inline.step-icon-lg .step-content .step-title::after,\n  .step-lg.step-inline .step-icon-lg + .step-content .step-title::after {\n    top: 2.125rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .step-xl.step-inline.step-dashed .step-title::after {\n    border-top-style: dashed;\n  }\n  .step-xl.step-inline .step-item {\n    overflow: hidden;\n  }\n  .step-xl.step-inline .step-icon {\n    margin-bottom: 0;\n  }\n  .step-xl.step-inline .step-icon::after {\n    display: none;\n  }\n  .step-xl.step-inline .step-title::after {\n    position: absolute;\n    top: 1.5625rem;\n    width: 100%;\n    height: 1.0625rem;\n    border-top: 0.125rem solid #e7eaf3;\n    margin-left: 0.9375rem;\n    content: \"\";\n  }\n  .step-xl.step-inline.step-icon-xs .step-content .step-title::after,\n  .step-xl.step-inline .step-icon-xs + .step-content .step-title::after {\n    top: 0.875rem;\n  }\n  .step-xl.step-inline.step-icon-sm .step-content .step-title::after,\n  .step-xl.step-inline .step-icon-sm + .step-content .step-title::after {\n    top: 1.34375rem;\n  }\n  .step-xl.step-inline.step-icon-lg .step-content .step-title::after,\n  .step-xl.step-inline .step-icon-lg + .step-content .step-title::after {\n    top: 2.125rem;\n  }\n}\n\n/*------------------------------------\n  Step Timeline\n------------------------------------*/\n@media (min-width: 576px) {\n  .step-timeline-sm {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .step-timeline-sm .step-item {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n    padding-left: 0;\n    padding-right: 0;\n    margin-left: 50%;\n  }\n  .step-timeline-sm .step-item:nth-child(even) {\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n    text-align: right;\n    margin-left: auto;\n    margin-right: 50%;\n  }\n  .step-timeline-sm .step-item:nth-child(even) .step-content-wrapper {\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n  }\n  .step-timeline-sm .step-item:nth-child(even) .step-icon {\n    margin-left: 0;\n    margin-right: -1.5625rem;\n  }\n  .step-timeline-sm .step-item:nth-child(even) .step-icon-xs {\n    margin-right: -0.875rem;\n  }\n  .step-timeline-sm .step-item:nth-child(even) .step-icon-sm {\n    margin-right: -1.34375rem;\n  }\n  .step-timeline-sm .step-item:nth-child(even) .step-icon-lg {\n    margin-right: -2.125rem;\n  }\n  .step-timeline-sm .step-item:nth-child(even) .step-content {\n    margin-right: 1.5rem;\n  }\n  .step-timeline-sm .step-icon {\n    margin-left: -1.5625rem;\n  }\n  .step-timeline-sm .step-icon::after {\n    left: auto;\n    width: auto;\n  }\n  .step-timeline-sm .step-icon-xs {\n    margin-left: -0.875rem;\n  }\n  .step-timeline-sm .step-icon-sm {\n    margin-left: -1.34375rem;\n  }\n  .step-timeline-sm .step-icon-lg {\n    margin-left: -2.125rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .step-timeline-md {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .step-timeline-md .step-item {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n    padding-left: 0;\n    padding-right: 0;\n    margin-left: 50%;\n  }\n  .step-timeline-md .step-item:nth-child(even) {\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n    text-align: right;\n    margin-left: auto;\n    margin-right: 50%;\n  }\n  .step-timeline-md .step-item:nth-child(even) .step-content-wrapper {\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n  }\n  .step-timeline-md .step-item:nth-child(even) .step-icon {\n    margin-left: 0;\n    margin-right: -1.5625rem;\n  }\n  .step-timeline-md .step-item:nth-child(even) .step-icon-xs {\n    margin-right: -0.875rem;\n  }\n  .step-timeline-md .step-item:nth-child(even) .step-icon-sm {\n    margin-right: -1.34375rem;\n  }\n  .step-timeline-md .step-item:nth-child(even) .step-icon-lg {\n    margin-right: -2.125rem;\n  }\n  .step-timeline-md .step-item:nth-child(even) .step-content {\n    margin-right: 1.5rem;\n  }\n  .step-timeline-md .step-icon {\n    margin-left: -1.5625rem;\n  }\n  .step-timeline-md .step-icon::after {\n    left: auto;\n    width: auto;\n  }\n  .step-timeline-md .step-icon-xs {\n    margin-left: -0.875rem;\n  }\n  .step-timeline-md .step-icon-sm {\n    margin-left: -1.34375rem;\n  }\n  .step-timeline-md .step-icon-lg {\n    margin-left: -2.125rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .step-timeline-lg {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .step-timeline-lg .step-item {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n    padding-left: 0;\n    padding-right: 0;\n    margin-left: 50%;\n  }\n  .step-timeline-lg .step-item:nth-child(even) {\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n    text-align: right;\n    margin-left: auto;\n    margin-right: 50%;\n  }\n  .step-timeline-lg .step-item:nth-child(even) .step-content-wrapper {\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n  }\n  .step-timeline-lg .step-item:nth-child(even) .step-icon {\n    margin-left: 0;\n    margin-right: -1.5625rem;\n  }\n  .step-timeline-lg .step-item:nth-child(even) .step-icon-xs {\n    margin-right: -0.875rem;\n  }\n  .step-timeline-lg .step-item:nth-child(even) .step-icon-sm {\n    margin-right: -1.34375rem;\n  }\n  .step-timeline-lg .step-item:nth-child(even) .step-icon-lg {\n    margin-right: -2.125rem;\n  }\n  .step-timeline-lg .step-item:nth-child(even) .step-content {\n    margin-right: 1.5rem;\n  }\n  .step-timeline-lg .step-icon {\n    margin-left: -1.5625rem;\n  }\n  .step-timeline-lg .step-icon::after {\n    left: auto;\n    width: auto;\n  }\n  .step-timeline-lg .step-icon-xs {\n    margin-left: -0.875rem;\n  }\n  .step-timeline-lg .step-icon-sm {\n    margin-left: -1.34375rem;\n  }\n  .step-timeline-lg .step-icon-lg {\n    margin-left: -2.125rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .step-timeline-xl {\n    margin-left: 0;\n    margin-right: 0;\n  }\n  .step-timeline-xl .step-item {\n    -ms-flex: 0 0 50%;\n        flex: 0 0 50%;\n    max-width: 50%;\n    padding-left: 0;\n    padding-right: 0;\n    margin-left: 50%;\n  }\n  .step-timeline-xl .step-item:nth-child(even) {\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n    text-align: right;\n    margin-left: auto;\n    margin-right: 50%;\n  }\n  .step-timeline-xl .step-item:nth-child(even) .step-content-wrapper {\n    -ms-flex-direction: row-reverse;\n        flex-direction: row-reverse;\n  }\n  .step-timeline-xl .step-item:nth-child(even) .step-icon {\n    margin-left: 0;\n    margin-right: -1.5625rem;\n  }\n  .step-timeline-xl .step-item:nth-child(even) .step-icon-xs {\n    margin-right: -0.875rem;\n  }\n  .step-timeline-xl .step-item:nth-child(even) .step-icon-sm {\n    margin-right: -1.34375rem;\n  }\n  .step-timeline-xl .step-item:nth-child(even) .step-icon-lg {\n    margin-right: -2.125rem;\n  }\n  .step-timeline-xl .step-item:nth-child(even) .step-content {\n    margin-right: 1.5rem;\n  }\n  .step-timeline-xl .step-icon {\n    margin-left: -1.5625rem;\n  }\n  .step-timeline-xl .step-icon::after {\n    left: auto;\n    width: auto;\n  }\n  .step-timeline-xl .step-icon-xs {\n    margin-left: -0.875rem;\n  }\n  .step-timeline-xl .step-icon-sm {\n    margin-left: -1.34375rem;\n  }\n  .step-timeline-xl .step-icon-lg {\n    margin-left: -2.125rem;\n  }\n}\n\n/*------------------------------------\n  Tables\n------------------------------------*/\n.table th {\n  font-weight: 400;\n}\n\n.table thead th {\n  font-size: 0.75rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  border-width: 0;\n}\n\n.table .btn {\n  white-space: nowrap;\n}\n\n.table-heighlighted thead th {\n  border-bottom-color: #1e2022;\n  border-top: none;\n}\n\n.table-heighlighted tfoot td {\n  border-top: 0.125rem solid #1e2022;\n}\n\n.table-light-bordered {\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.table-light-bordered thead th,\n.table-light-bordered th,\n.table-light-bordered td {\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.table-nowrap th, .table-nowrap td {\n  white-space: nowrap;\n}\n\n.table-align-middle tbody td {\n  vertical-align: middle;\n}\n\n.table-thead-bordered thead th {\n  border-top: 0.0625rem solid #e7eaf3;\n  border-bottom: 0.0625rem solid #e7eaf3;\n}\n\n/*------------------------------------\n  Text Highlight\n------------------------------------*/\n[class*=text-highlight-] {\n  background: left 1em/1em 0.2em;\n}\n\n/* primary text highlight */\n.text-highlight-primary {\n  background-image: linear-gradient(to bottom, rgba(55, 125, 255, 0.5) 0%, rgba(55, 125, 255, 0.5) 100%);\n  background-repeat: repeat-x;\n}\n\n/* secondary text highlight */\n.text-highlight-secondary {\n  background-image: linear-gradient(to bottom, rgba(113, 134, 157, 0.5) 0%, rgba(113, 134, 157, 0.5) 100%);\n  background-repeat: repeat-x;\n}\n\n/* success text highlight */\n.text-highlight-success {\n  background-image: linear-gradient(to bottom, rgba(0, 201, 167, 0.5) 0%, rgba(0, 201, 167, 0.5) 100%);\n  background-repeat: repeat-x;\n}\n\n/* info text highlight */\n.text-highlight-info {\n  background-image: linear-gradient(to bottom, rgba(9, 165, 190, 0.5) 0%, rgba(9, 165, 190, 0.5) 100%);\n  background-repeat: repeat-x;\n}\n\n/* warning text highlight */\n.text-highlight-warning {\n  background-image: linear-gradient(to bottom, rgba(245, 202, 153, 0.5) 0%, rgba(245, 202, 153, 0.5) 100%);\n  background-repeat: repeat-x;\n}\n\n/* danger text highlight */\n.text-highlight-danger {\n  background-image: linear-gradient(to bottom, rgba(237, 76, 120, 0.5) 0%, rgba(237, 76, 120, 0.5) 100%);\n  background-repeat: repeat-x;\n}\n\n/* light text highlight */\n.text-highlight-light {\n  background-image: linear-gradient(to bottom, rgba(247, 250, 255, 0.5) 0%, rgba(247, 250, 255, 0.5) 100%);\n  background-repeat: repeat-x;\n}\n\n/* dark text highlight */\n.text-highlight-dark {\n  background-image: linear-gradient(to bottom, rgba(33, 50, 91, 0.5) 0%, rgba(33, 50, 91, 0.5) 100%);\n  background-repeat: repeat-x;\n}\n\n/* indigo text highlight */\n.text-highlight-indigo {\n  background-image: linear-gradient(to bottom, rgba(45, 21, 130, 0.5) 0%, rgba(45, 21, 130, 0.5) 100%);\n  background-repeat: repeat-x;\n}\n\n/*------------------------------------\n  Sticky Blocks\n------------------------------------*/\n[class*=\"sticky-block\"] {\n  max-width: 100%;\n}\n\n/*------------------------------------\n  SVG IE10+ specific styles go here\n------------------------------------*/\n@media screen and (-ms-high-contrast: active), screen and (-ms-high-contrast: none) {\n  .media {\n    width: 100%;\n  }\n  .ie-slick-equal-height .slick-track .slick-slide {\n    display: block;\n  }\n  .ie-main-hero {\n    height: 686px;\n  }\n  .ie-showcase-mockup {\n    height: 373px;\n  }\n  .ie-device-and-mobile {\n    height: 638px;\n  }\n  .ie-curved-y {\n    height: 26px;\n  }\n  .ie-curved-x {\n    width: 26px;\n    height: 370px;\n    margin-right: -4px;\n  }\n}\n\n/*------------------------------------\n  Background Gradients\n------------------------------------*/\n.gradient-y-sm-primary {\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(55, 125, 255, 0.075) 100%);\n  background-repeat: repeat-x;\n}\n\n.gradient-y-gray {\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(231, 234, 243, 0.5) 100%);\n  background-repeat: repeat-x;\n}\n\n.gradient-y-lg-white {\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #fff 100%);\n  background-repeat: repeat-x;\n}\n\n.gradient-y-three-sm-primary {\n  background-image: linear-gradient(rgba(255, 255, 255, 0), rgba(55, 125, 255, 0.075) 50%, rgba(255, 255, 255, 0));\n  background-repeat: no-repeat;\n}\n\n.gradient-x-three-sm-primary {\n  background-image: linear-gradient(to right, rgba(55, 125, 255, 0.03), rgba(9, 165, 190, 0.05) 50%, rgba(245, 202, 153, 0.05));\n  background-repeat: no-repeat;\n}\n\n/*------------------------------------\n  Background Overlay Gradients\n------------------------------------*/\n[class*=\"gradient-x-overlay-\"],\n[class*=\"gradient-y-overlay-\"],\n[class*=\"gradient-y-three-overlay-\"] {\n  position: relative;\n  z-index: 1;\n}\n\n[class*=\"gradient-x-overlay-\"]::before,\n[class*=\"gradient-y-overlay-\"]::before,\n[class*=\"gradient-y-three-overlay-\"]::before {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  right: 0;\n  z-index: -1;\n  width: 100%;\n  height: 100%;\n  content: \"\";\n}\n\n.gradient-x-overlay-lg-dark-video::before {\n  z-index: 2;\n  background-image: linear-gradient(to right, rgba(33, 50, 91, 0.95) 0%, rgba(33, 50, 91, 0.95) 100%);\n  background-repeat: repeat-x;\n}\n\n.gradient-x-overlay-sm-dark::before {\n  background-image: linear-gradient(to right, rgba(33, 50, 91, 0.25) 0%, rgba(30, 32, 34, 0.25) 100%);\n  background-repeat: repeat-x;\n}\n\n.gradient-x-overlay-lg-dark::before {\n  background-image: linear-gradient(to right, rgba(33, 50, 91, 0.9) 0%, rgba(33, 50, 91, 0.9) 100%);\n  background-repeat: repeat-x;\n}\n\n.gradient-y-overlay-lg-dark::before {\n  background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 40%, rgba(12, 13, 14, 0.6) 100%);\n  background-repeat: repeat-x;\n}\n\n.gradient-x-overlay-sm-indigo::before {\n  background-image: linear-gradient(45deg, transparent, rgba(45, 21, 130, 0.05));\n  background-repeat: repeat-x;\n}\n\n.gradient-y-overlay-lg-white::before {\n  background-image: linear-gradient(to bottom, #fff 0%, rgba(255, 255, 255, 0.9) 100%);\n  background-repeat: repeat-x;\n}\n\n.gradient-y-overlay-sm-gray-900::before {\n  background-image: linear-gradient(to bottom, rgba(30, 32, 34, 0.3) 0%, rgba(33, 50, 91, 0.2) 100%);\n  background-repeat: repeat-x;\n}\n\n/*------------------------------------\n  Background Image Style\n------------------------------------*/\n.bg-img-hero {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: top center;\n}\n\n.bg-img-hero-bottom {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: bottom center;\n}\n\n.bg-img-hero-center {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n}\n\n.bg-img-hero-fixed {\n  background-size: cover;\n  background-repeat: no-repeat;\n  background-position: center center;\n  background-attachment: fixed;\n}\n\n/*------------------------------------\n  Background Soft Colors\n------------------------------------*/\n.bg-soft-primary {\n  background-color: rgba(55, 125, 255, 0.1);\n}\n\n.bg-soft-secondary {\n  background-color: rgba(113, 134, 157, 0.1);\n}\n\n.bg-soft-success {\n  background-color: rgba(0, 201, 167, 0.1);\n}\n\n.bg-soft-info {\n  background-color: rgba(9, 165, 190, 0.1);\n}\n\n.bg-soft-warning {\n  background-color: rgba(245, 202, 153, 0.1);\n}\n\n.bg-soft-danger {\n  background-color: rgba(237, 76, 120, 0.1);\n}\n\n.bg-soft-light {\n  background-color: rgba(247, 250, 255, 0.1);\n}\n\n.bg-soft-dark {\n  background-color: rgba(33, 50, 91, 0.1);\n}\n\n.bg-soft-indigo {\n  background-color: rgba(45, 21, 130, 0.1);\n}\n\n/*------------------------------------\n  Borders-radius\n------------------------------------*/\n.rounded-pseudo {\n  border-radius: 0.3125rem;\n}\n\n.rounded-pseudo::before, .rounded-pseudo::after {\n  border-radius: 0.3125rem;\n}\n\n.rounded-lg-pseudo {\n  border-radius: 0.75rem;\n}\n\n.rounded-lg-pseudo::before, .rounded-lg-pseudo::after {\n  border-radius: 0.75rem;\n}\n\n/*------------------------------------\n  Borders\n------------------------------------*/\n.border-dashed {\n  border: 0.0625rem dashed #e7eaf3;\n}\n\n.border-3 {\n  border-width: 0.1875rem !important;\n}\n\n/*------------------------------------\n  Position Spaces\n------------------------------------*/\n.top-auto {\n  top: auto;\n}\n\n.bottom-auto {\n  bottom: auto;\n}\n\n.right-auto {\n  right: auto;\n}\n\n.left-auto {\n  left: auto;\n}\n\n.top-0 {\n  top: 0;\n}\n\n.right-0 {\n  right: 0;\n}\n\n.bottom-0 {\n  bottom: 0;\n}\n\n.left-0 {\n  left: 0;\n}\n\n.top-50 {\n  top: 50%;\n}\n\n.right-50 {\n  right: 50%;\n}\n\n.bottom-50 {\n  bottom: 50%;\n}\n\n.left-50 {\n  left: 50%;\n}\n\n@media (min-width: 576px) {\n  .position-sm-absolute {\n    position: absolute;\n  }\n}\n\n@media (min-width: 768px) {\n  .top-md-0 {\n    top: 0;\n  }\n  .right-md-0 {\n    right: 0;\n  }\n  .bottom-md-0 {\n    bottom: 0;\n  }\n  .left-md-0 {\n    left: 0;\n  }\n  .position-md-absolute {\n    position: absolute;\n  }\n}\n\n@media (min-width: 992px) {\n  .top-lg-0 {\n    top: 0;\n  }\n  .right-lg-0 {\n    right: 0;\n  }\n  .bottom-lg-0 {\n    bottom: 0;\n  }\n  .left-lg-0 {\n    left: 0;\n  }\n  .position-lg-absolute {\n    position: absolute;\n  }\n}\n\n/*------------------------------------\n  Content Centered\n------------------------------------*/\n.content-centered-y {\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n}\n\n@media (min-width: 768px) {\n  .content-centered-y-md {\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n  }\n}\n\n@media (min-width: 992px) {\n  .content-centered-y-lg {\n    position: absolute;\n    top: 50%;\n    -webkit-transform: translate(0, -50%);\n            transform: translate(0, -50%);\n  }\n}\n\n/*------------------------------------\n  Opacity\n------------------------------------*/\n.opacity-xs {\n  opacity: .2;\n}\n\n.opacity-sm {\n  opacity: .4;\n}\n\n.opacity {\n  opacity: .6;\n}\n\n.opacity-lg {\n  opacity: .8;\n}\n\n/*------------------------------------\n  Box Shadow\n------------------------------------*/\n.shadow-primary-lg {\n  box-shadow: 0px 0px 50px rgba(55, 125, 255, 0.4) !important;\n}\n\n.shadow-soft {\n  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25) !important;\n}\n\n/*------------------------------------\n  Width\n------------------------------------*/\n.min-w-3rem {\n  min-width: 1rem;\n}\n\n.min-w-4rem {\n  min-width: 1.5rem;\n}\n\n.min-w-8rem {\n  min-width: 3.5rem;\n}\n\n.min-w-21rem {\n  min-width: 10rem;\n}\n\n.max-w-3rem {\n  max-width: 1rem;\n}\n\n.max-w-4rem {\n  max-width: 1.5rem;\n}\n\n.max-w-5rem {\n  max-width: 2rem;\n}\n\n.max-w-6rem {\n  max-width: 2.5rem;\n}\n\n.max-w-7rem {\n  max-width: 3rem;\n}\n\n.max-w-8rem {\n  max-width: 3.5rem;\n}\n\n.max-w-9rem {\n  max-width: 4rem;\n}\n\n.max-w-10rem {\n  max-width: 4.5rem;\n}\n\n.max-w-11rem {\n  max-width: 5rem;\n}\n\n.max-w-13rem {\n  max-width: 6rem;\n}\n\n.max-w-15rem {\n  max-width: 7rem;\n}\n\n.max-w-19rem {\n  max-width: 9rem;\n}\n\n.max-w-23rem {\n  max-width: 11rem;\n}\n\n.max-w-27rem {\n  max-width: 13rem;\n}\n\n.max-w-33rem {\n  max-width: 16rem;\n}\n\n.max-w-35rem {\n  max-width: 17rem;\n}\n\n.max-w-40rem {\n  max-width: 19.5rem;\n}\n\n.max-w-50rem {\n  max-width: 24.5rem;\n}\n\n/*------------------------------------\n  Height\n------------------------------------*/\n.h-4rem {\n  height: .25rem;\n}\n\n.h-250rem {\n  height: 15.625rem;\n}\n\n.h-380rem {\n  height: 23.75rem;\n}\n\n.min-h-270rem {\n  min-height: 16.875rem;\n}\n\n.min-h-300rem {\n  min-height: 18.75rem;\n}\n\n.min-h-380rem {\n  min-height: 23.75rem;\n}\n\n.min-h-450rem {\n  min-height: 28.125rem;\n}\n\n.min-h-500rem {\n  min-height: 31.25rem;\n}\n\n.min-h-620rem {\n  min-height: 38.75rem;\n}\n\n@media (min-width: 576px) {\n  .max-w-sm-15rem {\n    max-width: 7rem;\n  }\n  .max-w-sm-40rem {\n    max-width: 19.5rem;\n  }\n}\n\n@media (min-width: 768px) {\n  .vh-md-30 {\n    height: 30vh;\n  }\n  .vh-md-70 {\n    height: 70vh;\n  }\n  .min-vh-md-100 {\n    min-height: 100vh;\n  }\n  .max-w-md-13rem {\n    max-width: 6rem;\n  }\n}\n\n@media (min-width: 992px) {\n  .vh-lg-100 {\n    height: 100vh;\n  }\n  .min-vh-lg-100 {\n    min-height: 100vh;\n  }\n  .min-h-lg-600rem {\n    min-height: 37.5rem;\n  }\n}\n\n/*------------------------------------\n  Typography\n------------------------------------*/\n.text-inherit {\n  color: inherit;\n}\n\n.text-cap {\n  display: block;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 0.03125rem;\n}\n\n.text-lh-sm {\n  line-height: 1.2;\n}\n\n.text-lh-lg {\n  line-height: 1.8;\n}\n\n.font-size-1 {\n  font-size: 0.875rem;\n}\n\n.font-size-2 {\n  font-size: 1.5rem;\n}\n\n.font-size-3 {\n  font-size: 2rem;\n}\n\n.font-size-4 {\n  font-size: 2.5rem;\n}\n\n.font-size-5 {\n  font-size: 3rem;\n}\n\n/*------------------------------------\n  Text Colors\n------------------------------------*/\n.text-dark {\n  color: #1e2022 !important;\n}\n\n.text-dark[href]:hover {\n  color: #377dff !important;\n}\n\n.text-secondary[href]:hover {\n  color: #377dff !important;\n}\n\n.text-muted[href]:hover,\n.text-body[href]:hover {\n  color: #0052ea !important;\n}\n\n.text-white-70 {\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.text-white-70[href]:hover {\n  color: #fff;\n}\n\na:hover .text-hover-primary {\n  color: #0052ea !important;\n}\n\n.text-warning {\n  color: #ec9a3c !important;\n}\n\n/*------------------------------------\n  Transform Rotate\n------------------------------------*/\n.transform-rotate-1 {\n  -webkit-transform: rotate(-40deg);\n          transform: rotate(-40deg);\n  -webkit-transform-origin: 30% 20%;\n          transform-origin: 30% 20%;\n}\n\n.transform-rotate-2 {\n  -webkit-transform: rotate(-17deg);\n          transform: rotate(-17deg);\n  -webkit-transform-origin: 0% 0%;\n          transform-origin: 0% 0%;\n}\n\n.transform-rotate-3 {\n  -webkit-transform: rotate(15deg);\n          transform: rotate(15deg);\n  -webkit-transform-origin: 90% -20%;\n          transform-origin: 90% -20%;\n}\n\n.transform-rotate-4 {\n  -webkit-transform-origin: 100% 0;\n          transform-origin: 100% 0;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n\n.transform-rotate-5 {\n  -webkit-transform: rotate(-22deg);\n          transform: rotate(-22deg);\n}\n\n.transform-rotate-6 {\n  -webkit-transform: translate3d(20%, -55%, 0);\n          transform: translate3d(20%, -55%, 0);\n}\n\n/*------------------------------------\n  Transitions\n------------------------------------*/\n/* 3D Hover */\n.transition-3d-hover {\n  transition: all 0.2s ease-in-out;\n}\n\n.transition-3d-hover:hover, .transition-3d-hover:focus {\n  -webkit-transform: translateY(-3px);\n          transform: translateY(-3px);\n}\n\n/* Zoom Hover */\n.transition-zoom-hover {\n  -webkit-transform: scale(1);\n          transform: scale(1);\n  transition: -webkit-transform 0.3s;\n  transition: transform 0.3s;\n  transition: transform 0.3s, -webkit-transform 0.3s;\n}\n\n.transition-zoom-hover:hover, .transition-zoom-hover:focus {\n  -webkit-transform: scale(1.05);\n          transform: scale(1.05);\n}\n\n/*------------------------------------\n  Z-Index\n------------------------------------*/\n.z-index-n1 {\n  z-index: -1;\n}\n\n.z-index-2 {\n  z-index: 2;\n}\n\n.z-index-4 {\n  z-index: 4;\n}\n\n.z-index-999 {\n  z-index: 999;\n}\n\n.z-index-9999 {\n  z-index: 9999;\n}\n\n/*------------------------------------\n  Unfold\n------------------------------------*/\n.hs-unfold {\n  position: relative;\n  display: inline-block;\n}\n\n.hs-unfold-content {\n  display: block !important;\n  opacity: 0;\n  pointer-events: none;\n}\n\n.hs-unfold-content-initialized {\n  opacity: 1;\n  visibility: visible;\n  pointer-events: auto;\n}\n\n.hs-unfold-hidden {\n  display: none !important;\n  opacity: 0;\n  visibility: hidden;\n}\n\n.hs-unfold-overlay {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 1002;\n  background-color: rgba(33, 50, 91, 0.125);\n}\n\n.hs-unfold-content.hs-unfold-reverse-y {\n  top: auto;\n  bottom: 100%;\n  margin-top: 0;\n}\n\n.hs-unfold-has-submenu {\n  top: 0;\n  right: 100%;\n  left: auto;\n  margin-top: 0;\n  margin-right: .5rem;\n}\n\n/*------------------------------------\n  Video Background\n------------------------------------*/\n/*------------------------------------\n  Video Background\n------------------------------------*/\n.hs-video-bg-video video {\n  -o-object-fit: cover;\n     object-fit: cover;\n}\n\n/*------------------------------------\n  Nav Scroll Horizontal\n------------------------------------*/\n.hs-nav-scroller-horizontal {\n  position: relative;\n  z-index: 2;\n}\n\n.hs-nav-scroller-horizontal .nav {\n  overflow-x: auto;\n  overflow-y: hidden;\n  -ms-flex-wrap: nowrap;\n      flex-wrap: nowrap;\n  white-space: nowrap;\n  scroll-behavior: smooth;\n}\n\n.hs-nav-scroller-horizontal .nav .nav-item {\n  white-space: nowrap;\n}\n\n.hs-nav-scroller-horizontal .nav::-webkit-scrollbar {\n  display: none;\n}\n\n.hs-nav-scroller-horizontal .nav-tabs {\n  padding-bottom: 2px;\n}\n\n.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-prev,\n.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-next {\n  position: absolute;\n  height: 100%;\n  z-index: 1;\n  font-size: 1rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-align: center;\n      align-items: center;\n}\n\n.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-link {\n  width: 3.125rem;\n  color: #677788;\n}\n\n.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-link:hover {\n  color: #0052ea;\n}\n\n.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-prev {\n  left: 0;\n  margin-left: -0.125rem;\n}\n\n.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-prev .hs-nav-scroller-arrow-link {\n  padding: 0.5rem 0;\n  background-image: linear-gradient(to right, #fff 50%, rgba(255, 255, 255, 0) 100%);\n  background-repeat: repeat-x;\n}\n\n.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-next {\n  right: 0;\n  margin-right: -0.125rem;\n}\n\n.hs-nav-scroller-horizontal .hs-nav-scroller-arrow-next .hs-nav-scroller-arrow-link {\n  padding: 0.5rem 0;\n  background-image: linear-gradient(to right, rgba(255, 255, 255, 0) 0%, #fff 50%);\n  background-repeat: repeat-x;\n  text-align: right;\n}\n\n.hs-nav-scroller-vertical {\n  height: 100%;\n  overflow: hidden;\n  overflow-y: auto;\n}\n\n.hs-nav-scroller-vertical::-webkit-scrollbar {\n  width: 0.5rem;\n}\n\n.hs-nav-scroller-vertical::-webkit-scrollbar-thumb {\n  background-color: rgba(189, 197, 209, 0.6);\n}\n\n.hs-nav-scroller-unfold {\n  position: static;\n}\n\n/*------------------------------------\n  Chartjs\n------------------------------------*/\n.hs-chartjs-tooltip-wrap {\n  position: absolute;\n  z-index: 3;\n  transition: opacity 0.2s ease-in-out;\n}\n\n.hs-chartjs-tooltip {\n  background-color: #fff;\n  border: 0.0625rem solid #e7eaf3;\n  box-shadow: 0px 0.375rem 1.5rem 0px rgba(140, 152, 164, 0.125);\n  border-radius: 0.3125rem;\n  padding: 1rem 1rem;\n}\n\n.hs-chartjs-tooltip-header {\n  font-weight: 600;\n}\n\n.hs-chartjs-tooltip-body {\n  color: #677788;\n}\n\n/*------------------------------------\n  Cubeportfolio\n------------------------------------*/\n@media (max-width: 991.98px) {\n  .cbp-filter-scrollbar {\n    max-width: 100%;\n    display: -ms-flexbox;\n    display: flex;\n    overflow-x: auto;\n    white-space: nowrap;\n    -webkit-overflow-scrolling: touch;\n  }\n  .cbp-filter-scrollbar::-webkit-scrollbar {\n    height: 0.25rem;\n  }\n  .cbp-filter-scrollbar::-webkit-scrollbar-thumb {\n    background-color: rgba(189, 197, 209, 0.6);\n    visibility: hidden;\n  }\n  .cbp-filter-scrollbar:hover::-webkit-scrollbar-thumb {\n    visibility: visible;\n  }\n}\n\n.cbp-filter-item-active.label.label-soft-secondary {\n  color: #fff;\n  background-color: #377dff;\n}\n\n.cbp-filter-item-active.nav-link {\n  color: #377dff;\n}\n\n.cbp-l-loadMore-stop {\n  pointer-events: none;\n}\n\n.cbp-caption-zoom .cbp-caption-defaultWrap {\n  transition: -webkit-transform .2s ease-out;\n  transition: transform .2s ease-out;\n  transition: transform .2s ease-out, -webkit-transform .2s ease-out;\n}\n\n.cbp-caption-zoom .cbp-caption-activeWrap {\n  background-color: rgba(33, 50, 91, 0.5);\n}\n\n.cbp-caption-zoom .cbp-caption:hover .cbp-caption-defaultWrap {\n  -webkit-transform: scale(1.1);\n          transform: scale(1.1);\n}\n\n/*------------------------------------\n  Dropzone\n------------------------------------*/\n.dz-dropzone {\n  cursor: pointer;\n}\n\n.dz-dropzone-boxed {\n  width: 100%;\n  background-color: #f8fafd;\n  border: 0.125rem dashed #e7eaf3;\n  border-radius: 0.3125rem;\n  padding: 3rem 3rem;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n}\n\n.dz-dropzone .dz-message {\n  width: 100%;\n  text-align: center;\n}\n\n.dz-dropzone .dz-details {\n  margin-bottom: 1rem;\n}\n\n.dz-dropzone .dz-file-preview {\n  background-color: #fff;\n  border-radius: 0.3125rem;\n  padding: 1rem 1rem;\n  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);\n}\n\n.dz-dropzone .dz-file-wrapper {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.dz-dropzone .dz-filename {\n  margin-bottom: 0.25rem;\n}\n\n.dz-dropzone .dz-img {\n  max-width: 3.125rem;\n  border-radius: 0.3125rem;\n  margin-right: 0.75rem;\n}\n\n.dz-dropzone .dz-img-inner {\n  border-radius: 0.3125rem;\n}\n\n.dz-dropzone .dz-close-icon,\n.dz-dropzone .dz-size {\n  color: #677788;\n}\n\n.dz-dropzone .dz-title {\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.dz-dropzone .dz-size {\n  font-size: 80%;\n}\n\n.dz-dropzone .dz-file-initials {\n  display: inline-block;\n  width: 3.125rem;\n  height: 3.125rem;\n  line-height: 3.125rem;\n  font-weight: 600;\n  font-size: 1rem;\n  color: #377dff;\n  text-align: center;\n  background-color: rgba(55, 125, 255, 0.1);\n  border-radius: 0.3125rem;\n  margin-right: 0.75rem;\n}\n\n.dz-dropzone [data-dz-thumbnail]:not([src]) {\n  display: none;\n  margin-bottom: 0;\n}\n\n.dz-dropzone .dz-progress {\n  margin-bottom: 1rem;\n}\n\n.dz-dropzone .dz-processing .dz-error-mark,\n.dz-dropzone .dz-processing .dz-success-mark {\n  display: none;\n}\n\n.dz-dropzone .dz-processing.dz-error .dz-error-mark,\n.dz-dropzone .dz-processing.dz-success .dz-success-mark {\n  display: block;\n}\n\n.dz-dropzone .dz-processing .dz-error-mark {\n  color: #ed4c78;\n}\n\n.dz-dropzone .dz-processing .dz-success-mark {\n  color: #00c9a7;\n}\n\n/*------------------------------------\n  Dzsparallaxer\n------------------------------------*/\n.dzsparallaxer {\n  color: inherit;\n}\n\n/*--------------------------------------------------\n  Fancybox\n----------------------------------------------------*/\n.fancybox-theme .fancybox-slide.animated {\n  display: block;\n  opacity: 0;\n  z-index: 0;\n}\n\n.fancybox-theme .fancybox-slide.animated.fancybox-slide--current {\n  opacity: 1;\n  z-index: 1;\n}\n\n.fancybox-theme .fancybox-content {\n  background-color: transparent;\n}\n\n.fancybox-theme .fancybox-bg {\n  background-color: #1e2022;\n}\n\n.fancybox-theme .fancybox-button svg {\n  margin-bottom: 0;\n}\n\n.fancybox-theme .fancybox-progress {\n  background-color: #377dff;\n}\n\n.blur-30 {\n  -webkit-filter: blur(30px);\n          filter: blur(30px);\n}\n\n/*------------------------------------\n  Leaflet\n------------------------------------*/\n.leaflet-bar,\n.leaflet-popup-content-wrapper,\n.leaflet-popup-tip {\n  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);\n}\n\n.leaflet-bar,\n.leaflet-popup-content-wrapper {\n  border-radius: 0.3125rem;\n}\n\n.leaflet-popup {\n  margin-bottom: 3rem;\n}\n\n/*------------------------------------\n  Summernote Editor\n------------------------------------*/\n.quill-custom .ql-container {\n  position: static;\n}\n\n.quill-custom .ql-toolbar.ql-snow,\n.quill-custom .ql-container.ql-snow {\n  border-color: #e7eaf3;\n}\n\n.quill-custom .ql-toolbar.ql-snow {\n  padding: 0.75rem 1.5rem;\n  border-top-left-radius: 0.3125rem;\n  border-top-right-radius: 0.3125rem;\n}\n\n.quill-custom .ql-container.ql-snow {\n  border-bottom-right-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n}\n\n.quill-custom .ql-formats:first-child {\n  padding-left: 0;\n}\n\n.quill-custom .ql-formats:first-child button {\n  margin-right: 0.5rem;\n}\n\n.quill-custom .ql-formats:first-child button:first-child {\n  margin-left: -0.25rem;\n}\n\n.quill-custom .ql-editor {\n  position: relative;\n  padding: 1.5rem 1.5rem;\n}\n\n.quill-custom .ql-editor p {\n  font-size: 1rem;\n  font-family: \"Open Sans\", sans-serif;\n  color: #1e2022;\n}\n\n.quill-custom .ql-editor.ql-blank::before {\n  left: 1.5rem;\n  color: #97a4af;\n  font-family: \"Open Sans\", sans-serif;\n  font-style: normal;\n}\n\n.quill-custom .ql-snow.ql-toolbar .ql-fill {\n  fill: #677788;\n}\n\n.quill-custom .ql-snow.ql-toolbar .ql-stroke {\n  stroke: #677788;\n}\n\n.quill-custom .ql-snow.ql-toolbar button:hover {\n  color: #377dff;\n}\n\n.quill-custom .ql-snow.ql-toolbar button:hover .ql-fill {\n  fill: #377dff;\n}\n\n.quill-custom .ql-snow.ql-toolbar button:hover .ql-stroke {\n  stroke: #377dff;\n}\n\n.quill-custom .ql-snow.ql-toolbar button,\n.quill-custom .ql-snow .ql-toolbar button {\n  width: 1.75rem;\n  height: 1.75rem;\n  padding: 0.25rem 0.25rem;\n}\n\n.quill-custom .ql-snow.ql-toolbar button svg,\n.quill-custom .ql-snow .ql-toolbar button svg {\n  margin-bottom: 0;\n}\n\n.quill-custom .ql-snow .ql-tooltip {\n  position: fixed;\n  top: 50% !important;\n  left: 50% !important;\n  z-index: 1;\n  min-width: 20rem;\n  border-width: 0;\n  text-align: center;\n  box-shadow: 0px 10px 40px 10px rgba(140, 152, 164, 0.175);\n  padding: 1.5rem 1.5rem;\n  border-radius: 0.3125rem;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n\n.quill-custom .ql-snow .ql-tooltip::before {\n  display: block;\n  text-align: center;\n  font-family: \"Open Sans\", sans-serif;\n  font-weight: 600;\n  font-size: 1rem;\n  border-bottom: 0.0625rem solid #e7eaf3;\n  padding-bottom: 1rem;\n  margin-bottom: 1.5rem;\n  margin-right: 0;\n}\n\n.quill-custom .ql-snow .ql-tooltip.ql-editing a.ql-preview,\n.quill-custom .ql-snow .ql-tooltip.ql-editing a.ql-remove {\n  display: none;\n}\n\n.quill-custom .ql-snow .ql-tooltip a.ql-preview,\n.quill-custom .ql-snow .ql-tooltip.ql-editing input[type=text] {\n  min-width: 20rem;\n  font-size: 1rem;\n  line-height: normal;\n  border: 0.0625rem solid #e7eaf3;\n  padding: 0.75rem 1rem;\n  margin-bottom: 1.5rem;\n  border-radius: 0.3125rem;\n  transition: 0.3s;\n}\n\n.quill-custom .ql-snow .ql-tooltip a.ql-preview {\n  display: block;\n}\n\n.quill-custom .ql-snow .ql-tooltip a.ql-preview:hover {\n  border-color: #377dff;\n}\n\n.quill-custom .ql-snow .ql-tooltip.ql-editing input[type=text] {\n  height: auto;\n  display: block;\n  font-family: \"Open Sans\", sans-serif;\n}\n\n.quill-custom .ql-snow .ql-tooltip.ql-editing input[type=text]:focus {\n  border-color: rgba(55, 125, 255, 0.4);\n  box-shadow: 0 0 10px rgba(55, 125, 255, 0.1);\n}\n\n.quill-custom .ql-snow .ql-action {\n  display: inline-block;\n  color: #fff;\n  background-color: #377dff;\n  font-size: 1rem;\n  line-height: normal;\n  padding: 0.75rem 1rem;\n  border-radius: 0.3125rem;\n  transition: 0.3s;\n}\n\n.quill-custom .ql-snow .ql-action:hover {\n  background-color: #1366ff;\n}\n\n.quill-custom .ql-snow .ql-tooltip a.ql-remove::before,\n.quill-custom .ql-snow .ql-tooltip a.ql-action::after {\n  padding-right: 0;\n  margin-left: 0;\n  border-right: none;\n}\n\n.quill-custom .ql-snow .ql-tooltip a.ql-remove {\n  border: 0.0625rem solid #e7eaf3;\n  font-size: 1rem;\n  padding: 0.75rem 1rem;\n  border-radius: 0.3125rem;\n  margin-left: 0.5rem;\n  transition: 0.3s;\n}\n\n.quill-custom .ql-snow .ql-tooltip a.ql-remove:hover {\n  color: #0052ea;\n  box-shadow: 0px 3px 6px -2px rgba(140, 152, 164, 0.25);\n}\n\n/*------------------------------------\n  Select2\n------------------------------------*/\n.select2-custom {\n  position: relative;\n}\n\n.select2-custom .select2-custom-hide {\n  display: none;\n}\n\n.select2-custom-right .select2-container--open {\n  right: 0 !important;\n  left: auto !important;\n}\n\n@media (min-width: 576px) {\n  .select2-custom-sm-right .select2-container--open {\n    right: 0 !important;\n    left: auto !important;\n  }\n}\n\n@media (min-width: 768px) {\n  .select2-custom-md-right .select2-container--open {\n    right: 0 !important;\n    left: auto !important;\n  }\n}\n\n@media (min-width: 992px) {\n  .select2-custom-lg-right .select2-container--open {\n    right: 0 !important;\n    left: auto !important;\n  }\n}\n\n@media (min-width: 1200px) {\n  .select2-custom-xl-right .select2-container--open {\n    right: 0 !important;\n    left: auto !important;\n  }\n}\n\n.select2-dropdown {\n  border-color: #e7eaf3;\n}\n\n.select2-container--open .select2-dropdown--below {\n  border-radius: 0.3125rem;\n  border-top: 0.0625rem solid #e7eaf3;\n  margin-top: 0.5rem;\n}\n\n.select2-container--default.select2-container--open.select2-container--below .select2-selection--single,\n.select2-container--default.select2-container--open.select2-container--below .select2-selection--multiple {\n  border-radius: 0.3125rem;\n}\n\n.select2-container--default.select2-container--focus .select2-selection--multiple {\n  border-color: rgba(55, 125, 255, 0.4);\n}\n\n.select2-container--default .custom-select.select2-selection--multiple,\n.select2-container--default .form-control.select2-selection--multiple {\n  height: auto;\n  min-height: calc(1.6em + 1.625rem);\n}\n\n.select2-container--default .custom-select-sm.select2-selection--multiple,\n.select2-container--default .form-control-sm.select2-selection--multiple {\n  min-height: calc(1.5em + 1.375rem);\n}\n\n.select2-container--default .form-control.select2-selection--multiple .select2-selection__choice {\n  margin-top: 0.7rem;\n}\n\n.select2-container--default .custom-select-sm.select2-selection--multiple .select2-selection__choice,\n.select2-container--default .form-control-sm.select2-selection--multiple .select2-selection__choice {\n  margin-top: 0.5rem;\n}\n\n.select2-container--default .form-control.select2-selection--multiple .select2-search--inline {\n  margin-top: 0.25rem;\n}\n\n.select2-container--default .form-control-lg.select2-selection--multiple .select2-selection__choice {\n  margin-top: 0.6125rem;\n}\n\n.select2-container--default .select2-selection--multiple {\n  border-color: #e7eaf3;\n  padding: 0 0;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n  position: relative;\n  background-color: #e7eaf3;\n  border-color: transparent;\n  padding-right: 1.125rem;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__choice__remove {\n  position: absolute;\n  right: 0.125rem;\n  color: #71869d;\n}\n\n.select2-container--default .select2-search__field {\n  width: 100% !important;\n}\n\n.select2-container--default .select2-search__field::-webkit-input-placeholder {\n  color: #97a4af;\n}\n\n.select2-container--default .select2-search__field::-moz-placeholder {\n  color: #97a4af;\n}\n\n.select2-container--default .select2-search__field:-ms-input-placeholder {\n  color: #97a4af;\n}\n\n.select2-container--default .select2-search__field::-ms-input-placeholder {\n  color: #97a4af;\n}\n\n.select2-container--default .select2-search__field::placeholder {\n  color: #97a4af;\n}\n\n.select2-container--default .select2-search--dropdown .select2-search__field {\n  border-color: #e7eaf3;\n  background-color: #f7faff;\n  padding: 0.625rem 1.125rem;\n  border-radius: 0.3125rem;\n}\n\n.select2-container--default .select2-search--dropdown .select2-search__field::-webkit-input-placeholder {\n  color: #97a4af;\n}\n\n.select2-container--default .select2-search--dropdown .select2-search__field::-moz-placeholder {\n  color: #97a4af;\n}\n\n.select2-container--default .select2-search--dropdown .select2-search__field:-ms-input-placeholder {\n  color: #97a4af;\n}\n\n.select2-container--default .select2-search--dropdown .select2-search__field::-ms-input-placeholder {\n  color: #97a4af;\n}\n\n.select2-container--default .select2-search--dropdown .select2-search__field::placeholder {\n  color: #97a4af;\n}\n\n.select2-container--default .select2-search--dropdown .select2-search__field:focus {\n  border-color: rgba(55, 125, 255, 0.4);\n  box-shadow: 0 0 10px rgba(55, 125, 255, 0.1);\n}\n\n.select2-container--default .select2-selection.active .select2-selection__placeholder {\n  color: #1e2022;\n}\n\n.select2-container--default .custom-select .select2-search--inline .select2-search__field,\n.select2-container--default .select2-selection--multiple .select2-selection__choice {\n  margin-top: 0.7rem;\n}\n\n.select2-container--default .custom-select-sm .select2-search--inline .select2-search__field,\n.select2-container--default .form-control-sm .select2-search--inline .select2-search__field {\n  margin-top: 0.5rem;\n}\n\n.select2-container--default .select2-selection--multiple .select2-selection__rendered {\n  padding-right: 1rem;\n  padding-left: 1rem;\n}\n\n.select2-container--default .select2-results__option {\n  padding: 0.5rem 3rem 0.5rem 0.5rem;\n}\n\n.select2-container--default .select2-results__option[aria-selected=true] {\n  color: #1e2022;\n  background-color: rgba(189, 197, 209, 0.3);\n}\n\n.select2-container--default .select2-results__option:first-child, .select2-container--default .select2-results__option:first-child:hover {\n  border-top-left-radius: 0.3125rem;\n  border-top-right-radius: 0.3125rem;\n}\n\n.select2-container--default .select2-results__option:last-child, .select2-container--default .select2-results__option:last-child:hover {\n  border-bottom-right-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n}\n\n.select2-container--default .select2-results__option {\n  position: relative;\n}\n\n.select2-container--default .select2-results__option[aria-selected=true]::after {\n  position: absolute;\n  top: 50%;\n  right: 0.5rem;\n  width: 1rem;\n  height: 1rem;\n  background: url(\"data:image/svg+xml,%3Csvg width='16' height='16' viewBox='0 0 110 110' fill='%23377dff' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M98.1,16.2c-2.5-2.3-6.4-2.2-8.7,0.2L36.7,70.1l-13-15.5c-2.9-3.5-7.9-4.1-11.1-1.4c-2.9,2.4-3.5,6.6-1.4,10.1l16.5,28c3.2,5.4,10.8,5.8,14.5,0.8l56.5-67.3C100.7,22.1,100.4,18.5,98.1,16.2z'/%3E%3C/svg%3E%0A\") no-repeat right center/1rem 1rem;\n  content: \"\";\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n\n.select2-container--default .select2-results__option--highlighted[aria-selected]:not([aria-selected=true]) {\n  color: #1e2022;\n  background-color: rgba(189, 197, 209, 0.3);\n}\n\n.select2-container--default .select2-search--dropdown .select2-search__field {\n  border-color: #e7eaf3;\n}\n\n.select2-selection__placeholder {\n  color: #97a4af;\n}\n\n.select2-selection--multiple .select2-selection__placeholder {\n  position: absolute;\n  top: 50%;\n  left: 0;\n  padding-left: 0.75rem;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n\n/*------------------------------------\n  Range Slider\n------------------------------------*/\n.range-slider-custom {\n  height: 1.25rem;\n}\n\n.range-slider-custom .irs {\n  height: 1.25rem;\n}\n\n.range-slider-custom .irs-line {\n  height: 0.25rem;\n}\n\n.range-slider-custom .irs-bar {\n  height: 0.25rem;\n  background-color: #377dff;\n}\n\n.range-slider-custom .irs-handle {\n  width: 1.75rem;\n  height: 1.75rem;\n  top: 0.875rem;\n  background-color: #fff;\n  cursor: pointer;\n  border-radius: 50%;\n  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);\n}\n\n.range-slider-custom .irs-handle i:first-child {\n  display: none;\n}\n\n.range-slider-custom .irs-handle.state_hover {\n  -webkit-transform: scale(1.3);\n          transform: scale(1.3);\n}\n\n.range-slider-custom .irs-from,\n.range-slider-custom .irs-to,\n.range-slider-custom .irs-single {\n  top: -2.25rem;\n  display: inline-block;\n  min-width: 2.5rem;\n  background-color: #fff;\n  color: #1e2022;\n  font-size: 0.875rem;\n  text-shadow: none;\n  text-align: center;\n  box-shadow: 0px 3px 6px 0px rgba(140, 152, 164, 0.25);\n  border-radius: 0.3125rem;\n  padding: 0.5rem 0.5rem;\n}\n\n.range-slider-custom .irs-from::before,\n.range-slider-custom .irs-to::before,\n.range-slider-custom .irs-single::before {\n  border-top-color: #fff;\n}\n\n/* Grid */\n.range-slider-custom-grid .irs-grid-pol {\n  top: 0.5rem;\n  height: 0.75rem;\n  background-color: #e7eaf3;\n}\n\n.range-slider-custom-grid .irs-grid-pol.small {\n  display: none;\n}\n\n.range-slider-custom-grid .irs-grid-text {\n  top: 2rem;\n  font-size: 0.875rem;\n}\n\n/*------------------------------------\n  Slick\n------------------------------------*/\n.slick-cloned [data-hs-slick-carousel-slide-animated-element-animation] {\n  opacity: 0;\n}\n\n.slick {\n  background: url(../svg/components/circle-preloader.svg) no-repeat 50% 50%;\n}\n\n.slick .js-next,\n.slick .js-prev {\n  opacity: 0;\n}\n\n.slick.slick-initialized {\n  background: none;\n}\n\n.slick.slick-initialized .js-slide,\n.slick.slick-initialized .js-thumb {\n  visibility: visible;\n  height: auto;\n  overflow: visible;\n}\n\n.slick.slick-initialized .js-next,\n.slick.slick-initialized .js-prev {\n  opacity: 1;\n}\n\n.slick .js-slide,\n.slick .js-thumb {\n  height: 0;\n  visibility: hidden;\n  overflow: hidden;\n}\n\n.slick .js-slide:first-child,\n.slick .js-thumb:first-child {\n  height: auto;\n}\n\n/*------------------------------------\n  Tagify\n------------------------------------*/\n.tagify {\n  --tag-bg: unset;\n  --tag-hover: unset;\n  -ms-flex-align: center;\n      align-items: center;\n  border-color: #e7eaf3;\n  border-radius: 0.25rem;\n}\n\n.tagify:hover {\n  border-color: #e7eaf3;\n}\n\n.tagify.tagify--focus {\n  border-color: rgba(55, 125, 255, 0.4);\n}\n\n.tagify__tag {\n  background-color: #e7eaf3;\n  border-radius: 0.25rem;\n}\n\n.tagify__tag:first-child {\n  margin-left: 0;\n}\n\n.tagify__tag > div {\n  color: #1e2022;\n  line-height: normal;\n  padding: 0.3125rem 2rem 0.3125rem 1rem;\n  border-radius: 0.25rem;\n}\n\n.tagify__tag > div * {\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  vertical-align: baseline;\n}\n\n.tagify__tag__removeBtn {\n  width: 1rem;\n  height: 1rem;\n  line-height: 1rem;\n}\n\n.tagify__tag__removeBtn:hover {\n  background-color: #ed4c78;\n}\n\n.tagify__tag__removeBtn:hover + div::before {\n  box-shadow: none !important;\n}\n\n.tagify__tag__removeBtn:hover + div .tagify__tag-text {\n  opacity: 1;\n}\n\n.tagify-form-control {\n  display: -ms-flexbox;\n  display: flex;\n  height: auto;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n\n.tagify__input:first-child {\n  padding-left: 0;\n  margin-left: 0;\n}\n\n.tagify__input::before {\n  line-height: 1.8;\n}\n\n.tagify__input .tagify__tag > div {\n  padding: 0.3125rem 2rem 0.3125rem 1rem;\n  line-height: normal;\n}\n\n.tagify__dropdown__menu {\n  border: 0.0625rem solid #e7eaf3;\n  border-bottom-right-radius: 0.3125rem;\n  border-bottom-left-radius: 0.3125rem;\n  margin-top: -1px;\n}\n\n.tagify__dropdown__item--active {\n  color: #377dff;\n  background-color: rgba(55, 125, 255, 0.1);\n}\n\n.tagify.tagify-form-control-list {\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.tagify__dropdown__wrapper {\n  border: none;\n}\n\n/*------------------------------------\n  Typed.js\n------------------------------------*/\n.typed-cursor {\n  opacity: 1;\n  -webkit-animation: blink 0.7s infinite;\n          animation: blink 0.7s infinite;\n}\n\n@-webkit-keyframes blink {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n@keyframes blink {\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n\n/*------------------------------------\n  File for your custom SCSS style\n------------------------------------*/\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
